//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseClient {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
            ...options.headers,
            "Session-Correlation": this.config.getSessionCorrelation(),
        };
        return Promise.resolve(options);
    };
}

export class CompanyAccountServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyAccountRequestAccessReferenceData(body: GetCompanyAccountRequestAccessReferenceDataRequestDto | undefined): Promise<GetCompanyAccountRequestAccessReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/GetCompanyAccountRequestAccessReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyAccountRequestAccessReferenceData(_response);
        });
    }

    protected processGetCompanyAccountRequestAccessReferenceData(response: Response): Promise<GetCompanyAccountRequestAccessReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyAccountRequestAccessReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyAccountRequestAccessReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyAccountRequestAccessCr(body: CreateCompanyAccountRequestAccessCrRequestDto | undefined): Promise<CreateCompanyAccountRequestAccessCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/CreateCompanyAccountRequestAccessCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyAccountRequestAccessCr(_response);
        });
    }

    protected processCreateCompanyAccountRequestAccessCr(response: Response): Promise<CreateCompanyAccountRequestAccessCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyAccountRequestAccessCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyAccountRequestAccessCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyAccountRequestAccessCs(body: CreateCompanyAccountRequestAccessCsRequestDto | undefined): Promise<CreateCompanyAccountRequestAccessCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/CreateCompanyAccountRequestAccessCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyAccountRequestAccessCs(_response);
        });
    }

    protected processCreateCompanyAccountRequestAccessCs(response: Response): Promise<CreateCompanyAccountRequestAccessCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyAccountRequestAccessCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyAccountRequestAccessCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyAccountRequestAccessCrCs(body: CreateCompanyAccountRequestAccessCrCsRequestDto | undefined): Promise<CreateCompanyAccountRequestAccessCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/CreateCompanyAccountRequestAccessCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyAccountRequestAccessCrCs(_response);
        });
    }

    protected processCreateCompanyAccountRequestAccessCrCs(response: Response): Promise<CreateCompanyAccountRequestAccessCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyAccountRequestAccessCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyAccountRequestAccessCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyAccountRequestAccessCa(body: CreateCompanyAccountRequestAccessCaRequestDto | undefined): Promise<CreateCompanyAccountRequestAccessCaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/CreateCompanyAccountRequestAccessCa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyAccountRequestAccessCa(_response);
        });
    }

    protected processCreateCompanyAccountRequestAccessCa(response: Response): Promise<CreateCompanyAccountRequestAccessCaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyAccountRequestAccessCaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyAccountRequestAccessCaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyAccountRequestAccessNcCa(body: CreateCompanyAccountRequestAccessNcCaRequestDto | undefined): Promise<CreateCompanyAccountRequestAccessNcCaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/CreateCompanyAccountRequestAccessNcCa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyAccountRequestAccessNcCa(_response);
        });
    }

    protected processCreateCompanyAccountRequestAccessNcCa(response: Response): Promise<CreateCompanyAccountRequestAccessNcCaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyAccountRequestAccessNcCaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyAccountRequestAccessNcCaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyAccountMyDetails(body: GetCompanyAccountMyDetailsRequestDto | undefined): Promise<GetCompanyAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/GetCompanyAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyAccountMyDetails(_response);
        });
    }

    protected processGetCompanyAccountMyDetails(response: Response): Promise<GetCompanyAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyAccountMyDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyAccountMyDetails(body: SaveCompanyAccountMyDetailsRequestDto | undefined): Promise<SaveCompanyAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyAccountService/SaveCompanyAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyAccountMyDetails(_response);
        });
    }

    protected processSaveCompanyAccountMyDetails(response: Response): Promise<SaveCompanyAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyAccountMyDetailsResponseDto>(null as any);
    }
}

export class CompanyCommonDraftApplicationDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigning(body: SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto | undefined): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigning(response: Response): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    revertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparing(body: RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto | undefined): Promise<RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparing(_response);
        });
    }

    protected processRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparing(response: Response): Promise<RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyCommonDraftApplicationDetailsDraftApplicationAsPaying(body: SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto | undefined): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPaying";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsPaying(_response);
        });
    }

    protected processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsPaying(response: Response): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmission(body: SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto | undefined): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmission(_response);
        });
    }

    protected processSetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmission(response: Response): Promise<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyCommonDraftApplicationDetailsDraftApplicationToNopta(body: SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto | undefined): Promise<SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNopta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNopta(_response);
        });
    }

    protected processSubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNopta(response: Response): Promise<SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteCompanyCommonDraftApplicationDetailsDraftApplication(body: DeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto | undefined): Promise<DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/DeleteCompanyCommonDraftApplicationDetailsDraftApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCompanyCommonDraftApplicationDetailsDraftApplication(_response);
        });
    }

    protected processDeleteCompanyCommonDraftApplicationDetailsDraftApplication(response: Response): Promise<DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyCommonDraftApplicationDetailsSupportingDocumentation(body: GetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto | undefined): Promise<GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/GetCompanyCommonDraftApplicationDetailsSupportingDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyCommonDraftApplicationDetailsSupportingDocumentation(_response);
        });
    }

    protected processGetCompanyCommonDraftApplicationDetailsSupportingDocumentation(response: Response): Promise<GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyCommonDraftApplicationDetailsSupportingDocumentation(body: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto | undefined): Promise<SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SaveCompanyCommonDraftApplicationDetailsSupportingDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyCommonDraftApplicationDetailsSupportingDocumentation(_response);
        });
    }

    protected processSaveCompanyCommonDraftApplicationDetailsSupportingDocumentation(response: Response): Promise<SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyCommonDraftApplicationDetailsSignatureType(body: GetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto | undefined): Promise<GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/GetCompanyCommonDraftApplicationDetailsSignatureType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyCommonDraftApplicationDetailsSignatureType(_response);
        });
    }

    protected processGetCompanyCommonDraftApplicationDetailsSignatureType(response: Response): Promise<GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyCommonDraftApplicationDetailsSignatureType(body: SaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto | undefined): Promise<SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SaveCompanyCommonDraftApplicationDetailsSignatureType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyCommonDraftApplicationDetailsSignatureType(_response);
        });
    }

    protected processSaveCompanyCommonDraftApplicationDetailsSignatureType(response: Response): Promise<SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyCommonDraftApplicationDetailsFormDocumentation(body: GetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto | undefined): Promise<GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/GetCompanyCommonDraftApplicationDetailsFormDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyCommonDraftApplicationDetailsFormDocumentation(_response);
        });
    }

    protected processGetCompanyCommonDraftApplicationDetailsFormDocumentation(response: Response): Promise<GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocument(body: GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto | undefined): Promise<GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocument(_response);
        });
    }

    protected processGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocument(response: Response): Promise<GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyCommonDraftApplicationDetailsWetFormDocumentation(body: SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto | undefined): Promise<SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SaveCompanyCommonDraftApplicationDetailsWetFormDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyCommonDraftApplicationDetailsWetFormDocumentation(_response);
        });
    }

    protected processSaveCompanyCommonDraftApplicationDetailsWetFormDocumentation(response: Response): Promise<SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyCommonDraftApplicationDetailsDigitalSignature(body: SaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto | undefined): Promise<SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyCommonDraftApplicationDetailsService/SaveCompanyCommonDraftApplicationDetailsDigitalSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyCommonDraftApplicationDetailsDigitalSignature(_response);
        });
    }

    protected processSaveCompanyCommonDraftApplicationDetailsDigitalSignature(response: Response): Promise<SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto>(null as any);
    }
}

export class CompanyFinanceServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyFinanceFnList(body: GetCompanyFinanceFnListRequestDto | undefined): Promise<GetCompanyFinanceFnListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/GetCompanyFinanceFnList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyFinanceFnList(_response);
        });
    }

    protected processGetCompanyFinanceFnList(response: Response): Promise<GetCompanyFinanceFnListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyFinanceFnListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyFinanceFnListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyFinancePaymentHistoryList(body: GetCompanyFinancePaymentHistoryListRequestDto | undefined): Promise<GetCompanyFinancePaymentHistoryListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/GetCompanyFinancePaymentHistoryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyFinancePaymentHistoryList(_response);
        });
    }

    protected processGetCompanyFinancePaymentHistoryList(response: Response): Promise<GetCompanyFinancePaymentHistoryListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyFinancePaymentHistoryListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyFinancePaymentHistoryListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyFinanceFnDetails(body: GetCompanyFinanceFnDetailsRequestDto | undefined): Promise<GetCompanyFinanceFnDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/GetCompanyFinanceFnDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyFinanceFnDetails(_response);
        });
    }

    protected processGetCompanyFinanceFnDetails(response: Response): Promise<GetCompanyFinanceFnDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyFinanceFnDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyFinanceFnDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyFinanceFnDetailsPayment(body: CreateCompanyFinanceFnDetailsPaymentRequestDto | undefined): Promise<CreateCompanyFinanceFnDetailsPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/CreateCompanyFinanceFnDetailsPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyFinanceFnDetailsPayment(_response);
        });
    }

    protected processCreateCompanyFinanceFnDetailsPayment(response: Response): Promise<CreateCompanyFinanceFnDetailsPaymentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyFinanceFnDetailsPaymentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyFinanceFnDetailsPaymentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyFinanceFnDetailsCreditCardPayment(body: CreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto | undefined): Promise<CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/CreateCompanyFinanceFnDetailsCreditCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyFinanceFnDetailsCreditCardPayment(_response);
        });
    }

    protected processCreateCompanyFinanceFnDetailsCreditCardPayment(response: Response): Promise<CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyFinanceFnListCreditCardPayment(body: CreateCompanyFinanceFnListCreditCardPaymentRequestDto | undefined): Promise<CreateCompanyFinanceFnListCreditCardPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/CreateCompanyFinanceFnListCreditCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyFinanceFnListCreditCardPayment(_response);
        });
    }

    protected processCreateCompanyFinanceFnListCreditCardPayment(response: Response): Promise<CreateCompanyFinanceFnListCreditCardPaymentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyFinanceFnListCreditCardPaymentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyFinanceFnListCreditCardPaymentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyFinanceCreditCardSurcharge(body: GetCompanyFinanceCreditCardSurchargeRequestDto | undefined): Promise<GetCompanyFinanceCreditCardSurchargeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyFinanceService/GetCompanyFinanceCreditCardSurcharge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyFinanceCreditCardSurcharge(_response);
        });
    }

    protected processGetCompanyFinanceCreditCardSurcharge(response: Response): Promise<GetCompanyFinanceCreditCardSurchargeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyFinanceCreditCardSurchargeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyFinanceCreditCardSurchargeResponseDto>(null as any);
    }
}

export class CompanyHomeDashboardServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyHomeDashboard(body: GetCompanyHomeDashboardRequestDto | undefined): Promise<GetCompanyHomeDashboardResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyHomeDashboardService/GetCompanyHomeDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyHomeDashboard(_response);
        });
    }

    protected processGetCompanyHomeDashboard(response: Response): Promise<GetCompanyHomeDashboardResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyHomeDashboardResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyHomeDashboardResponseDto>(null as any);
    }
}

export class CompanyOeiApplicationListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiApplicationList(body: GetCompanyOeiApplicationListRequestDto | undefined): Promise<GetCompanyOeiApplicationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiApplicationListService/GetCompanyOeiApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiApplicationList(_response);
        });
    }

    protected processGetCompanyOeiApplicationList(response: Response): Promise<GetCompanyOeiApplicationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiApplicationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiApplicationListResponseDto>(null as any);
    }
}

export class CompanyOeiCreateDraftApplicationServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiCreateDraftApplicationReferenceData(body: GetCompanyOeiCreateDraftApplicationReferenceDataRequestDto | undefined): Promise<GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiCreateDraftApplicationService/GetCompanyOeiCreateDraftApplicationReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiCreateDraftApplicationReferenceData(_response);
        });
    }

    protected processGetCompanyOeiCreateDraftApplicationReferenceData(response: Response): Promise<GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOeiCreateDraftApplication(body: CreateCompanyOeiCreateDraftApplicationRequestDto | undefined): Promise<CreateCompanyOeiCreateDraftApplicationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiCreateDraftApplicationService/CreateCompanyOeiCreateDraftApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOeiCreateDraftApplication(_response);
        });
    }

    protected processCreateCompanyOeiCreateDraftApplication(response: Response): Promise<CreateCompanyOeiCreateDraftApplicationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOeiCreateDraftApplicationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOeiCreateDraftApplicationResponseDto>(null as any);
    }
}

export class CompanyOeiDraftApplicationDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiDraftApplicationDetailsContact(body: GetCompanyOeiDraftApplicationDetailsContactRequestDto | undefined): Promise<GetCompanyOeiDraftApplicationDetailsContactResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/GetCompanyOeiDraftApplicationDetailsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiDraftApplicationDetailsContact(_response);
        });
    }

    protected processGetCompanyOeiDraftApplicationDetailsContact(response: Response): Promise<GetCompanyOeiDraftApplicationDetailsContactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiDraftApplicationDetailsContactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiDraftApplicationDetailsContactResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOeiDraftApplicationDetailsContact(body: SaveCompanyOeiDraftApplicationDetailsContactRequestDto | undefined): Promise<SaveCompanyOeiDraftApplicationDetailsContactResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/SaveCompanyOeiDraftApplicationDetailsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOeiDraftApplicationDetailsContact(_response);
        });
    }

    protected processSaveCompanyOeiDraftApplicationDetailsContact(response: Response): Promise<SaveCompanyOeiDraftApplicationDetailsContactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOeiDraftApplicationDetailsContactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOeiDraftApplicationDetailsContactResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiDraftApplicationDetailsApplicant(body: GetCompanyOeiDraftApplicationDetailsApplicantRequestDto | undefined): Promise<GetCompanyOeiDraftApplicationDetailsApplicantResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/GetCompanyOeiDraftApplicationDetailsApplicant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiDraftApplicationDetailsApplicant(_response);
        });
    }

    protected processGetCompanyOeiDraftApplicationDetailsApplicant(response: Response): Promise<GetCompanyOeiDraftApplicationDetailsApplicantResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiDraftApplicationDetailsApplicantResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiDraftApplicationDetailsApplicantResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOeiDraftApplicationDetailsApplicant(body: SaveCompanyOeiDraftApplicationDetailsApplicantRequestDto | undefined): Promise<SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/SaveCompanyOeiDraftApplicationDetailsApplicant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOeiDraftApplicationDetailsApplicant(_response);
        });
    }

    protected processSaveCompanyOeiDraftApplicationDetailsApplicant(response: Response): Promise<SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiDraftApplicationDetailsIafl(body: GetCompanyOeiDraftApplicationDetailsIaflRequestDto | undefined): Promise<GetCompanyOeiDraftApplicationDetailsIaflResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/GetCompanyOeiDraftApplicationDetailsIafl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiDraftApplicationDetailsIafl(_response);
        });
    }

    protected processGetCompanyOeiDraftApplicationDetailsIafl(response: Response): Promise<GetCompanyOeiDraftApplicationDetailsIaflResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiDraftApplicationDetailsIaflResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiDraftApplicationDetailsIaflResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOeiDraftApplicationDetailsIafl(body: UpdateCompanyOeiDraftApplicationDetailsIaflRequestDto | undefined): Promise<UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationDetailsService/UpdateCompanyOeiDraftApplicationDetailsIafl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOeiDraftApplicationDetailsIafl(_response);
        });
    }

    protected processUpdateCompanyOeiDraftApplicationDetailsIafl(response: Response): Promise<UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto>(null as any);
    }
}

export class CompanyOeiDraftApplicationListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiDraftApplicationList(body: GetCompanyOeiDraftApplicationListRequestDto | undefined): Promise<GetCompanyOeiDraftApplicationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiDraftApplicationListService/GetCompanyOeiDraftApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiDraftApplicationList(_response);
        });
    }

    protected processGetCompanyOeiDraftApplicationList(response: Response): Promise<GetCompanyOeiDraftApplicationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiDraftApplicationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiDraftApplicationListResponseDto>(null as any);
    }
}

export class CompanyOeiInvitationToApplyListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiInvitationToApplyList(body: GetCompanyOeiInvitationToApplyListRequestDto | undefined): Promise<GetCompanyOeiInvitationToApplyListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiInvitationToApplyListService/GetCompanyOeiInvitationToApplyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiInvitationToApplyList(_response);
        });
    }

    protected processGetCompanyOeiInvitationToApplyList(response: Response): Promise<GetCompanyOeiInvitationToApplyListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiInvitationToApplyListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiInvitationToApplyListResponseDto>(null as any);
    }
}

export class CompanyOeiLicenceDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiLicenceDetails(body: GetCompanyOeiLicenceDetailsRequestDto | undefined): Promise<GetCompanyOeiLicenceDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiLicenceDetailsService/GetCompanyOeiLicenceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiLicenceDetails(_response);
        });
    }

    protected processGetCompanyOeiLicenceDetails(response: Response): Promise<GetCompanyOeiLicenceDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiLicenceDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiLicenceDetailsResponseDto>(null as any);
    }
}

export class CompanyOeiLicenceListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiLicenceList(body: GetCompanyOeiLicenceListRequestDto | undefined): Promise<GetCompanyOeiLicenceListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiLicenceListService/GetCompanyOeiLicenceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiLicenceList(_response);
        });
    }

    protected processGetCompanyOeiLicenceList(response: Response): Promise<GetCompanyOeiLicenceListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiLicenceListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiLicenceListResponseDto>(null as any);
    }
}

export class CompanyOeiOeiAdhocUploadServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOeiOeiAdhocUploadDetails(body: GetCompanyOeiOeiAdhocUploadDetailsRequestDto | undefined): Promise<GetCompanyOeiOeiAdhocUploadDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiOeiAdhocUploadService/GetCompanyOeiOeiAdhocUploadDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOeiOeiAdhocUploadDetails(_response);
        });
    }

    protected processGetCompanyOeiOeiAdhocUploadDetails(response: Response): Promise<GetCompanyOeiOeiAdhocUploadDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOeiOeiAdhocUploadDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOeiOeiAdhocUploadDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOeiOeiAdhocUpload(body: CreateCompanyOeiOeiAdhocUploadRequestDto | undefined): Promise<CreateCompanyOeiOeiAdhocUploadResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOeiOeiAdhocUploadService/CreateCompanyOeiOeiAdhocUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOeiOeiAdhocUpload(_response);
        });
    }

    protected processCreateCompanyOeiOeiAdhocUpload(response: Response): Promise<CreateCompanyOeiOeiAdhocUploadResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOeiOeiAdhocUploadResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOeiOeiAdhocUploadResponseDto>(null as any);
    }
}

export class CompanyOpggsApplicationAdhocUploadServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationAdhocUploadDetails(body: GetCompanyOpggsApplicationAdhocUploadDetailsRequestDto | undefined): Promise<GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationAdhocUploadService/GetCompanyOpggsApplicationAdhocUploadDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationAdhocUploadDetails(_response);
        });
    }

    protected processGetCompanyOpggsApplicationAdhocUploadDetails(response: Response): Promise<GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsApplicationAdhocUpload(body: CreateCompanyOpggsApplicationAdhocUploadRequestDto | undefined): Promise<CreateCompanyOpggsApplicationAdhocUploadResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationAdhocUploadService/CreateCompanyOpggsApplicationAdhocUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsApplicationAdhocUpload(_response);
        });
    }

    protected processCreateCompanyOpggsApplicationAdhocUpload(response: Response): Promise<CreateCompanyOpggsApplicationAdhocUploadResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsApplicationAdhocUploadResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsApplicationAdhocUploadResponseDto>(null as any);
    }
}

export class CompanyOpggsApplicationDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsLayoutAndHeader(body: GetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsLayoutAndHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsLayoutAndHeader(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsLayoutAndHeader(response: Response): Promise<GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsContact(body: GetCompanyOpggsApplicationDetailsContactRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsContactResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsContact(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsContact(response: Response): Promise<GetCompanyOpggsApplicationDetailsContactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsContactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsContactResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsApplicationDetails(body: GetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsApplicationDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsApplicationDetails(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsApplicationDetails(response: Response): Promise<GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsTitleholders(body: GetCompanyOpggsApplicationDetailsTitleholdersRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsTitleholdersResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsTitleholders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsTitleholders(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsTitleholders(response: Response): Promise<GetCompanyOpggsApplicationDetailsTitleholdersResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsTitleholdersResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsTitleholdersResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsBlockDetails(body: GetCompanyOpggsApplicationDetailsBlockDetailsRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsBlockDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsBlockDetails(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsBlockDetails(response: Response): Promise<GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsWorkProgram(body: GetCompanyOpggsApplicationDetailsWorkProgramRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsWorkProgramResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsWorkProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsWorkProgram(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsWorkProgram(response: Response): Promise<GetCompanyOpggsApplicationDetailsWorkProgramResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsWorkProgramResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsWorkProgramResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsFinancialNotification(body: GetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsFinancialNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsFinancialNotification(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsFinancialNotification(response: Response): Promise<GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsApprovalTracking(body: GetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsApprovalTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsApprovalTracking(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsApprovalTracking(response: Response): Promise<GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsDocumentation(body: GetCompanyOpggsApplicationDetailsDocumentationRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsDocumentation(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsDocumentation(response: Response): Promise<GetCompanyOpggsApplicationDetailsDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationDetailsRfi(body: GetCompanyOpggsApplicationDetailsRfiRequestDto | undefined): Promise<GetCompanyOpggsApplicationDetailsRfiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/GetCompanyOpggsApplicationDetailsRfi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationDetailsRfi(_response);
        });
    }

    protected processGetCompanyOpggsApplicationDetailsRfi(response: Response): Promise<GetCompanyOpggsApplicationDetailsRfiResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationDetailsRfiResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationDetailsRfiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsApplicationDetailsRfi(body: UpdateCompanyOpggsApplicationDetailsRfiRequestDto | undefined): Promise<UpdateCompanyOpggsApplicationDetailsRfiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationDetailsService/UpdateCompanyOpggsApplicationDetailsRfi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsApplicationDetailsRfi(_response);
        });
    }

    protected processUpdateCompanyOpggsApplicationDetailsRfi(response: Response): Promise<UpdateCompanyOpggsApplicationDetailsRfiResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsApplicationDetailsRfiResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsApplicationDetailsRfiResponseDto>(null as any);
    }
}

export class CompanyOpggsApplicationListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsApplicationList(body: GetCompanyOpggsApplicationListRequestDto | undefined): Promise<GetCompanyOpggsApplicationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsApplicationListService/GetCompanyOpggsApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsApplicationList(_response);
        });
    }

    protected processGetCompanyOpggsApplicationList(response: Response): Promise<GetCompanyOpggsApplicationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsApplicationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsApplicationListResponseDto>(null as any);
    }
}

export class CompanyOpggsCreateDraftApplicationServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsCreateDraftApplicationReferenceData(body: GetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto | undefined): Promise<GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsCreateDraftApplicationService/GetCompanyOpggsCreateDraftApplicationReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsCreateDraftApplicationReferenceData(_response);
        });
    }

    protected processGetCompanyOpggsCreateDraftApplicationReferenceData(response: Response): Promise<GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsCreateDraftApplication(body: CreateCompanyOpggsCreateDraftApplicationRequestDto | undefined): Promise<CreateCompanyOpggsCreateDraftApplicationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsCreateDraftApplicationService/CreateCompanyOpggsCreateDraftApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsCreateDraftApplication(_response);
        });
    }

    protected processCreateCompanyOpggsCreateDraftApplication(response: Response): Promise<CreateCompanyOpggsCreateDraftApplicationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsCreateDraftApplicationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsCreateDraftApplicationResponseDto>(null as any);
    }
}

export class CompanyOpggsDraftApplicationDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsContact(body: GetCompanyOpggsDraftApplicationDetailsContactRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsContactResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsContact(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsContact(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsContactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsContactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsContactResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsDraftApplicationDetailsContact(body: SaveCompanyOpggsDraftApplicationDetailsContactRequestDto | undefined): Promise<SaveCompanyOpggsDraftApplicationDetailsContactResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/SaveCompanyOpggsDraftApplicationDetailsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsDraftApplicationDetailsContact(_response);
        });
    }

    protected processSaveCompanyOpggsDraftApplicationDetailsContact(response: Response): Promise<SaveCompanyOpggsDraftApplicationDetailsContactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsDraftApplicationDetailsContactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsDraftApplicationDetailsContactResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsEva(body: GetCompanyOpggsDraftApplicationDetailsEvaRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsEvaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsEva";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsEva(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsEva(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsEvaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsEvaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsEvaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsDraftApplicationDetailsEva(body: SaveCompanyOpggsDraftApplicationDetailsEvaRequestDto | undefined): Promise<SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/SaveCompanyOpggsDraftApplicationDetailsEva";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsDraftApplicationDetailsEva(_response);
        });
    }

    protected processSaveCompanyOpggsDraftApplicationDetailsEva(response: Response): Promise<SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsWorkProgram(body: GetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsWorkProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsWorkProgram(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsWorkProgram(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsDraftApplicationDetailsWorkProgram(body: SaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto | undefined): Promise<SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/SaveCompanyOpggsDraftApplicationDetailsWorkProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsDraftApplicationDetailsWorkProgram(_response);
        });
    }

    protected processSaveCompanyOpggsDraftApplicationDetailsWorkProgram(response: Response): Promise<SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(body: GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(body: SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto | undefined): Promise<SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(_response);
        });
    }

    protected processSaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestment(response: Response): Promise<SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsCoCn(body: GetCompanyOpggsDraftApplicationDetailsCoCnRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsCoCn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsCoCn(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsCoCn(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsCoCn(body: UpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsCoCn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsCoCn(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsCoCn(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsEpRenewal(body: GetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsEpRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsEpRenewal(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsEpRenewal(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsEpRenewal(body: UpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsEpRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsEpRenewal(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsEpRenewal(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsEpRenewalBlocks(body: UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocks(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocks(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsRlRenewal(body: GetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsRlRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsRlRenewal(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsRlRenewal(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsRlRenewal(body: UpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsRlRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsRlRenewal(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsRlRenewal(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsEottlr(body: GetCompanyOpggsDraftApplicationDetailsEottlrRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsEottlr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsEottlr(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsEottlr(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsEottlr(body: UpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsEottlr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsEottlr(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsEottlr(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsIarl(body: GetCompanyOpggsDraftApplicationDetailsIarlRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsIarlResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsIarl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsIarl(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsIarl(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsIarlResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsIarlResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsIarlResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsIarl(body: UpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsIarl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsIarl(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsIarl(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationDetailsIapp(body: GetCompanyOpggsDraftApplicationDetailsIappRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationDetailsIappResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/GetCompanyOpggsDraftApplicationDetailsIapp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationDetailsIapp(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationDetailsIapp(response: Response): Promise<GetCompanyOpggsDraftApplicationDetailsIappResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationDetailsIappResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationDetailsIappResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCompanyOpggsDraftApplicationDetailsIapp(body: UpdateCompanyOpggsDraftApplicationDetailsIappRequestDto | undefined): Promise<UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationDetailsService/UpdateCompanyOpggsDraftApplicationDetailsIapp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyOpggsDraftApplicationDetailsIapp(_response);
        });
    }

    protected processUpdateCompanyOpggsDraftApplicationDetailsIapp(response: Response): Promise<UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto>(null as any);
    }
}

export class CompanyOpggsDraftApplicationListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsDraftApplicationList(body: GetCompanyOpggsDraftApplicationListRequestDto | undefined): Promise<GetCompanyOpggsDraftApplicationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsDraftApplicationListService/GetCompanyOpggsDraftApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsDraftApplicationList(_response);
        });
    }

    protected processGetCompanyOpggsDraftApplicationList(response: Response): Promise<GetCompanyOpggsDraftApplicationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsDraftApplicationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsDraftApplicationListResponseDto>(null as any);
    }
}

export class CompanyOpggsLegislativeFormsListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsList(body: GetCompanyOpggsLegislativeFormsListRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsListService/GetCompanyOpggsLegislativeFormsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsList(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsList(response: Response): Promise<GetCompanyOpggsLegislativeFormsListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsListResponseDto>(null as any);
    }
}

export class CompanyOpggsLegislativeFormsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsFormRequestReferenceData(body: GetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsFormRequestReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsFormRequestReferenceData(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsFormRequestReferenceData(response: Response): Promise<GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteCompanyOpggsLegislativeFormsFormRequest(body: DeleteCompanyOpggsLegislativeFormsFormRequestRequestDto | undefined): Promise<DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/DeleteCompanyOpggsLegislativeFormsFormRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCompanyOpggsLegislativeFormsFormRequest(_response);
        });
    }

    protected processDeleteCompanyOpggsLegislativeFormsFormRequest(response: Response): Promise<DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsFormRequestSignatureType(body: GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsFormRequestSignatureType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsFormRequestSignatureType(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsFormRequestSignatureType(response: Response): Promise<GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsLegislativeFormsFormRequestSignatureType(body: SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto | undefined): Promise<SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SaveCompanyOpggsLegislativeFormsFormRequestSignatureType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsLegislativeFormsFormRequestSignatureType(_response);
        });
    }

    protected processSaveCompanyOpggsLegislativeFormsFormRequestSignatureType(response: Response): Promise<SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsFormRequestFormDocumentation(body: GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsFormRequestFormDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsFormRequestFormDocumentation(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsFormRequestFormDocumentation(response: Response): Promise<GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentation(body: SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto | undefined): Promise<SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentation(_response);
        });
    }

    protected processSaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentation(response: Response): Promise<SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsLegislativeFormsFormRequestDigitalSignature(body: SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto | undefined): Promise<SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsLegislativeFormsFormRequestDigitalSignature(_response);
        });
    }

    protected processSaveCompanyOpggsLegislativeFormsFormRequestDigitalSignature(response: Response): Promise<SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm2Request(body: CreateCompanyOpggsLegislativeFormsForm2RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm2Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm2Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm2Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm2Request(body: GetCompanyOpggsLegislativeFormsForm2RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm2RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm2Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm2Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm2Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm2RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm2RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm2RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsLegislativeFormsForm2RequestDetails(body: SaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto | undefined): Promise<SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SaveCompanyOpggsLegislativeFormsForm2RequestDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsLegislativeFormsForm2RequestDetails(_response);
        });
    }

    protected processSaveCompanyOpggsLegislativeFormsForm2RequestDetails(response: Response): Promise<SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm2RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm2RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm2RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm2RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm3Request(body: CreateCompanyOpggsLegislativeFormsForm3RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm3Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm3Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm3Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm3Request(body: GetCompanyOpggsLegislativeFormsForm3RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm3RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm3Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm3Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm3Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm3RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm3RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm3RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyOpggsLegislativeFormsForm3RequestDetails(body: SaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto | undefined): Promise<SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SaveCompanyOpggsLegislativeFormsForm3RequestDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyOpggsLegislativeFormsForm3RequestDetails(_response);
        });
    }

    protected processSaveCompanyOpggsLegislativeFormsForm3RequestDetails(response: Response): Promise<SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm3RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm3RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm3RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm3RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm4Request(body: CreateCompanyOpggsLegislativeFormsForm4RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm4Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm4Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm4Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm4Request(body: GetCompanyOpggsLegislativeFormsForm4RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm4RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm4Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm4Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm4Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm4RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm4RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm4RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm4RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm4RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm4RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm4RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm5Request(body: CreateCompanyOpggsLegislativeFormsForm5RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm5Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm5Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm5Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm5Request(body: GetCompanyOpggsLegislativeFormsForm5RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm5RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm5Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm5Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm5Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm5RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm5RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm5RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm5RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm5RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm5RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm5RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm6Request(body: CreateCompanyOpggsLegislativeFormsForm6RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm6Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm6Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm6Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm6Request(body: GetCompanyOpggsLegislativeFormsForm6RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm6RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm6Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm6Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm6Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm6RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm6RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm6RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm6RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm6RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm6RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm6RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompanyOpggsLegislativeFormsForm7Request(body: CreateCompanyOpggsLegislativeFormsForm7RequestRequestDto | undefined): Promise<CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/CreateCompanyOpggsLegislativeFormsForm7Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompanyOpggsLegislativeFormsForm7Request(_response);
        });
    }

    protected processCreateCompanyOpggsLegislativeFormsForm7Request(response: Response): Promise<CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsLegislativeFormsForm7Request(body: GetCompanyOpggsLegislativeFormsForm7RequestRequestDto | undefined): Promise<GetCompanyOpggsLegislativeFormsForm7RequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GetCompanyOpggsLegislativeFormsForm7Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsLegislativeFormsForm7Request(_response);
        });
    }

    protected processGetCompanyOpggsLegislativeFormsForm7Request(response: Response): Promise<GetCompanyOpggsLegislativeFormsForm7RequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsLegislativeFormsForm7RequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsLegislativeFormsForm7RequestResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigning(body: SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto | undefined): Promise<SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigning(_response);
        });
    }

    protected processSetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigning(response: Response): Promise<SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateCompanyOpggsLegislativeFormsForm7RequestDocument(body: GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto | undefined): Promise<GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/GenerateCompanyOpggsLegislativeFormsForm7RequestDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCompanyOpggsLegislativeFormsForm7RequestDocument(_response);
        });
    }

    protected processGenerateCompanyOpggsLegislativeFormsForm7RequestDocument(response: Response): Promise<GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApproval(body: SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto | undefined): Promise<SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsLegislativeFormsService/SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApproval(_response);
        });
    }

    protected processSubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApproval(response: Response): Promise<SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto>(null as any);
    }
}

export class CompanyOpggsTitleDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsTitleDetails(body: GetCompanyOpggsTitleDetailsRequestDto | undefined): Promise<GetCompanyOpggsTitleDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsTitleDetailsService/GetCompanyOpggsTitleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsTitleDetails(_response);
        });
    }

    protected processGetCompanyOpggsTitleDetails(response: Response): Promise<GetCompanyOpggsTitleDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsTitleDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsTitleDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsTitleDetailsMap(body: GetCompanyOpggsTitleDetailsMapRequestDto | undefined): Promise<GetCompanyOpggsTitleDetailsMapResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsTitleDetailsService/GetCompanyOpggsTitleDetailsMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsTitleDetailsMap(_response);
        });
    }

    protected processGetCompanyOpggsTitleDetailsMap(response: Response): Promise<GetCompanyOpggsTitleDetailsMapResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsTitleDetailsMapResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsTitleDetailsMapResponseDto>(null as any);
    }
}

export class CompanyOpggsTitleListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyOpggsTitleList(body: GetCompanyOpggsTitleListRequestDto | undefined): Promise<GetCompanyOpggsTitleListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyOpggsTitleListService/GetCompanyOpggsTitleList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyOpggsTitleList(_response);
        });
    }

    protected processGetCompanyOpggsTitleList(response: Response): Promise<GetCompanyOpggsTitleListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyOpggsTitleListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyOpggsTitleListResponseDto>(null as any);
    }
}

export class CompanyUserManagementServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementCompanyList(body: GetCompanyUserManagementCompanyListRequestDto | undefined): Promise<GetCompanyUserManagementCompanyListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementCompanyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementCompanyList(_response);
        });
    }

    protected processGetCompanyUserManagementCompanyList(response: Response): Promise<GetCompanyUserManagementCompanyListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementCompanyListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementCompanyListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementCompanyDetails(body: GetCompanyUserManagementCompanyDetailsRequestDto | undefined): Promise<GetCompanyUserManagementCompanyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementCompanyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementCompanyDetails(_response);
        });
    }

    protected processGetCompanyUserManagementCompanyDetails(response: Response): Promise<GetCompanyUserManagementCompanyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementCompanyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementCompanyDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyUserManagementCompanyDetailsRoles(body: SaveCompanyUserManagementCompanyDetailsRolesRequestDto | undefined): Promise<SaveCompanyUserManagementCompanyDetailsRolesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/SaveCompanyUserManagementCompanyDetailsRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyUserManagementCompanyDetailsRoles(_response);
        });
    }

    protected processSaveCompanyUserManagementCompanyDetailsRoles(response: Response): Promise<SaveCompanyUserManagementCompanyDetailsRolesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyUserManagementCompanyDetailsRolesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyUserManagementCompanyDetailsRolesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementUserList(body: GetCompanyUserManagementUserListRequestDto | undefined): Promise<GetCompanyUserManagementUserListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementUserList(_response);
        });
    }

    protected processGetCompanyUserManagementUserList(response: Response): Promise<GetCompanyUserManagementUserListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementUserListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementUserListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementUserDetails(body: GetCompanyUserManagementUserDetailsRequestDto | undefined): Promise<GetCompanyUserManagementUserDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementUserDetails(_response);
        });
    }

    protected processGetCompanyUserManagementUserDetails(response: Response): Promise<GetCompanyUserManagementUserDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementUserDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementUserDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCompanyUserManagementUserDetailsRoles(body: SaveCompanyUserManagementUserDetailsRolesRequestDto | undefined): Promise<SaveCompanyUserManagementUserDetailsRolesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/SaveCompanyUserManagementUserDetailsRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCompanyUserManagementUserDetailsRoles(_response);
        });
    }

    protected processSaveCompanyUserManagementUserDetailsRoles(response: Response): Promise<SaveCompanyUserManagementUserDetailsRolesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCompanyUserManagementUserDetailsRolesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCompanyUserManagementUserDetailsRolesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeCompanyUserManagementUserDetailsUser(body: RemoveCompanyUserManagementUserDetailsUserRequestDto | undefined): Promise<RemoveCompanyUserManagementUserDetailsUserResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RemoveCompanyUserManagementUserDetailsUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveCompanyUserManagementUserDetailsUser(_response);
        });
    }

    protected processRemoveCompanyUserManagementUserDetailsUser(response: Response): Promise<RemoveCompanyUserManagementUserDetailsUserResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveCompanyUserManagementUserDetailsUserResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemoveCompanyUserManagementUserDetailsUserResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestList(body: GetCompanyUserManagementRequestListRequestDto | undefined): Promise<GetCompanyUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestList(_response);
        });
    }

    protected processGetCompanyUserManagementRequestList(response: Response): Promise<GetCompanyUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchApproveCompanyUserManagementRequestList(body: BatchApproveCompanyUserManagementRequestListRequestDto | undefined): Promise<BatchApproveCompanyUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/BatchApproveCompanyUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchApproveCompanyUserManagementRequestList(_response);
        });
    }

    protected processBatchApproveCompanyUserManagementRequestList(response: Response): Promise<BatchApproveCompanyUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchApproveCompanyUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchApproveCompanyUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchRejectCompanyUserManagementRequestList(body: BatchRejectCompanyUserManagementRequestListRequestDto | undefined): Promise<BatchRejectCompanyUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/BatchRejectCompanyUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchRejectCompanyUserManagementRequestList(_response);
        });
    }

    protected processBatchRejectCompanyUserManagementRequestList(response: Response): Promise<BatchRejectCompanyUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchRejectCompanyUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchRejectCompanyUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestDetailsCr(body: GetCompanyUserManagementRequestDetailsCrRequestDto | undefined): Promise<GetCompanyUserManagementRequestDetailsCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestDetailsCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestDetailsCr(_response);
        });
    }

    protected processGetCompanyUserManagementRequestDetailsCr(response: Response): Promise<GetCompanyUserManagementRequestDetailsCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestDetailsCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestDetailsCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveCompanyUserManagementRequestDetailsCr(body: ApproveCompanyUserManagementRequestDetailsCrRequestDto | undefined): Promise<ApproveCompanyUserManagementRequestDetailsCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/ApproveCompanyUserManagementRequestDetailsCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveCompanyUserManagementRequestDetailsCr(_response);
        });
    }

    protected processApproveCompanyUserManagementRequestDetailsCr(response: Response): Promise<ApproveCompanyUserManagementRequestDetailsCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveCompanyUserManagementRequestDetailsCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveCompanyUserManagementRequestDetailsCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectCompanyUserManagementRequestDetailsCr(body: RejectCompanyUserManagementRequestDetailsCrRequestDto | undefined): Promise<RejectCompanyUserManagementRequestDetailsCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RejectCompanyUserManagementRequestDetailsCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectCompanyUserManagementRequestDetailsCr(_response);
        });
    }

    protected processRejectCompanyUserManagementRequestDetailsCr(response: Response): Promise<RejectCompanyUserManagementRequestDetailsCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectCompanyUserManagementRequestDetailsCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectCompanyUserManagementRequestDetailsCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestDetailsNuCr(body: GetCompanyUserManagementRequestDetailsNuCrRequestDto | undefined): Promise<GetCompanyUserManagementRequestDetailsNuCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestDetailsNuCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestDetailsNuCr(_response);
        });
    }

    protected processGetCompanyUserManagementRequestDetailsNuCr(response: Response): Promise<GetCompanyUserManagementRequestDetailsNuCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestDetailsNuCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestDetailsNuCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveCompanyUserManagementRequestDetailsNuCr(body: ApproveCompanyUserManagementRequestDetailsNuCrRequestDto | undefined): Promise<ApproveCompanyUserManagementRequestDetailsNuCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/ApproveCompanyUserManagementRequestDetailsNuCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveCompanyUserManagementRequestDetailsNuCr(_response);
        });
    }

    protected processApproveCompanyUserManagementRequestDetailsNuCr(response: Response): Promise<ApproveCompanyUserManagementRequestDetailsNuCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveCompanyUserManagementRequestDetailsNuCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveCompanyUserManagementRequestDetailsNuCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectCompanyUserManagementRequestDetailsNuCr(body: RejectCompanyUserManagementRequestDetailsNuCrRequestDto | undefined): Promise<RejectCompanyUserManagementRequestDetailsNuCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RejectCompanyUserManagementRequestDetailsNuCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectCompanyUserManagementRequestDetailsNuCr(_response);
        });
    }

    protected processRejectCompanyUserManagementRequestDetailsNuCr(response: Response): Promise<RejectCompanyUserManagementRequestDetailsNuCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectCompanyUserManagementRequestDetailsNuCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectCompanyUserManagementRequestDetailsNuCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestDetailsCs(body: GetCompanyUserManagementRequestDetailsCsRequestDto | undefined): Promise<GetCompanyUserManagementRequestDetailsCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestDetailsCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestDetailsCs(_response);
        });
    }

    protected processGetCompanyUserManagementRequestDetailsCs(response: Response): Promise<GetCompanyUserManagementRequestDetailsCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestDetailsCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestDetailsCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveCompanyUserManagementRequestDetailsCs(body: ApproveCompanyUserManagementRequestDetailsCsRequestDto | undefined): Promise<ApproveCompanyUserManagementRequestDetailsCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/ApproveCompanyUserManagementRequestDetailsCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveCompanyUserManagementRequestDetailsCs(_response);
        });
    }

    protected processApproveCompanyUserManagementRequestDetailsCs(response: Response): Promise<ApproveCompanyUserManagementRequestDetailsCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveCompanyUserManagementRequestDetailsCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveCompanyUserManagementRequestDetailsCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectCompanyUserManagementRequestDetailsCs(body: RejectCompanyUserManagementRequestDetailsCsRequestDto | undefined): Promise<RejectCompanyUserManagementRequestDetailsCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RejectCompanyUserManagementRequestDetailsCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectCompanyUserManagementRequestDetailsCs(_response);
        });
    }

    protected processRejectCompanyUserManagementRequestDetailsCs(response: Response): Promise<RejectCompanyUserManagementRequestDetailsCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectCompanyUserManagementRequestDetailsCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectCompanyUserManagementRequestDetailsCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestDetailsCrCs(body: GetCompanyUserManagementRequestDetailsCrCsRequestDto | undefined): Promise<GetCompanyUserManagementRequestDetailsCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestDetailsCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestDetailsCrCs(_response);
        });
    }

    protected processGetCompanyUserManagementRequestDetailsCrCs(response: Response): Promise<GetCompanyUserManagementRequestDetailsCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestDetailsCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestDetailsCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveCompanyUserManagementRequestDetailsCrCs(body: ApproveCompanyUserManagementRequestDetailsCrCsRequestDto | undefined): Promise<ApproveCompanyUserManagementRequestDetailsCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/ApproveCompanyUserManagementRequestDetailsCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveCompanyUserManagementRequestDetailsCrCs(_response);
        });
    }

    protected processApproveCompanyUserManagementRequestDetailsCrCs(response: Response): Promise<ApproveCompanyUserManagementRequestDetailsCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveCompanyUserManagementRequestDetailsCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveCompanyUserManagementRequestDetailsCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectCompanyUserManagementRequestDetailsCrCs(body: RejectCompanyUserManagementRequestDetailsCrCsRequestDto | undefined): Promise<RejectCompanyUserManagementRequestDetailsCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RejectCompanyUserManagementRequestDetailsCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectCompanyUserManagementRequestDetailsCrCs(_response);
        });
    }

    protected processRejectCompanyUserManagementRequestDetailsCrCs(response: Response): Promise<RejectCompanyUserManagementRequestDetailsCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectCompanyUserManagementRequestDetailsCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectCompanyUserManagementRequestDetailsCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCompanyUserManagementRequestDetailsNuCrCs(body: GetCompanyUserManagementRequestDetailsNuCrCsRequestDto | undefined): Promise<GetCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/GetCompanyUserManagementRequestDetailsNuCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUserManagementRequestDetailsNuCrCs(_response);
        });
    }

    protected processGetCompanyUserManagementRequestDetailsNuCrCs(response: Response): Promise<GetCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyUserManagementRequestDetailsNuCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompanyUserManagementRequestDetailsNuCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveCompanyUserManagementRequestDetailsNuCrCs(body: ApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto | undefined): Promise<ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/ApproveCompanyUserManagementRequestDetailsNuCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveCompanyUserManagementRequestDetailsNuCrCs(_response);
        });
    }

    protected processApproveCompanyUserManagementRequestDetailsNuCrCs(response: Response): Promise<ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectCompanyUserManagementRequestDetailsNuCrCs(body: RejectCompanyUserManagementRequestDetailsNuCrCsRequestDto | undefined): Promise<RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CompanyUserManagementService/RejectCompanyUserManagementRequestDetailsNuCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectCompanyUserManagementRequestDetailsNuCrCs(_response);
        });
    }

    protected processRejectCompanyUserManagementRequestDetailsNuCrCs(response: Response): Promise<RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto>(null as any);
    }
}

export class EtlServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @param partitionPayload (optional) 
     * @return OK
     */
    run(name: string | undefined, partitionPayload: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/EtlService/Run?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (partitionPayload === null)
            throw new Error("The parameter 'partitionPayload' cannot be null.");
        else if (partitionPayload !== undefined)
            url_ += "partitionPayload=" + encodeURIComponent("" + partitionPayload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GaApiReportServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllReports(body: GetAllReportsRequestDto | undefined): Promise<GetAllReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiReportService/GetAllReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllReports(_response);
        });
    }

    protected processGetAllReports(response: Response): Promise<GetAllReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllReportsResponseDto>(null as any);
    }
}

export class GaApiReprocessingServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllReprocessing(body: GetAllReprocessingRequestDto | undefined): Promise<GetAllReprocessingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiReprocessingService/GetAllReprocessing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllReprocessing(_response);
        });
    }

    protected processGetAllReprocessing(response: Response): Promise<GetAllReprocessingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllReprocessingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllReprocessingResponseDto>(null as any);
    }
}

export class GaApiSurveyServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllSurveys(body: GetAllSurveysRequestDto | undefined): Promise<GetAllSurveysResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiSurveyService/GetAllSurveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSurveys(_response);
        });
    }

    protected processGetAllSurveys(response: Response): Promise<GetAllSurveysResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllSurveysResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllSurveysResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAcquisition(body: GetAcquisitionRequestDto | undefined): Promise<GetAcquisitionResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiSurveyService/GetAcquisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAcquisition(_response);
        });
    }

    protected processGetAcquisition(response: Response): Promise<GetAcquisitionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcquisitionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAcquisitionResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllAcquisitions(body: GetAllAcquisitionsRequestDto | undefined): Promise<GetAllAcquisitionsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiSurveyService/GetAllAcquisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAcquisitions(_response);
        });
    }

    protected processGetAllAcquisitions(response: Response): Promise<GetAllAcquisitionsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllAcquisitionsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllAcquisitionsResponseDto>(null as any);
    }
}

export class GaApiWellServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBorehole(body: GetBoreholeRequestDto | undefined): Promise<GetBoreholeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiWellService/GetBorehole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBorehole(_response);
        });
    }

    protected processGetBorehole(response: Response): Promise<GetBoreholeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBoreholeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBoreholeResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllBoreholes(body: GetAllBoreholesRequestDto | undefined): Promise<GetAllBoreholesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GaApiWellService/GetAllBoreholes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllBoreholes(_response);
        });
    }

    protected processGetAllBoreholes(response: Response): Promise<GetAllBoreholesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllBoreholesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllBoreholesResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaAccountServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAccountRequestAccessReferenceData(body: GetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAccountService/GetGeoscienceAustraliaAccountRequestAccessReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAccountRequestAccessReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaAccountRequestAccessReferenceData(response: Response): Promise<GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaAccountRequestAccessGar(body: CreateGeoscienceAustraliaAccountRequestAccessGarRequestDto | undefined): Promise<CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAccountService/CreateGeoscienceAustraliaAccountRequestAccessGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaAccountRequestAccessGar(_response);
        });
    }

    protected processCreateGeoscienceAustraliaAccountRequestAccessGar(response: Response): Promise<CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaAccountRequestAccessGaa(body: CreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto | undefined): Promise<CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAccountService/CreateGeoscienceAustraliaAccountRequestAccessGaa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaAccountRequestAccessGaa(_response);
        });
    }

    protected processCreateGeoscienceAustraliaAccountRequestAccessGaa(response: Response): Promise<CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAccountMyDetails(body: GetGeoscienceAustraliaAccountMyDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAccountService/GetGeoscienceAustraliaAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAccountMyDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaAccountMyDetails(response: Response): Promise<GetGeoscienceAustraliaAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAccountMyDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveGeoscienceAustraliaAccountMyDetails(body: SaveGeoscienceAustraliaAccountMyDetailsRequestDto | undefined): Promise<SaveGeoscienceAustraliaAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAccountService/SaveGeoscienceAustraliaAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveGeoscienceAustraliaAccountMyDetails(_response);
        });
    }

    protected processSaveGeoscienceAustraliaAccountMyDetails(response: Response): Promise<SaveGeoscienceAustraliaAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveGeoscienceAustraliaAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveGeoscienceAustraliaAccountMyDetailsResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaAttachmentServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAttachmentList(body: GetGeoscienceAustraliaAttachmentListRequestDto | undefined): Promise<GetGeoscienceAustraliaAttachmentListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/GetGeoscienceAustraliaAttachmentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAttachmentList(_response);
        });
    }

    protected processGetGeoscienceAustraliaAttachmentList(response: Response): Promise<GetGeoscienceAustraliaAttachmentListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAttachmentListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAttachmentListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAttachmentListReferenceData(body: GetGeoscienceAustraliaAttachmentListReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/GetGeoscienceAustraliaAttachmentListReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAttachmentListReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaAttachmentListReferenceData(response: Response): Promise<GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportGeoscienceAustraliaAttachments(body: ExportGeoscienceAustraliaAttachmentsRequestDto | undefined): Promise<ExportGeoscienceAustraliaAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/ExportGeoscienceAustraliaAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGeoscienceAustraliaAttachments(_response);
        });
    }

    protected processExportGeoscienceAustraliaAttachments(response: Response): Promise<ExportGeoscienceAustraliaAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportGeoscienceAustraliaAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportGeoscienceAustraliaAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importGeoscienceAustraliaAttachments(body: ImportGeoscienceAustraliaAttachmentsRequestDto | undefined): Promise<ImportGeoscienceAustraliaAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/ImportGeoscienceAustraliaAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportGeoscienceAustraliaAttachments(_response);
        });
    }

    protected processImportGeoscienceAustraliaAttachments(response: Response): Promise<ImportGeoscienceAustraliaAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportGeoscienceAustraliaAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportGeoscienceAustraliaAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDeleteGeoscienceAustraliaAttachmentsImportReferenceData(body: GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto | undefined): Promise<GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/GetDeleteGeoscienceAustraliaAttachmentsImportReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeleteGeoscienceAustraliaAttachmentsImportReferenceData(_response);
        });
    }

    protected processGetDeleteGeoscienceAustraliaAttachmentsImportReferenceData(response: Response): Promise<GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaAttachmentsImport(body: DeleteGeoscienceAustraliaAttachmentsImportRequestDto | undefined): Promise<DeleteGeoscienceAustraliaAttachmentsImportResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAttachmentService/DeleteGeoscienceAustraliaAttachmentsImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaAttachmentsImport(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaAttachmentsImport(response: Response): Promise<DeleteGeoscienceAustraliaAttachmentsImportResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaAttachmentsImportResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaAttachmentsImportResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaAuthorisationsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAuthorisationsAuthorisationList(body: GetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto | undefined): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAuthorisationsService/GetGeoscienceAustraliaAuthorisationsAuthorisationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAuthorisationsAuthorisationList(_response);
        });
    }

    protected processGetGeoscienceAustraliaAuthorisationsAuthorisationList(response: Response): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAuthorisationsAuthorisationDetails(body: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAuthorisationsService/GetGeoscienceAustraliaAuthorisationsAuthorisationDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAuthorisationsAuthorisationDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaAuthorisationsAuthorisationDetails(response: Response): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChanges(body: GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaAuthorisationsService/GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaDataSubmissionServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaDataSubmissionDataSubmissionDetails(body: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaDataSubmissionService/GetGeoscienceAustraliaDataSubmissionDataSubmissionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaDataSubmissionDataSubmissionDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaDataSubmissionDataSubmissionDetails(response: Response): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItems(body: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaDataSubmissionService/GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaDataSubmissionResubmissionList(body: GetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto | undefined): Promise<GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaDataSubmissionService/GetGeoscienceAustraliaDataSubmissionResubmissionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaDataSubmissionResubmissionList(_response);
        });
    }

    protected processGetGeoscienceAustraliaDataSubmissionResubmissionList(response: Response): Promise<GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChanges(body: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaDataSubmissionService/GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaDataSubmissionDataResubmissionDetails(body: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaDataSubmissionService/GetGeoscienceAustraliaDataSubmissionDataResubmissionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaDataSubmissionDataResubmissionDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaDataSubmissionDataResubmissionDetails(response: Response): Promise<GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaFeedbackServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaFeedbackList(body: GetGeoscienceAustraliaFeedbackListRequestDto | undefined): Promise<GetGeoscienceAustraliaFeedbackListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaFeedbackService/GetGeoscienceAustraliaFeedbackList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaFeedbackList(_response);
        });
    }

    protected processGetGeoscienceAustraliaFeedbackList(response: Response): Promise<GetGeoscienceAustraliaFeedbackListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaFeedbackListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaFeedbackListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaFeedbackReferenceData(body: GetGeoscienceAustraliaFeedbackReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaFeedbackReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaFeedbackService/GetGeoscienceAustraliaFeedbackReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaFeedbackReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaFeedbackReferenceData(response: Response): Promise<GetGeoscienceAustraliaFeedbackReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaFeedbackReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaFeedbackReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaFeedbackDetails(body: GetGeoscienceAustraliaFeedbackDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaFeedbackDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaFeedbackService/GetGeoscienceAustraliaFeedbackDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaFeedbackDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaFeedbackDetails(response: Response): Promise<GetGeoscienceAustraliaFeedbackDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaFeedbackDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaFeedbackDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveGeoscienceAustraliaFeedbackDetails(body: SaveGeoscienceAustraliaFeedbackDetailsRequestDto | undefined): Promise<SaveGeoscienceAustraliaFeedbackDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaFeedbackService/SaveGeoscienceAustraliaFeedbackDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveGeoscienceAustraliaFeedbackDetails(_response);
        });
    }

    protected processSaveGeoscienceAustraliaFeedbackDetails(response: Response): Promise<SaveGeoscienceAustraliaFeedbackDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveGeoscienceAustraliaFeedbackDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveGeoscienceAustraliaFeedbackDetailsResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaReportServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportList(body: GetGeoscienceAustraliaReportListRequestDto | undefined): Promise<GetGeoscienceAustraliaReportListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportList(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportList(response: Response): Promise<GetGeoscienceAustraliaReportListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportListReferenceData(body: GetGeoscienceAustraliaReportListReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReportListReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportListReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportListReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportListReferenceData(response: Response): Promise<GetGeoscienceAustraliaReportListReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportListReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportListReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportGeoscienceAustraliaReports(body: ExportGeoscienceAustraliaReportsRequestDto | undefined): Promise<ExportGeoscienceAustraliaReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/ExportGeoscienceAustraliaReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGeoscienceAustraliaReports(_response);
        });
    }

    protected processExportGeoscienceAustraliaReports(response: Response): Promise<ExportGeoscienceAustraliaReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportGeoscienceAustraliaReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportGeoscienceAustraliaReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportDetails(body: GetGeoscienceAustraliaReportDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaReportDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportDetails(response: Response): Promise<GetGeoscienceAustraliaReportDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportDetailsReferenceData(body: GetGeoscienceAustraliaReportDetailsReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportDetailsReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportDetailsReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportDetailsReferenceData(response: Response): Promise<GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportFileAssets(body: GetGeoscienceAustraliaReportFileAssetsRequestDto | undefined): Promise<GetGeoscienceAustraliaReportFileAssetsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportFileAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportFileAssets(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportFileAssets(response: Response): Promise<GetGeoscienceAustraliaReportFileAssetsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportFileAssetsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportFileAssetsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportFileAssetsReferenceData(body: GetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportFileAssetsReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportFileAssetsReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportFileAssetsReferenceData(response: Response): Promise<GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReportDetails(body: UpdateGeoscienceAustraliaReportDetailsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReportDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/UpdateGeoscienceAustraliaReportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReportDetails(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReportDetails(response: Response): Promise<UpdateGeoscienceAustraliaReportDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReportDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReportDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReportFileAssets(body: UpdateGeoscienceAustraliaReportFileAssetsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReportFileAssetsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/UpdateGeoscienceAustraliaReportFileAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReportFileAssets(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReportFileAssets(response: Response): Promise<UpdateGeoscienceAustraliaReportFileAssetsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReportFileAssetsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReportFileAssetsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaReport(body: DeleteGeoscienceAustraliaReportRequestDto | undefined): Promise<DeleteGeoscienceAustraliaReportResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/DeleteGeoscienceAustraliaReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaReport(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaReport(response: Response): Promise<DeleteGeoscienceAustraliaReportResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaReportResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaReportResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaReport(body: CreateGeoscienceAustraliaReportRequestDto | undefined): Promise<CreateGeoscienceAustraliaReportResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/CreateGeoscienceAustraliaReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaReport(_response);
        });
    }

    protected processCreateGeoscienceAustraliaReport(response: Response): Promise<CreateGeoscienceAustraliaReportResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaReportResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaReportResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCreateGeoscienceAustraliaReportReferenceData(body: GetCreateGeoscienceAustraliaReportReferenceDataRequestDto | undefined): Promise<GetCreateGeoscienceAustraliaReportReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetCreateGeoscienceAustraliaReportReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreateGeoscienceAustraliaReportReferenceData(_response);
        });
    }

    protected processGetCreateGeoscienceAustraliaReportReferenceData(response: Response): Promise<GetCreateGeoscienceAustraliaReportReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateGeoscienceAustraliaReportReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreateGeoscienceAustraliaReportReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportRelatedActivities(body: GetGeoscienceAustraliaReportRelatedActivitiesRequestDto | undefined): Promise<GetGeoscienceAustraliaReportRelatedActivitiesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportRelatedActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportRelatedActivities(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportRelatedActivities(response: Response): Promise<GetGeoscienceAustraliaReportRelatedActivitiesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportRelatedActivitiesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportRelatedActivitiesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addGeoscienceAustraliaReportRelatedActivities(body: AddGeoscienceAustraliaReportRelatedActivitiesRequestDto | undefined): Promise<AddGeoscienceAustraliaReportRelatedActivitiesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/AddGeoscienceAustraliaReportRelatedActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddGeoscienceAustraliaReportRelatedActivities(_response);
        });
    }

    protected processAddGeoscienceAustraliaReportRelatedActivities(response: Response): Promise<AddGeoscienceAustraliaReportRelatedActivitiesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddGeoscienceAustraliaReportRelatedActivitiesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddGeoscienceAustraliaReportRelatedActivitiesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaReportRelatedActivity(body: DeleteGeoscienceAustraliaReportRelatedActivityRequestDto | undefined): Promise<DeleteGeoscienceAustraliaReportRelatedActivityResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/DeleteGeoscienceAustraliaReportRelatedActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaReportRelatedActivity(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaReportRelatedActivity(response: Response): Promise<DeleteGeoscienceAustraliaReportRelatedActivityResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaReportRelatedActivityResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaReportRelatedActivityResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReports(body: UpdateGeoscienceAustraliaReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/UpdateGeoscienceAustraliaReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReports(response: Response): Promise<UpdateGeoscienceAustraliaReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportAttachments(body: GetGeoscienceAustraliaReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportAttachments(response: Response): Promise<GetGeoscienceAustraliaReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaReportAttachment(body: DeleteGeoscienceAustraliaReportAttachmentRequestDto | undefined): Promise<DeleteGeoscienceAustraliaReportAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/DeleteGeoscienceAustraliaReportAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaReportAttachment(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaReportAttachment(response: Response): Promise<DeleteGeoscienceAustraliaReportAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaReportAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaReportAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReportAttachment(body: UpdateGeoscienceAustraliaReportAttachmentRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReportAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/UpdateGeoscienceAustraliaReportAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReportAttachment(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReportAttachment(response: Response): Promise<UpdateGeoscienceAustraliaReportAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReportAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReportAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaReportAttachment(body: CreateGeoscienceAustraliaReportAttachmentRequestDto | undefined): Promise<CreateGeoscienceAustraliaReportAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/CreateGeoscienceAustraliaReportAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaReportAttachment(_response);
        });
    }

    protected processCreateGeoscienceAustraliaReportAttachment(response: Response): Promise<CreateGeoscienceAustraliaReportAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaReportAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaReportAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellReportAttachments(body: GetGeoscienceAustraliaWellReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaWellReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellReportAttachments(response: Response): Promise<GetGeoscienceAustraliaWellReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaBoreholeReportAttachments(body: GetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaBoreholeReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaBoreholeReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaBoreholeReportAttachments(response: Response): Promise<GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReportDataAuditChanges(body: GetGeoscienceAustraliaReportDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaReportDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReportService/GetGeoscienceAustraliaReportDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReportDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaReportDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaReportDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReportDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReportDataAuditChangesResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaReprocessingsProjectsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingList(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingList(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingList(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceData(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceData(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingDetails(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetails(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjects(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjects(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjects(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingTitles(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitles(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitles(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitions(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitions(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitions(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItems(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingReports(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingReports(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingReportAttachments(body: GetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingReportAttachments(response: Response): Promise<GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(body: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyData(response: Response): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReprocessingsProjectsReprocessingReports(body: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReports(response: Response): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChanges(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjectList(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectList(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectList(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceData(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceData(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetails(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetails(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitles(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitles(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitles(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitions(body: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitions(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitions(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItems(body: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReprocessingsProjectsProjectReports(body: UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/UpdateGeoscienceAustraliaReprocessingsProjectsProjectReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReprocessingsProjectsProjectReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReprocessingsProjectsProjectReports(response: Response): Promise<UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetails(body: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetails(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingsProjectsProjectReports(body: GetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingsProjectsProjectReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingsProjectsProjectReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingsProjectsProjectReports(response: Response): Promise<GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingProjectReportAttachments(body: GetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingProjectReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingProjectReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingProjectReportAttachments(response: Response): Promise<GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyData(body: GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto | undefined): Promise<GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyData(_response);
        });
    }

    protected processGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyData(response: Response): Promise<GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaReprocessingProjectsProjectSurveyData(body: UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto | undefined): Promise<UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaReprocessingsProjectsService/UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyData(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyData(response: Response): Promise<UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaSurveyDataServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataList(body: GetGeoscienceAustraliaSurveyDataListRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataList(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataList(response: Response): Promise<GetGeoscienceAustraliaSurveyDataListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataListReferenceData(body: GetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataListReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataListReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataListReferenceData(response: Response): Promise<GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportGeoscienceAustraliaSurveyData(body: ExportGeoscienceAustraliaSurveyDataRequestDto | undefined): Promise<ExportGeoscienceAustraliaSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/ExportGeoscienceAustraliaSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGeoscienceAustraliaSurveyData(_response);
        });
    }

    protected processExportGeoscienceAustraliaSurveyData(response: Response): Promise<ExportGeoscienceAustraliaSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportGeoscienceAustraliaSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportGeoscienceAustraliaSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveyDataBatch(body: UpdateGeoscienceAustraliaSurveyDataBatchRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveyDataBatchResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/UpdateGeoscienceAustraliaSurveyDataBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveyDataBatch(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveyDataBatch(response: Response): Promise<UpdateGeoscienceAustraliaSurveyDataBatchResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveyDataBatchResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveyDataBatchResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataDetails(body: GetGeoscienceAustraliaSurveyDataDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataDetails(response: Response): Promise<GetGeoscienceAustraliaSurveyDataDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataDetailsReferenceData(body: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataDetailsReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataDetailsReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataDetailsReferenceData(response: Response): Promise<GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveyDataDetails(body: UpdateGeoscienceAustraliaSurveyDataDetailsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/UpdateGeoscienceAustraliaSurveyDataDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveyDataDetails(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveyDataDetails(response: Response): Promise<UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveyData(body: DeleteGeoscienceAustraliaSurveyDataRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/DeleteGeoscienceAustraliaSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveyData(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveyData(response: Response): Promise<DeleteGeoscienceAustraliaSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataFileAssets(body: GetGeoscienceAustraliaSurveyDataFileAssetsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataFileAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataFileAssets(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataFileAssets(response: Response): Promise<GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataFileAssetsReferenceData(body: GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataFileAssetsReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataFileAssetsReferenceData(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataFileAssetsReferenceData(response: Response): Promise<GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveyDataFileAssets(body: UpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/UpdateGeoscienceAustraliaSurveyDataFileAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveyDataFileAssets(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveyDataFileAssets(response: Response): Promise<UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaSurveyData(body: CreateGeoscienceAustraliaSurveyDataRequestDto | undefined): Promise<CreateGeoscienceAustraliaSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/CreateGeoscienceAustraliaSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaSurveyData(_response);
        });
    }

    protected processCreateGeoscienceAustraliaSurveyData(response: Response): Promise<CreateGeoscienceAustraliaSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCreateGeoscienceAustraliaSurveyDataReferenceData(body: GetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto | undefined): Promise<GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetCreateGeoscienceAustraliaSurveyDataReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreateGeoscienceAustraliaSurveyDataReferenceData(_response);
        });
    }

    protected processGetCreateGeoscienceAustraliaSurveyDataReferenceData(response: Response): Promise<GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataRelatedActivities(body: GetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataRelatedActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataRelatedActivities(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataRelatedActivities(response: Response): Promise<GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addGeoscienceAustraliaSurveyDataRelatedActivities(body: AddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto | undefined): Promise<AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/AddGeoscienceAustraliaSurveyDataRelatedActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddGeoscienceAustraliaSurveyDataRelatedActivities(_response);
        });
    }

    protected processAddGeoscienceAustraliaSurveyDataRelatedActivities(response: Response): Promise<AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveyDataRelatedActivity(body: DeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/DeleteGeoscienceAustraliaSurveyDataRelatedActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveyDataRelatedActivity(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveyDataRelatedActivity(response: Response): Promise<DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataAttachments(body: GetGeoscienceAustraliaSurveyDataAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataAttachments(response: Response): Promise<GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveyDataAttachment(body: DeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/DeleteGeoscienceAustraliaSurveyDataAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveyDataAttachment(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveyDataAttachment(response: Response): Promise<DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveyDataAttachment(body: UpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/UpdateGeoscienceAustraliaSurveyDataAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveyDataAttachment(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveyDataAttachment(response: Response): Promise<UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaSurveyDataAttachment(body: CreateGeoscienceAustraliaSurveyDataAttachmentRequestDto | undefined): Promise<CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/CreateGeoscienceAustraliaSurveyDataAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaSurveyDataAttachment(_response);
        });
    }

    protected processCreateGeoscienceAustraliaSurveyDataAttachment(response: Response): Promise<CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataLines(body: GetGeoscienceAustraliaSurveyDataLinesRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataLinesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataLines(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataLines(response: Response): Promise<GetGeoscienceAustraliaSurveyDataLinesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataLinesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataLinesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveyDataAllLines(body: DeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/DeleteGeoscienceAustraliaSurveyDataAllLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveyDataAllLines(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveyDataAllLines(response: Response): Promise<DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveyDataLine(body: DeleteGeoscienceAustraliaSurveyDataLineRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveyDataLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/DeleteGeoscienceAustraliaSurveyDataLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveyDataLine(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveyDataLine(response: Response): Promise<DeleteGeoscienceAustraliaSurveyDataLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveyDataLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveyDataLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveyDataLine(body: UpdateGeoscienceAustraliaSurveyDataLineRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveyDataLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/UpdateGeoscienceAustraliaSurveyDataLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveyDataLine(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveyDataLine(response: Response): Promise<UpdateGeoscienceAustraliaSurveyDataLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveyDataLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveyDataLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaSurveyDataLine(body: CreateGeoscienceAustraliaSurveyDataLineRequestDto | undefined): Promise<CreateGeoscienceAustraliaSurveyDataLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/CreateGeoscienceAustraliaSurveyDataLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaSurveyDataLine(_response);
        });
    }

    protected processCreateGeoscienceAustraliaSurveyDataLine(response: Response): Promise<CreateGeoscienceAustraliaSurveyDataLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaSurveyDataLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaSurveyDataLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importGeoscienceAustraliaSurveyDataLines(body: ImportGeoscienceAustraliaSurveyDataLinesRequestDto | undefined): Promise<ImportGeoscienceAustraliaSurveyDataLinesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/ImportGeoscienceAustraliaSurveyDataLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportGeoscienceAustraliaSurveyDataLines(_response);
        });
    }

    protected processImportGeoscienceAustraliaSurveyDataLines(response: Response): Promise<ImportGeoscienceAustraliaSurveyDataLinesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportGeoscienceAustraliaSurveyDataLinesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportGeoscienceAustraliaSurveyDataLinesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importGeoscienceAustraliaSurveyData(body: ImportGeoscienceAustraliaSurveyDataRequestDto | undefined): Promise<ImportGeoscienceAustraliaSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/ImportGeoscienceAustraliaSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportGeoscienceAustraliaSurveyData(_response);
        });
    }

    protected processImportGeoscienceAustraliaSurveyData(response: Response): Promise<ImportGeoscienceAustraliaSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportGeoscienceAustraliaSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportGeoscienceAustraliaSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveyDataDataAuditChanges(body: GetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveyDataService/GetGeoscienceAustraliaSurveyDataDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveyDataDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveyDataDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaSurveysAcquisitionsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyList(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyList(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyList(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyDetails(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetails(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitions(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitions(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitions(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetails(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetails(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItems(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyParameters(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyParameters(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyParameters(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(body: CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto | undefined): Promise<CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(_response);
        });
    }

    protected processCreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(response: Response): Promise<CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(body: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(body: DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameter(response: Response): Promise<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyReports(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyReports(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsSurveyReports(body: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReports(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachments(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachments(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(body: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyData(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChanges(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(body: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(body: CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto | undefined): Promise<CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(_response);
        });
    }

    protected processCreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(response: Response): Promise<CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(body: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(body: DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto | undefined): Promise<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(_response);
        });
    }

    protected processDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLine(response: Response): Promise<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(body: ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto | undefined): Promise<ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(_response);
        });
    }

    protected processExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLines(response: Response): Promise<ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionList(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionList(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionList(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetails(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetails(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItems(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionParameters(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParameters(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParameters(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(body: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReports(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachments(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachments(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachments(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(body: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(body: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto | undefined): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyData(response: Response): Promise<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetails(body: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaSurveysAcquisitionsService/GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetails(response: Response): Promise<GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaUserManagementServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementGeoscienceAustraliaDetails(body: GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetails(response: Response): Promise<GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoles(body: SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto | undefined): Promise<SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoles(_response);
        });
    }

    protected processSaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoles(response: Response): Promise<SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementUserDetails(body: GetGeoscienceAustraliaUserManagementUserDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementUserDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementUserDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementUserDetails(response: Response): Promise<GetGeoscienceAustraliaUserManagementUserDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementUserDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementUserDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementUserList(body: GetGeoscienceAustraliaUserManagementUserListRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementUserListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementUserList(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementUserList(response: Response): Promise<GetGeoscienceAustraliaUserManagementUserListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementUserListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementUserListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementRequestList(body: GetGeoscienceAustraliaUserManagementRequestListRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementRequestList(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementRequestList(response: Response): Promise<GetGeoscienceAustraliaUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchApproveGeoscienceAustraliaUserManagementRequestList(body: BatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto | undefined): Promise<BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/BatchApproveGeoscienceAustraliaUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchApproveGeoscienceAustraliaUserManagementRequestList(_response);
        });
    }

    protected processBatchApproveGeoscienceAustraliaUserManagementRequestList(response: Response): Promise<BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchRejectGeoscienceAustraliaUserManagementRequestList(body: BatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto | undefined): Promise<BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/BatchRejectGeoscienceAustraliaUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchRejectGeoscienceAustraliaUserManagementRequestList(_response);
        });
    }

    protected processBatchRejectGeoscienceAustraliaUserManagementRequestList(response: Response): Promise<BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementRequestDetailsGar(body: GetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementRequestDetailsGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementRequestDetailsGar(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementRequestDetailsGar(response: Response): Promise<GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveGeoscienceAustraliaUserManagementRequestDetailsGar(body: ApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto | undefined): Promise<ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/ApproveGeoscienceAustraliaUserManagementRequestDetailsGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveGeoscienceAustraliaUserManagementRequestDetailsGar(_response);
        });
    }

    protected processApproveGeoscienceAustraliaUserManagementRequestDetailsGar(response: Response): Promise<ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectGeoscienceAustraliaUserManagementRequestDetailsGar(body: RejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto | undefined): Promise<RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/RejectGeoscienceAustraliaUserManagementRequestDetailsGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectGeoscienceAustraliaUserManagementRequestDetailsGar(_response);
        });
    }

    protected processRejectGeoscienceAustraliaUserManagementRequestDetailsGar(response: Response): Promise<RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaUserManagementRequestDetailsNuGar(body: GetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto | undefined): Promise<GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/GetGeoscienceAustraliaUserManagementRequestDetailsNuGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaUserManagementRequestDetailsNuGar(_response);
        });
    }

    protected processGetGeoscienceAustraliaUserManagementRequestDetailsNuGar(response: Response): Promise<GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveGeoscienceAustraliaUserManagementRequestDetailsNuGar(body: ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto | undefined): Promise<ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveGeoscienceAustraliaUserManagementRequestDetailsNuGar(_response);
        });
    }

    protected processApproveGeoscienceAustraliaUserManagementRequestDetailsNuGar(response: Response): Promise<ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectGeoscienceAustraliaUserManagementRequestDetailsNuGar(body: RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto | undefined): Promise<RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaUserManagementService/RejectGeoscienceAustraliaUserManagementRequestDetailsNuGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectGeoscienceAustraliaUserManagementRequestDetailsNuGar(_response);
        });
    }

    protected processRejectGeoscienceAustraliaUserManagementRequestDetailsNuGar(response: Response): Promise<RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto>(null as any);
    }
}

export class GeoscienceAustraliaWellsBoreholesServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellList(body: GetGeoscienceAustraliaWellsBoreholesWellListRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellList(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellList(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellDetails(body: GetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellDetails(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellBoreholes(body: GetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellBoreholes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellBoreholes(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellBoreholes(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellDataMonitoringItems(body: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellReports(body: GetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellReports(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaWellsBoreholesWellReports(body: UpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/UpdateGeoscienceAustraliaWellsBoreholesWellReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaWellsBoreholesWellReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaWellsBoreholesWellReports(response: Response): Promise<UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesWellDataAuditChanges(body: GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesWellDataAuditChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesWellDataAuditChanges(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesWellDataAuditChanges(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesBoreholeList(body: GetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesBoreholeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesBoreholeList(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesBoreholeList(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesBoreholeDetails(body: GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesBoreholeDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesBoreholeDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesBoreholeDetails(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItems(body: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItems(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItems(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesBoreholeReports(body: GetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesBoreholeReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesBoreholeReports(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesBoreholeReports(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGeoscienceAustraliaWellsBoreholesBoreholeReports(body: UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto | undefined): Promise<UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/UpdateGeoscienceAustraliaWellsBoreholesBoreholeReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeoscienceAustraliaWellsBoreholesBoreholeReports(_response);
        });
    }

    protected processUpdateGeoscienceAustraliaWellsBoreholesBoreholeReports(response: Response): Promise<UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetails(body: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetails(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesRigList(body: GetGeoscienceAustraliaWellsBoreholesRigListRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesRigListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesRigList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesRigList(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesRigList(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesRigListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesRigListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesRigListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesRigDetails(body: GetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesRigDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesRigDetails(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesRigDetails(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeoscienceAustraliaWellsBoreholesRigHistoryList(body: GetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto | undefined): Promise<GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/GeoscienceAustraliaWellsBoreholesService/GetGeoscienceAustraliaWellsBoreholesRigHistoryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGeoscienceAustraliaWellsBoreholesRigHistoryList(_response);
        });
    }

    protected processGetGeoscienceAustraliaWellsBoreholesRigHistoryList(response: Response): Promise<GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto>(null as any);
    }
}

export class JointAuthorityAccountServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityAccountRequestAccessReferenceData(body: GetJointAuthorityAccountRequestAccessReferenceDataRequestDto | undefined): Promise<GetJointAuthorityAccountRequestAccessReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityAccountService/GetJointAuthorityAccountRequestAccessReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityAccountRequestAccessReferenceData(_response);
        });
    }

    protected processGetJointAuthorityAccountRequestAccessReferenceData(response: Response): Promise<GetJointAuthorityAccountRequestAccessReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityAccountRequestAccessReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityAccountRequestAccessReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createJointAuthorityAccountRequestAccessJar(body: CreateJointAuthorityAccountRequestAccessJarRequestDto | undefined): Promise<CreateJointAuthorityAccountRequestAccessJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityAccountService/CreateJointAuthorityAccountRequestAccessJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateJointAuthorityAccountRequestAccessJar(_response);
        });
    }

    protected processCreateJointAuthorityAccountRequestAccessJar(response: Response): Promise<CreateJointAuthorityAccountRequestAccessJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJointAuthorityAccountRequestAccessJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateJointAuthorityAccountRequestAccessJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createJointAuthorityAccountRequestAccessJaa(body: CreateJointAuthorityAccountRequestAccessJaaRequestDto | undefined): Promise<CreateJointAuthorityAccountRequestAccessJaaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityAccountService/CreateJointAuthorityAccountRequestAccessJaa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateJointAuthorityAccountRequestAccessJaa(_response);
        });
    }

    protected processCreateJointAuthorityAccountRequestAccessJaa(response: Response): Promise<CreateJointAuthorityAccountRequestAccessJaaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJointAuthorityAccountRequestAccessJaaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateJointAuthorityAccountRequestAccessJaaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityAccountMyDetails(body: GetJointAuthorityAccountMyDetailsRequestDto | undefined): Promise<GetJointAuthorityAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityAccountService/GetJointAuthorityAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityAccountMyDetails(_response);
        });
    }

    protected processGetJointAuthorityAccountMyDetails(response: Response): Promise<GetJointAuthorityAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityAccountMyDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveJointAuthorityAccountMyDetails(body: SaveJointAuthorityAccountMyDetailsRequestDto | undefined): Promise<SaveJointAuthorityAccountMyDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityAccountService/SaveJointAuthorityAccountMyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveJointAuthorityAccountMyDetails(_response);
        });
    }

    protected processSaveJointAuthorityAccountMyDetails(response: Response): Promise<SaveJointAuthorityAccountMyDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveJointAuthorityAccountMyDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveJointAuthorityAccountMyDetailsResponseDto>(null as any);
    }
}

export class JointAuthorityHomeDashboardServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityHomeDashboard(body: GetJointAuthorityHomeDashboardRequestDto | undefined): Promise<GetJointAuthorityHomeDashboardResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityHomeDashboardService/GetJointAuthorityHomeDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityHomeDashboard(_response);
        });
    }

    protected processGetJointAuthorityHomeDashboard(response: Response): Promise<GetJointAuthorityHomeDashboardResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityHomeDashboardResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityHomeDashboardResponseDto>(null as any);
    }
}

export class JointAuthorityOeiLicenceDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOeiLicenceDetails(body: GetJointAuthorityOeiLicenceDetailsRequestDto | undefined): Promise<GetJointAuthorityOeiLicenceDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOeiLicenceDetailsService/GetJointAuthorityOeiLicenceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOeiLicenceDetails(_response);
        });
    }

    protected processGetJointAuthorityOeiLicenceDetails(response: Response): Promise<GetJointAuthorityOeiLicenceDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOeiLicenceDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOeiLicenceDetailsResponseDto>(null as any);
    }
}

export class JointAuthorityOeiLicenceListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOeiLicenceList(body: GetJointAuthorityOeiLicenceListRequestDto | undefined): Promise<GetJointAuthorityOeiLicenceListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOeiLicenceListService/GetJointAuthorityOeiLicenceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOeiLicenceList(_response);
        });
    }

    protected processGetJointAuthorityOeiLicenceList(response: Response): Promise<GetJointAuthorityOeiLicenceListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOeiLicenceListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOeiLicenceListResponseDto>(null as any);
    }
}

export class JointAuthorityOpggsApplicationDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsLayoutAndHeader(body: GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsLayoutAndHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsLayoutAndHeader(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsLayoutAndHeader(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsApplicationDetails(body: GetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsApplicationDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsApplicationDetails(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsApplicationDetails(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsTitleholders(body: GetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsTitleholders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsTitleholders(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsTitleholders(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsBlockDetails(body: GetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsBlockDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsBlockDetails(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsBlockDetails(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsWorkProgram(body: GetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsWorkProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsWorkProgram(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsWorkProgram(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsApprovalTracking(body: GetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsApprovalTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsApprovalTracking(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsApprovalTracking(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationDetailsDocumentation(body: GetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationDetailsService/GetJointAuthorityOpggsApplicationDetailsDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationDetailsDocumentation(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationDetailsDocumentation(response: Response): Promise<GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto>(null as any);
    }
}

export class JointAuthorityOpggsApplicationListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsApplicationList(body: GetJointAuthorityOpggsApplicationListRequestDto | undefined): Promise<GetJointAuthorityOpggsApplicationListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsApplicationListService/GetJointAuthorityOpggsApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsApplicationList(_response);
        });
    }

    protected processGetJointAuthorityOpggsApplicationList(response: Response): Promise<GetJointAuthorityOpggsApplicationListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsApplicationListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsApplicationListResponseDto>(null as any);
    }
}

export class JointAuthorityOpggsTitleListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityOpggsTitleList(body: GetJointAuthorityOpggsTitleListRequestDto | undefined): Promise<GetJointAuthorityOpggsTitleListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityOpggsTitleListService/GetJointAuthorityOpggsTitleList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityOpggsTitleList(_response);
        });
    }

    protected processGetJointAuthorityOpggsTitleList(response: Response): Promise<GetJointAuthorityOpggsTitleListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityOpggsTitleListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityOpggsTitleListResponseDto>(null as any);
    }
}

export class JointAuthorityUserManagementServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementJointAuthorityDetails(body: GetJointAuthorityUserManagementJointAuthorityDetailsRequestDto | undefined): Promise<GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementJointAuthorityDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementJointAuthorityDetails(_response);
        });
    }

    protected processGetJointAuthorityUserManagementJointAuthorityDetails(response: Response): Promise<GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveJointAuthorityUserManagementJointAuthorityDetailsRoles(body: SaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto | undefined): Promise<SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/SaveJointAuthorityUserManagementJointAuthorityDetailsRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveJointAuthorityUserManagementJointAuthorityDetailsRoles(_response);
        });
    }

    protected processSaveJointAuthorityUserManagementJointAuthorityDetailsRoles(response: Response): Promise<SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementUserDetails(body: GetJointAuthorityUserManagementUserDetailsRequestDto | undefined): Promise<GetJointAuthorityUserManagementUserDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementUserDetails(_response);
        });
    }

    protected processGetJointAuthorityUserManagementUserDetails(response: Response): Promise<GetJointAuthorityUserManagementUserDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementUserDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementUserDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementUserList(body: GetJointAuthorityUserManagementUserListRequestDto | undefined): Promise<GetJointAuthorityUserManagementUserListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementUserList(_response);
        });
    }

    protected processGetJointAuthorityUserManagementUserList(response: Response): Promise<GetJointAuthorityUserManagementUserListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementUserListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementUserListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementRequestList(body: GetJointAuthorityUserManagementRequestListRequestDto | undefined): Promise<GetJointAuthorityUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementRequestList(_response);
        });
    }

    protected processGetJointAuthorityUserManagementRequestList(response: Response): Promise<GetJointAuthorityUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchApproveJointAuthorityUserManagementRequestList(body: BatchApproveJointAuthorityUserManagementRequestListRequestDto | undefined): Promise<BatchApproveJointAuthorityUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/BatchApproveJointAuthorityUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchApproveJointAuthorityUserManagementRequestList(_response);
        });
    }

    protected processBatchApproveJointAuthorityUserManagementRequestList(response: Response): Promise<BatchApproveJointAuthorityUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchApproveJointAuthorityUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchApproveJointAuthorityUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchRejectJointAuthorityUserManagementRequestList(body: BatchRejectJointAuthorityUserManagementRequestListRequestDto | undefined): Promise<BatchRejectJointAuthorityUserManagementRequestListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/BatchRejectJointAuthorityUserManagementRequestList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchRejectJointAuthorityUserManagementRequestList(_response);
        });
    }

    protected processBatchRejectJointAuthorityUserManagementRequestList(response: Response): Promise<BatchRejectJointAuthorityUserManagementRequestListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchRejectJointAuthorityUserManagementRequestListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchRejectJointAuthorityUserManagementRequestListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementRequestDetailsJar(body: GetJointAuthorityUserManagementRequestDetailsJarRequestDto | undefined): Promise<GetJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementRequestDetailsJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementRequestDetailsJar(_response);
        });
    }

    protected processGetJointAuthorityUserManagementRequestDetailsJar(response: Response): Promise<GetJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementRequestDetailsJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementRequestDetailsJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveJointAuthorityUserManagementRequestDetailsJar(body: ApproveJointAuthorityUserManagementRequestDetailsJarRequestDto | undefined): Promise<ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/ApproveJointAuthorityUserManagementRequestDetailsJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveJointAuthorityUserManagementRequestDetailsJar(_response);
        });
    }

    protected processApproveJointAuthorityUserManagementRequestDetailsJar(response: Response): Promise<ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectJointAuthorityUserManagementRequestDetailsJar(body: RejectJointAuthorityUserManagementRequestDetailsJarRequestDto | undefined): Promise<RejectJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/RejectJointAuthorityUserManagementRequestDetailsJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectJointAuthorityUserManagementRequestDetailsJar(_response);
        });
    }

    protected processRejectJointAuthorityUserManagementRequestDetailsJar(response: Response): Promise<RejectJointAuthorityUserManagementRequestDetailsJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectJointAuthorityUserManagementRequestDetailsJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectJointAuthorityUserManagementRequestDetailsJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getJointAuthorityUserManagementRequestDetailsNuJar(body: GetJointAuthorityUserManagementRequestDetailsNuJarRequestDto | undefined): Promise<GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/GetJointAuthorityUserManagementRequestDetailsNuJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJointAuthorityUserManagementRequestDetailsNuJar(_response);
        });
    }

    protected processGetJointAuthorityUserManagementRequestDetailsNuJar(response: Response): Promise<GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveJointAuthorityUserManagementRequestDetailsNuJar(body: ApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto | undefined): Promise<ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/ApproveJointAuthorityUserManagementRequestDetailsNuJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveJointAuthorityUserManagementRequestDetailsNuJar(_response);
        });
    }

    protected processApproveJointAuthorityUserManagementRequestDetailsNuJar(response: Response): Promise<ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectJointAuthorityUserManagementRequestDetailsNuJar(body: RejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto | undefined): Promise<RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/JointAuthorityUserManagementService/RejectJointAuthorityUserManagementRequestDetailsNuJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectJointAuthorityUserManagementRequestDetailsNuJar(_response);
        });
    }

    protected processRejectJointAuthorityUserManagementRequestDetailsNuJar(response: Response): Promise<RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto>(null as any);
    }
}

export class PublicCoreCuttingsRequestServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCreatePublicCoreCuttingsRequestReferenceData(body: GetCreatePublicCoreCuttingsRequestReferenceDataRequestDto | undefined): Promise<GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicCoreCuttingsRequestService/GetCreatePublicCoreCuttingsRequestReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreatePublicCoreCuttingsRequestReferenceData(_response);
        });
    }

    protected processGetCreatePublicCoreCuttingsRequestReferenceData(response: Response): Promise<GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPublicCoreCuttingsRequest(body: CreatePublicCoreCuttingsRequestRequestDto | undefined): Promise<CreatePublicCoreCuttingsRequestResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicCoreCuttingsRequestService/CreatePublicCoreCuttingsRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePublicCoreCuttingsRequest(_response);
        });
    }

    protected processCreatePublicCoreCuttingsRequest(response: Response): Promise<CreatePublicCoreCuttingsRequestResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePublicCoreCuttingsRequestResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePublicCoreCuttingsRequestResponseDto>(null as any);
    }
}

export class PublicFeedbackServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCreatePublicFeedbackReferenceData(body: GetCreatePublicFeedbackReferenceDataRequestDto | undefined): Promise<GetCreatePublicFeedbackReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicFeedbackService/GetCreatePublicFeedbackReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreatePublicFeedbackReferenceData(_response);
        });
    }

    protected processGetCreatePublicFeedbackReferenceData(response: Response): Promise<GetCreatePublicFeedbackReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreatePublicFeedbackReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreatePublicFeedbackReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPublicFeedback(body: CreatePublicFeedbackRequestDto | undefined): Promise<CreatePublicFeedbackResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicFeedbackService/CreatePublicFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePublicFeedback(_response);
        });
    }

    protected processCreatePublicFeedback(response: Response): Promise<CreatePublicFeedbackResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePublicFeedbackResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePublicFeedbackResponseDto>(null as any);
    }
}

export class PublicNopimsBasketServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    savePublicNopimsBasket(body: SavePublicNopimsBasketRequestDto | undefined): Promise<SavePublicNopimsBasketResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicNopimsBasketService/SavePublicNopimsBasket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSavePublicNopimsBasket(_response);
        });
    }

    protected processSavePublicNopimsBasket(response: Response): Promise<SavePublicNopimsBasketResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePublicNopimsBasketResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePublicNopimsBasketResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicNopimsBasket(body: GetPublicNopimsBasketRequestDto | undefined): Promise<GetPublicNopimsBasketResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicNopimsBasketService/GetPublicNopimsBasket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicNopimsBasket(_response);
        });
    }

    protected processGetPublicNopimsBasket(response: Response): Promise<GetPublicNopimsBasketResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicNopimsBasketResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicNopimsBasketResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportPublicNopimsBasket(body: ExportPublicNopimsBasketRequestDto | undefined): Promise<ExportPublicNopimsBasketResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicNopimsBasketService/ExportPublicNopimsBasket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPublicNopimsBasket(_response);
        });
    }

    protected processExportPublicNopimsBasket(response: Response): Promise<ExportPublicNopimsBasketResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportPublicNopimsBasketResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportPublicNopimsBasketResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSubmitPublicNopimsBasketReferenceData(body: GetSubmitPublicNopimsBasketReferenceDataRequestDto | undefined): Promise<GetSubmitPublicNopimsBasketReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicNopimsBasketService/GetSubmitPublicNopimsBasketReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmitPublicNopimsBasketReferenceData(_response);
        });
    }

    protected processGetSubmitPublicNopimsBasketReferenceData(response: Response): Promise<GetSubmitPublicNopimsBasketReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubmitPublicNopimsBasketReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSubmitPublicNopimsBasketReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPublicNopimsBasket(body: SubmitPublicNopimsBasketRequestDto | undefined): Promise<SubmitPublicNopimsBasketResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicNopimsBasketService/SubmitPublicNopimsBasket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitPublicNopimsBasket(_response);
        });
    }

    protected processSubmitPublicNopimsBasket(response: Response): Promise<SubmitPublicNopimsBasketResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitPublicNopimsBasketResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitPublicNopimsBasketResponseDto>(null as any);
    }
}

export class PublicOeiApplicationsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOeiApplicationsTracking(body: GetPublicOeiApplicationsTrackingRequestDto | undefined): Promise<GetPublicOeiApplicationsTrackingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOeiApplicationsService/GetPublicOeiApplicationsTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOeiApplicationsTracking(_response);
        });
    }

    protected processGetPublicOeiApplicationsTracking(response: Response): Promise<GetPublicOeiApplicationsTrackingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOeiApplicationsTrackingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOeiApplicationsTrackingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOeiApplicationsTrackingDetails(body: GetPublicOeiApplicationsTrackingDetailsRequestDto | undefined): Promise<GetPublicOeiApplicationsTrackingDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOeiApplicationsService/GetPublicOeiApplicationsTrackingDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOeiApplicationsTrackingDetails(_response);
        });
    }

    protected processGetPublicOeiApplicationsTrackingDetails(response: Response): Promise<GetPublicOeiApplicationsTrackingDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOeiApplicationsTrackingDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOeiApplicationsTrackingDetailsResponseDto>(null as any);
    }
}

export class PublicOeiLicenceDetailsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicLicenceDetails(body: GetPublicLicenceDetailsRequestDto | undefined): Promise<GetPublicLicenceDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOeiLicenceDetailsService/GetPublicLicenceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicLicenceDetails(_response);
        });
    }

    protected processGetPublicLicenceDetails(response: Response): Promise<GetPublicLicenceDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicLicenceDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicLicenceDetailsResponseDto>(null as any);
    }
}

export class PublicOeiLicenceOpenServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOpenLicenceId(body: GetPublicOpenLicenceIdRequestDto | undefined): Promise<GetPublicOpenLicenceIdResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOeiLicenceOpenService/GetPublicOpenLicenceId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOpenLicenceId(_response);
        });
    }

    protected processGetPublicOpenLicenceId(response: Response): Promise<GetPublicOpenLicenceIdResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOpenLicenceIdResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOpenLicenceIdResponseDto>(null as any);
    }
}

export class PublicOeiLicencesSearchServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicLicencesList(body: GetPublicLicencesListRequestDto | undefined): Promise<GetPublicLicencesListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOeiLicencesSearchService/GetPublicLicencesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicLicencesList(_response);
        });
    }

    protected processGetPublicLicencesList(response: Response): Promise<GetPublicLicencesListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicLicencesListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicLicencesListResponseDto>(null as any);
    }
}

export class PublicOpggsApplicationsServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOpggsApplicationsTracking(body: GetPublicOpggsApplicationsTrackingRequestDto | undefined): Promise<GetPublicOpggsApplicationsTrackingResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsApplicationsService/GetPublicOpggsApplicationsTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOpggsApplicationsTracking(_response);
        });
    }

    protected processGetPublicOpggsApplicationsTracking(response: Response): Promise<GetPublicOpggsApplicationsTrackingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOpggsApplicationsTrackingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOpggsApplicationsTrackingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOpggsApplicationsTrackingDetails(body: GetPublicOpggsApplicationsTrackingDetailsRequestDto | undefined): Promise<GetPublicOpggsApplicationsTrackingDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsApplicationsService/GetPublicOpggsApplicationsTrackingDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOpggsApplicationsTrackingDetails(_response);
        });
    }

    protected processGetPublicOpggsApplicationsTrackingDetails(response: Response): Promise<GetPublicOpggsApplicationsTrackingDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOpggsApplicationsTrackingDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOpggsApplicationsTrackingDetailsResponseDto>(null as any);
    }
}

export class PublicOpggsStorageFormationsListServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicStorageFormationsList(body: GetPublicStorageFormationsListRequestDto | undefined): Promise<GetPublicStorageFormationsListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsStorageFormationsListService/GetPublicStorageFormationsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicStorageFormationsList(_response);
        });
    }

    protected processGetPublicStorageFormationsList(response: Response): Promise<GetPublicStorageFormationsListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicStorageFormationsListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicStorageFormationsListResponseDto>(null as any);
    }
}

export class PublicOpggsTitlesServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicTitlesList(body: GetPublicTitlesListRequestDto | undefined): Promise<GetPublicTitlesListResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsTitlesService/GetPublicTitlesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicTitlesList(_response);
        });
    }

    protected processGetPublicTitlesList(response: Response): Promise<GetPublicTitlesListResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicTitlesListResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicTitlesListResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicTitleDetails(body: GetPublicTitleDetailsRequestDto | undefined): Promise<GetPublicTitleDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsTitlesService/GetPublicTitleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicTitleDetails(_response);
        });
    }

    protected processGetPublicTitleDetails(response: Response): Promise<GetPublicTitleDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicTitleDetailsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicTitleDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicTitleDetailsMap(body: GetPublicTitleDetailsMapRequestDto | undefined): Promise<GetPublicTitleDetailsMapResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsTitlesService/GetPublicTitleDetailsMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicTitleDetailsMap(_response);
        });
    }

    protected processGetPublicTitleDetailsMap(response: Response): Promise<GetPublicTitleDetailsMapResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicTitleDetailsMapResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicTitleDetailsMapResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicOpenTitleId(body: GetPublicOpenTitleIdRequestDto | undefined): Promise<GetPublicOpenTitleIdResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicOpggsTitlesService/GetPublicOpenTitleId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicOpenTitleId(_response);
        });
    }

    protected processGetPublicOpenTitleId(response: Response): Promise<GetPublicOpenTitleIdResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicOpenTitleIdResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicOpenTitleIdResponseDto>(null as any);
    }
}

export class PublicShellServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicShellFeatureSwitches(body: GetPublicShellFeatureSwitchesRequestDto | undefined): Promise<GetPublicShellFeatureSwitchesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicShellService/GetPublicShellFeatureSwitches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicShellFeatureSwitches(_response);
        });
    }

    protected processGetPublicShellFeatureSwitches(response: Response): Promise<GetPublicShellFeatureSwitchesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicShellFeatureSwitchesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicShellFeatureSwitchesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPublicShellPortalLinks(body: GetPublicShellPortalLinksRequestDto | undefined): Promise<GetPublicShellPortalLinksResponseDto> {
        let url_ = this.baseUrl + "/api/v1/PublicShellService/GetPublicShellPortalLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicShellPortalLinks(_response);
        });
    }

    protected processGetPublicShellPortalLinks(response: Response): Promise<GetPublicShellPortalLinksResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicShellPortalLinksResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicShellPortalLinksResponseDto>(null as any);
    }
}

export class RegistrationAnonymousRequestServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRegistrationCompanyReferenceData(body: GetRegistrationCompanyReferenceDataRequestDto | undefined): Promise<GetRegistrationCompanyReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/GetRegistrationCompanyReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationCompanyReferenceData(_response);
        });
    }

    protected processGetRegistrationCompanyReferenceData(response: Response): Promise<GetRegistrationCompanyReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegistrationCompanyReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRegistrationCompanyReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationCompanyNuCa(body: CreateRegistrationCompanyNuCaRequestDto | undefined): Promise<CreateRegistrationCompanyNuCaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationCompanyNuCa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationCompanyNuCa(_response);
        });
    }

    protected processCreateRegistrationCompanyNuCa(response: Response): Promise<CreateRegistrationCompanyNuCaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationCompanyNuCaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationCompanyNuCaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationCompanyNuCr(body: CreateRegistrationCompanyNuCrRequestDto | undefined): Promise<CreateRegistrationCompanyNuCrResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationCompanyNuCr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationCompanyNuCr(_response);
        });
    }

    protected processCreateRegistrationCompanyNuCr(response: Response): Promise<CreateRegistrationCompanyNuCrResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationCompanyNuCrResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationCompanyNuCrResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationCompanyNuNcCa(body: CreateRegistrationCompanyNuNcCaRequestDto | undefined): Promise<CreateRegistrationCompanyNuNcCaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationCompanyNuNcCa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationCompanyNuNcCa(_response);
        });
    }

    protected processCreateRegistrationCompanyNuNcCa(response: Response): Promise<CreateRegistrationCompanyNuNcCaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationCompanyNuNcCaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationCompanyNuNcCaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationCompanyNuCrCs(body: CreateRegistrationCompanyNuCrCsRequestDto | undefined): Promise<CreateRegistrationCompanyNuCrCsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationCompanyNuCrCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationCompanyNuCrCs(_response);
        });
    }

    protected processCreateRegistrationCompanyNuCrCs(response: Response): Promise<CreateRegistrationCompanyNuCrCsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationCompanyNuCrCsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationCompanyNuCrCsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRegistrationJointAuthorityReferenceData(body: GetRegistrationJointAuthorityReferenceDataRequestDto | undefined): Promise<GetRegistrationJointAuthorityReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/GetRegistrationJointAuthorityReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationJointAuthorityReferenceData(_response);
        });
    }

    protected processGetRegistrationJointAuthorityReferenceData(response: Response): Promise<GetRegistrationJointAuthorityReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegistrationJointAuthorityReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRegistrationJointAuthorityReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationJointAuthorityNuJar(body: CreateRegistrationJointAuthorityNuJarRequestDto | undefined): Promise<CreateRegistrationJointAuthorityNuJarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationJointAuthorityNuJar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationJointAuthorityNuJar(_response);
        });
    }

    protected processCreateRegistrationJointAuthorityNuJar(response: Response): Promise<CreateRegistrationJointAuthorityNuJarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationJointAuthorityNuJarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationJointAuthorityNuJarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationJointAuthorityNuJaa(body: CreateRegistrationJointAuthorityNuJaaRequestDto | undefined): Promise<CreateRegistrationJointAuthorityNuJaaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationJointAuthorityNuJaa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationJointAuthorityNuJaa(_response);
        });
    }

    protected processCreateRegistrationJointAuthorityNuJaa(response: Response): Promise<CreateRegistrationJointAuthorityNuJaaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationJointAuthorityNuJaaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationJointAuthorityNuJaaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRegistrationGeoscienceAustraliaReferenceData(body: GetRegistrationGeoscienceAustraliaReferenceDataRequestDto | undefined): Promise<GetRegistrationGeoscienceAustraliaReferenceDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/GetRegistrationGeoscienceAustraliaReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationGeoscienceAustraliaReferenceData(_response);
        });
    }

    protected processGetRegistrationGeoscienceAustraliaReferenceData(response: Response): Promise<GetRegistrationGeoscienceAustraliaReferenceDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegistrationGeoscienceAustraliaReferenceDataResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRegistrationGeoscienceAustraliaReferenceDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationGeoscienceAustraliaNuGar(body: CreateRegistrationGeoscienceAustraliaNuGarRequestDto | undefined): Promise<CreateRegistrationGeoscienceAustraliaNuGarResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationGeoscienceAustraliaNuGar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationGeoscienceAustraliaNuGar(_response);
        });
    }

    protected processCreateRegistrationGeoscienceAustraliaNuGar(response: Response): Promise<CreateRegistrationGeoscienceAustraliaNuGarResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationGeoscienceAustraliaNuGarResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationGeoscienceAustraliaNuGarResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRegistrationGeoscienceAustraliaNuGaa(body: CreateRegistrationGeoscienceAustraliaNuGaaRequestDto | undefined): Promise<CreateRegistrationGeoscienceAustraliaNuGaaResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/CreateRegistrationGeoscienceAustraliaNuGaa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistrationGeoscienceAustraliaNuGaa(_response);
        });
    }

    protected processCreateRegistrationGeoscienceAustraliaNuGaa(response: Response): Promise<CreateRegistrationGeoscienceAustraliaNuGaaResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegistrationGeoscienceAustraliaNuGaaResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRegistrationGeoscienceAustraliaNuGaaResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestRegistrationEmailVerification(body: RequestRegistrationEmailVerificationRequestDto | undefined): Promise<RequestRegistrationEmailVerificationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/RequestRegistrationEmailVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestRegistrationEmailVerification(_response);
        });
    }

    protected processRequestRegistrationEmailVerification(response: Response): Promise<RequestRegistrationEmailVerificationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestRegistrationEmailVerificationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestRegistrationEmailVerificationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyRegistrationEmailVerificationCode(body: VerifyRegistrationEmailVerificationCodeRequestDto | undefined): Promise<VerifyRegistrationEmailVerificationCodeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/RegistrationAnonymousRequestService/VerifyRegistrationEmailVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyRegistrationEmailVerificationCode(_response);
        });
    }

    protected processVerifyRegistrationEmailVerificationCode(response: Response): Promise<VerifyRegistrationEmailVerificationCodeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyRegistrationEmailVerificationCodeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyRegistrationEmailVerificationCodeResponseDto>(null as any);
    }
}

export class ScheduledJobServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSummary(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ScheduledJobService/GetSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param scheduledFromHours (optional) 
     * @return OK
     */
    getQueue(name: string | undefined, scheduledFromHours: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ScheduledJobService/GetQueue?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (scheduledFromHours === null)
            throw new Error("The parameter 'scheduledFromHours' cannot be null.");
        else if (scheduledFromHours !== undefined)
            url_ += "scheduledFromHours=" + encodeURIComponent("" + scheduledFromHours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQueue(_response);
        });
    }

    protected processGetQueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    enqueue(name: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ScheduledJobService/Enqueue?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnqueue(_response);
        });
    }

    protected processEnqueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ShellAnonymousServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellPortalLinks(body: GetShellPortalLinksRequestDto | undefined): Promise<GetShellPortalLinksResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellAnonymousService/GetShellPortalLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellPortalLinks(_response);
        });
    }

    protected processGetShellPortalLinks(response: Response): Promise<GetShellPortalLinksResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellPortalLinksResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellPortalLinksResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellSecureUserRoleConfiguration(body: GetShellSecureUserRoleConfigurationRequestDto | undefined): Promise<GetShellSecureUserRoleConfigurationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellAnonymousService/GetShellSecureUserRoleConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellSecureUserRoleConfiguration(_response);
        });
    }

    protected processGetShellSecureUserRoleConfiguration(response: Response): Promise<GetShellSecureUserRoleConfigurationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellSecureUserRoleConfigurationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellSecureUserRoleConfigurationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellFeatureSwitches(body: GetShellFeatureSwitchesRequestDto | undefined): Promise<GetShellFeatureSwitchesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellAnonymousService/GetShellFeatureSwitches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellFeatureSwitches(_response);
        });
    }

    protected processGetShellFeatureSwitches(response: Response): Promise<GetShellFeatureSwitchesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellFeatureSwitchesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellFeatureSwitchesResponseDto>(null as any);
    }
}

export class ShellServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signIn(body: SignInRequestDto | undefined): Promise<SignInResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellService/SignIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: Response): Promise<SignInResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignInResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellLhsNavigation(body: GetShellLhsNavigationRequestDto | undefined): Promise<GetShellLhsNavigationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellService/GetShellLhsNavigation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellLhsNavigation(_response);
        });
    }

    protected processGetShellLhsNavigation(response: Response): Promise<GetShellLhsNavigationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellLhsNavigationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellLhsNavigationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellBamboraConfiguration(body: GetShellBamboraConfigurationRequestDto | undefined): Promise<GetShellBamboraConfigurationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellService/GetShellBamboraConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellBamboraConfiguration(_response);
        });
    }

    protected processGetShellBamboraConfiguration(response: Response): Promise<GetShellBamboraConfigurationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellBamboraConfigurationResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellBamboraConfigurationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellTitleBadges(body: GetShellTitleBadgesRequestDto | undefined): Promise<GetShellTitleBadgesResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellService/GetShellTitleBadges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellTitleBadges(_response);
        });
    }

    protected processGetShellTitleBadges(response: Response): Promise<GetShellTitleBadgesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellTitleBadgesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellTitleBadgesResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getShellOpenLink(body: GetShellOpenLinkRequestDto | undefined): Promise<GetShellOpenLinkResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ShellService/GetShellOpenLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetShellOpenLink(_response);
        });
    }

    protected processGetShellOpenLink(response: Response): Promise<GetShellOpenLinkResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShellOpenLinkResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShellOpenLinkResponseDto>(null as any);
    }
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto {
    id: number;
    name: string;
}

export class StatusMessagesDto implements IStatusMessagesDto {
    isSuccess!: boolean;
    success!: string[];
    information!: string[];
    warning!: string[];
    error!: string[];

    constructor(data?: IStatusMessagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.success = [];
            this.information = [];
            this.warning = [];
            this.error = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["information"])) {
                this.information = [] as any;
                for (let item of _data["information"])
                    this.information!.push(item);
            }
            if (Array.isArray(_data["warning"])) {
                this.warning = [] as any;
                for (let item of _data["warning"])
                    this.warning!.push(item);
            }
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusMessagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusMessagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.information)) {
            data["information"] = [];
            for (let item of this.information)
                data["information"].push(item);
        }
        if (Array.isArray(this.warning)) {
            data["warning"] = [];
            for (let item of this.warning)
                data["warning"].push(item);
        }
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item);
        }
        return data;
    }
}

export interface IStatusMessagesDto {
    isSuccess: boolean;
    success: string[];
    information: string[];
    warning: string[];
    error: string[];
}

export class GetPublicApplicationsTrackingDetailsApprovalTrackingDto implements IGetPublicApplicationsTrackingDetailsApprovalTrackingDto {
    applicationStatus!: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    displayOrder!: number;
    weekdaysAtStatus!: number;

    constructor(data?: IGetPublicApplicationsTrackingDetailsApprovalTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusName = _data["applicationStatusName"];
            this.displayOrder = _data["displayOrder"];
            this.weekdaysAtStatus = _data["weekdaysAtStatus"];
        }
    }

    static fromJS(data: any): GetPublicApplicationsTrackingDetailsApprovalTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicApplicationsTrackingDetailsApprovalTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusName"] = this.applicationStatusName;
        data["displayOrder"] = this.displayOrder;
        data["weekdaysAtStatus"] = this.weekdaysAtStatus;
        return data;
    }
}

export interface IGetPublicApplicationsTrackingDetailsApprovalTrackingDto {
    applicationStatus: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    displayOrder: number;
    weekdaysAtStatus: number;
}

export enum OeiApplicationTrackingTypeEnum {
    InitialApplicationFeasibilityLicence = "InitialApplicationFeasibilityLicence",
    Transfer = "Transfer",
}

export enum OpggsApplicationTrackingTypeEnum {
    AcreageReleasePetroleum = "AcreageReleasePetroleum",
    DeclarationOfLocation = "DeclarationOfLocation",
    ExplorationPermit = "ExplorationPermit",
    RetentionLease = "RetentionLease",
    ProductionLicence = "ProductionLicence",
    PipelineLicence = "PipelineLicence",
    InfrastructureLicence = "InfrastructureLicence",
    SpecialProspectingAuthority = "SpecialProspectingAuthority",
    AccessAuthority = "AccessAuthority",
    TransfersAndDealings = "TransfersAndDealings",
    ChangeOfCompanyName = "ChangeOfCompanyName",
    AssessmentPermit = "AssessmentPermit",
    AcreageReleaseGhg = "AcreageReleaseGhg",
    ChangeInControl = "ChangeInControl",
    DoISF = "DoISF",
}

export class ExportPublicNopimsBasketRequestDto implements IExportPublicNopimsBasketRequestDto {
    userToken!: string;

    constructor(data?: IExportPublicNopimsBasketRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
        }
    }

    static fromJS(data: any): ExportPublicNopimsBasketRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPublicNopimsBasketRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        return data;
    }
}

export interface IExportPublicNopimsBasketRequestDto {
    userToken: string;
}

export class ExportPublicNopimsBasketResponseDto implements IExportPublicNopimsBasketResponseDto {
    fileName!: string;
    mimeType!: string;
    content!: string;

    constructor(data?: IExportPublicNopimsBasketResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ExportPublicNopimsBasketResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPublicNopimsBasketResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        return data;
    }
}

export interface IExportPublicNopimsBasketResponseDto {
    fileName: string;
    mimeType: string;
    content: string;
}

export class GetPublicNopimsBasketItemResponseDto implements IGetPublicNopimsBasketItemResponseDto {
    dataDescription!: string;
    infoUrl?: string | undefined;
    downloadName?: string | undefined;
    downloadUrl?: string | undefined;
    fileSizeBytes?: number | undefined;
    reportId?: number | undefined;
    surveyDataId?: number | undefined;
    wellBoreholeId?: number | undefined;
    surveyAcquisitionId?: number | undefined;
    reprocessingProjectId?: number | undefined;
    documentType!: string;
    type!: string;
    itemId!: string;
    activity!: string;
    activityIdentifier!: string;
    activityName!: string;

    constructor(data?: IGetPublicNopimsBasketItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataDescription = _data["dataDescription"];
            this.infoUrl = _data["infoUrl"];
            this.downloadName = _data["downloadName"];
            this.downloadUrl = _data["downloadUrl"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.reportId = _data["reportId"];
            this.surveyDataId = _data["surveyDataId"];
            this.wellBoreholeId = _data["wellBoreholeId"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.reprocessingProjectId = _data["reprocessingProjectId"];
            this.documentType = _data["documentType"];
            this.type = _data["type"];
            this.itemId = _data["itemId"];
            this.activity = _data["activity"];
            this.activityIdentifier = _data["activityIdentifier"];
            this.activityName = _data["activityName"];
        }
    }

    static fromJS(data: any): GetPublicNopimsBasketItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicNopimsBasketItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataDescription"] = this.dataDescription;
        data["infoUrl"] = this.infoUrl;
        data["downloadName"] = this.downloadName;
        data["downloadUrl"] = this.downloadUrl;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["reportId"] = this.reportId;
        data["surveyDataId"] = this.surveyDataId;
        data["wellBoreholeId"] = this.wellBoreholeId;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["reprocessingProjectId"] = this.reprocessingProjectId;
        data["documentType"] = this.documentType;
        data["type"] = this.type;
        data["itemId"] = this.itemId;
        data["activity"] = this.activity;
        data["activityIdentifier"] = this.activityIdentifier;
        data["activityName"] = this.activityName;
        return data;
    }
}

export interface IGetPublicNopimsBasketItemResponseDto {
    dataDescription: string;
    infoUrl?: string | undefined;
    downloadName?: string | undefined;
    downloadUrl?: string | undefined;
    fileSizeBytes?: number | undefined;
    reportId?: number | undefined;
    surveyDataId?: number | undefined;
    wellBoreholeId?: number | undefined;
    surveyAcquisitionId?: number | undefined;
    reprocessingProjectId?: number | undefined;
    documentType: string;
    type: string;
    itemId: string;
    activity: string;
    activityIdentifier: string;
    activityName: string;
}

export class GetPublicNopimsBasketRequestDto implements IGetPublicNopimsBasketRequestDto {
    userToken!: string;

    constructor(data?: IGetPublicNopimsBasketRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
        }
    }

    static fromJS(data: any): GetPublicNopimsBasketRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicNopimsBasketRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        return data;
    }
}

export interface IGetPublicNopimsBasketRequestDto {
    userToken: string;
}

export class GetPublicNopimsBasketResponseDto implements IGetPublicNopimsBasketResponseDto {
    items!: GetPublicNopimsBasketItemResponseDto[];

    constructor(data?: IGetPublicNopimsBasketResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPublicNopimsBasketItemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicNopimsBasketResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicNopimsBasketResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicNopimsBasketResponseDto {
    items: GetPublicNopimsBasketItemResponseDto[];
}

export class GetSubmitPublicNopimsBasketReferenceDataRequestDto implements IGetSubmitPublicNopimsBasketReferenceDataRequestDto {

    constructor(data?: IGetSubmitPublicNopimsBasketReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSubmitPublicNopimsBasketReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmitPublicNopimsBasketReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSubmitPublicNopimsBasketReferenceDataRequestDto {
}

export class GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto implements IGetSubmitPublicNopimsBasketReferenceDataResponseCountryDto {
    id!: number;
    name!: string;

    constructor(data?: IGetSubmitPublicNopimsBasketReferenceDataResponseCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetSubmitPublicNopimsBasketReferenceDataResponseCountryDto {
    id: number;
    name: string;
}

export class GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto implements IGetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto {
    id!: number;
    name!: string;
    countryId!: number;

    constructor(data?: IGetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IGetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto {
    id: number;
    name: string;
    countryId: number;
}

export class GetSubmitPublicNopimsBasketReferenceDataResponseDto implements IGetSubmitPublicNopimsBasketReferenceDataResponseDto {
    honorifics!: GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto[];
    countrySubDivisions!: GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto[];
    countries!: GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto[];

    constructor(data?: IGetSubmitPublicNopimsBasketReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.honorifics = [];
            this.countrySubDivisions = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["honorifics"])) {
                this.honorifics = [] as any;
                for (let item of _data["honorifics"])
                    this.honorifics!.push(GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto.fromJS(item));
            }
            if (Array.isArray(_data["countrySubDivisions"])) {
                this.countrySubDivisions = [] as any;
                for (let item of _data["countrySubDivisions"])
                    this.countrySubDivisions!.push(GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubmitPublicNopimsBasketReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmitPublicNopimsBasketReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.honorifics)) {
            data["honorifics"] = [];
            for (let item of this.honorifics)
                data["honorifics"].push(item.toJSON());
        }
        if (Array.isArray(this.countrySubDivisions)) {
            data["countrySubDivisions"] = [];
            for (let item of this.countrySubDivisions)
                data["countrySubDivisions"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSubmitPublicNopimsBasketReferenceDataResponseDto {
    honorifics: GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto[];
    countrySubDivisions: GetSubmitPublicNopimsBasketReferenceDataResponseCountrySubDivisionDto[];
    countries: GetSubmitPublicNopimsBasketReferenceDataResponseCountryDto[];
}

export class GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto implements IGetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto {
    id!: number;
    name!: string;

    constructor(data?: IGetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetSubmitPublicNopimsBasketReferenceDataResponseHonorificDto {
    id: number;
    name: string;
}

export class SavePublicNopimsBasketItemRequestDto implements ISavePublicNopimsBasketItemRequestDto {
    reportId?: number | undefined;
    surveyDataId?: number | undefined;
    wellBoreholeId?: number | undefined;
    surveyAcquisitionId?: number | undefined;
    reprocessingProjectId?: number | undefined;

    constructor(data?: ISavePublicNopimsBasketItemRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.surveyDataId = _data["surveyDataId"];
            this.wellBoreholeId = _data["wellBoreholeId"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.reprocessingProjectId = _data["reprocessingProjectId"];
        }
    }

    static fromJS(data: any): SavePublicNopimsBasketItemRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePublicNopimsBasketItemRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["surveyDataId"] = this.surveyDataId;
        data["wellBoreholeId"] = this.wellBoreholeId;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["reprocessingProjectId"] = this.reprocessingProjectId;
        return data;
    }
}

export interface ISavePublicNopimsBasketItemRequestDto {
    reportId?: number | undefined;
    surveyDataId?: number | undefined;
    wellBoreholeId?: number | undefined;
    surveyAcquisitionId?: number | undefined;
    reprocessingProjectId?: number | undefined;
}

export class SavePublicNopimsBasketRequestDto implements ISavePublicNopimsBasketRequestDto {
    userToken!: string;
    items?: SavePublicNopimsBasketItemRequestDto[] | undefined;

    constructor(data?: ISavePublicNopimsBasketRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SavePublicNopimsBasketItemRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePublicNopimsBasketRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePublicNopimsBasketRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePublicNopimsBasketRequestDto {
    userToken: string;
    items?: SavePublicNopimsBasketItemRequestDto[] | undefined;
}

export class SavePublicNopimsBasketResponseDto implements ISavePublicNopimsBasketResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISavePublicNopimsBasketResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SavePublicNopimsBasketResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePublicNopimsBasketResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISavePublicNopimsBasketResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitPublicNopimsBasketRequestDto implements ISubmitPublicNopimsBasketRequestDto {
    userToken!: string;
    honorificId?: number | undefined;
    firstName!: string;
    lastName!: string;
    email!: string;
    contactNumber!: string;
    companyName?: string | undefined;
    address!: string;
    suburb!: string;
    postcode?: string | undefined;
    countryId!: number;
    countrySubdivisionId?: number | undefined;
    comments!: string;

    constructor(data?: ISubmitPublicNopimsBasketRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
            this.honorificId = _data["honorificId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.countryId = _data["countryId"];
            this.countrySubdivisionId = _data["countrySubdivisionId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): SubmitPublicNopimsBasketRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitPublicNopimsBasketRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        data["honorificId"] = this.honorificId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["countryId"] = this.countryId;
        data["countrySubdivisionId"] = this.countrySubdivisionId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ISubmitPublicNopimsBasketRequestDto {
    userToken: string;
    honorificId?: number | undefined;
    firstName: string;
    lastName: string;
    email: string;
    contactNumber: string;
    companyName?: string | undefined;
    address: string;
    suburb: string;
    postcode?: string | undefined;
    countryId: number;
    countrySubdivisionId?: number | undefined;
    comments: string;
}

export class SubmitPublicNopimsBasketResponseDto implements ISubmitPublicNopimsBasketResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitPublicNopimsBasketResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitPublicNopimsBasketResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitPublicNopimsBasketResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitPublicNopimsBasketResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto implements ICreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto {
    boreholeId!: number;
    intervalTop!: number;
    intervalBottom!: number;
    boreholeSampleTypeIds!: number[];

    constructor(data?: ICreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholeSampleTypeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeId = _data["boreholeId"];
            this.intervalTop = _data["intervalTop"];
            this.intervalBottom = _data["intervalBottom"];
            if (Array.isArray(_data["boreholeSampleTypeIds"])) {
                this.boreholeSampleTypeIds = [] as any;
                for (let item of _data["boreholeSampleTypeIds"])
                    this.boreholeSampleTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeId"] = this.boreholeId;
        data["intervalTop"] = this.intervalTop;
        data["intervalBottom"] = this.intervalBottom;
        if (Array.isArray(this.boreholeSampleTypeIds)) {
            data["boreholeSampleTypeIds"] = [];
            for (let item of this.boreholeSampleTypeIds)
                data["boreholeSampleTypeIds"].push(item);
        }
        return data;
    }
}

export interface ICreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto {
    boreholeId: number;
    intervalTop: number;
    intervalBottom: number;
    boreholeSampleTypeIds: number[];
}

export class CreatePublicCoreCuttingsRequestRequestDto implements ICreatePublicCoreCuttingsRequestRequestDto {
    userToken!: string;
    honorificId?: number | undefined;
    firstName!: string;
    lastName!: string;
    companyName?: string | undefined;
    contactNumber!: string;
    emailAddress!: string;
    streetAddress?: string | undefined;
    suburb!: string;
    countrySubdivisionId?: number | undefined;
    countryId!: number;
    postcode?: string | undefined;
    isAcademia!: boolean;
    supervisorHonorific?: number | undefined;
    supervisorFirstName?: string | undefined;
    supervisorLastName?: string | undefined;
    supervisorUniversityName?: string | undefined;
    supervisorContactNumber?: string | undefined;
    supervisorEmailAddress?: string | undefined;
    supervisorSchoolName?: string | undefined;
    studyDescription!: string;
    boreholeSampleDetails!: CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto[];

    constructor(data?: ICreatePublicCoreCuttingsRequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholeSampleDetails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
            this.honorificId = _data["honorificId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyName = _data["companyName"];
            this.contactNumber = _data["contactNumber"];
            this.emailAddress = _data["emailAddress"];
            this.streetAddress = _data["streetAddress"];
            this.suburb = _data["suburb"];
            this.countrySubdivisionId = _data["countrySubdivisionId"];
            this.countryId = _data["countryId"];
            this.postcode = _data["postcode"];
            this.isAcademia = _data["isAcademia"];
            this.supervisorHonorific = _data["supervisorHonorific"];
            this.supervisorFirstName = _data["supervisorFirstName"];
            this.supervisorLastName = _data["supervisorLastName"];
            this.supervisorUniversityName = _data["supervisorUniversityName"];
            this.supervisorContactNumber = _data["supervisorContactNumber"];
            this.supervisorEmailAddress = _data["supervisorEmailAddress"];
            this.supervisorSchoolName = _data["supervisorSchoolName"];
            this.studyDescription = _data["studyDescription"];
            if (Array.isArray(_data["boreholeSampleDetails"])) {
                this.boreholeSampleDetails = [] as any;
                for (let item of _data["boreholeSampleDetails"])
                    this.boreholeSampleDetails!.push(CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePublicCoreCuttingsRequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicCoreCuttingsRequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        data["honorificId"] = this.honorificId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["contactNumber"] = this.contactNumber;
        data["emailAddress"] = this.emailAddress;
        data["streetAddress"] = this.streetAddress;
        data["suburb"] = this.suburb;
        data["countrySubdivisionId"] = this.countrySubdivisionId;
        data["countryId"] = this.countryId;
        data["postcode"] = this.postcode;
        data["isAcademia"] = this.isAcademia;
        data["supervisorHonorific"] = this.supervisorHonorific;
        data["supervisorFirstName"] = this.supervisorFirstName;
        data["supervisorLastName"] = this.supervisorLastName;
        data["supervisorUniversityName"] = this.supervisorUniversityName;
        data["supervisorContactNumber"] = this.supervisorContactNumber;
        data["supervisorEmailAddress"] = this.supervisorEmailAddress;
        data["supervisorSchoolName"] = this.supervisorSchoolName;
        data["studyDescription"] = this.studyDescription;
        if (Array.isArray(this.boreholeSampleDetails)) {
            data["boreholeSampleDetails"] = [];
            for (let item of this.boreholeSampleDetails)
                data["boreholeSampleDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePublicCoreCuttingsRequestRequestDto {
    userToken: string;
    honorificId?: number | undefined;
    firstName: string;
    lastName: string;
    companyName?: string | undefined;
    contactNumber: string;
    emailAddress: string;
    streetAddress?: string | undefined;
    suburb: string;
    countrySubdivisionId?: number | undefined;
    countryId: number;
    postcode?: string | undefined;
    isAcademia: boolean;
    supervisorHonorific?: number | undefined;
    supervisorFirstName?: string | undefined;
    supervisorLastName?: string | undefined;
    supervisorUniversityName?: string | undefined;
    supervisorContactNumber?: string | undefined;
    supervisorEmailAddress?: string | undefined;
    supervisorSchoolName?: string | undefined;
    studyDescription: string;
    boreholeSampleDetails: CreatePublicCoreCuttingsRequestRequestBoreholeSampleDetailDto[];
}

export class CreatePublicCoreCuttingsRequestResponseDto implements ICreatePublicCoreCuttingsRequestResponseDto {
    id?: number | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreatePublicCoreCuttingsRequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreatePublicCoreCuttingsRequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicCoreCuttingsRequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePublicCoreCuttingsRequestResponseDto {
    id?: number | undefined;
    statusMessages: StatusMessagesDto;
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataRequestDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataRequestDto {

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataRequestDto {
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto {
    id!: number;
    identifier!: string;
    name!: string;
    displayText!: string;

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto {
    id: number;
    identifier: string;
    name: string;
    displayText: string;
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto {
    id: number;
    name: string;
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto {
    id!: number;
    name!: string;
    countryId!: number;

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto {
    id: number;
    name: string;
    countryId: number;
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseDto {
    honorifics!: GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto[];
    countrySubDivisions!: GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto[];
    countries!: GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto[];
    boreholes!: GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto[];
    sampleTypes!: GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto[];

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.honorifics = [];
            this.countrySubDivisions = [];
            this.countries = [];
            this.boreholes = [];
            this.sampleTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["honorifics"])) {
                this.honorifics = [] as any;
                for (let item of _data["honorifics"])
                    this.honorifics!.push(GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto.fromJS(item));
            }
            if (Array.isArray(_data["countrySubDivisions"])) {
                this.countrySubDivisions = [] as any;
                for (let item of _data["countrySubDivisions"])
                    this.countrySubDivisions!.push(GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto.fromJS(item));
            }
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["sampleTypes"])) {
                this.sampleTypes = [] as any;
                for (let item of _data["sampleTypes"])
                    this.sampleTypes!.push(GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.honorifics)) {
            data["honorifics"] = [];
            for (let item of this.honorifics)
                data["honorifics"].push(item.toJSON());
        }
        if (Array.isArray(this.countrySubDivisions)) {
            data["countrySubDivisions"] = [];
            for (let item of this.countrySubDivisions)
                data["countrySubDivisions"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.sampleTypes)) {
            data["sampleTypes"] = [];
            for (let item of this.sampleTypes)
                data["sampleTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseDto {
    honorifics: GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto[];
    countrySubDivisions: GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountrySubDivisionDto[];
    countries: GetCreatePublicCoreCuttingsRequestReferenceDataResponseCountryDto[];
    boreholes: GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto[];
    sampleTypes: GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto[];
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseHonorificDto {
    id: number;
    name: string;
}

export class GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto implements IGetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto {
    id: number;
    name: string;
}

export class CreatePublicFeedbackRequestDto implements ICreatePublicFeedbackRequestDto {
    userToken!: string;
    honorificId?: number | undefined;
    customerFirstName!: string;
    customerLastName!: string;
    customerCompanyName?: string | undefined;
    customerContactNumber!: string;
    customerEmailAddress!: string;
    feedbackTypeId!: number;
    nopimsActivityTypeId?: number | undefined;
    activityId?: number | undefined;
    dataMonitoringItemTypeId?: number | undefined;
    customerComments!: string;

    constructor(data?: ICreatePublicFeedbackRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
            this.honorificId = _data["honorificId"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerCompanyName = _data["customerCompanyName"];
            this.customerContactNumber = _data["customerContactNumber"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.feedbackTypeId = _data["feedbackTypeId"];
            this.nopimsActivityTypeId = _data["nopimsActivityTypeId"];
            this.activityId = _data["activityId"];
            this.dataMonitoringItemTypeId = _data["dataMonitoringItemTypeId"];
            this.customerComments = _data["customerComments"];
        }
    }

    static fromJS(data: any): CreatePublicFeedbackRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicFeedbackRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        data["honorificId"] = this.honorificId;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerCompanyName"] = this.customerCompanyName;
        data["customerContactNumber"] = this.customerContactNumber;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["feedbackTypeId"] = this.feedbackTypeId;
        data["nopimsActivityTypeId"] = this.nopimsActivityTypeId;
        data["activityId"] = this.activityId;
        data["dataMonitoringItemTypeId"] = this.dataMonitoringItemTypeId;
        data["customerComments"] = this.customerComments;
        return data;
    }
}

export interface ICreatePublicFeedbackRequestDto {
    userToken: string;
    honorificId?: number | undefined;
    customerFirstName: string;
    customerLastName: string;
    customerCompanyName?: string | undefined;
    customerContactNumber: string;
    customerEmailAddress: string;
    feedbackTypeId: number;
    nopimsActivityTypeId?: number | undefined;
    activityId?: number | undefined;
    dataMonitoringItemTypeId?: number | undefined;
    customerComments: string;
}

export class CreatePublicFeedbackResponseDto implements ICreatePublicFeedbackResponseDto {
    id?: number | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreatePublicFeedbackResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreatePublicFeedbackResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicFeedbackResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePublicFeedbackResponseDto {
    id?: number | undefined;
    statusMessages: StatusMessagesDto;
}

export class GetCreatePublicFeedbackReferenceDataRequestDto implements IGetCreatePublicFeedbackReferenceDataRequestDto {

    constructor(data?: IGetCreatePublicFeedbackReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataRequestDto {
}

export class GetCreatePublicFeedbackReferenceDataResponseActivityDto implements IGetCreatePublicFeedbackReferenceDataResponseActivityDto {
    id!: number;
    name!: string;
    nopimsActivityTypeId!: number;
    surveyAcquisitionTypeId?: number | undefined;

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nopimsActivityTypeId = _data["nopimsActivityTypeId"];
            this.surveyAcquisitionTypeId = _data["surveyAcquisitionTypeId"];
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nopimsActivityTypeId"] = this.nopimsActivityTypeId;
        data["surveyAcquisitionTypeId"] = this.surveyAcquisitionTypeId;
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseActivityDto {
    id: number;
    name: string;
    nopimsActivityTypeId: number;
    surveyAcquisitionTypeId?: number | undefined;
}

export class GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto implements IGetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    nopimsActivityTypeId!: number;
    surveyAcquisitionTypeId?: number | undefined;

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nopimsActivityTypeId = _data["nopimsActivityTypeId"];
            this.surveyAcquisitionTypeId = _data["surveyAcquisitionTypeId"];
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nopimsActivityTypeId"] = this.nopimsActivityTypeId;
        data["surveyAcquisitionTypeId"] = this.surveyAcquisitionTypeId;
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    nopimsActivityTypeId: number;
    surveyAcquisitionTypeId?: number | undefined;
}

export class GetCreatePublicFeedbackReferenceDataResponseDto implements IGetCreatePublicFeedbackReferenceDataResponseDto {
    honorifics!: GetCreatePublicFeedbackReferenceDataResponseHonorificDto[];
    feedbackTypes!: GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto[];
    nopimsActivityTypes!: GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto[];
    activities!: GetCreatePublicFeedbackReferenceDataResponseActivityDto[];
    dataMonitoringItemTypes!: GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto[];

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.honorifics = [];
            this.feedbackTypes = [];
            this.nopimsActivityTypes = [];
            this.activities = [];
            this.dataMonitoringItemTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["honorifics"])) {
                this.honorifics = [] as any;
                for (let item of _data["honorifics"])
                    this.honorifics!.push(GetCreatePublicFeedbackReferenceDataResponseHonorificDto.fromJS(item));
            }
            if (Array.isArray(_data["feedbackTypes"])) {
                this.feedbackTypes = [] as any;
                for (let item of _data["feedbackTypes"])
                    this.feedbackTypes!.push(GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["nopimsActivityTypes"])) {
                this.nopimsActivityTypes = [] as any;
                for (let item of _data["nopimsActivityTypes"])
                    this.nopimsActivityTypes!.push(GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(GetCreatePublicFeedbackReferenceDataResponseActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["dataMonitoringItemTypes"])) {
                this.dataMonitoringItemTypes = [] as any;
                for (let item of _data["dataMonitoringItemTypes"])
                    this.dataMonitoringItemTypes!.push(GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.honorifics)) {
            data["honorifics"] = [];
            for (let item of this.honorifics)
                data["honorifics"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackTypes)) {
            data["feedbackTypes"] = [];
            for (let item of this.feedbackTypes)
                data["feedbackTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.nopimsActivityTypes)) {
            data["nopimsActivityTypes"] = [];
            for (let item of this.nopimsActivityTypes)
                data["nopimsActivityTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        if (Array.isArray(this.dataMonitoringItemTypes)) {
            data["dataMonitoringItemTypes"] = [];
            for (let item of this.dataMonitoringItemTypes)
                data["dataMonitoringItemTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseDto {
    honorifics: GetCreatePublicFeedbackReferenceDataResponseHonorificDto[];
    feedbackTypes: GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto[];
    nopimsActivityTypes: GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto[];
    activities: GetCreatePublicFeedbackReferenceDataResponseActivityDto[];
    dataMonitoringItemTypes: GetCreatePublicFeedbackReferenceDataResponseDataMonitoringItemTypeDto[];
}

export class GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto implements IGetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto {
    id!: number;
    name!: string;
    isDataFeedbackType!: boolean;

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDataFeedbackType = _data["isDataFeedbackType"];
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDataFeedbackType"] = this.isDataFeedbackType;
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseFeedbackTypeDto {
    id: number;
    name: string;
    isDataFeedbackType: boolean;
}

export class GetCreatePublicFeedbackReferenceDataResponseHonorificDto implements IGetCreatePublicFeedbackReferenceDataResponseHonorificDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseHonorificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseHonorificDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseHonorificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseHonorificDto {
    id: number;
    name: string;
}

export class GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto implements IGetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreatePublicFeedbackReferenceDataResponseNopimsActivityTypeDto {
    id: number;
    name: string;
}

export class GetPublicOeiApplicationsTrackingApplicationListItemDto implements IGetPublicOeiApplicationsTrackingApplicationListItemDto {
    applicationId?: string | undefined;
    licenceNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    licenceType?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatus!: PublicStatusEnum;
    applicationStatusName?: string | undefined;

    constructor(data?: IGetPublicOeiApplicationsTrackingApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.licenceNumber = _data["licenceNumber"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.licenceType = _data["licenceType"];
            this.applicantCompany = _data["applicantCompany"];
            this.lodgedDate = _data["lodgedDate"] ? new Date(_data["lodgedDate"].toString()) : <any>undefined;
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusName = _data["applicationStatusName"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["licenceNumber"] = this.licenceNumber;
        data["applicationTypeName"] = this.applicationTypeName;
        data["licenceType"] = this.licenceType;
        data["applicantCompany"] = this.applicantCompany;
        data["lodgedDate"] = this.lodgedDate ? this.lodgedDate.toISOString() : <any>undefined;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusName"] = this.applicationStatusName;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingApplicationListItemDto {
    applicationId?: string | undefined;
    licenceNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    licenceType?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatus: PublicStatusEnum;
    applicationStatusName?: string | undefined;
}

export class GetPublicOeiApplicationsTrackingDetailsRequestDto implements IGetPublicOeiApplicationsTrackingDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetPublicOeiApplicationsTrackingDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingDetailsRequestDto {
    applicationId: string;
}

export class GetPublicOeiApplicationsTrackingDetailsResponseDto implements IGetPublicOeiApplicationsTrackingDetailsResponseDto {
    applicationId!: string;
    applicationTypeName?: string | undefined;
    licenceType?: string | undefined;
    licenceId?: number | undefined;
    licenceNumber?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatusName?: string | undefined;
    approvalTracking?: GetPublicApplicationsTrackingDetailsApprovalTrackingDto[] | undefined;

    constructor(data?: IGetPublicOeiApplicationsTrackingDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.licenceType = _data["licenceType"];
            this.licenceId = _data["licenceId"];
            this.licenceNumber = _data["licenceNumber"];
            this.applicantCompany = _data["applicantCompany"];
            this.lodgedDate = _data["lodgedDate"] ? new Date(_data["lodgedDate"].toString()) : <any>undefined;
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.applicationStatusName = _data["applicationStatusName"];
            if (Array.isArray(_data["approvalTracking"])) {
                this.approvalTracking = [] as any;
                for (let item of _data["approvalTracking"])
                    this.approvalTracking!.push(GetPublicApplicationsTrackingDetailsApprovalTrackingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["licenceType"] = this.licenceType;
        data["licenceId"] = this.licenceId;
        data["licenceNumber"] = this.licenceNumber;
        data["applicantCompany"] = this.applicantCompany;
        data["lodgedDate"] = this.lodgedDate ? this.lodgedDate.toISOString() : <any>undefined;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["applicationStatusName"] = this.applicationStatusName;
        if (Array.isArray(this.approvalTracking)) {
            data["approvalTracking"] = [];
            for (let item of this.approvalTracking)
                data["approvalTracking"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingDetailsResponseDto {
    applicationId: string;
    applicationTypeName?: string | undefined;
    licenceType?: string | undefined;
    licenceId?: number | undefined;
    licenceNumber?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatusName?: string | undefined;
    approvalTracking?: GetPublicApplicationsTrackingDetailsApprovalTrackingDto[] | undefined;
}

export class GetPublicOeiApplicationsTrackingRequestDto implements IGetPublicOeiApplicationsTrackingRequestDto {
    applicationTrackingType?: OeiApplicationTrackingTypeEnum | undefined;
    isCompleted!: boolean;

    constructor(data?: IGetPublicOeiApplicationsTrackingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTrackingType = _data["applicationTrackingType"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTrackingType"] = this.applicationTrackingType;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingRequestDto {
    applicationTrackingType?: OeiApplicationTrackingTypeEnum | undefined;
    isCompleted: boolean;
}

export class GetPublicOeiApplicationsTrackingResponseDto implements IGetPublicOeiApplicationsTrackingResponseDto {
    applicationTrackingTypeSummary?: GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto[] | undefined;
    applicationTrackingStatusSummary?: GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto[] | undefined;
    applicationList?: GetPublicOeiApplicationsTrackingApplicationListItemDto[] | undefined;
    applicationTrackingTypes?: GetPublicOeiApplicationsTrackingTrackingTypeDto[] | undefined;

    constructor(data?: IGetPublicOeiApplicationsTrackingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationTrackingTypeSummary"])) {
                this.applicationTrackingTypeSummary = [] as any;
                for (let item of _data["applicationTrackingTypeSummary"])
                    this.applicationTrackingTypeSummary!.push(GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTrackingStatusSummary"])) {
                this.applicationTrackingStatusSummary = [] as any;
                for (let item of _data["applicationTrackingStatusSummary"])
                    this.applicationTrackingStatusSummary!.push(GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationList"])) {
                this.applicationList = [] as any;
                for (let item of _data["applicationList"])
                    this.applicationList!.push(GetPublicOeiApplicationsTrackingApplicationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTrackingTypes"])) {
                this.applicationTrackingTypes = [] as any;
                for (let item of _data["applicationTrackingTypes"])
                    this.applicationTrackingTypes!.push(GetPublicOeiApplicationsTrackingTrackingTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationTrackingTypeSummary)) {
            data["applicationTrackingTypeSummary"] = [];
            for (let item of this.applicationTrackingTypeSummary)
                data["applicationTrackingTypeSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTrackingStatusSummary)) {
            data["applicationTrackingStatusSummary"] = [];
            for (let item of this.applicationTrackingStatusSummary)
                data["applicationTrackingStatusSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationList)) {
            data["applicationList"] = [];
            for (let item of this.applicationList)
                data["applicationList"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTrackingTypes)) {
            data["applicationTrackingTypes"] = [];
            for (let item of this.applicationTrackingTypes)
                data["applicationTrackingTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingResponseDto {
    applicationTrackingTypeSummary?: GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto[] | undefined;
    applicationTrackingStatusSummary?: GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto[] | undefined;
    applicationList?: GetPublicOeiApplicationsTrackingApplicationListItemDto[] | undefined;
    applicationTrackingTypes?: GetPublicOeiApplicationsTrackingTrackingTypeDto[] | undefined;
}

export class GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto implements IGetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto {
    applicationStatus!: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    applicationStatusColour?: string | undefined;
    displayOrder!: number;
    total!: number;

    constructor(data?: IGetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusName = _data["applicationStatusName"];
            this.applicationStatusColour = _data["applicationStatusColour"];
            this.displayOrder = _data["displayOrder"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusName"] = this.applicationStatusName;
        data["applicationStatusColour"] = this.applicationStatusColour;
        data["displayOrder"] = this.displayOrder;
        data["total"] = this.total;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingTrackingStatusSummaryItemDto {
    applicationStatus: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    applicationStatusColour?: string | undefined;
    displayOrder: number;
    total: number;
}

export class GetPublicOeiApplicationsTrackingTrackingTypeDto implements IGetPublicOeiApplicationsTrackingTrackingTypeDto {
    id?: OeiApplicationTrackingTypeEnum | undefined;
    name!: string;

    constructor(data?: IGetPublicOeiApplicationsTrackingTrackingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingTrackingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingTrackingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingTrackingTypeDto {
    id?: OeiApplicationTrackingTypeEnum | undefined;
    name: string;
}

export class GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto implements IGetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto {
    applicationTrackingType!: OeiApplicationTrackingTypeEnum;
    applicationTrackingTypeName!: string;
    applicationTrackingTypeColour?: string | undefined;
    total!: number;

    constructor(data?: IGetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTrackingType = _data["applicationTrackingType"];
            this.applicationTrackingTypeName = _data["applicationTrackingTypeName"];
            this.applicationTrackingTypeColour = _data["applicationTrackingTypeColour"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTrackingType"] = this.applicationTrackingType;
        data["applicationTrackingTypeName"] = this.applicationTrackingTypeName;
        data["applicationTrackingTypeColour"] = this.applicationTrackingTypeColour;
        data["total"] = this.total;
        return data;
    }
}

export interface IGetPublicOeiApplicationsTrackingTrackingTypeSummaryItemDto {
    applicationTrackingType: OeiApplicationTrackingTypeEnum;
    applicationTrackingTypeName: string;
    applicationTrackingTypeColour?: string | undefined;
    total: number;
}

export class GetPublicLicenceDetailsLicenceHolderDto implements IGetPublicLicenceDetailsLicenceHolderDto {
    licenceHolderId!: number;
    licenceHolder!: string;
    acnOrArbn?: string | undefined;

    constructor(data?: IGetPublicLicenceDetailsLicenceHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceHolderId = _data["licenceHolderId"];
            this.licenceHolder = _data["licenceHolder"];
            this.acnOrArbn = _data["acnOrArbn"];
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsLicenceHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsLicenceHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceHolderId"] = this.licenceHolderId;
        data["licenceHolder"] = this.licenceHolder;
        data["acnOrArbn"] = this.acnOrArbn;
        return data;
    }
}

export interface IGetPublicLicenceDetailsLicenceHolderDto {
    licenceHolderId: number;
    licenceHolder: string;
    acnOrArbn?: string | undefined;
}

export class GetPublicLicenceDetailsRegisterDto implements IGetPublicLicenceDetailsRegisterDto {
    applicationId!: string;
    applicationTypeName?: string | undefined;
    decision?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;

    constructor(data?: IGetPublicLicenceDetailsRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.decision = _data["decision"];
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["decision"] = this.decision;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetPublicLicenceDetailsRegisterDto {
    applicationId: string;
    applicationTypeName?: string | undefined;
    decision?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;
}

export class GetPublicLicenceDetailsRelatedLicenceDto implements IGetPublicLicenceDetailsRelatedLicenceDto {
    licenceId!: number;
    licenceNumber!: string;

    constructor(data?: IGetPublicLicenceDetailsRelatedLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.licenceNumber = _data["licenceNumber"];
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsRelatedLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsRelatedLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["licenceNumber"] = this.licenceNumber;
        return data;
    }
}

export interface IGetPublicLicenceDetailsRelatedLicenceDto {
    licenceId: number;
    licenceNumber: string;
}

export class GetPublicLicenceDetailsRequestDto implements IGetPublicLicenceDetailsRequestDto {
    licenceId!: number;

    constructor(data?: IGetPublicLicenceDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        return data;
    }
}

export interface IGetPublicLicenceDetailsRequestDto {
    licenceId: number;
}

export class GetPublicLicenceDetailsResponseDto implements IGetPublicLicenceDetailsResponseDto {
    licenceId!: number;
    summary!: GetPublicLicenceDetailsSummaryDto;
    licenceHolder!: GetPublicLicenceDetailsLicenceHolderDto;
    memorial!: GetPublicLicenceDetailsRegisterDto[];

    constructor(data?: IGetPublicLicenceDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new GetPublicLicenceDetailsSummaryDto();
            this.licenceHolder = new GetPublicLicenceDetailsLicenceHolderDto();
            this.memorial = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.summary = _data["summary"] ? GetPublicLicenceDetailsSummaryDto.fromJS(_data["summary"]) : new GetPublicLicenceDetailsSummaryDto();
            this.licenceHolder = _data["licenceHolder"] ? GetPublicLicenceDetailsLicenceHolderDto.fromJS(_data["licenceHolder"]) : new GetPublicLicenceDetailsLicenceHolderDto();
            if (Array.isArray(_data["memorial"])) {
                this.memorial = [] as any;
                for (let item of _data["memorial"])
                    this.memorial!.push(GetPublicLicenceDetailsRegisterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["licenceHolder"] = this.licenceHolder ? this.licenceHolder.toJSON() : <any>undefined;
        if (Array.isArray(this.memorial)) {
            data["memorial"] = [];
            for (let item of this.memorial)
                data["memorial"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicLicenceDetailsResponseDto {
    licenceId: number;
    summary: GetPublicLicenceDetailsSummaryDto;
    licenceHolder: GetPublicLicenceDetailsLicenceHolderDto;
    memorial: GetPublicLicenceDetailsRegisterDto[];
}

export class GetPublicLicenceDetailsSummaryDto implements IGetPublicLicenceDetailsSummaryDto {
    licenceNumber!: string;
    licenceStatusDescription!: string;
    licenceTypeDescription!: string;
    legislationDescription!: string;
    projectName!: string;
    declaredAreaName!: string;
    relatedLicences!: GetPublicLicenceDetailsRelatedLicenceDto[];
    grantDate!: Date;
    comesIntoForceDate!: Date;
    endDate!: Date;
    licenceCeaseDate?: Date | undefined;
    finalisedArea!: number;
    finalisedGenerationCapacity!: number;
    renewableEnergyResourceDescription!: string;
    technologyToBeInvestigatedDescription!: string;

    constructor(data?: IGetPublicLicenceDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedLicences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"];
            this.licenceStatusDescription = _data["licenceStatusDescription"];
            this.licenceTypeDescription = _data["licenceTypeDescription"];
            this.legislationDescription = _data["legislationDescription"];
            this.projectName = _data["projectName"];
            this.declaredAreaName = _data["declaredAreaName"];
            if (Array.isArray(_data["relatedLicences"])) {
                this.relatedLicences = [] as any;
                for (let item of _data["relatedLicences"])
                    this.relatedLicences!.push(GetPublicLicenceDetailsRelatedLicenceDto.fromJS(item));
            }
            this.grantDate = _data["grantDate"] ? new Date(_data["grantDate"].toString()) : <any>undefined;
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.licenceCeaseDate = _data["licenceCeaseDate"] ? new Date(_data["licenceCeaseDate"].toString()) : <any>undefined;
            this.finalisedArea = _data["finalisedArea"];
            this.finalisedGenerationCapacity = _data["finalisedGenerationCapacity"];
            this.renewableEnergyResourceDescription = _data["renewableEnergyResourceDescription"];
            this.technologyToBeInvestigatedDescription = _data["technologyToBeInvestigatedDescription"];
        }
    }

    static fromJS(data: any): GetPublicLicenceDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicenceDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber;
        data["licenceStatusDescription"] = this.licenceStatusDescription;
        data["licenceTypeDescription"] = this.licenceTypeDescription;
        data["legislationDescription"] = this.legislationDescription;
        data["projectName"] = this.projectName;
        data["declaredAreaName"] = this.declaredAreaName;
        if (Array.isArray(this.relatedLicences)) {
            data["relatedLicences"] = [];
            for (let item of this.relatedLicences)
                data["relatedLicences"].push(item.toJSON());
        }
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["licenceCeaseDate"] = this.licenceCeaseDate ? this.licenceCeaseDate.toISOString() : <any>undefined;
        data["finalisedArea"] = this.finalisedArea;
        data["finalisedGenerationCapacity"] = this.finalisedGenerationCapacity;
        data["renewableEnergyResourceDescription"] = this.renewableEnergyResourceDescription;
        data["technologyToBeInvestigatedDescription"] = this.technologyToBeInvestigatedDescription;
        return data;
    }
}

export interface IGetPublicLicenceDetailsSummaryDto {
    licenceNumber: string;
    licenceStatusDescription: string;
    licenceTypeDescription: string;
    legislationDescription: string;
    projectName: string;
    declaredAreaName: string;
    relatedLicences: GetPublicLicenceDetailsRelatedLicenceDto[];
    grantDate: Date;
    comesIntoForceDate: Date;
    endDate: Date;
    licenceCeaseDate?: Date | undefined;
    finalisedArea: number;
    finalisedGenerationCapacity: number;
    renewableEnergyResourceDescription: string;
    technologyToBeInvestigatedDescription: string;
}

export class GetPublicLicencesListItemDto implements IGetPublicLicencesListItemDto {
    licenceId!: number;
    licenceNumber!: string;
    licenceType!: string;
    licenceStatus!: string;
    licenceHolder!: string;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    grantDate?: Date | undefined;

    constructor(data?: IGetPublicLicencesListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.licenceNumber = _data["licenceNumber"];
            this.licenceType = _data["licenceType"];
            this.licenceStatus = _data["licenceStatus"];
            this.licenceHolder = _data["licenceHolder"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? new Date(_data["grantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublicLicencesListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicencesListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["licenceNumber"] = this.licenceNumber;
        data["licenceType"] = this.licenceType;
        data["licenceStatus"] = this.licenceStatus;
        data["licenceHolder"] = this.licenceHolder;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPublicLicencesListItemDto {
    licenceId: number;
    licenceNumber: string;
    licenceType: string;
    licenceStatus: string;
    licenceHolder: string;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    grantDate?: Date | undefined;
}

export class GetPublicLicencesListRequestDto implements IGetPublicLicencesListRequestDto {
    filterFullTextSearch?: string | undefined;

    constructor(data?: IGetPublicLicencesListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
        }
    }

    static fromJS(data: any): GetPublicLicencesListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicencesListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        return data;
    }
}

export interface IGetPublicLicencesListRequestDto {
    filterFullTextSearch?: string | undefined;
}

export class GetPublicLicencesListResponseDto implements IGetPublicLicencesListResponseDto {
    licences!: GetPublicLicencesListItemDto[];

    constructor(data?: IGetPublicLicencesListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(GetPublicLicencesListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicLicencesListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLicencesListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicLicencesListResponseDto {
    licences: GetPublicLicencesListItemDto[];
}

export class GetPublicOpenLicenceIdRequestDto implements IGetPublicOpenLicenceIdRequestDto {
    licenceNumber?: string | undefined;

    constructor(data?: IGetPublicOpenLicenceIdRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"];
        }
    }

    static fromJS(data: any): GetPublicOpenLicenceIdRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpenLicenceIdRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber;
        return data;
    }
}

export interface IGetPublicOpenLicenceIdRequestDto {
    licenceNumber?: string | undefined;
}

export class GetPublicOpenLicenceIdResponseDto implements IGetPublicOpenLicenceIdResponseDto {
    licenceId?: number | undefined;

    constructor(data?: IGetPublicOpenLicenceIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): GetPublicOpenLicenceIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpenLicenceIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        return data;
    }
}

export interface IGetPublicOpenLicenceIdResponseDto {
    licenceId?: number | undefined;
}

export class GetPublicApplicationsTrackingApplicationListItemDto implements IGetPublicApplicationsTrackingApplicationListItemDto {
    applicationId?: string | undefined;
    titleNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    titleType?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatus!: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    offshoreAreaName?: string | undefined;

    constructor(data?: IGetPublicApplicationsTrackingApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.titleNumber = _data["titleNumber"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.titleType = _data["titleType"];
            this.applicantCompany = _data["applicantCompany"];
            this.lodgedDate = _data["lodgedDate"] ? new Date(_data["lodgedDate"].toString()) : <any>undefined;
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusName = _data["applicationStatusName"];
            this.offshoreAreaName = _data["offshoreAreaName"];
        }
    }

    static fromJS(data: any): GetPublicApplicationsTrackingApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicApplicationsTrackingApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["titleNumber"] = this.titleNumber;
        data["applicationTypeName"] = this.applicationTypeName;
        data["titleType"] = this.titleType;
        data["applicantCompany"] = this.applicantCompany;
        data["lodgedDate"] = this.lodgedDate ? this.lodgedDate.toISOString() : <any>undefined;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusName"] = this.applicationStatusName;
        data["offshoreAreaName"] = this.offshoreAreaName;
        return data;
    }
}

export interface IGetPublicApplicationsTrackingApplicationListItemDto {
    applicationId?: string | undefined;
    titleNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    titleType?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatus: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    offshoreAreaName?: string | undefined;
}

export class GetPublicApplicationsTrackingTrackingStatusSummaryItemDto implements IGetPublicApplicationsTrackingTrackingStatusSummaryItemDto {
    applicationStatus!: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    applicationStatusColour?: string | undefined;
    displayOrder!: number;
    total!: number;

    constructor(data?: IGetPublicApplicationsTrackingTrackingStatusSummaryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusName = _data["applicationStatusName"];
            this.applicationStatusColour = _data["applicationStatusColour"];
            this.displayOrder = _data["displayOrder"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetPublicApplicationsTrackingTrackingStatusSummaryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicApplicationsTrackingTrackingStatusSummaryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusName"] = this.applicationStatusName;
        data["applicationStatusColour"] = this.applicationStatusColour;
        data["displayOrder"] = this.displayOrder;
        data["total"] = this.total;
        return data;
    }
}

export interface IGetPublicApplicationsTrackingTrackingStatusSummaryItemDto {
    applicationStatus: PublicStatusEnum;
    applicationStatusName?: string | undefined;
    applicationStatusColour?: string | undefined;
    displayOrder: number;
    total: number;
}

export class GetPublicApplicationsTrackingTrackingTypeDto implements IGetPublicApplicationsTrackingTrackingTypeDto {
    id?: OpggsApplicationTrackingTypeEnum | undefined;
    name!: string;

    constructor(data?: IGetPublicApplicationsTrackingTrackingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetPublicApplicationsTrackingTrackingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicApplicationsTrackingTrackingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetPublicApplicationsTrackingTrackingTypeDto {
    id?: OpggsApplicationTrackingTypeEnum | undefined;
    name: string;
}

export class GetPublicApplicationsTrackingTrackingTypeSummaryItemDto implements IGetPublicApplicationsTrackingTrackingTypeSummaryItemDto {
    applicationTrackingType!: OpggsApplicationTrackingTypeEnum;
    applicationTrackingTypeName!: string;
    applicationTrackingTypeColour?: string | undefined;
    total!: number;

    constructor(data?: IGetPublicApplicationsTrackingTrackingTypeSummaryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTrackingType = _data["applicationTrackingType"];
            this.applicationTrackingTypeName = _data["applicationTrackingTypeName"];
            this.applicationTrackingTypeColour = _data["applicationTrackingTypeColour"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetPublicApplicationsTrackingTrackingTypeSummaryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicApplicationsTrackingTrackingTypeSummaryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTrackingType"] = this.applicationTrackingType;
        data["applicationTrackingTypeName"] = this.applicationTrackingTypeName;
        data["applicationTrackingTypeColour"] = this.applicationTrackingTypeColour;
        data["total"] = this.total;
        return data;
    }
}

export interface IGetPublicApplicationsTrackingTrackingTypeSummaryItemDto {
    applicationTrackingType: OpggsApplicationTrackingTypeEnum;
    applicationTrackingTypeName: string;
    applicationTrackingTypeColour?: string | undefined;
    total: number;
}

export class GetPublicOpggsApplicationsTrackingDetailsRequestDto implements IGetPublicOpggsApplicationsTrackingDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetPublicOpggsApplicationsTrackingDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetPublicOpggsApplicationsTrackingDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpggsApplicationsTrackingDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetPublicOpggsApplicationsTrackingDetailsRequestDto {
    applicationId: string;
}

export class GetPublicOpggsApplicationsTrackingDetailsResponseDto implements IGetPublicOpggsApplicationsTrackingDetailsResponseDto {
    applicationId!: string;
    applicationTypeName?: string | undefined;
    titleType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatusName?: string | undefined;
    offshoreAreaName?: string | undefined;
    approvalTracking?: GetPublicApplicationsTrackingDetailsApprovalTrackingDto[] | undefined;

    constructor(data?: IGetPublicOpggsApplicationsTrackingDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.titleType = _data["titleType"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.applicantCompany = _data["applicantCompany"];
            this.lodgedDate = _data["lodgedDate"] ? new Date(_data["lodgedDate"].toString()) : <any>undefined;
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.applicationStatusName = _data["applicationStatusName"];
            this.offshoreAreaName = _data["offshoreAreaName"];
            if (Array.isArray(_data["approvalTracking"])) {
                this.approvalTracking = [] as any;
                for (let item of _data["approvalTracking"])
                    this.approvalTracking!.push(GetPublicApplicationsTrackingDetailsApprovalTrackingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicOpggsApplicationsTrackingDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpggsApplicationsTrackingDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["titleType"] = this.titleType;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["applicantCompany"] = this.applicantCompany;
        data["lodgedDate"] = this.lodgedDate ? this.lodgedDate.toISOString() : <any>undefined;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["applicationStatusName"] = this.applicationStatusName;
        data["offshoreAreaName"] = this.offshoreAreaName;
        if (Array.isArray(this.approvalTracking)) {
            data["approvalTracking"] = [];
            for (let item of this.approvalTracking)
                data["approvalTracking"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicOpggsApplicationsTrackingDetailsResponseDto {
    applicationId: string;
    applicationTypeName?: string | undefined;
    titleType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    applicantCompany?: string | undefined;
    lodgedDate?: Date | undefined;
    implementedDate?: Date | undefined;
    applicationStatusName?: string | undefined;
    offshoreAreaName?: string | undefined;
    approvalTracking?: GetPublicApplicationsTrackingDetailsApprovalTrackingDto[] | undefined;
}

export class GetPublicOpggsApplicationsTrackingRequestDto implements IGetPublicOpggsApplicationsTrackingRequestDto {
    applicationTrackingType?: OpggsApplicationTrackingTypeEnum | undefined;
    isCompleted!: boolean;

    constructor(data?: IGetPublicOpggsApplicationsTrackingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTrackingType = _data["applicationTrackingType"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetPublicOpggsApplicationsTrackingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpggsApplicationsTrackingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTrackingType"] = this.applicationTrackingType;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetPublicOpggsApplicationsTrackingRequestDto {
    applicationTrackingType?: OpggsApplicationTrackingTypeEnum | undefined;
    isCompleted: boolean;
}

export class GetPublicOpggsApplicationsTrackingResponseDto implements IGetPublicOpggsApplicationsTrackingResponseDto {
    applicationTrackingTypeSummary?: GetPublicApplicationsTrackingTrackingTypeSummaryItemDto[] | undefined;
    applicationTrackingStatusSummary?: GetPublicApplicationsTrackingTrackingStatusSummaryItemDto[] | undefined;
    applicationList?: GetPublicApplicationsTrackingApplicationListItemDto[] | undefined;
    applicationTrackingTypes?: GetPublicApplicationsTrackingTrackingTypeDto[] | undefined;

    constructor(data?: IGetPublicOpggsApplicationsTrackingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationTrackingTypeSummary"])) {
                this.applicationTrackingTypeSummary = [] as any;
                for (let item of _data["applicationTrackingTypeSummary"])
                    this.applicationTrackingTypeSummary!.push(GetPublicApplicationsTrackingTrackingTypeSummaryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTrackingStatusSummary"])) {
                this.applicationTrackingStatusSummary = [] as any;
                for (let item of _data["applicationTrackingStatusSummary"])
                    this.applicationTrackingStatusSummary!.push(GetPublicApplicationsTrackingTrackingStatusSummaryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationList"])) {
                this.applicationList = [] as any;
                for (let item of _data["applicationList"])
                    this.applicationList!.push(GetPublicApplicationsTrackingApplicationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTrackingTypes"])) {
                this.applicationTrackingTypes = [] as any;
                for (let item of _data["applicationTrackingTypes"])
                    this.applicationTrackingTypes!.push(GetPublicApplicationsTrackingTrackingTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicOpggsApplicationsTrackingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpggsApplicationsTrackingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationTrackingTypeSummary)) {
            data["applicationTrackingTypeSummary"] = [];
            for (let item of this.applicationTrackingTypeSummary)
                data["applicationTrackingTypeSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTrackingStatusSummary)) {
            data["applicationTrackingStatusSummary"] = [];
            for (let item of this.applicationTrackingStatusSummary)
                data["applicationTrackingStatusSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationList)) {
            data["applicationList"] = [];
            for (let item of this.applicationList)
                data["applicationList"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTrackingTypes)) {
            data["applicationTrackingTypes"] = [];
            for (let item of this.applicationTrackingTypes)
                data["applicationTrackingTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicOpggsApplicationsTrackingResponseDto {
    applicationTrackingTypeSummary?: GetPublicApplicationsTrackingTrackingTypeSummaryItemDto[] | undefined;
    applicationTrackingStatusSummary?: GetPublicApplicationsTrackingTrackingStatusSummaryItemDto[] | undefined;
    applicationList?: GetPublicApplicationsTrackingApplicationListItemDto[] | undefined;
    applicationTrackingTypes?: GetPublicApplicationsTrackingTrackingTypeDto[] | undefined;
}

export class GetPublicStorageFormationListItemDto implements IGetPublicStorageFormationListItemDto {
    storageFormationId!: number;
    storageFormationName?: string | undefined;
    storageFormationStatus?: string | undefined;
    implementedDate!: Date;
    registeredDate!: Date;
    titleId!: string;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titleholders?: string | undefined;
    mapSheet?: string | undefined;
    graticularBlocks?: string | undefined;
    applicationId!: string;
    fileId?: number | undefined;

    constructor(data?: IGetPublicStorageFormationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageFormationId = _data["storageFormationId"];
            this.storageFormationName = _data["storageFormationName"];
            this.storageFormationStatus = _data["storageFormationStatus"];
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titleholders = _data["titleholders"];
            this.mapSheet = _data["mapSheet"];
            this.graticularBlocks = _data["graticularBlocks"];
            this.applicationId = _data["applicationId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetPublicStorageFormationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicStorageFormationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageFormationId"] = this.storageFormationId;
        data["storageFormationName"] = this.storageFormationName;
        data["storageFormationStatus"] = this.storageFormationStatus;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titleholders"] = this.titleholders;
        data["mapSheet"] = this.mapSheet;
        data["graticularBlocks"] = this.graticularBlocks;
        data["applicationId"] = this.applicationId;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetPublicStorageFormationListItemDto {
    storageFormationId: number;
    storageFormationName?: string | undefined;
    storageFormationStatus?: string | undefined;
    implementedDate: Date;
    registeredDate: Date;
    titleId: string;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titleholders?: string | undefined;
    mapSheet?: string | undefined;
    graticularBlocks?: string | undefined;
    applicationId: string;
    fileId?: number | undefined;
}

export class GetPublicStorageFormationsListRequestDto implements IGetPublicStorageFormationsListRequestDto {

    constructor(data?: IGetPublicStorageFormationsListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPublicStorageFormationsListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicStorageFormationsListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPublicStorageFormationsListRequestDto {
}

export class GetPublicStorageFormationsListResponseDto implements IGetPublicStorageFormationsListResponseDto {
    storageFormations!: GetPublicStorageFormationListItemDto[];

    constructor(data?: IGetPublicStorageFormationsListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storageFormations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storageFormations"])) {
                this.storageFormations = [] as any;
                for (let item of _data["storageFormations"])
                    this.storageFormations!.push(GetPublicStorageFormationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicStorageFormationsListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicStorageFormationsListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storageFormations)) {
            data["storageFormations"] = [];
            for (let item of this.storageFormations)
                data["storageFormations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicStorageFormationsListResponseDto {
    storageFormations: GetPublicStorageFormationListItemDto[];
}

export class GetPublicOpenTitleIdRequestDto implements IGetPublicOpenTitleIdRequestDto {
    titleNumber?: string | undefined;

    constructor(data?: IGetPublicOpenTitleIdRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): GetPublicOpenTitleIdRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpenTitleIdRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IGetPublicOpenTitleIdRequestDto {
    titleNumber?: string | undefined;
}

export class GetPublicOpenTitleIdResponseDto implements IGetPublicOpenTitleIdResponseDto {
    titleId?: string | undefined;

    constructor(data?: IGetPublicOpenTitleIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetPublicOpenTitleIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicOpenTitleIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetPublicOpenTitleIdResponseDto {
    titleId?: string | undefined;
}

export class GetPublicTitleDetailsBlockDto implements IGetPublicTitleDetailsBlockDto {
    blockId!: number;
    blockNumber!: number;
    isPartBlock?: string | undefined;
    mapSheetCode?: string | undefined;
    mapSheetName?: string | undefined;
    locationName?: string | undefined;

    constructor(data?: IGetPublicTitleDetailsBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blockId = _data["blockId"];
            this.blockNumber = _data["blockNumber"];
            this.isPartBlock = _data["isPartBlock"];
            this.mapSheetCode = _data["mapSheetCode"];
            this.mapSheetName = _data["mapSheetName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockId"] = this.blockId;
        data["blockNumber"] = this.blockNumber;
        data["isPartBlock"] = this.isPartBlock;
        data["mapSheetCode"] = this.mapSheetCode;
        data["mapSheetName"] = this.mapSheetName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetPublicTitleDetailsBlockDto {
    blockId: number;
    blockNumber: number;
    isPartBlock?: string | undefined;
    mapSheetCode?: string | undefined;
    mapSheetName?: string | undefined;
    locationName?: string | undefined;
}

export class GetPublicTitleDetailsBlocksAndLocationsDto implements IGetPublicTitleDetailsBlocksAndLocationsDto {
    blocks?: GetPublicTitleDetailsBlockDto[] | undefined;
    locations?: GetPublicTitleDetailsLocationDto[] | undefined;

    constructor(data?: IGetPublicTitleDetailsBlocksAndLocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(GetPublicTitleDetailsBlockDto.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(GetPublicTitleDetailsLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsBlocksAndLocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsBlocksAndLocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicTitleDetailsBlocksAndLocationsDto {
    blocks?: GetPublicTitleDetailsBlockDto[] | undefined;
    locations?: GetPublicTitleDetailsLocationDto[] | undefined;
}

export class GetPublicTitleDetailsLocationDto implements IGetPublicTitleDetailsLocationDto {
    locationId!: number;
    locationName?: string | undefined;
    isActive!: boolean;
    substanceName?: string | undefined;
    statusName?: string | undefined;
    originalExpiryDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;

    constructor(data?: IGetPublicTitleDetailsLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.isActive = _data["isActive"];
            this.substanceName = _data["substanceName"];
            this.statusName = _data["statusName"];
            this.originalExpiryDate = _data["originalExpiryDate"] ? new Date(_data["originalExpiryDate"].toString()) : <any>undefined;
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["isActive"] = this.isActive;
        data["substanceName"] = this.substanceName;
        data["statusName"] = this.statusName;
        data["originalExpiryDate"] = this.originalExpiryDate ? this.originalExpiryDate.toISOString() : <any>undefined;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPublicTitleDetailsLocationDto {
    locationId: number;
    locationName?: string | undefined;
    isActive: boolean;
    substanceName?: string | undefined;
    statusName?: string | undefined;
    originalExpiryDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
}

export class GetPublicTitleDetailsMapRequestDto implements IGetPublicTitleDetailsMapRequestDto {
    titleId!: string;

    constructor(data?: IGetPublicTitleDetailsMapRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsMapRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsMapRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetPublicTitleDetailsMapRequestDto {
    titleId: string;
}

export class GetPublicTitleDetailsMapResponseDto implements IGetPublicTitleDetailsMapResponseDto {
    isOnline!: boolean;
    isFeatureAvailable!: boolean;
    areaSqKm?: number | undefined;
    pinLatitude?: number | undefined;
    pinLongitude?: number | undefined;
    extentMinLatitude?: number | undefined;
    extentMinLongitude?: number | undefined;
    extentMaxLatitude?: number | undefined;
    extentMaxLongitude?: number | undefined;
    zoomLevel?: number | undefined;

    constructor(data?: IGetPublicTitleDetailsMapResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["isOnline"];
            this.isFeatureAvailable = _data["isFeatureAvailable"];
            this.areaSqKm = _data["areaSqKm"];
            this.pinLatitude = _data["pinLatitude"];
            this.pinLongitude = _data["pinLongitude"];
            this.extentMinLatitude = _data["extentMinLatitude"];
            this.extentMinLongitude = _data["extentMinLongitude"];
            this.extentMaxLatitude = _data["extentMaxLatitude"];
            this.extentMaxLongitude = _data["extentMaxLongitude"];
            this.zoomLevel = _data["zoomLevel"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsMapResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsMapResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnline"] = this.isOnline;
        data["isFeatureAvailable"] = this.isFeatureAvailable;
        data["areaSqKm"] = this.areaSqKm;
        data["pinLatitude"] = this.pinLatitude;
        data["pinLongitude"] = this.pinLongitude;
        data["extentMinLatitude"] = this.extentMinLatitude;
        data["extentMinLongitude"] = this.extentMinLongitude;
        data["extentMaxLatitude"] = this.extentMaxLatitude;
        data["extentMaxLongitude"] = this.extentMaxLongitude;
        data["zoomLevel"] = this.zoomLevel;
        return data;
    }
}

export interface IGetPublicTitleDetailsMapResponseDto {
    isOnline: boolean;
    isFeatureAvailable: boolean;
    areaSqKm?: number | undefined;
    pinLatitude?: number | undefined;
    pinLongitude?: number | undefined;
    extentMinLatitude?: number | undefined;
    extentMinLongitude?: number | undefined;
    extentMaxLatitude?: number | undefined;
    extentMaxLongitude?: number | undefined;
    zoomLevel?: number | undefined;
}

export class GetPublicTitleDetailsMemorialApplicationDto implements IGetPublicTitleDetailsMemorialApplicationDto {
    applicationId!: string;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision?: string | undefined;
    implementedDate?: Date | undefined;
    registeredDatetime?: Date | undefined;
    fileId?: number | undefined;

    constructor(data?: IGetPublicTitleDetailsMemorialApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.applicationName = _data["applicationName"];
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.decision = _data["decision"];
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDatetime = _data["registeredDatetime"] ? new Date(_data["registeredDatetime"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsMemorialApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsMemorialApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["applicationName"] = this.applicationName;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["decision"] = this.decision;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDatetime"] = this.registeredDatetime ? this.registeredDatetime.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetPublicTitleDetailsMemorialApplicationDto {
    applicationId: string;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision?: string | undefined;
    implementedDate?: Date | undefined;
    registeredDatetime?: Date | undefined;
    fileId?: number | undefined;
}

export class GetPublicTitleDetailsMemorialDto implements IGetPublicTitleDetailsMemorialDto {
    applications?: GetPublicTitleDetailsMemorialApplicationDto[] | undefined;

    constructor(data?: IGetPublicTitleDetailsMemorialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(GetPublicTitleDetailsMemorialApplicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsMemorialDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsMemorialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicTitleDetailsMemorialDto {
    applications?: GetPublicTitleDetailsMemorialApplicationDto[] | undefined;
}

export class GetPublicTitleDetailsRelatedTitleDto implements IGetPublicTitleDetailsRelatedTitleDto {
    titleId?: string | undefined;
    titleNumber?: string | undefined;

    constructor(data?: IGetPublicTitleDetailsRelatedTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsRelatedTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsRelatedTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IGetPublicTitleDetailsRelatedTitleDto {
    titleId?: string | undefined;
    titleNumber?: string | undefined;
}

export class GetPublicTitleDetailsRequestDto implements IGetPublicTitleDetailsRequestDto {
    titleId!: string;

    constructor(data?: IGetPublicTitleDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetPublicTitleDetailsRequestDto {
    titleId: string;
}

export class GetPublicTitleDetailsResponseDto implements IGetPublicTitleDetailsResponseDto {
    titleId!: string;
    titleNumber?: string | undefined;
    titleType!: TitleTypeEnum;
    titleTypeName?: string | undefined;
    title2SubType?: Title2SubTypeEnum | undefined;
    title2SubTypeTypeName?: string | undefined;
    summary?: GetPublicTitleDetailsSummaryDto | undefined;
    titleholders?: GetPublicTitleDetailsTitleholderDto[] | undefined;
    workProgram?: GetPublicTitleDetailsWorkProgramDto | undefined;
    memorial?: GetPublicTitleDetailsMemorialDto | undefined;
    blocksAndLocations?: GetPublicTitleDetailsBlocksAndLocationsDto | undefined;

    constructor(data?: IGetPublicTitleDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titleTypeName = _data["titleTypeName"];
            this.title2SubType = _data["title2SubType"];
            this.title2SubTypeTypeName = _data["title2SubTypeTypeName"];
            this.summary = _data["summary"] ? GetPublicTitleDetailsSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["titleholders"])) {
                this.titleholders = [] as any;
                for (let item of _data["titleholders"])
                    this.titleholders!.push(GetPublicTitleDetailsTitleholderDto.fromJS(item));
            }
            this.workProgram = _data["workProgram"] ? GetPublicTitleDetailsWorkProgramDto.fromJS(_data["workProgram"]) : <any>undefined;
            this.memorial = _data["memorial"] ? GetPublicTitleDetailsMemorialDto.fromJS(_data["memorial"]) : <any>undefined;
            this.blocksAndLocations = _data["blocksAndLocations"] ? GetPublicTitleDetailsBlocksAndLocationsDto.fromJS(_data["blocksAndLocations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titleTypeName"] = this.titleTypeName;
        data["title2SubType"] = this.title2SubType;
        data["title2SubTypeTypeName"] = this.title2SubTypeTypeName;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.titleholders)) {
            data["titleholders"] = [];
            for (let item of this.titleholders)
                data["titleholders"].push(item.toJSON());
        }
        data["workProgram"] = this.workProgram ? this.workProgram.toJSON() : <any>undefined;
        data["memorial"] = this.memorial ? this.memorial.toJSON() : <any>undefined;
        data["blocksAndLocations"] = this.blocksAndLocations ? this.blocksAndLocations.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPublicTitleDetailsResponseDto {
    titleId: string;
    titleNumber?: string | undefined;
    titleType: TitleTypeEnum;
    titleTypeName?: string | undefined;
    title2SubType?: Title2SubTypeEnum | undefined;
    title2SubTypeTypeName?: string | undefined;
    summary?: GetPublicTitleDetailsSummaryDto | undefined;
    titleholders?: GetPublicTitleDetailsTitleholderDto[] | undefined;
    workProgram?: GetPublicTitleDetailsWorkProgramDto | undefined;
    memorial?: GetPublicTitleDetailsMemorialDto | undefined;
    blocksAndLocations?: GetPublicTitleDetailsBlocksAndLocationsDto | undefined;
}

export class GetPublicTitleDetailsSummaryDto implements IGetPublicTitleDetailsSummaryDto {
    titleStatus?: string | undefined;
    numberOfRenewals!: number;
    initialGrantDate!: Date;
    originalExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    numberOfBlocks!: number;
    hasPriorUsageRight!: boolean;
    isDesignatedFrontierArea?: string | undefined;
    storageFormationNames?: string | undefined;
    pipelineLength?: number | undefined;
    pipelineName?: string | undefined;
    substanceName?: string | undefined;
    startPointName?: string | undefined;
    endPointName?: string | undefined;
    locationNames?: string[] | undefined;
    relatedTitles?: GetPublicTitleDetailsRelatedTitleDto[] | undefined;

    constructor(data?: IGetPublicTitleDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleStatus = _data["titleStatus"];
            this.numberOfRenewals = _data["numberOfRenewals"];
            this.initialGrantDate = _data["initialGrantDate"] ? new Date(_data["initialGrantDate"].toString()) : <any>undefined;
            this.originalExpiryDate = _data["originalExpiryDate"] ? new Date(_data["originalExpiryDate"].toString()) : <any>undefined;
            this.lastRenewalDate = _data["lastRenewalDate"] ? new Date(_data["lastRenewalDate"].toString()) : <any>undefined;
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.offshoreAreaName = _data["offshoreAreaName"];
            this.basinName = _data["basinName"];
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.numberOfBlocks = _data["numberOfBlocks"];
            this.hasPriorUsageRight = _data["hasPriorUsageRight"];
            this.isDesignatedFrontierArea = _data["isDesignatedFrontierArea"];
            this.storageFormationNames = _data["storageFormationNames"];
            this.pipelineLength = _data["pipelineLength"];
            this.pipelineName = _data["pipelineName"];
            this.substanceName = _data["substanceName"];
            this.startPointName = _data["startPointName"];
            this.endPointName = _data["endPointName"];
            if (Array.isArray(_data["locationNames"])) {
                this.locationNames = [] as any;
                for (let item of _data["locationNames"])
                    this.locationNames!.push(item);
            }
            if (Array.isArray(_data["relatedTitles"])) {
                this.relatedTitles = [] as any;
                for (let item of _data["relatedTitles"])
                    this.relatedTitles!.push(GetPublicTitleDetailsRelatedTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleStatus"] = this.titleStatus;
        data["numberOfRenewals"] = this.numberOfRenewals;
        data["initialGrantDate"] = this.initialGrantDate ? this.initialGrantDate.toISOString() : <any>undefined;
        data["originalExpiryDate"] = this.originalExpiryDate ? this.originalExpiryDate.toISOString() : <any>undefined;
        data["lastRenewalDate"] = this.lastRenewalDate ? this.lastRenewalDate.toISOString() : <any>undefined;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["offshoreAreaName"] = this.offshoreAreaName;
        data["basinName"] = this.basinName;
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["numberOfBlocks"] = this.numberOfBlocks;
        data["hasPriorUsageRight"] = this.hasPriorUsageRight;
        data["isDesignatedFrontierArea"] = this.isDesignatedFrontierArea;
        data["storageFormationNames"] = this.storageFormationNames;
        data["pipelineLength"] = this.pipelineLength;
        data["pipelineName"] = this.pipelineName;
        data["substanceName"] = this.substanceName;
        data["startPointName"] = this.startPointName;
        data["endPointName"] = this.endPointName;
        if (Array.isArray(this.locationNames)) {
            data["locationNames"] = [];
            for (let item of this.locationNames)
                data["locationNames"].push(item);
        }
        if (Array.isArray(this.relatedTitles)) {
            data["relatedTitles"] = [];
            for (let item of this.relatedTitles)
                data["relatedTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicTitleDetailsSummaryDto {
    titleStatus?: string | undefined;
    numberOfRenewals: number;
    initialGrantDate: Date;
    originalExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    numberOfBlocks: number;
    hasPriorUsageRight: boolean;
    isDesignatedFrontierArea?: string | undefined;
    storageFormationNames?: string | undefined;
    pipelineLength?: number | undefined;
    pipelineName?: string | undefined;
    substanceName?: string | undefined;
    startPointName?: string | undefined;
    endPointName?: string | undefined;
    locationNames?: string[] | undefined;
    relatedTitles?: GetPublicTitleDetailsRelatedTitleDto[] | undefined;
}

export class GetPublicTitleDetailsTitleholderDto implements IGetPublicTitleDetailsTitleholderDto {
    companyId!: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isOperator!: boolean;
    percentageOwnership!: number;

    constructor(data?: IGetPublicTitleDetailsTitleholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.isOperator = _data["isOperator"];
            this.percentageOwnership = _data["percentageOwnership"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsTitleholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsTitleholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["isOperator"] = this.isOperator;
        data["percentageOwnership"] = this.percentageOwnership;
        return data;
    }
}

export interface IGetPublicTitleDetailsTitleholderDto {
    companyId: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isOperator: boolean;
    percentageOwnership: number;
}

export class GetPublicTitleDetailsWorkProgramDto implements IGetPublicTitleDetailsWorkProgramDto {
    showPrimaryAndSecondaryTerms!: boolean;
    years?: GetPublicTitleDetailsWorkProgramYearDto[] | undefined;
    grandTotal!: number;
    primaryTermTotal!: number;
    secondaryTermTotal!: number;

    constructor(data?: IGetPublicTitleDetailsWorkProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showPrimaryAndSecondaryTerms = _data["showPrimaryAndSecondaryTerms"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(GetPublicTitleDetailsWorkProgramYearDto.fromJS(item));
            }
            this.grandTotal = _data["grandTotal"];
            this.primaryTermTotal = _data["primaryTermTotal"];
            this.secondaryTermTotal = _data["secondaryTermTotal"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsWorkProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsWorkProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPrimaryAndSecondaryTerms"] = this.showPrimaryAndSecondaryTerms;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal;
        data["primaryTermTotal"] = this.primaryTermTotal;
        data["secondaryTermTotal"] = this.secondaryTermTotal;
        return data;
    }
}

export interface IGetPublicTitleDetailsWorkProgramDto {
    showPrimaryAndSecondaryTerms: boolean;
    years?: GetPublicTitleDetailsWorkProgramYearDto[] | undefined;
    grandTotal: number;
    primaryTermTotal: number;
    secondaryTermTotal: number;
}

export class GetPublicTitleDetailsWorkProgramYearActivityDto implements IGetPublicTitleDetailsWorkProgramYearActivityDto {
    description?: string | undefined;
    quantity?: string | undefined;
    value?: number | undefined;
    activityOrder!: number;

    constructor(data?: IGetPublicTitleDetailsWorkProgramYearActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.value = _data["value"];
            this.activityOrder = _data["activityOrder"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsWorkProgramYearActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsWorkProgramYearActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["value"] = this.value;
        data["activityOrder"] = this.activityOrder;
        return data;
    }
}

export interface IGetPublicTitleDetailsWorkProgramYearActivityDto {
    description?: string | undefined;
    quantity?: string | undefined;
    value?: number | undefined;
    activityOrder: number;
}

export class GetPublicTitleDetailsWorkProgramYearDto implements IGetPublicTitleDetailsWorkProgramYearDto {
    years?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEpPrimaryTerm?: boolean | undefined;
    isEpSecondaryTerm?: boolean | undefined;
    activities?: GetPublicTitleDetailsWorkProgramYearActivityDto[] | undefined;
    value?: number | undefined;
    yearOrder!: number;

    constructor(data?: IGetPublicTitleDetailsWorkProgramYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.years = _data["years"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isEpPrimaryTerm = _data["isEpPrimaryTerm"];
            this.isEpSecondaryTerm = _data["isEpSecondaryTerm"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(GetPublicTitleDetailsWorkProgramYearActivityDto.fromJS(item));
            }
            this.value = _data["value"];
            this.yearOrder = _data["yearOrder"];
        }
    }

    static fromJS(data: any): GetPublicTitleDetailsWorkProgramYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitleDetailsWorkProgramYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["years"] = this.years;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isEpPrimaryTerm"] = this.isEpPrimaryTerm;
        data["isEpSecondaryTerm"] = this.isEpSecondaryTerm;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["value"] = this.value;
        data["yearOrder"] = this.yearOrder;
        return data;
    }
}

export interface IGetPublicTitleDetailsWorkProgramYearDto {
    years?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEpPrimaryTerm?: boolean | undefined;
    isEpSecondaryTerm?: boolean | undefined;
    activities?: GetPublicTitleDetailsWorkProgramYearActivityDto[] | undefined;
    value?: number | undefined;
    yearOrder: number;
}

export class GetPublicTitlesListItemDto implements IGetPublicTitlesListItemDto {
    titleId!: string;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titleholders?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    initialGrantDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;

    constructor(data?: IGetPublicTitlesListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titleholders = _data["titleholders"];
            this.titleStatus = _data["titleStatus"];
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.lastRenewalDate = _data["lastRenewalDate"] ? new Date(_data["lastRenewalDate"].toString()) : <any>undefined;
            this.initialGrantDate = _data["initialGrantDate"] ? new Date(_data["initialGrantDate"].toString()) : <any>undefined;
            this.offshoreAreaName = _data["offshoreAreaName"];
            this.basinName = _data["basinName"];
        }
    }

    static fromJS(data: any): GetPublicTitlesListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitlesListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titleholders"] = this.titleholders;
        data["titleStatus"] = this.titleStatus;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["lastRenewalDate"] = this.lastRenewalDate ? this.lastRenewalDate.toISOString() : <any>undefined;
        data["initialGrantDate"] = this.initialGrantDate ? this.initialGrantDate.toISOString() : <any>undefined;
        data["offshoreAreaName"] = this.offshoreAreaName;
        data["basinName"] = this.basinName;
        return data;
    }
}

export interface IGetPublicTitlesListItemDto {
    titleId: string;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titleholders?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    initialGrantDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;
}

export class GetPublicTitlesListRequestDto implements IGetPublicTitlesListRequestDto {
    filterFullTextSearch?: string | undefined;

    constructor(data?: IGetPublicTitlesListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
        }
    }

    static fromJS(data: any): GetPublicTitlesListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitlesListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        return data;
    }
}

export interface IGetPublicTitlesListRequestDto {
    filterFullTextSearch?: string | undefined;
}

export class GetPublicTitlesListResponseDto implements IGetPublicTitlesListResponseDto {
    titles!: GetPublicTitlesListItemDto[];

    constructor(data?: IGetPublicTitlesListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetPublicTitlesListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicTitlesListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTitlesListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicTitlesListResponseDto {
    titles: GetPublicTitlesListItemDto[];
}

export class GetPublicShellFeatureSwitchesRequestDto implements IGetPublicShellFeatureSwitchesRequestDto {

    constructor(data?: IGetPublicShellFeatureSwitchesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPublicShellFeatureSwitchesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicShellFeatureSwitchesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPublicShellFeatureSwitchesRequestDto {
}

export class GetPublicShellFeatureSwitchesResponseDto implements IGetPublicShellFeatureSwitchesResponseDto {
    featureSwitches!: NeatsFeatureSwitchEnum[];

    constructor(data?: IGetPublicShellFeatureSwitchesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureSwitches = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureSwitches"])) {
                this.featureSwitches = [] as any;
                for (let item of _data["featureSwitches"])
                    this.featureSwitches!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPublicShellFeatureSwitchesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicShellFeatureSwitchesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureSwitches)) {
            data["featureSwitches"] = [];
            for (let item of this.featureSwitches)
                data["featureSwitches"].push(item);
        }
        return data;
    }
}

export interface IGetPublicShellFeatureSwitchesResponseDto {
    featureSwitches: NeatsFeatureSwitchEnum[];
}

export class GetPublicShellPortalLinksLinkDto implements IGetPublicShellPortalLinksLinkDto {
    name!: ExternalLinkEnum;
    url!: string;

    constructor(data?: IGetPublicShellPortalLinksLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetPublicShellPortalLinksLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicShellPortalLinksLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetPublicShellPortalLinksLinkDto {
    name: ExternalLinkEnum;
    url: string;
}

export class GetPublicShellPortalLinksRequestDto implements IGetPublicShellPortalLinksRequestDto {

    constructor(data?: IGetPublicShellPortalLinksRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPublicShellPortalLinksRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicShellPortalLinksRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPublicShellPortalLinksRequestDto {
}

export class GetPublicShellPortalLinksResponseDto implements IGetPublicShellPortalLinksResponseDto {
    links!: GetPublicShellPortalLinksLinkDto[];

    constructor(data?: IGetPublicShellPortalLinksResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(GetPublicShellPortalLinksLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicShellPortalLinksResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicShellPortalLinksResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublicShellPortalLinksResponseDto {
    links: GetPublicShellPortalLinksLinkDto[];
}

export class ForeignInvestmentApprovalTypeDto implements IForeignInvestmentApprovalTypeDto {
    foreignInvestmentApprovalType!: DraftApplicationForeignInvestmentApprovalTypeEnum;
    description!: string;

    constructor(data?: IForeignInvestmentApprovalTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foreignInvestmentApprovalType = _data["foreignInvestmentApprovalType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ForeignInvestmentApprovalTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForeignInvestmentApprovalTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foreignInvestmentApprovalType"] = this.foreignInvestmentApprovalType;
        data["description"] = this.description;
        return data;
    }
}

export interface IForeignInvestmentApprovalTypeDto {
    foreignInvestmentApprovalType: DraftApplicationForeignInvestmentApprovalTypeEnum;
    description: string;
}

export class ApplicationLinkDto implements IApplicationLinkDto {
    id!: string;
    act!: ActEnum;
    trackingNumber!: string;
    isAuthorised!: boolean;

    constructor(data?: IApplicationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.act = _data["act"];
            this.trackingNumber = _data["trackingNumber"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): ApplicationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["act"] = this.act;
        data["trackingNumber"] = this.trackingNumber;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IApplicationLinkDto {
    id: string;
    act: ActEnum;
    trackingNumber: string;
    isAuthorised: boolean;
}

export class DraftApplicationLinkDto implements IDraftApplicationLinkDto {
    id!: number;
    trackingNumber!: string;
    type!: DraftApplicationTypeEnum;
    isAuthorised!: boolean;

    constructor(data?: IDraftApplicationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): DraftApplicationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IDraftApplicationLinkDto {
    id: number;
    trackingNumber: string;
    type: DraftApplicationTypeEnum;
    isAuthorised: boolean;
}

export class FinancialNotificationLinkDto implements IFinancialNotificationLinkDto {
    id!: number;
    code!: string;
    isComplete!: boolean;
    isAuthorised!: boolean;

    constructor(data?: IFinancialNotificationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.isComplete = _data["isComplete"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): FinancialNotificationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNotificationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["isComplete"] = this.isComplete;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IFinancialNotificationLinkDto {
    id: number;
    code: string;
    isComplete: boolean;
    isAuthorised: boolean;
}

export class LicenceLinkDto implements ILicenceLinkDto {
    id!: number;
    licenceNumber!: string;
    isAuthorised!: boolean;

    constructor(data?: ILicenceLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceNumber = _data["licenceNumber"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): LicenceLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceNumber"] = this.licenceNumber;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface ILicenceLinkDto {
    id: number;
    licenceNumber: string;
    isAuthorised: boolean;
}

export class SecureRequestGroupLinkDto implements ISecureRequestGroupLinkDto {
    id!: number;
    code!: string;
    type!: SecureRequestGroupTypeEnum;
    isAuthorised!: boolean;

    constructor(data?: ISecureRequestGroupLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): SecureRequestGroupLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureRequestGroupLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface ISecureRequestGroupLinkDto {
    id: number;
    code: string;
    type: SecureRequestGroupTypeEnum;
    isAuthorised: boolean;
}

export class TitleLinkDto implements ITitleLinkDto {
    id!: string;
    titleNumber!: string;
    isAuthorised!: boolean;

    constructor(data?: ITitleLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleNumber = _data["titleNumber"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): TitleLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleNumber"] = this.titleNumber;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface ITitleLinkDto {
    id: string;
    titleNumber: string;
    isAuthorised: boolean;
}

export class SecurePortalCountryDto implements ISecurePortalCountryDto {
    countryId!: number;
    countryName?: string | undefined;
    subdivisions?: SecurePortalCountrySubdivisionDto[] | undefined;

    constructor(data?: ISecurePortalCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            if (Array.isArray(_data["subdivisions"])) {
                this.subdivisions = [] as any;
                for (let item of _data["subdivisions"])
                    this.subdivisions!.push(SecurePortalCountrySubdivisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurePortalCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        if (Array.isArray(this.subdivisions)) {
            data["subdivisions"] = [];
            for (let item of this.subdivisions)
                data["subdivisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecurePortalCountryDto {
    countryId: number;
    countryName?: string | undefined;
    subdivisions?: SecurePortalCountrySubdivisionDto[] | undefined;
}

export class SecurePortalCountrySubdivisionDto implements ISecurePortalCountrySubdivisionDto {
    countrySubdivisionId!: number;
    countrySubdivisionName?: string | undefined;

    constructor(data?: ISecurePortalCountrySubdivisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countrySubdivisionId = _data["countrySubdivisionId"];
            this.countrySubdivisionName = _data["countrySubdivisionName"];
        }
    }

    static fromJS(data: any): SecurePortalCountrySubdivisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalCountrySubdivisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countrySubdivisionId"] = this.countrySubdivisionId;
        data["countrySubdivisionName"] = this.countrySubdivisionName;
        return data;
    }
}

export interface ISecurePortalCountrySubdivisionDto {
    countrySubdivisionId: number;
    countrySubdivisionName?: string | undefined;
}

export class SecurePortalDocumentDto implements ISecurePortalDocumentDto {
    fileName!: string;
    mimeType!: string;
    content!: string;

    constructor(data?: ISecurePortalDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SecurePortalDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        return data;
    }
}

export interface ISecurePortalDocumentDto {
    fileName: string;
    mimeType: string;
    content: string;
}

export class SecurePortalSimpleAuditEventDto implements ISecurePortalSimpleAuditEventDto {
    action?: string | undefined;
    identity?: string | undefined;
    timestamp!: Date;

    constructor(data?: ISecurePortalSimpleAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.identity = _data["identity"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SecurePortalSimpleAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalSimpleAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["identity"] = this.identity;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISecurePortalSimpleAuditEventDto {
    action?: string | undefined;
    identity?: string | undefined;
    timestamp: Date;
}

export class SecurePortalSimpleAuditEventsDto implements ISecurePortalSimpleAuditEventsDto {
    events?: SecurePortalSimpleAuditEventDto[] | undefined;

    constructor(data?: ISecurePortalSimpleAuditEventsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(SecurePortalSimpleAuditEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurePortalSimpleAuditEventsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalSimpleAuditEventsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecurePortalSimpleAuditEventsDto {
    events?: SecurePortalSimpleAuditEventDto[] | undefined;
}

export class SecurePortalSimpleDataAuditChangeDto implements ISecurePortalSimpleDataAuditChangeDto {
    changeType!: SimpleDataAuditChangeTypeEnum;
    identity?: string | undefined;
    timestamp!: Date;
    comments?: string | undefined;
    snapshot?: SimpleDataAuditSnapshotModelNodeDto | undefined;
    delta?: SimpleDataAuditDeltaModelNodeDto | undefined;

    constructor(data?: ISecurePortalSimpleDataAuditChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeType = _data["changeType"];
            this.identity = _data["identity"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.snapshot = _data["snapshot"] ? SimpleDataAuditSnapshotModelNodeDto.fromJS(_data["snapshot"]) : <any>undefined;
            this.delta = _data["delta"] ? SimpleDataAuditDeltaModelNodeDto.fromJS(_data["delta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecurePortalSimpleDataAuditChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalSimpleDataAuditChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType;
        data["identity"] = this.identity;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["snapshot"] = this.snapshot ? this.snapshot.toJSON() : <any>undefined;
        data["delta"] = this.delta ? this.delta.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecurePortalSimpleDataAuditChangeDto {
    changeType: SimpleDataAuditChangeTypeEnum;
    identity?: string | undefined;
    timestamp: Date;
    comments?: string | undefined;
    snapshot?: SimpleDataAuditSnapshotModelNodeDto | undefined;
    delta?: SimpleDataAuditDeltaModelNodeDto | undefined;
}

export class SecurePortalSimpleDataAuditChangesDto implements ISecurePortalSimpleDataAuditChangesDto {
    changes?: SecurePortalSimpleDataAuditChangeDto[] | undefined;

    constructor(data?: ISecurePortalSimpleDataAuditChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(SecurePortalSimpleDataAuditChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurePortalSimpleDataAuditChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurePortalSimpleDataAuditChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecurePortalSimpleDataAuditChangesDto {
    changes?: SecurePortalSimpleDataAuditChangeDto[] | undefined;
}

export class SecureUserNotificationTypesDto implements ISecureUserNotificationTypesDto {
    notificationType!: SecureEntityTypeNotificationTypeEnum;
    name!: string;
    isSelected!: boolean;

    constructor(data?: ISecureUserNotificationTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SecureUserNotificationTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserNotificationTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISecureUserNotificationTypesDto {
    notificationType: SecureEntityTypeNotificationTypeEnum;
    name: string;
    isSelected: boolean;
}

export class UserContactDto implements IUserContactDto {
    fullName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IUserContactDto {
    fullName?: string | undefined;
    emailAddress?: string | undefined;
}

export class CompanyAccountMyDetailsPendingRequestsDto implements ICompanyAccountMyDetailsPendingRequestsDto {
    secureRequestGroupId!: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime!: Date;
    companyName?: string | undefined;
    rolesRequested!: SecureRoleEnum[];

    constructor(data?: ICompanyAccountMyDetailsPendingRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.secureRequestGroupCode = _data["secureRequestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
        }
    }

    static fromJS(data: any): CompanyAccountMyDetailsPendingRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyAccountMyDetailsPendingRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["secureRequestGroupCode"] = this.secureRequestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        return data;
    }
}

export interface ICompanyAccountMyDetailsPendingRequestsDto {
    secureRequestGroupId: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime: Date;
    companyName?: string | undefined;
    rolesRequested: SecureRoleEnum[];
}

export class GetCompanyAccountMyDetailsRequestDto implements IGetCompanyAccountMyDetailsRequestDto {

    constructor(data?: IGetCompanyAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyAccountMyDetailsRequestDto {
}

export class GetCompanyAccountMyDetailsResponseDto implements IGetCompanyAccountMyDetailsResponseDto {
    versionNumber!: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    existingRoles!: CompanySecureUserCompanyRoleDto[];
    pendingRequests!: CompanyAccountMyDetailsPendingRequestsDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.existingRoles = [];
            this.pendingRequests = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["existingRoles"])) {
                this.existingRoles = [] as any;
                for (let item of _data["existingRoles"])
                    this.existingRoles!.push(CompanySecureUserCompanyRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["pendingRequests"])) {
                this.pendingRequests = [] as any;
                for (let item of _data["pendingRequests"])
                    this.pendingRequests!.push(CompanyAccountMyDetailsPendingRequestsDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.existingRoles)) {
            data["existingRoles"] = [];
            for (let item of this.existingRoles)
                data["existingRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingRequests)) {
            data["pendingRequests"] = [];
            for (let item of this.pendingRequests)
                data["pendingRequests"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyAccountMyDetailsResponseDto {
    versionNumber: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    existingRoles: CompanySecureUserCompanyRoleDto[];
    pendingRequests: CompanyAccountMyDetailsPendingRequestsDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyAccountMyDetailsRequestDto implements ISaveCompanyAccountMyDetailsRequestDto {
    versionNumber!: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;

    constructor(data?: ISaveCompanyAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): SaveCompanyAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface ISaveCompanyAccountMyDetailsRequestDto {
    versionNumber: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
}

export class SaveCompanyAccountMyDetailsResponseDto implements ISaveCompanyAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ISaveCompanyAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCompanyAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class CreateCompanyAccountRequestAccessCaRequestDto implements ICreateCompanyAccountRequestAccessCaRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.caAuthoritySupportingDocument = _data["caAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["caAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["caAuthoritySupportingDocument"] = this.caAuthoritySupportingDocument ? this.caAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCaRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateCompanyAccountRequestAccessCaResponseDto implements ICreateCompanyAccountRequestAccessCaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateCompanyAccountRequestAccessCrCsRequestDto implements ICreateCompanyAccountRequestAccessCrCsRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest!: boolean;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.isCompanySignerPoaRequest = _data["isCompanySignerPoaRequest"];
            this.companyStandardRolesRequest = _data["companyStandardRolesRequest"] ? CompanyStandardRoleRequestDetailsDto.fromJS(_data["companyStandardRolesRequest"]) : <any>undefined;
            this.csAuthoritySupportingDocument = _data["csAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csAuthoritySupportingDocument"]) : <any>undefined;
            this.csPoaSupportingDocument = _data["csPoaSupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csPoaSupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["isCompanySignerPoaRequest"] = this.isCompanySignerPoaRequest;
        data["companyStandardRolesRequest"] = this.companyStandardRolesRequest ? this.companyStandardRolesRequest.toJSON() : <any>undefined;
        data["csAuthoritySupportingDocument"] = this.csAuthoritySupportingDocument ? this.csAuthoritySupportingDocument.toJSON() : <any>undefined;
        data["csPoaSupportingDocument"] = this.csPoaSupportingDocument ? this.csPoaSupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCrCsRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest: boolean;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateCompanyAccountRequestAccessCrCsResponseDto implements ICreateCompanyAccountRequestAccessCrCsResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCrCsResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateCompanyAccountRequestAccessCrRequestDto implements ICreateCompanyAccountRequestAccessCrRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.companyStandardRolesRequest = _data["companyStandardRolesRequest"] ? CompanyStandardRoleRequestDetailsDto.fromJS(_data["companyStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["companyStandardRolesRequest"] = this.companyStandardRolesRequest ? this.companyStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCrRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
}

export class CreateCompanyAccountRequestAccessCrResponseDto implements ICreateCompanyAccountRequestAccessCrResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCrResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateCompanyAccountRequestAccessCsRequestDto implements ICreateCompanyAccountRequestAccessCsRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest!: boolean;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.isCompanySignerPoaRequest = _data["isCompanySignerPoaRequest"];
            this.csAuthoritySupportingDocument = _data["csAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csAuthoritySupportingDocument"]) : <any>undefined;
            this.csPoaSupportingDocument = _data["csPoaSupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csPoaSupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["isCompanySignerPoaRequest"] = this.isCompanySignerPoaRequest;
        data["csAuthoritySupportingDocument"] = this.csAuthoritySupportingDocument ? this.csAuthoritySupportingDocument.toJSON() : <any>undefined;
        data["csPoaSupportingDocument"] = this.csPoaSupportingDocument ? this.csPoaSupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCsRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest: boolean;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateCompanyAccountRequestAccessCsResponseDto implements ICreateCompanyAccountRequestAccessCsResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessCsResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateCompanyAccountRequestAccessNcCaRequestDto implements ICreateCompanyAccountRequestAccessNcCaRequestDto {
    submittedComments?: string | undefined;
    newCompanyRequest?: NewCompanyRequestDetailsDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessNcCaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.newCompanyRequest = _data["newCompanyRequest"] ? NewCompanyRequestDetailsDto.fromJS(_data["newCompanyRequest"]) : <any>undefined;
            this.caAuthoritySupportingDocument = _data["caAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["caAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessNcCaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessNcCaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["newCompanyRequest"] = this.newCompanyRequest ? this.newCompanyRequest.toJSON() : <any>undefined;
        data["caAuthoritySupportingDocument"] = this.caAuthoritySupportingDocument ? this.caAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessNcCaRequestDto {
    submittedComments?: string | undefined;
    newCompanyRequest?: NewCompanyRequestDetailsDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateCompanyAccountRequestAccessNcCaResponseDto implements ICreateCompanyAccountRequestAccessNcCaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateCompanyAccountRequestAccessNcCaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyAccountRequestAccessNcCaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyAccountRequestAccessNcCaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyAccountRequestAccessNcCaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetCompanyAccountRequestAccessReferenceDataRequestDto implements IGetCompanyAccountRequestAccessReferenceDataRequestDto {

    constructor(data?: IGetCompanyAccountRequestAccessReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyAccountRequestAccessReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyAccountRequestAccessReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyAccountRequestAccessReferenceDataRequestDto {
}

export class GetCompanyAccountRequestAccessReferenceDataResponseDto implements IGetCompanyAccountRequestAccessReferenceDataResponseDto {
    companies!: SecureUserCompanyDto[];
    countries!: SecurePortalCountryDto[];

    constructor(data?: IGetCompanyAccountRequestAccessReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companies = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SecureUserCompanyDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SecurePortalCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyAccountRequestAccessReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyAccountRequestAccessReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyAccountRequestAccessReferenceDataResponseDto {
    companies: SecureUserCompanyDto[];
    countries: SecurePortalCountryDto[];
}

export class SecureUserCompanyDto implements ISecureUserCompanyDto {
    companyId!: number;
    companyName?: string | undefined;
    hasPendingRequest!: boolean;
    hasCompanyAdministrator!: boolean;
    activeRoles!: SecureRoleEnum[];
    isCompanyAdministrator!: boolean;
    isCompanySigner!: boolean;
    hasAllSpecialRoles!: boolean;
    hasAllGeneralRoles!: boolean;

    constructor(data?: ISecureUserCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.hasCompanyAdministrator = _data["hasCompanyAdministrator"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.isCompanyAdministrator = _data["isCompanyAdministrator"];
            this.isCompanySigner = _data["isCompanySigner"];
            this.hasAllSpecialRoles = _data["hasAllSpecialRoles"];
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): SecureUserCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["hasCompanyAdministrator"] = this.hasCompanyAdministrator;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["isCompanyAdministrator"] = this.isCompanyAdministrator;
        data["isCompanySigner"] = this.isCompanySigner;
        data["hasAllSpecialRoles"] = this.hasAllSpecialRoles;
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface ISecureUserCompanyDto {
    companyId: number;
    companyName?: string | undefined;
    hasPendingRequest: boolean;
    hasCompanyAdministrator: boolean;
    activeRoles: SecureRoleEnum[];
    isCompanyAdministrator: boolean;
    isCompanySigner: boolean;
    hasAllSpecialRoles: boolean;
    hasAllGeneralRoles: boolean;
}

export class CompanyApplicationApplicantDto implements ICompanyApplicationApplicantDto {
    companyId!: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyApplicationApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyApplicationApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyApplicationApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyApplicationApplicantDto {
    companyId: number;
    companyName?: string | undefined;
}

export class CompanyApplicationListItemDto implements ICompanyApplicationListItemDto {
    applicationLink!: ApplicationLinkDto;
    act!: ActEnum;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    applicationStatusDisplay?: string | undefined;
    statusDate?: Date | undefined;
    submittedDate?: Date | undefined;
    titleLink?: TitleLinkDto | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    titleLicenceNumber?: string | undefined;
    titleLicenceTypeDisplay?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;

    constructor(data?: ICompanyApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicationLink = new ApplicationLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationLink = _data["applicationLink"] ? ApplicationLinkDto.fromJS(_data["applicationLink"]) : new ApplicationLinkDto();
            this.act = _data["act"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.applicationName = _data["applicationName"];
            this.applicationStatusDisplay = _data["applicationStatusDisplay"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : <any>undefined;
            this.licenceLink = _data["licenceLink"] ? LicenceLinkDto.fromJS(_data["licenceLink"]) : <any>undefined;
            this.titleLicenceNumber = _data["titleLicenceNumber"];
            this.titleLicenceTypeDisplay = _data["titleLicenceTypeDisplay"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationLink"] = this.applicationLink ? this.applicationLink.toJSON() : <any>undefined;
        data["act"] = this.act;
        data["applicationTypeName"] = this.applicationTypeName;
        data["applicationName"] = this.applicationName;
        data["applicationStatusDisplay"] = this.applicationStatusDisplay;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        data["titleLicenceNumber"] = this.titleLicenceNumber;
        data["titleLicenceTypeDisplay"] = this.titleLicenceTypeDisplay;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyApplicationListItemDto {
    applicationLink: ApplicationLinkDto;
    act: ActEnum;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    applicationStatusDisplay?: string | undefined;
    statusDate?: Date | undefined;
    submittedDate?: Date | undefined;
    titleLink?: TitleLinkDto | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    titleLicenceNumber?: string | undefined;
    titleLicenceTypeDisplay?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
}

export class CompanySecureUserCompanyRoleDto implements ICompanySecureUserCompanyRoleDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    username?: string | undefined;
    fullName?: string | undefined;
    companyId!: number;
    companyName?: string | undefined;
    companyAdministrators?: UserContactDto[] | undefined;
    isSecureUserBlocked!: boolean;
    isSecureUserSignedIn!: boolean;
    hasPendingRequest!: boolean;
    hasCompanyMembership!: boolean;
    activeRoles!: SecureRoleEnum[];
    isCompanyRevokedButVisible!: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;

    constructor(data?: ICompanySecureUserCompanyRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["companyAdministrators"])) {
                this.companyAdministrators = [] as any;
                for (let item of _data["companyAdministrators"])
                    this.companyAdministrators!.push(UserContactDto.fromJS(item));
            }
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserSignedIn = _data["isSecureUserSignedIn"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.hasCompanyMembership = _data["hasCompanyMembership"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.isCompanyRevokedButVisible = _data["isCompanyRevokedButVisible"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedDatetime = _data["lastUpdatedDatetime"] ? new Date(_data["lastUpdatedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanySecureUserCompanyRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySecureUserCompanyRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.companyAdministrators)) {
            data["companyAdministrators"] = [];
            for (let item of this.companyAdministrators)
                data["companyAdministrators"].push(item.toJSON());
        }
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserSignedIn"] = this.isSecureUserSignedIn;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["hasCompanyMembership"] = this.hasCompanyMembership;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["isCompanyRevokedButVisible"] = this.isCompanyRevokedButVisible;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedDatetime"] = this.lastUpdatedDatetime ? this.lastUpdatedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICompanySecureUserCompanyRoleDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    username?: string | undefined;
    fullName?: string | undefined;
    companyId: number;
    companyName?: string | undefined;
    companyAdministrators?: UserContactDto[] | undefined;
    isSecureUserBlocked: boolean;
    isSecureUserSignedIn: boolean;
    hasPendingRequest: boolean;
    hasCompanyMembership: boolean;
    activeRoles: SecureRoleEnum[];
    isCompanyRevokedButVisible: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsPaymentDto implements IGetCompanyOpggsDraftApplicationDetailsPaymentDto {
    feeEstimate!: number;
    isPaymentRequired!: boolean;
    isPaymentComplete!: boolean;
    financialNotificationStatus?: string | undefined;
    financialNotificationLink?: FinancialNotificationLinkDto | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeEstimate = _data["feeEstimate"];
            this.isPaymentRequired = _data["isPaymentRequired"];
            this.isPaymentComplete = _data["isPaymentComplete"];
            this.financialNotificationStatus = _data["financialNotificationStatus"];
            this.financialNotificationLink = _data["financialNotificationLink"] ? FinancialNotificationLinkDto.fromJS(_data["financialNotificationLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeEstimate"] = this.feeEstimate;
        data["isPaymentRequired"] = this.isPaymentRequired;
        data["isPaymentComplete"] = this.isPaymentComplete;
        data["financialNotificationStatus"] = this.financialNotificationStatus;
        data["financialNotificationLink"] = this.financialNotificationLink ? this.financialNotificationLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsPaymentDto {
    feeEstimate: number;
    isPaymentRequired: boolean;
    isPaymentComplete: boolean;
    financialNotificationStatus?: string | undefined;
    financialNotificationLink?: FinancialNotificationLinkDto | undefined;
}

export class DeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto implements IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): DeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationRequestDto {
    id: number;
    versionNumber: number;
}

export class DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto implements IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteCompanyCommonDraftApplicationDetailsDraftApplicationResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto implements IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentRequestDto {
    id: number;
}

export class GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto implements IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyCommonDraftApplicationDetailsDraftApplicationFormDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto implements IGetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto {
    id!: number;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsFormDocumentationRequestDto {
    id: number;
}

export class GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto implements IGetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto {
    versionNumber!: number;
    signatureType?: DraftApplicationFormDocumentationSignatureTypeEnum | undefined;
    isSigned!: boolean;
    isForSigning!: boolean;
    wetSignatureDetails?: GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto | undefined;
    digitalSignatureDetails?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto | undefined;
    files!: GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto[];
    statusMessages!: StatusMessagesDto;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
            this.statusMessages = new StatusMessagesDto();
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.signatureType = _data["signatureType"];
            this.isSigned = _data["isSigned"];
            this.isForSigning = _data["isForSigning"];
            this.wetSignatureDetails = _data["wetSignatureDetails"] ? GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto.fromJS(_data["wetSignatureDetails"]) : <any>undefined;
            this.digitalSignatureDetails = _data["digitalSignatureDetails"] ? GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto.fromJS(_data["digitalSignatureDetails"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto.fromJS(item));
            }
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["signatureType"] = this.signatureType;
        data["isSigned"] = this.isSigned;
        data["isForSigning"] = this.isForSigning;
        data["wetSignatureDetails"] = this.wetSignatureDetails ? this.wetSignatureDetails.toJSON() : <any>undefined;
        data["digitalSignatureDetails"] = this.digitalSignatureDetails ? this.digitalSignatureDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsFormDocumentationResponseDto {
    versionNumber: number;
    signatureType?: DraftApplicationFormDocumentationSignatureTypeEnum | undefined;
    isSigned: boolean;
    isForSigning: boolean;
    wetSignatureDetails?: GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto | undefined;
    digitalSignatureDetails?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto | undefined;
    files: GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto[];
    statusMessages: StatusMessagesDto;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto implements IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto {
    type!: DraftApplicationFormDocumentationDigitalSignatureTypeEnum;
    name?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto {
    type: DraftApplicationFormDocumentationDigitalSignatureTypeEnum;
    name?: string | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto implements IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto {
    companyId!: number;
    companyName?: string | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto[] | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto {
    companyId: number;
    companyName?: string | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypeItemDto[] | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto implements IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto {
    companyId!: number;
    companyName?: string | undefined;
    status?: string | undefined;
    signedSignatureTypes?: string | undefined;
    lastSignedDatetime?: Date | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.status = _data["status"];
            this.signedSignatureTypes = _data["signedSignatureTypes"];
            this.lastSignedDatetime = _data["lastSignedDatetime"] ? new Date(_data["lastSignedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["status"] = this.status;
        data["signedSignatureTypes"] = this.signedSignatureTypes;
        data["lastSignedDatetime"] = this.lastSignedDatetime ? this.lastSignedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto {
    companyId: number;
    companyName?: string | undefined;
    status?: string | undefined;
    signedSignatureTypes?: string | undefined;
    lastSignedDatetime?: Date | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto {
    companySignatures?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto[] | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto[] | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companySignatures"])) {
                this.companySignatures = [] as any;
                for (let item of _data["companySignatures"])
                    this.companySignatures!.push(GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto.fromJS(item));
            }
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companySignatures)) {
            data["companySignatures"] = [];
            for (let item of this.companySignatures)
                data["companySignatures"].push(item.toJSON());
        }
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsDigitalSignatureDetailsDto {
    companySignatures?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureCompanySignatureDto[] | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsDigitalSignatureAvailableSignatureTypesDto[] | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto implements IGetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto {
    fileId!: number;
    fileName!: string;
    fileSize!: number;
    uploadedDatetime!: Date;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadedDatetime = _data["uploadedDatetime"] ? new Date(_data["uploadedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadedDatetime"] = this.uploadedDatetime ? this.uploadedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsFormDocumentationFileDto {
    fileId: number;
    fileName: string;
    fileSize: number;
    uploadedDatetime: Date;
}

export class GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto {
    configuration!: DocumentationConfigurationDto;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new DocumentationConfigurationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? DocumentationConfigurationDto.fromJS(_data["configuration"]) : new DocumentationConfigurationDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsWetSignatureDetailsDto {
    configuration: DocumentationConfigurationDto;
}

export class SaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto implements ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto {
    id!: number;
    versionNumber!: number;
    companyId!: number;
    digitalSignatureType!: DraftApplicationFormDocumentationDigitalSignatureTypeEnum;
    clientOffsetMinutes!: number;
    poaLocation?: string | undefined;
    poaPosition?: string | undefined;
    isPoaPreviouslyProvided?: boolean | undefined;
    poaDate?: Date | undefined;
    poaDateOffsetMinutes?: number | undefined;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.companyId = _data["companyId"];
            this.digitalSignatureType = _data["digitalSignatureType"];
            this.clientOffsetMinutes = _data["clientOffsetMinutes"];
            this.poaLocation = _data["poaLocation"];
            this.poaPosition = _data["poaPosition"];
            this.isPoaPreviouslyProvided = _data["isPoaPreviouslyProvided"];
            this.poaDate = _data["poaDate"] ? new Date(_data["poaDate"].toString()) : <any>undefined;
            this.poaDateOffsetMinutes = _data["poaDateOffsetMinutes"];
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["companyId"] = this.companyId;
        data["digitalSignatureType"] = this.digitalSignatureType;
        data["clientOffsetMinutes"] = this.clientOffsetMinutes;
        data["poaLocation"] = this.poaLocation;
        data["poaPosition"] = this.poaPosition;
        data["isPoaPreviouslyProvided"] = this.isPoaPreviouslyProvided;
        data["poaDate"] = this.poaDate ? this.poaDate.toISOString() : <any>undefined;
        data["poaDateOffsetMinutes"] = this.poaDateOffsetMinutes;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureRequestDto {
    id: number;
    versionNumber: number;
    companyId: number;
    digitalSignatureType: DraftApplicationFormDocumentationDigitalSignatureTypeEnum;
    clientOffsetMinutes: number;
    poaLocation?: string | undefined;
    poaPosition?: string | undefined;
    isPoaPreviouslyProvided?: boolean | undefined;
    poaDate?: Date | undefined;
    poaDateOffsetMinutes?: number | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto implements ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsDigitalSignatureResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto implements ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto {
    id!: number;
    versionNumber!: number;
    fileIds?: number[] | undefined;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationRequestDto {
    id: number;
    versionNumber: number;
    fileIds?: number[] | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto implements ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsWetFormDocumentationResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto implements IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingRequestDto {
    id: number;
    versionNumber: number;
}

export class RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto implements IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRevertCompanyCommonDraftApplicationDetailsDraftApplicationToPreparingResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsPayingResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto implements ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyCommonDraftApplicationDetailsDraftApplicationAsReadyForSubmissionResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto implements IGetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
    id!: number;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
    id: number;
}

export class GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto implements IGetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
    versionNumber!: number;
    signatureType?: GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto[] | undefined;
    isPreparing!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.signatureType = _data["signatureType"] ? GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto.fromJS(_data["signatureType"]) : <any>undefined;
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto.fromJS(item));
            }
            this.isPreparing = _data["isPreparing"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["signatureType"] = this.signatureType ? this.signatureType.toJSON() : <any>undefined;
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        data["isPreparing"] = this.isPreparing;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
    versionNumber: number;
    signatureType?: GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto | undefined;
    availableSignatureTypes?: GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto[] | undefined;
    isPreparing: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto implements IGetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto {
    signatureType!: DraftApplicationFormDocumentationSignatureTypeEnum;
    description?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signatureType = _data["signatureType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signatureType"] = this.signatureType;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsSignatureTypeItemDto {
    signatureType: DraftApplicationFormDocumentationSignatureTypeEnum;
    description?: string | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto implements ISaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
    id!: number;
    versionNumber!: number;
    signatureType!: DraftApplicationFormDocumentationSignatureTypeEnum;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.signatureType = _data["signatureType"];
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["signatureType"] = this.signatureType;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSignatureTypeRequestDto {
    id: number;
    versionNumber: number;
    signatureType: DraftApplicationFormDocumentationSignatureTypeEnum;
}

export class SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto implements ISaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSignatureTypeResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto implements ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto implements ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyCommonDraftApplicationDetailsDraftApplicationToNoptaResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto implements IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
    id!: number;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
    id: number;
}

export class GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto implements IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
    versionNumber!: number;
    files!: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto[];
    checklistItems!: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto[];
    suppliedOfflineDetails!: SupportingDocumentationSuppliedOfflineDetailsDto;
    canSupplyOffline!: boolean;
    canSetSensitivity!: boolean;
    partnerCompanies!: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto[];
    sensitiveToCompanies!: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto[];
    isComplete!: boolean;
    configuration!: DocumentationConfigurationDto;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
            this.checklistItems = [];
            this.suppliedOfflineDetails = new SupportingDocumentationSuppliedOfflineDetailsDto();
            this.partnerCompanies = [];
            this.sensitiveToCompanies = [];
            this.configuration = new DocumentationConfigurationDto();
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto.fromJS(item));
            }
            if (Array.isArray(_data["checklistItems"])) {
                this.checklistItems = [] as any;
                for (let item of _data["checklistItems"])
                    this.checklistItems!.push(GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto.fromJS(item));
            }
            this.suppliedOfflineDetails = _data["suppliedOfflineDetails"] ? SupportingDocumentationSuppliedOfflineDetailsDto.fromJS(_data["suppliedOfflineDetails"]) : new SupportingDocumentationSuppliedOfflineDetailsDto();
            this.canSupplyOffline = _data["canSupplyOffline"];
            this.canSetSensitivity = _data["canSetSensitivity"];
            if (Array.isArray(_data["partnerCompanies"])) {
                this.partnerCompanies = [] as any;
                for (let item of _data["partnerCompanies"])
                    this.partnerCompanies!.push(GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto.fromJS(item));
            }
            if (Array.isArray(_data["sensitiveToCompanies"])) {
                this.sensitiveToCompanies = [] as any;
                for (let item of _data["sensitiveToCompanies"])
                    this.sensitiveToCompanies!.push(GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto.fromJS(item));
            }
            this.isComplete = _data["isComplete"];
            this.configuration = _data["configuration"] ? DocumentationConfigurationDto.fromJS(_data["configuration"]) : new DocumentationConfigurationDto();
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.checklistItems)) {
            data["checklistItems"] = [];
            for (let item of this.checklistItems)
                data["checklistItems"].push(item.toJSON());
        }
        data["suppliedOfflineDetails"] = this.suppliedOfflineDetails ? this.suppliedOfflineDetails.toJSON() : <any>undefined;
        data["canSupplyOffline"] = this.canSupplyOffline;
        data["canSetSensitivity"] = this.canSetSensitivity;
        if (Array.isArray(this.partnerCompanies)) {
            data["partnerCompanies"] = [];
            for (let item of this.partnerCompanies)
                data["partnerCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.sensitiveToCompanies)) {
            data["sensitiveToCompanies"] = [];
            for (let item of this.sensitiveToCompanies)
                data["sensitiveToCompanies"].push(item.toJSON());
        }
        data["isComplete"] = this.isComplete;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
    versionNumber: number;
    files: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto[];
    checklistItems: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto[];
    suppliedOfflineDetails: SupportingDocumentationSuppliedOfflineDetailsDto;
    canSupplyOffline: boolean;
    canSetSensitivity: boolean;
    partnerCompanies: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto[];
    sensitiveToCompanies: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto[];
    isComplete: boolean;
    configuration: DocumentationConfigurationDto;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto implements IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
    type!: DraftApplicationSupportingDocumentationChecklistItemTypeEnum;
    isChecked!: boolean;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isChecked"] = this.isChecked;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
    type: DraftApplicationSupportingDocumentationChecklistItemTypeEnum;
    isChecked: boolean;
}

export class GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto implements IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto {
    fileId!: number;
    fileName!: string;
    fileSize!: number;
    uploadedDatetime!: Date;
    sensitiveToCompany!: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto;
    canDownload!: boolean;
    canManage!: boolean;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sensitiveToCompany = new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadedDatetime = _data["uploadedDatetime"] ? new Date(_data["uploadedDatetime"].toString()) : <any>undefined;
            this.sensitiveToCompany = _data["sensitiveToCompany"] ? GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto.fromJS(_data["sensitiveToCompany"]) : new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto();
            this.canDownload = _data["canDownload"];
            this.canManage = _data["canManage"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadedDatetime"] = this.uploadedDatetime ? this.uploadedDatetime.toISOString() : <any>undefined;
        data["sensitiveToCompany"] = this.sensitiveToCompany ? this.sensitiveToCompany.toJSON() : <any>undefined;
        data["canDownload"] = this.canDownload;
        data["canManage"] = this.canManage;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationFileDto {
    fileId: number;
    fileName: string;
    fileSize: number;
    uploadedDatetime: Date;
    sensitiveToCompany: GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto;
    canDownload: boolean;
    canManage: boolean;
}

export class GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto implements IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto {
    companyId!: number;
    companyName?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationPartnerCompanyDto {
    companyId: number;
    companyName?: string | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto implements IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto {
    companyId!: number;
    displayName?: string | undefined;
    editName?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.displayName = _data["displayName"];
            this.editName = _data["editName"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["displayName"] = this.displayName;
        data["editName"] = this.editName;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsSupportingDocumentationSensitiveToCompanyDto {
    companyId: number;
    displayName?: string | undefined;
    editName?: string | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto implements ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
    type!: DraftApplicationSupportingDocumentationChecklistItemTypeEnum;
    isChecked!: boolean;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isChecked"] = this.isChecked;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto {
    type: DraftApplicationSupportingDocumentationChecklistItemTypeEnum;
    isChecked: boolean;
}

export class SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto implements ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto {
    fileId!: number;
    sensitiveToCompanyId?: number | undefined;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.sensitiveToCompanyId = _data["sensitiveToCompanyId"];
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["sensitiveToCompanyId"] = this.sensitiveToCompanyId;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto {
    fileId: number;
    sensitiveToCompanyId?: number | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto implements ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
    id!: number;
    versionNumber!: number;
    addedFiles?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto[] | undefined;
    modifiedFiles?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto[] | undefined;
    deletedFileIds?: number[] | undefined;
    checklistItems?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto[] | undefined;
    suppliedOfflineDetails?: SupportingDocumentationSuppliedOfflineDetailsDto | undefined;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedFiles"])) {
                this.modifiedFiles = [] as any;
                for (let item of _data["modifiedFiles"])
                    this.modifiedFiles!.push(SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto.fromJS(item));
            }
            if (Array.isArray(_data["deletedFileIds"])) {
                this.deletedFileIds = [] as any;
                for (let item of _data["deletedFileIds"])
                    this.deletedFileIds!.push(item);
            }
            if (Array.isArray(_data["checklistItems"])) {
                this.checklistItems = [] as any;
                for (let item of _data["checklistItems"])
                    this.checklistItems!.push(SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto.fromJS(item));
            }
            this.suppliedOfflineDetails = _data["suppliedOfflineDetails"] ? SupportingDocumentationSuppliedOfflineDetailsDto.fromJS(_data["suppliedOfflineDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.modifiedFiles)) {
            data["modifiedFiles"] = [];
            for (let item of this.modifiedFiles)
                data["modifiedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedFileIds)) {
            data["deletedFileIds"] = [];
            for (let item of this.deletedFileIds)
                data["deletedFileIds"].push(item);
        }
        if (Array.isArray(this.checklistItems)) {
            data["checklistItems"] = [];
            for (let item of this.checklistItems)
                data["checklistItems"].push(item.toJSON());
        }
        data["suppliedOfflineDetails"] = this.suppliedOfflineDetails ? this.suppliedOfflineDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationRequestDto {
    id: number;
    versionNumber: number;
    addedFiles?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto[] | undefined;
    modifiedFiles?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationFileDto[] | undefined;
    deletedFileIds?: number[] | undefined;
    checklistItems?: SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationChecklistItemDto[] | undefined;
    suppliedOfflineDetails?: SupportingDocumentationSuppliedOfflineDetailsDto | undefined;
}

export class SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto implements ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyCommonDraftApplicationDetailsSupportingDocumentationResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CompanyFinanceFnListDetailDto implements ICompanyFinanceFnListDetailDto {
    financialNotificationLink!: FinancialNotificationLinkDto;
    versionNumber!: number;
    financialNotificationDueDate!: Date;
    isDueWithinSevenDays!: boolean;
    isOverdue!: boolean;
    isAwaitingConfirmation!: boolean;
    financialNotificationIssueDate!: Date;
    financialNotificationStatus?: string | undefined;
    financialNotificationType?: string | undefined;
    totalAmount!: number;
    outstandingAmount!: number;
    paymentConfirmationDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    act!: ActEnum;
    titleLicenceNumber?: string | undefined;
    titleLink?: TitleLinkDto | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    companyId!: number;
    companyName?: string | undefined;
    draftApplicationLink?: DraftApplicationLinkDto | undefined;
    applicationLink?: ApplicationLinkDto | undefined;
    trackingNumberDisplay?: string | undefined;

    constructor(data?: ICompanyFinanceFnListDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.financialNotificationLink = new FinancialNotificationLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationLink = _data["financialNotificationLink"] ? FinancialNotificationLinkDto.fromJS(_data["financialNotificationLink"]) : new FinancialNotificationLinkDto();
            this.versionNumber = _data["versionNumber"];
            this.financialNotificationDueDate = _data["financialNotificationDueDate"] ? new Date(_data["financialNotificationDueDate"].toString()) : <any>undefined;
            this.isDueWithinSevenDays = _data["isDueWithinSevenDays"];
            this.isOverdue = _data["isOverdue"];
            this.isAwaitingConfirmation = _data["isAwaitingConfirmation"];
            this.financialNotificationIssueDate = _data["financialNotificationIssueDate"] ? new Date(_data["financialNotificationIssueDate"].toString()) : <any>undefined;
            this.financialNotificationStatus = _data["financialNotificationStatus"];
            this.financialNotificationType = _data["financialNotificationType"];
            this.totalAmount = _data["totalAmount"];
            this.outstandingAmount = _data["outstandingAmount"];
            this.paymentConfirmationDate = _data["paymentConfirmationDate"] ? new Date(_data["paymentConfirmationDate"].toString()) : <any>undefined;
            this.anniversaryDate = _data["anniversaryDate"] ? new Date(_data["anniversaryDate"].toString()) : <any>undefined;
            this.act = _data["act"];
            this.titleLicenceNumber = _data["titleLicenceNumber"];
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : <any>undefined;
            this.licenceLink = _data["licenceLink"] ? LicenceLinkDto.fromJS(_data["licenceLink"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.draftApplicationLink = _data["draftApplicationLink"] ? DraftApplicationLinkDto.fromJS(_data["draftApplicationLink"]) : <any>undefined;
            this.applicationLink = _data["applicationLink"] ? ApplicationLinkDto.fromJS(_data["applicationLink"]) : <any>undefined;
            this.trackingNumberDisplay = _data["trackingNumberDisplay"];
        }
    }

    static fromJS(data: any): CompanyFinanceFnListDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyFinanceFnListDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationLink"] = this.financialNotificationLink ? this.financialNotificationLink.toJSON() : <any>undefined;
        data["versionNumber"] = this.versionNumber;
        data["financialNotificationDueDate"] = this.financialNotificationDueDate ? this.financialNotificationDueDate.toISOString() : <any>undefined;
        data["isDueWithinSevenDays"] = this.isDueWithinSevenDays;
        data["isOverdue"] = this.isOverdue;
        data["isAwaitingConfirmation"] = this.isAwaitingConfirmation;
        data["financialNotificationIssueDate"] = this.financialNotificationIssueDate ? this.financialNotificationIssueDate.toISOString() : <any>undefined;
        data["financialNotificationStatus"] = this.financialNotificationStatus;
        data["financialNotificationType"] = this.financialNotificationType;
        data["totalAmount"] = this.totalAmount;
        data["outstandingAmount"] = this.outstandingAmount;
        data["paymentConfirmationDate"] = this.paymentConfirmationDate ? this.paymentConfirmationDate.toISOString() : <any>undefined;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["act"] = this.act;
        data["titleLicenceNumber"] = this.titleLicenceNumber;
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["draftApplicationLink"] = this.draftApplicationLink ? this.draftApplicationLink.toJSON() : <any>undefined;
        data["applicationLink"] = this.applicationLink ? this.applicationLink.toJSON() : <any>undefined;
        data["trackingNumberDisplay"] = this.trackingNumberDisplay;
        return data;
    }
}

export interface ICompanyFinanceFnListDetailDto {
    financialNotificationLink: FinancialNotificationLinkDto;
    versionNumber: number;
    financialNotificationDueDate: Date;
    isDueWithinSevenDays: boolean;
    isOverdue: boolean;
    isAwaitingConfirmation: boolean;
    financialNotificationIssueDate: Date;
    financialNotificationStatus?: string | undefined;
    financialNotificationType?: string | undefined;
    totalAmount: number;
    outstandingAmount: number;
    paymentConfirmationDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    act: ActEnum;
    titleLicenceNumber?: string | undefined;
    titleLink?: TitleLinkDto | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    companyId: number;
    companyName?: string | undefined;
    draftApplicationLink?: DraftApplicationLinkDto | undefined;
    applicationLink?: ApplicationLinkDto | undefined;
    trackingNumberDisplay?: string | undefined;
}

export class GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto implements IGetCompanyFinanceCreditCardSurchargeFinancialNotificationDto {
    financialNotificationId!: number;
    versionNumber!: number;

    constructor(data?: IGetCompanyFinanceCreditCardSurchargeFinancialNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IGetCompanyFinanceCreditCardSurchargeFinancialNotificationDto {
    financialNotificationId: number;
    versionNumber: number;
}

export class GetCompanyFinanceCreditCardSurchargeRequestDto implements IGetCompanyFinanceCreditCardSurchargeRequestDto {
    financialNotifications?: GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto[] | undefined;
    secureTransactionToken?: string | undefined;

    constructor(data?: IGetCompanyFinanceCreditCardSurchargeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["financialNotifications"])) {
                this.financialNotifications = [] as any;
                for (let item of _data["financialNotifications"])
                    this.financialNotifications!.push(GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto.fromJS(item));
            }
            this.secureTransactionToken = _data["secureTransactionToken"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceCreditCardSurchargeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceCreditCardSurchargeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.financialNotifications)) {
            data["financialNotifications"] = [];
            for (let item of this.financialNotifications)
                data["financialNotifications"].push(item.toJSON());
        }
        data["secureTransactionToken"] = this.secureTransactionToken;
        return data;
    }
}

export interface IGetCompanyFinanceCreditCardSurchargeRequestDto {
    financialNotifications?: GetCompanyFinanceCreditCardSurchargeFinancialNotificationDto[] | undefined;
    secureTransactionToken?: string | undefined;
}

export class GetCompanyFinanceCreditCardSurchargeResponseDto implements IGetCompanyFinanceCreditCardSurchargeResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    cardType?: string | undefined;
    surchargeAmount?: number | undefined;
    surchargePercentage?: number | undefined;

    constructor(data?: IGetCompanyFinanceCreditCardSurchargeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.cardType = _data["cardType"];
            this.surchargeAmount = _data["surchargeAmount"];
            this.surchargePercentage = _data["surchargePercentage"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceCreditCardSurchargeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceCreditCardSurchargeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["cardType"] = this.cardType;
        data["surchargeAmount"] = this.surchargeAmount;
        data["surchargePercentage"] = this.surchargePercentage;
        return data;
    }
}

export interface IGetCompanyFinanceCreditCardSurchargeResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    cardType?: string | undefined;
    surchargeAmount?: number | undefined;
    surchargePercentage?: number | undefined;
}

export class CreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto implements ICreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto {
    financialNotificationId!: number;
    versionNumber!: number;
    secureTransactionToken?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
            this.versionNumber = _data["versionNumber"];
            this.secureTransactionToken = _data["secureTransactionToken"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        data["versionNumber"] = this.versionNumber;
        data["secureTransactionToken"] = this.secureTransactionToken;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCompanyFinanceFnDetailsCreditCardPaymentRequestDto {
    financialNotificationId: number;
    versionNumber: number;
    secureTransactionToken?: string | undefined;
    comments?: string | undefined;
}

export class CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto implements ICreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ICreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyFinanceFnDetailsCreditCardPaymentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class CreateCompanyFinanceFnDetailsPaymentRequestDto implements ICreateCompanyFinanceFnDetailsPaymentRequestDto {
    financialNotificationId!: number;
    versionNumber!: number;
    paymentMethod!: Payment2MethodEnum;
    paymentDate!: Date;
    paymentDateOffsetMinutes!: number;
    receivedAmount!: number;
    bankName?: string | undefined;
    bankReceiptNumber?: string | undefined;
    chequeNumber?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateCompanyFinanceFnDetailsPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
            this.versionNumber = _data["versionNumber"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentDateOffsetMinutes = _data["paymentDateOffsetMinutes"];
            this.receivedAmount = _data["receivedAmount"];
            this.bankName = _data["bankName"];
            this.bankReceiptNumber = _data["bankReceiptNumber"];
            this.chequeNumber = _data["chequeNumber"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnDetailsPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnDetailsPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        data["versionNumber"] = this.versionNumber;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentDateOffsetMinutes"] = this.paymentDateOffsetMinutes;
        data["receivedAmount"] = this.receivedAmount;
        data["bankName"] = this.bankName;
        data["bankReceiptNumber"] = this.bankReceiptNumber;
        data["chequeNumber"] = this.chequeNumber;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCompanyFinanceFnDetailsPaymentRequestDto {
    financialNotificationId: number;
    versionNumber: number;
    paymentMethod: Payment2MethodEnum;
    paymentDate: Date;
    paymentDateOffsetMinutes: number;
    receivedAmount: number;
    bankName?: string | undefined;
    bankReceiptNumber?: string | undefined;
    chequeNumber?: string | undefined;
    comments?: string | undefined;
}

export class CreateCompanyFinanceFnDetailsPaymentResponseDto implements ICreateCompanyFinanceFnDetailsPaymentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ICreateCompanyFinanceFnDetailsPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnDetailsPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnDetailsPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyFinanceFnDetailsPaymentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class GetCompanyFinanceFnDetailsRequestDto implements IGetCompanyFinanceFnDetailsRequestDto {
    financialNotificationId!: number;

    constructor(data?: IGetCompanyFinanceFnDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceFnDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        return data;
    }
}

export interface IGetCompanyFinanceFnDetailsRequestDto {
    financialNotificationId: number;
}

export class GetCompanyFinanceFnDetailsResponseDocumentDto implements IGetCompanyFinanceFnDetailsResponseDocumentDto {
    fileId!: number;
    documentId!: number;
    documentName?: string | undefined;
    documentType!: AlfDocumentTypeEnum;

    constructor(data?: IGetCompanyFinanceFnDetailsResponseDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceFnDetailsResponseDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnDetailsResponseDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface IGetCompanyFinanceFnDetailsResponseDocumentDto {
    fileId: number;
    documentId: number;
    documentName?: string | undefined;
    documentType: AlfDocumentTypeEnum;
}

export class GetCompanyFinanceFnDetailsResponseDto implements IGetCompanyFinanceFnDetailsResponseDto {
    financialNotificationId!: number;
    versionNumber!: number;
    act!: ActEnum;
    financialNotificationTypeEnum!: FinancialNotificationTypeEnum;
    financialNotificationTypeDisplay?: string | undefined;
    financialNotificationStatus?: string | undefined;
    canPay!: boolean;
    isComplete!: boolean;
    financialNotificationCode?: string | undefined;
    financialNotificationIssueDatetime!: Date;
    financialNotificationDueDate!: Date;
    totalAmount!: number;
    outstandingAmount!: number;
    lateFinancialNotificationLink?: FinancialNotificationLinkDto | undefined;
    applicationLink?: ApplicationLinkDto | undefined;
    draftApplicationLink?: DraftApplicationLinkDto | undefined;
    titleLink?: TitleLinkDto | undefined;
    titleType?: string | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    licenceType?: string | undefined;
    anniversaryDate?: Date | undefined;
    anniversaryPeriodStart?: Date | undefined;
    anniversaryPeriodEnd?: Date | undefined;
    companyId!: number;
    companyName?: string | undefined;
    paymentReferences!: GetCompanyFinanceFnDetailsResponsePaymentDto[];
    notificationDocument?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    paymentStatement?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    creditCardReceipt?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetCompanyFinanceFnDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paymentReferences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
            this.versionNumber = _data["versionNumber"];
            this.act = _data["act"];
            this.financialNotificationTypeEnum = _data["financialNotificationTypeEnum"];
            this.financialNotificationTypeDisplay = _data["financialNotificationTypeDisplay"];
            this.financialNotificationStatus = _data["financialNotificationStatus"];
            this.canPay = _data["canPay"];
            this.isComplete = _data["isComplete"];
            this.financialNotificationCode = _data["financialNotificationCode"];
            this.financialNotificationIssueDatetime = _data["financialNotificationIssueDatetime"] ? new Date(_data["financialNotificationIssueDatetime"].toString()) : <any>undefined;
            this.financialNotificationDueDate = _data["financialNotificationDueDate"] ? new Date(_data["financialNotificationDueDate"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.outstandingAmount = _data["outstandingAmount"];
            this.lateFinancialNotificationLink = _data["lateFinancialNotificationLink"] ? FinancialNotificationLinkDto.fromJS(_data["lateFinancialNotificationLink"]) : <any>undefined;
            this.applicationLink = _data["applicationLink"] ? ApplicationLinkDto.fromJS(_data["applicationLink"]) : <any>undefined;
            this.draftApplicationLink = _data["draftApplicationLink"] ? DraftApplicationLinkDto.fromJS(_data["draftApplicationLink"]) : <any>undefined;
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : <any>undefined;
            this.titleType = _data["titleType"];
            this.licenceLink = _data["licenceLink"] ? LicenceLinkDto.fromJS(_data["licenceLink"]) : <any>undefined;
            this.licenceType = _data["licenceType"];
            this.anniversaryDate = _data["anniversaryDate"] ? new Date(_data["anniversaryDate"].toString()) : <any>undefined;
            this.anniversaryPeriodStart = _data["anniversaryPeriodStart"] ? new Date(_data["anniversaryPeriodStart"].toString()) : <any>undefined;
            this.anniversaryPeriodEnd = _data["anniversaryPeriodEnd"] ? new Date(_data["anniversaryPeriodEnd"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["paymentReferences"])) {
                this.paymentReferences = [] as any;
                for (let item of _data["paymentReferences"])
                    this.paymentReferences!.push(GetCompanyFinanceFnDetailsResponsePaymentDto.fromJS(item));
            }
            this.notificationDocument = _data["notificationDocument"] ? GetCompanyFinanceFnDetailsResponseDocumentDto.fromJS(_data["notificationDocument"]) : <any>undefined;
            this.paymentStatement = _data["paymentStatement"] ? GetCompanyFinanceFnDetailsResponseDocumentDto.fromJS(_data["paymentStatement"]) : <any>undefined;
            this.creditCardReceipt = _data["creditCardReceipt"] ? GetCompanyFinanceFnDetailsResponseDocumentDto.fromJS(_data["creditCardReceipt"]) : <any>undefined;
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyFinanceFnDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        data["versionNumber"] = this.versionNumber;
        data["act"] = this.act;
        data["financialNotificationTypeEnum"] = this.financialNotificationTypeEnum;
        data["financialNotificationTypeDisplay"] = this.financialNotificationTypeDisplay;
        data["financialNotificationStatus"] = this.financialNotificationStatus;
        data["canPay"] = this.canPay;
        data["isComplete"] = this.isComplete;
        data["financialNotificationCode"] = this.financialNotificationCode;
        data["financialNotificationIssueDatetime"] = this.financialNotificationIssueDatetime ? this.financialNotificationIssueDatetime.toISOString() : <any>undefined;
        data["financialNotificationDueDate"] = this.financialNotificationDueDate ? this.financialNotificationDueDate.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["outstandingAmount"] = this.outstandingAmount;
        data["lateFinancialNotificationLink"] = this.lateFinancialNotificationLink ? this.lateFinancialNotificationLink.toJSON() : <any>undefined;
        data["applicationLink"] = this.applicationLink ? this.applicationLink.toJSON() : <any>undefined;
        data["draftApplicationLink"] = this.draftApplicationLink ? this.draftApplicationLink.toJSON() : <any>undefined;
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["titleType"] = this.titleType;
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        data["licenceType"] = this.licenceType;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["anniversaryPeriodStart"] = this.anniversaryPeriodStart ? this.anniversaryPeriodStart.toISOString() : <any>undefined;
        data["anniversaryPeriodEnd"] = this.anniversaryPeriodEnd ? this.anniversaryPeriodEnd.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.paymentReferences)) {
            data["paymentReferences"] = [];
            for (let item of this.paymentReferences)
                data["paymentReferences"].push(item.toJSON());
        }
        data["notificationDocument"] = this.notificationDocument ? this.notificationDocument.toJSON() : <any>undefined;
        data["paymentStatement"] = this.paymentStatement ? this.paymentStatement.toJSON() : <any>undefined;
        data["creditCardReceipt"] = this.creditCardReceipt ? this.creditCardReceipt.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyFinanceFnDetailsResponseDto {
    financialNotificationId: number;
    versionNumber: number;
    act: ActEnum;
    financialNotificationTypeEnum: FinancialNotificationTypeEnum;
    financialNotificationTypeDisplay?: string | undefined;
    financialNotificationStatus?: string | undefined;
    canPay: boolean;
    isComplete: boolean;
    financialNotificationCode?: string | undefined;
    financialNotificationIssueDatetime: Date;
    financialNotificationDueDate: Date;
    totalAmount: number;
    outstandingAmount: number;
    lateFinancialNotificationLink?: FinancialNotificationLinkDto | undefined;
    applicationLink?: ApplicationLinkDto | undefined;
    draftApplicationLink?: DraftApplicationLinkDto | undefined;
    titleLink?: TitleLinkDto | undefined;
    titleType?: string | undefined;
    licenceLink?: LicenceLinkDto | undefined;
    licenceType?: string | undefined;
    anniversaryDate?: Date | undefined;
    anniversaryPeriodStart?: Date | undefined;
    anniversaryPeriodEnd?: Date | undefined;
    companyId: number;
    companyName?: string | undefined;
    paymentReferences: GetCompanyFinanceFnDetailsResponsePaymentDto[];
    notificationDocument?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    paymentStatement?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    creditCardReceipt?: GetCompanyFinanceFnDetailsResponseDocumentDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetCompanyFinanceFnDetailsResponsePaymentDto implements IGetCompanyFinanceFnDetailsResponsePaymentDto {
    paymentId!: number;
    paymentCode?: string | undefined;

    constructor(data?: IGetCompanyFinanceFnDetailsResponsePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.paymentCode = _data["paymentCode"];
        }
    }

    static fromJS(data: any): GetCompanyFinanceFnDetailsResponsePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnDetailsResponsePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["paymentCode"] = this.paymentCode;
        return data;
    }
}

export interface IGetCompanyFinanceFnDetailsResponsePaymentDto {
    paymentId: number;
    paymentCode?: string | undefined;
}

export class CreateCompanyFinanceFnListCreditCardPaymentRequestDto implements ICreateCompanyFinanceFnListCreditCardPaymentRequestDto {
    allocatedFinancialNotifications?: AllocatedFinancialNotificationDetailsDto[] | undefined;
    secureTransactionToken?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateCompanyFinanceFnListCreditCardPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allocatedFinancialNotifications"])) {
                this.allocatedFinancialNotifications = [] as any;
                for (let item of _data["allocatedFinancialNotifications"])
                    this.allocatedFinancialNotifications!.push(AllocatedFinancialNotificationDetailsDto.fromJS(item));
            }
            this.secureTransactionToken = _data["secureTransactionToken"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnListCreditCardPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnListCreditCardPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allocatedFinancialNotifications)) {
            data["allocatedFinancialNotifications"] = [];
            for (let item of this.allocatedFinancialNotifications)
                data["allocatedFinancialNotifications"].push(item.toJSON());
        }
        data["secureTransactionToken"] = this.secureTransactionToken;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCompanyFinanceFnListCreditCardPaymentRequestDto {
    allocatedFinancialNotifications?: AllocatedFinancialNotificationDetailsDto[] | undefined;
    secureTransactionToken?: string | undefined;
    comments?: string | undefined;
}

export class CreateCompanyFinanceFnListCreditCardPaymentResponseDto implements ICreateCompanyFinanceFnListCreditCardPaymentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyFinanceFnListCreditCardPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyFinanceFnListCreditCardPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyFinanceFnListCreditCardPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyFinanceFnListCreditCardPaymentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyFinanceFnListRequestDto implements IGetCompanyFinanceFnListRequestDto {

    constructor(data?: IGetCompanyFinanceFnListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyFinanceFnListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyFinanceFnListRequestDto {
}

export class GetCompanyFinanceFnListResponseDto implements IGetCompanyFinanceFnListResponseDto {
    financialNotificationsAwaitingConfirmation!: CompanyFinanceFnListDetailDto[];
    financialNotificationsRequiringPayment!: CompanyFinanceFnListDetailDto[];

    constructor(data?: IGetCompanyFinanceFnListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.financialNotificationsAwaitingConfirmation = [];
            this.financialNotificationsRequiringPayment = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["financialNotificationsAwaitingConfirmation"])) {
                this.financialNotificationsAwaitingConfirmation = [] as any;
                for (let item of _data["financialNotificationsAwaitingConfirmation"])
                    this.financialNotificationsAwaitingConfirmation!.push(CompanyFinanceFnListDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["financialNotificationsRequiringPayment"])) {
                this.financialNotificationsRequiringPayment = [] as any;
                for (let item of _data["financialNotificationsRequiringPayment"])
                    this.financialNotificationsRequiringPayment!.push(CompanyFinanceFnListDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyFinanceFnListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinanceFnListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.financialNotificationsAwaitingConfirmation)) {
            data["financialNotificationsAwaitingConfirmation"] = [];
            for (let item of this.financialNotificationsAwaitingConfirmation)
                data["financialNotificationsAwaitingConfirmation"].push(item.toJSON());
        }
        if (Array.isArray(this.financialNotificationsRequiringPayment)) {
            data["financialNotificationsRequiringPayment"] = [];
            for (let item of this.financialNotificationsRequiringPayment)
                data["financialNotificationsRequiringPayment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyFinanceFnListResponseDto {
    financialNotificationsAwaitingConfirmation: CompanyFinanceFnListDetailDto[];
    financialNotificationsRequiringPayment: CompanyFinanceFnListDetailDto[];
}

export class GetCompanyFinancePaymentHistoryListRequestDto implements IGetCompanyFinancePaymentHistoryListRequestDto {

    constructor(data?: IGetCompanyFinancePaymentHistoryListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyFinancePaymentHistoryListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinancePaymentHistoryListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyFinancePaymentHistoryListRequestDto {
}

export class GetCompanyFinancePaymentHistoryListResponseDto implements IGetCompanyFinancePaymentHistoryListResponseDto {
    financialNotifications!: CompanyFinanceFnListDetailDto[];

    constructor(data?: IGetCompanyFinancePaymentHistoryListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.financialNotifications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["financialNotifications"])) {
                this.financialNotifications = [] as any;
                for (let item of _data["financialNotifications"])
                    this.financialNotifications!.push(CompanyFinanceFnListDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyFinancePaymentHistoryListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyFinancePaymentHistoryListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.financialNotifications)) {
            data["financialNotifications"] = [];
            for (let item of this.financialNotifications)
                data["financialNotifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyFinancePaymentHistoryListResponseDto {
    financialNotifications: CompanyFinanceFnListDetailDto[];
}

export class GetCompanyHomeDashboardRequestDto implements IGetCompanyHomeDashboardRequestDto {

    constructor(data?: IGetCompanyHomeDashboardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyHomeDashboardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyHomeDashboardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyHomeDashboardRequestDto {
}

export class GetCompanyHomeDashboardResponseDto implements IGetCompanyHomeDashboardResponseDto {
    hasAssociatedCompanies!: boolean;
    isApplicationsTileVisible!: boolean;
    isFinancialNotificationsTileVisible!: boolean;
    isTitlesTileVisible!: boolean;
    applications?: CompanyApplicationListItemDto[] | undefined;
    financialNotifications?: CompanyFinanceFnListDetailDto[] | undefined;
    titles?: GetCompanyHomeDashboardResponseTitleDto[] | undefined;

    constructor(data?: IGetCompanyHomeDashboardResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAssociatedCompanies = _data["hasAssociatedCompanies"];
            this.isApplicationsTileVisible = _data["isApplicationsTileVisible"];
            this.isFinancialNotificationsTileVisible = _data["isFinancialNotificationsTileVisible"];
            this.isTitlesTileVisible = _data["isTitlesTileVisible"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(CompanyApplicationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["financialNotifications"])) {
                this.financialNotifications = [] as any;
                for (let item of _data["financialNotifications"])
                    this.financialNotifications!.push(CompanyFinanceFnListDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetCompanyHomeDashboardResponseTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyHomeDashboardResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyHomeDashboardResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssociatedCompanies"] = this.hasAssociatedCompanies;
        data["isApplicationsTileVisible"] = this.isApplicationsTileVisible;
        data["isFinancialNotificationsTileVisible"] = this.isFinancialNotificationsTileVisible;
        data["isTitlesTileVisible"] = this.isTitlesTileVisible;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.financialNotifications)) {
            data["financialNotifications"] = [];
            for (let item of this.financialNotifications)
                data["financialNotifications"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyHomeDashboardResponseDto {
    hasAssociatedCompanies: boolean;
    isApplicationsTileVisible: boolean;
    isFinancialNotificationsTileVisible: boolean;
    isTitlesTileVisible: boolean;
    applications?: CompanyApplicationListItemDto[] | undefined;
    financialNotifications?: CompanyFinanceFnListDetailDto[] | undefined;
    titles?: GetCompanyHomeDashboardResponseTitleDto[] | undefined;
}

export class GetCompanyHomeDashboardResponseTitleDto implements IGetCompanyHomeDashboardResponseTitleDto {
    titleLink!: TitleLinkDto;
    titleTypeDisplay?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    titleHoldersDisplay?: string | undefined;

    constructor(data?: IGetCompanyHomeDashboardResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLink = new TitleLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : new TitleLinkDto();
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.titleStatus = _data["titleStatus"];
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.anniversaryDate = _data["anniversaryDate"] ? new Date(_data["anniversaryDate"].toString()) : <any>undefined;
            this.titleHoldersDisplay = _data["titleHoldersDisplay"];
        }
    }

    static fromJS(data: any): GetCompanyHomeDashboardResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyHomeDashboardResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["titleStatus"] = this.titleStatus;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["titleHoldersDisplay"] = this.titleHoldersDisplay;
        return data;
    }
}

export interface IGetCompanyHomeDashboardResponseTitleDto {
    titleLink: TitleLinkDto;
    titleTypeDisplay?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    titleHoldersDisplay?: string | undefined;
}

export class GetCompanyOeiApplicationListRequestDto implements IGetCompanyOeiApplicationListRequestDto {
    inProgressOnly!: boolean;

    constructor(data?: IGetCompanyOeiApplicationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressOnly = _data["inProgressOnly"];
        }
    }

    static fromJS(data: any): GetCompanyOeiApplicationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiApplicationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressOnly"] = this.inProgressOnly;
        return data;
    }
}

export interface IGetCompanyOeiApplicationListRequestDto {
    inProgressOnly: boolean;
}

export class GetCompanyOeiApplicationListResponseDto implements IGetCompanyOeiApplicationListResponseDto {
    applications?: CompanyApplicationListItemDto[] | undefined;

    constructor(data?: IGetCompanyOeiApplicationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(CompanyApplicationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiApplicationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiApplicationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiApplicationListResponseDto {
    applications?: CompanyApplicationListItemDto[] | undefined;
}

export class CreateCompanyOeiCreateDraftApplicationRequestDto implements ICreateCompanyOeiCreateDraftApplicationRequestDto {
    invitationToApplyId!: number;
    applicantCompanyId!: number;
    applicationType!: DraftApplicationTypeEnum;

    constructor(data?: ICreateCompanyOeiCreateDraftApplicationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationToApplyId = _data["invitationToApplyId"];
            this.applicantCompanyId = _data["applicantCompanyId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateCompanyOeiCreateDraftApplicationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOeiCreateDraftApplicationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationToApplyId"] = this.invitationToApplyId;
        data["applicantCompanyId"] = this.applicantCompanyId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateCompanyOeiCreateDraftApplicationRequestDto {
    invitationToApplyId: number;
    applicantCompanyId: number;
    applicationType: DraftApplicationTypeEnum;
}

export class CreateCompanyOeiCreateDraftApplicationResponseDto implements ICreateCompanyOeiCreateDraftApplicationResponseDto {
    id?: DraftApplicationIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOeiCreateDraftApplicationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? DraftApplicationIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOeiCreateDraftApplicationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOeiCreateDraftApplicationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOeiCreateDraftApplicationResponseDto {
    id?: DraftApplicationIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOeiCreateDraftApplicationReferenceDataRequestDto implements IGetCompanyOeiCreateDraftApplicationReferenceDataRequestDto {

    constructor(data?: IGetCompanyOeiCreateDraftApplicationReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOeiCreateDraftApplicationReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiCreateDraftApplicationReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOeiCreateDraftApplicationReferenceDataRequestDto {
}

export class GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto implements IGetCompanyOeiCreateDraftApplicationReferenceDataResponseDto {
    applicants!: GetInvitationToApplyReferenceDataDraftApplicationApplicantDto[];
    applicationTypes!: GetInvitationToApplyReferenceDataDraftApplicationTypeDto[];

    constructor(data?: IGetCompanyOeiCreateDraftApplicationReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicants = [];
            this.applicationTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(GetInvitationToApplyReferenceDataDraftApplicationApplicantDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTypes"])) {
                this.applicationTypes = [] as any;
                for (let item of _data["applicationTypes"])
                    this.applicationTypes!.push(GetInvitationToApplyReferenceDataDraftApplicationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiCreateDraftApplicationReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTypes)) {
            data["applicationTypes"] = [];
            for (let item of this.applicationTypes)
                data["applicationTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiCreateDraftApplicationReferenceDataResponseDto {
    applicants: GetInvitationToApplyReferenceDataDraftApplicationApplicantDto[];
    applicationTypes: GetInvitationToApplyReferenceDataDraftApplicationTypeDto[];
}

export class GetCompanyOeiDraftApplicationDetailsApplicantRequestDto implements IGetCompanyOeiDraftApplicationDetailsApplicantRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsApplicantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsApplicantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsApplicantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsApplicantRequestDto {
    id: number;
}

export class GetCompanyOeiDraftApplicationDetailsApplicantResponseDto implements IGetCompanyOeiDraftApplicationDetailsApplicantResponseDto {
    companyName!: string;
    acnOrArbn!: string;
    foreignInvestmentApprovalType?: ForeignInvestmentApprovalTypeDto | undefined;
    isApplicantEligibleUnderSection8?: boolean | undefined;
    availableForeignInvestmentApprovalTypes!: ForeignInvestmentApprovalTypeDto[];
    versionNumber!: number;
    lastModifiedAudit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsApplicantResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableForeignInvestmentApprovalTypes = [];
            this.lastModifiedAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.foreignInvestmentApprovalType = _data["foreignInvestmentApprovalType"] ? ForeignInvestmentApprovalTypeDto.fromJS(_data["foreignInvestmentApprovalType"]) : <any>undefined;
            this.isApplicantEligibleUnderSection8 = _data["isApplicantEligibleUnderSection8"];
            if (Array.isArray(_data["availableForeignInvestmentApprovalTypes"])) {
                this.availableForeignInvestmentApprovalTypes = [] as any;
                for (let item of _data["availableForeignInvestmentApprovalTypes"])
                    this.availableForeignInvestmentApprovalTypes!.push(ForeignInvestmentApprovalTypeDto.fromJS(item));
            }
            this.versionNumber = _data["versionNumber"];
            this.lastModifiedAudit = _data["lastModifiedAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["lastModifiedAudit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsApplicantResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsApplicantResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["foreignInvestmentApprovalType"] = this.foreignInvestmentApprovalType ? this.foreignInvestmentApprovalType.toJSON() : <any>undefined;
        data["isApplicantEligibleUnderSection8"] = this.isApplicantEligibleUnderSection8;
        if (Array.isArray(this.availableForeignInvestmentApprovalTypes)) {
            data["availableForeignInvestmentApprovalTypes"] = [];
            for (let item of this.availableForeignInvestmentApprovalTypes)
                data["availableForeignInvestmentApprovalTypes"].push(item.toJSON());
        }
        data["versionNumber"] = this.versionNumber;
        data["lastModifiedAudit"] = this.lastModifiedAudit ? this.lastModifiedAudit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsApplicantResponseDto {
    companyName: string;
    acnOrArbn: string;
    foreignInvestmentApprovalType?: ForeignInvestmentApprovalTypeDto | undefined;
    isApplicantEligibleUnderSection8?: boolean | undefined;
    availableForeignInvestmentApprovalTypes: ForeignInvestmentApprovalTypeDto[];
    versionNumber: number;
    lastModifiedAudit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyOeiDraftApplicationDetailsApplicantRequestDto implements ISaveCompanyOeiDraftApplicationDetailsApplicantRequestDto {
    id!: number;
    foreignInvestmentApprovalType?: DraftApplicationForeignInvestmentApprovalTypeEnum | undefined;
    isApplicantEligibleUnderSection8?: boolean | undefined;
    versionNumber!: number;

    constructor(data?: ISaveCompanyOeiDraftApplicationDetailsApplicantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foreignInvestmentApprovalType = _data["foreignInvestmentApprovalType"];
            this.isApplicantEligibleUnderSection8 = _data["isApplicantEligibleUnderSection8"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SaveCompanyOeiDraftApplicationDetailsApplicantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOeiDraftApplicationDetailsApplicantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foreignInvestmentApprovalType"] = this.foreignInvestmentApprovalType;
        data["isApplicantEligibleUnderSection8"] = this.isApplicantEligibleUnderSection8;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISaveCompanyOeiDraftApplicationDetailsApplicantRequestDto {
    id: number;
    foreignInvestmentApprovalType?: DraftApplicationForeignInvestmentApprovalTypeEnum | undefined;
    isApplicantEligibleUnderSection8?: boolean | undefined;
    versionNumber: number;
}

export class SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto implements ISaveCompanyOeiDraftApplicationDetailsApplicantResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOeiDraftApplicationDetailsApplicantResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOeiDraftApplicationDetailsApplicantResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOeiDraftApplicationDetailsApplicantResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto implements IGetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto {
    overlappingContactType!: DraftApplicationOeiContactOverlappingContactTypeEnum;
    description!: string;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overlappingContactType = _data["overlappingContactType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overlappingContactType"] = this.overlappingContactType;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto {
    overlappingContactType: DraftApplicationOeiContactOverlappingContactTypeEnum;
    description: string;
}

export class GetCompanyOeiDraftApplicationDetailsContactRequestDto implements IGetCompanyOeiDraftApplicationDetailsContactRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsContactRequestDto {
    id: number;
}

export class GetCompanyOeiDraftApplicationDetailsContactResponseDto implements IGetCompanyOeiDraftApplicationDetailsContactResponseDto {
    applicantCompanyName?: string | undefined;
    primaryContactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    businessAddress?: string | undefined;
    isOverlappingContactSharingConsent!: boolean;
    overlappingContactType!: GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto;
    isElectronicCommunicationConsent?: boolean | undefined;
    overlappingContactTypes!: GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto[];
    versionNumber!: number;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsContactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.overlappingContactType = new GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto();
            this.overlappingContactTypes = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantCompanyName = _data["applicantCompanyName"];
            this.primaryContactName = _data["primaryContactName"];
            this.positionHeld = _data["positionHeld"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.businessAddress = _data["businessAddress"];
            this.isOverlappingContactSharingConsent = _data["isOverlappingContactSharingConsent"];
            this.overlappingContactType = _data["overlappingContactType"] ? GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto.fromJS(_data["overlappingContactType"]) : new GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto();
            this.isElectronicCommunicationConsent = _data["isElectronicCommunicationConsent"];
            if (Array.isArray(_data["overlappingContactTypes"])) {
                this.overlappingContactTypes = [] as any;
                for (let item of _data["overlappingContactTypes"])
                    this.overlappingContactTypes!.push(GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto.fromJS(item));
            }
            this.versionNumber = _data["versionNumber"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsContactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsContactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantCompanyName"] = this.applicantCompanyName;
        data["primaryContactName"] = this.primaryContactName;
        data["positionHeld"] = this.positionHeld;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["businessAddress"] = this.businessAddress;
        data["isOverlappingContactSharingConsent"] = this.isOverlappingContactSharingConsent;
        data["overlappingContactType"] = this.overlappingContactType ? this.overlappingContactType.toJSON() : <any>undefined;
        data["isElectronicCommunicationConsent"] = this.isElectronicCommunicationConsent;
        if (Array.isArray(this.overlappingContactTypes)) {
            data["overlappingContactTypes"] = [];
            for (let item of this.overlappingContactTypes)
                data["overlappingContactTypes"].push(item.toJSON());
        }
        data["versionNumber"] = this.versionNumber;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsContactResponseDto {
    applicantCompanyName?: string | undefined;
    primaryContactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    businessAddress?: string | undefined;
    isOverlappingContactSharingConsent: boolean;
    overlappingContactType: GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto;
    isElectronicCommunicationConsent?: boolean | undefined;
    overlappingContactTypes: GetCompanyOeiDraftApplicationDetailsContactOverlappingContactTypeDto[];
    versionNumber: number;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyOeiDraftApplicationDetailsContactRequestDto implements ISaveCompanyOeiDraftApplicationDetailsContactRequestDto {
    id!: number;
    versionNumber!: number;
    primaryContactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    businessAddress?: string | undefined;
    isOverlappingContactSharingConsent!: boolean;
    overlappingContactType!: DraftApplicationOeiContactOverlappingContactTypeEnum;
    isElectronicCommunicationConsent!: boolean;

    constructor(data?: ISaveCompanyOeiDraftApplicationDetailsContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.primaryContactName = _data["primaryContactName"];
            this.positionHeld = _data["positionHeld"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.businessAddress = _data["businessAddress"];
            this.isOverlappingContactSharingConsent = _data["isOverlappingContactSharingConsent"];
            this.overlappingContactType = _data["overlappingContactType"];
            this.isElectronicCommunicationConsent = _data["isElectronicCommunicationConsent"];
        }
    }

    static fromJS(data: any): SaveCompanyOeiDraftApplicationDetailsContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOeiDraftApplicationDetailsContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["primaryContactName"] = this.primaryContactName;
        data["positionHeld"] = this.positionHeld;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["businessAddress"] = this.businessAddress;
        data["isOverlappingContactSharingConsent"] = this.isOverlappingContactSharingConsent;
        data["overlappingContactType"] = this.overlappingContactType;
        data["isElectronicCommunicationConsent"] = this.isElectronicCommunicationConsent;
        return data;
    }
}

export interface ISaveCompanyOeiDraftApplicationDetailsContactRequestDto {
    id: number;
    versionNumber: number;
    primaryContactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    businessAddress?: string | undefined;
    isOverlappingContactSharingConsent: boolean;
    overlappingContactType: DraftApplicationOeiContactOverlappingContactTypeEnum;
    isElectronicCommunicationConsent: boolean;
}

export class SaveCompanyOeiDraftApplicationDetailsContactResponseDto implements ISaveCompanyOeiDraftApplicationDetailsContactResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOeiDraftApplicationDetailsContactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOeiDraftApplicationDetailsContactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOeiDraftApplicationDetailsContactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOeiDraftApplicationDetailsContactResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto implements IGetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto {
    id: number;
    name?: string | undefined;
}

export class GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto implements IGetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto {
    id: number;
    name?: string | undefined;
}

export class GetCompanyOeiDraftApplicationDetailsIaflRequestDto implements IGetCompanyOeiDraftApplicationDetailsIaflRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsIaflRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsIaflRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsIaflRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsIaflRequestDto {
    id: number;
}

export class GetCompanyOeiDraftApplicationDetailsIaflResponseDto implements IGetCompanyOeiDraftApplicationDetailsIaflResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    invitationToApplyId?: number | undefined;
    invitationToApplyName?: string | undefined;
    declaredAreaId?: number | undefined;
    projectNameOrReference?: string | undefined;
    proposedLicenceArea?: number | undefined;
    proposedGenerationCapacity?: number | undefined;
    renewableEnergyResourceTypeId?: number | undefined;
    technologyTypeId?: number | undefined;
    declaredAreas?: GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto[] | undefined;
    renewableEnergyResourceTypes?: GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto[] | undefined;
    technologyTypes?: GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto[] | undefined;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsIaflResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.invitationToApplyId = _data["invitationToApplyId"];
            this.invitationToApplyName = _data["invitationToApplyName"];
            this.declaredAreaId = _data["declaredAreaId"];
            this.projectNameOrReference = _data["projectNameOrReference"];
            this.proposedLicenceArea = _data["proposedLicenceArea"];
            this.proposedGenerationCapacity = _data["proposedGenerationCapacity"];
            this.renewableEnergyResourceTypeId = _data["renewableEnergyResourceTypeId"];
            this.technologyTypeId = _data["technologyTypeId"];
            if (Array.isArray(_data["declaredAreas"])) {
                this.declaredAreas = [] as any;
                for (let item of _data["declaredAreas"])
                    this.declaredAreas!.push(GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto.fromJS(item));
            }
            if (Array.isArray(_data["renewableEnergyResourceTypes"])) {
                this.renewableEnergyResourceTypes = [] as any;
                for (let item of _data["renewableEnergyResourceTypes"])
                    this.renewableEnergyResourceTypes!.push(GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["technologyTypes"])) {
                this.technologyTypes = [] as any;
                for (let item of _data["technologyTypes"])
                    this.technologyTypes!.push(GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsIaflResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsIaflResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["invitationToApplyId"] = this.invitationToApplyId;
        data["invitationToApplyName"] = this.invitationToApplyName;
        data["declaredAreaId"] = this.declaredAreaId;
        data["projectNameOrReference"] = this.projectNameOrReference;
        data["proposedLicenceArea"] = this.proposedLicenceArea;
        data["proposedGenerationCapacity"] = this.proposedGenerationCapacity;
        data["renewableEnergyResourceTypeId"] = this.renewableEnergyResourceTypeId;
        data["technologyTypeId"] = this.technologyTypeId;
        if (Array.isArray(this.declaredAreas)) {
            data["declaredAreas"] = [];
            for (let item of this.declaredAreas)
                data["declaredAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.renewableEnergyResourceTypes)) {
            data["renewableEnergyResourceTypes"] = [];
            for (let item of this.renewableEnergyResourceTypes)
                data["renewableEnergyResourceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.technologyTypes)) {
            data["technologyTypes"] = [];
            for (let item of this.technologyTypes)
                data["technologyTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsIaflResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    invitationToApplyId?: number | undefined;
    invitationToApplyName?: string | undefined;
    declaredAreaId?: number | undefined;
    projectNameOrReference?: string | undefined;
    proposedLicenceArea?: number | undefined;
    proposedGenerationCapacity?: number | undefined;
    renewableEnergyResourceTypeId?: number | undefined;
    technologyTypeId?: number | undefined;
    declaredAreas?: GetCompanyOeiDraftApplicationDetailsIaflDeclaredAreaDto[] | undefined;
    renewableEnergyResourceTypes?: GetCompanyOeiDraftApplicationDetailsIaflRenewableEnergyResourceTypeDto[] | undefined;
    technologyTypes?: GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto[] | undefined;
}

export class GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto implements IGetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationDetailsIaflTechnologyTypeDto {
    id: number;
    name?: string | undefined;
}

export class UpdateCompanyOeiDraftApplicationDetailsIaflRequestDto implements IUpdateCompanyOeiDraftApplicationDetailsIaflRequestDto {
    id!: number;
    versionNumber!: number;
    invitationToApplyId?: number | undefined;
    declaredAreaId?: number | undefined;
    projectNameOrReference?: string | undefined;
    proposedLicenceArea?: number | undefined;
    proposedGenerationCapacity?: number | undefined;
    renewableEnergyResourceTypeId?: number | undefined;
    technologyTypeId?: number | undefined;

    constructor(data?: IUpdateCompanyOeiDraftApplicationDetailsIaflRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.invitationToApplyId = _data["invitationToApplyId"];
            this.declaredAreaId = _data["declaredAreaId"];
            this.projectNameOrReference = _data["projectNameOrReference"];
            this.proposedLicenceArea = _data["proposedLicenceArea"];
            this.proposedGenerationCapacity = _data["proposedGenerationCapacity"];
            this.renewableEnergyResourceTypeId = _data["renewableEnergyResourceTypeId"];
            this.technologyTypeId = _data["technologyTypeId"];
        }
    }

    static fromJS(data: any): UpdateCompanyOeiDraftApplicationDetailsIaflRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOeiDraftApplicationDetailsIaflRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["invitationToApplyId"] = this.invitationToApplyId;
        data["declaredAreaId"] = this.declaredAreaId;
        data["projectNameOrReference"] = this.projectNameOrReference;
        data["proposedLicenceArea"] = this.proposedLicenceArea;
        data["proposedGenerationCapacity"] = this.proposedGenerationCapacity;
        data["renewableEnergyResourceTypeId"] = this.renewableEnergyResourceTypeId;
        data["technologyTypeId"] = this.technologyTypeId;
        return data;
    }
}

export interface IUpdateCompanyOeiDraftApplicationDetailsIaflRequestDto {
    id: number;
    versionNumber: number;
    invitationToApplyId?: number | undefined;
    declaredAreaId?: number | undefined;
    projectNameOrReference?: string | undefined;
    proposedLicenceArea?: number | undefined;
    proposedGenerationCapacity?: number | undefined;
    renewableEnergyResourceTypeId?: number | undefined;
    technologyTypeId?: number | undefined;
}

export class UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto implements IUpdateCompanyOeiDraftApplicationDetailsIaflResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOeiDraftApplicationDetailsIaflResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOeiDraftApplicationDetailsIaflResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOeiDraftApplicationDetailsIaflResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOeiDraftApplicationListItemDto implements IGetCompanyOeiDraftApplicationListItemDto {
    link!: DraftApplicationLinkDto;
    typeDisplay?: string | undefined;
    applicationName?: string | undefined;
    status?: string | undefined;
    licences!: DraftApplicationLicenceDto[];
    licenceNumberDisplay?: string | undefined;
    licenceTypeDisplay?: string | undefined;
    applicantId!: number;
    applicantName?: string | undefined;
    createdDate!: Date;

    constructor(data?: IGetCompanyOeiDraftApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.link = new DraftApplicationLinkDto();
            this.licences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"] ? DraftApplicationLinkDto.fromJS(_data["link"]) : new DraftApplicationLinkDto();
            this.typeDisplay = _data["typeDisplay"];
            this.applicationName = _data["applicationName"];
            this.status = _data["status"];
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(DraftApplicationLicenceDto.fromJS(item));
            }
            this.licenceNumberDisplay = _data["licenceNumberDisplay"];
            this.licenceTypeDisplay = _data["licenceTypeDisplay"];
            this.applicantId = _data["applicantId"];
            this.applicantName = _data["applicantName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["typeDisplay"] = this.typeDisplay;
        data["applicationName"] = this.applicationName;
        data["status"] = this.status;
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        data["licenceNumberDisplay"] = this.licenceNumberDisplay;
        data["licenceTypeDisplay"] = this.licenceTypeDisplay;
        data["applicantId"] = this.applicantId;
        data["applicantName"] = this.applicantName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationListItemDto {
    link: DraftApplicationLinkDto;
    typeDisplay?: string | undefined;
    applicationName?: string | undefined;
    status?: string | undefined;
    licences: DraftApplicationLicenceDto[];
    licenceNumberDisplay?: string | undefined;
    licenceTypeDisplay?: string | undefined;
    applicantId: number;
    applicantName?: string | undefined;
    createdDate: Date;
}

export class GetCompanyOeiDraftApplicationListRequestDto implements IGetCompanyOeiDraftApplicationListRequestDto {

    constructor(data?: IGetCompanyOeiDraftApplicationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationListRequestDto {
}

export class GetCompanyOeiDraftApplicationListResponseDto implements IGetCompanyOeiDraftApplicationListResponseDto {
    draftApplications?: GetCompanyOeiDraftApplicationListItemDto[] | undefined;

    constructor(data?: IGetCompanyOeiDraftApplicationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["draftApplications"])) {
                this.draftApplications = [] as any;
                for (let item of _data["draftApplications"])
                    this.draftApplications!.push(GetCompanyOeiDraftApplicationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiDraftApplicationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiDraftApplicationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.draftApplications)) {
            data["draftApplications"] = [];
            for (let item of this.draftApplications)
                data["draftApplications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiDraftApplicationListResponseDto {
    draftApplications?: GetCompanyOeiDraftApplicationListItemDto[] | undefined;
}

export class GetCompanyOeiInvitationToApplyListInvitationToApplyDto implements IGetCompanyOeiInvitationToApplyListInvitationToApplyDto {
    id!: number;
    name!: string;
    licenceType?: string | undefined;
    bidOpenDate?: Date | undefined;
    bidClosedDatetime!: Date;
    isBidOpen!: boolean;

    constructor(data?: IGetCompanyOeiInvitationToApplyListInvitationToApplyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.licenceType = _data["licenceType"];
            this.bidOpenDate = _data["bidOpenDate"] ? new Date(_data["bidOpenDate"].toString()) : <any>undefined;
            this.bidClosedDatetime = _data["bidClosedDatetime"] ? new Date(_data["bidClosedDatetime"].toString()) : <any>undefined;
            this.isBidOpen = _data["isBidOpen"];
        }
    }

    static fromJS(data: any): GetCompanyOeiInvitationToApplyListInvitationToApplyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiInvitationToApplyListInvitationToApplyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["licenceType"] = this.licenceType;
        data["bidOpenDate"] = this.bidOpenDate ? this.bidOpenDate.toISOString() : <any>undefined;
        data["bidClosedDatetime"] = this.bidClosedDatetime ? this.bidClosedDatetime.toISOString() : <any>undefined;
        data["isBidOpen"] = this.isBidOpen;
        return data;
    }
}

export interface IGetCompanyOeiInvitationToApplyListInvitationToApplyDto {
    id: number;
    name: string;
    licenceType?: string | undefined;
    bidOpenDate?: Date | undefined;
    bidClosedDatetime: Date;
    isBidOpen: boolean;
}

export class GetCompanyOeiInvitationToApplyListRequestDto implements IGetCompanyOeiInvitationToApplyListRequestDto {

    constructor(data?: IGetCompanyOeiInvitationToApplyListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOeiInvitationToApplyListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiInvitationToApplyListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOeiInvitationToApplyListRequestDto {
}

export class GetCompanyOeiInvitationToApplyListResponseDto implements IGetCompanyOeiInvitationToApplyListResponseDto {
    canCreateInvitationToApply!: boolean;
    invitationsToApply?: GetCompanyOeiInvitationToApplyListInvitationToApplyDto[] | undefined;

    constructor(data?: IGetCompanyOeiInvitationToApplyListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateInvitationToApply = _data["canCreateInvitationToApply"];
            if (Array.isArray(_data["invitationsToApply"])) {
                this.invitationsToApply = [] as any;
                for (let item of _data["invitationsToApply"])
                    this.invitationsToApply!.push(GetCompanyOeiInvitationToApplyListInvitationToApplyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiInvitationToApplyListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiInvitationToApplyListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateInvitationToApply"] = this.canCreateInvitationToApply;
        if (Array.isArray(this.invitationsToApply)) {
            data["invitationsToApply"] = [];
            for (let item of this.invitationsToApply)
                data["invitationsToApply"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiInvitationToApplyListResponseDto {
    canCreateInvitationToApply: boolean;
    invitationsToApply?: GetCompanyOeiInvitationToApplyListInvitationToApplyDto[] | undefined;
}

export class GetCompanyOeiLicenceDetailsMemorialApplicationDto implements IGetCompanyOeiLicenceDetailsMemorialApplicationDto {
    applicationId!: string;
    applicationTypeName!: string;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision!: string;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;

    constructor(data?: IGetCompanyOeiLicenceDetailsMemorialApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.decision = _data["decision"];
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceDetailsMemorialApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceDetailsMemorialApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["decision"] = this.decision;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOeiLicenceDetailsMemorialApplicationDto {
    applicationId: string;
    applicationTypeName: string;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision: string;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;
}

export class GetCompanyOeiLicenceDetailsRequestDto implements IGetCompanyOeiLicenceDetailsRequestDto {
    licenceId!: number;

    constructor(data?: IGetCompanyOeiLicenceDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        return data;
    }
}

export interface IGetCompanyOeiLicenceDetailsRequestDto {
    licenceId: number;
}

export class GetCompanyOeiLicenceDetailsResponseDto implements IGetCompanyOeiLicenceDetailsResponseDto {
    licenceId!: number;
    summary!: GetCompanyOeiLicenceDetailsSummaryDto;
    memorial!: GetCompanyOeiLicenceDetailsMemorialApplicationDto[];

    constructor(data?: IGetCompanyOeiLicenceDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new GetCompanyOeiLicenceDetailsSummaryDto();
            this.memorial = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.summary = _data["summary"] ? GetCompanyOeiLicenceDetailsSummaryDto.fromJS(_data["summary"]) : new GetCompanyOeiLicenceDetailsSummaryDto();
            if (Array.isArray(_data["memorial"])) {
                this.memorial = [] as any;
                for (let item of _data["memorial"])
                    this.memorial!.push(GetCompanyOeiLicenceDetailsMemorialApplicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.memorial)) {
            data["memorial"] = [];
            for (let item of this.memorial)
                data["memorial"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiLicenceDetailsResponseDto {
    licenceId: number;
    summary: GetCompanyOeiLicenceDetailsSummaryDto;
    memorial: GetCompanyOeiLicenceDetailsMemorialApplicationDto[];
}

export class GetCompanyOeiLicenceDetailsSummaryDto implements IGetCompanyOeiLicenceDetailsSummaryDto {
    licenceNumber!: string;
    projectName!: string;
    licenceTypeDescription!: string;
    licenceStatusDescription!: string;
    legislationDescription!: string;
    declaredAreaName!: string;
    grantDate!: Date;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    ceaseDate?: Date | undefined;
    licenceHolderId!: number;
    licenceHolderName!: string;
    finalisedArea!: number;
    finalisedGenerationCapacity!: number;
    renewableEnergyResourceDescription!: string;
    technologyToBeInvestigatedDescription!: string;
    relatedLicences!: LicenceLinkDto[];

    constructor(data?: IGetCompanyOeiLicenceDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedLicences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"];
            this.projectName = _data["projectName"];
            this.licenceTypeDescription = _data["licenceTypeDescription"];
            this.licenceStatusDescription = _data["licenceStatusDescription"];
            this.legislationDescription = _data["legislationDescription"];
            this.declaredAreaName = _data["declaredAreaName"];
            this.grantDate = _data["grantDate"] ? new Date(_data["grantDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.ceaseDate = _data["ceaseDate"] ? new Date(_data["ceaseDate"].toString()) : <any>undefined;
            this.licenceHolderId = _data["licenceHolderId"];
            this.licenceHolderName = _data["licenceHolderName"];
            this.finalisedArea = _data["finalisedArea"];
            this.finalisedGenerationCapacity = _data["finalisedGenerationCapacity"];
            this.renewableEnergyResourceDescription = _data["renewableEnergyResourceDescription"];
            this.technologyToBeInvestigatedDescription = _data["technologyToBeInvestigatedDescription"];
            if (Array.isArray(_data["relatedLicences"])) {
                this.relatedLicences = [] as any;
                for (let item of _data["relatedLicences"])
                    this.relatedLicences!.push(LicenceLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber;
        data["projectName"] = this.projectName;
        data["licenceTypeDescription"] = this.licenceTypeDescription;
        data["licenceStatusDescription"] = this.licenceStatusDescription;
        data["legislationDescription"] = this.legislationDescription;
        data["declaredAreaName"] = this.declaredAreaName;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["ceaseDate"] = this.ceaseDate ? this.ceaseDate.toISOString() : <any>undefined;
        data["licenceHolderId"] = this.licenceHolderId;
        data["licenceHolderName"] = this.licenceHolderName;
        data["finalisedArea"] = this.finalisedArea;
        data["finalisedGenerationCapacity"] = this.finalisedGenerationCapacity;
        data["renewableEnergyResourceDescription"] = this.renewableEnergyResourceDescription;
        data["technologyToBeInvestigatedDescription"] = this.technologyToBeInvestigatedDescription;
        if (Array.isArray(this.relatedLicences)) {
            data["relatedLicences"] = [];
            for (let item of this.relatedLicences)
                data["relatedLicences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiLicenceDetailsSummaryDto {
    licenceNumber: string;
    projectName: string;
    licenceTypeDescription: string;
    licenceStatusDescription: string;
    legislationDescription: string;
    declaredAreaName: string;
    grantDate: Date;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    ceaseDate?: Date | undefined;
    licenceHolderId: number;
    licenceHolderName: string;
    finalisedArea: number;
    finalisedGenerationCapacity: number;
    renewableEnergyResourceDescription: string;
    technologyToBeInvestigatedDescription: string;
    relatedLicences: LicenceLinkDto[];
}

export class GetCompanyOeiLicenceListLicenceDto implements IGetCompanyOeiLicenceListLicenceDto {
    licenceLink!: LicenceLinkDto;
    licenceTypeDisplay!: string;
    licenceStatusDisplay?: string | undefined;
    licenceHolderDisplay?: string | undefined;
    comesIntoForceDate!: Date;
    endDate!: Date;

    constructor(data?: IGetCompanyOeiLicenceListLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licenceLink = new LicenceLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceLink = _data["licenceLink"] ? LicenceLinkDto.fromJS(_data["licenceLink"]) : new LicenceLinkDto();
            this.licenceTypeDisplay = _data["licenceTypeDisplay"];
            this.licenceStatusDisplay = _data["licenceStatusDisplay"];
            this.licenceHolderDisplay = _data["licenceHolderDisplay"];
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceListLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceListLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        data["licenceTypeDisplay"] = this.licenceTypeDisplay;
        data["licenceStatusDisplay"] = this.licenceStatusDisplay;
        data["licenceHolderDisplay"] = this.licenceHolderDisplay;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOeiLicenceListLicenceDto {
    licenceLink: LicenceLinkDto;
    licenceTypeDisplay: string;
    licenceStatusDisplay?: string | undefined;
    licenceHolderDisplay?: string | undefined;
    comesIntoForceDate: Date;
    endDate: Date;
}

export class GetCompanyOeiLicenceListRequestDto implements IGetCompanyOeiLicenceListRequestDto {

    constructor(data?: IGetCompanyOeiLicenceListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOeiLicenceListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOeiLicenceListRequestDto {
}

export class GetCompanyOeiLicenceListResponseDto implements IGetCompanyOeiLicenceListResponseDto {
    licences!: GetCompanyOeiLicenceListLicenceDto[];

    constructor(data?: IGetCompanyOeiLicenceListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(GetCompanyOeiLicenceListLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiLicenceListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiLicenceListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiLicenceListResponseDto {
    licences: GetCompanyOeiLicenceListLicenceDto[];
}

export class CreateCompanyOeiOeiAdhocUploadRequestDto implements ICreateCompanyOeiOeiAdhocUploadRequestDto {
    fileIds!: number[];
    applicantCompanyId!: number;
    comments?: string | undefined;

    constructor(data?: ICreateCompanyOeiOeiAdhocUploadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fileIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            this.applicantCompanyId = _data["applicantCompanyId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCompanyOeiOeiAdhocUploadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOeiOeiAdhocUploadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        data["applicantCompanyId"] = this.applicantCompanyId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCompanyOeiOeiAdhocUploadRequestDto {
    fileIds: number[];
    applicantCompanyId: number;
    comments?: string | undefined;
}

export class CreateCompanyOeiOeiAdhocUploadResponseDto implements ICreateCompanyOeiOeiAdhocUploadResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOeiOeiAdhocUploadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOeiOeiAdhocUploadResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOeiOeiAdhocUploadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOeiOeiAdhocUploadResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto implements IGetCompanyOeiOeiAdhocUploadDetailsConfigurationDto {
    container!: string;
    allowedExtensions!: string[];
    maximumFileSizeMb!: number;

    constructor(data?: IGetCompanyOeiOeiAdhocUploadDetailsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowedExtensions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            if (Array.isArray(_data["allowedExtensions"])) {
                this.allowedExtensions = [] as any;
                for (let item of _data["allowedExtensions"])
                    this.allowedExtensions!.push(item);
            }
            this.maximumFileSizeMb = _data["maximumFileSizeMb"];
        }
    }

    static fromJS(data: any): GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        if (Array.isArray(this.allowedExtensions)) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        data["maximumFileSizeMb"] = this.maximumFileSizeMb;
        return data;
    }
}

export interface IGetCompanyOeiOeiAdhocUploadDetailsConfigurationDto {
    container: string;
    allowedExtensions: string[];
    maximumFileSizeMb: number;
}

export class GetCompanyOeiOeiAdhocUploadDetailsRequestDto implements IGetCompanyOeiOeiAdhocUploadDetailsRequestDto {

    constructor(data?: IGetCompanyOeiOeiAdhocUploadDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOeiOeiAdhocUploadDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiOeiAdhocUploadDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOeiOeiAdhocUploadDetailsRequestDto {
}

export class GetCompanyOeiOeiAdhocUploadDetailsResponseDto implements IGetCompanyOeiOeiAdhocUploadDetailsResponseDto {
    configuration!: GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto;
    applicants!: CompanyApplicationApplicantDto[];

    constructor(data?: IGetCompanyOeiOeiAdhocUploadDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto();
            this.applicants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto.fromJS(_data["configuration"]) : new GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto();
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(CompanyApplicationApplicantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOeiOeiAdhocUploadDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOeiOeiAdhocUploadDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOeiOeiAdhocUploadDetailsResponseDto {
    configuration: GetCompanyOeiOeiAdhocUploadDetailsConfigurationDto;
    applicants: CompanyApplicationApplicantDto[];
}

export class CreateCompanyOpggsApplicationAdhocUploadRequestDto implements ICreateCompanyOpggsApplicationAdhocUploadRequestDto {
    fileIds!: number[];
    applicantCompanyId!: number;
    comments?: string | undefined;

    constructor(data?: ICreateCompanyOpggsApplicationAdhocUploadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fileIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            this.applicantCompanyId = _data["applicantCompanyId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsApplicationAdhocUploadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsApplicationAdhocUploadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        data["applicantCompanyId"] = this.applicantCompanyId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCompanyOpggsApplicationAdhocUploadRequestDto {
    fileIds: number[];
    applicantCompanyId: number;
    comments?: string | undefined;
}

export class CreateCompanyOpggsApplicationAdhocUploadResponseDto implements ICreateCompanyOpggsApplicationAdhocUploadResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsApplicationAdhocUploadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsApplicationAdhocUploadResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsApplicationAdhocUploadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsApplicationAdhocUploadResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto implements IGetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto {
    container!: string;
    allowedExtensions!: string[];
    maximumFileSizeMb!: number;

    constructor(data?: IGetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowedExtensions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            if (Array.isArray(_data["allowedExtensions"])) {
                this.allowedExtensions = [] as any;
                for (let item of _data["allowedExtensions"])
                    this.allowedExtensions!.push(item);
            }
            this.maximumFileSizeMb = _data["maximumFileSizeMb"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        if (Array.isArray(this.allowedExtensions)) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        data["maximumFileSizeMb"] = this.maximumFileSizeMb;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto {
    container: string;
    allowedExtensions: string[];
    maximumFileSizeMb: number;
}

export class GetCompanyOpggsApplicationAdhocUploadDetailsRequestDto implements IGetCompanyOpggsApplicationAdhocUploadDetailsRequestDto {

    constructor(data?: IGetCompanyOpggsApplicationAdhocUploadDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOpggsApplicationAdhocUploadDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationAdhocUploadDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOpggsApplicationAdhocUploadDetailsRequestDto {
}

export class GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto implements IGetCompanyOpggsApplicationAdhocUploadDetailsResponseDto {
    configuration!: GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto;
    creatableDraftApplicationTypes!: string[];
    applicants!: CompanyApplicationApplicantDto[];

    constructor(data?: IGetCompanyOpggsApplicationAdhocUploadDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto();
            this.creatableDraftApplicationTypes = [];
            this.applicants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto.fromJS(_data["configuration"]) : new GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto();
            if (Array.isArray(_data["creatableDraftApplicationTypes"])) {
                this.creatableDraftApplicationTypes = [] as any;
                for (let item of _data["creatableDraftApplicationTypes"])
                    this.creatableDraftApplicationTypes!.push(item);
            }
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(CompanyApplicationApplicantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationAdhocUploadDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        if (Array.isArray(this.creatableDraftApplicationTypes)) {
            data["creatableDraftApplicationTypes"] = [];
            for (let item of this.creatableDraftApplicationTypes)
                data["creatableDraftApplicationTypes"].push(item);
        }
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationAdhocUploadDetailsResponseDto {
    configuration: GetCompanyOpggsApplicationAdhocUploadDetailsConfigurationDto;
    creatableDraftApplicationTypes: string[];
    applicants: CompanyApplicationApplicantDto[];
}

export class GetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto implements IGetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsApplicationDetailsRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto implements IGetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto {
    items!: GetApplicationDetailsItemDto[];

    constructor(data?: IGetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetApplicationDetailsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsApplicationDetailsResponseDto {
    items: GetApplicationDetailsItemDto[];
}

export class GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto implements IGetCompanyOpggsApplicationDetailsApprovalTrackingItemDto {
    status!: string;
    startedDatetime!: Date;
    daysAtStatus!: number;

    constructor(data?: IGetCompanyOpggsApplicationDetailsApprovalTrackingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.startedDatetime = _data["startedDatetime"] ? new Date(_data["startedDatetime"].toString()) : <any>undefined;
            this.daysAtStatus = _data["daysAtStatus"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["startedDatetime"] = this.startedDatetime ? this.startedDatetime.toISOString() : <any>undefined;
        data["daysAtStatus"] = this.daysAtStatus;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsApprovalTrackingItemDto {
    status: string;
    startedDatetime: Date;
    daysAtStatus: number;
}

export class GetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto implements IGetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsApprovalTrackingRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto implements IGetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto {
    items!: GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto[];

    constructor(data?: IGetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsApprovalTrackingResponseDto {
    items: GetCompanyOpggsApplicationDetailsApprovalTrackingItemDto[];
}

export class GetCompanyOpggsApplicationDetailsBlockDetailsRequestDto implements IGetCompanyOpggsApplicationDetailsBlockDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsBlockDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsBlockDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsBlockDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsBlockDetailsRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto implements IGetCompanyOpggsApplicationDetailsBlockDetailsResponseDto {
    blocks!: GetBlockDetailsItemDto[];
    showLocationDetails!: boolean;

    constructor(data?: IGetCompanyOpggsApplicationDetailsBlockDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.blocks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(GetBlockDetailsItemDto.fromJS(item));
            }
            this.showLocationDetails = _data["showLocationDetails"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsBlockDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["showLocationDetails"] = this.showLocationDetails;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsBlockDetailsResponseDto {
    blocks: GetBlockDetailsItemDto[];
    showLocationDetails: boolean;
}

export class GetCompanyOpggsApplicationDetailsContactRequestDto implements IGetCompanyOpggsApplicationDetailsContactRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsContactRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsContactResponseDto implements IGetCompanyOpggsApplicationDetailsContactResponseDto {
    companyName?: string | undefined;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IGetCompanyOpggsApplicationDetailsContactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.positionHeld = _data["positionHeld"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsContactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsContactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["positionHeld"] = this.positionHeld;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsContactResponseDto {
    companyName?: string | undefined;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto implements IGetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
    authorisationId?: string | undefined;
    documentName!: string;
    documentSize!: number;
    canDownload!: boolean;

    constructor(data?: IGetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
            this.documentName = _data["documentName"];
            this.documentSize = _data["documentSize"];
            this.canDownload = _data["canDownload"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        data["documentName"] = this.documentName;
        data["documentSize"] = this.documentSize;
        data["canDownload"] = this.canDownload;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
    authorisationId?: string | undefined;
    documentName: string;
    documentSize: number;
    canDownload: boolean;
}

export class GetCompanyOpggsApplicationDetailsDocumentationRequestDto implements IGetCompanyOpggsApplicationDetailsDocumentationRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsDocumentationRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsDocumentationResponseDto implements IGetCompanyOpggsApplicationDetailsDocumentationResponseDto {
    applicationFormDocuments!: GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto[];
    supportingDocumentationDocuments!: GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto[];
    hasUnavailableApplicationFormDocuments!: boolean;
    hasUnavailableSupportingDocumentationDocuments!: boolean;
    hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning!: boolean;

    constructor(data?: IGetCompanyOpggsApplicationDetailsDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicationFormDocuments = [];
            this.supportingDocumentationDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationFormDocuments"])) {
                this.applicationFormDocuments = [] as any;
                for (let item of _data["applicationFormDocuments"])
                    this.applicationFormDocuments!.push(GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["supportingDocumentationDocuments"])) {
                this.supportingDocumentationDocuments = [] as any;
                for (let item of _data["supportingDocumentationDocuments"])
                    this.supportingDocumentationDocuments!.push(GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto.fromJS(item));
            }
            this.hasUnavailableApplicationFormDocuments = _data["hasUnavailableApplicationFormDocuments"];
            this.hasUnavailableSupportingDocumentationDocuments = _data["hasUnavailableSupportingDocumentationDocuments"];
            this.hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning = _data["hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationFormDocuments)) {
            data["applicationFormDocuments"] = [];
            for (let item of this.applicationFormDocuments)
                data["applicationFormDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.supportingDocumentationDocuments)) {
            data["supportingDocumentationDocuments"] = [];
            for (let item of this.supportingDocumentationDocuments)
                data["supportingDocumentationDocuments"].push(item.toJSON());
        }
        data["hasUnavailableApplicationFormDocuments"] = this.hasUnavailableApplicationFormDocuments;
        data["hasUnavailableSupportingDocumentationDocuments"] = this.hasUnavailableSupportingDocumentationDocuments;
        data["hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning"] = this.hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsDocumentationResponseDto {
    applicationFormDocuments: GetCompanyOpggsApplicationDetailsDocumentationApplicationFormDocumentDto[];
    supportingDocumentationDocuments: GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto[];
    hasUnavailableApplicationFormDocuments: boolean;
    hasUnavailableSupportingDocumentationDocuments: boolean;
    hasSupportingDocumentationSensitiveToCompanyAuthorisationWarning: boolean;
}

export class GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto implements IGetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
    authorisationId?: string | undefined;
    documentName!: string;
    documentSize!: number;
    sensitiveToCompanyName?: string | undefined;
    canDownload!: boolean;

    constructor(data?: IGetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
            this.documentName = _data["documentName"];
            this.documentSize = _data["documentSize"];
            this.sensitiveToCompanyName = _data["sensitiveToCompanyName"];
            this.canDownload = _data["canDownload"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        data["documentName"] = this.documentName;
        data["documentSize"] = this.documentSize;
        data["sensitiveToCompanyName"] = this.sensitiveToCompanyName;
        data["canDownload"] = this.canDownload;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
    authorisationId?: string | undefined;
    documentName: string;
    documentSize: number;
    sensitiveToCompanyName?: string | undefined;
    canDownload: boolean;
}

export class GetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto implements IGetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsFinancialNotificationRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto implements IGetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto {
    hasValidFinancialNotification!: boolean;
    financialNotificationLink?: FinancialNotificationLinkDto | undefined;
    financialNotificationStatus?: string | undefined;

    constructor(data?: IGetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasValidFinancialNotification = _data["hasValidFinancialNotification"];
            this.financialNotificationLink = _data["financialNotificationLink"] ? FinancialNotificationLinkDto.fromJS(_data["financialNotificationLink"]) : <any>undefined;
            this.financialNotificationStatus = _data["financialNotificationStatus"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasValidFinancialNotification"] = this.hasValidFinancialNotification;
        data["financialNotificationLink"] = this.financialNotificationLink ? this.financialNotificationLink.toJSON() : <any>undefined;
        data["financialNotificationStatus"] = this.financialNotificationStatus;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsFinancialNotificationResponseDto {
    hasValidFinancialNotification: boolean;
    financialNotificationLink?: FinancialNotificationLinkDto | undefined;
    financialNotificationStatus?: string | undefined;
}

export class GetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto implements IGetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsLayoutAndHeaderRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto implements IGetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto {
    applicationId!: string;
    hasTitleholders!: boolean;
    hasBlockDetails!: boolean;
    hasWorkProgram!: boolean;
    hasFinancialNotification!: boolean;
    applicationTypeName?: string | undefined;
    trackingNumber?: string | undefined;
    applicationStatus?: string | undefined;
    applicationStatusDatetime?: Date | undefined;
    applicationName?: string | undefined;
    submittedDate!: Date;
    titlesLabel?: string | undefined;
    titleLinks?: TitleLinkDto[] | undefined;

    constructor(data?: IGetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.hasTitleholders = _data["hasTitleholders"];
            this.hasBlockDetails = _data["hasBlockDetails"];
            this.hasWorkProgram = _data["hasWorkProgram"];
            this.hasFinancialNotification = _data["hasFinancialNotification"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.trackingNumber = _data["trackingNumber"];
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusDatetime = _data["applicationStatusDatetime"] ? new Date(_data["applicationStatusDatetime"].toString()) : <any>undefined;
            this.applicationName = _data["applicationName"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.titlesLabel = _data["titlesLabel"];
            if (Array.isArray(_data["titleLinks"])) {
                this.titleLinks = [] as any;
                for (let item of _data["titleLinks"])
                    this.titleLinks!.push(TitleLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["hasTitleholders"] = this.hasTitleholders;
        data["hasBlockDetails"] = this.hasBlockDetails;
        data["hasWorkProgram"] = this.hasWorkProgram;
        data["hasFinancialNotification"] = this.hasFinancialNotification;
        data["applicationTypeName"] = this.applicationTypeName;
        data["trackingNumber"] = this.trackingNumber;
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusDatetime"] = this.applicationStatusDatetime ? this.applicationStatusDatetime.toISOString() : <any>undefined;
        data["applicationName"] = this.applicationName;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["titlesLabel"] = this.titlesLabel;
        if (Array.isArray(this.titleLinks)) {
            data["titleLinks"] = [];
            for (let item of this.titleLinks)
                data["titleLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsLayoutAndHeaderResponseDto {
    applicationId: string;
    hasTitleholders: boolean;
    hasBlockDetails: boolean;
    hasWorkProgram: boolean;
    hasFinancialNotification: boolean;
    applicationTypeName?: string | undefined;
    trackingNumber?: string | undefined;
    applicationStatus?: string | undefined;
    applicationStatusDatetime?: Date | undefined;
    applicationName?: string | undefined;
    submittedDate: Date;
    titlesLabel?: string | undefined;
    titleLinks?: TitleLinkDto[] | undefined;
}

export class GetCompanyOpggsApplicationDetailsRfiRequestDto implements IGetCompanyOpggsApplicationDetailsRfiRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsRfiRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsRfiRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsRfiRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsRfiRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsRfiResponseDto implements IGetCompanyOpggsApplicationDetailsRfiResponseDto {

    constructor(data?: IGetCompanyOpggsApplicationDetailsRfiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsRfiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsRfiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsRfiResponseDto {
}

export class GetCompanyOpggsApplicationDetailsTitleholdersRequestDto implements IGetCompanyOpggsApplicationDetailsTitleholdersRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsTitleholdersRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsTitleholdersRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsTitleholdersRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsTitleholdersRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsTitleholdersResponseDto implements IGetCompanyOpggsApplicationDetailsTitleholdersResponseDto {
    titleholders!: GetTitleholdersItemDto[];

    constructor(data?: IGetCompanyOpggsApplicationDetailsTitleholdersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleholders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titleholders"])) {
                this.titleholders = [] as any;
                for (let item of _data["titleholders"])
                    this.titleholders!.push(GetTitleholdersItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsTitleholdersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsTitleholdersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titleholders)) {
            data["titleholders"] = [];
            for (let item of this.titleholders)
                data["titleholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsTitleholdersResponseDto {
    titleholders: GetTitleholdersItemDto[];
}

export class GetCompanyOpggsApplicationDetailsWorkProgramRequestDto implements IGetCompanyOpggsApplicationDetailsWorkProgramRequestDto {
    applicationId!: string;

    constructor(data?: IGetCompanyOpggsApplicationDetailsWorkProgramRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsWorkProgramRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsWorkProgramRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsWorkProgramRequestDto {
    applicationId: string;
}

export class GetCompanyOpggsApplicationDetailsWorkProgramResponseDto implements IGetCompanyOpggsApplicationDetailsWorkProgramResponseDto {
    showPrimaryAndSecondaryTerms!: boolean;
    years?: ApplicationWorkProgramYearDto[] | undefined;
    grandTotal!: number;
    primaryTermTotal!: number;
    secondaryTermTotal!: number;

    constructor(data?: IGetCompanyOpggsApplicationDetailsWorkProgramResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showPrimaryAndSecondaryTerms = _data["showPrimaryAndSecondaryTerms"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(ApplicationWorkProgramYearDto.fromJS(item));
            }
            this.grandTotal = _data["grandTotal"];
            this.primaryTermTotal = _data["primaryTermTotal"];
            this.secondaryTermTotal = _data["secondaryTermTotal"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationDetailsWorkProgramResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationDetailsWorkProgramResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPrimaryAndSecondaryTerms"] = this.showPrimaryAndSecondaryTerms;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal;
        data["primaryTermTotal"] = this.primaryTermTotal;
        data["secondaryTermTotal"] = this.secondaryTermTotal;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationDetailsWorkProgramResponseDto {
    showPrimaryAndSecondaryTerms: boolean;
    years?: ApplicationWorkProgramYearDto[] | undefined;
    grandTotal: number;
    primaryTermTotal: number;
    secondaryTermTotal: number;
}

export class UpdateCompanyOpggsApplicationDetailsRfiRequestDto implements IUpdateCompanyOpggsApplicationDetailsRfiRequestDto {
    applicationId!: string;

    constructor(data?: IUpdateCompanyOpggsApplicationDetailsRfiRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsApplicationDetailsRfiRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsApplicationDetailsRfiRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IUpdateCompanyOpggsApplicationDetailsRfiRequestDto {
    applicationId: string;
}

export class UpdateCompanyOpggsApplicationDetailsRfiResponseDto implements IUpdateCompanyOpggsApplicationDetailsRfiResponseDto {

    constructor(data?: IUpdateCompanyOpggsApplicationDetailsRfiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCompanyOpggsApplicationDetailsRfiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsApplicationDetailsRfiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateCompanyOpggsApplicationDetailsRfiResponseDto {
}

export class GetCompanyOpggsApplicationListRequestDto implements IGetCompanyOpggsApplicationListRequestDto {
    inProgressOnly!: boolean;

    constructor(data?: IGetCompanyOpggsApplicationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressOnly = _data["inProgressOnly"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressOnly"] = this.inProgressOnly;
        return data;
    }
}

export interface IGetCompanyOpggsApplicationListRequestDto {
    inProgressOnly: boolean;
}

export class GetCompanyOpggsApplicationListResponseDto implements IGetCompanyOpggsApplicationListResponseDto {
    applications?: CompanyApplicationListItemDto[] | undefined;

    constructor(data?: IGetCompanyOpggsApplicationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(CompanyApplicationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsApplicationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsApplicationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsApplicationListResponseDto {
    applications?: CompanyApplicationListItemDto[] | undefined;
}

export class CreateCompanyOpggsCreateDraftApplicationRequestDto implements ICreateCompanyOpggsCreateDraftApplicationRequestDto {
    titleId!: string;
    applicantCompanyId!: number;
    applicationType!: DraftApplicationTypeEnum;

    constructor(data?: ICreateCompanyOpggsCreateDraftApplicationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.applicantCompanyId = _data["applicantCompanyId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsCreateDraftApplicationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsCreateDraftApplicationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["applicantCompanyId"] = this.applicantCompanyId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateCompanyOpggsCreateDraftApplicationRequestDto {
    titleId: string;
    applicantCompanyId: number;
    applicationType: DraftApplicationTypeEnum;
}

export class CreateCompanyOpggsCreateDraftApplicationResponseDto implements ICreateCompanyOpggsCreateDraftApplicationResponseDto {
    id?: DraftApplicationIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsCreateDraftApplicationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? DraftApplicationIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsCreateDraftApplicationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsCreateDraftApplicationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsCreateDraftApplicationResponseDto {
    id?: DraftApplicationIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto implements IGetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto {
    titleId!: string;

    constructor(data?: IGetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetCompanyOpggsCreateDraftApplicationReferenceDataRequestDto {
    titleId: string;
}

export class GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto implements IGetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto {
    applicants!: GetTitleReferenceDataDraftApplicationApplicantDto[];
    applicationTypes!: GetTitleReferenceDataDraftApplicationTypeDto[];

    constructor(data?: IGetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicants = [];
            this.applicationTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(GetTitleReferenceDataDraftApplicationApplicantDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTypes"])) {
                this.applicationTypes = [] as any;
                for (let item of _data["applicationTypes"])
                    this.applicationTypes!.push(GetTitleReferenceDataDraftApplicationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTypes)) {
            data["applicationTypes"] = [];
            for (let item of this.applicationTypes)
                data["applicationTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsCreateDraftApplicationReferenceDataResponseDto {
    applicants: GetTitleReferenceDataDraftApplicationApplicantDto[];
    applicationTypes: GetTitleReferenceDataDraftApplicationTypeDto[];
}

export class GetCompanyOpggsDraftApplicationDetailsCoCnRequestDto implements IGetCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsCoCnRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsCoCnRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto implements IGetCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    currentCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isAcnOrArbnMissing!: boolean;
    newCompanyName?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsCoCnResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.currentCompanyName = _data["currentCompanyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.isAcnOrArbnMissing = _data["isAcnOrArbnMissing"];
            this.newCompanyName = _data["newCompanyName"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsCoCnResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["currentCompanyName"] = this.currentCompanyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["isAcnOrArbnMissing"] = this.isAcnOrArbnMissing;
        data["newCompanyName"] = this.newCompanyName;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    currentCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isAcnOrArbnMissing: boolean;
    newCompanyName?: string | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
    id!: number;
    versionNumber!: number;
    acnOrArbn?: string | undefined;
    newCompanyName?: string | undefined;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.newCompanyName = _data["newCompanyName"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["acnOrArbn"] = this.acnOrArbn;
        data["newCompanyName"] = this.newCompanyName;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsCoCnRequestDto {
    id: number;
    versionNumber: number;
    acnOrArbn?: string | undefined;
    newCompanyName?: string | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsCoCnResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsEvaRequestDto implements IGetCompanyOpggsDraftApplicationDetailsEvaRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEvaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEvaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEvaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEvaRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsEvaResponseDto implements IGetCompanyOpggsDraftApplicationDetailsEvaResponseDto {
    evaType?: DraftApplicationEvaTypeEnum | undefined;
    evaTypeDisplay?: string | undefined;
    isActive!: boolean;
    isApplicant!: boolean;
    nominatedTitleholderCompanyName?: string | undefined;
    availableEvaTypes!: GetCompanyOpggsDraftApplicationDetailsEvaTypeDto[];
    statusMessages!: StatusMessagesDto;
    versionNumber!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEvaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableEvaTypes = [];
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evaType = _data["evaType"];
            this.evaTypeDisplay = _data["evaTypeDisplay"];
            this.isActive = _data["isActive"];
            this.isApplicant = _data["isApplicant"];
            this.nominatedTitleholderCompanyName = _data["nominatedTitleholderCompanyName"];
            if (Array.isArray(_data["availableEvaTypes"])) {
                this.availableEvaTypes = [] as any;
                for (let item of _data["availableEvaTypes"])
                    this.availableEvaTypes!.push(GetCompanyOpggsDraftApplicationDetailsEvaTypeDto.fromJS(item));
            }
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEvaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEvaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaType"] = this.evaType;
        data["evaTypeDisplay"] = this.evaTypeDisplay;
        data["isActive"] = this.isActive;
        data["isApplicant"] = this.isApplicant;
        data["nominatedTitleholderCompanyName"] = this.nominatedTitleholderCompanyName;
        if (Array.isArray(this.availableEvaTypes)) {
            data["availableEvaTypes"] = [];
            for (let item of this.availableEvaTypes)
                data["availableEvaTypes"].push(item.toJSON());
        }
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEvaResponseDto {
    evaType?: DraftApplicationEvaTypeEnum | undefined;
    evaTypeDisplay?: string | undefined;
    isActive: boolean;
    isApplicant: boolean;
    nominatedTitleholderCompanyName?: string | undefined;
    availableEvaTypes: GetCompanyOpggsDraftApplicationDetailsEvaTypeDto[];
    statusMessages: StatusMessagesDto;
    versionNumber: number;
}

export class GetCompanyOpggsDraftApplicationDetailsEvaTypeDto implements IGetCompanyOpggsDraftApplicationDetailsEvaTypeDto {
    type!: DraftApplicationEvaTypeEnum;
    name?: string | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEvaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEvaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEvaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEvaTypeDto {
    type: DraftApplicationEvaTypeEnum;
    name?: string | undefined;
}

export class SaveCompanyOpggsDraftApplicationDetailsEvaRequestDto implements ISaveCompanyOpggsDraftApplicationDetailsEvaRequestDto {
    id!: number;
    versionNumber!: number;
    evaType!: DraftApplicationEvaTypeEnum;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsEvaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.evaType = _data["evaType"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsEvaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsEvaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["evaType"] = this.evaType;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsEvaRequestDto {
    id: number;
    versionNumber: number;
    evaType: DraftApplicationEvaTypeEnum;
}

export class SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto implements ISaveCompanyOpggsDraftApplicationDetailsEvaResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsEvaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsEvaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsEvaResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsContactRequestDto implements IGetCompanyOpggsDraftApplicationDetailsContactRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsContactRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsContactResponseDto implements IGetCompanyOpggsDraftApplicationDetailsContactResponseDto {
    applicantCompanyName?: string | undefined;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    versionNumber!: number;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsContactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantCompanyName = _data["applicantCompanyName"];
            this.contactName = _data["contactName"];
            this.positionHeld = _data["positionHeld"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.versionNumber = _data["versionNumber"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsContactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsContactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantCompanyName"] = this.applicantCompanyName;
        data["contactName"] = this.contactName;
        data["positionHeld"] = this.positionHeld;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["versionNumber"] = this.versionNumber;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsContactResponseDto {
    applicantCompanyName?: string | undefined;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    versionNumber: number;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyOpggsDraftApplicationDetailsContactRequestDto implements ISaveCompanyOpggsDraftApplicationDetailsContactRequestDto {
    id!: number;
    versionNumber!: number;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.contactName = _data["contactName"];
            this.positionHeld = _data["positionHeld"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["contactName"] = this.contactName;
        data["positionHeld"] = this.positionHeld;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsContactRequestDto {
    id: number;
    versionNumber: number;
    contactName?: string | undefined;
    positionHeld?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class SaveCompanyOpggsDraftApplicationDetailsContactResponseDto implements ISaveCompanyOpggsDraftApplicationDetailsContactResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsContactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsContactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsContactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsContactResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto implements IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
    companyId!: number;
    companyName!: string;
    acnOrArbn!: string;
    foreignInvestmentApprovalType!: ForeignInvestmentApprovalTypeDto;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.foreignInvestmentApprovalType = new ForeignInvestmentApprovalTypeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.foreignInvestmentApprovalType = _data["foreignInvestmentApprovalType"] ? ForeignInvestmentApprovalTypeDto.fromJS(_data["foreignInvestmentApprovalType"]) : new ForeignInvestmentApprovalTypeDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["foreignInvestmentApprovalType"] = this.foreignInvestmentApprovalType ? this.foreignInvestmentApprovalType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
    companyId: number;
    companyName: string;
    acnOrArbn: string;
    foreignInvestmentApprovalType: ForeignInvestmentApprovalTypeDto;
}

export class GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto implements IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto implements IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
    titleholderForeignInvestmentApprovals!: GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto[];
    availableForeignInvestmentApprovalTypes!: ForeignInvestmentApprovalTypeDto[];
    versionNumber!: number;
    lastModifiedAudit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleholderForeignInvestmentApprovals = [];
            this.availableForeignInvestmentApprovalTypes = [];
            this.lastModifiedAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titleholderForeignInvestmentApprovals"])) {
                this.titleholderForeignInvestmentApprovals = [] as any;
                for (let item of _data["titleholderForeignInvestmentApprovals"])
                    this.titleholderForeignInvestmentApprovals!.push(GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto.fromJS(item));
            }
            if (Array.isArray(_data["availableForeignInvestmentApprovalTypes"])) {
                this.availableForeignInvestmentApprovalTypes = [] as any;
                for (let item of _data["availableForeignInvestmentApprovalTypes"])
                    this.availableForeignInvestmentApprovalTypes!.push(ForeignInvestmentApprovalTypeDto.fromJS(item));
            }
            this.versionNumber = _data["versionNumber"];
            this.lastModifiedAudit = _data["lastModifiedAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["lastModifiedAudit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titleholderForeignInvestmentApprovals)) {
            data["titleholderForeignInvestmentApprovals"] = [];
            for (let item of this.titleholderForeignInvestmentApprovals)
                data["titleholderForeignInvestmentApprovals"].push(item.toJSON());
        }
        if (Array.isArray(this.availableForeignInvestmentApprovalTypes)) {
            data["availableForeignInvestmentApprovalTypes"] = [];
            for (let item of this.availableForeignInvestmentApprovalTypes)
                data["availableForeignInvestmentApprovalTypes"].push(item.toJSON());
        }
        data["versionNumber"] = this.versionNumber;
        data["lastModifiedAudit"] = this.lastModifiedAudit ? this.lastModifiedAudit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
    titleholderForeignInvestmentApprovals: GetCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto[];
    availableForeignInvestmentApprovalTypes: ForeignInvestmentApprovalTypeDto[];
    versionNumber: number;
    lastModifiedAudit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto implements ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
    companyId!: number;
    foreignInvestmentApprovalType?: DraftApplicationForeignInvestmentApprovalTypeEnum | undefined;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.foreignInvestmentApprovalType = _data["foreignInvestmentApprovalType"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["foreignInvestmentApprovalType"] = this.foreignInvestmentApprovalType;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto {
    companyId: number;
    foreignInvestmentApprovalType?: DraftApplicationForeignInvestmentApprovalTypeEnum | undefined;
}

export class SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto implements ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
    id!: number;
    titleholderForeignInvestmentApprovals?: SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto[] | undefined;
    versionNumber!: number;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["titleholderForeignInvestmentApprovals"])) {
                this.titleholderForeignInvestmentApprovals = [] as any;
                for (let item of _data["titleholderForeignInvestmentApprovals"])
                    this.titleholderForeignInvestmentApprovals!.push(SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto.fromJS(item));
            }
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.titleholderForeignInvestmentApprovals)) {
            data["titleholderForeignInvestmentApprovals"] = [];
            for (let item of this.titleholderForeignInvestmentApprovals)
                data["titleholderForeignInvestmentApprovals"].push(item.toJSON());
        }
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentRequestDto {
    id: number;
    titleholderForeignInvestmentApprovals?: SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentApprovalDto[] | undefined;
    versionNumber: number;
}

export class SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto implements ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsTitleholderForeignInvestmentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto implements IGetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto implements IGetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
    activities!: DraftApplicationWorkProgramActivityDto[];
    isComplete!: boolean;
    validYears!: DraftApplicationWorkProgramYearDto[];
    activityList!: string[];
    units!: DraftApplicationWorkProgramUnitDto[];
    versionNumber!: number;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activities = [];
            this.validYears = [];
            this.activityList = [];
            this.units = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(DraftApplicationWorkProgramActivityDto.fromJS(item));
            }
            this.isComplete = _data["isComplete"];
            if (Array.isArray(_data["validYears"])) {
                this.validYears = [] as any;
                for (let item of _data["validYears"])
                    this.validYears!.push(DraftApplicationWorkProgramYearDto.fromJS(item));
            }
            if (Array.isArray(_data["activityList"])) {
                this.activityList = [] as any;
                for (let item of _data["activityList"])
                    this.activityList!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(DraftApplicationWorkProgramUnitDto.fromJS(item));
            }
            this.versionNumber = _data["versionNumber"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["isComplete"] = this.isComplete;
        if (Array.isArray(this.validYears)) {
            data["validYears"] = [];
            for (let item of this.validYears)
                data["validYears"].push(item.toJSON());
        }
        if (Array.isArray(this.activityList)) {
            data["activityList"] = [];
            for (let item of this.activityList)
                data["activityList"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["versionNumber"] = this.versionNumber;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
    activities: DraftApplicationWorkProgramActivityDto[];
    isComplete: boolean;
    validYears: DraftApplicationWorkProgramYearDto[];
    activityList: string[];
    units: DraftApplicationWorkProgramUnitDto[];
    versionNumber: number;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class SaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto implements ISaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
    id!: number;
    versionNumber!: number;
    activities?: DraftApplicationWorkProgramActivityDto[] | undefined;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(DraftApplicationWorkProgramActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsWorkProgramRequestDto {
    id: number;
    versionNumber: number;
    activities?: DraftApplicationWorkProgramActivityDto[] | undefined;
}

export class SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto implements ISaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsDraftApplicationDetailsWorkProgramResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsEottlrRequestDto implements IGetCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEottlrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEottlrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto implements IGetCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    titleId!: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    extensionDate?: Date | undefined;
    isWarningPeriod!: boolean;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEottlrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleExpiryDate = _data["titleExpiryDate"] ? new Date(_data["titleExpiryDate"].toString()) : <any>undefined;
            this.extensionDate = _data["extensionDate"] ? new Date(_data["extensionDate"].toString()) : <any>undefined;
            this.isWarningPeriod = _data["isWarningPeriod"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEottlrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleExpiryDate"] = this.titleExpiryDate ? this.titleExpiryDate.toISOString() : <any>undefined;
        data["extensionDate"] = this.extensionDate ? this.extensionDate.toISOString() : <any>undefined;
        data["isWarningPeriod"] = this.isWarningPeriod;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    titleId: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    extensionDate?: Date | undefined;
    isWarningPeriod: boolean;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
    id!: number;
    versionNumber!: number;
    extensionDate!: Date;
    extensionDateOffsetMinutes!: number;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.extensionDate = _data["extensionDate"] ? new Date(_data["extensionDate"].toString()) : <any>undefined;
            this.extensionDateOffsetMinutes = _data["extensionDateOffsetMinutes"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["extensionDate"] = this.extensionDate ? this.extensionDate.toISOString() : <any>undefined;
        data["extensionDateOffsetMinutes"] = this.extensionDateOffsetMinutes;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEottlrRequestDto {
    id: number;
    versionNumber: number;
    extensionDate: Date;
    extensionDateOffsetMinutes: number;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEottlrResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto implements IGetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto implements IGetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    titleId!: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    isExtensionAccepted?: boolean | undefined;
    numberOfBlocks!: number;
    numberOfLocationBlocks!: number;
    locations?: string | undefined;
    blocksRenewed?: number | undefined;
    blocksRelinquished?: number | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleExpiryDate = _data["titleExpiryDate"] ? new Date(_data["titleExpiryDate"].toString()) : <any>undefined;
            this.isExtensionAccepted = _data["isExtensionAccepted"];
            this.numberOfBlocks = _data["numberOfBlocks"];
            this.numberOfLocationBlocks = _data["numberOfLocationBlocks"];
            this.locations = _data["locations"];
            this.blocksRenewed = _data["blocksRenewed"];
            this.blocksRelinquished = _data["blocksRelinquished"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleExpiryDate"] = this.titleExpiryDate ? this.titleExpiryDate.toISOString() : <any>undefined;
        data["isExtensionAccepted"] = this.isExtensionAccepted;
        data["numberOfBlocks"] = this.numberOfBlocks;
        data["numberOfLocationBlocks"] = this.numberOfLocationBlocks;
        data["locations"] = this.locations;
        data["blocksRenewed"] = this.blocksRenewed;
        data["blocksRelinquished"] = this.blocksRelinquished;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    titleId: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    isExtensionAccepted?: boolean | undefined;
    numberOfBlocks: number;
    numberOfLocationBlocks: number;
    locations?: string | undefined;
    blocksRenewed?: number | undefined;
    blocksRelinquished?: number | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto {
    id!: number;
    versionNumber!: number;
    blocksRenewed!: number;
    blocksRelinquished!: number;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.blocksRenewed = _data["blocksRenewed"];
            this.blocksRelinquished = _data["blocksRelinquished"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["blocksRenewed"] = this.blocksRenewed;
        data["blocksRelinquished"] = this.blocksRelinquished;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksRequestDto {
    id: number;
    versionNumber: number;
    blocksRenewed: number;
    blocksRelinquished: number;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalBlocksResponseDto {
    statusMessages: StatusMessagesDto;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
    id!: number;
    versionNumber!: number;
    isExtensionAccepted!: boolean;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.isExtensionAccepted = _data["isExtensionAccepted"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["isExtensionAccepted"] = this.isExtensionAccepted;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalRequestDto {
    id: number;
    versionNumber: number;
    isExtensionAccepted: boolean;
}

export class UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsEpRenewalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto {
    locations?: GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto[] | undefined;
    locationId?: number | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto.fromJS(item));
            }
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto {
    locations?: GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto[] | undefined;
    locationId?: number | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto implements IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto {
    id!: number;
    name?: string | undefined;
    dateLocationDeclared?: Date | undefined;
    isLongerApplicationPeriodAllowed?: boolean | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dateLocationDeclared = _data["dateLocationDeclared"] ? new Date(_data["dateLocationDeclared"].toString()) : <any>undefined;
            this.isLongerApplicationPeriodAllowed = _data["isLongerApplicationPeriodAllowed"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dateLocationDeclared"] = this.dateLocationDeclared ? this.dateLocationDeclared.toISOString() : <any>undefined;
        data["isLongerApplicationPeriodAllowed"] = this.isLongerApplicationPeriodAllowed;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIappEpDetailsLocationDto {
    id: number;
    name?: string | undefined;
    dateLocationDeclared?: Date | undefined;
    isLongerApplicationPeriodAllowed?: boolean | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsIappRequestDto implements IGetCompanyOpggsDraftApplicationDetailsIappRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIappRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIappRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIappRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIappRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsIappResponseDto implements IGetCompanyOpggsDraftApplicationDetailsIappResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    titleId!: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    originatingTitleType!: TitleTypeEnum;
    epDetails?: GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto | undefined;
    rlDetails?: GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIappResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleExpiryDate = _data["titleExpiryDate"] ? new Date(_data["titleExpiryDate"].toString()) : <any>undefined;
            this.originatingTitleType = _data["originatingTitleType"];
            this.epDetails = _data["epDetails"] ? GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto.fromJS(_data["epDetails"]) : <any>undefined;
            this.rlDetails = _data["rlDetails"] ? GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto.fromJS(_data["rlDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIappResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIappResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleExpiryDate"] = this.titleExpiryDate ? this.titleExpiryDate.toISOString() : <any>undefined;
        data["originatingTitleType"] = this.originatingTitleType;
        data["epDetails"] = this.epDetails ? this.epDetails.toJSON() : <any>undefined;
        data["rlDetails"] = this.rlDetails ? this.rlDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIappResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    titleId: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    originatingTitleType: TitleTypeEnum;
    epDetails?: GetCompanyOpggsDraftApplicationDetailsIappEpDetailsDto | undefined;
    rlDetails?: GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto {
    fieldName?: string | undefined;
    initialGrantDate?: Date | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate?: Date | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.initialGrantDate = _data["initialGrantDate"] ? new Date(_data["initialGrantDate"].toString()) : <any>undefined;
            this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate = _data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"] ? new Date(_data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["initialGrantDate"] = this.initialGrantDate ? this.initialGrantDate.toISOString() : <any>undefined;
        data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"] = this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate ? this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIappRlDetailsDto {
    fieldName?: string | undefined;
    initialGrantDate?: Date | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate?: Date | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsIappRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsIappRequestDto {
    id!: number;
    versionNumber!: number;
    locationId?: number | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate?: Date | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes!: number;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsIappRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.locationId = _data["locationId"];
            this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate = _data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"] ? new Date(_data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"].toString()) : <any>undefined;
            this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes = _data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsIappRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsIappRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["locationId"] = this.locationId;
        data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate"] = this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate ? this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate.toISOString() : <any>undefined;
        data["dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes"] = this.dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsIappRequestDto {
    id: number;
    versionNumber: number;
    locationId?: number | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDate?: Date | undefined;
    dateOfRevocationOrRefusalOfRenewalOfRetentionLeaseDateOffsetMinutes: number;
}

export class UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsIappResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsIappResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsIappResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsIappResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto {
    existingLocations?: GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto[] | undefined;
    existingLocationId?: number | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["existingLocations"])) {
                this.existingLocations = [] as any;
                for (let item of _data["existingLocations"])
                    this.existingLocations!.push(GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto.fromJS(item));
            }
            this.existingLocationId = _data["existingLocationId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.existingLocations)) {
            data["existingLocations"] = [];
            for (let item of this.existingLocations)
                data["existingLocations"].push(item.toJSON());
        }
        data["existingLocationId"] = this.existingLocationId;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto {
    existingLocations?: GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto[] | undefined;
    existingLocationId?: number | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto implements IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto {
    id!: number;
    name?: string | undefined;
    dateLocationDeclared?: Date | undefined;
    isLongerApplicationPeriodAllowed!: boolean;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dateLocationDeclared = _data["dateLocationDeclared"] ? new Date(_data["dateLocationDeclared"].toString()) : <any>undefined;
            this.isLongerApplicationPeriodAllowed = _data["isLongerApplicationPeriodAllowed"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dateLocationDeclared"] = this.dateLocationDeclared ? this.dateLocationDeclared.toISOString() : <any>undefined;
        data["isLongerApplicationPeriodAllowed"] = this.isLongerApplicationPeriodAllowed;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIarlEpDetailsExistingLocationDto {
    id: number;
    name?: string | undefined;
    dateLocationDeclared?: Date | undefined;
    isLongerApplicationPeriodAllowed: boolean;
}

export class GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto implements IGetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto {
    existingNeatsFieldName?: string | undefined;
    initialGrantDate?: Date | undefined;
    isCreateNewField?: boolean | undefined;
    newFieldName?: string | undefined;
    lastDayOfPetroleumRecoveryOperationsDate?: Date | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingNeatsFieldName = _data["existingNeatsFieldName"];
            this.initialGrantDate = _data["initialGrantDate"] ? new Date(_data["initialGrantDate"].toString()) : <any>undefined;
            this.isCreateNewField = _data["isCreateNewField"];
            this.newFieldName = _data["newFieldName"];
            this.lastDayOfPetroleumRecoveryOperationsDate = _data["lastDayOfPetroleumRecoveryOperationsDate"] ? new Date(_data["lastDayOfPetroleumRecoveryOperationsDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingNeatsFieldName"] = this.existingNeatsFieldName;
        data["initialGrantDate"] = this.initialGrantDate ? this.initialGrantDate.toISOString() : <any>undefined;
        data["isCreateNewField"] = this.isCreateNewField;
        data["newFieldName"] = this.newFieldName;
        data["lastDayOfPetroleumRecoveryOperationsDate"] = this.lastDayOfPetroleumRecoveryOperationsDate ? this.lastDayOfPetroleumRecoveryOperationsDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto {
    existingNeatsFieldName?: string | undefined;
    initialGrantDate?: Date | undefined;
    isCreateNewField?: boolean | undefined;
    newFieldName?: string | undefined;
    lastDayOfPetroleumRecoveryOperationsDate?: Date | undefined;
}

export class GetCompanyOpggsDraftApplicationDetailsIarlRequestDto implements IGetCompanyOpggsDraftApplicationDetailsIarlRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIarlRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIarlRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIarlRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIarlRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsIarlResponseDto implements IGetCompanyOpggsDraftApplicationDetailsIarlResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    titleId!: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    originatingTitleType!: TitleTypeEnum;
    epDetails?: GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto | undefined;
    ppDetails?: GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsIarlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleExpiryDate = _data["titleExpiryDate"] ? new Date(_data["titleExpiryDate"].toString()) : <any>undefined;
            this.originatingTitleType = _data["originatingTitleType"];
            this.epDetails = _data["epDetails"] ? GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto.fromJS(_data["epDetails"]) : <any>undefined;
            this.ppDetails = _data["ppDetails"] ? GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto.fromJS(_data["ppDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsIarlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsIarlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleExpiryDate"] = this.titleExpiryDate ? this.titleExpiryDate.toISOString() : <any>undefined;
        data["originatingTitleType"] = this.originatingTitleType;
        data["epDetails"] = this.epDetails ? this.epDetails.toJSON() : <any>undefined;
        data["ppDetails"] = this.ppDetails ? this.ppDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsIarlResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    titleId: string;
    titleNumber?: string | undefined;
    titleExpiryDate?: Date | undefined;
    originatingTitleType: TitleTypeEnum;
    epDetails?: GetCompanyOpggsDraftApplicationDetailsIarlEpDetailsDto | undefined;
    ppDetails?: GetCompanyOpggsDraftApplicationDetailsIarlPpDetailsDto | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto {
    id!: number;
    versionNumber!: number;
    existingLocationId?: number | undefined;
    isCreateNewField?: boolean | undefined;
    newFieldName?: string | undefined;
    lastDayOfPetroleumRecoveryOperationsDate?: Date | undefined;
    lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes!: number;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.existingLocationId = _data["existingLocationId"];
            this.isCreateNewField = _data["isCreateNewField"];
            this.newFieldName = _data["newFieldName"];
            this.lastDayOfPetroleumRecoveryOperationsDate = _data["lastDayOfPetroleumRecoveryOperationsDate"] ? new Date(_data["lastDayOfPetroleumRecoveryOperationsDate"].toString()) : <any>undefined;
            this.lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes = _data["lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["existingLocationId"] = this.existingLocationId;
        data["isCreateNewField"] = this.isCreateNewField;
        data["newFieldName"] = this.newFieldName;
        data["lastDayOfPetroleumRecoveryOperationsDate"] = this.lastDayOfPetroleumRecoveryOperationsDate ? this.lastDayOfPetroleumRecoveryOperationsDate.toISOString() : <any>undefined;
        data["lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes"] = this.lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsIarlRequestDto {
    id: number;
    versionNumber: number;
    existingLocationId?: number | undefined;
    isCreateNewField?: boolean | undefined;
    newFieldName?: string | undefined;
    lastDayOfPetroleumRecoveryOperationsDate?: Date | undefined;
    lastDayOfPetroleumRecoveryOperationsDateOffsetMinutes: number;
}

export class UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsIarlResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto implements IGetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
    id: number;
}

export class GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto implements IGetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
    id!: number;
    trackingNumber?: string | undefined;
    type!: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state!: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment!: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures!: boolean;
    canManageApplicantOnly!: boolean;
    canManageApplicantOrPartnerCompany!: boolean;
    canManageFormDocumentation!: boolean;
    canSubmit!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState!: DraftApplicationValidationStateEnum;
    versionNumber!: number;
    applicationDetailsAudit!: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist!: ProgressChecklistItemDto[];
    titleId!: string;
    titleNumber?: string | undefined;
    field?: string | undefined;
    titleExpiryDate?: Date | undefined;
    isExtensionAccepted?: boolean | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.applicationDetailsAudit = new SecurePortalSimpleAuditEventsDto();
            this.progressChecklist = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingNumber = _data["trackingNumber"];
            this.type = _data["type"];
            this.typeDisplay = _data["typeDisplay"];
            this.state = _data["state"];
            this.stateDisplay = _data["stateDisplay"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.payment = _data["payment"] ? GetCompanyOpggsDraftApplicationDetailsPaymentDto.fromJS(_data["payment"]) : new GetCompanyOpggsDraftApplicationDetailsPaymentDto();
            this.isDigitalSignatures = _data["isDigitalSignatures"];
            this.canManageApplicantOnly = _data["canManageApplicantOnly"];
            this.canManageApplicantOrPartnerCompany = _data["canManageApplicantOrPartnerCompany"];
            this.canManageFormDocumentation = _data["canManageFormDocumentation"];
            this.canSubmit = _data["canSubmit"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.validationState = _data["validationState"];
            this.versionNumber = _data["versionNumber"];
            this.applicationDetailsAudit = _data["applicationDetailsAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["applicationDetailsAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.stateAudit = _data["stateAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["stateAudit"]) : <any>undefined;
            if (Array.isArray(_data["progressChecklist"])) {
                this.progressChecklist = [] as any;
                for (let item of _data["progressChecklist"])
                    this.progressChecklist!.push(ProgressChecklistItemDto.fromJS(item));
            }
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.field = _data["field"];
            this.titleExpiryDate = _data["titleExpiryDate"] ? new Date(_data["titleExpiryDate"].toString()) : <any>undefined;
            this.isExtensionAccepted = _data["isExtensionAccepted"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingNumber"] = this.trackingNumber;
        data["type"] = this.type;
        data["typeDisplay"] = this.typeDisplay;
        data["state"] = this.state;
        data["stateDisplay"] = this.stateDisplay;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isDigitalSignatures"] = this.isDigitalSignatures;
        data["canManageApplicantOnly"] = this.canManageApplicantOnly;
        data["canManageApplicantOrPartnerCompany"] = this.canManageApplicantOrPartnerCompany;
        data["canManageFormDocumentation"] = this.canManageFormDocumentation;
        data["canSubmit"] = this.canSubmit;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["validationState"] = this.validationState;
        data["versionNumber"] = this.versionNumber;
        data["applicationDetailsAudit"] = this.applicationDetailsAudit ? this.applicationDetailsAudit.toJSON() : <any>undefined;
        data["stateAudit"] = this.stateAudit ? this.stateAudit.toJSON() : <any>undefined;
        if (Array.isArray(this.progressChecklist)) {
            data["progressChecklist"] = [];
            for (let item of this.progressChecklist)
                data["progressChecklist"].push(item.toJSON());
        }
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["field"] = this.field;
        data["titleExpiryDate"] = this.titleExpiryDate ? this.titleExpiryDate.toISOString() : <any>undefined;
        data["isExtensionAccepted"] = this.isExtensionAccepted;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
    id: number;
    trackingNumber?: string | undefined;
    type: DraftApplicationTypeEnum;
    typeDisplay?: string | undefined;
    state: DraftApplicationStateEnum;
    stateDisplay?: string | undefined;
    applicationName?: string | undefined;
    titles?: DraftApplicationTitleDto[] | undefined;
    payment: GetCompanyOpggsDraftApplicationDetailsPaymentDto;
    isDigitalSignatures: boolean;
    canManageApplicantOnly: boolean;
    canManageApplicantOrPartnerCompany: boolean;
    canManageFormDocumentation: boolean;
    canSubmit: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    validationState: DraftApplicationValidationStateEnum;
    versionNumber: number;
    applicationDetailsAudit: SecurePortalSimpleAuditEventsDto;
    stateAudit?: SecurePortalSimpleAuditEventsDto | undefined;
    progressChecklist: ProgressChecklistItemDto[];
    titleId: string;
    titleNumber?: string | undefined;
    field?: string | undefined;
    titleExpiryDate?: Date | undefined;
    isExtensionAccepted?: boolean | undefined;
}

export class UpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto implements IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
    id!: number;
    versionNumber!: number;
    isExtensionAccepted!: boolean;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.isExtensionAccepted = _data["isExtensionAccepted"];
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["isExtensionAccepted"] = this.isExtensionAccepted;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalRequestDto {
    id: number;
    versionNumber: number;
    isExtensionAccepted: boolean;
}

export class UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto implements IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyOpggsDraftApplicationDetailsRlRenewalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsDraftApplicationListItemDto implements IGetCompanyOpggsDraftApplicationListItemDto {
    link!: DraftApplicationLinkDto;
    typeDisplay?: string | undefined;
    applicationName?: string | undefined;
    status?: string | undefined;
    titles!: DraftApplicationTitleDto[];
    titleNumberDisplay?: string | undefined;
    titleTypeDisplay?: string | undefined;
    applicantId!: number;
    applicantName?: string | undefined;
    createdDate!: Date;

    constructor(data?: IGetCompanyOpggsDraftApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.link = new DraftApplicationLinkDto();
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"] ? DraftApplicationLinkDto.fromJS(_data["link"]) : new DraftApplicationLinkDto();
            this.typeDisplay = _data["typeDisplay"];
            this.applicationName = _data["applicationName"];
            this.status = _data["status"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(DraftApplicationTitleDto.fromJS(item));
            }
            this.titleNumberDisplay = _data["titleNumberDisplay"];
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.applicantId = _data["applicantId"];
            this.applicantName = _data["applicantName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["typeDisplay"] = this.typeDisplay;
        data["applicationName"] = this.applicationName;
        data["status"] = this.status;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["titleNumberDisplay"] = this.titleNumberDisplay;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["applicantId"] = this.applicantId;
        data["applicantName"] = this.applicantName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationListItemDto {
    link: DraftApplicationLinkDto;
    typeDisplay?: string | undefined;
    applicationName?: string | undefined;
    status?: string | undefined;
    titles: DraftApplicationTitleDto[];
    titleNumberDisplay?: string | undefined;
    titleTypeDisplay?: string | undefined;
    applicantId: number;
    applicantName?: string | undefined;
    createdDate: Date;
}

export class GetCompanyOpggsDraftApplicationListRequestDto implements IGetCompanyOpggsDraftApplicationListRequestDto {

    constructor(data?: IGetCompanyOpggsDraftApplicationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationListRequestDto {
}

export class GetCompanyOpggsDraftApplicationListResponseDto implements IGetCompanyOpggsDraftApplicationListResponseDto {
    draftApplications?: GetCompanyOpggsDraftApplicationListItemDto[] | undefined;

    constructor(data?: IGetCompanyOpggsDraftApplicationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["draftApplications"])) {
                this.draftApplications = [] as any;
                for (let item of _data["draftApplications"])
                    this.draftApplications!.push(GetCompanyOpggsDraftApplicationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsDraftApplicationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsDraftApplicationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.draftApplications)) {
            data["draftApplications"] = [];
            for (let item of this.draftApplications)
                data["draftApplications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsDraftApplicationListResponseDto {
    draftApplications?: GetCompanyOpggsDraftApplicationListItemDto[] | undefined;
}

export class CompanyOpggsLegislativeFormsFormRequestSummaryDto implements ICompanyOpggsLegislativeFormsFormRequestSummaryDto {
    id!: number;
    formTypeId!: number;
    titleIds?: string[] | undefined;
    titleNumber?: string | undefined;
    titleholder!: FormRequestTitleholderInfoDto;
    becomingARegisteredTitleholderDate?: Date | undefined;
    formRequestState!: LegislativeFormRequestStateEnum;
    formRequestStateDisplayName?: string | undefined;
    submittedDatetime?: Date | undefined;
    noptaReturnToCompanyComment?: string | undefined;
    canManageForm!: boolean;
    isAcnOrArbnRequired!: boolean;
    versionNumber!: number;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: ICompanyOpggsLegislativeFormsFormRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleholder = new FormRequestTitleholderInfoDto();
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formTypeId = _data["formTypeId"];
            if (Array.isArray(_data["titleIds"])) {
                this.titleIds = [] as any;
                for (let item of _data["titleIds"])
                    this.titleIds!.push(item);
            }
            this.titleNumber = _data["titleNumber"];
            this.titleholder = _data["titleholder"] ? FormRequestTitleholderInfoDto.fromJS(_data["titleholder"]) : new FormRequestTitleholderInfoDto();
            this.becomingARegisteredTitleholderDate = _data["becomingARegisteredTitleholderDate"] ? new Date(_data["becomingARegisteredTitleholderDate"].toString()) : <any>undefined;
            this.formRequestState = _data["formRequestState"];
            this.formRequestStateDisplayName = _data["formRequestStateDisplayName"];
            this.submittedDatetime = _data["submittedDatetime"] ? new Date(_data["submittedDatetime"].toString()) : <any>undefined;
            this.noptaReturnToCompanyComment = _data["noptaReturnToCompanyComment"];
            this.canManageForm = _data["canManageForm"];
            this.isAcnOrArbnRequired = _data["isAcnOrArbnRequired"];
            this.versionNumber = _data["versionNumber"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): CompanyOpggsLegislativeFormsFormRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formTypeId"] = this.formTypeId;
        if (Array.isArray(this.titleIds)) {
            data["titleIds"] = [];
            for (let item of this.titleIds)
                data["titleIds"].push(item);
        }
        data["titleNumber"] = this.titleNumber;
        data["titleholder"] = this.titleholder ? this.titleholder.toJSON() : <any>undefined;
        data["becomingARegisteredTitleholderDate"] = this.becomingARegisteredTitleholderDate ? this.becomingARegisteredTitleholderDate.toISOString() : <any>undefined;
        data["formRequestState"] = this.formRequestState;
        data["formRequestStateDisplayName"] = this.formRequestStateDisplayName;
        data["submittedDatetime"] = this.submittedDatetime ? this.submittedDatetime.toISOString() : <any>undefined;
        data["noptaReturnToCompanyComment"] = this.noptaReturnToCompanyComment;
        data["canManageForm"] = this.canManageForm;
        data["isAcnOrArbnRequired"] = this.isAcnOrArbnRequired;
        data["versionNumber"] = this.versionNumber;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompanyOpggsLegislativeFormsFormRequestSummaryDto {
    id: number;
    formTypeId: number;
    titleIds?: string[] | undefined;
    titleNumber?: string | undefined;
    titleholder: FormRequestTitleholderInfoDto;
    becomingARegisteredTitleholderDate?: Date | undefined;
    formRequestState: LegislativeFormRequestStateEnum;
    formRequestStateDisplayName?: string | undefined;
    submittedDatetime?: Date | undefined;
    noptaReturnToCompanyComment?: string | undefined;
    canManageForm: boolean;
    isAcnOrArbnRequired: boolean;
    versionNumber: number;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class DeleteCompanyOpggsLegislativeFormsFormRequestRequestDto implements IDeleteCompanyOpggsLegislativeFormsFormRequestRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: IDeleteCompanyOpggsLegislativeFormsFormRequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): DeleteCompanyOpggsLegislativeFormsFormRequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompanyOpggsLegislativeFormsFormRequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IDeleteCompanyOpggsLegislativeFormsFormRequestRequestDto {
    id: number;
    versionNumber: number;
}

export class DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto implements IDeleteCompanyOpggsLegislativeFormsFormRequestResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteCompanyOpggsLegislativeFormsFormRequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompanyOpggsLegislativeFormsFormRequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteCompanyOpggsLegislativeFormsFormRequestResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm2RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm2RequestRequestDto {
    titleId!: string;
    registeredTitleholderCompanyId!: number;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    address?: FormRequestAddressDetailsDto | undefined;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm2RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.registeredTitleholderCompanyId = _data["registeredTitleholderCompanyId"];
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
            this.address = _data["address"] ? FormRequestAddressDetailsDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm2RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm2RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["registeredTitleholderCompanyId"] = this.registeredTitleholderCompanyId;
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm2RequestRequestDto {
    titleId: string;
    registeredTitleholderCompanyId: number;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    address?: FormRequestAddressDetailsDto | undefined;
}

export class CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm2RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm2RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm2RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm2RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm3RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm3RequestRequestDto {
    titleId!: string;
    registeredTitleholderCompanyId!: number;
    additionalTitleIds?: string[] | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    address?: FormRequestAddressDetailsDto | undefined;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm3RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.registeredTitleholderCompanyId = _data["registeredTitleholderCompanyId"];
            if (Array.isArray(_data["additionalTitleIds"])) {
                this.additionalTitleIds = [] as any;
                for (let item of _data["additionalTitleIds"])
                    this.additionalTitleIds!.push(item);
            }
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
            this.address = _data["address"] ? FormRequestAddressDetailsDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm3RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm3RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["registeredTitleholderCompanyId"] = this.registeredTitleholderCompanyId;
        if (Array.isArray(this.additionalTitleIds)) {
            data["additionalTitleIds"] = [];
            for (let item of this.additionalTitleIds)
                data["additionalTitleIds"].push(item);
        }
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm3RequestRequestDto {
    titleId: string;
    registeredTitleholderCompanyId: number;
    additionalTitleIds?: string[] | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    address?: FormRequestAddressDetailsDto | undefined;
}

export class CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm3RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm3RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm3RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm3RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm4RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm4RequestRequestDto {
    titleId!: string;
    nomineeTitleholderCompanyId!: number;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm4RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.nomineeTitleholderCompanyId = _data["nomineeTitleholderCompanyId"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm4RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm4RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["nomineeTitleholderCompanyId"] = this.nomineeTitleholderCompanyId;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm4RequestRequestDto {
    titleId: string;
    nomineeTitleholderCompanyId: number;
}

export class CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm4RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm4RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm4RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm4RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm5RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm5RequestRequestDto {
    titleId!: string;
    titleholderGivingNoticeCompanyId!: number;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm5RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleholderGivingNoticeCompanyId = _data["titleholderGivingNoticeCompanyId"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm5RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm5RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleholderGivingNoticeCompanyId"] = this.titleholderGivingNoticeCompanyId;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm5RequestRequestDto {
    titleId: string;
    titleholderGivingNoticeCompanyId: number;
}

export class CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm5RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm5RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm5RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm5RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm6RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm6RequestRequestDto {
    titleId!: string;
    nomineeTitleholderCompanyId!: number;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm6RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.nomineeTitleholderCompanyId = _data["nomineeTitleholderCompanyId"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm6RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm6RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["nomineeTitleholderCompanyId"] = this.nomineeTitleholderCompanyId;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm6RequestRequestDto {
    titleId: string;
    nomineeTitleholderCompanyId: number;
}

export class CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm6RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm6RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm6RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm6RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class CreateCompanyOpggsLegislativeFormsForm7RequestRequestDto implements ICreateCompanyOpggsLegislativeFormsForm7RequestRequestDto {
    titleId!: string;
    titleholderGivingNoticeCompanyId!: number;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm7RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleholderGivingNoticeCompanyId = _data["titleholderGivingNoticeCompanyId"];
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm7RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm7RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleholderGivingNoticeCompanyId"] = this.titleholderGivingNoticeCompanyId;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm7RequestRequestDto {
    titleId: string;
    titleholderGivingNoticeCompanyId: number;
}

export class CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto implements ICreateCompanyOpggsLegislativeFormsForm7RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateCompanyOpggsLegislativeFormsForm7RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? FormRequestIdDto.fromJS(_data["id"]) : <any>undefined;
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyOpggsLegislativeFormsForm7RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCompanyOpggsLegislativeFormsForm7RequestResponseDto {
    id?: FormRequestIdDto | undefined;
    statusMessages: StatusMessagesDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm2RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm3RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm4RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm5RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm6RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto implements IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto {
    id!: number;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentRequestDto {
    id: number;
}

export class GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto implements IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto {
    generatedDocument!: SecurePortalDocumentDto;

    constructor(data?: IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatedDocument = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedDocument = _data["generatedDocument"] ? SecurePortalDocumentDto.fromJS(_data["generatedDocument"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedDocument"] = this.generatedDocument ? this.generatedDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateCompanyOpggsLegislativeFormsForm7RequestDocumentResponseDto {
    generatedDocument: SecurePortalDocumentDto;
}

export class GetCompanyOpggsLegislativeFormsForm2RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm2RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm2RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm2RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm2RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm2RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm2RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm2RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    countries!: SecurePortalCountryDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm2RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.addressDetails = _data["addressDetails"] ? FormRequestAddressDetailsDto.fromJS(_data["addressDetails"]) : <any>undefined;
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SecurePortalCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm2RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm2RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm2RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    countries: SecurePortalCountryDto[];
}

export class GetCompanyOpggsLegislativeFormsForm3RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm3RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm3RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm3RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm3RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm3RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm3RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm3RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    hasInvalidTitlesOnForm!: boolean;
    additionalTitles!: TitleInfoDto[];
    countries!: SecurePortalCountryDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm3RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.additionalTitles = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.addressDetails = _data["addressDetails"] ? FormRequestAddressDetailsDto.fromJS(_data["addressDetails"]) : <any>undefined;
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
            this.hasInvalidTitlesOnForm = _data["hasInvalidTitlesOnForm"];
            if (Array.isArray(_data["additionalTitles"])) {
                this.additionalTitles = [] as any;
                for (let item of _data["additionalTitles"])
                    this.additionalTitles!.push(TitleInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SecurePortalCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm3RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm3RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        data["hasInvalidTitlesOnForm"] = this.hasInvalidTitlesOnForm;
        if (Array.isArray(this.additionalTitles)) {
            data["additionalTitles"] = [];
            for (let item of this.additionalTitles)
                data["additionalTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm3RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
    hasInvalidTitlesOnForm: boolean;
    additionalTitles: TitleInfoDto[];
    countries: SecurePortalCountryDto[];
}

export class GetCompanyOpggsLegislativeFormsForm4RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm4RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm4RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm4RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm4RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm4RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm4RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm4RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    allTitleholders!: FormRequestTitleholderInfoDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm4RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.allTitleholders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            if (Array.isArray(_data["allTitleholders"])) {
                this.allTitleholders = [] as any;
                for (let item of _data["allTitleholders"])
                    this.allTitleholders!.push(FormRequestTitleholderInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm4RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm4RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.allTitleholders)) {
            data["allTitleholders"] = [];
            for (let item of this.allTitleholders)
                data["allTitleholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm4RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    allTitleholders: FormRequestTitleholderInfoDto[];
}

export class GetCompanyOpggsLegislativeFormsForm5RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm5RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm5RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm5RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm5RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm5RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm5RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm5RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    nomineeTitleholder!: FormRequestTitleholderInfoDto;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm5RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.nomineeTitleholder = new FormRequestTitleholderInfoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.nomineeTitleholder = _data["nomineeTitleholder"] ? FormRequestTitleholderInfoDto.fromJS(_data["nomineeTitleholder"]) : new FormRequestTitleholderInfoDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm5RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm5RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["nomineeTitleholder"] = this.nomineeTitleholder ? this.nomineeTitleholder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm5RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    nomineeTitleholder: FormRequestTitleholderInfoDto;
}

export class GetCompanyOpggsLegislativeFormsForm6RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm6RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm6RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm6RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm6RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm6RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm6RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm6RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    allTitleholders!: FormRequestTitleholderInfoDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm6RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.allTitleholders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            if (Array.isArray(_data["allTitleholders"])) {
                this.allTitleholders = [] as any;
                for (let item of _data["allTitleholders"])
                    this.allTitleholders!.push(FormRequestTitleholderInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm6RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm6RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.allTitleholders)) {
            data["allTitleholders"] = [];
            for (let item of this.allTitleholders)
                data["allTitleholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm6RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    allTitleholders: FormRequestTitleholderInfoDto[];
}

export class GetCompanyOpggsLegislativeFormsForm7RequestRequestDto implements IGetCompanyOpggsLegislativeFormsForm7RequestRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm7RequestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm7RequestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm7RequestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm7RequestRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsForm7RequestResponseDto implements IGetCompanyOpggsLegislativeFormsForm7RequestResponseDto {
    canProgress!: boolean;
    statusMessages!: StatusMessagesDto;
    summary!: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    nomineeTitleholder!: FormRequestTitleholderInfoDto;

    constructor(data?: IGetCompanyOpggsLegislativeFormsForm7RequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
            this.summary = new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.nomineeTitleholder = new FormRequestTitleholderInfoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canProgress = _data["canProgress"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.summary = _data["summary"] ? CompanyOpggsLegislativeFormsFormRequestSummaryDto.fromJS(_data["summary"]) : new CompanyOpggsLegislativeFormsFormRequestSummaryDto();
            this.nomineeTitleholder = _data["nomineeTitleholder"] ? FormRequestTitleholderInfoDto.fromJS(_data["nomineeTitleholder"]) : new FormRequestTitleholderInfoDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsForm7RequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsForm7RequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canProgress"] = this.canProgress;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["nomineeTitleholder"] = this.nomineeTitleholder ? this.nomineeTitleholder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsForm7RequestResponseDto {
    canProgress: boolean;
    statusMessages: StatusMessagesDto;
    summary: CompanyOpggsLegislativeFormsFormRequestSummaryDto;
    nomineeTitleholder: FormRequestTitleholderInfoDto;
}

export class GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto implements IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto {
    type!: LegislativeFormRequestFormDocumentationDigitalSignatureTypeEnum;
    name?: string | undefined;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto {
    type: LegislativeFormRequestFormDocumentationDigitalSignatureTypeEnum;
    name?: string | undefined;
}

export class GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto implements IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto {
    companyId!: number;
    companyName?: string | undefined;
    availableSignatureTypes!: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableSignatureTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto {
    companyId: number;
    companyName?: string | undefined;
    availableSignatureTypes: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypeItemDto[];
}

export class GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto implements IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto {
    companyId!: number;
    companyName?: string | undefined;
    status?: string | undefined;
    signedSignatureTypes?: string | undefined;
    lastSignedDatetime?: Date | undefined;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.status = _data["status"];
            this.signedSignatureTypes = _data["signedSignatureTypes"];
            this.lastSignedDatetime = _data["lastSignedDatetime"] ? new Date(_data["lastSignedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["status"] = this.status;
        data["signedSignatureTypes"] = this.signedSignatureTypes;
        data["lastSignedDatetime"] = this.lastSignedDatetime ? this.lastSignedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto {
    companyId: number;
    companyName?: string | undefined;
    status?: string | undefined;
    signedSignatureTypes?: string | undefined;
    lastSignedDatetime?: Date | undefined;
}

export class GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto implements IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto {
    companySignatures!: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto[];
    availableSignatureTypes!: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companySignatures = [];
            this.availableSignatureTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companySignatures"])) {
                this.companySignatures = [] as any;
                for (let item of _data["companySignatures"])
                    this.companySignatures!.push(GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto.fromJS(item));
            }
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companySignatures)) {
            data["companySignatures"] = [];
            for (let item of this.companySignatures)
                data["companySignatures"].push(item.toJSON());
        }
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto {
    companySignatures: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureCompanySignatureDto[];
    availableSignatureTypes: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureAvailableSignatureTypesDto[];
}

export class GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto implements IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto {
    fileId!: number;
    fileName!: string;
    fileSize!: number;
    uploadedDatetime!: Date;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadedDatetime = _data["uploadedDatetime"] ? new Date(_data["uploadedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadedDatetime"] = this.uploadedDatetime ? this.uploadedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto {
    fileId: number;
    fileName: string;
    fileSize: number;
    uploadedDatetime: Date;
}

export class GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto implements IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto implements IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto {
    versionNumber!: number;
    formType!: LegislativeFormTypeEnum;
    signatureType?: LegislativeFormRequestFormDocumentationSignatureTypeEnum | undefined;
    isSigned!: boolean;
    isForSigning!: boolean;
    wetSignatureDetails?: GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto | undefined;
    digitalSignatureDetails?: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto | undefined;
    files!: GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto[];
    statusMessages!: StatusMessagesDto;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
            this.statusMessages = new StatusMessagesDto();
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.formType = _data["formType"];
            this.signatureType = _data["signatureType"];
            this.isSigned = _data["isSigned"];
            this.isForSigning = _data["isForSigning"];
            this.wetSignatureDetails = _data["wetSignatureDetails"] ? GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto.fromJS(_data["wetSignatureDetails"]) : <any>undefined;
            this.digitalSignatureDetails = _data["digitalSignatureDetails"] ? GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto.fromJS(_data["digitalSignatureDetails"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto.fromJS(item));
            }
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["formType"] = this.formType;
        data["signatureType"] = this.signatureType;
        data["isSigned"] = this.isSigned;
        data["isForSigning"] = this.isForSigning;
        data["wetSignatureDetails"] = this.wetSignatureDetails ? this.wetSignatureDetails.toJSON() : <any>undefined;
        data["digitalSignatureDetails"] = this.digitalSignatureDetails ? this.digitalSignatureDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestFormDocumentationResponseDto {
    versionNumber: number;
    formType: LegislativeFormTypeEnum;
    signatureType?: LegislativeFormRequestFormDocumentationSignatureTypeEnum | undefined;
    isSigned: boolean;
    isForSigning: boolean;
    wetSignatureDetails?: GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto | undefined;
    digitalSignatureDetails?: GetCompanyOpggsLegislativeFormsFormRequestDigitalSignatureDetailsDto | undefined;
    files: GetCompanyOpggsLegislativeFormsFormRequestFormDocumentationFileDto[];
    statusMessages: StatusMessagesDto;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto implements IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto {
    titleId!: string;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataRequestDto {
    titleId: string;
}

export class GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto implements IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto {
    titleNumber?: string | undefined;
    formTypeIds!: number[];
    selectableTitleholders!: GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto[];
    allTitleholders!: FormRequestTitleholderInfoDto[];
    form4NomineeTitleholder?: FormRequestTitleholderInfoDto | undefined;
    form6NomineeTitleholder?: FormRequestTitleholderInfoDto | undefined;
    countries!: SecurePortalCountryDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formTypeIds = [];
            this.selectableTitleholders = [];
            this.allTitleholders = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleNumber = _data["titleNumber"];
            if (Array.isArray(_data["formTypeIds"])) {
                this.formTypeIds = [] as any;
                for (let item of _data["formTypeIds"])
                    this.formTypeIds!.push(item);
            }
            if (Array.isArray(_data["selectableTitleholders"])) {
                this.selectableTitleholders = [] as any;
                for (let item of _data["selectableTitleholders"])
                    this.selectableTitleholders!.push(GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["allTitleholders"])) {
                this.allTitleholders = [] as any;
                for (let item of _data["allTitleholders"])
                    this.allTitleholders!.push(FormRequestTitleholderInfoDto.fromJS(item));
            }
            this.form4NomineeTitleholder = _data["form4NomineeTitleholder"] ? FormRequestTitleholderInfoDto.fromJS(_data["form4NomineeTitleholder"]) : <any>undefined;
            this.form6NomineeTitleholder = _data["form6NomineeTitleholder"] ? FormRequestTitleholderInfoDto.fromJS(_data["form6NomineeTitleholder"]) : <any>undefined;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SecurePortalCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleNumber"] = this.titleNumber;
        if (Array.isArray(this.formTypeIds)) {
            data["formTypeIds"] = [];
            for (let item of this.formTypeIds)
                data["formTypeIds"].push(item);
        }
        if (Array.isArray(this.selectableTitleholders)) {
            data["selectableTitleholders"] = [];
            for (let item of this.selectableTitleholders)
                data["selectableTitleholders"].push(item.toJSON());
        }
        if (Array.isArray(this.allTitleholders)) {
            data["allTitleholders"] = [];
            for (let item of this.allTitleholders)
                data["allTitleholders"].push(item.toJSON());
        }
        data["form4NomineeTitleholder"] = this.form4NomineeTitleholder ? this.form4NomineeTitleholder.toJSON() : <any>undefined;
        data["form6NomineeTitleholder"] = this.form6NomineeTitleholder ? this.form6NomineeTitleholder.toJSON() : <any>undefined;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestReferenceDataResponseDto {
    titleNumber?: string | undefined;
    formTypeIds: number[];
    selectableTitleholders: GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto[];
    allTitleholders: FormRequestTitleholderInfoDto[];
    form4NomineeTitleholder?: FormRequestTitleholderInfoDto | undefined;
    form6NomineeTitleholder?: FormRequestTitleholderInfoDto | undefined;
    countries: SecurePortalCountryDto[];
}

export class GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto implements IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto {
    signatureType!: LegislativeFormRequestFormDocumentationSignatureTypeEnum;
    description?: string | undefined;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signatureType = _data["signatureType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signatureType"] = this.signatureType;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto {
    signatureType: LegislativeFormRequestFormDocumentationSignatureTypeEnum;
    description?: string | undefined;
}

export class GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto implements IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
    id!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
    id: number;
}

export class GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto implements IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
    versionNumber!: number;
    signatureType?: GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto | undefined;
    availableSignatureTypes?: GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto[] | undefined;
    isDraft!: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.signatureType = _data["signatureType"] ? GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto.fromJS(_data["signatureType"]) : <any>undefined;
            if (Array.isArray(_data["availableSignatureTypes"])) {
                this.availableSignatureTypes = [] as any;
                for (let item of _data["availableSignatureTypes"])
                    this.availableSignatureTypes!.push(GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto.fromJS(item));
            }
            this.isDraft = _data["isDraft"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["signatureType"] = this.signatureType ? this.signatureType.toJSON() : <any>undefined;
        if (Array.isArray(this.availableSignatureTypes)) {
            data["availableSignatureTypes"] = [];
            for (let item of this.availableSignatureTypes)
                data["availableSignatureTypes"].push(item.toJSON());
        }
        data["isDraft"] = this.isDraft;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
    versionNumber: number;
    signatureType?: GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto | undefined;
    availableSignatureTypes?: GetCompanyOpggsLegislativeFormsFormRequestSignatureTypeItemDto[] | undefined;
    isDraft: boolean;
    statusMessages?: StatusMessagesDto | undefined;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto implements IGetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto {
    companyId!: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isAcnOrArbnRequired!: boolean;
    additionalTitles?: TitleInfoDto[] | undefined;
    becomingARegisteredTitleholderDate!: Date;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.isAcnOrArbnRequired = _data["isAcnOrArbnRequired"];
            if (Array.isArray(_data["additionalTitles"])) {
                this.additionalTitles = [] as any;
                for (let item of _data["additionalTitles"])
                    this.additionalTitles!.push(TitleInfoDto.fromJS(item));
            }
            this.becomingARegisteredTitleholderDate = _data["becomingARegisteredTitleholderDate"] ? new Date(_data["becomingARegisteredTitleholderDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["isAcnOrArbnRequired"] = this.isAcnOrArbnRequired;
        if (Array.isArray(this.additionalTitles)) {
            data["additionalTitles"] = [];
            for (let item of this.additionalTitles)
                data["additionalTitles"].push(item.toJSON());
        }
        data["becomingARegisteredTitleholderDate"] = this.becomingARegisteredTitleholderDate ? this.becomingARegisteredTitleholderDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestTitleholderDetailsDto {
    companyId: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isAcnOrArbnRequired: boolean;
    additionalTitles?: TitleInfoDto[] | undefined;
    becomingARegisteredTitleholderDate: Date;
}

export class GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto implements IGetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto {
    configuration!: FormDocumentationConfigurationDto;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new FormDocumentationConfigurationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? FormDocumentationConfigurationDto.fromJS(_data["configuration"]) : new FormDocumentationConfigurationDto();
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestWetSignatureDetailsDto {
    configuration: FormDocumentationConfigurationDto;
}

export class SaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto implements ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto {
    id!: number;
    versionNumber!: number;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.addressDetails = _data["addressDetails"] ? FormRequestAddressDetailsDto.fromJS(_data["addressDetails"]) : <any>undefined;
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsRequestDto {
    id: number;
    versionNumber: number;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
}

export class SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto implements ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsForm2RequestDetailsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto implements ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto {
    id!: number;
    versionNumber!: number;
    titleIds?: string[] | undefined;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["titleIds"])) {
                this.titleIds = [] as any;
                for (let item of _data["titleIds"])
                    this.titleIds!.push(item);
            }
            this.addressDetails = _data["addressDetails"] ? FormRequestAddressDetailsDto.fromJS(_data["addressDetails"]) : <any>undefined;
            this.registeredTitleholderDetails = _data["registeredTitleholderDetails"] ? FormRequestRegisteredTitleholderDetailsDto.fromJS(_data["registeredTitleholderDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.titleIds)) {
            data["titleIds"] = [];
            for (let item of this.titleIds)
                data["titleIds"].push(item);
        }
        data["addressDetails"] = this.addressDetails ? this.addressDetails.toJSON() : <any>undefined;
        data["registeredTitleholderDetails"] = this.registeredTitleholderDetails ? this.registeredTitleholderDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsRequestDto {
    id: number;
    versionNumber: number;
    titleIds?: string[] | undefined;
    addressDetails?: FormRequestAddressDetailsDto | undefined;
    registeredTitleholderDetails?: FormRequestRegisteredTitleholderDetailsDto | undefined;
}

export class SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto implements ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsForm3RequestDetailsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto implements ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto {
    id!: number;
    versionNumber!: number;
    companyId!: number;
    digitalSignatureType!: LegislativeFormRequestFormDocumentationDigitalSignatureTypeEnum;
    clientOffsetMinutes!: number;
    poaLocation?: string | undefined;
    poaPosition?: string | undefined;
    isPoaPreviouslyProvided?: boolean | undefined;
    poaDate?: Date | undefined;
    poaDateOffsetMinutes?: number | undefined;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.companyId = _data["companyId"];
            this.digitalSignatureType = _data["digitalSignatureType"];
            this.clientOffsetMinutes = _data["clientOffsetMinutes"];
            this.poaLocation = _data["poaLocation"];
            this.poaPosition = _data["poaPosition"];
            this.isPoaPreviouslyProvided = _data["isPoaPreviouslyProvided"];
            this.poaDate = _data["poaDate"] ? new Date(_data["poaDate"].toString()) : <any>undefined;
            this.poaDateOffsetMinutes = _data["poaDateOffsetMinutes"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["companyId"] = this.companyId;
        data["digitalSignatureType"] = this.digitalSignatureType;
        data["clientOffsetMinutes"] = this.clientOffsetMinutes;
        data["poaLocation"] = this.poaLocation;
        data["poaPosition"] = this.poaPosition;
        data["isPoaPreviouslyProvided"] = this.isPoaPreviouslyProvided;
        data["poaDate"] = this.poaDate ? this.poaDate.toISOString() : <any>undefined;
        data["poaDateOffsetMinutes"] = this.poaDateOffsetMinutes;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureRequestDto {
    id: number;
    versionNumber: number;
    companyId: number;
    digitalSignatureType: LegislativeFormRequestFormDocumentationDigitalSignatureTypeEnum;
    clientOffsetMinutes: number;
    poaLocation?: string | undefined;
    poaPosition?: string | undefined;
    isPoaPreviouslyProvided?: boolean | undefined;
    poaDate?: Date | undefined;
    poaDateOffsetMinutes?: number | undefined;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto implements ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestDigitalSignatureResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto implements ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
    id!: number;
    versionNumber!: number;
    signatureType!: LegislativeFormRequestFormDocumentationSignatureTypeEnum;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.signatureType = _data["signatureType"];
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["signatureType"] = this.signatureType;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeRequestDto {
    id: number;
    versionNumber: number;
    signatureType: LegislativeFormRequestFormDocumentationSignatureTypeEnum;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto implements ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestSignatureTypeResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto implements ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto {
    id!: number;
    versionNumber!: number;
    fileIds?: number[] | undefined;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationRequestDto {
    id: number;
    versionNumber: number;
    fileIds?: number[] | undefined;
}

export class SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto implements ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyOpggsLegislativeFormsFormRequestWetFormDocumentationResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm2RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm3RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm4RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm5RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm6RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto implements ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningRequestDto {
    id: number;
    versionNumber: number;
}

export class SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto implements ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetCompanyOpggsLegislativeFormsForm7RequestAsReadyForSigningResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm2RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm3RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm4RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm5RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm6RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto implements ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalRequestDto {
    id: number;
    versionNumber: number;
}

export class SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto implements ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitCompanyOpggsLegislativeFormsForm7RequestToNoptaForApprovalResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyOpggsLegislativeFormsFormListItemDto implements IGetCompanyOpggsLegislativeFormsFormListItemDto {
    id!: number;
    formTypeId!: number;
    titleLink!: TitleLinkDto;
    relatedTitleholderId!: number;
    relatedTitleholderName?: string | undefined;
    effectiveFromDate?: Date | undefined;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLink = new TitleLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formTypeId = _data["formTypeId"];
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : new TitleLinkDto();
            this.relatedTitleholderId = _data["relatedTitleholderId"];
            this.relatedTitleholderName = _data["relatedTitleholderName"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formTypeId"] = this.formTypeId;
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["relatedTitleholderId"] = this.relatedTitleholderId;
        data["relatedTitleholderName"] = this.relatedTitleholderName;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormListItemDto {
    id: number;
    formTypeId: number;
    titleLink: TitleLinkDto;
    relatedTitleholderId: number;
    relatedTitleholderName?: string | undefined;
    effectiveFromDate?: Date | undefined;
    fileId: number;
}

export class GetCompanyOpggsLegislativeFormsFormRequestListItemDto implements IGetCompanyOpggsLegislativeFormsFormRequestListItemDto {
    id!: number;
    formTypeId!: number;
    titleLinks!: TitleLinkDto[];
    titleNumbersDisplay?: string | undefined;
    relatedTitleholderId!: number;
    relatedTitleholderName?: string | undefined;
    lodgedByCompanyId!: number;
    lodgedByCompanyName?: string | undefined;
    submittedDate?: Date | undefined;
    status?: string | undefined;

    constructor(data?: IGetCompanyOpggsLegislativeFormsFormRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formTypeId = _data["formTypeId"];
            if (Array.isArray(_data["titleLinks"])) {
                this.titleLinks = [] as any;
                for (let item of _data["titleLinks"])
                    this.titleLinks!.push(TitleLinkDto.fromJS(item));
            }
            this.titleNumbersDisplay = _data["titleNumbersDisplay"];
            this.relatedTitleholderId = _data["relatedTitleholderId"];
            this.relatedTitleholderName = _data["relatedTitleholderName"];
            this.lodgedByCompanyId = _data["lodgedByCompanyId"];
            this.lodgedByCompanyName = _data["lodgedByCompanyName"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsFormRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsFormRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formTypeId"] = this.formTypeId;
        if (Array.isArray(this.titleLinks)) {
            data["titleLinks"] = [];
            for (let item of this.titleLinks)
                data["titleLinks"].push(item.toJSON());
        }
        data["titleNumbersDisplay"] = this.titleNumbersDisplay;
        data["relatedTitleholderId"] = this.relatedTitleholderId;
        data["relatedTitleholderName"] = this.relatedTitleholderName;
        data["lodgedByCompanyId"] = this.lodgedByCompanyId;
        data["lodgedByCompanyName"] = this.lodgedByCompanyName;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsFormRequestListItemDto {
    id: number;
    formTypeId: number;
    titleLinks: TitleLinkDto[];
    titleNumbersDisplay?: string | undefined;
    relatedTitleholderId: number;
    relatedTitleholderName?: string | undefined;
    lodgedByCompanyId: number;
    lodgedByCompanyName?: string | undefined;
    submittedDate?: Date | undefined;
    status?: string | undefined;
}

export class GetCompanyOpggsLegislativeFormsListRequestDto implements IGetCompanyOpggsLegislativeFormsListRequestDto {

    constructor(data?: IGetCompanyOpggsLegislativeFormsListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsListRequestDto {
}

export class GetCompanyOpggsLegislativeFormsListResponseDto implements IGetCompanyOpggsLegislativeFormsListResponseDto {
    legislativeFormRequests!: GetCompanyOpggsLegislativeFormsFormRequestListItemDto[];
    legislativeForms!: GetCompanyOpggsLegislativeFormsFormListItemDto[];

    constructor(data?: IGetCompanyOpggsLegislativeFormsListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.legislativeFormRequests = [];
            this.legislativeForms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["legislativeFormRequests"])) {
                this.legislativeFormRequests = [] as any;
                for (let item of _data["legislativeFormRequests"])
                    this.legislativeFormRequests!.push(GetCompanyOpggsLegislativeFormsFormRequestListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["legislativeForms"])) {
                this.legislativeForms = [] as any;
                for (let item of _data["legislativeForms"])
                    this.legislativeForms!.push(GetCompanyOpggsLegislativeFormsFormListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsLegislativeFormsListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsLegislativeFormsListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.legislativeFormRequests)) {
            data["legislativeFormRequests"] = [];
            for (let item of this.legislativeFormRequests)
                data["legislativeFormRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.legislativeForms)) {
            data["legislativeForms"] = [];
            for (let item of this.legislativeForms)
                data["legislativeForms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsLegislativeFormsListResponseDto {
    legislativeFormRequests: GetCompanyOpggsLegislativeFormsFormRequestListItemDto[];
    legislativeForms: GetCompanyOpggsLegislativeFormsFormListItemDto[];
}

export class GetCompanyOpggsTitleDetailsBlockDto implements IGetCompanyOpggsTitleDetailsBlockDto {
    blockId!: number;
    blockNumber!: number;
    isPartBlock?: string | undefined;
    mapSheetCode?: string | undefined;
    mapSheetName?: string | undefined;
    locationName?: string | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blockId = _data["blockId"];
            this.blockNumber = _data["blockNumber"];
            this.isPartBlock = _data["isPartBlock"];
            this.mapSheetCode = _data["mapSheetCode"];
            this.mapSheetName = _data["mapSheetName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockId"] = this.blockId;
        data["blockNumber"] = this.blockNumber;
        data["isPartBlock"] = this.isPartBlock;
        data["mapSheetCode"] = this.mapSheetCode;
        data["mapSheetName"] = this.mapSheetName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsBlockDto {
    blockId: number;
    blockNumber: number;
    isPartBlock?: string | undefined;
    mapSheetCode?: string | undefined;
    mapSheetName?: string | undefined;
    locationName?: string | undefined;
}

export class GetCompanyOpggsTitleDetailsBlocksAndLocationsDto implements IGetCompanyOpggsTitleDetailsBlocksAndLocationsDto {
    blocks?: GetCompanyOpggsTitleDetailsBlockDto[] | undefined;
    locations?: GetCompanyOpggsTitleDetailsLocationDto[] | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsBlocksAndLocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(GetCompanyOpggsTitleDetailsBlockDto.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(GetCompanyOpggsTitleDetailsLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsBlocksAndLocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsBlocksAndLocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsBlocksAndLocationsDto {
    blocks?: GetCompanyOpggsTitleDetailsBlockDto[] | undefined;
    locations?: GetCompanyOpggsTitleDetailsLocationDto[] | undefined;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm2Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm2Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    registeredTitleholderCompanyId!: number;
    registeredTitleholderCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    becomingARegisteredTitleholderDate!: Date;
    registeredTitleholderPhone?: string | undefined;
    registeredTitleholderEmail?: string | undefined;
    address!: GetCompanyOpggsTitleDetailsLegislativeFormAddressDto;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new GetCompanyOpggsTitleDetailsLegislativeFormAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.registeredTitleholderCompanyId = _data["registeredTitleholderCompanyId"];
            this.registeredTitleholderCompanyName = _data["registeredTitleholderCompanyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.becomingARegisteredTitleholderDate = _data["becomingARegisteredTitleholderDate"] ? new Date(_data["becomingARegisteredTitleholderDate"].toString()) : <any>undefined;
            this.registeredTitleholderPhone = _data["registeredTitleholderPhone"];
            this.registeredTitleholderEmail = _data["registeredTitleholderEmail"];
            this.address = _data["address"] ? GetCompanyOpggsTitleDetailsLegislativeFormAddressDto.fromJS(_data["address"]) : new GetCompanyOpggsTitleDetailsLegislativeFormAddressDto();
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["registeredTitleholderCompanyId"] = this.registeredTitleholderCompanyId;
        data["registeredTitleholderCompanyName"] = this.registeredTitleholderCompanyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["becomingARegisteredTitleholderDate"] = this.becomingARegisteredTitleholderDate ? this.becomingARegisteredTitleholderDate.toISOString() : <any>undefined;
        data["registeredTitleholderPhone"] = this.registeredTitleholderPhone;
        data["registeredTitleholderEmail"] = this.registeredTitleholderEmail;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm2Dto {
    id: number;
    effectiveFromDatetime: Date;
    registeredTitleholderCompanyId: number;
    registeredTitleholderCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    becomingARegisteredTitleholderDate: Date;
    registeredTitleholderPhone?: string | undefined;
    registeredTitleholderEmail?: string | undefined;
    address: GetCompanyOpggsTitleDetailsLegislativeFormAddressDto;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm3Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm3Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    registeredTitleholderCompanyId!: number;
    registeredTitleholderCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    registeredTitleholderPhone?: string | undefined;
    registeredTitleholderEmail?: string | undefined;
    address!: GetCompanyOpggsTitleDetailsLegislativeFormAddressDto;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new GetCompanyOpggsTitleDetailsLegislativeFormAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.registeredTitleholderCompanyId = _data["registeredTitleholderCompanyId"];
            this.registeredTitleholderCompanyName = _data["registeredTitleholderCompanyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.registeredTitleholderPhone = _data["registeredTitleholderPhone"];
            this.registeredTitleholderEmail = _data["registeredTitleholderEmail"];
            this.address = _data["address"] ? GetCompanyOpggsTitleDetailsLegislativeFormAddressDto.fromJS(_data["address"]) : new GetCompanyOpggsTitleDetailsLegislativeFormAddressDto();
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["registeredTitleholderCompanyId"] = this.registeredTitleholderCompanyId;
        data["registeredTitleholderCompanyName"] = this.registeredTitleholderCompanyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["registeredTitleholderPhone"] = this.registeredTitleholderPhone;
        data["registeredTitleholderEmail"] = this.registeredTitleholderEmail;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm3Dto {
    id: number;
    effectiveFromDatetime: Date;
    registeredTitleholderCompanyId: number;
    registeredTitleholderCompanyName?: string | undefined;
    acnOrArbn?: string | undefined;
    registeredTitleholderPhone?: string | undefined;
    registeredTitleholderEmail?: string | undefined;
    address: GetCompanyOpggsTitleDetailsLegislativeFormAddressDto;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm4Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm4Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    nomineeTitleholderCompanyId!: number;
    nomineeTitleholderCompanyName?: string | undefined;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm4Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.nomineeTitleholderCompanyId = _data["nomineeTitleholderCompanyId"];
            this.nomineeTitleholderCompanyName = _data["nomineeTitleholderCompanyName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm4Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm4Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["nomineeTitleholderCompanyId"] = this.nomineeTitleholderCompanyId;
        data["nomineeTitleholderCompanyName"] = this.nomineeTitleholderCompanyName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm4Dto {
    id: number;
    effectiveFromDatetime: Date;
    nomineeTitleholderCompanyId: number;
    nomineeTitleholderCompanyName?: string | undefined;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm5Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm5Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    titleholderGivingNoticeCompanyId!: number;
    titleholderGivingNoticeCompanyName?: string | undefined;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm5Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.titleholderGivingNoticeCompanyId = _data["titleholderGivingNoticeCompanyId"];
            this.titleholderGivingNoticeCompanyName = _data["titleholderGivingNoticeCompanyName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm5Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm5Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["titleholderGivingNoticeCompanyId"] = this.titleholderGivingNoticeCompanyId;
        data["titleholderGivingNoticeCompanyName"] = this.titleholderGivingNoticeCompanyName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm5Dto {
    id: number;
    effectiveFromDatetime: Date;
    titleholderGivingNoticeCompanyId: number;
    titleholderGivingNoticeCompanyName?: string | undefined;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm6Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm6Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    nomineeTitleholderCompanyId!: number;
    nomineeTitleholderCompanyName?: string | undefined;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm6Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.nomineeTitleholderCompanyId = _data["nomineeTitleholderCompanyId"];
            this.nomineeTitleholderCompanyName = _data["nomineeTitleholderCompanyName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm6Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm6Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["nomineeTitleholderCompanyId"] = this.nomineeTitleholderCompanyId;
        data["nomineeTitleholderCompanyName"] = this.nomineeTitleholderCompanyName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm6Dto {
    id: number;
    effectiveFromDatetime: Date;
    nomineeTitleholderCompanyId: number;
    nomineeTitleholderCompanyName?: string | undefined;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeForm7Dto implements IGetCompanyOpggsTitleDetailsLegislativeForm7Dto {
    id!: number;
    effectiveFromDatetime!: Date;
    titleholderGivingNoticeCompanyId!: number;
    titleholderGivingNoticeCompanyName?: string | undefined;
    fileId!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeForm7Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFromDatetime = _data["effectiveFromDatetime"] ? new Date(_data["effectiveFromDatetime"].toString()) : <any>undefined;
            this.titleholderGivingNoticeCompanyId = _data["titleholderGivingNoticeCompanyId"];
            this.titleholderGivingNoticeCompanyName = _data["titleholderGivingNoticeCompanyName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeForm7Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeForm7Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFromDatetime"] = this.effectiveFromDatetime ? this.effectiveFromDatetime.toISOString() : <any>undefined;
        data["titleholderGivingNoticeCompanyId"] = this.titleholderGivingNoticeCompanyId;
        data["titleholderGivingNoticeCompanyName"] = this.titleholderGivingNoticeCompanyName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeForm7Dto {
    id: number;
    effectiveFromDatetime: Date;
    titleholderGivingNoticeCompanyId: number;
    titleholderGivingNoticeCompanyName?: string | undefined;
    fileId: number;
}

export class GetCompanyOpggsTitleDetailsLegislativeFormAddressDto implements IGetCompanyOpggsTitleDetailsLegislativeFormAddressDto {
    streetAddress?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    country?: string | undefined;
    countrySubdivision?: string | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeFormAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.country = _data["country"];
            this.countrySubdivision = _data["countrySubdivision"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeFormAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeFormAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["country"] = this.country;
        data["countrySubdivision"] = this.countrySubdivision;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeFormAddressDto {
    streetAddress?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    country?: string | undefined;
    countrySubdivision?: string | undefined;
}

export class GetCompanyOpggsTitleDetailsLegislativeFormRequestDto implements IGetCompanyOpggsTitleDetailsLegislativeFormRequestDto {
    id!: number;
    formTypeId!: number;
    formRequestState?: string | undefined;
    lodgedByCompanyId!: number;
    lodgedByCompanyName?: string | undefined;
    submittedDate?: Date | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeFormRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formTypeId = _data["formTypeId"];
            this.formRequestState = _data["formRequestState"];
            this.lodgedByCompanyId = _data["lodgedByCompanyId"];
            this.lodgedByCompanyName = _data["lodgedByCompanyName"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeFormRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeFormRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formTypeId"] = this.formTypeId;
        data["formRequestState"] = this.formRequestState;
        data["lodgedByCompanyId"] = this.lodgedByCompanyId;
        data["lodgedByCompanyName"] = this.lodgedByCompanyName;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeFormRequestDto {
    id: number;
    formTypeId: number;
    formRequestState?: string | undefined;
    lodgedByCompanyId: number;
    lodgedByCompanyName?: string | undefined;
    submittedDate?: Date | undefined;
}

export class GetCompanyOpggsTitleDetailsLegislativeFormsDto implements IGetCompanyOpggsTitleDetailsLegislativeFormsDto {
    form2Forms?: GetCompanyOpggsTitleDetailsLegislativeForm2Dto[] | undefined;
    form3Forms?: GetCompanyOpggsTitleDetailsLegislativeForm3Dto[] | undefined;
    form4Form?: GetCompanyOpggsTitleDetailsLegislativeForm4Dto | undefined;
    form5Form?: GetCompanyOpggsTitleDetailsLegislativeForm5Dto | undefined;
    form6Form?: GetCompanyOpggsTitleDetailsLegislativeForm6Dto | undefined;
    form7Form?: GetCompanyOpggsTitleDetailsLegislativeForm7Dto | undefined;
    pendingFormRequests?: GetCompanyOpggsTitleDetailsLegislativeFormRequestDto[] | undefined;
    canManageLegislativeForms!: boolean;
    hasActiveForm4Form!: boolean;
    hasActiveForm6Form!: boolean;

    constructor(data?: IGetCompanyOpggsTitleDetailsLegislativeFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["form2Forms"])) {
                this.form2Forms = [] as any;
                for (let item of _data["form2Forms"])
                    this.form2Forms!.push(GetCompanyOpggsTitleDetailsLegislativeForm2Dto.fromJS(item));
            }
            if (Array.isArray(_data["form3Forms"])) {
                this.form3Forms = [] as any;
                for (let item of _data["form3Forms"])
                    this.form3Forms!.push(GetCompanyOpggsTitleDetailsLegislativeForm3Dto.fromJS(item));
            }
            this.form4Form = _data["form4Form"] ? GetCompanyOpggsTitleDetailsLegislativeForm4Dto.fromJS(_data["form4Form"]) : <any>undefined;
            this.form5Form = _data["form5Form"] ? GetCompanyOpggsTitleDetailsLegislativeForm5Dto.fromJS(_data["form5Form"]) : <any>undefined;
            this.form6Form = _data["form6Form"] ? GetCompanyOpggsTitleDetailsLegislativeForm6Dto.fromJS(_data["form6Form"]) : <any>undefined;
            this.form7Form = _data["form7Form"] ? GetCompanyOpggsTitleDetailsLegislativeForm7Dto.fromJS(_data["form7Form"]) : <any>undefined;
            if (Array.isArray(_data["pendingFormRequests"])) {
                this.pendingFormRequests = [] as any;
                for (let item of _data["pendingFormRequests"])
                    this.pendingFormRequests!.push(GetCompanyOpggsTitleDetailsLegislativeFormRequestDto.fromJS(item));
            }
            this.canManageLegislativeForms = _data["canManageLegislativeForms"];
            this.hasActiveForm4Form = _data["hasActiveForm4Form"];
            this.hasActiveForm6Form = _data["hasActiveForm6Form"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLegislativeFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLegislativeFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.form2Forms)) {
            data["form2Forms"] = [];
            for (let item of this.form2Forms)
                data["form2Forms"].push(item.toJSON());
        }
        if (Array.isArray(this.form3Forms)) {
            data["form3Forms"] = [];
            for (let item of this.form3Forms)
                data["form3Forms"].push(item.toJSON());
        }
        data["form4Form"] = this.form4Form ? this.form4Form.toJSON() : <any>undefined;
        data["form5Form"] = this.form5Form ? this.form5Form.toJSON() : <any>undefined;
        data["form6Form"] = this.form6Form ? this.form6Form.toJSON() : <any>undefined;
        data["form7Form"] = this.form7Form ? this.form7Form.toJSON() : <any>undefined;
        if (Array.isArray(this.pendingFormRequests)) {
            data["pendingFormRequests"] = [];
            for (let item of this.pendingFormRequests)
                data["pendingFormRequests"].push(item.toJSON());
        }
        data["canManageLegislativeForms"] = this.canManageLegislativeForms;
        data["hasActiveForm4Form"] = this.hasActiveForm4Form;
        data["hasActiveForm6Form"] = this.hasActiveForm6Form;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLegislativeFormsDto {
    form2Forms?: GetCompanyOpggsTitleDetailsLegislativeForm2Dto[] | undefined;
    form3Forms?: GetCompanyOpggsTitleDetailsLegislativeForm3Dto[] | undefined;
    form4Form?: GetCompanyOpggsTitleDetailsLegislativeForm4Dto | undefined;
    form5Form?: GetCompanyOpggsTitleDetailsLegislativeForm5Dto | undefined;
    form6Form?: GetCompanyOpggsTitleDetailsLegislativeForm6Dto | undefined;
    form7Form?: GetCompanyOpggsTitleDetailsLegislativeForm7Dto | undefined;
    pendingFormRequests?: GetCompanyOpggsTitleDetailsLegislativeFormRequestDto[] | undefined;
    canManageLegislativeForms: boolean;
    hasActiveForm4Form: boolean;
    hasActiveForm6Form: boolean;
}

export class GetCompanyOpggsTitleDetailsLocationDto implements IGetCompanyOpggsTitleDetailsLocationDto {
    locationId!: number;
    locationName?: string | undefined;
    isActive!: boolean;
    substanceName?: string | undefined;
    statusName?: string | undefined;
    originalExpiryDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.isActive = _data["isActive"];
            this.substanceName = _data["substanceName"];
            this.statusName = _data["statusName"];
            this.originalExpiryDate = _data["originalExpiryDate"] ? new Date(_data["originalExpiryDate"].toString()) : <any>undefined;
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["isActive"] = this.isActive;
        data["substanceName"] = this.substanceName;
        data["statusName"] = this.statusName;
        data["originalExpiryDate"] = this.originalExpiryDate ? this.originalExpiryDate.toISOString() : <any>undefined;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsLocationDto {
    locationId: number;
    locationName?: string | undefined;
    isActive: boolean;
    substanceName?: string | undefined;
    statusName?: string | undefined;
    originalExpiryDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
}

export class GetCompanyOpggsTitleDetailsMapRequestDto implements IGetCompanyOpggsTitleDetailsMapRequestDto {
    titleId!: string;

    constructor(data?: IGetCompanyOpggsTitleDetailsMapRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsMapRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsMapRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsMapRequestDto {
    titleId: string;
}

export class GetCompanyOpggsTitleDetailsMapResponseDto implements IGetCompanyOpggsTitleDetailsMapResponseDto {
    isOnline!: boolean;
    isFeatureAvailable!: boolean;
    areaSqKm?: number | undefined;
    pinLatitude?: number | undefined;
    pinLongitude?: number | undefined;
    extentMinLatitude?: number | undefined;
    extentMinLongitude?: number | undefined;
    extentMaxLatitude?: number | undefined;
    extentMaxLongitude?: number | undefined;
    zoomLevel?: number | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsMapResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["isOnline"];
            this.isFeatureAvailable = _data["isFeatureAvailable"];
            this.areaSqKm = _data["areaSqKm"];
            this.pinLatitude = _data["pinLatitude"];
            this.pinLongitude = _data["pinLongitude"];
            this.extentMinLatitude = _data["extentMinLatitude"];
            this.extentMinLongitude = _data["extentMinLongitude"];
            this.extentMaxLatitude = _data["extentMaxLatitude"];
            this.extentMaxLongitude = _data["extentMaxLongitude"];
            this.zoomLevel = _data["zoomLevel"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsMapResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsMapResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnline"] = this.isOnline;
        data["isFeatureAvailable"] = this.isFeatureAvailable;
        data["areaSqKm"] = this.areaSqKm;
        data["pinLatitude"] = this.pinLatitude;
        data["pinLongitude"] = this.pinLongitude;
        data["extentMinLatitude"] = this.extentMinLatitude;
        data["extentMinLongitude"] = this.extentMinLongitude;
        data["extentMaxLatitude"] = this.extentMaxLatitude;
        data["extentMaxLongitude"] = this.extentMaxLongitude;
        data["zoomLevel"] = this.zoomLevel;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsMapResponseDto {
    isOnline: boolean;
    isFeatureAvailable: boolean;
    areaSqKm?: number | undefined;
    pinLatitude?: number | undefined;
    pinLongitude?: number | undefined;
    extentMinLatitude?: number | undefined;
    extentMinLongitude?: number | undefined;
    extentMaxLatitude?: number | undefined;
    extentMaxLongitude?: number | undefined;
    zoomLevel?: number | undefined;
}

export class GetCompanyOpggsTitleDetailsMemorialApplicationDto implements IGetCompanyOpggsTitleDetailsMemorialApplicationDto {
    applicationId!: string;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision?: string | undefined;
    implementedDate?: Date | undefined;
    registeredDatetime?: Date | undefined;
    fileId?: number | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsMemorialApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.applicationName = _data["applicationName"];
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.decision = _data["decision"];
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDatetime = _data["registeredDatetime"] ? new Date(_data["registeredDatetime"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsMemorialApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsMemorialApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["applicationName"] = this.applicationName;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["decision"] = this.decision;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDatetime"] = this.registeredDatetime ? this.registeredDatetime.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsMemorialApplicationDto {
    applicationId: string;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision?: string | undefined;
    implementedDate?: Date | undefined;
    registeredDatetime?: Date | undefined;
    fileId?: number | undefined;
}

export class GetCompanyOpggsTitleDetailsMemorialDto implements IGetCompanyOpggsTitleDetailsMemorialDto {
    applications?: GetCompanyOpggsTitleDetailsMemorialApplicationDto[] | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsMemorialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(GetCompanyOpggsTitleDetailsMemorialApplicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsMemorialDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsMemorialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsMemorialDto {
    applications?: GetCompanyOpggsTitleDetailsMemorialApplicationDto[] | undefined;
}

export class GetCompanyOpggsTitleDetailsRequestDto implements IGetCompanyOpggsTitleDetailsRequestDto {
    titleId!: string;

    constructor(data?: IGetCompanyOpggsTitleDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsRequestDto {
    titleId: string;
}

export class GetCompanyOpggsTitleDetailsResponseDto implements IGetCompanyOpggsTitleDetailsResponseDto {
    titleId!: string;
    titleNumber?: string | undefined;
    titleType!: TitleTypeEnum;
    titleTypeName?: string | undefined;
    title2SubType?: Title2SubTypeEnum | undefined;
    title2SubTypeTypeName?: string | undefined;
    isTitleActive!: boolean;
    summary?: GetCompanyOpggsTitleDetailsSummaryDto | undefined;
    titleholders?: GetCompanyOpggsTitleDetailsTitleholderDto[] | undefined;
    workProgram?: GetCompanyOpggsTitleDetailsWorkProgramDto | undefined;
    memorial?: GetCompanyOpggsTitleDetailsMemorialDto | undefined;
    blocksAndLocations?: GetCompanyOpggsTitleDetailsBlocksAndLocationsDto | undefined;
    legislativeForms?: GetCompanyOpggsTitleDetailsLegislativeFormsDto | undefined;
    canManageDraftApplications!: boolean;
    canViewLegislativeForms!: boolean;

    constructor(data?: IGetCompanyOpggsTitleDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titleTypeName = _data["titleTypeName"];
            this.title2SubType = _data["title2SubType"];
            this.title2SubTypeTypeName = _data["title2SubTypeTypeName"];
            this.isTitleActive = _data["isTitleActive"];
            this.summary = _data["summary"] ? GetCompanyOpggsTitleDetailsSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["titleholders"])) {
                this.titleholders = [] as any;
                for (let item of _data["titleholders"])
                    this.titleholders!.push(GetCompanyOpggsTitleDetailsTitleholderDto.fromJS(item));
            }
            this.workProgram = _data["workProgram"] ? GetCompanyOpggsTitleDetailsWorkProgramDto.fromJS(_data["workProgram"]) : <any>undefined;
            this.memorial = _data["memorial"] ? GetCompanyOpggsTitleDetailsMemorialDto.fromJS(_data["memorial"]) : <any>undefined;
            this.blocksAndLocations = _data["blocksAndLocations"] ? GetCompanyOpggsTitleDetailsBlocksAndLocationsDto.fromJS(_data["blocksAndLocations"]) : <any>undefined;
            this.legislativeForms = _data["legislativeForms"] ? GetCompanyOpggsTitleDetailsLegislativeFormsDto.fromJS(_data["legislativeForms"]) : <any>undefined;
            this.canManageDraftApplications = _data["canManageDraftApplications"];
            this.canViewLegislativeForms = _data["canViewLegislativeForms"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titleTypeName"] = this.titleTypeName;
        data["title2SubType"] = this.title2SubType;
        data["title2SubTypeTypeName"] = this.title2SubTypeTypeName;
        data["isTitleActive"] = this.isTitleActive;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.titleholders)) {
            data["titleholders"] = [];
            for (let item of this.titleholders)
                data["titleholders"].push(item.toJSON());
        }
        data["workProgram"] = this.workProgram ? this.workProgram.toJSON() : <any>undefined;
        data["memorial"] = this.memorial ? this.memorial.toJSON() : <any>undefined;
        data["blocksAndLocations"] = this.blocksAndLocations ? this.blocksAndLocations.toJSON() : <any>undefined;
        data["legislativeForms"] = this.legislativeForms ? this.legislativeForms.toJSON() : <any>undefined;
        data["canManageDraftApplications"] = this.canManageDraftApplications;
        data["canViewLegislativeForms"] = this.canViewLegislativeForms;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsResponseDto {
    titleId: string;
    titleNumber?: string | undefined;
    titleType: TitleTypeEnum;
    titleTypeName?: string | undefined;
    title2SubType?: Title2SubTypeEnum | undefined;
    title2SubTypeTypeName?: string | undefined;
    isTitleActive: boolean;
    summary?: GetCompanyOpggsTitleDetailsSummaryDto | undefined;
    titleholders?: GetCompanyOpggsTitleDetailsTitleholderDto[] | undefined;
    workProgram?: GetCompanyOpggsTitleDetailsWorkProgramDto | undefined;
    memorial?: GetCompanyOpggsTitleDetailsMemorialDto | undefined;
    blocksAndLocations?: GetCompanyOpggsTitleDetailsBlocksAndLocationsDto | undefined;
    legislativeForms?: GetCompanyOpggsTitleDetailsLegislativeFormsDto | undefined;
    canManageDraftApplications: boolean;
    canViewLegislativeForms: boolean;
}

export class GetCompanyOpggsTitleDetailsSummaryDto implements IGetCompanyOpggsTitleDetailsSummaryDto {
    titleStatus?: string | undefined;
    numberOfRenewals!: number;
    initialGrantDate!: Date;
    originalExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    numberOfBlocks!: number;
    hasPriorUsageRight!: boolean;
    isDesignatedFrontierArea?: string | undefined;
    pipelineLength?: number | undefined;
    pipelineName?: string | undefined;
    substanceName?: string | undefined;
    startPointName?: string | undefined;
    endPointName?: string | undefined;
    locationNames?: string[] | undefined;
    relatedTitleLinks?: TitleLinkDto[] | undefined;

    constructor(data?: IGetCompanyOpggsTitleDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleStatus = _data["titleStatus"];
            this.numberOfRenewals = _data["numberOfRenewals"];
            this.initialGrantDate = _data["initialGrantDate"] ? new Date(_data["initialGrantDate"].toString()) : <any>undefined;
            this.originalExpiryDate = _data["originalExpiryDate"] ? new Date(_data["originalExpiryDate"].toString()) : <any>undefined;
            this.lastRenewalDate = _data["lastRenewalDate"] ? new Date(_data["lastRenewalDate"].toString()) : <any>undefined;
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.offshoreAreaName = _data["offshoreAreaName"];
            this.basinName = _data["basinName"];
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.numberOfBlocks = _data["numberOfBlocks"];
            this.hasPriorUsageRight = _data["hasPriorUsageRight"];
            this.isDesignatedFrontierArea = _data["isDesignatedFrontierArea"];
            this.pipelineLength = _data["pipelineLength"];
            this.pipelineName = _data["pipelineName"];
            this.substanceName = _data["substanceName"];
            this.startPointName = _data["startPointName"];
            this.endPointName = _data["endPointName"];
            if (Array.isArray(_data["locationNames"])) {
                this.locationNames = [] as any;
                for (let item of _data["locationNames"])
                    this.locationNames!.push(item);
            }
            if (Array.isArray(_data["relatedTitleLinks"])) {
                this.relatedTitleLinks = [] as any;
                for (let item of _data["relatedTitleLinks"])
                    this.relatedTitleLinks!.push(TitleLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleStatus"] = this.titleStatus;
        data["numberOfRenewals"] = this.numberOfRenewals;
        data["initialGrantDate"] = this.initialGrantDate ? this.initialGrantDate.toISOString() : <any>undefined;
        data["originalExpiryDate"] = this.originalExpiryDate ? this.originalExpiryDate.toISOString() : <any>undefined;
        data["lastRenewalDate"] = this.lastRenewalDate ? this.lastRenewalDate.toISOString() : <any>undefined;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["offshoreAreaName"] = this.offshoreAreaName;
        data["basinName"] = this.basinName;
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["numberOfBlocks"] = this.numberOfBlocks;
        data["hasPriorUsageRight"] = this.hasPriorUsageRight;
        data["isDesignatedFrontierArea"] = this.isDesignatedFrontierArea;
        data["pipelineLength"] = this.pipelineLength;
        data["pipelineName"] = this.pipelineName;
        data["substanceName"] = this.substanceName;
        data["startPointName"] = this.startPointName;
        data["endPointName"] = this.endPointName;
        if (Array.isArray(this.locationNames)) {
            data["locationNames"] = [];
            for (let item of this.locationNames)
                data["locationNames"].push(item);
        }
        if (Array.isArray(this.relatedTitleLinks)) {
            data["relatedTitleLinks"] = [];
            for (let item of this.relatedTitleLinks)
                data["relatedTitleLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsSummaryDto {
    titleStatus?: string | undefined;
    numberOfRenewals: number;
    initialGrantDate: Date;
    originalExpiryDate?: Date | undefined;
    lastRenewalDate?: Date | undefined;
    currentExpiryDate?: Date | undefined;
    offshoreAreaName?: string | undefined;
    basinName?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    numberOfBlocks: number;
    hasPriorUsageRight: boolean;
    isDesignatedFrontierArea?: string | undefined;
    pipelineLength?: number | undefined;
    pipelineName?: string | undefined;
    substanceName?: string | undefined;
    startPointName?: string | undefined;
    endPointName?: string | undefined;
    locationNames?: string[] | undefined;
    relatedTitleLinks?: TitleLinkDto[] | undefined;
}

export class GetCompanyOpggsTitleDetailsTitleholderDto implements IGetCompanyOpggsTitleDetailsTitleholderDto {
    companyId!: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isOperator!: boolean;
    percentageOwnership!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsTitleholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.isOperator = _data["isOperator"];
            this.percentageOwnership = _data["percentageOwnership"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsTitleholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsTitleholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        data["isOperator"] = this.isOperator;
        data["percentageOwnership"] = this.percentageOwnership;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsTitleholderDto {
    companyId: number;
    companyName?: string | undefined;
    acnOrArbn?: string | undefined;
    isOperator: boolean;
    percentageOwnership: number;
}

export class GetCompanyOpggsTitleDetailsWorkProgramDto implements IGetCompanyOpggsTitleDetailsWorkProgramDto {
    showPrimaryAndSecondaryTerms!: boolean;
    years?: GetCompanyOpggsTitleDetailsWorkProgramYearDto[] | undefined;
    grandTotal!: number;
    primaryTermTotal!: number;
    secondaryTermTotal!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsWorkProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showPrimaryAndSecondaryTerms = _data["showPrimaryAndSecondaryTerms"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(GetCompanyOpggsTitleDetailsWorkProgramYearDto.fromJS(item));
            }
            this.grandTotal = _data["grandTotal"];
            this.primaryTermTotal = _data["primaryTermTotal"];
            this.secondaryTermTotal = _data["secondaryTermTotal"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsWorkProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsWorkProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPrimaryAndSecondaryTerms"] = this.showPrimaryAndSecondaryTerms;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal;
        data["primaryTermTotal"] = this.primaryTermTotal;
        data["secondaryTermTotal"] = this.secondaryTermTotal;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsWorkProgramDto {
    showPrimaryAndSecondaryTerms: boolean;
    years?: GetCompanyOpggsTitleDetailsWorkProgramYearDto[] | undefined;
    grandTotal: number;
    primaryTermTotal: number;
    secondaryTermTotal: number;
}

export class GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto implements IGetCompanyOpggsTitleDetailsWorkProgramYearActivityDto {
    description?: string | undefined;
    quantity?: string | undefined;
    value?: number | undefined;
    activityOrder!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsWorkProgramYearActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.value = _data["value"];
            this.activityOrder = _data["activityOrder"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["value"] = this.value;
        data["activityOrder"] = this.activityOrder;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsWorkProgramYearActivityDto {
    description?: string | undefined;
    quantity?: string | undefined;
    value?: number | undefined;
    activityOrder: number;
}

export class GetCompanyOpggsTitleDetailsWorkProgramYearDto implements IGetCompanyOpggsTitleDetailsWorkProgramYearDto {
    years!: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEpPrimaryTerm?: boolean | undefined;
    isEpSecondaryTerm?: boolean | undefined;
    activities?: GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto[] | undefined;
    value?: number | undefined;
    yearOrder!: number;

    constructor(data?: IGetCompanyOpggsTitleDetailsWorkProgramYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.years = _data["years"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isEpPrimaryTerm = _data["isEpPrimaryTerm"];
            this.isEpSecondaryTerm = _data["isEpSecondaryTerm"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto.fromJS(item));
            }
            this.value = _data["value"];
            this.yearOrder = _data["yearOrder"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleDetailsWorkProgramYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleDetailsWorkProgramYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["years"] = this.years;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isEpPrimaryTerm"] = this.isEpPrimaryTerm;
        data["isEpSecondaryTerm"] = this.isEpSecondaryTerm;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["value"] = this.value;
        data["yearOrder"] = this.yearOrder;
        return data;
    }
}

export interface IGetCompanyOpggsTitleDetailsWorkProgramYearDto {
    years: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEpPrimaryTerm?: boolean | undefined;
    isEpSecondaryTerm?: boolean | undefined;
    activities?: GetCompanyOpggsTitleDetailsWorkProgramYearActivityDto[] | undefined;
    value?: number | undefined;
    yearOrder: number;
}

export class GetCompanyOpggsTitleListRequestDto implements IGetCompanyOpggsTitleListRequestDto {

    constructor(data?: IGetCompanyOpggsTitleListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyOpggsTitleListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyOpggsTitleListRequestDto {
}

export class GetCompanyOpggsTitleListResponseDto implements IGetCompanyOpggsTitleListResponseDto {
    titles?: GetCompanyOpggsTitleListTitleDto[] | undefined;

    constructor(data?: IGetCompanyOpggsTitleListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetCompanyOpggsTitleListTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyOpggsTitleListResponseDto {
    titles?: GetCompanyOpggsTitleListTitleDto[] | undefined;
}

export class GetCompanyOpggsTitleListTitleDto implements IGetCompanyOpggsTitleListTitleDto {
    titleLink!: TitleLinkDto;
    titleTypeDisplay!: string;
    titleStatusDisplay?: string | undefined;
    titleHoldersDisplay?: string | undefined;
    currentExpiryDate?: Date | undefined;
    renewalDate?: Date | undefined;
    grantedDate?: Date | undefined;
    offshoreArea?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;

    constructor(data?: IGetCompanyOpggsTitleListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLink = new TitleLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : new TitleLinkDto();
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.titleStatusDisplay = _data["titleStatusDisplay"];
            this.titleHoldersDisplay = _data["titleHoldersDisplay"];
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : <any>undefined;
            this.grantedDate = _data["grantedDate"] ? new Date(_data["grantedDate"].toString()) : <any>undefined;
            this.offshoreArea = _data["offshoreArea"];
            this.basin = _data["basin"];
            this.subBasin = _data["subBasin"];
        }
    }

    static fromJS(data: any): GetCompanyOpggsTitleListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyOpggsTitleListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["titleStatusDisplay"] = this.titleStatusDisplay;
        data["titleHoldersDisplay"] = this.titleHoldersDisplay;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>undefined;
        data["grantedDate"] = this.grantedDate ? this.grantedDate.toISOString() : <any>undefined;
        data["offshoreArea"] = this.offshoreArea;
        data["basin"] = this.basin;
        data["subBasin"] = this.subBasin;
        return data;
    }
}

export interface IGetCompanyOpggsTitleListTitleDto {
    titleLink: TitleLinkDto;
    titleTypeDisplay: string;
    titleStatusDisplay?: string | undefined;
    titleHoldersDisplay?: string | undefined;
    currentExpiryDate?: Date | undefined;
    renewalDate?: Date | undefined;
    grantedDate?: Date | undefined;
    offshoreArea?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;
}

export class GetCompanyUserManagementCompanyDetailsRequestDto implements IGetCompanyUserManagementCompanyDetailsRequestDto {
    companyId!: number;

    constructor(data?: IGetCompanyUserManagementCompanyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementCompanyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementCompanyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IGetCompanyUserManagementCompanyDetailsRequestDto {
    companyId: number;
}

export class GetCompanyUserManagementCompanyDetailsResponseDto implements IGetCompanyUserManagementCompanyDetailsResponseDto {
    companyId!: number;
    companyName?: string | undefined;
    abn?: string | undefined;
    acnOrArbn?: string | undefined;
    roles!: CompanySecureUserCompanyRoleDto[];

    constructor(data?: IGetCompanyUserManagementCompanyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.abn = _data["abn"];
            this.acnOrArbn = _data["acnOrArbn"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(CompanySecureUserCompanyRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyUserManagementCompanyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementCompanyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["abn"] = this.abn;
        data["acnOrArbn"] = this.acnOrArbn;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyUserManagementCompanyDetailsResponseDto {
    companyId: number;
    companyName?: string | undefined;
    abn?: string | undefined;
    acnOrArbn?: string | undefined;
    roles: CompanySecureUserCompanyRoleDto[];
}

export class SaveCompanyUserManagementCompanyDetailsRoleDto implements ISaveCompanyUserManagementCompanyDetailsRoleDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    companyId!: number;
    roles?: SecureRoleEnum[] | undefined;

    constructor(data?: ISaveCompanyUserManagementCompanyDetailsRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementCompanyDetailsRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementCompanyDetailsRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ISaveCompanyUserManagementCompanyDetailsRoleDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    companyId: number;
    roles?: SecureRoleEnum[] | undefined;
}

export class SaveCompanyUserManagementCompanyDetailsRolesRequestDto implements ISaveCompanyUserManagementCompanyDetailsRolesRequestDto {
    companyId!: number;
    roles?: SaveCompanyUserManagementCompanyDetailsRoleDto[] | undefined;

    constructor(data?: ISaveCompanyUserManagementCompanyDetailsRolesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(SaveCompanyUserManagementCompanyDetailsRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementCompanyDetailsRolesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementCompanyDetailsRolesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveCompanyUserManagementCompanyDetailsRolesRequestDto {
    companyId: number;
    roles?: SaveCompanyUserManagementCompanyDetailsRoleDto[] | undefined;
}

export class SaveCompanyUserManagementCompanyDetailsRolesResponseDto implements ISaveCompanyUserManagementCompanyDetailsRolesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyUserManagementCompanyDetailsRolesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementCompanyDetailsRolesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementCompanyDetailsRolesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyUserManagementCompanyDetailsRolesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyUserManagementCompanyListItemDto implements IGetCompanyUserManagementCompanyListItemDto {
    companyId!: number;
    companyName?: string | undefined;
    abn?: string | undefined;
    acnOrArbn?: string | undefined;
    companyAdministratorCount!: number;

    constructor(data?: IGetCompanyUserManagementCompanyListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.abn = _data["abn"];
            this.acnOrArbn = _data["acnOrArbn"];
            this.companyAdministratorCount = _data["companyAdministratorCount"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementCompanyListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementCompanyListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["abn"] = this.abn;
        data["acnOrArbn"] = this.acnOrArbn;
        data["companyAdministratorCount"] = this.companyAdministratorCount;
        return data;
    }
}

export interface IGetCompanyUserManagementCompanyListItemDto {
    companyId: number;
    companyName?: string | undefined;
    abn?: string | undefined;
    acnOrArbn?: string | undefined;
    companyAdministratorCount: number;
}

export class GetCompanyUserManagementCompanyListRequestDto implements IGetCompanyUserManagementCompanyListRequestDto {

    constructor(data?: IGetCompanyUserManagementCompanyListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyUserManagementCompanyListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementCompanyListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyUserManagementCompanyListRequestDto {
}

export class GetCompanyUserManagementCompanyListResponseDto implements IGetCompanyUserManagementCompanyListResponseDto {
    companies!: GetCompanyUserManagementCompanyListItemDto[];

    constructor(data?: IGetCompanyUserManagementCompanyListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(GetCompanyUserManagementCompanyListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyUserManagementCompanyListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementCompanyListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyUserManagementCompanyListResponseDto {
    companies: GetCompanyUserManagementCompanyListItemDto[];
}

export class ApproveCompanyUserManagementRequestDetailsCrCsRequestDto implements IApproveCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    isCompanyStandardRoleRequestApproved!: boolean;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.isCompanyStandardRoleRequestApproved = _data["isCompanyStandardRoleRequestApproved"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["isCompanyStandardRoleRequestApproved"] = this.isCompanyStandardRoleRequestApproved;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    isCompanyStandardRoleRequestApproved: boolean;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveCompanyUserManagementRequestDetailsCrCsResponseDto implements IApproveCompanyUserManagementRequestDetailsCrCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCrCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveCompanyUserManagementRequestDetailsCrRequestDto implements IApproveCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveCompanyUserManagementRequestDetailsCrResponseDto implements IApproveCompanyUserManagementRequestDetailsCrResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCrResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveCompanyUserManagementRequestDetailsCsRequestDto implements IApproveCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
}

export class ApproveCompanyUserManagementRequestDetailsCsResponseDto implements IApproveCompanyUserManagementRequestDetailsCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto implements IApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    isCompanyStandardRoleRequestApproved!: boolean;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.isCompanyStandardRoleRequestApproved = _data["isCompanyStandardRoleRequestApproved"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["isCompanyStandardRoleRequestApproved"] = this.isCompanyStandardRoleRequestApproved;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    isCompanyStandardRoleRequestApproved: boolean;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto implements IApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveCompanyUserManagementRequestDetailsNuCrRequestDto implements IApproveCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveCompanyUserManagementRequestDetailsNuCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsNuCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsNuCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveCompanyUserManagementRequestDetailsNuCrResponseDto implements IApproveCompanyUserManagementRequestDetailsNuCrResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveCompanyUserManagementRequestDetailsNuCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveCompanyUserManagementRequestDetailsNuCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveCompanyUserManagementRequestDetailsNuCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveCompanyUserManagementRequestDetailsNuCrResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CompanyUserManagementRequestDetailsExistingUserDetailsDto implements ICompanyUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    isSecureUserBlocked!: boolean;
    isCompanyRevokedButVisible!: boolean;

    constructor(data?: ICompanyUserManagementRequestDetailsExistingUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isCompanyRevokedButVisible = _data["isCompanyRevokedButVisible"];
        }
    }

    static fromJS(data: any): CompanyUserManagementRequestDetailsExistingUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isCompanyRevokedButVisible"] = this.isCompanyRevokedButVisible;
        return data;
    }
}

export interface ICompanyUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    isSecureUserBlocked: boolean;
    isCompanyRevokedButVisible: boolean;
}

export class CompanyUserManagementRequestDetailsNewUserDetailsDto implements ICompanyUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;

    constructor(data?: ICompanyUserManagementRequestDetailsNewUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): CompanyUserManagementRequestDetailsNewUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementRequestDetailsNewUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface ICompanyUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
}

export class CompanyUserManagementRequestDetailsSignerDetailsDto implements ICompanyUserManagementRequestDetailsSignerDetailsDto {
    isCompanySignerPoaRequest!: boolean;
    csAuthoritySupportingDocument!: SupportingDocumentDto;
    csPoaSupportingDocument?: SupportingDocumentDto | undefined;

    constructor(data?: ICompanyUserManagementRequestDetailsSignerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.csAuthoritySupportingDocument = new SupportingDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCompanySignerPoaRequest = _data["isCompanySignerPoaRequest"];
            this.csAuthoritySupportingDocument = _data["csAuthoritySupportingDocument"] ? SupportingDocumentDto.fromJS(_data["csAuthoritySupportingDocument"]) : new SupportingDocumentDto();
            this.csPoaSupportingDocument = _data["csPoaSupportingDocument"] ? SupportingDocumentDto.fromJS(_data["csPoaSupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyUserManagementRequestDetailsSignerDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementRequestDetailsSignerDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompanySignerPoaRequest"] = this.isCompanySignerPoaRequest;
        data["csAuthoritySupportingDocument"] = this.csAuthoritySupportingDocument ? this.csAuthoritySupportingDocument.toJSON() : <any>undefined;
        data["csPoaSupportingDocument"] = this.csPoaSupportingDocument ? this.csPoaSupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompanyUserManagementRequestDetailsSignerDetailsDto {
    isCompanySignerPoaRequest: boolean;
    csAuthoritySupportingDocument: SupportingDocumentDto;
    csPoaSupportingDocument?: SupportingDocumentDto | undefined;
}

export class CompanyUserManagementRequestDetailsStandardRoleDetailsDto implements ICompanyUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting!: SecureRoleEnum[];
    rolesRequested!: SecureRoleEnum[];
    rolesApproved!: SecureRoleEnum[];
    hasAllGeneralRoles!: boolean;

    constructor(data?: ICompanyUserManagementRequestDetailsStandardRoleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesExisting = [];
            this.rolesRequested = [];
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesExisting"])) {
                this.rolesExisting = [] as any;
                for (let item of _data["rolesExisting"])
                    this.rolesExisting!.push(item);
            }
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): CompanyUserManagementRequestDetailsStandardRoleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesExisting)) {
            data["rolesExisting"] = [];
            for (let item of this.rolesExisting)
                data["rolesExisting"].push(item);
        }
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface ICompanyUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting: SecureRoleEnum[];
    rolesRequested: SecureRoleEnum[];
    rolesApproved: SecureRoleEnum[];
    hasAllGeneralRoles: boolean;
}

export class CompanyUserManagementRequestDetailsSummaryDto implements ICompanyUserManagementRequestDetailsSummaryDto {
    id!: number;
    versionNumber!: number;
    type!: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime!: Date;
    companyId!: number;
    companyName?: string | undefined;
    comments?: string | undefined;
    isComplete!: boolean;
    isNewUserRequest!: boolean;
    isCompanyStandardRoleRequest!: boolean;
    isCompanySignerRequest!: boolean;

    constructor(data?: ICompanyUserManagementRequestDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.type = _data["type"];
            this.requestGroupCode = _data["requestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.comments = _data["comments"];
            this.isComplete = _data["isComplete"];
            this.isNewUserRequest = _data["isNewUserRequest"];
            this.isCompanyStandardRoleRequest = _data["isCompanyStandardRoleRequest"];
            this.isCompanySignerRequest = _data["isCompanySignerRequest"];
        }
    }

    static fromJS(data: any): CompanyUserManagementRequestDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementRequestDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["type"] = this.type;
        data["requestGroupCode"] = this.requestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["comments"] = this.comments;
        data["isComplete"] = this.isComplete;
        data["isNewUserRequest"] = this.isNewUserRequest;
        data["isCompanyStandardRoleRequest"] = this.isCompanyStandardRoleRequest;
        data["isCompanySignerRequest"] = this.isCompanySignerRequest;
        return data;
    }
}

export interface ICompanyUserManagementRequestDetailsSummaryDto {
    id: number;
    versionNumber: number;
    type: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime: Date;
    companyId: number;
    companyName?: string | undefined;
    comments?: string | undefined;
    isComplete: boolean;
    isNewUserRequest: boolean;
    isCompanyStandardRoleRequest: boolean;
    isCompanySignerRequest: boolean;
}

export class GetCompanyUserManagementRequestDetailsCrCsRequestDto implements IGetCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId: number;
}

export class GetCompanyUserManagementRequestDetailsCrCsResponseDto implements IGetCompanyUserManagementRequestDetailsCrCsResponseDto {
    summary!: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails!: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companyStandardRoleDetails!: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;
    companySignerDetails!: CompanyUserManagementRequestDetailsSignerDetailsDto;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companyStandardRoleDetails = new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
            this.companySignerDetails = new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? CompanyUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = _data["existingUserDetails"] ? CompanyUserManagementRequestDetailsExistingUserDetailsDto.fromJS(_data["existingUserDetails"]) : new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companyStandardRoleDetails = _data["companyStandardRoleDetails"] ? CompanyUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["companyStandardRoleDetails"]) : new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
            this.companySignerDetails = _data["companySignerDetails"] ? CompanyUserManagementRequestDetailsSignerDetailsDto.fromJS(_data["companySignerDetails"]) : new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["existingUserDetails"] = this.existingUserDetails ? this.existingUserDetails.toJSON() : <any>undefined;
        data["companyStandardRoleDetails"] = this.companyStandardRoleDetails ? this.companyStandardRoleDetails.toJSON() : <any>undefined;
        data["companySignerDetails"] = this.companySignerDetails ? this.companySignerDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCrCsResponseDto {
    summary: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companyStandardRoleDetails: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;
    companySignerDetails: CompanyUserManagementRequestDetailsSignerDetailsDto;
}

export class GetCompanyUserManagementRequestDetailsCrRequestDto implements IGetCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId: number;
}

export class GetCompanyUserManagementRequestDetailsCrResponseDto implements IGetCompanyUserManagementRequestDetailsCrResponseDto {
    summary!: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails!: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companyStandardRoleDetails!: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companyStandardRoleDetails = new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? CompanyUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = _data["existingUserDetails"] ? CompanyUserManagementRequestDetailsExistingUserDetailsDto.fromJS(_data["existingUserDetails"]) : new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companyStandardRoleDetails = _data["companyStandardRoleDetails"] ? CompanyUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["companyStandardRoleDetails"]) : new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["existingUserDetails"] = this.existingUserDetails ? this.existingUserDetails.toJSON() : <any>undefined;
        data["companyStandardRoleDetails"] = this.companyStandardRoleDetails ? this.companyStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCrResponseDto {
    summary: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companyStandardRoleDetails: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class GetCompanyUserManagementRequestDetailsCsRequestDto implements IGetCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId: number;
}

export class GetCompanyUserManagementRequestDetailsCsResponseDto implements IGetCompanyUserManagementRequestDetailsCsResponseDto {
    summary!: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails!: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companySignerDetails!: CompanyUserManagementRequestDetailsSignerDetailsDto;

    constructor(data?: IGetCompanyUserManagementRequestDetailsCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companySignerDetails = new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? CompanyUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new CompanyUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = _data["existingUserDetails"] ? CompanyUserManagementRequestDetailsExistingUserDetailsDto.fromJS(_data["existingUserDetails"]) : new CompanyUserManagementRequestDetailsExistingUserDetailsDto();
            this.companySignerDetails = _data["companySignerDetails"] ? CompanyUserManagementRequestDetailsSignerDetailsDto.fromJS(_data["companySignerDetails"]) : new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["existingUserDetails"] = this.existingUserDetails ? this.existingUserDetails.toJSON() : <any>undefined;
        data["companySignerDetails"] = this.companySignerDetails ? this.companySignerDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsCsResponseDto {
    summary: CompanyUserManagementRequestDetailsSummaryDto;
    existingUserDetails: CompanyUserManagementRequestDetailsExistingUserDetailsDto;
    companySignerDetails: CompanyUserManagementRequestDetailsSignerDetailsDto;
}

export class GetCompanyUserManagementRequestDetailsNuCrCsRequestDto implements IGetCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetCompanyUserManagementRequestDetailsNuCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsNuCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsNuCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId: number;
}

export class GetCompanyUserManagementRequestDetailsNuCrCsResponseDto implements IGetCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    summary!: CompanyUserManagementRequestDetailsSummaryDto;
    newUserDetails?: CompanyUserManagementRequestDetailsNewUserDetailsDto | undefined;
    companyStandardRoleDetails?: CompanyUserManagementRequestDetailsStandardRoleDetailsDto | undefined;
    companySignerDetails!: CompanyUserManagementRequestDetailsSignerDetailsDto;

    constructor(data?: IGetCompanyUserManagementRequestDetailsNuCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new CompanyUserManagementRequestDetailsSummaryDto();
            this.companySignerDetails = new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? CompanyUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new CompanyUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = _data["newUserDetails"] ? CompanyUserManagementRequestDetailsNewUserDetailsDto.fromJS(_data["newUserDetails"]) : <any>undefined;
            this.companyStandardRoleDetails = _data["companyStandardRoleDetails"] ? CompanyUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["companyStandardRoleDetails"]) : <any>undefined;
            this.companySignerDetails = _data["companySignerDetails"] ? CompanyUserManagementRequestDetailsSignerDetailsDto.fromJS(_data["companySignerDetails"]) : new CompanyUserManagementRequestDetailsSignerDetailsDto();
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsNuCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsNuCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["newUserDetails"] = this.newUserDetails ? this.newUserDetails.toJSON() : <any>undefined;
        data["companyStandardRoleDetails"] = this.companyStandardRoleDetails ? this.companyStandardRoleDetails.toJSON() : <any>undefined;
        data["companySignerDetails"] = this.companySignerDetails ? this.companySignerDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    summary: CompanyUserManagementRequestDetailsSummaryDto;
    newUserDetails?: CompanyUserManagementRequestDetailsNewUserDetailsDto | undefined;
    companyStandardRoleDetails?: CompanyUserManagementRequestDetailsStandardRoleDetailsDto | undefined;
    companySignerDetails: CompanyUserManagementRequestDetailsSignerDetailsDto;
}

export class GetCompanyUserManagementRequestDetailsNuCrRequestDto implements IGetCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetCompanyUserManagementRequestDetailsNuCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsNuCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsNuCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId: number;
}

export class GetCompanyUserManagementRequestDetailsNuCrResponseDto implements IGetCompanyUserManagementRequestDetailsNuCrResponseDto {
    summary!: CompanyUserManagementRequestDetailsSummaryDto;
    newUserDetails!: CompanyUserManagementRequestDetailsNewUserDetailsDto;
    companyStandardRoleDetails!: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetCompanyUserManagementRequestDetailsNuCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new CompanyUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = new CompanyUserManagementRequestDetailsNewUserDetailsDto();
            this.companyStandardRoleDetails = new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? CompanyUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new CompanyUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = _data["newUserDetails"] ? CompanyUserManagementRequestDetailsNewUserDetailsDto.fromJS(_data["newUserDetails"]) : new CompanyUserManagementRequestDetailsNewUserDetailsDto();
            this.companyStandardRoleDetails = _data["companyStandardRoleDetails"] ? CompanyUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["companyStandardRoleDetails"]) : new CompanyUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestDetailsNuCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestDetailsNuCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["newUserDetails"] = this.newUserDetails ? this.newUserDetails.toJSON() : <any>undefined;
        data["companyStandardRoleDetails"] = this.companyStandardRoleDetails ? this.companyStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestDetailsNuCrResponseDto {
    summary: CompanyUserManagementRequestDetailsSummaryDto;
    newUserDetails: CompanyUserManagementRequestDetailsNewUserDetailsDto;
    companyStandardRoleDetails: CompanyUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class RejectCompanyUserManagementRequestDetailsCrCsRequestDto implements IRejectCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;
    isCompanyStandardRoleRequestApproved!: boolean;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
            this.isCompanyStandardRoleRequestApproved = _data["isCompanyStandardRoleRequestApproved"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        data["isCompanyStandardRoleRequestApproved"] = this.isCompanyStandardRoleRequestApproved;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCrCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
    isCompanyStandardRoleRequestApproved: boolean;
    rolesApproved: SecureRoleEnum[];
}

export class RejectCompanyUserManagementRequestDetailsCrCsResponseDto implements IRejectCompanyUserManagementRequestDetailsCrCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCrCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectCompanyUserManagementRequestDetailsCrRequestDto implements IRejectCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCrRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectCompanyUserManagementRequestDetailsCrResponseDto implements IRejectCompanyUserManagementRequestDetailsCrResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCrResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectCompanyUserManagementRequestDetailsCsRequestDto implements IRejectCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectCompanyUserManagementRequestDetailsCsResponseDto implements IRejectCompanyUserManagementRequestDetailsCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectCompanyUserManagementRequestDetailsNuCrCsRequestDto implements IRejectCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;
    isCompanyStandardRoleRequestApproved!: boolean;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IRejectCompanyUserManagementRequestDetailsNuCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
            this.isCompanyStandardRoleRequestApproved = _data["isCompanyStandardRoleRequestApproved"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsNuCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsNuCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        data["isCompanyStandardRoleRequestApproved"] = this.isCompanyStandardRoleRequestApproved;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsNuCrCsRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
    isCompanyStandardRoleRequestApproved: boolean;
    rolesApproved: SecureRoleEnum[];
}

export class RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto implements IRejectCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsNuCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsNuCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsNuCrCsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectCompanyUserManagementRequestDetailsNuCrRequestDto implements IRejectCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsNuCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsNuCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsNuCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsNuCrRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectCompanyUserManagementRequestDetailsNuCrResponseDto implements IRejectCompanyUserManagementRequestDetailsNuCrResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectCompanyUserManagementRequestDetailsNuCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectCompanyUserManagementRequestDetailsNuCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCompanyUserManagementRequestDetailsNuCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectCompanyUserManagementRequestDetailsNuCrResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SupportingDocumentDto implements ISupportingDocumentDto {
    fileId!: number;
    fileName?: string | undefined;
    fileSize!: number;

    constructor(data?: ISupportingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): SupportingDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface ISupportingDocumentDto {
    fileId: number;
    fileName?: string | undefined;
    fileSize: number;
}

export class BatchApproveCompanyUserManagementRequestListRequestDto implements IBatchApproveCompanyUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;

    constructor(data?: IBatchApproveCompanyUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchApproveCompanyUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveCompanyUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchApproveCompanyUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
}

export class BatchApproveCompanyUserManagementRequestListResponseDto implements IBatchApproveCompanyUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchApproveCompanyUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchApproveCompanyUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveCompanyUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchApproveCompanyUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class BatchRejectCompanyUserManagementRequestListRequestDto implements IBatchRejectCompanyUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IBatchRejectCompanyUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): BatchRejectCompanyUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectCompanyUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IBatchRejectCompanyUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class BatchRejectCompanyUserManagementRequestListResponseDto implements IBatchRejectCompanyUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchRejectCompanyUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchRejectCompanyUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectCompanyUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchRejectCompanyUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto implements ICompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto {
    requestDatetime!: Date;
    companyId!: number;
    companyName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    isCompanyRevokedButVisible!: boolean;
    secureRequestGroupLink!: SecureRequestGroupLinkDto;
    requestVersionNumber!: number;
    rolesRequested!: SecureRoleEnum[];
    isSignerRequest!: boolean;

    constructor(data?: ICompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureRequestGroupLink = new SecureRequestGroupLinkDto();
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isCompanyRevokedButVisible = _data["isCompanyRevokedButVisible"];
            this.secureRequestGroupLink = _data["secureRequestGroupLink"] ? SecureRequestGroupLinkDto.fromJS(_data["secureRequestGroupLink"]) : new SecureRequestGroupLinkDto();
            this.requestVersionNumber = _data["requestVersionNumber"];
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            this.isSignerRequest = _data["isSignerRequest"];
        }
    }

    static fromJS(data: any): CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isCompanyRevokedButVisible"] = this.isCompanyRevokedButVisible;
        data["secureRequestGroupLink"] = this.secureRequestGroupLink ? this.secureRequestGroupLink.toJSON() : <any>undefined;
        data["requestVersionNumber"] = this.requestVersionNumber;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        data["isSignerRequest"] = this.isSignerRequest;
        return data;
    }
}

export interface ICompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto {
    requestDatetime: Date;
    companyId: number;
    companyName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    isCompanyRevokedButVisible: boolean;
    secureRequestGroupLink: SecureRequestGroupLinkDto;
    requestVersionNumber: number;
    rolesRequested: SecureRoleEnum[];
    isSignerRequest: boolean;
}

export class GetCompanyUserManagementRequestListRequestDto implements IGetCompanyUserManagementRequestListRequestDto {

    constructor(data?: IGetCompanyUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyUserManagementRequestListRequestDto {
}

export class GetCompanyUserManagementRequestListResponseDto implements IGetCompanyUserManagementRequestListResponseDto {
    companyAdministratorRequests!: CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto[];
    isCompanyAdministratorRequestLimitExceeded!: boolean;
    noptaRequests!: NoptaCompanyRequestListItemDto[];
    isNoptaRequestLimitExceeded!: boolean;

    constructor(data?: IGetCompanyUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companyAdministratorRequests = [];
            this.noptaRequests = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companyAdministratorRequests"])) {
                this.companyAdministratorRequests = [] as any;
                for (let item of _data["companyAdministratorRequests"])
                    this.companyAdministratorRequests!.push(CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto.fromJS(item));
            }
            this.isCompanyAdministratorRequestLimitExceeded = _data["isCompanyAdministratorRequestLimitExceeded"];
            if (Array.isArray(_data["noptaRequests"])) {
                this.noptaRequests = [] as any;
                for (let item of _data["noptaRequests"])
                    this.noptaRequests!.push(NoptaCompanyRequestListItemDto.fromJS(item));
            }
            this.isNoptaRequestLimitExceeded = _data["isNoptaRequestLimitExceeded"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companyAdministratorRequests)) {
            data["companyAdministratorRequests"] = [];
            for (let item of this.companyAdministratorRequests)
                data["companyAdministratorRequests"].push(item.toJSON());
        }
        data["isCompanyAdministratorRequestLimitExceeded"] = this.isCompanyAdministratorRequestLimitExceeded;
        if (Array.isArray(this.noptaRequests)) {
            data["noptaRequests"] = [];
            for (let item of this.noptaRequests)
                data["noptaRequests"].push(item.toJSON());
        }
        data["isNoptaRequestLimitExceeded"] = this.isNoptaRequestLimitExceeded;
        return data;
    }
}

export interface IGetCompanyUserManagementRequestListResponseDto {
    companyAdministratorRequests: CompanyUserManagementCompanyRequestListAdministratorCompanyRequestListItemDto[];
    isCompanyAdministratorRequestLimitExceeded: boolean;
    noptaRequests: NoptaCompanyRequestListItemDto[];
    isNoptaRequestLimitExceeded: boolean;
}

export class NoptaCompanyRequestListItemDto implements INoptaCompanyRequestListItemDto {
    requestDatetime!: Date;
    companyId!: number;
    companyName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    isCompanyRevokedButVisible!: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;

    constructor(data?: INoptaCompanyRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isCompanyRevokedButVisible = _data["isCompanyRevokedButVisible"];
            this.requestCode = _data["requestCode"];
            this.roleRequested = _data["roleRequested"];
        }
    }

    static fromJS(data: any): NoptaCompanyRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoptaCompanyRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isCompanyRevokedButVisible"] = this.isCompanyRevokedButVisible;
        data["requestCode"] = this.requestCode;
        data["roleRequested"] = this.roleRequested;
        return data;
    }
}

export interface INoptaCompanyRequestListItemDto {
    requestDatetime: Date;
    companyId: number;
    companyName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    isCompanyRevokedButVisible: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;
}

export class GetCompanyUserManagementUserDetailsRequestDto implements IGetCompanyUserManagementUserDetailsRequestDto {
    secureUserId!: number;

    constructor(data?: IGetCompanyUserManagementUserDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementUserDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        return data;
    }
}

export interface IGetCompanyUserManagementUserDetailsRequestDto {
    secureUserId: number;
}

export class GetCompanyUserManagementUserDetailsResponseDto implements IGetCompanyUserManagementUserDetailsResponseDto {
    id!: number;
    versionNumber!: number;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    isSecureUserBlocked!: boolean;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    hasInactivityWarning!: boolean;
    relationshipExpirationDatetime?: Date | undefined;
    roles!: CompanySecureUserCompanyRoleDto[];

    constructor(data?: IGetCompanyUserManagementUserDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.accountStatus = _data["accountStatus"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.hasInactivityWarning = _data["hasInactivityWarning"];
            this.relationshipExpirationDatetime = _data["relationshipExpirationDatetime"] ? new Date(_data["relationshipExpirationDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(CompanySecureUserCompanyRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyUserManagementUserDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["accountStatus"] = this.accountStatus;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["hasInactivityWarning"] = this.hasInactivityWarning;
        data["relationshipExpirationDatetime"] = this.relationshipExpirationDatetime ? this.relationshipExpirationDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyUserManagementUserDetailsResponseDto {
    id: number;
    versionNumber: number;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    isSecureUserBlocked: boolean;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    hasInactivityWarning: boolean;
    relationshipExpirationDatetime?: Date | undefined;
    roles: CompanySecureUserCompanyRoleDto[];
}

export class RemoveCompanyUserManagementUserDetailsUserRequestDto implements IRemoveCompanyUserManagementUserDetailsUserRequestDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;

    constructor(data?: IRemoveCompanyUserManagementUserDetailsUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
        }
    }

    static fromJS(data: any): RemoveCompanyUserManagementUserDetailsUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCompanyUserManagementUserDetailsUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        return data;
    }
}

export interface IRemoveCompanyUserManagementUserDetailsUserRequestDto {
    secureUserId: number;
    secureUserVersionNumber: number;
}

export class RemoveCompanyUserManagementUserDetailsUserResponseDto implements IRemoveCompanyUserManagementUserDetailsUserResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRemoveCompanyUserManagementUserDetailsUserResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RemoveCompanyUserManagementUserDetailsUserResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCompanyUserManagementUserDetailsUserResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemoveCompanyUserManagementUserDetailsUserResponseDto {
    statusMessages: StatusMessagesDto;
}

export class SaveCompanyUserManagementUserDetailsRoleDto implements ISaveCompanyUserManagementUserDetailsRoleDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    companyId!: number;
    roles?: SecureRoleEnum[] | undefined;

    constructor(data?: ISaveCompanyUserManagementUserDetailsRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementUserDetailsRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementUserDetailsRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ISaveCompanyUserManagementUserDetailsRoleDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    companyId: number;
    roles?: SecureRoleEnum[] | undefined;
}

export class SaveCompanyUserManagementUserDetailsRolesRequestDto implements ISaveCompanyUserManagementUserDetailsRolesRequestDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    roles?: SaveCompanyUserManagementUserDetailsRoleDto[] | undefined;

    constructor(data?: ISaveCompanyUserManagementUserDetailsRolesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(SaveCompanyUserManagementUserDetailsRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementUserDetailsRolesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementUserDetailsRolesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveCompanyUserManagementUserDetailsRolesRequestDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    roles?: SaveCompanyUserManagementUserDetailsRoleDto[] | undefined;
}

export class SaveCompanyUserManagementUserDetailsRolesResponseDto implements ISaveCompanyUserManagementUserDetailsRolesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveCompanyUserManagementUserDetailsRolesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveCompanyUserManagementUserDetailsRolesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCompanyUserManagementUserDetailsRolesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCompanyUserManagementUserDetailsRolesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCompanyUserManagementUserListCompanyDto implements IGetCompanyUserManagementUserListCompanyDto {
    companyId!: number;
    companyName?: string | undefined;

    constructor(data?: IGetCompanyUserManagementUserListCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetCompanyUserManagementUserListCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserListCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetCompanyUserManagementUserListCompanyDto {
    companyId: number;
    companyName?: string | undefined;
}

export class GetCompanyUserManagementUserListRequestDto implements IGetCompanyUserManagementUserListRequestDto {

    constructor(data?: IGetCompanyUserManagementUserListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCompanyUserManagementUserListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCompanyUserManagementUserListRequestDto {
}

export class GetCompanyUserManagementUserListResponseDto implements IGetCompanyUserManagementUserListResponseDto {
    users!: GetCompanyUserManagementUserListUserDto[];

    constructor(data?: IGetCompanyUserManagementUserListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(GetCompanyUserManagementUserListUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyUserManagementUserListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyUserManagementUserListResponseDto {
    users: GetCompanyUserManagementUserListUserDto[];
}

export class GetCompanyUserManagementUserListUserDto implements IGetCompanyUserManagementUserListUserDto {
    secureUserId!: number;
    username?: string | undefined;
    fullName?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    companiesDisplay?: string | undefined;
    accountStatus?: string | undefined;
    emailAddress?: string | undefined;
    isSecureUserSignedIn!: boolean;
    isSecureUserBlocked!: boolean;
    hasPendingRequest!: boolean;
    isAnyCompanyRevokedButVisible!: boolean;
    hasInactivityWarning!: boolean;
    badgeSortOrder!: number;
    companies!: GetCompanyUserManagementUserListCompanyDto[];

    constructor(data?: IGetCompanyUserManagementUserListUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.companiesDisplay = _data["companiesDisplay"];
            this.accountStatus = _data["accountStatus"];
            this.emailAddress = _data["emailAddress"];
            this.isSecureUserSignedIn = _data["isSecureUserSignedIn"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.isAnyCompanyRevokedButVisible = _data["isAnyCompanyRevokedButVisible"];
            this.hasInactivityWarning = _data["hasInactivityWarning"];
            this.badgeSortOrder = _data["badgeSortOrder"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(GetCompanyUserManagementUserListCompanyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompanyUserManagementUserListUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyUserManagementUserListUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["companiesDisplay"] = this.companiesDisplay;
        data["accountStatus"] = this.accountStatus;
        data["emailAddress"] = this.emailAddress;
        data["isSecureUserSignedIn"] = this.isSecureUserSignedIn;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["isAnyCompanyRevokedButVisible"] = this.isAnyCompanyRevokedButVisible;
        data["hasInactivityWarning"] = this.hasInactivityWarning;
        data["badgeSortOrder"] = this.badgeSortOrder;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompanyUserManagementUserListUserDto {
    secureUserId: number;
    username?: string | undefined;
    fullName?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    companiesDisplay?: string | undefined;
    accountStatus?: string | undefined;
    emailAddress?: string | undefined;
    isSecureUserSignedIn: boolean;
    isSecureUserBlocked: boolean;
    hasPendingRequest: boolean;
    isAnyCompanyRevokedButVisible: boolean;
    hasInactivityWarning: boolean;
    badgeSortOrder: number;
    companies: GetCompanyUserManagementUserListCompanyDto[];
}

export class GeoscienceAustraliaAccountMyDetailsPendingRequestsDto implements IGeoscienceAustraliaAccountMyDetailsPendingRequestsDto {
    secureRequestGroupId!: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime!: Date;
    rolesRequested!: SecureRoleEnum[];

    constructor(data?: IGeoscienceAustraliaAccountMyDetailsPendingRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.secureRequestGroupCode = _data["secureRequestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
        }
    }

    static fromJS(data: any): GeoscienceAustraliaAccountMyDetailsPendingRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaAccountMyDetailsPendingRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["secureRequestGroupCode"] = this.secureRequestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        return data;
    }
}

export interface IGeoscienceAustraliaAccountMyDetailsPendingRequestsDto {
    secureRequestGroupId: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime: Date;
    rolesRequested: SecureRoleEnum[];
}

export class GetGeoscienceAustraliaAccountMyDetailsRequestDto implements IGetGeoscienceAustraliaAccountMyDetailsRequestDto {

    constructor(data?: IGetGeoscienceAustraliaAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaAccountMyDetailsRequestDto {
}

export class GetGeoscienceAustraliaAccountMyDetailsResponseDto implements IGetGeoscienceAustraliaAccountMyDetailsResponseDto {
    versionNumber!: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    geoscienceAustraliaAdministrators!: UserContactDto[];
    existingRoles!: SecureUserGeoscienceAustraliaRoleDto;
    pendingRequests!: GeoscienceAustraliaAccountMyDetailsPendingRequestsDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.geoscienceAustraliaAdministrators = [];
            this.existingRoles = new SecureUserGeoscienceAustraliaRoleDto();
            this.pendingRequests = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["geoscienceAustraliaAdministrators"])) {
                this.geoscienceAustraliaAdministrators = [] as any;
                for (let item of _data["geoscienceAustraliaAdministrators"])
                    this.geoscienceAustraliaAdministrators!.push(UserContactDto.fromJS(item));
            }
            this.existingRoles = _data["existingRoles"] ? SecureUserGeoscienceAustraliaRoleDto.fromJS(_data["existingRoles"]) : new SecureUserGeoscienceAustraliaRoleDto();
            if (Array.isArray(_data["pendingRequests"])) {
                this.pendingRequests = [] as any;
                for (let item of _data["pendingRequests"])
                    this.pendingRequests!.push(GeoscienceAustraliaAccountMyDetailsPendingRequestsDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.geoscienceAustraliaAdministrators)) {
            data["geoscienceAustraliaAdministrators"] = [];
            for (let item of this.geoscienceAustraliaAdministrators)
                data["geoscienceAustraliaAdministrators"].push(item.toJSON());
        }
        data["existingRoles"] = this.existingRoles ? this.existingRoles.toJSON() : <any>undefined;
        if (Array.isArray(this.pendingRequests)) {
            data["pendingRequests"] = [];
            for (let item of this.pendingRequests)
                data["pendingRequests"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAccountMyDetailsResponseDto {
    versionNumber: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    geoscienceAustraliaAdministrators: UserContactDto[];
    existingRoles: SecureUserGeoscienceAustraliaRoleDto;
    pendingRequests: GeoscienceAustraliaAccountMyDetailsPendingRequestsDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class SaveGeoscienceAustraliaAccountMyDetailsRequestDto implements ISaveGeoscienceAustraliaAccountMyDetailsRequestDto {
    versionNumber!: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;

    constructor(data?: ISaveGeoscienceAustraliaAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface ISaveGeoscienceAustraliaAccountMyDetailsRequestDto {
    versionNumber: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
}

export class SaveGeoscienceAustraliaAccountMyDetailsResponseDto implements ISaveGeoscienceAustraliaAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ISaveGeoscienceAustraliaAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveGeoscienceAustraliaAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class SecureUserGeoscienceAustraliaRoleDto implements ISecureUserGeoscienceAustraliaRoleDto {
    activeRoles!: SecureRoleEnum[];
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;

    constructor(data?: ISecureUserGeoscienceAustraliaRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedDatetime = _data["lastUpdatedDatetime"] ? new Date(_data["lastUpdatedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SecureUserGeoscienceAustraliaRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserGeoscienceAustraliaRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedDatetime"] = this.lastUpdatedDatetime ? this.lastUpdatedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISecureUserGeoscienceAustraliaRoleDto {
    activeRoles: SecureRoleEnum[];
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
}

export class CreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto implements ICreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto {
    submittedComments?: string | undefined;
    gaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.gaaAuthoritySupportingDocument = _data["gaaAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["gaaAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["gaaAuthoritySupportingDocument"] = this.gaaAuthoritySupportingDocument ? this.gaaAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaAccountRequestAccessGaaRequestDto {
    submittedComments?: string | undefined;
    gaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto implements ICreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaAccountRequestAccessGaaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateGeoscienceAustraliaAccountRequestAccessGarRequestDto implements ICreateGeoscienceAustraliaAccountRequestAccessGarRequestDto {
    submittedComments?: string | undefined;
    geoscienceAustraliaStandardRolesRequest?: GeoscienceAustraliaStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaAccountRequestAccessGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.geoscienceAustraliaStandardRolesRequest = _data["geoscienceAustraliaStandardRolesRequest"] ? GeoscienceAustraliaStandardRoleRequestDetailsDto.fromJS(_data["geoscienceAustraliaStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaAccountRequestAccessGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaAccountRequestAccessGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["geoscienceAustraliaStandardRolesRequest"] = this.geoscienceAustraliaStandardRolesRequest ? this.geoscienceAustraliaStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaAccountRequestAccessGarRequestDto {
    submittedComments?: string | undefined;
    geoscienceAustraliaStandardRolesRequest?: GeoscienceAustraliaStandardRoleRequestDetailsDto | undefined;
}

export class CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto implements ICreateGeoscienceAustraliaAccountRequestAccessGarResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaAccountRequestAccessGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaAccountRequestAccessGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaAccountRequestAccessGarResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto implements IGetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaAccountRequestAccessReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto implements IGetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto {
    hasPendingRequest!: boolean;
    hasGeoscienceAustraliaAdministrator!: boolean;
    activeRoles!: SecureRoleEnum[];
    isGeoscienceAustraliaAdministrator!: boolean;
    hasAllSpecialRoles!: boolean;
    hasAllGeneralRoles!: boolean;

    constructor(data?: IGetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.hasGeoscienceAustraliaAdministrator = _data["hasGeoscienceAustraliaAdministrator"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.isGeoscienceAustraliaAdministrator = _data["isGeoscienceAustraliaAdministrator"];
            this.hasAllSpecialRoles = _data["hasAllSpecialRoles"];
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["hasGeoscienceAustraliaAdministrator"] = this.hasGeoscienceAustraliaAdministrator;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["isGeoscienceAustraliaAdministrator"] = this.isGeoscienceAustraliaAdministrator;
        data["hasAllSpecialRoles"] = this.hasAllSpecialRoles;
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAccountRequestAccessReferenceDataResponseDto {
    hasPendingRequest: boolean;
    hasGeoscienceAustraliaAdministrator: boolean;
    activeRoles: SecureRoleEnum[];
    isGeoscienceAustraliaAdministrator: boolean;
    hasAllSpecialRoles: boolean;
    hasAllGeneralRoles: boolean;
}

export class AdvancedSearchOperationAttachmentTypeDto implements IAdvancedSearchOperationAttachmentTypeDto {
    id!: number;
    value!: AttachmentTypeEnum;
    name!: string;

    constructor(data?: IAdvancedSearchOperationAttachmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchOperationAttachmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchOperationAttachmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchOperationAttachmentTypeDto {
    id: number;
    value: AttachmentTypeEnum;
    name: string;
}

export class DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto implements IDeleteGeoscienceAustraliaAttachmentsImportAttachmentDto {
    attachmentType!: AttachmentTypeEnum;
    attachmentId!: number;
    attachmentTypeId!: number;
    attachmentTypeVersionNumber!: number;

    constructor(data?: IDeleteGeoscienceAustraliaAttachmentsImportAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentType = _data["attachmentType"];
            this.attachmentId = _data["attachmentId"];
            this.attachmentTypeId = _data["attachmentTypeId"];
            this.attachmentTypeVersionNumber = _data["attachmentTypeVersionNumber"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentType"] = this.attachmentType;
        data["attachmentId"] = this.attachmentId;
        data["attachmentTypeId"] = this.attachmentTypeId;
        data["attachmentTypeVersionNumber"] = this.attachmentTypeVersionNumber;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaAttachmentsImportAttachmentDto {
    attachmentType: AttachmentTypeEnum;
    attachmentId: number;
    attachmentTypeId: number;
    attachmentTypeVersionNumber: number;
}

export class DeleteGeoscienceAustraliaAttachmentsImportRequestDto implements IDeleteGeoscienceAustraliaAttachmentsImportRequestDto {
    attachmentBulkImportNumber!: number;
    attachmentDetails!: DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto[];

    constructor(data?: IDeleteGeoscienceAustraliaAttachmentsImportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachmentDetails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentBulkImportNumber = _data["attachmentBulkImportNumber"];
            if (Array.isArray(_data["attachmentDetails"])) {
                this.attachmentDetails = [] as any;
                for (let item of _data["attachmentDetails"])
                    this.attachmentDetails!.push(DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaAttachmentsImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaAttachmentsImportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentBulkImportNumber"] = this.attachmentBulkImportNumber;
        if (Array.isArray(this.attachmentDetails)) {
            data["attachmentDetails"] = [];
            for (let item of this.attachmentDetails)
                data["attachmentDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaAttachmentsImportRequestDto {
    attachmentBulkImportNumber: number;
    attachmentDetails: DeleteGeoscienceAustraliaAttachmentsImportAttachmentDto[];
}

export class DeleteGeoscienceAustraliaAttachmentsImportResponseDto implements IDeleteGeoscienceAustraliaAttachmentsImportResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaAttachmentsImportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaAttachmentsImportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaAttachmentsImportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaAttachmentsImportResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ExportGeoscienceAustraliaAttachmentsRequestDto implements IExportGeoscienceAustraliaAttachmentsRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IExportGeoscienceAustraliaAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportGeoscienceAustraliaAttachmentsRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class ExportGeoscienceAustraliaAttachmentsResponseDto implements IExportGeoscienceAustraliaAttachmentsResponseDto {
    document!: SecurePortalDocumentDto;

    constructor(data?: IExportGeoscienceAustraliaAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.document = new SecurePortalDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? SecurePortalDocumentDto.fromJS(_data["document"]) : new SecurePortalDocumentDto();
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExportGeoscienceAustraliaAttachmentsResponseDto {
    document: SecurePortalDocumentDto;
}

export class GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem implements IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem {
    batchNumber!: number;
    batchDisplayName?: string | undefined;
    attachmentItems!: GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem[];

    constructor(data?: IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachmentItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"];
            this.batchDisplayName = _data["batchDisplayName"];
            if (Array.isArray(_data["attachmentItems"])) {
                this.attachmentItems = [] as any;
                for (let item of _data["attachmentItems"])
                    this.attachmentItems!.push(GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["batchDisplayName"] = this.batchDisplayName;
        if (Array.isArray(this.attachmentItems)) {
            data["attachmentItems"] = [];
            for (let item of this.attachmentItems)
                data["attachmentItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem {
    batchNumber: number;
    batchDisplayName?: string | undefined;
    attachmentItems: GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem[];
}

export class GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem implements IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem {
    attachmentType!: AttachmentTypeEnum;
    attachmentId!: number;
    attachmentTypeId!: number;
    attachmentTypeVersionNumber!: number;

    constructor(data?: IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentType = _data["attachmentType"];
            this.attachmentId = _data["attachmentId"];
            this.attachmentTypeId = _data["attachmentTypeId"];
            this.attachmentTypeVersionNumber = _data["attachmentTypeVersionNumber"];
        }
    }

    static fromJS(data: any): GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentType"] = this.attachmentType;
        data["attachmentId"] = this.attachmentId;
        data["attachmentTypeId"] = this.attachmentTypeId;
        data["attachmentTypeVersionNumber"] = this.attachmentTypeVersionNumber;
        return data;
    }
}

export interface IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentItem {
    attachmentType: AttachmentTypeEnum;
    attachmentId: number;
    attachmentTypeId: number;
    attachmentTypeVersionNumber: number;
}

export class GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto implements IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto {

    constructor(data?: IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataRequestDto {
}

export class GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto implements IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto {
    attachmentBatchItems!: GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem[];

    constructor(data?: IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachmentBatchItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachmentBatchItems"])) {
                this.attachmentBatchItems = [] as any;
                for (let item of _data["attachmentBatchItems"])
                    this.attachmentBatchItems!.push(GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachmentBatchItems)) {
            data["attachmentBatchItems"] = [];
            for (let item of this.attachmentBatchItems)
                data["attachmentBatchItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataResponseDto {
    attachmentBatchItems: GetDeleteGeoscienceAustraliaAttachmentsImportReferenceDataAttachmentBatchItem[];
}

export class GetGeoscienceAustraliaAttachmentListItemDto implements IGetGeoscienceAustraliaAttachmentListItemDto {
    attachmentType!: AttachmentTypeEnum;
    id!: number;
    attachmentTypeId!: number;
    attachmentTypeVersionNumber!: number;
    itemId!: string;
    documentLink!: string;
    fileName!: string;
    fileSize!: number;
    numberOfMappings!: number;
    bulkLoadNumber?: number | undefined;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified!: Date;
    relatedActivities?: GetGeoscienceAustraliaAttachmentListRelatedActivityDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaAttachmentListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentType = _data["attachmentType"];
            this.id = _data["id"];
            this.attachmentTypeId = _data["attachmentTypeId"];
            this.attachmentTypeVersionNumber = _data["attachmentTypeVersionNumber"];
            this.itemId = _data["itemId"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.numberOfMappings = _data["numberOfMappings"];
            this.bulkLoadNumber = _data["bulkLoadNumber"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedDate = _data["uploadedDate"] ? new Date(_data["uploadedDate"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["relatedActivities"])) {
                this.relatedActivities = [] as any;
                for (let item of _data["relatedActivities"])
                    this.relatedActivities!.push(GetGeoscienceAustraliaAttachmentListRelatedActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentType"] = this.attachmentType;
        data["id"] = this.id;
        data["attachmentTypeId"] = this.attachmentTypeId;
        data["attachmentTypeVersionNumber"] = this.attachmentTypeVersionNumber;
        data["itemId"] = this.itemId;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["numberOfMappings"] = this.numberOfMappings;
        data["bulkLoadNumber"] = this.bulkLoadNumber;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        if (Array.isArray(this.relatedActivities)) {
            data["relatedActivities"] = [];
            for (let item of this.relatedActivities)
                data["relatedActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListItemDto {
    attachmentType: AttachmentTypeEnum;
    id: number;
    attachmentTypeId: number;
    attachmentTypeVersionNumber: number;
    itemId: string;
    documentLink: string;
    fileName: string;
    fileSize: number;
    numberOfMappings: number;
    bulkLoadNumber?: number | undefined;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified: Date;
    relatedActivities?: GetGeoscienceAustraliaAttachmentListRelatedActivityDto[] | undefined;
}

export class GetGeoscienceAustraliaAttachmentListPermissionsDto implements IGetGeoscienceAustraliaAttachmentListPermissionsDto {
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewProjects!: boolean;
    canViewReports!: boolean;
    canViewSurveyData!: boolean;

    constructor(data?: IGetGeoscienceAustraliaAttachmentListPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewProjects = _data["canViewProjects"];
            this.canViewReports = _data["canViewReports"];
            this.canViewSurveyData = _data["canViewSurveyData"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewProjects"] = this.canViewProjects;
        data["canViewReports"] = this.canViewReports;
        data["canViewSurveyData"] = this.canViewSurveyData;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListPermissionsDto {
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewProjects: boolean;
    canViewReports: boolean;
    canViewSurveyData: boolean;
}

export class GetGeoscienceAustraliaAttachmentListReferenceDataRequestDto implements IGetGeoscienceAustraliaAttachmentListReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaAttachmentListReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto implements IGetGeoscienceAustraliaAttachmentListReferenceDataResponseDto {
    wellBoreholes!: AdvancedSearchReferenceDataWellBoreholeDto[];
    surveyAcquisitions!: AdvancedSearchReferenceDataAcquisitionDto[];
    reprocessingProjects!: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos!: AdvancedSearchReferenceDataEnoDto[];
    searchTypes!: AdvancedSearchTypeDto[];
    searchOperations!: AdvancedSearchOperationDto[];
    attachmentTypes!: AdvancedSearchOperationAttachmentTypeDto[];

    constructor(data?: IGetGeoscienceAustraliaAttachmentListReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellBoreholes = [];
            this.surveyAcquisitions = [];
            this.reprocessingProjects = [];
            this.enos = [];
            this.searchTypes = [];
            this.searchOperations = [];
            this.attachmentTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(AdvancedSearchReferenceDataWellBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(AdvancedSearchReferenceDataAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(AdvancedSearchReferenceDataReprocessingProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["enos"])) {
                this.enos = [] as any;
                for (let item of _data["enos"])
                    this.enos!.push(AdvancedSearchReferenceDataEnoDto.fromJS(item));
            }
            if (Array.isArray(_data["searchTypes"])) {
                this.searchTypes = [] as any;
                for (let item of _data["searchTypes"])
                    this.searchTypes!.push(AdvancedSearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["searchOperations"])) {
                this.searchOperations = [] as any;
                for (let item of _data["searchOperations"])
                    this.searchOperations!.push(AdvancedSearchOperationDto.fromJS(item));
            }
            if (Array.isArray(_data["attachmentTypes"])) {
                this.attachmentTypes = [] as any;
                for (let item of _data["attachmentTypes"])
                    this.attachmentTypes!.push(AdvancedSearchOperationAttachmentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.enos)) {
            data["enos"] = [];
            for (let item of this.enos)
                data["enos"].push(item.toJSON());
        }
        if (Array.isArray(this.searchTypes)) {
            data["searchTypes"] = [];
            for (let item of this.searchTypes)
                data["searchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.searchOperations)) {
            data["searchOperations"] = [];
            for (let item of this.searchOperations)
                data["searchOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.attachmentTypes)) {
            data["attachmentTypes"] = [];
            for (let item of this.attachmentTypes)
                data["attachmentTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListReferenceDataResponseDto {
    wellBoreholes: AdvancedSearchReferenceDataWellBoreholeDto[];
    surveyAcquisitions: AdvancedSearchReferenceDataAcquisitionDto[];
    reprocessingProjects: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos: AdvancedSearchReferenceDataEnoDto[];
    searchTypes: AdvancedSearchTypeDto[];
    searchOperations: AdvancedSearchOperationDto[];
    attachmentTypes: AdvancedSearchOperationAttachmentTypeDto[];
}

export class GetGeoscienceAustraliaAttachmentListRelatedActivityDto implements IGetGeoscienceAustraliaAttachmentListRelatedActivityDto {
    type!: RelatedActivityEnum;
    relatedActivityParentId!: number;
    relatedActivityId!: number;
    identifier?: string | undefined;
    name?: string | undefined;
    selectedInAdvancedSearch!: boolean;

    constructor(data?: IGetGeoscienceAustraliaAttachmentListRelatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.relatedActivityParentId = _data["relatedActivityParentId"];
            this.relatedActivityId = _data["relatedActivityId"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.selectedInAdvancedSearch = _data["selectedInAdvancedSearch"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListRelatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListRelatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["relatedActivityParentId"] = this.relatedActivityParentId;
        data["relatedActivityId"] = this.relatedActivityId;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["selectedInAdvancedSearch"] = this.selectedInAdvancedSearch;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListRelatedActivityDto {
    type: RelatedActivityEnum;
    relatedActivityParentId: number;
    relatedActivityId: number;
    identifier?: string | undefined;
    name?: string | undefined;
    selectedInAdvancedSearch: boolean;
}

export class GetGeoscienceAustraliaAttachmentListRequestDto implements IGetGeoscienceAustraliaAttachmentListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaAttachmentListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class GetGeoscienceAustraliaAttachmentListResponseDto implements IGetGeoscienceAustraliaAttachmentListResponseDto {
    permissions!: GetGeoscienceAustraliaAttachmentListPermissionsDto;
    items!: GetGeoscienceAustraliaAttachmentListItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaAttachmentListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = new GetGeoscienceAustraliaAttachmentListPermissionsDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissions = _data["permissions"] ? GetGeoscienceAustraliaAttachmentListPermissionsDto.fromJS(_data["permissions"]) : new GetGeoscienceAustraliaAttachmentListPermissionsDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaAttachmentListItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAttachmentListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAttachmentListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAttachmentListResponseDto {
    permissions: GetGeoscienceAustraliaAttachmentListPermissionsDto;
    items: GetGeoscienceAustraliaAttachmentListItemDto[];
    isResultSetLimited: boolean;
}

export class ImportGeoscienceAustraliaAttachmentsRequestDto implements IImportGeoscienceAustraliaAttachmentsRequestDto {
    fileName?: string | undefined;
    fileContent?: string | undefined;

    constructor(data?: IImportGeoscienceAustraliaAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IImportGeoscienceAustraliaAttachmentsRequestDto {
    fileName?: string | undefined;
    fileContent?: string | undefined;
}

export class ImportGeoscienceAustraliaAttachmentsResponseDto implements IImportGeoscienceAustraliaAttachmentsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IImportGeoscienceAustraliaAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportGeoscienceAustraliaAttachmentsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto {
    authorisationId!: number;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesRequestDto {
    authorisationId: number;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto {
    authorisationIdentifier!: string;
    authorisationDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.authorisationDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationIdentifier = _data["authorisationIdentifier"];
            this.authorisationDataAuditChanges = _data["authorisationDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["authorisationDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationIdentifier"] = this.authorisationIdentifier;
        data["authorisationDataAuditChanges"] = this.authorisationDataAuditChanges ? this.authorisationDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDataAuditChangesResponseDto {
    authorisationIdentifier: string;
    authorisationDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto {
    id!: number;
    surveyId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto {
    id: number;
    surveyId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto {
    id!: number;
    wellId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto {
    id: number;
    wellId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto {
    extensionDueDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionDueDate = _data["extensionDueDate"] ? new Date(_data["extensionDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionDueDate"] = this.extensionDueDate ? this.extensionDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto {
    extensionDueDate?: Date | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto {
    id!: number;
    title!: string;
    type!: AuthorisationCategoryTypeEnum;
    dataMonitoringItems!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto[];
    extensionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto | undefined;
    combineDataSubmissionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto | undefined;
    digitalTransferDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto | undefined;
    exportDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto | undefined;
    sampleViewDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto | undefined;
    samplingDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto | undefined;
    samplingExportDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.type = _data["type"];
            if (Array.isArray(_data["dataMonitoringItems"])) {
                this.dataMonitoringItems = [] as any;
                for (let item of _data["dataMonitoringItems"])
                    this.dataMonitoringItems!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto.fromJS(item));
            }
            this.extensionDetails = _data["extensionDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto.fromJS(_data["extensionDetails"]) : <any>undefined;
            this.combineDataSubmissionDetails = _data["combineDataSubmissionDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto.fromJS(_data["combineDataSubmissionDetails"]) : <any>undefined;
            this.digitalTransferDetails = _data["digitalTransferDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto.fromJS(_data["digitalTransferDetails"]) : <any>undefined;
            this.exportDetails = _data["exportDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto.fromJS(_data["exportDetails"]) : <any>undefined;
            this.sampleViewDetails = _data["sampleViewDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto.fromJS(_data["sampleViewDetails"]) : <any>undefined;
            this.samplingDetails = _data["samplingDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto.fromJS(_data["samplingDetails"]) : <any>undefined;
            this.samplingExportDetails = _data["samplingExportDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto.fromJS(_data["samplingExportDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["type"] = this.type;
        if (Array.isArray(this.dataMonitoringItems)) {
            data["dataMonitoringItems"] = [];
            for (let item of this.dataMonitoringItems)
                data["dataMonitoringItems"].push(item.toJSON());
        }
        data["extensionDetails"] = this.extensionDetails ? this.extensionDetails.toJSON() : <any>undefined;
        data["combineDataSubmissionDetails"] = this.combineDataSubmissionDetails ? this.combineDataSubmissionDetails.toJSON() : <any>undefined;
        data["digitalTransferDetails"] = this.digitalTransferDetails ? this.digitalTransferDetails.toJSON() : <any>undefined;
        data["exportDetails"] = this.exportDetails ? this.exportDetails.toJSON() : <any>undefined;
        data["sampleViewDetails"] = this.sampleViewDetails ? this.sampleViewDetails.toJSON() : <any>undefined;
        data["samplingDetails"] = this.samplingDetails ? this.samplingDetails.toJSON() : <any>undefined;
        data["samplingExportDetails"] = this.samplingExportDetails ? this.samplingExportDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto {
    id: number;
    title: string;
    type: AuthorisationCategoryTypeEnum;
    dataMonitoringItems: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto[];
    extensionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto | undefined;
    combineDataSubmissionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryCombineDataSubmissionDetailsDto | undefined;
    digitalTransferDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto | undefined;
    exportDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto | undefined;
    sampleViewDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto | undefined;
    samplingDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto | undefined;
    samplingExportDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto {
    digitalTransferMethodTypeName?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.digitalTransferMethodTypeName = _data["digitalTransferMethodTypeName"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["digitalTransferMethodTypeName"] = this.digitalTransferMethodTypeName;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDigitalTransferDetailsDto {
    digitalTransferMethodTypeName?: string | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    exportToCountryName?: string | undefined;
    analysisTypeNames!: string[];
    sampleTypeNames!: string[];
    returnDataMonitoringItems!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.analysisTypeNames = [];
            this.sampleTypeNames = [];
            this.returnDataMonitoringItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleToBeReturned = _data["sampleToBeReturned"];
            this.sampleDepth = _data["sampleDepth"];
            this.reportingDueMonths = _data["reportingDueMonths"];
            this.reportingDueDate = _data["reportingDueDate"] ? new Date(_data["reportingDueDate"].toString()) : <any>undefined;
            this.exportToCountryName = _data["exportToCountryName"];
            if (Array.isArray(_data["analysisTypeNames"])) {
                this.analysisTypeNames = [] as any;
                for (let item of _data["analysisTypeNames"])
                    this.analysisTypeNames!.push(item);
            }
            if (Array.isArray(_data["sampleTypeNames"])) {
                this.sampleTypeNames = [] as any;
                for (let item of _data["sampleTypeNames"])
                    this.sampleTypeNames!.push(item);
            }
            if (Array.isArray(_data["returnDataMonitoringItems"])) {
                this.returnDataMonitoringItems = [] as any;
                for (let item of _data["returnDataMonitoringItems"])
                    this.returnDataMonitoringItems!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleToBeReturned"] = this.sampleToBeReturned;
        data["sampleDepth"] = this.sampleDepth;
        data["reportingDueMonths"] = this.reportingDueMonths;
        data["reportingDueDate"] = this.reportingDueDate ? this.reportingDueDate.toISOString() : <any>undefined;
        data["exportToCountryName"] = this.exportToCountryName;
        if (Array.isArray(this.analysisTypeNames)) {
            data["analysisTypeNames"] = [];
            for (let item of this.analysisTypeNames)
                data["analysisTypeNames"].push(item);
        }
        if (Array.isArray(this.sampleTypeNames)) {
            data["sampleTypeNames"] = [];
            for (let item of this.sampleTypeNames)
                data["sampleTypeNames"].push(item);
        }
        if (Array.isArray(this.returnDataMonitoringItems)) {
            data["returnDataMonitoringItems"] = [];
            for (let item of this.returnDataMonitoringItems)
                data["returnDataMonitoringItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExportDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    exportToCountryName?: string | undefined;
    analysisTypeNames: string[];
    sampleTypeNames: string[];
    returnDataMonitoringItems: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto {
    extensionDueDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionDueDate = _data["extensionDueDate"] ? new Date(_data["extensionDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionDueDate"] = this.extensionDueDate ? this.extensionDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryExtensionDetailsDto {
    extensionDueDate?: Date | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto {
    sampleDepth?: string | undefined;
    repositoryTypeName?: string | undefined;
    sampleTypeNames!: string[];

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sampleTypeNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleDepth = _data["sampleDepth"];
            this.repositoryTypeName = _data["repositoryTypeName"];
            if (Array.isArray(_data["sampleTypeNames"])) {
                this.sampleTypeNames = [] as any;
                for (let item of _data["sampleTypeNames"])
                    this.sampleTypeNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleDepth"] = this.sampleDepth;
        data["repositoryTypeName"] = this.repositoryTypeName;
        if (Array.isArray(this.sampleTypeNames)) {
            data["sampleTypeNames"] = [];
            for (let item of this.sampleTypeNames)
                data["sampleTypeNames"].push(item);
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySampleViewDetailsDto {
    sampleDepth?: string | undefined;
    repositoryTypeName?: string | undefined;
    sampleTypeNames: string[];
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    repositoryTypeName?: string | undefined;
    analysisTypeNames!: string[];
    sampleTypeNames!: string[];
    returnDataMonitoringItems!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.analysisTypeNames = [];
            this.sampleTypeNames = [];
            this.returnDataMonitoringItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleToBeReturned = _data["sampleToBeReturned"];
            this.sampleDepth = _data["sampleDepth"];
            this.reportingDueMonths = _data["reportingDueMonths"];
            this.reportingDueDate = _data["reportingDueDate"] ? new Date(_data["reportingDueDate"].toString()) : <any>undefined;
            this.repositoryTypeName = _data["repositoryTypeName"];
            if (Array.isArray(_data["analysisTypeNames"])) {
                this.analysisTypeNames = [] as any;
                for (let item of _data["analysisTypeNames"])
                    this.analysisTypeNames!.push(item);
            }
            if (Array.isArray(_data["sampleTypeNames"])) {
                this.sampleTypeNames = [] as any;
                for (let item of _data["sampleTypeNames"])
                    this.sampleTypeNames!.push(item);
            }
            if (Array.isArray(_data["returnDataMonitoringItems"])) {
                this.returnDataMonitoringItems = [] as any;
                for (let item of _data["returnDataMonitoringItems"])
                    this.returnDataMonitoringItems!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleToBeReturned"] = this.sampleToBeReturned;
        data["sampleDepth"] = this.sampleDepth;
        data["reportingDueMonths"] = this.reportingDueMonths;
        data["reportingDueDate"] = this.reportingDueDate ? this.reportingDueDate.toISOString() : <any>undefined;
        data["repositoryTypeName"] = this.repositoryTypeName;
        if (Array.isArray(this.analysisTypeNames)) {
            data["analysisTypeNames"] = [];
            for (let item of this.analysisTypeNames)
                data["analysisTypeNames"].push(item);
        }
        if (Array.isArray(this.sampleTypeNames)) {
            data["sampleTypeNames"] = [];
            for (let item of this.sampleTypeNames)
                data["sampleTypeNames"].push(item);
        }
        if (Array.isArray(this.returnDataMonitoringItems)) {
            data["returnDataMonitoringItems"] = [];
            for (let item of this.returnDataMonitoringItems)
                data["returnDataMonitoringItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    repositoryTypeName?: string | undefined;
    analysisTypeNames: string[];
    sampleTypeNames: string[];
    returnDataMonitoringItems: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    exportToCountryName?: string | undefined;
    repositoryTypeName?: string | undefined;
    analysisTypeNames!: string[];
    sampleTypeNames!: string[];
    returnDataMonitoringItems!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.analysisTypeNames = [];
            this.sampleTypeNames = [];
            this.returnDataMonitoringItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleToBeReturned = _data["sampleToBeReturned"];
            this.sampleDepth = _data["sampleDepth"];
            this.reportingDueMonths = _data["reportingDueMonths"];
            this.reportingDueDate = _data["reportingDueDate"] ? new Date(_data["reportingDueDate"].toString()) : <any>undefined;
            this.exportToCountryName = _data["exportToCountryName"];
            this.repositoryTypeName = _data["repositoryTypeName"];
            if (Array.isArray(_data["analysisTypeNames"])) {
                this.analysisTypeNames = [] as any;
                for (let item of _data["analysisTypeNames"])
                    this.analysisTypeNames!.push(item);
            }
            if (Array.isArray(_data["sampleTypeNames"])) {
                this.sampleTypeNames = [] as any;
                for (let item of _data["sampleTypeNames"])
                    this.sampleTypeNames!.push(item);
            }
            if (Array.isArray(_data["returnDataMonitoringItems"])) {
                this.returnDataMonitoringItems = [] as any;
                for (let item of _data["returnDataMonitoringItems"])
                    this.returnDataMonitoringItems!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleToBeReturned"] = this.sampleToBeReturned;
        data["sampleDepth"] = this.sampleDepth;
        data["reportingDueMonths"] = this.reportingDueMonths;
        data["reportingDueDate"] = this.reportingDueDate ? this.reportingDueDate.toISOString() : <any>undefined;
        data["exportToCountryName"] = this.exportToCountryName;
        data["repositoryTypeName"] = this.repositoryTypeName;
        if (Array.isArray(this.analysisTypeNames)) {
            data["analysisTypeNames"] = [];
            for (let item of this.analysisTypeNames)
                data["analysisTypeNames"].push(item);
        }
        if (Array.isArray(this.sampleTypeNames)) {
            data["sampleTypeNames"] = [];
            for (let item of this.sampleTypeNames)
                data["sampleTypeNames"].push(item);
        }
        if (Array.isArray(this.returnDataMonitoringItems)) {
            data["returnDataMonitoringItems"] = [];
            for (let item of this.returnDataMonitoringItems)
                data["returnDataMonitoringItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategorySamplingExportDetailsDto {
    sampleToBeReturned?: boolean | undefined;
    sampleDepth?: string | undefined;
    reportingDueMonths?: number | undefined;
    reportingDueDate?: Date | undefined;
    exportToCountryName?: string | undefined;
    repositoryTypeName?: string | undefined;
    analysisTypeNames: string[];
    sampleTypeNames: string[];
    returnDataMonitoringItems: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto[];
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto {
    acquisitionId!: number;
    acquisitionName!: string;
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionName = _data["acquisitionName"];
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionName"] = this.acquisitionName;
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto {
    acquisitionId: number;
    acquisitionName: string;
    surveyId: number;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto {
    boreholeId!: number;
    boreholeName!: string;
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeId = _data["boreholeId"];
            this.boreholeName = _data["boreholeName"];
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeId"] = this.boreholeId;
        data["boreholeName"] = this.boreholeName;
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto {
    boreholeId: number;
    boreholeName: string;
    wellId: number;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto {
    dataMonitoringItemId!: number;
    dataMonitoringItemIdentifier!: string;
    dataMonitoringItemTypeName!: string;
    activityType!: NopimsActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
            this.dataMonitoringItemIdentifier = _data["dataMonitoringItemIdentifier"];
            this.dataMonitoringItemTypeName = _data["dataMonitoringItemTypeName"];
            this.activityType = _data["activityType"];
            this.boreholeDetails = _data["boreholeDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto.fromJS(_data["boreholeDetails"]) : <any>undefined;
            this.acquisitionDetails = _data["acquisitionDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto.fromJS(_data["acquisitionDetails"]) : <any>undefined;
            this.projectDetails = _data["projectDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto.fromJS(_data["projectDetails"]) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        data["dataMonitoringItemIdentifier"] = this.dataMonitoringItemIdentifier;
        data["dataMonitoringItemTypeName"] = this.dataMonitoringItemTypeName;
        data["activityType"] = this.activityType;
        data["boreholeDetails"] = this.boreholeDetails ? this.boreholeDetails.toJSON() : <any>undefined;
        data["acquisitionDetails"] = this.acquisitionDetails ? this.acquisitionDetails.toJSON() : <any>undefined;
        data["projectDetails"] = this.projectDetails ? this.projectDetails.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemDto {
    dataMonitoringItemId: number;
    dataMonitoringItemIdentifier: string;
    dataMonitoringItemTypeName: string;
    activityType: NopimsActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto {
    projectId!: number;
    projectName!: string;
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto {
    projectId: number;
    projectName: string;
    reprocessingId: number;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto {
    id!: number;
    identifier!: string;
    requestDate!: Date;
    activityType?: AuthorisationActivityTypeEnum | undefined;
    type!: string;
    status!: string;
    resubmission?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto | undefined;
    requestingCompanyName?: string | undefined;
    contactName?: string | undefined;
    operatorCompanyName?: string | undefined;
    boreholes!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto[];
    acquisitions!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto[];
    reprocessingProjects!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto[];
    titles!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto[];
    isNonTitleholderRequest!: boolean;
    nonTitleholderContractorCompanyName?: string | undefined;
    nonTitleholderContactPhoneNumber?: string | undefined;
    nonTitleholderContactEmailAddress?: string | undefined;
    originalRequest?: string | undefined;
    categories!: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto[];
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewProjects!: boolean;
    canViewDataSubmissions!: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholes = [];
            this.acquisitions = [];
            this.reprocessingProjects = [];
            this.titles = [];
            this.categories = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.activityType = _data["activityType"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.resubmission = _data["resubmission"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto.fromJS(_data["resubmission"]) : <any>undefined;
            this.requestingCompanyName = _data["requestingCompanyName"];
            this.contactName = _data["contactName"];
            this.operatorCompanyName = _data["operatorCompanyName"];
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto.fromJS(item));
            }
            this.isNonTitleholderRequest = _data["isNonTitleholderRequest"];
            this.nonTitleholderContractorCompanyName = _data["nonTitleholderContractorCompanyName"];
            this.nonTitleholderContactPhoneNumber = _data["nonTitleholderContactPhoneNumber"];
            this.nonTitleholderContactEmailAddress = _data["nonTitleholderContactEmailAddress"];
            this.originalRequest = _data["originalRequest"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto.fromJS(item));
            }
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewProjects = _data["canViewProjects"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["activityType"] = this.activityType;
        data["type"] = this.type;
        data["status"] = this.status;
        data["resubmission"] = this.resubmission ? this.resubmission.toJSON() : <any>undefined;
        data["requestingCompanyName"] = this.requestingCompanyName;
        data["contactName"] = this.contactName;
        data["operatorCompanyName"] = this.operatorCompanyName;
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["isNonTitleholderRequest"] = this.isNonTitleholderRequest;
        data["nonTitleholderContractorCompanyName"] = this.nonTitleholderContractorCompanyName;
        data["nonTitleholderContactPhoneNumber"] = this.nonTitleholderContactPhoneNumber;
        data["nonTitleholderContactEmailAddress"] = this.nonTitleholderContactEmailAddress;
        data["originalRequest"] = this.originalRequest;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewProjects"] = this.canViewProjects;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDto {
    id: number;
    identifier: string;
    requestDate: Date;
    activityType?: AuthorisationActivityTypeEnum | undefined;
    type: string;
    status: string;
    resubmission?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto | undefined;
    requestingCompanyName?: string | undefined;
    contactName?: string | undefined;
    operatorCompanyName?: string | undefined;
    boreholes: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseBoreholeDto[];
    acquisitions: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseAcquisitionDto[];
    reprocessingProjects: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto[];
    titles: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto[];
    isNonTitleholderRequest: boolean;
    nonTitleholderContractorCompanyName?: string | undefined;
    nonTitleholderContactPhoneNumber?: string | undefined;
    nonTitleholderContactEmailAddress?: string | undefined;
    originalRequest?: string | undefined;
    categories: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseCategoryDetailsDto[];
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewProjects: boolean;
    canViewDataSubmissions: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto {
    dataMonitoringItemId?: number | undefined;
    dataMonitoringItemIdentifier!: string;
    dataMonitoringItemTypeName!: string;
    activityType!: NopimsActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
            this.dataMonitoringItemIdentifier = _data["dataMonitoringItemIdentifier"];
            this.dataMonitoringItemTypeName = _data["dataMonitoringItemTypeName"];
            this.activityType = _data["activityType"];
            this.boreholeDetails = _data["boreholeDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto.fromJS(_data["boreholeDetails"]) : <any>undefined;
            this.acquisitionDetails = _data["acquisitionDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto.fromJS(_data["acquisitionDetails"]) : <any>undefined;
            this.projectDetails = _data["projectDetails"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto.fromJS(_data["projectDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        data["dataMonitoringItemIdentifier"] = this.dataMonitoringItemIdentifier;
        data["dataMonitoringItemTypeName"] = this.dataMonitoringItemTypeName;
        data["activityType"] = this.activityType;
        data["boreholeDetails"] = this.boreholeDetails ? this.boreholeDetails.toJSON() : <any>undefined;
        data["acquisitionDetails"] = this.acquisitionDetails ? this.acquisitionDetails.toJSON() : <any>undefined;
        data["projectDetails"] = this.projectDetails ? this.projectDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseExportReturnDataMonitoringItemDto {
    dataMonitoringItemId?: number | undefined;
    dataMonitoringItemIdentifier: string;
    dataMonitoringItemTypeName: string;
    activityType: NopimsActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseDataMonitoringItemProjectDto | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto {
    id!: number;
    reprocessingId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reprocessingId = _data["reprocessingId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reprocessingId"] = this.reprocessingId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseProjectDto {
    id: number;
    reprocessingId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto {
    id!: number;
    dataSubmissionId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataSubmissionId = _data["dataSubmissionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataSubmissionId"] = this.dataSubmissionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseResubmissionDto {
    id: number;
    dataSubmissionId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto {
    id!: string;
    titleNumber!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationDetailsResponseTitleDto {
    id: string;
    titleNumber: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto {
    searchType!: SearchAuthorisationsTypeEnum;
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data["searchType"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchType"] = this.searchType;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListRequestDto {
    searchType: SearchAuthorisationsTypeEnum;
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto {
    items!: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto[];
    isResultSetLimited!: boolean;
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewProjects!: boolean;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewProjects = _data["canViewProjects"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewProjects"] = this.canViewProjects;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseDto {
    items: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto[];
    isResultSetLimited: boolean;
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewProjects: boolean;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto {
    id!: number;
    surveyId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto {
    id: number;
    surveyId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto {
    activityType!: NopimsActivityTypeEnum;
    borehole?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto | undefined;
    reprocessingProject?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityType = _data["activityType"];
            this.borehole = _data["borehole"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto.fromJS(_data["borehole"]) : <any>undefined;
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto.fromJS(_data["acquisition"]) : <any>undefined;
            this.reprocessingProject = _data["reprocessingProject"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto.fromJS(_data["reprocessingProject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType;
        data["borehole"] = this.borehole ? this.borehole.toJSON() : <any>undefined;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["reprocessingProject"] = this.reprocessingProject ? this.reprocessingProject.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto {
    activityType: NopimsActivityTypeEnum;
    borehole?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemAcquisitionDto | undefined;
    reprocessingProject?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto {
    id!: number;
    wellId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemBoreholeDto {
    id: number;
    wellId: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto {
    id!: number;
    identifier!: string;
    activityType?: string | undefined;
    requestDate!: Date;
    operatorCompany?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto | undefined;
    activities!: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto[];
    type!: string;
    categories!: string[];
    status!: string;
    decisionDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activities = [];
            this.categories = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.activityType = _data["activityType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.operatorCompany = _data["operatorCompany"] ? GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto.fromJS(_data["operatorCompany"]) : <any>undefined;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto.fromJS(item));
            }
            this.type = _data["type"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            this.status = _data["status"];
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["activityType"] = this.activityType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["operatorCompany"] = this.operatorCompany ? this.operatorCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["type"] = this.type;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["status"] = this.status;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemDto {
    id: number;
    identifier: string;
    activityType?: string | undefined;
    requestDate: Date;
    operatorCompany?: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto | undefined;
    activities: GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemActivityDto[];
    type: string;
    categories: string[];
    status: string;
    decisionDate?: Date | undefined;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemOperatorCompanyDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto implements IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto {
    id!: number;
    reprocessingId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reprocessingId = _data["reprocessingId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reprocessingId"] = this.reprocessingId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAuthorisationsAuthorisationListResponseItemReprocessingProjectDto {
    id: number;
    reprocessingId: number;
    name: string;
}

export class GeoscienceAustraliaSecureUserDetailsDto implements IGeoscienceAustraliaSecureUserDetailsDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    registrationDatetime!: Date;
    lastLoginDatetime?: Date | undefined;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    isSecureUserBlocked!: boolean;
    isSecureUserRevokedButVisible!: boolean;
    isSecureUserSignedIn!: boolean;
    hasPendingRequest!: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
    hasInactivityWarning!: boolean;
    badgeSortOrder!: number;
    activeRoles!: SecureRoleEnum[];

    constructor(data?: IGeoscienceAustraliaSecureUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.accountStatus = _data["accountStatus"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserRevokedButVisible = _data["isSecureUserRevokedButVisible"];
            this.isSecureUserSignedIn = _data["isSecureUserSignedIn"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedDatetime = _data["lastUpdatedDatetime"] ? new Date(_data["lastUpdatedDatetime"].toString()) : <any>undefined;
            this.hasInactivityWarning = _data["hasInactivityWarning"];
            this.badgeSortOrder = _data["badgeSortOrder"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): GeoscienceAustraliaSecureUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaSecureUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["accountStatus"] = this.accountStatus;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserRevokedButVisible"] = this.isSecureUserRevokedButVisible;
        data["isSecureUserSignedIn"] = this.isSecureUserSignedIn;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedDatetime"] = this.lastUpdatedDatetime ? this.lastUpdatedDatetime.toISOString() : <any>undefined;
        data["hasInactivityWarning"] = this.hasInactivityWarning;
        data["badgeSortOrder"] = this.badgeSortOrder;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        return data;
    }
}

export interface IGeoscienceAustraliaSecureUserDetailsDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    registrationDatetime: Date;
    lastLoginDatetime?: Date | undefined;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    isSecureUserBlocked: boolean;
    isSecureUserRevokedButVisible: boolean;
    isSecureUserSignedIn: boolean;
    hasPendingRequest: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
    hasInactivityWarning: boolean;
    badgeSortOrder: number;
    activeRoles: SecureRoleEnum[];
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto {
    dataSubmissionId!: number;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesRequestDto {
    dataSubmissionId: number;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto {
    activityType!: NopimsActivityTypeEnum;
    dataSubmissionName!: string;
    dataSubmissionDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataSubmissionDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityType = _data["activityType"];
            this.dataSubmissionName = _data["dataSubmissionName"];
            this.dataSubmissionDataAuditChanges = _data["dataSubmissionDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["dataSubmissionDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType;
        data["dataSubmissionName"] = this.dataSubmissionName;
        data["dataSubmissionDataAuditChanges"] = this.dataSubmissionDataAuditChanges ? this.dataSubmissionDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataAuditChangesResponseDto {
    activityType: NopimsActivityTypeEnum;
    dataSubmissionName: string;
    dataSubmissionDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto {
    dataSubmissionId!: number;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsRequestDto {
    dataSubmissionId: number;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto {
    id!: number;
    surveyId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto {
    id: number;
    surveyId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto {
    id!: number;
    wellId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto {
    id: number;
    wellId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classification?: string | undefined;
    sortOrder!: number;
    acquisitionType?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classification = _data["classification"];
            this.sortOrder = _data["sortOrder"];
            this.acquisitionType = _data["acquisitionType"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classification"] = this.classification;
        data["sortOrder"] = this.sortOrder;
        data["acquisitionType"] = this.acquisitionType;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classification?: string | undefined;
    sortOrder: number;
    acquisitionType?: string | undefined;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto {
    dataSubmissionId!: number;
    dataSubmissionName!: string;
    type!: NopimsActivityTypeEnum;
    items!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto[];
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewReprocessingProjects!: boolean;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
            this.dataSubmissionName = _data["dataSubmissionName"];
            this.type = _data["type"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto.fromJS(item));
            }
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewReprocessingProjects = _data["canViewReprocessingProjects"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        data["dataSubmissionName"] = this.dataSubmissionName;
        data["type"] = this.type;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewReprocessingProjects"] = this.canViewReprocessingProjects;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDto {
    dataSubmissionId: number;
    dataSubmissionName: string;
    type: NopimsActivityTypeEnum;
    items: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto[];
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewReprocessingProjects: boolean;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    borehole?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto | undefined;
    project?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto | undefined;
    status!: string;
    receivedDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.borehole = _data["borehole"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto.fromJS(_data["borehole"]) : <any>undefined;
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto.fromJS(_data["acquisition"]) : <any>undefined;
            this.project = _data["project"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.status = _data["status"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["borehole"] = this.borehole ? this.borehole.toJSON() : <any>undefined;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    borehole?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseAcquisitionDto | undefined;
    project?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto | undefined;
    status: string;
    receivedDate?: Date | undefined;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto {
    id!: number;
    reprocessingId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reprocessingId = _data["reprocessingId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reprocessingId"] = this.reprocessingId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDataMonitoringItemsResponseProjectDto {
    id: number;
    reprocessingId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto {
    id!: number;
    name!: string;
    type!: NopimsActivityTypeEnum;
    wellDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto | undefined;
    surveyDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto | undefined;
    reprocessingDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto | undefined;
    classificationType!: string;
    contactName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    receivedDate?: Date | undefined;
    comments?: string | undefined;
    canViewWells!: boolean;
    canViewBoreholes!: boolean;
    canViewSurveys!: boolean;
    canViewAcquisitions!: boolean;
    canViewReprocessing!: boolean;
    canViewReprocessingProjects!: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.wellDetails = _data["wellDetails"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto.fromJS(_data["wellDetails"]) : <any>undefined;
            this.surveyDetails = _data["surveyDetails"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto.fromJS(_data["surveyDetails"]) : <any>undefined;
            this.reprocessingDetails = _data["reprocessingDetails"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto.fromJS(_data["reprocessingDetails"]) : <any>undefined;
            this.classificationType = _data["classificationType"];
            this.contactName = _data["contactName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.canViewWells = _data["canViewWells"];
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewSurveys = _data["canViewSurveys"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewReprocessing = _data["canViewReprocessing"];
            this.canViewReprocessingProjects = _data["canViewReprocessingProjects"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["wellDetails"] = this.wellDetails ? this.wellDetails.toJSON() : <any>undefined;
        data["surveyDetails"] = this.surveyDetails ? this.surveyDetails.toJSON() : <any>undefined;
        data["reprocessingDetails"] = this.reprocessingDetails ? this.reprocessingDetails.toJSON() : <any>undefined;
        data["classificationType"] = this.classificationType;
        data["contactName"] = this.contactName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["canViewWells"] = this.canViewWells;
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewSurveys"] = this.canViewSurveys;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewReprocessing"] = this.canViewReprocessing;
        data["canViewReprocessingProjects"] = this.canViewReprocessingProjects;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseDto {
    id: number;
    name: string;
    type: NopimsActivityTypeEnum;
    wellDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto | undefined;
    surveyDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto | undefined;
    reprocessingDetails?: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto | undefined;
    classificationType: string;
    contactName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    receivedDate?: Date | undefined;
    comments?: string | undefined;
    canViewWells: boolean;
    canViewBoreholes: boolean;
    canViewSurveys: boolean;
    canViewAcquisitions: boolean;
    canViewReprocessing: boolean;
    canViewReprocessingProjects: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto {
    projectOperatorCompanies!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    reprocessing!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    projects!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectOperatorCompanies = [];
            this.reprocessing = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            this.projects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectOperatorCompanies"])) {
                this.projectOperatorCompanies = [] as any;
                for (let item of _data["projectOperatorCompanies"])
                    this.projectOperatorCompanies!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
            this.reprocessing = _data["reprocessing"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(_data["reprocessing"]) : new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectOperatorCompanies)) {
            data["projectOperatorCompanies"] = [];
            for (let item of this.projectOperatorCompanies)
                data["projectOperatorCompanies"].push(item.toJSON());
        }
        data["reprocessing"] = this.reprocessing ? this.reprocessing.toJSON() : <any>undefined;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReprocessingDto {
    projectOperatorCompanies: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    reprocessing: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    projects: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto {
    acquisitionOperatorCompanies!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    survey!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    acquisitions!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitionOperatorCompanies = [];
            this.survey = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            this.acquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["acquisitionOperatorCompanies"])) {
                this.acquisitionOperatorCompanies = [] as any;
                for (let item of _data["acquisitionOperatorCompanies"])
                    this.acquisitionOperatorCompanies!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
            this.survey = _data["survey"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(_data["survey"]) : new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.acquisitionOperatorCompanies)) {
            data["acquisitionOperatorCompanies"] = [];
            for (let item of this.acquisitionOperatorCompanies)
                data["acquisitionOperatorCompanies"].push(item.toJSON());
        }
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseSurveyDto {
    acquisitionOperatorCompanies: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    survey: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    acquisitions: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
}

export class GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto implements IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto {
    boreholeOperatorCompanies!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    well!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    boreholes!: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholeOperatorCompanies = [];
            this.well = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            this.boreholes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boreholeOperatorCompanies"])) {
                this.boreholeOperatorCompanies = [] as any;
                for (let item of _data["boreholeOperatorCompanies"])
                    this.boreholeOperatorCompanies!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
            this.well = _data["well"] ? GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(_data["well"]) : new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto();
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boreholeOperatorCompanies)) {
            data["boreholeOperatorCompanies"] = [];
            for (let item of this.boreholeOperatorCompanies)
                data["boreholeOperatorCompanies"].push(item.toJSON());
        }
        data["well"] = this.well ? this.well.toJSON() : <any>undefined;
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseWellDto {
    boreholeOperatorCompanies: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
    well: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto;
    boreholes: GetGeoscienceAustraliaDataSubmissionDataSubmissionDetailsResponseReferenceDto[];
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto {
    dataSubmissionId!: number;
    resubmissionId!: number;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
            this.resubmissionId = _data["resubmissionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        data["resubmissionId"] = this.resubmissionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsRequestDto {
    dataSubmissionId: number;
    resubmissionId: number;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto {
    id!: number;
    surveyId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto {
    id: number;
    surveyId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto {
    id!: number;
    wellId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto {
    id: number;
    wellId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;
    name!: string;
    classification!: string;
    status!: string;
    borehole?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto | undefined;
    project?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.classification = _data["classification"];
            this.status = _data["status"];
            this.borehole = _data["borehole"] ? GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto.fromJS(_data["borehole"]) : <any>undefined;
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto.fromJS(_data["acquisition"]) : <any>undefined;
            this.project = _data["project"] ? GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["classification"] = this.classification;
        data["status"] = this.status;
        data["borehole"] = this.borehole ? this.borehole.toJSON() : <any>undefined;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
    name: string;
    classification: string;
    status: string;
    borehole?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseBoreholeDto | undefined;
    acquisition?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseAcquisitionDto | undefined;
    project?: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto | undefined;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto {
    dataSubmissionId!: number;
    resubmissionId!: number;
    dataSubmissionName!: string;
    resubmissionName!: string;
    status!: DataSubmissionResubmissionStatusEnum;
    type!: NopimsActivityTypeEnum;
    requestedDate?: Date | undefined;
    dueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    commentsHtml?: string | undefined;
    resubmissionItems!: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto[];
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewReprocessingProjects!: boolean;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resubmissionItems = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
            this.resubmissionId = _data["resubmissionId"];
            this.dataSubmissionName = _data["dataSubmissionName"];
            this.resubmissionName = _data["resubmissionName"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.commentsHtml = _data["commentsHtml"];
            if (Array.isArray(_data["resubmissionItems"])) {
                this.resubmissionItems = [] as any;
                for (let item of _data["resubmissionItems"])
                    this.resubmissionItems!.push(GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto.fromJS(item));
            }
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewReprocessingProjects = _data["canViewReprocessingProjects"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        data["resubmissionId"] = this.resubmissionId;
        data["dataSubmissionName"] = this.dataSubmissionName;
        data["resubmissionName"] = this.resubmissionName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["commentsHtml"] = this.commentsHtml;
        if (Array.isArray(this.resubmissionItems)) {
            data["resubmissionItems"] = [];
            for (let item of this.resubmissionItems)
                data["resubmissionItems"].push(item.toJSON());
        }
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewReprocessingProjects"] = this.canViewReprocessingProjects;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDto {
    dataSubmissionId: number;
    resubmissionId: number;
    dataSubmissionName: string;
    resubmissionName: string;
    status: DataSubmissionResubmissionStatusEnum;
    type: NopimsActivityTypeEnum;
    requestedDate?: Date | undefined;
    dueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    commentsHtml?: string | undefined;
    resubmissionItems: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto[];
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewReprocessingProjects: boolean;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto {
    id!: number;
    dataMonitoringItem!: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto;
    reason?: string | undefined;
    outcome?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto();
            this.reason = _data["reason"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["reason"] = this.reason;
        data["outcome"] = this.outcome;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseItemDto {
    id: number;
    dataMonitoringItem: GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseDataMonitoringItemDto;
    reason?: string | undefined;
    outcome?: string | undefined;
}

export class GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto implements IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto {
    id!: number;
    reprocessingId!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reprocessingId = _data["reprocessingId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reprocessingId"] = this.reprocessingId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionDataResubmissionDetailsResponseProjectDto {
    id: number;
    reprocessingId: number;
    name: string;
}

export class GetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto implements IGetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto {
    dataSubmissionId!: number;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionResubmissionListRequestDto {
    dataSubmissionId: number;
}

export class GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto implements IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto {
    dataSubmissionId!: number;
    dataSubmissionName!: string;
    dataSubmissionType!: NopimsActivityTypeEnum;
    items!: GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto[];

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSubmissionId = _data["dataSubmissionId"];
            this.dataSubmissionName = _data["dataSubmissionName"];
            this.dataSubmissionType = _data["dataSubmissionType"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSubmissionId"] = this.dataSubmissionId;
        data["dataSubmissionName"] = this.dataSubmissionName;
        data["dataSubmissionType"] = this.dataSubmissionType;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseDto {
    dataSubmissionId: number;
    dataSubmissionName: string;
    dataSubmissionType: NopimsActivityTypeEnum;
    items: GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto[];
}

export class GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto implements IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto {
    resubmissionId!: number;
    name!: string;
    status!: string;
    requestedDate?: Date | undefined;
    dueDate?: Date | undefined;
    receivedDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resubmissionId = _data["resubmissionId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resubmissionId"] = this.resubmissionId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaDataSubmissionResubmissionListResponseItemDto {
    resubmissionId: number;
    name: string;
    status: string;
    requestedDate?: Date | undefined;
    dueDate?: Date | undefined;
    receivedDate?: Date | undefined;
}

export class GetGeoscienceAustraliaFeedbackDetailsRequestDto implements IGetGeoscienceAustraliaFeedbackDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaFeedbackDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaFeedbackDetailsResponseDto implements IGetGeoscienceAustraliaFeedbackDetailsResponseDto {
    id!: number;
    identifier!: string;
    submittedDate!: Date;
    feedbackType!: FeedbackTypeEnum;
    feedbackTypeName!: string;
    customerComments!: string;
    nopimsActivityTypeName?: string | undefined;
    dataMonitoringItemTypeName?: string | undefined;
    dataFeedbackActivityName?: string | undefined;
    honorificName?: string | undefined;
    customerFirstName!: string;
    customerLastName!: string;
    customerCompanyName?: string | undefined;
    customerContactNumber!: string;
    customerEmailAddress!: string;
    status!: string;
    assignmentGroup?: AssignmentGroupEnum | undefined;
    assignedUserId?: number | undefined;
    completionComments?: string | undefined;
    isComplete!: boolean;
    canManage!: boolean;
    versionNumber!: number;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaFeedbackDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.feedbackType = _data["feedbackType"];
            this.feedbackTypeName = _data["feedbackTypeName"];
            this.customerComments = _data["customerComments"];
            this.nopimsActivityTypeName = _data["nopimsActivityTypeName"];
            this.dataMonitoringItemTypeName = _data["dataMonitoringItemTypeName"];
            this.dataFeedbackActivityName = _data["dataFeedbackActivityName"];
            this.honorificName = _data["honorificName"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerCompanyName = _data["customerCompanyName"];
            this.customerContactNumber = _data["customerContactNumber"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.status = _data["status"];
            this.assignmentGroup = _data["assignmentGroup"];
            this.assignedUserId = _data["assignedUserId"];
            this.completionComments = _data["completionComments"];
            this.isComplete = _data["isComplete"];
            this.canManage = _data["canManage"];
            this.versionNumber = _data["versionNumber"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["feedbackType"] = this.feedbackType;
        data["feedbackTypeName"] = this.feedbackTypeName;
        data["customerComments"] = this.customerComments;
        data["nopimsActivityTypeName"] = this.nopimsActivityTypeName;
        data["dataMonitoringItemTypeName"] = this.dataMonitoringItemTypeName;
        data["dataFeedbackActivityName"] = this.dataFeedbackActivityName;
        data["honorificName"] = this.honorificName;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerCompanyName"] = this.customerCompanyName;
        data["customerContactNumber"] = this.customerContactNumber;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["status"] = this.status;
        data["assignmentGroup"] = this.assignmentGroup;
        data["assignedUserId"] = this.assignedUserId;
        data["completionComments"] = this.completionComments;
        data["isComplete"] = this.isComplete;
        data["canManage"] = this.canManage;
        data["versionNumber"] = this.versionNumber;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackDetailsResponseDto {
    id: number;
    identifier: string;
    submittedDate: Date;
    feedbackType: FeedbackTypeEnum;
    feedbackTypeName: string;
    customerComments: string;
    nopimsActivityTypeName?: string | undefined;
    dataMonitoringItemTypeName?: string | undefined;
    dataFeedbackActivityName?: string | undefined;
    honorificName?: string | undefined;
    customerFirstName: string;
    customerLastName: string;
    customerCompanyName?: string | undefined;
    customerContactNumber: string;
    customerEmailAddress: string;
    status: string;
    assignmentGroup?: AssignmentGroupEnum | undefined;
    assignedUserId?: number | undefined;
    completionComments?: string | undefined;
    isComplete: boolean;
    canManage: boolean;
    versionNumber: number;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaFeedbackReferenceDataRequestDto implements IGetGeoscienceAustraliaFeedbackReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaFeedbackReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto implements IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto {
    id!: number;
    assignmentGroup!: AssignmentGroupEnum;
    isActive!: boolean;
    canManage!: boolean;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignmentGroup = _data["assignmentGroup"];
            this.isActive = _data["isActive"];
            this.canManage = _data["canManage"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignmentGroup"] = this.assignmentGroup;
        data["isActive"] = this.isActive;
        data["canManage"] = this.canManage;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto {
    id: number;
    assignmentGroup: AssignmentGroupEnum;
    isActive: boolean;
    canManage: boolean;
    name: string;
}

export class GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto implements IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto {
    assignmentGroup!: AssignmentGroupEnum;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentGroup = _data["assignmentGroup"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentGroup"] = this.assignmentGroup;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto {
    assignmentGroup: AssignmentGroupEnum;
    name: string;
}

export class GetGeoscienceAustraliaFeedbackReferenceDataResponseDto implements IGetGeoscienceAustraliaFeedbackReferenceDataResponseDto {
    assignmentGroups!: GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto[];
    assignedUsers!: GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto[];

    constructor(data?: IGetGeoscienceAustraliaFeedbackReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignmentGroups = [];
            this.assignedUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignmentGroups"])) {
                this.assignmentGroups = [] as any;
                for (let item of _data["assignmentGroups"])
                    this.assignmentGroups!.push(GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignmentGroups)) {
            data["assignmentGroups"] = [];
            for (let item of this.assignmentGroups)
                data["assignmentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackReferenceDataResponseDto {
    assignmentGroups: GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignmentGroupDto[];
    assignedUsers: GetGeoscienceAustraliaFeedbackReferenceDataResponseAssignedUserDto[];
}

export class SaveGeoscienceAustraliaFeedbackDetailsRequestDto implements ISaveGeoscienceAustraliaFeedbackDetailsRequestDto {
    id!: number;
    versionNumber!: number;
    assignmentGroup!: AssignmentGroupEnum;
    assignedUserId!: number;
    completionComments?: string | undefined;
    isComplete!: boolean;

    constructor(data?: ISaveGeoscienceAustraliaFeedbackDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.assignmentGroup = _data["assignmentGroup"];
            this.assignedUserId = _data["assignedUserId"];
            this.completionComments = _data["completionComments"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaFeedbackDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaFeedbackDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["assignmentGroup"] = this.assignmentGroup;
        data["assignedUserId"] = this.assignedUserId;
        data["completionComments"] = this.completionComments;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface ISaveGeoscienceAustraliaFeedbackDetailsRequestDto {
    id: number;
    versionNumber: number;
    assignmentGroup: AssignmentGroupEnum;
    assignedUserId: number;
    completionComments?: string | undefined;
    isComplete: boolean;
}

export class SaveGeoscienceAustraliaFeedbackDetailsResponseDto implements ISaveGeoscienceAustraliaFeedbackDetailsResponseDto {
    isComplete!: boolean;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveGeoscienceAustraliaFeedbackDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplete = _data["isComplete"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaFeedbackDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaFeedbackDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplete"] = this.isComplete;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveGeoscienceAustraliaFeedbackDetailsResponseDto {
    isComplete: boolean;
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaFeedbackListItemDto implements IGetGeoscienceAustraliaFeedbackListItemDto {
    id!: number;
    identifier!: string;
    status!: string;
    submittedDate!: Date;
    assignmentGroupName?: string | undefined;
    assignedUserName?: string | undefined;
    feedbackTypeName!: string;
    customerCompanyName?: string | undefined;
    customerFullName!: string;

    constructor(data?: IGetGeoscienceAustraliaFeedbackListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.assignmentGroupName = _data["assignmentGroupName"];
            this.assignedUserName = _data["assignedUserName"];
            this.feedbackTypeName = _data["feedbackTypeName"];
            this.customerCompanyName = _data["customerCompanyName"];
            this.customerFullName = _data["customerFullName"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["assignmentGroupName"] = this.assignmentGroupName;
        data["assignedUserName"] = this.assignedUserName;
        data["feedbackTypeName"] = this.feedbackTypeName;
        data["customerCompanyName"] = this.customerCompanyName;
        data["customerFullName"] = this.customerFullName;
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackListItemDto {
    id: number;
    identifier: string;
    status: string;
    submittedDate: Date;
    assignmentGroupName?: string | undefined;
    assignedUserName?: string | undefined;
    feedbackTypeName: string;
    customerCompanyName?: string | undefined;
    customerFullName: string;
}

export class GetGeoscienceAustraliaFeedbackListRequestDto implements IGetGeoscienceAustraliaFeedbackListRequestDto {

    constructor(data?: IGetGeoscienceAustraliaFeedbackListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackListRequestDto {
}

export class GetGeoscienceAustraliaFeedbackListResponseDto implements IGetGeoscienceAustraliaFeedbackListResponseDto {
    items!: GetGeoscienceAustraliaFeedbackListItemDto[];

    constructor(data?: IGetGeoscienceAustraliaFeedbackListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaFeedbackListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaFeedbackListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaFeedbackListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaFeedbackListResponseDto {
    items: GetGeoscienceAustraliaFeedbackListItemDto[];
}

export class CreateGeoscienceAustraliaReportAttachmentRequestDto implements ICreateGeoscienceAustraliaReportAttachmentRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: ICreateGeoscienceAustraliaReportAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaReportAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaReportAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaReportAttachmentRequestDto {
    reportId: number;
    reportVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
}

export class CreateGeoscienceAustraliaReportAttachmentResponseDto implements ICreateGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaReportAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaReportAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaReportAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class DeleteGeoscienceAustraliaReportAttachmentRequestDto implements IDeleteGeoscienceAustraliaReportAttachmentRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    reportAttachmentId!: number;

    constructor(data?: IDeleteGeoscienceAustraliaReportAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.reportAttachmentId = _data["reportAttachmentId"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["reportAttachmentId"] = this.reportAttachmentId;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportAttachmentRequestDto {
    reportId: number;
    reportVersionNumber: number;
    reportAttachmentId: number;
}

export class DeleteGeoscienceAustraliaReportAttachmentResponseDto implements IDeleteGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaReportAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaReportAttachmentsItemDto implements IGetGeoscienceAustraliaReportAttachmentsItemDto {
    id!: number;
    reportId!: number;
    reportVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
    fileSize!: number;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaReportAttachmentsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedDate = _data["uploadedDate"] ? new Date(_data["uploadedDate"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportAttachmentsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportAttachmentsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportAttachmentsItemDto {
    id: number;
    reportId: number;
    reportVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaReportAttachmentsRequestDto implements IGetGeoscienceAustraliaReportAttachmentsRequestDto {
    reportId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportAttachmentsRequestDto {
    reportId: number;
}

export class GetGeoscienceAustraliaReportAttachmentsResponseDto implements IGetGeoscienceAustraliaReportAttachmentsResponseDto {
    reportId!: number;
    reportVersionNumber!: number;
    reportHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    attachments?: GetGeoscienceAustraliaReportAttachmentsItemDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.reportHeader = _data["reportHeader"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["reportHeader"] = this.reportHeader;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportAttachmentsResponseDto {
    reportId: number;
    reportVersionNumber: number;
    reportHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    attachments?: GetGeoscienceAustraliaReportAttachmentsItemDto[] | undefined;
}

export class UpdateGeoscienceAustraliaReportAttachmentRequestDto implements IUpdateGeoscienceAustraliaReportAttachmentRequestDto {
    reportAttachmentId!: number;
    reportId!: number;
    reportVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportAttachmentId = _data["reportAttachmentId"];
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportAttachmentId"] = this.reportAttachmentId;
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportAttachmentRequestDto {
    reportAttachmentId: number;
    reportId: number;
    reportVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
}

export class UpdateGeoscienceAustraliaReportAttachmentResponseDto implements IUpdateGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportAttachmentResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class CreateGeoscienceAustraliaReportRequestDto implements ICreateGeoscienceAustraliaReportRequestDto {
    itemId?: string | undefined;
    isConfidential!: boolean;
    wellBoreholeIds!: number[];
    surveyAcquisitionIds!: number[];
    reprocessingProjectIds!: number[];
    tapeId?: string | undefined;
    reportTypeId!: number;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    reportTitle?: string | undefined;
    remarks?: string | undefined;
    confidentialityRemarks?: string | undefined;
    qcRemarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    reportCopyStatusId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    rddsStatusId?: number | undefined;
    reportDataStatusId?: number | undefined;
    rddsComments?: string | undefined;
    companyId?: number | undefined;
    consignment?: string | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;

    constructor(data?: ICreateGeoscienceAustraliaReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellBoreholeIds = [];
            this.surveyAcquisitionIds = [];
            this.reprocessingProjectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.isConfidential = _data["isConfidential"];
            if (Array.isArray(_data["wellBoreholeIds"])) {
                this.wellBoreholeIds = [] as any;
                for (let item of _data["wellBoreholeIds"])
                    this.wellBoreholeIds!.push(item);
            }
            if (Array.isArray(_data["surveyAcquisitionIds"])) {
                this.surveyAcquisitionIds = [] as any;
                for (let item of _data["surveyAcquisitionIds"])
                    this.surveyAcquisitionIds!.push(item);
            }
            if (Array.isArray(_data["reprocessingProjectIds"])) {
                this.reprocessingProjectIds = [] as any;
                for (let item of _data["reprocessingProjectIds"])
                    this.reprocessingProjectIds!.push(item);
            }
            this.tapeId = _data["tapeId"];
            this.reportTypeId = _data["reportTypeId"];
            this.reportDataFormatId = _data["reportDataFormatId"];
            this.reportMediaTypeId = _data["reportMediaTypeId"];
            this.reportTitle = _data["reportTitle"];
            this.remarks = _data["remarks"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.qcRemarks = _data["qcRemarks"];
            this.reportConditionStatusId = _data["reportConditionStatusId"];
            this.reportLoanStatusId = _data["reportLoanStatusId"];
            this.reportCopyStatusId = _data["reportCopyStatusId"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.rddsStatusId = _data["rddsStatusId"];
            this.reportDataStatusId = _data["reportDataStatusId"];
            this.rddsComments = _data["rddsComments"];
            this.companyId = _data["companyId"];
            this.consignment = _data["consignment"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.writtenDateOffset = _data["writtenDateOffset"];
            this.author = _data["author"];
            this.contractorId = _data["contractorId"];
            this.basicInterpType = _data["basicInterpType"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicRelevantDateOffset = _data["basicRelevantDateOffset"];
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDateOffset = _data["interpRelevantDateOffset"];
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.releasedDateOffset = _data["releasedDateOffset"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["isConfidential"] = this.isConfidential;
        if (Array.isArray(this.wellBoreholeIds)) {
            data["wellBoreholeIds"] = [];
            for (let item of this.wellBoreholeIds)
                data["wellBoreholeIds"].push(item);
        }
        if (Array.isArray(this.surveyAcquisitionIds)) {
            data["surveyAcquisitionIds"] = [];
            for (let item of this.surveyAcquisitionIds)
                data["surveyAcquisitionIds"].push(item);
        }
        if (Array.isArray(this.reprocessingProjectIds)) {
            data["reprocessingProjectIds"] = [];
            for (let item of this.reprocessingProjectIds)
                data["reprocessingProjectIds"].push(item);
        }
        data["tapeId"] = this.tapeId;
        data["reportTypeId"] = this.reportTypeId;
        data["reportDataFormatId"] = this.reportDataFormatId;
        data["reportMediaTypeId"] = this.reportMediaTypeId;
        data["reportTitle"] = this.reportTitle;
        data["remarks"] = this.remarks;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["qcRemarks"] = this.qcRemarks;
        data["reportConditionStatusId"] = this.reportConditionStatusId;
        data["reportLoanStatusId"] = this.reportLoanStatusId;
        data["reportCopyStatusId"] = this.reportCopyStatusId;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["rddsStatusId"] = this.rddsStatusId;
        data["reportDataStatusId"] = this.reportDataStatusId;
        data["rddsComments"] = this.rddsComments;
        data["companyId"] = this.companyId;
        data["consignment"] = this.consignment;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["writtenDateOffset"] = this.writtenDateOffset;
        data["author"] = this.author;
        data["contractorId"] = this.contractorId;
        data["basicInterpType"] = this.basicInterpType;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicRelevantDateOffset"] = this.basicRelevantDateOffset;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDateOffset"] = this.interpRelevantDateOffset;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["releasedDateOffset"] = this.releasedDateOffset;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaReportRequestDto {
    itemId?: string | undefined;
    isConfidential: boolean;
    wellBoreholeIds: number[];
    surveyAcquisitionIds: number[];
    reprocessingProjectIds: number[];
    tapeId?: string | undefined;
    reportTypeId: number;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    reportTitle?: string | undefined;
    remarks?: string | undefined;
    confidentialityRemarks?: string | undefined;
    qcRemarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    reportCopyStatusId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    rddsStatusId?: number | undefined;
    reportDataStatusId?: number | undefined;
    rddsComments?: string | undefined;
    companyId?: number | undefined;
    consignment?: string | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
}

export class CreateGeoscienceAustraliaReportResponseDto implements ICreateGeoscienceAustraliaReportResponseDto {
    reportId?: number | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateGeoscienceAustraliaReportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaReportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaReportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaReportResponseDto {
    reportId?: number | undefined;
    statusMessages: StatusMessagesDto;
}

export class GetCreateGeoscienceAustraliaReportReferenceDataRequestDto implements IGetCreateGeoscienceAustraliaReportReferenceDataRequestDto {
    relatedActivityType?: CreateReportRelatedActivityTypeEnum | undefined;
    relatedActivityId?: number | undefined;

    constructor(data?: IGetCreateGeoscienceAustraliaReportReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedActivityType = _data["relatedActivityType"];
            this.relatedActivityId = _data["relatedActivityId"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaReportReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaReportReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedActivityType"] = this.relatedActivityType;
        data["relatedActivityId"] = this.relatedActivityId;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaReportReferenceDataRequestDto {
    relatedActivityType?: CreateReportRelatedActivityTypeEnum | undefined;
    relatedActivityId?: number | undefined;
}

export class GetCreateGeoscienceAustraliaReportReferenceDataResponseDto implements IGetCreateGeoscienceAustraliaReportReferenceDataResponseDto {
    wellBoreholes!: GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole[];
    surveyAcquisitions!: GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition[];
    reprocessingProjects!: GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject[];
    reportTypes!: GetGeoscienceAustraliaCreateReportReferenceDataReportType[];
    basicInterpTypes!: GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType[];
    contractorCompanies!: GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies[];
    reportDataFormats!: GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat[];
    reportMediaTypes!: GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType[];
    reportConditionStatuses!: GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus[];
    reportCopyStatuses!: GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus[];
    reportLoanStatuses!: GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus[];
    rddsStatuses!: GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus[];
    reportDataStatuses!: GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus[];

    constructor(data?: IGetCreateGeoscienceAustraliaReportReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellBoreholes = [];
            this.surveyAcquisitions = [];
            this.reprocessingProjects = [];
            this.reportTypes = [];
            this.basicInterpTypes = [];
            this.contractorCompanies = [];
            this.reportDataFormats = [];
            this.reportMediaTypes = [];
            this.reportConditionStatuses = [];
            this.reportCopyStatuses = [];
            this.reportLoanStatuses = [];
            this.rddsStatuses = [];
            this.reportDataStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole.fromJS(item));
            }
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition.fromJS(item));
            }
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject.fromJS(item));
            }
            if (Array.isArray(_data["reportTypes"])) {
                this.reportTypes = [] as any;
                for (let item of _data["reportTypes"])
                    this.reportTypes!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportType.fromJS(item));
            }
            if (Array.isArray(_data["basicInterpTypes"])) {
                this.basicInterpTypes = [] as any;
                for (let item of _data["basicInterpTypes"])
                    this.basicInterpTypes!.push(GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType.fromJS(item));
            }
            if (Array.isArray(_data["contractorCompanies"])) {
                this.contractorCompanies = [] as any;
                for (let item of _data["contractorCompanies"])
                    this.contractorCompanies!.push(GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies.fromJS(item));
            }
            if (Array.isArray(_data["reportDataFormats"])) {
                this.reportDataFormats = [] as any;
                for (let item of _data["reportDataFormats"])
                    this.reportDataFormats!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat.fromJS(item));
            }
            if (Array.isArray(_data["reportMediaTypes"])) {
                this.reportMediaTypes = [] as any;
                for (let item of _data["reportMediaTypes"])
                    this.reportMediaTypes!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType.fromJS(item));
            }
            if (Array.isArray(_data["reportConditionStatuses"])) {
                this.reportConditionStatuses = [] as any;
                for (let item of _data["reportConditionStatuses"])
                    this.reportConditionStatuses!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportCopyStatuses"])) {
                this.reportCopyStatuses = [] as any;
                for (let item of _data["reportCopyStatuses"])
                    this.reportCopyStatuses!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportLoanStatuses"])) {
                this.reportLoanStatuses = [] as any;
                for (let item of _data["reportLoanStatuses"])
                    this.reportLoanStatuses!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus.fromJS(item));
            }
            if (Array.isArray(_data["rddsStatuses"])) {
                this.rddsStatuses = [] as any;
                for (let item of _data["rddsStatuses"])
                    this.rddsStatuses!.push(GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportDataStatuses"])) {
                this.reportDataStatuses = [] as any;
                for (let item of _data["reportDataStatuses"])
                    this.reportDataStatuses!.push(GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaReportReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaReportReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.reportTypes)) {
            data["reportTypes"] = [];
            for (let item of this.reportTypes)
                data["reportTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.basicInterpTypes)) {
            data["basicInterpTypes"] = [];
            for (let item of this.basicInterpTypes)
                data["basicInterpTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contractorCompanies)) {
            data["contractorCompanies"] = [];
            for (let item of this.contractorCompanies)
                data["contractorCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.reportDataFormats)) {
            data["reportDataFormats"] = [];
            for (let item of this.reportDataFormats)
                data["reportDataFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.reportMediaTypes)) {
            data["reportMediaTypes"] = [];
            for (let item of this.reportMediaTypes)
                data["reportMediaTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.reportConditionStatuses)) {
            data["reportConditionStatuses"] = [];
            for (let item of this.reportConditionStatuses)
                data["reportConditionStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportCopyStatuses)) {
            data["reportCopyStatuses"] = [];
            for (let item of this.reportCopyStatuses)
                data["reportCopyStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportLoanStatuses)) {
            data["reportLoanStatuses"] = [];
            for (let item of this.reportLoanStatuses)
                data["reportLoanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.rddsStatuses)) {
            data["rddsStatuses"] = [];
            for (let item of this.rddsStatuses)
                data["rddsStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportDataStatuses)) {
            data["reportDataStatuses"] = [];
            for (let item of this.reportDataStatuses)
                data["reportDataStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaReportReferenceDataResponseDto {
    wellBoreholes: GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole[];
    surveyAcquisitions: GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition[];
    reprocessingProjects: GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject[];
    reportTypes: GetGeoscienceAustraliaCreateReportReferenceDataReportType[];
    basicInterpTypes: GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType[];
    contractorCompanies: GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies[];
    reportDataFormats: GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat[];
    reportMediaTypes: GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType[];
    reportConditionStatuses: GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus[];
    reportCopyStatuses: GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus[];
    reportLoanStatuses: GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus[];
    rddsStatuses: GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus[];
    reportDataStatuses: GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus[];
}

export class GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType implements IGetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType {
    id!: number;
    name!: string;
    value!: BasicInterpTypeEnum;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataBasicInterpType {
    id: number;
    name: string;
    value: BasicInterpTypeEnum;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies implements IGetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataContractorCompanies {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus implements IGetGeoscienceAustraliaCreateReportReferenceDataRddsStatus {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataRddsStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataRddsStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataRddsStatus {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus implements IGetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportConditionStatus {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus implements IGetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportCopyStatus {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat implements IGetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportDataFormat {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus implements IGetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportDataStatus {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus implements IGetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportLoanStatus {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType implements IGetGeoscienceAustraliaCreateReportReferenceDataReportMediaType {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportMediaType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportMediaType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportMediaType {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReportType implements IGetGeoscienceAustraliaCreateReportReferenceDataReportType {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReportType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReportType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReportType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReportType {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject implements IGetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataReprocessingProject {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition implements IGetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataSurveyAcquisition {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole implements IGetGeoscienceAustraliaCreateReportReferenceDataWellBorehole {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaCreateReportReferenceDataWellBorehole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaCreateReportReferenceDataWellBorehole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaCreateReportReferenceDataWellBorehole {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus implements IGetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto implements IGetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportFileAssetsReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto implements IGetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto {
    reportDataFormats!: GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat[];
    reportMediaTypes!: GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType[];
    reportConditionStatuses!: GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus[];
    reportCopyStatuses!: GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus[];
    reportLoanStatuses!: GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus[];
    rddsStatuses!: GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus[];
    reportDataStatuses!: GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus[];

    constructor(data?: IGetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportDataFormats = [];
            this.reportMediaTypes = [];
            this.reportConditionStatuses = [];
            this.reportCopyStatuses = [];
            this.reportLoanStatuses = [];
            this.rddsStatuses = [];
            this.reportDataStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportDataFormats"])) {
                this.reportDataFormats = [] as any;
                for (let item of _data["reportDataFormats"])
                    this.reportDataFormats!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat.fromJS(item));
            }
            if (Array.isArray(_data["reportMediaTypes"])) {
                this.reportMediaTypes = [] as any;
                for (let item of _data["reportMediaTypes"])
                    this.reportMediaTypes!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType.fromJS(item));
            }
            if (Array.isArray(_data["reportConditionStatuses"])) {
                this.reportConditionStatuses = [] as any;
                for (let item of _data["reportConditionStatuses"])
                    this.reportConditionStatuses!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportCopyStatuses"])) {
                this.reportCopyStatuses = [] as any;
                for (let item of _data["reportCopyStatuses"])
                    this.reportCopyStatuses!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportLoanStatuses"])) {
                this.reportLoanStatuses = [] as any;
                for (let item of _data["reportLoanStatuses"])
                    this.reportLoanStatuses!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus.fromJS(item));
            }
            if (Array.isArray(_data["rddsStatuses"])) {
                this.rddsStatuses = [] as any;
                for (let item of _data["rddsStatuses"])
                    this.rddsStatuses!.push(GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus.fromJS(item));
            }
            if (Array.isArray(_data["reportDataStatuses"])) {
                this.reportDataStatuses = [] as any;
                for (let item of _data["reportDataStatuses"])
                    this.reportDataStatuses!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportDataFormats)) {
            data["reportDataFormats"] = [];
            for (let item of this.reportDataFormats)
                data["reportDataFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.reportMediaTypes)) {
            data["reportMediaTypes"] = [];
            for (let item of this.reportMediaTypes)
                data["reportMediaTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.reportConditionStatuses)) {
            data["reportConditionStatuses"] = [];
            for (let item of this.reportConditionStatuses)
                data["reportConditionStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportCopyStatuses)) {
            data["reportCopyStatuses"] = [];
            for (let item of this.reportCopyStatuses)
                data["reportCopyStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportLoanStatuses)) {
            data["reportLoanStatuses"] = [];
            for (let item of this.reportLoanStatuses)
                data["reportLoanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.rddsStatuses)) {
            data["rddsStatuses"] = [];
            for (let item of this.rddsStatuses)
                data["rddsStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.reportDataStatuses)) {
            data["reportDataStatuses"] = [];
            for (let item of this.reportDataStatuses)
                data["reportDataStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportFileAssetsReferenceDataResponseDto {
    reportDataFormats: GetGeoscienceAustraliaReportDetailsReferenceDataReportDataFormat[];
    reportMediaTypes: GetGeoscienceAustraliaReportDetailsReferenceDataReportMediaType[];
    reportConditionStatuses: GetGeoscienceAustraliaReportDetailsReferenceDataReportConditionStatus[];
    reportCopyStatuses: GetGeoscienceAustraliaReportDetailsReferenceDataReportCopyStatus[];
    reportLoanStatuses: GetGeoscienceAustraliaReportDetailsReferenceDataReportLoanStatus[];
    rddsStatuses: GetGeoscienceAustraliaReportDetailsReferenceDataRddsStatus[];
    reportDataStatuses: GetGeoscienceAustraliaReportDetailsReferenceDataReportDataStatus[];
}

export class GetGeoscienceAustraliaReportFileAssetsRequestDto implements IGetGeoscienceAustraliaReportFileAssetsRequestDto {
    reportId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportFileAssetsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportFileAssetsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportFileAssetsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportFileAssetsRequestDto {
    reportId: number;
}

export class GetGeoscienceAustraliaReportFileAssetsResponseDto implements IGetGeoscienceAustraliaReportFileAssetsResponseDto {
    reportId!: number;
    reportVersionNumber!: number;
    reportHeader?: string | undefined;
    isPublic!: boolean;
    tapeId?: string | undefined;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    reportCopyStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    rddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    reportDataStatusId?: number | undefined;
    consignment?: string | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportFileAssetsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.reportHeader = _data["reportHeader"];
            this.isPublic = _data["isPublic"];
            this.tapeId = _data["tapeId"];
            this.reportDataFormatId = _data["reportDataFormatId"];
            this.reportMediaTypeId = _data["reportMediaTypeId"];
            this.remarks = _data["remarks"];
            this.reportConditionStatusId = _data["reportConditionStatusId"];
            this.qcRemarks = _data["qcRemarks"];
            this.reportCopyStatusId = _data["reportCopyStatusId"];
            this.reportLoanStatusId = _data["reportLoanStatusId"];
            this.rddsStatusId = _data["rddsStatusId"];
            this.rddsComments = _data["rddsComments"];
            this.reportDataStatusId = _data["reportDataStatusId"];
            this.consignment = _data["consignment"];
            this.auditDto = _data["auditDto"] ? SimpleAuditEventsDto.fromJS(_data["auditDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportFileAssetsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportFileAssetsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["reportHeader"] = this.reportHeader;
        data["isPublic"] = this.isPublic;
        data["tapeId"] = this.tapeId;
        data["reportDataFormatId"] = this.reportDataFormatId;
        data["reportMediaTypeId"] = this.reportMediaTypeId;
        data["remarks"] = this.remarks;
        data["reportConditionStatusId"] = this.reportConditionStatusId;
        data["qcRemarks"] = this.qcRemarks;
        data["reportCopyStatusId"] = this.reportCopyStatusId;
        data["reportLoanStatusId"] = this.reportLoanStatusId;
        data["rddsStatusId"] = this.rddsStatusId;
        data["rddsComments"] = this.rddsComments;
        data["reportDataStatusId"] = this.reportDataStatusId;
        data["consignment"] = this.consignment;
        data["auditDto"] = this.auditDto ? this.auditDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportFileAssetsResponseDto {
    reportId: number;
    reportVersionNumber: number;
    reportHeader?: string | undefined;
    isPublic: boolean;
    tapeId?: string | undefined;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    reportCopyStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    rddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    reportDataStatusId?: number | undefined;
    consignment?: string | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;
}

export class UpdateGeoscienceAustraliaReportFileAssetsRequestDto implements IUpdateGeoscienceAustraliaReportFileAssetsRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    tapeId?: string | undefined;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    reportCopyStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    rddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    reportDataStatusId?: number | undefined;
    consignment?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportFileAssetsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.tapeId = _data["tapeId"];
            this.reportDataFormatId = _data["reportDataFormatId"];
            this.reportMediaTypeId = _data["reportMediaTypeId"];
            this.remarks = _data["remarks"];
            this.reportConditionStatusId = _data["reportConditionStatusId"];
            this.qcRemarks = _data["qcRemarks"];
            this.reportCopyStatusId = _data["reportCopyStatusId"];
            this.reportLoanStatusId = _data["reportLoanStatusId"];
            this.rddsStatusId = _data["rddsStatusId"];
            this.rddsComments = _data["rddsComments"];
            this.reportDataStatusId = _data["reportDataStatusId"];
            this.consignment = _data["consignment"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportFileAssetsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportFileAssetsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["tapeId"] = this.tapeId;
        data["reportDataFormatId"] = this.reportDataFormatId;
        data["reportMediaTypeId"] = this.reportMediaTypeId;
        data["remarks"] = this.remarks;
        data["reportConditionStatusId"] = this.reportConditionStatusId;
        data["qcRemarks"] = this.qcRemarks;
        data["reportCopyStatusId"] = this.reportCopyStatusId;
        data["reportLoanStatusId"] = this.reportLoanStatusId;
        data["rddsStatusId"] = this.rddsStatusId;
        data["rddsComments"] = this.rddsComments;
        data["reportDataStatusId"] = this.reportDataStatusId;
        data["consignment"] = this.consignment;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportFileAssetsRequestDto {
    reportId: number;
    reportVersionNumber: number;
    tapeId?: string | undefined;
    reportDataFormatId?: number | undefined;
    reportMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    reportConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    reportCopyStatusId?: number | undefined;
    reportLoanStatusId?: number | undefined;
    rddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    reportDataStatusId?: number | undefined;
    consignment?: string | undefined;
}

export class UpdateGeoscienceAustraliaReportFileAssetsResponseDto implements IUpdateGeoscienceAustraliaReportFileAssetsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaReportFileAssetsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportFileAssetsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportFileAssetsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportFileAssetsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class UpdateGeoscienceAustraliaReportsReportDto implements IUpdateGeoscienceAustraliaReportsReportDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: IUpdateGeoscienceAustraliaReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportsReportDto {
    id: number;
    versionNumber: number;
}

export class UpdateGeoscienceAustraliaReportsRequestDto implements IUpdateGeoscienceAustraliaReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class AddGeoscienceAustraliaReportRelatedActivitiesRequestDto implements IAddGeoscienceAustraliaReportRelatedActivitiesRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    reportRelatedActivityType!: ReportRelatedActivityTypeEnum;
    activityIds?: number[] | undefined;
    comments?: string | undefined;

    constructor(data?: IAddGeoscienceAustraliaReportRelatedActivitiesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.reportRelatedActivityType = _data["reportRelatedActivityType"];
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AddGeoscienceAustraliaReportRelatedActivitiesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddGeoscienceAustraliaReportRelatedActivitiesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["reportRelatedActivityType"] = this.reportRelatedActivityType;
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAddGeoscienceAustraliaReportRelatedActivitiesRequestDto {
    reportId: number;
    reportVersionNumber: number;
    reportRelatedActivityType: ReportRelatedActivityTypeEnum;
    activityIds?: number[] | undefined;
    comments?: string | undefined;
}

export class AddGeoscienceAustraliaReportRelatedActivitiesResponseDto implements IAddGeoscienceAustraliaReportRelatedActivitiesResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IAddGeoscienceAustraliaReportRelatedActivitiesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddGeoscienceAustraliaReportRelatedActivitiesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddGeoscienceAustraliaReportRelatedActivitiesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddGeoscienceAustraliaReportRelatedActivitiesResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class DeleteGeoscienceAustraliaReportRelatedActivityRequestDto implements IDeleteGeoscienceAustraliaReportRelatedActivityRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    activityId!: number;
    reportRelatedActivityType!: ReportRelatedActivityTypeEnum;

    constructor(data?: IDeleteGeoscienceAustraliaReportRelatedActivityRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.activityId = _data["activityId"];
            this.reportRelatedActivityType = _data["reportRelatedActivityType"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportRelatedActivityRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportRelatedActivityRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["activityId"] = this.activityId;
        data["reportRelatedActivityType"] = this.reportRelatedActivityType;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportRelatedActivityRequestDto {
    reportId: number;
    reportVersionNumber: number;
    activityId: number;
    reportRelatedActivityType: ReportRelatedActivityTypeEnum;
}

export class DeleteGeoscienceAustraliaReportRelatedActivityResponseDto implements IDeleteGeoscienceAustraliaReportRelatedActivityResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IDeleteGeoscienceAustraliaReportRelatedActivityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportRelatedActivityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportRelatedActivityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportRelatedActivityResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class GetGeoscienceAustraliaReportRelatedActivitiesRequestDto implements IGetGeoscienceAustraliaReportRelatedActivitiesRequestDto {
    reportId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivitiesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivitiesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivitiesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivitiesRequestDto {
    reportId: number;
}

export class GetGeoscienceAustraliaReportRelatedActivitiesResponseDto implements IGetGeoscienceAustraliaReportRelatedActivitiesResponseDto {
    reportId!: number;
    reportVersionNumber!: number;
    publicTitle?: string | undefined;
    reportHeader?: string | undefined;
    isPublic!: boolean;
    relatedActivities!: GetGeoscienceAustraliaReportRelatedActivityDto[];
    relatedActivityReferenceData!: GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto[];

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivitiesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedActivities = [];
            this.relatedActivityReferenceData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.publicTitle = _data["publicTitle"];
            this.reportHeader = _data["reportHeader"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["relatedActivities"])) {
                this.relatedActivities = [] as any;
                for (let item of _data["relatedActivities"])
                    this.relatedActivities!.push(GetGeoscienceAustraliaReportRelatedActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedActivityReferenceData"])) {
                this.relatedActivityReferenceData = [] as any;
                for (let item of _data["relatedActivityReferenceData"])
                    this.relatedActivityReferenceData!.push(GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivitiesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivitiesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["publicTitle"] = this.publicTitle;
        data["reportHeader"] = this.reportHeader;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.relatedActivities)) {
            data["relatedActivities"] = [];
            for (let item of this.relatedActivities)
                data["relatedActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedActivityReferenceData)) {
            data["relatedActivityReferenceData"] = [];
            for (let item of this.relatedActivityReferenceData)
                data["relatedActivityReferenceData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivitiesResponseDto {
    reportId: number;
    reportVersionNumber: number;
    publicTitle?: string | undefined;
    reportHeader?: string | undefined;
    isPublic: boolean;
    relatedActivities: GetGeoscienceAustraliaReportRelatedActivityDto[];
    relatedActivityReferenceData: GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto[];
}

export class GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto implements IGetGeoscienceAustraliaReportRelatedActivityAcquisitionDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivityAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivityAcquisitionDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaReportRelatedActivityBoreholeDto implements IGetGeoscienceAustraliaReportRelatedActivityBoreholeDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivityBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivityBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivityBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivityBoreholeDto {
    wellId: number;
}

export class GetGeoscienceAustraliaReportRelatedActivityDto implements IGetGeoscienceAustraliaReportRelatedActivityDto {
    id!: number;
    reportRelatedActivityType!: ReportRelatedActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaReportRelatedActivityBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaReportRelatedActivityProjectDto | undefined;
    activityId?: string | undefined;
    activityName?: string | undefined;
    isPublic!: boolean;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportRelatedActivityType = _data["reportRelatedActivityType"];
            this.boreholeDetails = _data["boreholeDetails"] ? GetGeoscienceAustraliaReportRelatedActivityBoreholeDto.fromJS(_data["boreholeDetails"]) : <any>undefined;
            this.acquisitionDetails = _data["acquisitionDetails"] ? GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto.fromJS(_data["acquisitionDetails"]) : <any>undefined;
            this.projectDetails = _data["projectDetails"] ? GetGeoscienceAustraliaReportRelatedActivityProjectDto.fromJS(_data["projectDetails"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.isPublic = _data["isPublic"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportRelatedActivityType"] = this.reportRelatedActivityType;
        data["boreholeDetails"] = this.boreholeDetails ? this.boreholeDetails.toJSON() : <any>undefined;
        data["acquisitionDetails"] = this.acquisitionDetails ? this.acquisitionDetails.toJSON() : <any>undefined;
        data["projectDetails"] = this.projectDetails ? this.projectDetails.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["isPublic"] = this.isPublic;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivityDto {
    id: number;
    reportRelatedActivityType: ReportRelatedActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaReportRelatedActivityBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaReportRelatedActivityAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaReportRelatedActivityProjectDto | undefined;
    activityId?: string | undefined;
    activityName?: string | undefined;
    isPublic: boolean;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReportRelatedActivityProjectDto implements IGetGeoscienceAustraliaReportRelatedActivityProjectDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivityProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivityProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivityProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivityProjectDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto implements IGetGeoscienceAustraliaReportRelatedActivityReferenceDataDto {
    elementId!: number;
    reportRelatedActivityType!: ReportRelatedActivityTypeEnum;
    activityId?: string | undefined;
    isPublic!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReportRelatedActivityReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.reportRelatedActivityType = _data["reportRelatedActivityType"];
            this.activityId = _data["activityId"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportRelatedActivityReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["reportRelatedActivityType"] = this.reportRelatedActivityType;
        data["activityId"] = this.activityId;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportRelatedActivityReferenceDataDto {
    elementId: number;
    reportRelatedActivityType: ReportRelatedActivityTypeEnum;
    activityId?: string | undefined;
    isPublic: boolean;
}

export class UpdateGeoscienceAustraliaReportsResponseDto implements IUpdateGeoscienceAustraliaReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetGeoscienceAustraliaReportDataAuditChangesRequestDto implements IGetGeoscienceAustraliaReportDataAuditChangesRequestDto {
    reportId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDataAuditChangesRequestDto {
    reportId: number;
}

export class GetGeoscienceAustraliaReportDataAuditChangesResponseDto implements IGetGeoscienceAustraliaReportDataAuditChangesResponseDto {
    reportHeader!: string;
    isPublic!: boolean;
    reportDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaReportDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportHeader = _data["reportHeader"];
            this.isPublic = _data["isPublic"];
            this.reportDataAuditChanges = _data["reportDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["reportDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportHeader"] = this.reportHeader;
        data["isPublic"] = this.isPublic;
        data["reportDataAuditChanges"] = this.reportDataAuditChanges ? this.reportDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDataAuditChangesResponseDto {
    reportHeader: string;
    isPublic: boolean;
    reportDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class DeleteGeoscienceAustraliaReportRequestDto implements IDeleteGeoscienceAustraliaReportRequestDto {
    reportId!: number;
    reportVersionNumber!: number;

    constructor(data?: IDeleteGeoscienceAustraliaReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportRequestDto {
    reportId: number;
    reportVersionNumber: number;
}

export class DeleteGeoscienceAustraliaReportResponseDto implements IDeleteGeoscienceAustraliaReportResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaReportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaReportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaReportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaReportResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes implements IGetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes {
    id!: number;
    name!: string;
    value!: BasicInterpTypeEnum;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes {
    id: number;
    name: string;
    value: BasicInterpTypeEnum;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies implements IGetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataReportType implements IGetGeoscienceAustraliaReportDetailsReferenceDataReportType {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataReportType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataReportType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataReportType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataReportType {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataRequestDto implements IGetGeoscienceAustraliaReportDetailsReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto implements IGetGeoscienceAustraliaReportDetailsReferenceDataResponseDto {
    reportTypes!: GetGeoscienceAustraliaReportDetailsReferenceDataReportType[];
    basicInterpTypes!: GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes[];
    contractorCompanies!: GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies[];

    constructor(data?: IGetGeoscienceAustraliaReportDetailsReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportTypes = [];
            this.basicInterpTypes = [];
            this.contractorCompanies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportTypes"])) {
                this.reportTypes = [] as any;
                for (let item of _data["reportTypes"])
                    this.reportTypes!.push(GetGeoscienceAustraliaReportDetailsReferenceDataReportType.fromJS(item));
            }
            if (Array.isArray(_data["basicInterpTypes"])) {
                this.basicInterpTypes = [] as any;
                for (let item of _data["basicInterpTypes"])
                    this.basicInterpTypes!.push(GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes.fromJS(item));
            }
            if (Array.isArray(_data["contractorCompanies"])) {
                this.contractorCompanies = [] as any;
                for (let item of _data["contractorCompanies"])
                    this.contractorCompanies!.push(GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportTypes)) {
            data["reportTypes"] = [];
            for (let item of this.reportTypes)
                data["reportTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.basicInterpTypes)) {
            data["basicInterpTypes"] = [];
            for (let item of this.basicInterpTypes)
                data["basicInterpTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contractorCompanies)) {
            data["contractorCompanies"] = [];
            for (let item of this.contractorCompanies)
                data["contractorCompanies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsReferenceDataResponseDto {
    reportTypes: GetGeoscienceAustraliaReportDetailsReferenceDataReportType[];
    basicInterpTypes: GetGeoscienceAustraliaReportDetailsReferenceDataBasicInterpTypes[];
    contractorCompanies: GetGeoscienceAustraliaReportDetailsReferenceDataContractorCompanies[];
}

export class GetGeoscienceAustraliaReportDetailsRequestDto implements IGetGeoscienceAustraliaReportDetailsRequestDto {
    reportId!: number;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsRequestDto {
    reportId: number;
}

export class GetGeoscienceAustraliaReportDetailsResponseDto implements IGetGeoscienceAustraliaReportDetailsResponseDto {
    reportId!: number;
    reportVersionNumber!: number;
    reportHeader?: string | undefined;
    itemId?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    reportTypeId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    reportTitle?: string | undefined;
    writtenDate?: Date | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: boolean | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    interpRelevantDate?: Date | undefined;
    releasedDate?: Date | undefined;
    companyId?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.reportHeader = _data["reportHeader"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportTypeId = _data["reportTypeId"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.reportTitle = _data["reportTitle"];
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.basicInterpType = _data["basicInterpType"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.author = _data["author"];
            this.contractorId = _data["contractorId"];
            this.auditDto = _data["auditDto"] ? SimpleAuditEventsDto.fromJS(_data["auditDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["reportHeader"] = this.reportHeader;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportTypeId"] = this.reportTypeId;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["reportTitle"] = this.reportTitle;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["basicInterpType"] = this.basicInterpType;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["author"] = this.author;
        data["contractorId"] = this.contractorId;
        data["auditDto"] = this.auditDto ? this.auditDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportDetailsResponseDto {
    reportId: number;
    reportVersionNumber: number;
    reportHeader?: string | undefined;
    itemId?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    reportTypeId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    reportTitle?: string | undefined;
    writtenDate?: Date | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: boolean | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    interpRelevantDate?: Date | undefined;
    releasedDate?: Date | undefined;
    companyId?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;
}

export class UpdateGeoscienceAustraliaReportDetailsRequestDto implements IUpdateGeoscienceAustraliaReportDetailsRequestDto {
    reportId!: number;
    reportVersionNumber!: number;
    itemId?: string | undefined;
    reportTypeId!: number;
    isCopiedToNopims?: boolean | undefined;
    comments?: string | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    isConfidential!: boolean;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
    companyId?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReportDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportVersionNumber = _data["reportVersionNumber"];
            this.itemId = _data["itemId"];
            this.reportTypeId = _data["reportTypeId"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.comments = _data["comments"];
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.writtenDateOffset = _data["writtenDateOffset"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.basicInterpType = _data["basicInterpType"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicRelevantDateOffset = _data["basicRelevantDateOffset"];
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDateOffset = _data["interpRelevantDateOffset"];
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.releasedDateOffset = _data["releasedDateOffset"];
            this.companyId = _data["companyId"];
            this.author = _data["author"];
            this.contractorId = _data["contractorId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportVersionNumber"] = this.reportVersionNumber;
        data["itemId"] = this.itemId;
        data["reportTypeId"] = this.reportTypeId;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["comments"] = this.comments;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["writtenDateOffset"] = this.writtenDateOffset;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["basicInterpType"] = this.basicInterpType;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicRelevantDateOffset"] = this.basicRelevantDateOffset;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDateOffset"] = this.interpRelevantDateOffset;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["releasedDateOffset"] = this.releasedDateOffset;
        data["companyId"] = this.companyId;
        data["author"] = this.author;
        data["contractorId"] = this.contractorId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportDetailsRequestDto {
    reportId: number;
    reportVersionNumber: number;
    itemId?: string | undefined;
    reportTypeId: number;
    isCopiedToNopims?: boolean | undefined;
    comments?: string | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    isConfidential: boolean;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
    companyId?: number | undefined;
    author?: string | undefined;
    contractorId?: number | undefined;
}

export class UpdateGeoscienceAustraliaReportDetailsResponseDto implements IUpdateGeoscienceAustraliaReportDetailsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaReportDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReportDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReportDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReportDetailsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ExportGeoscienceAustraliaReportsRequestDto implements IExportGeoscienceAustraliaReportsRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IExportGeoscienceAustraliaReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportGeoscienceAustraliaReportsRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class ExportGeoscienceAustraliaReportsResponseDto implements IExportGeoscienceAustraliaReportsResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;

    constructor(data?: IExportGeoscienceAustraliaReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        return data;
    }
}

export interface IExportGeoscienceAustraliaReportsResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
}

export class GetGeoscienceAustraliaReportListItemDto implements IGetGeoscienceAustraliaReportListItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    numberOfMappings!: number;
    numberOfAttachments!: number;
    consignment!: string;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;
    relatedActivities?: GetGeoscienceAustraliaReportListRelatedActivityDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.numberOfMappings = _data["numberOfMappings"];
            this.numberOfAttachments = _data["numberOfAttachments"];
            this.consignment = _data["consignment"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["relatedActivities"])) {
                this.relatedActivities = [] as any;
                for (let item of _data["relatedActivities"])
                    this.relatedActivities!.push(GetGeoscienceAustraliaReportListRelatedActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["numberOfMappings"] = this.numberOfMappings;
        data["numberOfAttachments"] = this.numberOfAttachments;
        data["consignment"] = this.consignment;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        if (Array.isArray(this.relatedActivities)) {
            data["relatedActivities"] = [];
            for (let item of this.relatedActivities)
                data["relatedActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    numberOfMappings: number;
    numberOfAttachments: number;
    consignment: string;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
    relatedActivities?: GetGeoscienceAustraliaReportListRelatedActivityDto[] | undefined;
}

export class GetGeoscienceAustraliaReportListPermissionDto implements IGetGeoscienceAustraliaReportListPermissionDto {
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewProjects!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReportListPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewProjects = _data["canViewProjects"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewProjects"] = this.canViewProjects;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListPermissionDto {
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewProjects: boolean;
}

export class GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto implements IGetGeoscienceAustraliaReportListReferenceDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReportListReferenceDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListReferenceDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto implements IGetGeoscienceAustraliaReportListReferenceDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReportListReferenceDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListReferenceDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReportListReferenceDataRequestDto implements IGetGeoscienceAustraliaReportListReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaReportListReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaReportListReferenceDataResponseDto implements IGetGeoscienceAustraliaReportListReferenceDataResponseDto {
    wellBoreholes!: AdvancedSearchReferenceDataWellBoreholeDto[];
    acquisitions!: AdvancedSearchReferenceDataAcquisitionDto[];
    projects!: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos!: AdvancedSearchReferenceDataEnoDto[];
    advancedSearchTypes!: AdvancedSearchTypeDto[];
    advancedSearchOperations!: AdvancedSearchOperationDto[];
    loanStatuses!: GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaReportListReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellBoreholes = [];
            this.acquisitions = [];
            this.projects = [];
            this.enos = [];
            this.advancedSearchTypes = [];
            this.advancedSearchOperations = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(AdvancedSearchReferenceDataWellBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(AdvancedSearchReferenceDataAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(AdvancedSearchReferenceDataReprocessingProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["enos"])) {
                this.enos = [] as any;
                for (let item of _data["enos"])
                    this.enos!.push(AdvancedSearchReferenceDataEnoDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchTypes"])) {
                this.advancedSearchTypes = [] as any;
                for (let item of _data["advancedSearchTypes"])
                    this.advancedSearchTypes!.push(AdvancedSearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchOperations"])) {
                this.advancedSearchOperations = [] as any;
                for (let item of _data["advancedSearchOperations"])
                    this.advancedSearchOperations!.push(AdvancedSearchOperationDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.enos)) {
            data["enos"] = [];
            for (let item of this.enos)
                data["enos"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchTypes)) {
            data["advancedSearchTypes"] = [];
            for (let item of this.advancedSearchTypes)
                data["advancedSearchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchOperations)) {
            data["advancedSearchOperations"] = [];
            for (let item of this.advancedSearchOperations)
                data["advancedSearchOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListReferenceDataResponseDto {
    wellBoreholes: AdvancedSearchReferenceDataWellBoreholeDto[];
    acquisitions: AdvancedSearchReferenceDataAcquisitionDto[];
    projects: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos: AdvancedSearchReferenceDataEnoDto[];
    advancedSearchTypes: AdvancedSearchTypeDto[];
    advancedSearchOperations: AdvancedSearchOperationDto[];
    loanStatuses: GetGeoscienceAustraliaReportListReferenceDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaReportListReferenceDataConditionStatusDto[];
}

export class GetGeoscienceAustraliaReportListRelatedActivityDto implements IGetGeoscienceAustraliaReportListRelatedActivityDto {
    type!: RelatedActivityEnum;
    relatedActivityParentId!: number;
    relatedActivityId!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    selectedInAdvancedSearch!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReportListRelatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.relatedActivityParentId = _data["relatedActivityParentId"];
            this.relatedActivityId = _data["relatedActivityId"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.selectedInAdvancedSearch = _data["selectedInAdvancedSearch"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListRelatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListRelatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["relatedActivityParentId"] = this.relatedActivityParentId;
        data["relatedActivityId"] = this.relatedActivityId;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["selectedInAdvancedSearch"] = this.selectedInAdvancedSearch;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListRelatedActivityDto {
    type: RelatedActivityEnum;
    relatedActivityParentId: number;
    relatedActivityId: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    selectedInAdvancedSearch: boolean;
}

export class GetGeoscienceAustraliaReportListRequestDto implements IGetGeoscienceAustraliaReportListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaReportListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class GetGeoscienceAustraliaReportListResponseDto implements IGetGeoscienceAustraliaReportListResponseDto {
    items!: GetGeoscienceAustraliaReportListItemDto[];
    permissions!: GetGeoscienceAustraliaReportListPermissionDto;
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReportListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.permissions = new GetGeoscienceAustraliaReportListPermissionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReportListItemDto.fromJS(item));
            }
            this.permissions = _data["permissions"] ? GetGeoscienceAustraliaReportListPermissionDto.fromJS(_data["permissions"]) : new GetGeoscienceAustraliaReportListPermissionDto();
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReportListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReportListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReportListResponseDto {
    items: GetGeoscienceAustraliaReportListItemDto[];
    permissions: GetGeoscienceAustraliaReportListPermissionDto;
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId!: number;
    name!: string;
    identifier!: string;
    reprocessingDetails!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto;
    duplicateDataMonitoringItems!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto | undefined;
    authorisations!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto[];
    status!: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewReprocessings!: boolean;
    canViewProjects!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessingDetails = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto();
            this.duplicateDataMonitoringItems = [];
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.reprocessingDetails = _data["reprocessingDetails"] ? GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto.fromJS(_data["reprocessingDetails"]) : new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto();
            if (Array.isArray(_data["duplicateDataMonitoringItems"])) {
                this.duplicateDataMonitoringItems = [] as any;
                for (let item of _data["duplicateDataMonitoringItems"])
                    this.duplicateDataMonitoringItems!.push(GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto.fromJS(item));
            }
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto.fromJS(item));
            }
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.extensionDueDate = _data["extensionDueDate"] ? new Date(_data["extensionDueDate"].toString()) : <any>undefined;
            this.resubmissionDueDate = _data["resubmissionDueDate"] ? new Date(_data["resubmissionDueDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.canViewReprocessings = _data["canViewReprocessings"];
            this.canViewProjects = _data["canViewProjects"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["reprocessingDetails"] = this.reprocessingDetails ? this.reprocessingDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.duplicateDataMonitoringItems)) {
            data["duplicateDataMonitoringItems"] = [];
            for (let item of this.duplicateDataMonitoringItems)
                data["duplicateDataMonitoringItems"].push(item.toJSON());
        }
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["extensionDueDate"] = this.extensionDueDate ? this.extensionDueDate.toISOString() : <any>undefined;
        data["resubmissionDueDate"] = this.resubmissionDueDate ? this.resubmissionDueDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["canViewReprocessings"] = this.canViewReprocessings;
        data["canViewProjects"] = this.canViewProjects;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId: number;
    name: string;
    identifier: string;
    reprocessingDetails: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto;
    duplicateDataMonitoringItems: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDataSubmissionDto | undefined;
    authorisations: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto[];
    status: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewReprocessings: boolean;
    canViewProjects: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
    id!: number;
    identifier!: string;
    isInvalid!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.isInvalid = _data["isInvalid"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
    id: number;
    identifier: string;
    isInvalid: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto {
    reprocessing!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto;
    project!: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto;
    projectCalcDueDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessing = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto();
            this.project = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessing = _data["reprocessing"] ? GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto.fromJS(_data["reprocessing"]) : new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto();
            this.project = _data["project"] ? GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto.fromJS(_data["project"]) : new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto();
            this.projectCalcDueDate = _data["projectCalcDueDate"] ? new Date(_data["projectCalcDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessing"] = this.reprocessing ? this.reprocessing.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["projectCalcDueDate"] = this.projectCalcDueDate ? this.projectCalcDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReprocessingDto {
    reprocessing: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto;
    project: GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseReferenceDto;
    projectCalcDueDate?: Date | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsDataMonitoringItemDetailsResponseResubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto {
    reprocessingId!: number;
    projectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsRequestDto {
    reprocessingId: number;
    projectId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto {
    reprocessingId!: number;
    projectId!: number;
    reprocessingName!: string;
    projectName!: string;
    isPublic!: boolean;
    items!: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto[];
    canViewReprocessings!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
            this.reprocessingName = _data["reprocessingName"];
            this.projectName = _data["projectName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto.fromJS(item));
            }
            this.canViewReprocessings = _data["canViewReprocessings"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        data["reprocessingName"] = this.reprocessingName;
        data["projectName"] = this.projectName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewReprocessings"] = this.canViewReprocessings;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDto {
    reprocessingId: number;
    projectId: number;
    reprocessingName: string;
    projectName: string;
    isPublic: boolean;
    items: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto[];
    canViewReprocessings: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status!: string;
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status: string;
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectDataMonitoringItemsResponseResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto {
    projectId!: number;
    projectIdentifier?: string | undefined;
    surveyId!: number;
    surveyIdentifier?: string | undefined;
    acquisitionId!: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic!: boolean;
    acquisitionEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    exclusivity?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectIdentifier = _data["projectIdentifier"];
            this.surveyId = _data["surveyId"];
            this.surveyIdentifier = _data["surveyIdentifier"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionIdentifier = _data["acquisitionIdentifier"];
            this.acquisitionName = _data["acquisitionName"];
            this.isPublic = _data["isPublic"];
            this.acquisitionEndDate = _data["acquisitionEndDate"] ? new Date(_data["acquisitionEndDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.exclusivity = _data["exclusivity"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectIdentifier"] = this.projectIdentifier;
        data["surveyId"] = this.surveyId;
        data["surveyIdentifier"] = this.surveyIdentifier;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionIdentifier"] = this.acquisitionIdentifier;
        data["acquisitionName"] = this.acquisitionName;
        data["isPublic"] = this.isPublic;
        data["acquisitionEndDate"] = this.acquisitionEndDate ? this.acquisitionEndDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["exclusivity"] = this.exclusivity;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto {
    projectId: number;
    projectIdentifier?: string | undefined;
    surveyId: number;
    surveyIdentifier?: string | undefined;
    acquisitionId: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic: boolean;
    acquisitionEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    exclusivity?: string | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto {
    id!: number;
    name?: string | undefined;
    isPublic!: boolean;
    acquisitions!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseDto {
    id: number;
    name?: string | undefined;
    isPublic: boolean;
    acquisitions: GetGeoscienceAustraliaReprocessingsProjectsReprocessingAcquisitionsResponseAcquisitionDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesRequestDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto {
    reprocessingName!: string;
    isPublic!: boolean;
    reprocessingDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessingDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            this.reprocessingDataAuditChanges = _data["reprocessingDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["reprocessingDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        data["reprocessingDataAuditChanges"] = this.reprocessingDataAuditChanges ? this.reprocessingDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataAuditChangesResponseDto {
    reprocessingName: string;
    isPublic: boolean;
    reprocessingDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsRequestDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto {
    reprocessingId!: number;
    reprocessingName!: string;
    isPublic!: boolean;
    projects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto[];
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto[];
    canViewReprocessingProjects!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projects = [];
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto.fromJS(item));
            }
            this.canViewReprocessingProjects = _data["canViewReprocessingProjects"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewReprocessingProjects"] = this.canViewReprocessingProjects;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDto {
    reprocessingId: number;
    reprocessingName: string;
    isPublic: boolean;
    projects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto[];
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto[];
    canViewReprocessingProjects: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto;
    project!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto();
            this.project = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto();
            this.project = _data["project"] ? GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto.fromJS(_data["project"]) : new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemDto;
    project: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto;
    dataMonitoringItemType: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseProjectDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDataMonitoringItemsResponseResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto {
    id!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    isConfidential!: boolean;
    operatorCompanyName?: string | undefined;
    nopimsLegislationName?: string | undefined;
    basinNames!: string;
    titles!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto[];
    comments?: string | undefined;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.isConfidential = _data["isConfidential"];
            this.operatorCompanyName = _data["operatorCompanyName"];
            this.nopimsLegislationName = _data["nopimsLegislationName"];
            this.basinNames = _data["basinNames"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["isConfidential"] = this.isConfidential;
        data["operatorCompanyName"] = this.operatorCompanyName;
        data["nopimsLegislationName"] = this.nopimsLegislationName;
        data["basinNames"] = this.basinNames;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseDto {
    id: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    isConfidential: boolean;
    operatorCompanyName?: string | undefined;
    nopimsLegislationName?: string | undefined;
    basinNames: string;
    titles: GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto[];
    comments?: string | undefined;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto {
    nopimsTitleType!: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingDetailsResponseTitleDto {
    nopimsTitleType: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto {
    advancedSearchOperations!: AdvancedSearchOperationDto[];
    advancedSearchTypes!: AdvancedSearchTypeDto[];
    titles!: AdvancedSearchReferenceDataTitleDto[];
    acquisitions!: AdvancedSearchReferenceDataAcquisitionDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.advancedSearchOperations = [];
            this.advancedSearchTypes = [];
            this.titles = [];
            this.acquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["advancedSearchOperations"])) {
                this.advancedSearchOperations = [] as any;
                for (let item of _data["advancedSearchOperations"])
                    this.advancedSearchOperations!.push(AdvancedSearchOperationDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchTypes"])) {
                this.advancedSearchTypes = [] as any;
                for (let item of _data["advancedSearchTypes"])
                    this.advancedSearchTypes!.push(AdvancedSearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(AdvancedSearchReferenceDataTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(AdvancedSearchReferenceDataAcquisitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.advancedSearchOperations)) {
            data["advancedSearchOperations"] = [];
            for (let item of this.advancedSearchOperations)
                data["advancedSearchOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchTypes)) {
            data["advancedSearchTypes"] = [];
            for (let item of this.advancedSearchTypes)
                data["advancedSearchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListReferenceDataResponseDto {
    advancedSearchOperations: AdvancedSearchOperationDto[];
    advancedSearchTypes: AdvancedSearchTypeDto[];
    titles: AdvancedSearchReferenceDataTitleDto[];
    acquisitions: AdvancedSearchReferenceDataAcquisitionDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto {
    filterText?: string | undefined;
    advancedFilters!: SearchAdvancedFilterDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.advancedFilters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterText = _data["filterText"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterText"] = this.filterText;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListRequestDto {
    filterText?: string | undefined;
    advancedFilters: SearchAdvancedFilterDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto {
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseDto {
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto {
    id!: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic!: boolean;
    legislation?: string | undefined;
    titleNumbers?: string | undefined;
    titles!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto[];
    operatorCompanyId?: number | undefined;
    operator?: string | undefined;
    basins?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.legislation = _data["legislation"];
            this.titleNumbers = _data["titleNumbers"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto.fromJS(item));
            }
            this.operatorCompanyId = _data["operatorCompanyId"];
            this.operator = _data["operator"];
            this.basins = _data["basins"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["legislation"] = this.legislation;
        data["titleNumbers"] = this.titleNumbers;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["operatorCompanyId"] = this.operatorCompanyId;
        data["operator"] = this.operator;
        data["basins"] = this.basins;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseItemDto {
    id: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic: boolean;
    legislation?: string | undefined;
    titleNumbers?: string | undefined;
    titles: GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto[];
    operatorCompanyId?: number | undefined;
    operator?: string | undefined;
    basins?: string | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto {
    titleId?: string | undefined;
    titleNumber!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingListResponseTitleDto {
    titleId?: string | undefined;
    titleNumber: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto {
    reprocessingId!: number;
    projectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsRequestDto {
    reprocessingId: number;
    projectId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto {
    surveyId!: number;
    surveyIdentifier?: string | undefined;
    acquisitionId!: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic!: boolean;
    acquisitionEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    exclusivity?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyIdentifier = _data["surveyIdentifier"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionIdentifier = _data["acquisitionIdentifier"];
            this.acquisitionName = _data["acquisitionName"];
            this.isPublic = _data["isPublic"];
            this.acquisitionEndDate = _data["acquisitionEndDate"] ? new Date(_data["acquisitionEndDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.exclusivity = _data["exclusivity"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyIdentifier"] = this.surveyIdentifier;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionIdentifier"] = this.acquisitionIdentifier;
        data["acquisitionName"] = this.acquisitionName;
        data["isPublic"] = this.isPublic;
        data["acquisitionEndDate"] = this.acquisitionEndDate ? this.acquisitionEndDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["exclusivity"] = this.exclusivity;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto {
    surveyId: number;
    surveyIdentifier?: string | undefined;
    acquisitionId: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic: boolean;
    acquisitionEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    exclusivity?: string | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto {
    name!: string;
    isPublic!: boolean;
    acquisitions!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseDto {
    name: string;
    isPublic: boolean;
    acquisitions: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectAcquisitionsResponseAcquisitionDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto {
    reprocessingId!: number;
    projectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsRequestDto {
    reprocessingId: number;
    projectId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto {
    isConfidential!: boolean;
    isSystemConfidential!: boolean;
    isUserOverridden!: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConfidential = _data["isConfidential"];
            this.isSystemConfidential = _data["isSystemConfidential"];
            this.isUserOverridden = _data["isUserOverridden"];
            this.isUserConfidential = _data["isUserConfidential"];
            this.comments = _data["comments"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConfidential"] = this.isConfidential;
        data["isSystemConfidential"] = this.isSystemConfidential;
        data["isUserOverridden"] = this.isUserOverridden;
        data["isUserConfidential"] = this.isUserConfidential;
        data["comments"] = this.comments;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto {
    isConfidential: boolean;
    isSystemConfidential: boolean;
    isUserOverridden: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto {
    reprocessingId!: number;
    reprocessingIdentifier!: string;
    reprocessingName?: string | undefined;
    id!: number;
    identifier!: string;
    name?: string | undefined;
    nopimsJurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    isAutoCalculateDates!: boolean;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    nopimsExclusivityStatus?: string | undefined;
    reprocessingLicenceType?: string | undefined;
    reprocessingLicenceComment?: string | undefined;
    contractor?: string | undefined;
    totalLineProcessedKm?: number | undefined;
    totalAreaProcessedKm2?: number | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    releaseComments?: string | undefined;
    confidentiality!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto;
    isPublic!: boolean;
    isNeverPublicUserOverride!: boolean;
    neverPublicUserOverrideComments?: string | undefined;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.confidentiality = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto();
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.reprocessingIdentifier = _data["reprocessingIdentifier"];
            this.reprocessingName = _data["reprocessingName"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.nopimsJurisdiction = _data["nopimsJurisdiction"];
            this.reprocessingType = _data["reprocessingType"];
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.finalDeliverableDate = _data["finalDeliverableDate"] ? new Date(_data["finalDeliverableDate"].toString()) : <any>undefined;
            this.permitYearEndDate = _data["permitYearEndDate"] ? new Date(_data["permitYearEndDate"].toString()) : <any>undefined;
            this.nopimsExclusivityStatus = _data["nopimsExclusivityStatus"];
            this.reprocessingLicenceType = _data["reprocessingLicenceType"];
            this.reprocessingLicenceComment = _data["reprocessingLicenceComment"];
            this.contractor = _data["contractor"];
            this.totalLineProcessedKm = _data["totalLineProcessedKm"];
            this.totalAreaProcessedKm2 = _data["totalAreaProcessedKm2"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.releaseComments = _data["releaseComments"];
            this.confidentiality = _data["confidentiality"] ? GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto.fromJS(_data["confidentiality"]) : new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto();
            this.isPublic = _data["isPublic"];
            this.isNeverPublicUserOverride = _data["isNeverPublicUserOverride"];
            this.neverPublicUserOverrideComments = _data["neverPublicUserOverrideComments"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["reprocessingIdentifier"] = this.reprocessingIdentifier;
        data["reprocessingName"] = this.reprocessingName;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["nopimsJurisdiction"] = this.nopimsJurisdiction;
        data["reprocessingType"] = this.reprocessingType;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["finalDeliverableDate"] = this.finalDeliverableDate ? this.finalDeliverableDate.toISOString() : <any>undefined;
        data["permitYearEndDate"] = this.permitYearEndDate ? this.permitYearEndDate.toISOString() : <any>undefined;
        data["nopimsExclusivityStatus"] = this.nopimsExclusivityStatus;
        data["reprocessingLicenceType"] = this.reprocessingLicenceType;
        data["reprocessingLicenceComment"] = this.reprocessingLicenceComment;
        data["contractor"] = this.contractor;
        data["totalLineProcessedKm"] = this.totalLineProcessedKm;
        data["totalAreaProcessedKm2"] = this.totalAreaProcessedKm2;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["releaseComments"] = this.releaseComments;
        data["confidentiality"] = this.confidentiality ? this.confidentiality.toJSON() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["isNeverPublicUserOverride"] = this.isNeverPublicUserOverride;
        data["neverPublicUserOverrideComments"] = this.neverPublicUserOverrideComments;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseDto {
    reprocessingId: number;
    reprocessingIdentifier: string;
    reprocessingName?: string | undefined;
    id: number;
    identifier: string;
    name?: string | undefined;
    nopimsJurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    isAutoCalculateDates: boolean;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    nopimsExclusivityStatus?: string | undefined;
    reprocessingLicenceType?: string | undefined;
    reprocessingLicenceComment?: string | undefined;
    contractor?: string | undefined;
    totalLineProcessedKm?: number | undefined;
    totalAreaProcessedKm2?: number | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    releaseComments?: string | undefined;
    confidentiality: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectDetailsResponseConfidentialityDto;
    isPublic: boolean;
    isNeverPublicUserOverride: boolean;
    neverPublicUserOverrideComments?: string | undefined;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto {
    advancedSearchOperations!: AdvancedSearchOperationDto[];
    advancedSearchTypes!: AdvancedSearchTypeDto[];
    titles!: AdvancedSearchReferenceDataTitleDto[];
    acquisitions!: AdvancedSearchReferenceDataAcquisitionDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.advancedSearchOperations = [];
            this.advancedSearchTypes = [];
            this.titles = [];
            this.acquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["advancedSearchOperations"])) {
                this.advancedSearchOperations = [] as any;
                for (let item of _data["advancedSearchOperations"])
                    this.advancedSearchOperations!.push(AdvancedSearchOperationDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchTypes"])) {
                this.advancedSearchTypes = [] as any;
                for (let item of _data["advancedSearchTypes"])
                    this.advancedSearchTypes!.push(AdvancedSearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(AdvancedSearchReferenceDataTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(AdvancedSearchReferenceDataAcquisitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.advancedSearchOperations)) {
            data["advancedSearchOperations"] = [];
            for (let item of this.advancedSearchOperations)
                data["advancedSearchOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchTypes)) {
            data["advancedSearchTypes"] = [];
            for (let item of this.advancedSearchTypes)
                data["advancedSearchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListReferenceDataResponseDto {
    advancedSearchOperations: AdvancedSearchOperationDto[];
    advancedSearchTypes: AdvancedSearchTypeDto[];
    titles: AdvancedSearchReferenceDataTitleDto[];
    acquisitions: AdvancedSearchReferenceDataAcquisitionDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto {
    filterText?: string | undefined;
    advancedFilters!: SearchAdvancedFilterDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.advancedFilters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterText = _data["filterText"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterText"] = this.filterText;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListRequestDto {
    filterText?: string | undefined;
    advancedFilters: SearchAdvancedFilterDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto {
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseDto {
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto {
    reprocessingId!: number;
    projectId!: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic!: boolean;
    jurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    confidential?: string | undefined;
    contractorName?: string | undefined;
    comments?: string | undefined;
    titleNumbers?: string | undefined;
    titles!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.jurisdiction = _data["jurisdiction"];
            this.reprocessingType = _data["reprocessingType"];
            this.finalDeliverableDate = _data["finalDeliverableDate"] ? new Date(_data["finalDeliverableDate"].toString()) : <any>undefined;
            this.permitYearEndDate = _data["permitYearEndDate"] ? new Date(_data["permitYearEndDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.confidential = _data["confidential"];
            this.contractorName = _data["contractorName"];
            this.comments = _data["comments"];
            this.titleNumbers = _data["titleNumbers"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["jurisdiction"] = this.jurisdiction;
        data["reprocessingType"] = this.reprocessingType;
        data["finalDeliverableDate"] = this.finalDeliverableDate ? this.finalDeliverableDate.toISOString() : <any>undefined;
        data["permitYearEndDate"] = this.permitYearEndDate ? this.permitYearEndDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["confidential"] = this.confidential;
        data["contractorName"] = this.contractorName;
        data["comments"] = this.comments;
        data["titleNumbers"] = this.titleNumbers;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseItemDto {
    reprocessingId: number;
    projectId: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic: boolean;
    jurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    confidential?: string | undefined;
    contractorName?: string | undefined;
    comments?: string | undefined;
    titleNumbers?: string | undefined;
    titles: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto {
    titleId?: string | undefined;
    titleNumber!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectListResponseTitleDto {
    titleId?: string | undefined;
    titleNumber: string;
}

export class GetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto implements IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto {
    reprocessingProjectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingProjectId = _data["reprocessingProjectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingProjectId"] = this.reprocessingProjectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsRequestDto {
    reprocessingProjectId: number;
}

export class GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto implements IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto {
    reprocessingProjectId!: number;
    reprocessingId!: number;
    reprocessingProjectName?: string | undefined;
    reprocessingName?: string | undefined;
    isPublic!: boolean;
    canViewReprocessing!: boolean;
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingProjectId = _data["reprocessingProjectId"];
            this.reprocessingId = _data["reprocessingId"];
            this.reprocessingProjectName = _data["reprocessingProjectName"];
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            this.canViewReprocessing = _data["canViewReprocessing"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingProjectId"] = this.reprocessingProjectId;
        data["reprocessingId"] = this.reprocessingId;
        data["reprocessingProjectName"] = this.reprocessingProjectName;
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        data["canViewReprocessing"] = this.canViewReprocessing;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingProjectReportAttachmentsResponseDto {
    reprocessingProjectId: number;
    reprocessingId: number;
    reprocessingProjectName?: string | undefined;
    reprocessingName?: string | undefined;
    isPublic: boolean;
    canViewReprocessing: boolean;
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
    reprocessingId!: number;
    projectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
    reprocessingId: number;
    projectId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
    projectName!: string;
    reprocessingName!: string;
    isPublic!: boolean;
    canViewReprocessings!: boolean;
    items!: GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto[];
    loanStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            this.canViewReprocessings = _data["canViewReprocessings"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        data["canViewReprocessings"] = this.canViewReprocessings;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
    projectName: string;
    reprocessingName: string;
    isPublic: boolean;
    canViewReprocessings: boolean;
    items: GetGeoscienceAustraliaReprocessingsProjectsProjectReportsItemDto[];
    loanStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectReportsLoanStatusDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsProjectReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto implements IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto {
    reprocessingId!: number;
    reprocessingProjectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.reprocessingProjectId = _data["reprocessingProjectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["reprocessingProjectId"] = this.reprocessingProjectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataRequestDto {
    reprocessingId: number;
    reprocessingProjectId: number;
}

export class GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto implements IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto {
    reprocessingProjectName!: string;
    reprocessingName!: string;
    isPublic!: boolean;
    canViewReprocessings!: boolean;
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto[];
    loanStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingProjectName = _data["reprocessingProjectName"];
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            this.canViewReprocessings = _data["canViewReprocessings"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingProjectName"] = this.reprocessingProjectName;
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        data["canViewReprocessings"] = this.canViewReprocessings;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingProjectReprocessingProjectSurveyDataResponseDto {
    reprocessingProjectName: string;
    reprocessingName: string;
    isPublic: boolean;
    canViewReprocessings: boolean;
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto[];
    loanStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataConditionStatusDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    isPublic!: boolean;
    title?: string | undefined;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.isPublic = _data["isPublic"];
            this.title = _data["title"];
            this.dataType = _data["dataType"];
            this.tapeId = _data["tapeId"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.consignment = _data["consignment"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["isPublic"] = this.isPublic;
        data["title"] = this.title;
        data["dataType"] = this.dataType;
        data["tapeId"] = this.tapeId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["consignment"] = this.consignment;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectSurveyDataItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    isPublic: boolean;
    title?: string | undefined;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto implements IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto {
    reprocessingId!: number;
    surveyData!: UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto[];
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            if (Array.isArray(_data["surveyData"])) {
                this.surveyData = [] as any;
                for (let item of _data["surveyData"])
                    this.surveyData!.push(UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        if (Array.isArray(this.surveyData)) {
            data["surveyData"] = [];
            for (let item of this.surveyData)
                data["surveyData"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataRequestDto {
    reprocessingId: number;
    surveyData: UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto[];
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto implements IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto {
    statusMessages!: StatusMessagesDto;
    failedSurveyDataIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            if (Array.isArray(_data["failedSurveyDataIds"])) {
                this.failedSurveyDataIds = [] as any;
                for (let item of _data["failedSurveyDataIds"])
                    this.failedSurveyDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedSurveyDataIds)) {
            data["failedSurveyDataIds"] = [];
            for (let item of this.failedSurveyDataIds)
                data["failedSurveyDataIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataResponseDto {
    statusMessages: StatusMessagesDto;
    failedSurveyDataIds?: number[] | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto implements IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingProjectsProjectSurveyDataSurveyDataDto {
    versionNumber: number;
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto {
    reprocessingId!: number;
    projectId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesRequestDto {
    reprocessingId: number;
    projectId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto {
    reprocessingId!: number;
    id!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    titles!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto[];
    workProgramItems!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
            this.workProgramItems = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["workProgramItems"])) {
                this.workProgramItems = [] as any;
                for (let item of _data["workProgramItems"])
                    this.workProgramItems!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.workProgramItems)) {
            data["workProgramItems"] = [];
            for (let item of this.workProgramItems)
                data["workProgramItems"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseDto {
    reprocessingId: number;
    id: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    titles: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto[];
    workProgramItems: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto {
    sequenceNumber!: number;
    reprocessingProjectTitleId!: number;
    titleRelationshipType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titlePermitYearEndDate?: Date | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.reprocessingProjectTitleId = _data["reprocessingProjectTitleId"];
            this.titleRelationshipType = _data["titleRelationshipType"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titlePermitYearEndDate = _data["titlePermitYearEndDate"] ? new Date(_data["titlePermitYearEndDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["reprocessingProjectTitleId"] = this.reprocessingProjectTitleId;
        data["titleRelationshipType"] = this.titleRelationshipType;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titlePermitYearEndDate"] = this.titlePermitYearEndDate ? this.titlePermitYearEndDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseTitleDto {
    sequenceNumber: number;
    reprocessingProjectTitleId: number;
    titleRelationshipType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titlePermitYearEndDate?: Date | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto {
    titleSequenceNumber!: number;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    quantity?: number | undefined;
    units?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleSequenceNumber = _data["titleSequenceNumber"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.activity = _data["activity"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.units = _data["units"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleSequenceNumber"] = this.titleSequenceNumber;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["activity"] = this.activity;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["units"] = this.units;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectTitlesResponseWorkProgramItemDto {
    titleSequenceNumber: number;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    quantity?: number | undefined;
    units?: string | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto {
    id!: number;
    name?: string | undefined;
    isPublic!: boolean;
    projects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projects = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseDto {
    id: number;
    name?: string | undefined;
    isPublic: boolean;
    projects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto {
    id!: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic!: boolean;
    jurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    confidentiality?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.jurisdiction = _data["jurisdiction"];
            this.reprocessingType = _data["reprocessingType"];
            this.finalDeliverableDate = _data["finalDeliverableDate"] ? new Date(_data["finalDeliverableDate"].toString()) : <any>undefined;
            this.permitYearEndDate = _data["permitYearEndDate"] ? new Date(_data["permitYearEndDate"].toString()) : <any>undefined;
            this.confidentiality = _data["confidentiality"];
            this.contractor = _data["contractor"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["jurisdiction"] = this.jurisdiction;
        data["reprocessingType"] = this.reprocessingType;
        data["finalDeliverableDate"] = this.finalDeliverableDate ? this.finalDeliverableDate.toISOString() : <any>undefined;
        data["permitYearEndDate"] = this.permitYearEndDate ? this.permitYearEndDate.toISOString() : <any>undefined;
        data["confidentiality"] = this.confidentiality;
        data["contractor"] = this.contractor;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingProjectsResponseProjectDto {
    id: number;
    identifier?: string | undefined;
    name?: string | undefined;
    isPublic: boolean;
    jurisdiction?: string | undefined;
    reprocessingType?: string | undefined;
    finalDeliverableDate?: Date | undefined;
    permitYearEndDate?: Date | undefined;
    confidentiality?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaProjectIdentifierDto implements IGetGeoscienceAustraliaProjectIdentifierDto {
    projectId!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaProjectIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaProjectIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaProjectIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaProjectIdentifierDto {
    projectId: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto implements IGetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingReportAttachmentsRequestDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto implements IGetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto {
    reprocessingId!: number;
    reprocessingName?: string | undefined;
    isPublic!: boolean;
    projectIdentifiers!: GetGeoscienceAustraliaProjectIdentifierDto[];
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectIdentifiers = [];
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["projectIdentifiers"])) {
                this.projectIdentifiers = [] as any;
                for (let item of _data["projectIdentifiers"])
                    this.projectIdentifiers!.push(GetGeoscienceAustraliaProjectIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.projectIdentifiers)) {
            data["projectIdentifiers"] = [];
            for (let item of this.projectIdentifiers)
                data["projectIdentifiers"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingReportAttachmentsResponseDto {
    reprocessingId: number;
    reprocessingName?: string | undefined;
    isPublic: boolean;
    projectIdentifiers: GetGeoscienceAustraliaProjectIdentifierDto[];
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    reprocessingProjects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessingProjects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto.fromJS(item));
            }
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    reprocessingProjects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
    reprocessingName!: string;
    isPublic!: boolean;
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto[];
    reprocessingProjects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto[];
    loanStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.reprocessingProjects = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
    reprocessingName: string;
    isPublic: boolean;
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsItemDto[];
    reprocessingProjects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReprocessingProjectItemDto[];
    loanStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingReportsConditionStatusDto[];
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    isPublic!: boolean;
    title?: string | undefined;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    reprocessingProjects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto[];
    reprocessingProjectDescriptions?: string | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessingProjects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.isPublic = _data["isPublic"];
            this.title = _data["title"];
            this.dataType = _data["dataType"];
            this.tapeId = _data["tapeId"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto.fromJS(item));
            }
            this.reprocessingProjectDescriptions = _data["reprocessingProjectDescriptions"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.consignment = _data["consignment"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["isPublic"] = this.isPublic;
        data["title"] = this.title;
        data["dataType"] = this.dataType;
        data["tapeId"] = this.tapeId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        data["reprocessingProjectDescriptions"] = this.reprocessingProjectDescriptions;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["consignment"] = this.consignment;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    isPublic: boolean;
    title?: string | undefined;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    reprocessingProjects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto[];
    reprocessingProjectDescriptions?: string | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
    reprocessingName!: string;
    isPublic!: boolean;
    reprocessingProjects!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto[];
    items!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto[];
    loanStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessingProjects = [];
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingName = _data["reprocessingName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["reprocessingProjects"])) {
                this.reprocessingProjects = [] as any;
                for (let item of _data["reprocessingProjects"])
                    this.reprocessingProjects!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingName"] = this.reprocessingName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.reprocessingProjects)) {
            data["reprocessingProjects"] = [];
            for (let item of this.reprocessingProjects)
                data["reprocessingProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
    reprocessingName: string;
    isPublic: boolean;
    reprocessingProjects: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataReprocessingProjectItemDto[];
    items: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataItemDto[];
    loanStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataConditionStatusDto[];
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
    reprocessingId!: number;
    surveyData!: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto[];
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
            if (Array.isArray(_data["surveyData"])) {
                this.surveyData = [] as any;
                for (let item of _data["surveyData"])
                    this.surveyData!.push(UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        if (Array.isArray(this.surveyData)) {
            data["surveyData"] = [];
            for (let item of this.surveyData)
                data["surveyData"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataRequestDto {
    reprocessingId: number;
    surveyData: UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto[];
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedSurveyDataIds"])) {
                this.failedSurveyDataIds = [] as any;
                for (let item of _data["failedSurveyDataIds"])
                    this.failedSurveyDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedSurveyDataIds)) {
            data["failedSurveyDataIds"] = [];
            for (let item of this.failedSurveyDataIds)
                data["failedSurveyDataIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;
}

export class UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto implements IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaReprocessingsProjectsReprocessingSurveyDataSurveyDataDto {
    versionNumber: number;
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto {
    id!: number;
    name?: string | undefined;
    isPublic!: boolean;
    titles!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto[];
    workProgramItems!: GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
            this.workProgramItems = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["workProgramItems"])) {
                this.workProgramItems = [] as any;
                for (let item of _data["workProgramItems"])
                    this.workProgramItems!.push(GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.workProgramItems)) {
            data["workProgramItems"] = [];
            for (let item of this.workProgramItems)
                data["workProgramItems"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseDto {
    id: number;
    name?: string | undefined;
    isPublic: boolean;
    titles: GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto[];
    workProgramItems: GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto {
    projectId!: number;
    projectIdentifier?: string | undefined;
    titleRelationshipType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titlePermitYearEndDate?: Date | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectIdentifier = _data["projectIdentifier"];
            this.titleRelationshipType = _data["titleRelationshipType"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleType = _data["titleType"];
            this.titlePermitYearEndDate = _data["titlePermitYearEndDate"] ? new Date(_data["titlePermitYearEndDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectIdentifier"] = this.projectIdentifier;
        data["titleRelationshipType"] = this.titleRelationshipType;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleType"] = this.titleType;
        data["titlePermitYearEndDate"] = this.titlePermitYearEndDate ? this.titlePermitYearEndDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseTitleDto {
    projectId: number;
    projectIdentifier?: string | undefined;
    titleRelationshipType?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleType?: string | undefined;
    titlePermitYearEndDate?: Date | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto implements IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto {
    projectId!: number;
    projectIdentifier?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    quantity?: number | undefined;
    units?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectIdentifier = _data["projectIdentifier"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.activity = _data["activity"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.units = _data["units"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectIdentifier"] = this.projectIdentifier;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["activity"] = this.activity;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["units"] = this.units;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaReprocessingsProjectsReprocessingTitlesResponseWorkProgramItemDto {
    projectId: number;
    projectIdentifier?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    quantity?: number | undefined;
    units?: string | undefined;
    comments?: string | undefined;
}

export class CreateGeoscienceAustraliaSurveyDataAttachmentRequestDto implements ICreateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
}

export class CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto implements ICreateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class DeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto implements IDeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataAttachmentId!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataAttachmentId = _data["surveyDataAttachmentId"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataAttachmentId"] = this.surveyDataAttachmentId;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataAttachmentId: number;
}

export class DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto implements IDeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaSurveyDataAttachmentsItemDto implements IGetGeoscienceAustraliaSurveyDataAttachmentsItemDto {
    id!: number;
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
    fileSize!: number;
    numberOfMappings!: number;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataAttachmentsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.numberOfMappings = _data["numberOfMappings"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedDate = _data["uploadedDate"] ? new Date(_data["uploadedDate"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataAttachmentsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataAttachmentsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["numberOfMappings"] = this.numberOfMappings;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataAttachmentsItemDto {
    id: number;
    surveyDataId: number;
    surveyDataVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
    numberOfMappings: number;
    uploadedBy?: string | undefined;
    uploadedDate?: Date | undefined;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaSurveyDataAttachmentsRequestDto implements IGetGeoscienceAustraliaSurveyDataAttachmentsRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataAttachmentsRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto implements IGetGeoscienceAustraliaSurveyDataAttachmentsResponseDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    itemId?: string | undefined;
    attachments?: GetGeoscienceAustraliaSurveyDataAttachmentsItemDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaSurveyDataAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["itemId"] = this.itemId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataAttachmentsResponseDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    itemId?: string | undefined;
    attachments?: GetGeoscienceAustraliaSurveyDataAttachmentsItemDto[] | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto implements IUpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataAttachmentId!: number;
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataAttachmentId = _data["surveyDataAttachmentId"];
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.documentLink = _data["documentLink"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataAttachmentId"] = this.surveyDataAttachmentId;
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["documentLink"] = this.documentLink;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataAttachmentRequestDto {
    surveyDataAttachmentId: number;
    surveyDataId: number;
    surveyDataVersionNumber: number;
    documentLink?: string | undefined;
    fileName?: string | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto implements IUpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataAttachmentResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceData implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceData {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceData {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceData {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto implements IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto implements IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto {
    surveyDataConditionStatuses!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataDataFormats!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataMediaTypes!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataDataStatuses!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataRddsStatuses!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataLoanStatuses!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataCopyStatuses!: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];

    constructor(data?: IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyDataConditionStatuses = [];
            this.surveyDataDataFormats = [];
            this.surveyDataMediaTypes = [];
            this.surveyDataDataStatuses = [];
            this.surveyDataRddsStatuses = [];
            this.surveyDataLoanStatuses = [];
            this.surveyDataCopyStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyDataConditionStatuses"])) {
                this.surveyDataConditionStatuses = [] as any;
                for (let item of _data["surveyDataConditionStatuses"])
                    this.surveyDataConditionStatuses!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataDataFormats"])) {
                this.surveyDataDataFormats = [] as any;
                for (let item of _data["surveyDataDataFormats"])
                    this.surveyDataDataFormats!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataMediaTypes"])) {
                this.surveyDataMediaTypes = [] as any;
                for (let item of _data["surveyDataMediaTypes"])
                    this.surveyDataMediaTypes!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataDataStatuses"])) {
                this.surveyDataDataStatuses = [] as any;
                for (let item of _data["surveyDataDataStatuses"])
                    this.surveyDataDataStatuses!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataRddsStatuses"])) {
                this.surveyDataRddsStatuses = [] as any;
                for (let item of _data["surveyDataRddsStatuses"])
                    this.surveyDataRddsStatuses!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataLoanStatuses"])) {
                this.surveyDataLoanStatuses = [] as any;
                for (let item of _data["surveyDataLoanStatuses"])
                    this.surveyDataLoanStatuses!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataCopyStatuses"])) {
                this.surveyDataCopyStatuses = [] as any;
                for (let item of _data["surveyDataCopyStatuses"])
                    this.surveyDataCopyStatuses!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyDataConditionStatuses)) {
            data["surveyDataConditionStatuses"] = [];
            for (let item of this.surveyDataConditionStatuses)
                data["surveyDataConditionStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataDataFormats)) {
            data["surveyDataDataFormats"] = [];
            for (let item of this.surveyDataDataFormats)
                data["surveyDataDataFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataMediaTypes)) {
            data["surveyDataMediaTypes"] = [];
            for (let item of this.surveyDataMediaTypes)
                data["surveyDataMediaTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataDataStatuses)) {
            data["surveyDataDataStatuses"] = [];
            for (let item of this.surveyDataDataStatuses)
                data["surveyDataDataStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataRddsStatuses)) {
            data["surveyDataRddsStatuses"] = [];
            for (let item of this.surveyDataRddsStatuses)
                data["surveyDataRddsStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataLoanStatuses)) {
            data["surveyDataLoanStatuses"] = [];
            for (let item of this.surveyDataLoanStatuses)
                data["surveyDataLoanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataCopyStatuses)) {
            data["surveyDataCopyStatuses"] = [];
            for (let item of this.surveyDataCopyStatuses)
                data["surveyDataCopyStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataFileAssetsReferenceDataResponseDto {
    surveyDataConditionStatuses: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataDataFormats: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataMediaTypes: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataDataStatuses: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataRddsStatuses: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataLoanStatuses: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
    surveyDataCopyStatuses: GetGeoscienceAustraliaSurveyDataDetailsReferenceData[];
}

export class GetGeoscienceAustraliaSurveyDataFileAssetsRequestDto implements IGetGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataFileAssetsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataFileAssetsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto implements IGetGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    itemId?: string | undefined;
    tapeId?: string | undefined;
    remarks?: string | undefined;
    qcRemarks?: string | undefined;
    rddsComments?: string | undefined;
    consignment?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    surveyDataDataStatusId?: number | undefined;
    surveyDataRddsStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataCopyStatusId?: number | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataFileAssetsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.itemId = _data["itemId"];
            this.tapeId = _data["tapeId"];
            this.remarks = _data["remarks"];
            this.qcRemarks = _data["qcRemarks"];
            this.rddsComments = _data["rddsComments"];
            this.consignment = _data["consignment"];
            this.surveyDataConditionStatusId = _data["surveyDataConditionStatusId"];
            this.surveyDataDataFormatId = _data["surveyDataDataFormatId"];
            this.surveyDataMediaTypeId = _data["surveyDataMediaTypeId"];
            this.surveyDataDataStatusId = _data["surveyDataDataStatusId"];
            this.surveyDataRddsStatusId = _data["surveyDataRddsStatusId"];
            this.surveyDataLoanStatusId = _data["surveyDataLoanStatusId"];
            this.surveyDataCopyStatusId = _data["surveyDataCopyStatusId"];
            this.auditDto = _data["auditDto"] ? SimpleAuditEventsDto.fromJS(_data["auditDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataFileAssetsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["itemId"] = this.itemId;
        data["tapeId"] = this.tapeId;
        data["remarks"] = this.remarks;
        data["qcRemarks"] = this.qcRemarks;
        data["rddsComments"] = this.rddsComments;
        data["consignment"] = this.consignment;
        data["surveyDataConditionStatusId"] = this.surveyDataConditionStatusId;
        data["surveyDataDataFormatId"] = this.surveyDataDataFormatId;
        data["surveyDataMediaTypeId"] = this.surveyDataMediaTypeId;
        data["surveyDataDataStatusId"] = this.surveyDataDataStatusId;
        data["surveyDataRddsStatusId"] = this.surveyDataRddsStatusId;
        data["surveyDataLoanStatusId"] = this.surveyDataLoanStatusId;
        data["surveyDataCopyStatusId"] = this.surveyDataCopyStatusId;
        data["auditDto"] = this.auditDto ? this.auditDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    itemId?: string | undefined;
    tapeId?: string | undefined;
    remarks?: string | undefined;
    qcRemarks?: string | undefined;
    rddsComments?: string | undefined;
    consignment?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    surveyDataDataStatusId?: number | undefined;
    surveyDataRddsStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataCopyStatusId?: number | undefined;
    auditDto?: SimpleAuditEventsDto | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto implements IUpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    tapeId?: string | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    surveyDataCopyStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataRddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    surveyDataDataStatusId?: number | undefined;
    consignment?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.tapeId = _data["tapeId"];
            this.surveyDataDataFormatId = _data["surveyDataDataFormatId"];
            this.surveyDataMediaTypeId = _data["surveyDataMediaTypeId"];
            this.remarks = _data["remarks"];
            this.surveyDataConditionStatusId = _data["surveyDataConditionStatusId"];
            this.qcRemarks = _data["qcRemarks"];
            this.surveyDataCopyStatusId = _data["surveyDataCopyStatusId"];
            this.surveyDataLoanStatusId = _data["surveyDataLoanStatusId"];
            this.surveyDataRddsStatusId = _data["surveyDataRddsStatusId"];
            this.rddsComments = _data["rddsComments"];
            this.surveyDataDataStatusId = _data["surveyDataDataStatusId"];
            this.consignment = _data["consignment"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["tapeId"] = this.tapeId;
        data["surveyDataDataFormatId"] = this.surveyDataDataFormatId;
        data["surveyDataMediaTypeId"] = this.surveyDataMediaTypeId;
        data["remarks"] = this.remarks;
        data["surveyDataConditionStatusId"] = this.surveyDataConditionStatusId;
        data["qcRemarks"] = this.qcRemarks;
        data["surveyDataCopyStatusId"] = this.surveyDataCopyStatusId;
        data["surveyDataLoanStatusId"] = this.surveyDataLoanStatusId;
        data["surveyDataRddsStatusId"] = this.surveyDataRddsStatusId;
        data["rddsComments"] = this.rddsComments;
        data["surveyDataDataStatusId"] = this.surveyDataDataStatusId;
        data["consignment"] = this.consignment;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataFileAssetsRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    tapeId?: string | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    remarks?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    qcRemarks?: string | undefined;
    surveyDataCopyStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataRddsStatusId?: number | undefined;
    rddsComments?: string | undefined;
    surveyDataDataStatusId?: number | undefined;
    consignment?: string | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto implements IUpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataFileAssetsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class CreateGeoscienceAustraliaSurveyDataLineRequestDto implements ICreateGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.lineName = _data["lineName"];
            this.fsl = _data["fsl"];
            this.lsl = _data["lsl"];
            this.lineComments = _data["lineComments"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["lineName"] = this.lineName;
        data["fsl"] = this.fsl;
        data["lsl"] = this.lsl;
        data["lineComments"] = this.lineComments;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;
}

export class CreateGeoscienceAustraliaSurveyDataLineResponseDto implements ICreateGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages: StatusMessagesDto;
}

export class DeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto implements IDeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataAllLinesRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
}

export class DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto implements IDeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataAllLinesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class DeleteGeoscienceAustraliaSurveyDataLineRequestDto implements IDeleteGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataLineId!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataLineId = _data["surveyDataLineId"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataLineId"] = this.surveyDataLineId;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataLineId: number;
}

export class DeleteGeoscienceAustraliaSurveyDataLineResponseDto implements IDeleteGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaSurveyDataLineItemDto implements IGetGeoscienceAustraliaSurveyDataLineItemDto {
    id!: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineName = _data["lineName"];
            this.fsl = _data["fsl"];
            this.lsl = _data["lsl"];
            this.lineComments = _data["lineComments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineName"] = this.lineName;
        data["fsl"] = this.fsl;
        data["lsl"] = this.lsl;
        data["lineComments"] = this.lineComments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataLineItemDto {
    id: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveyDataLinesRequestDto implements IGetGeoscienceAustraliaSurveyDataLinesRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataLinesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataLinesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataLinesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataLinesRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataLinesResponseDto implements IGetGeoscienceAustraliaSurveyDataLinesResponseDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    itemId?: string | undefined;
    lines!: GetGeoscienceAustraliaSurveyDataLineItemDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveyDataLinesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(GetGeoscienceAustraliaSurveyDataLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataLinesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataLinesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["itemId"] = this.itemId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataLinesResponseDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    itemId?: string | undefined;
    lines: GetGeoscienceAustraliaSurveyDataLineItemDto[];
}

export class ImportGeoscienceAustraliaSurveyDataLinesRequestDto implements IImportGeoscienceAustraliaSurveyDataLinesRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    fileName?: string | undefined;
    fileContent?: string | undefined;

    constructor(data?: IImportGeoscienceAustraliaSurveyDataLinesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaSurveyDataLinesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaSurveyDataLinesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IImportGeoscienceAustraliaSurveyDataLinesRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    fileName?: string | undefined;
    fileContent?: string | undefined;
}

export class ImportGeoscienceAustraliaSurveyDataLinesResponseDto implements IImportGeoscienceAustraliaSurveyDataLinesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IImportGeoscienceAustraliaSurveyDataLinesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaSurveyDataLinesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaSurveyDataLinesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportGeoscienceAustraliaSurveyDataLinesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class UpdateGeoscienceAustraliaSurveyDataLineRequestDto implements IUpdateGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataLineId!: number;
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataLineId = _data["surveyDataLineId"];
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.lineName = _data["lineName"];
            this.fsl = _data["fsl"];
            this.lsl = _data["lsl"];
            this.lineComments = _data["lineComments"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataLineId"] = this.surveyDataLineId;
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["lineName"] = this.lineName;
        data["fsl"] = this.fsl;
        data["lsl"] = this.lsl;
        data["lineComments"] = this.lineComments;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataLineRequestDto {
    surveyDataLineId: number;
    surveyDataId: number;
    surveyDataVersionNumber: number;
    lineName?: string | undefined;
    fsl?: string | undefined;
    lsl?: string | undefined;
    lineComments?: string | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataLineResponseDto implements IUpdateGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataLineResponseDto {
    statusMessages: StatusMessagesDto;
}

export class AddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto implements IAddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataRelatedActivityType!: SurveyDataRelatedActivityTypeEnum;
    activityIds?: number[] | undefined;
    comments?: string | undefined;

    constructor(data?: IAddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataRelatedActivityType = _data["surveyDataRelatedActivityType"];
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataRelatedActivityType"] = this.surveyDataRelatedActivityType;
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAddGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataRelatedActivityType: SurveyDataRelatedActivityTypeEnum;
    activityIds?: number[] | undefined;
    comments?: string | undefined;
}

export class AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto implements IAddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IAddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class DeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto implements IDeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    activityId!: number;
    surveyDataRelatedActivityType!: SurveyDataRelatedActivityTypeEnum;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.activityId = _data["activityId"];
            this.surveyDataRelatedActivityType = _data["surveyDataRelatedActivityType"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["activityId"] = this.activityId;
        data["surveyDataRelatedActivityType"] = this.surveyDataRelatedActivityType;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataRelatedActivityRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    activityId: number;
    surveyDataRelatedActivityType: SurveyDataRelatedActivityTypeEnum;
}

export class DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto implements IDeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataRelatedActivityResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivitiesRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    itemId?: string | undefined;
    relatedActivities!: GetGeoscienceAustraliaSurveyDataRelatedActivityDto[];
    relatedActivityReferenceData!: GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedActivities = [];
            this.relatedActivityReferenceData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["relatedActivities"])) {
                this.relatedActivities = [] as any;
                for (let item of _data["relatedActivities"])
                    this.relatedActivities!.push(GetGeoscienceAustraliaSurveyDataRelatedActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedActivityReferenceData"])) {
                this.relatedActivityReferenceData = [] as any;
                for (let item of _data["relatedActivityReferenceData"])
                    this.relatedActivityReferenceData!.push(GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["itemId"] = this.itemId;
        if (Array.isArray(this.relatedActivities)) {
            data["relatedActivities"] = [];
            for (let item of this.relatedActivities)
                data["relatedActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedActivityReferenceData)) {
            data["relatedActivityReferenceData"] = [];
            for (let item of this.relatedActivityReferenceData)
                data["relatedActivityReferenceData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivitiesResponseDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataHeader?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    itemId?: string | undefined;
    relatedActivities: GetGeoscienceAustraliaSurveyDataRelatedActivityDto[];
    relatedActivityReferenceData: GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto[];
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto {
    wellId: number;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivityDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivityDto {
    id!: number;
    surveyDataRelatedActivityType!: SurveyDataRelatedActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto | undefined;
    activityId?: string | undefined;
    activityName?: string | undefined;
    isPublic!: boolean;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyDataRelatedActivityType = _data["surveyDataRelatedActivityType"];
            this.boreholeDetails = _data["boreholeDetails"] ? GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto.fromJS(_data["boreholeDetails"]) : <any>undefined;
            this.acquisitionDetails = _data["acquisitionDetails"] ? GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto.fromJS(_data["acquisitionDetails"]) : <any>undefined;
            this.projectDetails = _data["projectDetails"] ? GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto.fromJS(_data["projectDetails"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.isPublic = _data["isPublic"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyDataRelatedActivityType"] = this.surveyDataRelatedActivityType;
        data["boreholeDetails"] = this.boreholeDetails ? this.boreholeDetails.toJSON() : <any>undefined;
        data["acquisitionDetails"] = this.acquisitionDetails ? this.acquisitionDetails.toJSON() : <any>undefined;
        data["projectDetails"] = this.projectDetails ? this.projectDetails.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["isPublic"] = this.isPublic;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivityDto {
    id: number;
    surveyDataRelatedActivityType: SurveyDataRelatedActivityTypeEnum;
    boreholeDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityBoreholeDto | undefined;
    acquisitionDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityAcquisitionDto | undefined;
    projectDetails?: GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto | undefined;
    activityId?: string | undefined;
    activityName?: string | undefined;
    isPublic: boolean;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto {
    reprocessingId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reprocessingId = _data["reprocessingId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reprocessingId"] = this.reprocessingId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivityProjectDto {
    reprocessingId: number;
}

export class GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto implements IGetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto {
    elementId!: number;
    surveyDataRelatedActivityType!: SurveyDataRelatedActivityTypeEnum;
    activityId?: string | undefined;
    isPublic!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.surveyDataRelatedActivityType = _data["surveyDataRelatedActivityType"];
            this.activityId = _data["activityId"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["surveyDataRelatedActivityType"] = this.surveyDataRelatedActivityType;
        data["activityId"] = this.activityId;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataRelatedActivityReferenceDataDto {
    elementId: number;
    surveyDataRelatedActivityType: SurveyDataRelatedActivityTypeEnum;
    activityId?: string | undefined;
    isPublic: boolean;
}

export class GetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto implements IGetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDataAuditChangesRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto implements IGetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto {
    surveyDataHeader!: string;
    isPublic!: boolean;
    surveyDataDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyDataDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.isPublic = _data["isPublic"];
            this.surveyDataDataAuditChanges = _data["surveyDataDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["surveyDataDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["isPublic"] = this.isPublic;
        data["surveyDataDataAuditChanges"] = this.surveyDataDataAuditChanges ? this.surveyDataDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDataAuditChangesResponseDto {
    surveyDataHeader: string;
    isPublic: boolean;
    surveyDataDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class CreateGeoscienceAustraliaSurveyDataRequestDto implements ICreateGeoscienceAustraliaSurveyDataRequestDto {
    itemId?: string | undefined;
    isConfidential!: boolean;
    surveyAcquisitionIds!: number[];
    tapeId?: string | undefined;
    surveyDataTypeId!: number;
    surveyDataType?: string | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    surveyDataTitle?: string | undefined;
    remarks?: string | undefined;
    confidentialityRemarks?: string | undefined;
    qcRemarks?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataCopyStatusId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    surveyDataRddsStatusId?: number | undefined;
    surveyDataDataStatusId?: number | undefined;
    rddsComments?: string | undefined;
    companyId?: number | undefined;
    consignment?: string | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    contractorId?: number | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.isConfidential = _data["isConfidential"];
            if (Array.isArray(_data["surveyAcquisitionIds"])) {
                this.surveyAcquisitionIds = [] as any;
                for (let item of _data["surveyAcquisitionIds"])
                    this.surveyAcquisitionIds!.push(item);
            }
            this.tapeId = _data["tapeId"];
            this.surveyDataTypeId = _data["surveyDataTypeId"];
            this.surveyDataType = _data["surveyDataType"];
            this.inlineRange = _data["inlineRange"];
            this.crossLineRange = _data["crossLineRange"];
            this.surveyDataDataFormatId = _data["surveyDataDataFormatId"];
            this.surveyDataMediaTypeId = _data["surveyDataMediaTypeId"];
            this.surveyDataTitle = _data["surveyDataTitle"];
            this.remarks = _data["remarks"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.qcRemarks = _data["qcRemarks"];
            this.surveyDataConditionStatusId = _data["surveyDataConditionStatusId"];
            this.surveyDataLoanStatusId = _data["surveyDataLoanStatusId"];
            this.surveyDataCopyStatusId = _data["surveyDataCopyStatusId"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.surveyDataRddsStatusId = _data["surveyDataRddsStatusId"];
            this.surveyDataDataStatusId = _data["surveyDataDataStatusId"];
            this.rddsComments = _data["rddsComments"];
            this.companyId = _data["companyId"];
            this.consignment = _data["consignment"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.writtenDateOffset = _data["writtenDateOffset"];
            this.contractorId = _data["contractorId"];
            this.basicInterpType = _data["basicInterpType"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicRelevantDateOffset = _data["basicRelevantDateOffset"];
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDateOffset = _data["interpRelevantDateOffset"];
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.releasedDateOffset = _data["releasedDateOffset"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["isConfidential"] = this.isConfidential;
        if (Array.isArray(this.surveyAcquisitionIds)) {
            data["surveyAcquisitionIds"] = [];
            for (let item of this.surveyAcquisitionIds)
                data["surveyAcquisitionIds"].push(item);
        }
        data["tapeId"] = this.tapeId;
        data["surveyDataTypeId"] = this.surveyDataTypeId;
        data["surveyDataType"] = this.surveyDataType;
        data["inlineRange"] = this.inlineRange;
        data["crossLineRange"] = this.crossLineRange;
        data["surveyDataDataFormatId"] = this.surveyDataDataFormatId;
        data["surveyDataMediaTypeId"] = this.surveyDataMediaTypeId;
        data["surveyDataTitle"] = this.surveyDataTitle;
        data["remarks"] = this.remarks;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["qcRemarks"] = this.qcRemarks;
        data["surveyDataConditionStatusId"] = this.surveyDataConditionStatusId;
        data["surveyDataLoanStatusId"] = this.surveyDataLoanStatusId;
        data["surveyDataCopyStatusId"] = this.surveyDataCopyStatusId;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["surveyDataRddsStatusId"] = this.surveyDataRddsStatusId;
        data["surveyDataDataStatusId"] = this.surveyDataDataStatusId;
        data["rddsComments"] = this.rddsComments;
        data["companyId"] = this.companyId;
        data["consignment"] = this.consignment;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["writtenDateOffset"] = this.writtenDateOffset;
        data["contractorId"] = this.contractorId;
        data["basicInterpType"] = this.basicInterpType;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicRelevantDateOffset"] = this.basicRelevantDateOffset;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDateOffset"] = this.interpRelevantDateOffset;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["releasedDateOffset"] = this.releasedDateOffset;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataRequestDto {
    itemId?: string | undefined;
    isConfidential: boolean;
    surveyAcquisitionIds: number[];
    tapeId?: string | undefined;
    surveyDataTypeId: number;
    surveyDataType?: string | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;
    surveyDataDataFormatId?: number | undefined;
    surveyDataMediaTypeId?: number | undefined;
    surveyDataTitle?: string | undefined;
    remarks?: string | undefined;
    confidentialityRemarks?: string | undefined;
    qcRemarks?: string | undefined;
    surveyDataConditionStatusId?: number | undefined;
    surveyDataLoanStatusId?: number | undefined;
    surveyDataCopyStatusId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    surveyDataRddsStatusId?: number | undefined;
    surveyDataDataStatusId?: number | undefined;
    rddsComments?: string | undefined;
    companyId?: number | undefined;
    consignment?: string | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    contractorId?: number | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
}

export class CreateGeoscienceAustraliaSurveyDataResponseDto implements ICreateGeoscienceAustraliaSurveyDataResponseDto {
    surveyDataId?: number | undefined;
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateGeoscienceAustraliaSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveyDataResponseDto {
    surveyDataId?: number | undefined;
    statusMessages: StatusMessagesDto;
}

export class DeleteGeoscienceAustraliaSurveyDataRequestDto implements IDeleteGeoscienceAustraliaSurveyDataRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
}

export class DeleteGeoscienceAustraliaSurveyDataResponseDto implements IDeleteGeoscienceAustraliaSurveyDataResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveyDataResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto {
    relatedActivityType?: CreateSurveyDataRelatedActivityTypeEnum | undefined;
    relatedActivityId?: number | undefined;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedActivityType = _data["relatedActivityType"];
            this.relatedActivityId = _data["relatedActivityId"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedActivityType"] = this.relatedActivityType;
        data["relatedActivityId"] = this.relatedActivityId;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataRequestDto {
    relatedActivityType?: CreateSurveyDataRelatedActivityTypeEnum | undefined;
    relatedActivityId?: number | undefined;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto {
    id!: number;
    name!: string;
    value!: BasicInterpTypeEnum;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto {
    id: number;
    name: string;
    value: BasicInterpTypeEnum;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto {
    surveyAcquisitions!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto[];
    surveyDataTypes!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto[];
    basicInterpTypes!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto[];
    contractorCompanies!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto[];
    surveyDataDataFormats!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto[];
    surveyDataMediaTypes!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto[];
    surveyDataConditionStatuses!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto[];
    surveyDataCopyStatuses!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto[];
    surveyDataLoanStatuses!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto[];
    surveyDataRddsStatuses!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto[];
    surveyDataDataStatuses!: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto[];

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
            this.surveyDataTypes = [];
            this.basicInterpTypes = [];
            this.contractorCompanies = [];
            this.surveyDataDataFormats = [];
            this.surveyDataMediaTypes = [];
            this.surveyDataConditionStatuses = [];
            this.surveyDataCopyStatuses = [];
            this.surveyDataLoanStatuses = [];
            this.surveyDataRddsStatuses = [];
            this.surveyDataDataStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataTypes"])) {
                this.surveyDataTypes = [] as any;
                for (let item of _data["surveyDataTypes"])
                    this.surveyDataTypes!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["basicInterpTypes"])) {
                this.basicInterpTypes = [] as any;
                for (let item of _data["basicInterpTypes"])
                    this.basicInterpTypes!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["contractorCompanies"])) {
                this.contractorCompanies = [] as any;
                for (let item of _data["contractorCompanies"])
                    this.contractorCompanies!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataDataFormats"])) {
                this.surveyDataDataFormats = [] as any;
                for (let item of _data["surveyDataDataFormats"])
                    this.surveyDataDataFormats!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataMediaTypes"])) {
                this.surveyDataMediaTypes = [] as any;
                for (let item of _data["surveyDataMediaTypes"])
                    this.surveyDataMediaTypes!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataConditionStatuses"])) {
                this.surveyDataConditionStatuses = [] as any;
                for (let item of _data["surveyDataConditionStatuses"])
                    this.surveyDataConditionStatuses!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataCopyStatuses"])) {
                this.surveyDataCopyStatuses = [] as any;
                for (let item of _data["surveyDataCopyStatuses"])
                    this.surveyDataCopyStatuses!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataLoanStatuses"])) {
                this.surveyDataLoanStatuses = [] as any;
                for (let item of _data["surveyDataLoanStatuses"])
                    this.surveyDataLoanStatuses!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataRddsStatuses"])) {
                this.surveyDataRddsStatuses = [] as any;
                for (let item of _data["surveyDataRddsStatuses"])
                    this.surveyDataRddsStatuses!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyDataDataStatuses"])) {
                this.surveyDataDataStatuses = [] as any;
                for (let item of _data["surveyDataDataStatuses"])
                    this.surveyDataDataStatuses!.push(GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataTypes)) {
            data["surveyDataTypes"] = [];
            for (let item of this.surveyDataTypes)
                data["surveyDataTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.basicInterpTypes)) {
            data["basicInterpTypes"] = [];
            for (let item of this.basicInterpTypes)
                data["basicInterpTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contractorCompanies)) {
            data["contractorCompanies"] = [];
            for (let item of this.contractorCompanies)
                data["contractorCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataDataFormats)) {
            data["surveyDataDataFormats"] = [];
            for (let item of this.surveyDataDataFormats)
                data["surveyDataDataFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataMediaTypes)) {
            data["surveyDataMediaTypes"] = [];
            for (let item of this.surveyDataMediaTypes)
                data["surveyDataMediaTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataConditionStatuses)) {
            data["surveyDataConditionStatuses"] = [];
            for (let item of this.surveyDataConditionStatuses)
                data["surveyDataConditionStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataCopyStatuses)) {
            data["surveyDataCopyStatuses"] = [];
            for (let item of this.surveyDataCopyStatuses)
                data["surveyDataCopyStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataLoanStatuses)) {
            data["surveyDataLoanStatuses"] = [];
            for (let item of this.surveyDataLoanStatuses)
                data["surveyDataLoanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataRddsStatuses)) {
            data["surveyDataRddsStatuses"] = [];
            for (let item of this.surveyDataRddsStatuses)
                data["surveyDataRddsStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyDataDataStatuses)) {
            data["surveyDataDataStatuses"] = [];
            for (let item of this.surveyDataDataStatuses)
                data["surveyDataDataStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseDto {
    surveyAcquisitions: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto[];
    surveyDataTypes: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto[];
    basicInterpTypes: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseBasicInterpTypeDto[];
    contractorCompanies: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseContractorCompaniesDto[];
    surveyDataDataFormats: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto[];
    surveyDataMediaTypes: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto[];
    surveyDataConditionStatuses: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto[];
    surveyDataCopyStatuses: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto[];
    surveyDataLoanStatuses: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto[];
    surveyDataRddsStatuses: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto[];
    surveyDataDataStatuses: GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto[];
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyAcquisitionDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataCopyStatusDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataFormatDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataDataStatusDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataMediaTypeDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataRddsStatusDto {
    id: number;
    name: string;
}

export class GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto implements IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateGeoscienceAustraliaSurveyDataReferenceDataResponseSurveyDataTypeDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes {
    id!: number;
    name!: string;
    value!: BasicInterpTypeEnum;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes {
    id: number;
    name: string;
    value: BasicInterpTypeEnum;
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto {
    surveyDataTypes!: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType[];
    basicInterpTypes!: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes[];
    contractorCompanies!: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies[];

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyDataTypes = [];
            this.basicInterpTypes = [];
            this.contractorCompanies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyDataTypes"])) {
                this.surveyDataTypes = [] as any;
                for (let item of _data["surveyDataTypes"])
                    this.surveyDataTypes!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType.fromJS(item));
            }
            if (Array.isArray(_data["basicInterpTypes"])) {
                this.basicInterpTypes = [] as any;
                for (let item of _data["basicInterpTypes"])
                    this.basicInterpTypes!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes.fromJS(item));
            }
            if (Array.isArray(_data["contractorCompanies"])) {
                this.contractorCompanies = [] as any;
                for (let item of _data["contractorCompanies"])
                    this.contractorCompanies!.push(GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyDataTypes)) {
            data["surveyDataTypes"] = [];
            for (let item of this.surveyDataTypes)
                data["surveyDataTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.basicInterpTypes)) {
            data["basicInterpTypes"] = [];
            for (let item of this.basicInterpTypes)
                data["basicInterpTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contractorCompanies)) {
            data["contractorCompanies"] = [];
            for (let item of this.contractorCompanies)
                data["contractorCompanies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataResponseDto {
    surveyDataTypes: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType[];
    basicInterpTypes: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataBasicInterpTypes[];
    contractorCompanies: GetGeoscienceAustraliaSurveyDataDetailsReferenceDataContractorCompanies[];
}

export class GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType implements IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsReferenceDataSurveyDataType {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveyDataDetailsRequestDto implements IGetGeoscienceAustraliaSurveyDataDetailsRequestDto {
    surveyDataId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsRequestDto {
    surveyDataId: number;
}

export class GetGeoscienceAustraliaSurveyDataDetailsResponseDto implements IGetGeoscienceAustraliaSurveyDataDetailsResponseDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    surveyDataHeader?: string | undefined;
    title?: string | undefined;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    itemId?: string | undefined;
    surveyDataTypeId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential?: boolean | undefined;
    tapeId?: string | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    receivedDate?: Date | undefined;
    writtenDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpRelevantDate?: Date | undefined;
    releasedDate?: Date | undefined;
    companyId?: number | undefined;
    contractorId?: number | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;
    surveyDataAuditDto?: SimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.surveyDataHeader = _data["surveyDataHeader"];
            this.title = _data["title"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.itemId = _data["itemId"];
            this.surveyDataTypeId = _data["surveyDataTypeId"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.isConfidential = _data["isConfidential"];
            this.tapeId = _data["tapeId"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.basicInterpType = _data["basicInterpType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.contractorId = _data["contractorId"];
            this.inlineRange = _data["inlineRange"];
            this.crossLineRange = _data["crossLineRange"];
            this.surveyDataAuditDto = _data["surveyDataAuditDto"] ? SimpleAuditEventsDto.fromJS(_data["surveyDataAuditDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["surveyDataHeader"] = this.surveyDataHeader;
        data["title"] = this.title;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["itemId"] = this.itemId;
        data["surveyDataTypeId"] = this.surveyDataTypeId;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["isConfidential"] = this.isConfidential;
        data["tapeId"] = this.tapeId;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["basicInterpType"] = this.basicInterpType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["contractorId"] = this.contractorId;
        data["inlineRange"] = this.inlineRange;
        data["crossLineRange"] = this.crossLineRange;
        data["surveyDataAuditDto"] = this.surveyDataAuditDto ? this.surveyDataAuditDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataDetailsResponseDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    surveyDataHeader?: string | undefined;
    title?: string | undefined;
    publicTitle?: string | undefined;
    isPublic: boolean;
    itemId?: string | undefined;
    surveyDataTypeId?: number | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential?: boolean | undefined;
    tapeId?: string | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    receivedDate?: Date | undefined;
    writtenDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpRelevantDate?: Date | undefined;
    releasedDate?: Date | undefined;
    companyId?: number | undefined;
    contractorId?: number | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;
    surveyDataAuditDto?: SimpleAuditEventsDto | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataDetailsRequestDto implements IUpdateGeoscienceAustraliaSurveyDataDetailsRequestDto {
    surveyDataId!: number;
    surveyDataVersionNumber!: number;
    title?: string | undefined;
    itemId?: string | undefined;
    surveyDataTypeId?: number | undefined;
    surveyDataType?: string | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential!: boolean;
    tapeId?: string | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
    companyId?: number | undefined;
    contractorId?: number | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyDataId = _data["surveyDataId"];
            this.surveyDataVersionNumber = _data["surveyDataVersionNumber"];
            this.title = _data["title"];
            this.itemId = _data["itemId"];
            this.surveyDataTypeId = _data["surveyDataTypeId"];
            this.surveyDataType = _data["surveyDataType"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.isConfidential = _data["isConfidential"];
            this.tapeId = _data["tapeId"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.basicInterpType = _data["basicInterpType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.writtenDateOffset = _data["writtenDateOffset"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicRelevantDateOffset = _data["basicRelevantDateOffset"];
            this.interpRelevantDate = _data["interpRelevantDate"] ? new Date(_data["interpRelevantDate"].toString()) : <any>undefined;
            this.interpRelevantDateOffset = _data["interpRelevantDateOffset"];
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.releasedDateOffset = _data["releasedDateOffset"];
            this.companyId = _data["companyId"];
            this.contractorId = _data["contractorId"];
            this.inlineRange = _data["inlineRange"];
            this.crossLineRange = _data["crossLineRange"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDataId"] = this.surveyDataId;
        data["surveyDataVersionNumber"] = this.surveyDataVersionNumber;
        data["title"] = this.title;
        data["itemId"] = this.itemId;
        data["surveyDataTypeId"] = this.surveyDataTypeId;
        data["surveyDataType"] = this.surveyDataType;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["isConfidential"] = this.isConfidential;
        data["tapeId"] = this.tapeId;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["basicInterpType"] = this.basicInterpType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["writtenDateOffset"] = this.writtenDateOffset;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicRelevantDateOffset"] = this.basicRelevantDateOffset;
        data["interpRelevantDate"] = this.interpRelevantDate ? this.interpRelevantDate.toISOString() : <any>undefined;
        data["interpRelevantDateOffset"] = this.interpRelevantDateOffset;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["releasedDateOffset"] = this.releasedDateOffset;
        data["companyId"] = this.companyId;
        data["contractorId"] = this.contractorId;
        data["inlineRange"] = this.inlineRange;
        data["crossLineRange"] = this.crossLineRange;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataDetailsRequestDto {
    surveyDataId: number;
    surveyDataVersionNumber: number;
    title?: string | undefined;
    itemId?: string | undefined;
    surveyDataTypeId?: number | undefined;
    surveyDataType?: string | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential: boolean;
    tapeId?: string | undefined;
    confidentialityRemarks?: string | undefined;
    basicInterpType?: BasicInterpTypeEnum | undefined;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    writtenDate?: Date | undefined;
    writtenDateOffset?: number | undefined;
    basicRelevantDate?: Date | undefined;
    basicRelevantDateOffset?: number | undefined;
    interpRelevantDate?: Date | undefined;
    interpRelevantDateOffset?: number | undefined;
    releasedDate?: Date | undefined;
    releasedDateOffset?: number | undefined;
    companyId?: number | undefined;
    contractorId?: number | undefined;
    inlineRange?: string | undefined;
    crossLineRange?: string | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto implements IUpdateGeoscienceAustraliaSurveyDataDetailsResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataDetailsResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ExportGeoscienceAustraliaSurveyDataRequestDto implements IExportGeoscienceAustraliaSurveyDataRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IExportGeoscienceAustraliaSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportGeoscienceAustraliaSurveyDataRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class ExportGeoscienceAustraliaSurveyDataResponseDto implements IExportGeoscienceAustraliaSurveyDataResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;

    constructor(data?: IExportGeoscienceAustraliaSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        return data;
    }
}

export interface IExportGeoscienceAustraliaSurveyDataResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
}

export class GetGeoscienceAustraliaSurveyDataListItemDto implements IGetGeoscienceAustraliaSurveyDataListItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    title!: string;
    publicTitle?: string | undefined;
    isPublic!: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    numberOfMappings!: number;
    numberOfAttachments!: number;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    consignment!: string;
    relatedActivities?: GetGeoscienceAustraliaSurveyDataListRelatedActivityDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.title = _data["title"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.dataType = _data["dataType"];
            this.tapeId = _data["tapeId"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.numberOfMappings = _data["numberOfMappings"];
            this.numberOfAttachments = _data["numberOfAttachments"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
            this.consignment = _data["consignment"];
            if (Array.isArray(_data["relatedActivities"])) {
                this.relatedActivities = [] as any;
                for (let item of _data["relatedActivities"])
                    this.relatedActivities!.push(GetGeoscienceAustraliaSurveyDataListRelatedActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["title"] = this.title;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["dataType"] = this.dataType;
        data["tapeId"] = this.tapeId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["numberOfMappings"] = this.numberOfMappings;
        data["numberOfAttachments"] = this.numberOfAttachments;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        data["consignment"] = this.consignment;
        if (Array.isArray(this.relatedActivities)) {
            data["relatedActivities"] = [];
            for (let item of this.relatedActivities)
                data["relatedActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    title: string;
    publicTitle?: string | undefined;
    isPublic: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    numberOfMappings: number;
    numberOfAttachments: number;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    consignment: string;
    relatedActivities?: GetGeoscienceAustraliaSurveyDataListRelatedActivityDto[] | undefined;
}

export class GetGeoscienceAustraliaSurveyDataListPermissionDto implements IGetGeoscienceAustraliaSurveyDataListPermissionDto {
    canViewBoreholes!: boolean;
    canViewAcquisitions!: boolean;
    canViewProjects!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewProjects = _data["canViewProjects"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewProjects"] = this.canViewProjects;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListPermissionDto {
    canViewBoreholes: boolean;
    canViewAcquisitions: boolean;
    canViewProjects: boolean;
}

export class GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto implements IGetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto implements IGetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto implements IGetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto {

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListReferenceDataRequestDto {
}

export class GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto implements IGetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto {
    wells!: AdvancedSearchReferenceDataWellDto[];
    wellBoreholes!: AdvancedSearchReferenceDataWellBoreholeDto[];
    surveys!: AdvancedSearchReferenceDataSurveyDto[];
    acquisitions!: AdvancedSearchReferenceDataAcquisitionDto[];
    reprocessings!: AdvancedSearchReferenceDataReprocessingDto[];
    projects!: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos!: AdvancedSearchReferenceDataEnoDto[];
    advancedSearchTypes!: AdvancedSearchTypeDto[];
    advancedSearchOperations!: AdvancedSearchOperationDto[];
    loanStatuses!: GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wells = [];
            this.wellBoreholes = [];
            this.surveys = [];
            this.acquisitions = [];
            this.reprocessings = [];
            this.projects = [];
            this.enos = [];
            this.advancedSearchTypes = [];
            this.advancedSearchOperations = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wells"])) {
                this.wells = [] as any;
                for (let item of _data["wells"])
                    this.wells!.push(AdvancedSearchReferenceDataWellDto.fromJS(item));
            }
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(AdvancedSearchReferenceDataWellBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(AdvancedSearchReferenceDataSurveyDto.fromJS(item));
            }
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(AdvancedSearchReferenceDataAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["reprocessings"])) {
                this.reprocessings = [] as any;
                for (let item of _data["reprocessings"])
                    this.reprocessings!.push(AdvancedSearchReferenceDataReprocessingDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(AdvancedSearchReferenceDataReprocessingProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["enos"])) {
                this.enos = [] as any;
                for (let item of _data["enos"])
                    this.enos!.push(AdvancedSearchReferenceDataEnoDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchTypes"])) {
                this.advancedSearchTypes = [] as any;
                for (let item of _data["advancedSearchTypes"])
                    this.advancedSearchTypes!.push(AdvancedSearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["advancedSearchOperations"])) {
                this.advancedSearchOperations = [] as any;
                for (let item of _data["advancedSearchOperations"])
                    this.advancedSearchOperations!.push(AdvancedSearchOperationDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wells)) {
            data["wells"] = [];
            for (let item of this.wells)
                data["wells"].push(item.toJSON());
        }
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.reprocessings)) {
            data["reprocessings"] = [];
            for (let item of this.reprocessings)
                data["reprocessings"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.enos)) {
            data["enos"] = [];
            for (let item of this.enos)
                data["enos"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchTypes)) {
            data["advancedSearchTypes"] = [];
            for (let item of this.advancedSearchTypes)
                data["advancedSearchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedSearchOperations)) {
            data["advancedSearchOperations"] = [];
            for (let item of this.advancedSearchOperations)
                data["advancedSearchOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListReferenceDataResponseDto {
    wells: AdvancedSearchReferenceDataWellDto[];
    wellBoreholes: AdvancedSearchReferenceDataWellBoreholeDto[];
    surveys: AdvancedSearchReferenceDataSurveyDto[];
    acquisitions: AdvancedSearchReferenceDataAcquisitionDto[];
    reprocessings: AdvancedSearchReferenceDataReprocessingDto[];
    projects: AdvancedSearchReferenceDataReprocessingProjectDto[];
    enos: AdvancedSearchReferenceDataEnoDto[];
    advancedSearchTypes: AdvancedSearchTypeDto[];
    advancedSearchOperations: AdvancedSearchOperationDto[];
    loanStatuses: GetGeoscienceAustraliaSurveyDataListReferenceDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaSurveyDataListReferenceDataConditionStatusDto[];
}

export class GetGeoscienceAustraliaSurveyDataListRelatedActivityDto implements IGetGeoscienceAustraliaSurveyDataListRelatedActivityDto {
    type!: RelatedActivityEnum;
    relatedActivityParentId!: number;
    relatedActivityId!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    selectedInAdvancedSearch!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListRelatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.relatedActivityParentId = _data["relatedActivityParentId"];
            this.relatedActivityId = _data["relatedActivityId"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.selectedInAdvancedSearch = _data["selectedInAdvancedSearch"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListRelatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListRelatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["relatedActivityParentId"] = this.relatedActivityParentId;
        data["relatedActivityId"] = this.relatedActivityId;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["selectedInAdvancedSearch"] = this.selectedInAdvancedSearch;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListRelatedActivityDto {
    type: RelatedActivityEnum;
    relatedActivityParentId: number;
    relatedActivityId: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    selectedInAdvancedSearch: boolean;
}

export class GetGeoscienceAustraliaSurveyDataListRequestDto implements IGetGeoscienceAustraliaSurveyDataListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterFullTextSearch = _data["filterFullTextSearch"];
            if (Array.isArray(_data["advancedFilters"])) {
                this.advancedFilters = [] as any;
                for (let item of _data["advancedFilters"])
                    this.advancedFilters!.push(SearchAdvancedFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterFullTextSearch"] = this.filterFullTextSearch;
        if (Array.isArray(this.advancedFilters)) {
            data["advancedFilters"] = [];
            for (let item of this.advancedFilters)
                data["advancedFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListRequestDto {
    filterFullTextSearch?: string | undefined;
    advancedFilters?: SearchAdvancedFilterDto[] | undefined;
}

export class GetGeoscienceAustraliaSurveyDataListResponseDto implements IGetGeoscienceAustraliaSurveyDataListResponseDto {
    items!: GetGeoscienceAustraliaSurveyDataListItemDto[];
    permissions!: GetGeoscienceAustraliaSurveyDataListPermissionDto;
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveyDataListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.permissions = new GetGeoscienceAustraliaSurveyDataListPermissionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveyDataListItemDto.fromJS(item));
            }
            this.permissions = _data["permissions"] ? GetGeoscienceAustraliaSurveyDataListPermissionDto.fromJS(_data["permissions"]) : new GetGeoscienceAustraliaSurveyDataListPermissionDto();
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveyDataListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveyDataListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveyDataListResponseDto {
    items: GetGeoscienceAustraliaSurveyDataListItemDto[];
    permissions: GetGeoscienceAustraliaSurveyDataListPermissionDto;
    isResultSetLimited: boolean;
}

export class ImportGeoscienceAustraliaSurveyDataRequestDto implements IImportGeoscienceAustraliaSurveyDataRequestDto {
    fileName?: string | undefined;
    fileContent?: string | undefined;

    constructor(data?: IImportGeoscienceAustraliaSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IImportGeoscienceAustraliaSurveyDataRequestDto {
    fileName?: string | undefined;
    fileContent?: string | undefined;
}

export class ImportGeoscienceAustraliaSurveyDataResponseDto implements IImportGeoscienceAustraliaSurveyDataResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IImportGeoscienceAustraliaSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ImportGeoscienceAustraliaSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportGeoscienceAustraliaSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportGeoscienceAustraliaSurveyDataResponseDto {
    statusMessages: StatusMessagesDto;
}

export class UpdateGeoscienceAustraliaSurveyDataBatchRequestDto implements IUpdateGeoscienceAustraliaSurveyDataBatchRequestDto {
    surveyData?: UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: SurveyDataStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: SurveyDataStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataBatchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyData"])) {
                this.surveyData = [] as any;
                for (let item of _data["surveyData"])
                    this.surveyData!.push(UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataBatchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataBatchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyData)) {
            data["surveyData"] = [];
            for (let item of this.surveyData)
                data["surveyData"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataBatchRequestDto {
    surveyData?: UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: SurveyDataStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: SurveyDataStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataBatchResponseDto implements IUpdateGeoscienceAustraliaSurveyDataBatchResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataBatchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedSurveyDataIds"])) {
                this.failedSurveyDataIds = [] as any;
                for (let item of _data["failedSurveyDataIds"])
                    this.failedSurveyDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataBatchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataBatchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedSurveyDataIds)) {
            data["failedSurveyDataIds"] = [];
            for (let item of this.failedSurveyDataIds)
                data["failedSurveyDataIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataBatchResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;
}

export class UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto implements IUpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: IUpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveyDataBatchSurveyDataIdDto {
    id: number;
    versionNumber: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto {
    surveyId!: number;
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsRequestDto {
    surveyId: number;
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;
    acquisitionType!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
            this.acquisitionType = _data["acquisitionType"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        data["acquisitionType"] = this.acquisitionType;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
    acquisitionType: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto {
    surveyId!: number;
    acquisitionId!: number;
    surveyName!: string;
    acquisitionName!: string;
    isPublic!: boolean;
    items!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto[];
    canViewSurveys!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
            this.surveyName = _data["surveyName"];
            this.acquisitionName = _data["acquisitionName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto.fromJS(item));
            }
            this.canViewSurveys = _data["canViewSurveys"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        data["surveyName"] = this.surveyName;
        data["acquisitionName"] = this.acquisitionName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewSurveys"] = this.canViewSurveys;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDto {
    surveyId: number;
    acquisitionId: number;
    surveyName: string;
    acquisitionName: string;
    isPublic: boolean;
    items: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto[];
    canViewSurveys: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemDto;
    dataMonitoringItemType: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDataMonitoringItemsResponseResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto {
    surveyId!: number;
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsRequestDto {
    surveyId: number;
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto {
    isConfidential!: boolean;
    isSystemConfidential!: boolean;
    isUserOverridden!: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    confidentialityAudit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.confidentialityAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConfidential = _data["isConfidential"];
            this.isSystemConfidential = _data["isSystemConfidential"];
            this.isUserOverridden = _data["isUserOverridden"];
            this.isUserConfidential = _data["isUserConfidential"];
            this.comments = _data["comments"];
            this.confidentialityAudit = _data["confidentialityAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["confidentialityAudit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConfidential"] = this.isConfidential;
        data["isSystemConfidential"] = this.isSystemConfidential;
        data["isUserOverridden"] = this.isUserOverridden;
        data["isUserConfidential"] = this.isUserConfidential;
        data["comments"] = this.comments;
        data["confidentialityAudit"] = this.confidentialityAudit ? this.confidentialityAudit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto {
    isConfidential: boolean;
    isSystemConfidential: boolean;
    isUserOverridden: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    confidentialityAudit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto {
    acquisitionId!: number;
    surveyId!: number;
    surveyIdentifier!: string;
    surveyName!: string;
    surveyOperatorCompany?: string | undefined;
    surveyTitleConditions!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    acquisitionIdentifier!: string;
    acquisitionName!: string;
    acquisitionAlias?: string | undefined;
    acquisitionStatus?: string | undefined;
    acquisitionType?: string | undefined;
    linePrefix?: string | undefined;
    authorisingTitles!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    titlesCoverage!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    terrainType?: string | undefined;
    contractor?: string | undefined;
    vessel?: string | undefined;
    nopimsExclusivityStatus?: string | undefined;
    titleAdministrationType?: string | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    totalLineLength?: number | undefined;
    areaSqKms?: number | undefined;
    fullFoldTotalLineLength?: number | undefined;
    fullFoldAreaSqKms?: number | undefined;
    isAutoCalculateDates!: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2dRelevantDate?: Date | undefined;
    subset2dReleaseDate?: Date | undefined;
    confidentiality!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto;
    acquisitionAudit!: SecurePortalSimpleAuditEventsDto;
    isPublic!: boolean;
    isNeverPublicUserOverride!: boolean;
    neverPublicUserOverrideComments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyTitleConditions = [];
            this.authorisingTitles = [];
            this.titlesCoverage = [];
            this.confidentiality = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto();
            this.acquisitionAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
            this.surveyId = _data["surveyId"];
            this.surveyIdentifier = _data["surveyIdentifier"];
            this.surveyName = _data["surveyName"];
            this.surveyOperatorCompany = _data["surveyOperatorCompany"];
            if (Array.isArray(_data["surveyTitleConditions"])) {
                this.surveyTitleConditions = [] as any;
                for (let item of _data["surveyTitleConditions"])
                    this.surveyTitleConditions!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto.fromJS(item));
            }
            this.acquisitionIdentifier = _data["acquisitionIdentifier"];
            this.acquisitionName = _data["acquisitionName"];
            this.acquisitionAlias = _data["acquisitionAlias"];
            this.acquisitionStatus = _data["acquisitionStatus"];
            this.acquisitionType = _data["acquisitionType"];
            this.linePrefix = _data["linePrefix"];
            if (Array.isArray(_data["authorisingTitles"])) {
                this.authorisingTitles = [] as any;
                for (let item of _data["authorisingTitles"])
                    this.authorisingTitles!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["titlesCoverage"])) {
                this.titlesCoverage = [] as any;
                for (let item of _data["titlesCoverage"])
                    this.titlesCoverage!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto.fromJS(item));
            }
            this.terrainType = _data["terrainType"];
            this.contractor = _data["contractor"];
            this.vessel = _data["vessel"];
            this.nopimsExclusivityStatus = _data["nopimsExclusivityStatus"];
            this.titleAdministrationType = _data["titleAdministrationType"];
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.totalLineLength = _data["totalLineLength"];
            this.areaSqKms = _data["areaSqKms"];
            this.fullFoldTotalLineLength = _data["fullFoldTotalLineLength"];
            this.fullFoldAreaSqKms = _data["fullFoldAreaSqKms"];
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.subset2dRelevantDate = _data["subset2dRelevantDate"] ? new Date(_data["subset2dRelevantDate"].toString()) : <any>undefined;
            this.subset2dReleaseDate = _data["subset2dReleaseDate"] ? new Date(_data["subset2dReleaseDate"].toString()) : <any>undefined;
            this.confidentiality = _data["confidentiality"] ? GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto.fromJS(_data["confidentiality"]) : new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto();
            this.acquisitionAudit = _data["acquisitionAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["acquisitionAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.isPublic = _data["isPublic"];
            this.isNeverPublicUserOverride = _data["isNeverPublicUserOverride"];
            this.neverPublicUserOverrideComments = _data["neverPublicUserOverrideComments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        data["surveyId"] = this.surveyId;
        data["surveyIdentifier"] = this.surveyIdentifier;
        data["surveyName"] = this.surveyName;
        data["surveyOperatorCompany"] = this.surveyOperatorCompany;
        if (Array.isArray(this.surveyTitleConditions)) {
            data["surveyTitleConditions"] = [];
            for (let item of this.surveyTitleConditions)
                data["surveyTitleConditions"].push(item.toJSON());
        }
        data["acquisitionIdentifier"] = this.acquisitionIdentifier;
        data["acquisitionName"] = this.acquisitionName;
        data["acquisitionAlias"] = this.acquisitionAlias;
        data["acquisitionStatus"] = this.acquisitionStatus;
        data["acquisitionType"] = this.acquisitionType;
        data["linePrefix"] = this.linePrefix;
        if (Array.isArray(this.authorisingTitles)) {
            data["authorisingTitles"] = [];
            for (let item of this.authorisingTitles)
                data["authorisingTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.titlesCoverage)) {
            data["titlesCoverage"] = [];
            for (let item of this.titlesCoverage)
                data["titlesCoverage"].push(item.toJSON());
        }
        data["terrainType"] = this.terrainType;
        data["contractor"] = this.contractor;
        data["vessel"] = this.vessel;
        data["nopimsExclusivityStatus"] = this.nopimsExclusivityStatus;
        data["titleAdministrationType"] = this.titleAdministrationType;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["totalLineLength"] = this.totalLineLength;
        data["areaSqKms"] = this.areaSqKms;
        data["fullFoldTotalLineLength"] = this.fullFoldTotalLineLength;
        data["fullFoldAreaSqKms"] = this.fullFoldAreaSqKms;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["subset2dRelevantDate"] = this.subset2dRelevantDate ? this.subset2dRelevantDate.toISOString() : <any>undefined;
        data["subset2dReleaseDate"] = this.subset2dReleaseDate ? this.subset2dReleaseDate.toISOString() : <any>undefined;
        data["confidentiality"] = this.confidentiality ? this.confidentiality.toJSON() : <any>undefined;
        data["acquisitionAudit"] = this.acquisitionAudit ? this.acquisitionAudit.toJSON() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["isNeverPublicUserOverride"] = this.isNeverPublicUserOverride;
        data["neverPublicUserOverrideComments"] = this.neverPublicUserOverrideComments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseDto {
    acquisitionId: number;
    surveyId: number;
    surveyIdentifier: string;
    surveyName: string;
    surveyOperatorCompany?: string | undefined;
    surveyTitleConditions: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    acquisitionIdentifier: string;
    acquisitionName: string;
    acquisitionAlias?: string | undefined;
    acquisitionStatus?: string | undefined;
    acquisitionType?: string | undefined;
    linePrefix?: string | undefined;
    authorisingTitles: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    titlesCoverage: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto[];
    terrainType?: string | undefined;
    contractor?: string | undefined;
    vessel?: string | undefined;
    nopimsExclusivityStatus?: string | undefined;
    titleAdministrationType?: string | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    totalLineLength?: number | undefined;
    areaSqKms?: number | undefined;
    fullFoldTotalLineLength?: number | undefined;
    fullFoldAreaSqKms?: number | undefined;
    isAutoCalculateDates: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2dRelevantDate?: Date | undefined;
    subset2dReleaseDate?: Date | undefined;
    confidentiality: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseConfidentialityDto;
    acquisitionAudit: SecurePortalSimpleAuditEventsDto;
    isPublic: boolean;
    isNeverPublicUserOverride: boolean;
    neverPublicUserOverrideComments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto {
    nopimsTitleType!: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionDetailsResponseTitleDto {
    nopimsTitleType: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto {
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListRequestDto {
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto {
    acquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseDto {
    acquisitions: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto {
    surveyId!: number;
    surveyName?: string | undefined;
    acquisitionId!: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic!: boolean;
    acquisitionStatus?: string | undefined;
    acquisitionType?: string | undefined;
    acquisitionContractor?: string | undefined;
    surveyOperatorCompany?: string | undefined;
    vessel?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionIdentifier = _data["acquisitionIdentifier"];
            this.acquisitionName = _data["acquisitionName"];
            this.isPublic = _data["isPublic"];
            this.acquisitionStatus = _data["acquisitionStatus"];
            this.acquisitionType = _data["acquisitionType"];
            this.acquisitionContractor = _data["acquisitionContractor"];
            this.surveyOperatorCompany = _data["surveyOperatorCompany"];
            this.vessel = _data["vessel"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionIdentifier"] = this.acquisitionIdentifier;
        data["acquisitionName"] = this.acquisitionName;
        data["isPublic"] = this.isPublic;
        data["acquisitionStatus"] = this.acquisitionStatus;
        data["acquisitionType"] = this.acquisitionType;
        data["acquisitionContractor"] = this.acquisitionContractor;
        data["surveyOperatorCompany"] = this.surveyOperatorCompany;
        data["vessel"] = this.vessel;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionListResponseItemDto {
    surveyId: number;
    surveyName?: string | undefined;
    acquisitionId: number;
    acquisitionIdentifier?: string | undefined;
    acquisitionName?: string | undefined;
    isPublic: boolean;
    acquisitionStatus?: string | undefined;
    acquisitionType?: string | undefined;
    acquisitionContractor?: string | undefined;
    surveyOperatorCompany?: string | undefined;
    vessel?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto {
    surveyId!: number;
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersRequestDto {
    surveyId: number;
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto {
    surveyId!: number;
    surveyName?: string | undefined;
    acquisitionId!: number;
    acquisitionName?: string | undefined;
    isPublic!: boolean;
    parameters!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto[];
    canViewSurvey!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.parameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionName = _data["acquisitionName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto.fromJS(item));
            }
            this.canViewSurvey = _data["canViewSurvey"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionName"] = this.acquisitionName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["canViewSurvey"] = this.canViewSurvey;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseDto {
    surveyId: number;
    surveyName?: string | undefined;
    acquisitionId: number;
    acquisitionName?: string | undefined;
    isPublic: boolean;
    parameters: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto[];
    canViewSurvey: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto {
    id!: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceType?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shotPointInterval = _data["shotPointInterval"];
            this.receiverGroupInterval = _data["receiverGroupInterval"];
            this.groupChannelCount = _data["groupChannelCount"];
            this.surveyEnergySourceType = _data["surveyEnergySourceType"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shotPointInterval"] = this.shotPointInterval;
        data["receiverGroupInterval"] = this.receiverGroupInterval;
        data["groupChannelCount"] = this.groupChannelCount;
        data["surveyEnergySourceType"] = this.surveyEnergySourceType;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionParametersResponseParameterDto {
    id: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceType?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto {
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsRequestDto {
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto {
    acquisitionId!: number;
    surveyId!: number;
    acquisitionName?: string | undefined;
    surveyName?: string | undefined;
    isPublic!: boolean;
    canViewSurvey!: boolean;
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
            this.surveyId = _data["surveyId"];
            this.acquisitionName = _data["acquisitionName"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            this.canViewSurvey = _data["canViewSurvey"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        data["surveyId"] = this.surveyId;
        data["acquisitionName"] = this.acquisitionName;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        data["canViewSurvey"] = this.canViewSurvey;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportAttachmentsResponseDto {
    acquisitionId: number;
    surveyId: number;
    acquisitionName?: string | undefined;
    surveyName?: string | undefined;
    isPublic: boolean;
    canViewSurvey: boolean;
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
    surveyId!: number;
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
    surveyId: number;
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
    acquisitionName!: string;
    surveyName!: string;
    isPublic!: boolean;
    canViewSurveys!: boolean;
    items!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto[];
    loanStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionName = _data["acquisitionName"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            this.canViewSurveys = _data["canViewSurveys"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionName"] = this.acquisitionName;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        data["canViewSurveys"] = this.canViewSurveys;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
    acquisitionName: string;
    surveyName: string;
    isPublic: boolean;
    canViewSurveys: boolean;
    items: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsItemDto[];
    loanStatuses: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsConditionStatusDto[];
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    title?: string | undefined;
    isPublic!: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.title = _data["title"];
            this.isPublic = _data["isPublic"];
            this.dataType = _data["dataType"];
            this.tapeId = _data["tapeId"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.consignment = _data["consignment"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["title"] = this.title;
        data["isPublic"] = this.isPublic;
        data["dataType"] = this.dataType;
        data["tapeId"] = this.tapeId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["consignment"] = this.consignment;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    title?: string | undefined;
    isPublic: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
    surveyId!: number;
    acquisitionId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.acquisitionId = _data["acquisitionId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["acquisitionId"] = this.acquisitionId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
    surveyId: number;
    acquisitionId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
    acquisitionName!: string;
    surveyName!: string;
    isPublic!: boolean;
    canViewSurveys!: boolean;
    items!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto[];
    loanStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionName = _data["acquisitionName"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            this.canViewSurveys = _data["canViewSurveys"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionName"] = this.acquisitionName;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        data["canViewSurveys"] = this.canViewSurveys;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
    acquisitionName: string;
    surveyName: string;
    isPublic: boolean;
    canViewSurveys: boolean;
    items: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataItemDto[];
    loanStatuses: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataConditionStatusDto[];
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
    surveyId!: number;
    surveyData?: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            if (Array.isArray(_data["surveyData"])) {
                this.surveyData = [] as any;
                for (let item of _data["surveyData"])
                    this.surveyData!.push(UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        if (Array.isArray(this.surveyData)) {
            data["surveyData"] = [];
            for (let item of this.surveyData)
                data["surveyData"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataRequestDto {
    surveyId: number;
    surveyData?: UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedSurveyDataIds"])) {
                this.failedSurveyDataIds = [] as any;
                for (let item of _data["failedSurveyDataIds"])
                    this.failedSurveyDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedSurveyDataIds)) {
            data["failedSurveyDataIds"] = [];
            for (let item of this.failedSurveyDataIds)
                data["failedSurveyDataIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsAcquisitionSurveyDataSurveyDataDto {
    versionNumber: number;
    id: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId!: number;
    name!: string;
    identifier!: string;
    surveyDetails!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto;
    duplicateDataMonitoringItems!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto | undefined;
    authorisations!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto[];
    status!: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewSurveys!: boolean;
    canViewAcquisitions!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyDetails = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto();
            this.duplicateDataMonitoringItems = [];
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.surveyDetails = _data["surveyDetails"] ? GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto.fromJS(_data["surveyDetails"]) : new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto();
            if (Array.isArray(_data["duplicateDataMonitoringItems"])) {
                this.duplicateDataMonitoringItems = [] as any;
                for (let item of _data["duplicateDataMonitoringItems"])
                    this.duplicateDataMonitoringItems!.push(GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto.fromJS(item));
            }
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto.fromJS(item));
            }
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.extensionDueDate = _data["extensionDueDate"] ? new Date(_data["extensionDueDate"].toString()) : <any>undefined;
            this.resubmissionDueDate = _data["resubmissionDueDate"] ? new Date(_data["resubmissionDueDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.canViewSurveys = _data["canViewSurveys"];
            this.canViewAcquisitions = _data["canViewAcquisitions"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["surveyDetails"] = this.surveyDetails ? this.surveyDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.duplicateDataMonitoringItems)) {
            data["duplicateDataMonitoringItems"] = [];
            for (let item of this.duplicateDataMonitoringItems)
                data["duplicateDataMonitoringItems"].push(item.toJSON());
        }
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["extensionDueDate"] = this.extensionDueDate ? this.extensionDueDate.toISOString() : <any>undefined;
        data["resubmissionDueDate"] = this.resubmissionDueDate ? this.resubmissionDueDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["canViewSurveys"] = this.canViewSurveys;
        data["canViewAcquisitions"] = this.canViewAcquisitions;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId: number;
    name: string;
    identifier: string;
    surveyDetails: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto;
    duplicateDataMonitoringItems: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDataSubmissionDto | undefined;
    authorisations: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto[];
    status: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewSurveys: boolean;
    canViewAcquisitions: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
    id!: number;
    identifier!: string;
    isInvalid!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.isInvalid = _data["isInvalid"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseDuplicateDataMonitoringItemDto {
    id: number;
    identifier: string;
    isInvalid: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseResubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto implements IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto {
    survey!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto;
    acquisition!: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto;
    acquisitionCalcDueDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.survey = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto();
            this.acquisition = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.survey = _data["survey"] ? GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto.fromJS(_data["survey"]) : new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto();
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto.fromJS(_data["acquisition"]) : new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto();
            this.acquisitionCalcDueDate = _data["acquisitionCalcDueDate"] ? new Date(_data["acquisitionCalcDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["acquisitionCalcDueDate"] = this.acquisitionCalcDueDate ? this.acquisitionCalcDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseSurveyDto {
    survey: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto;
    acquisition: GetGeoscienceAustraliaSurveysAcquisitionsDataMonitoringItemDetailsResponseReferenceDto;
    acquisitionCalcDueDate?: Date | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto {
    id!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    type?: string | undefined;
    status?: string | undefined;
    alias?: string | undefined;
    contractor?: string | undefined;
    vessel?: string | undefined;
    linePrefix?: string | undefined;
    titleCoverage!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];
    authorisingTitles!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];
    comments?: string | undefined;
    publicComments?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleCoverage = [];
            this.authorisingTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.alias = _data["alias"];
            this.contractor = _data["contractor"];
            this.vessel = _data["vessel"];
            this.linePrefix = _data["linePrefix"];
            if (Array.isArray(_data["titleCoverage"])) {
                this.titleCoverage = [] as any;
                for (let item of _data["titleCoverage"])
                    this.titleCoverage!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["authorisingTitles"])) {
                this.authorisingTitles = [] as any;
                for (let item of _data["authorisingTitles"])
                    this.authorisingTitles!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["type"] = this.type;
        data["status"] = this.status;
        data["alias"] = this.alias;
        data["contractor"] = this.contractor;
        data["vessel"] = this.vessel;
        data["linePrefix"] = this.linePrefix;
        if (Array.isArray(this.titleCoverage)) {
            data["titleCoverage"] = [];
            for (let item of this.titleCoverage)
                data["titleCoverage"].push(item.toJSON());
        }
        if (Array.isArray(this.authorisingTitles)) {
            data["authorisingTitles"] = [];
            for (let item of this.authorisingTitles)
                data["authorisingTitles"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto {
    id: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    type?: string | undefined;
    status?: string | undefined;
    alias?: string | undefined;
    contractor?: string | undefined;
    vessel?: string | undefined;
    linePrefix?: string | undefined;
    titleCoverage: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];
    authorisingTitles: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];
    comments?: string | undefined;
    publicComments?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto {
    surveyName!: string;
    isPublic!: boolean;
    acquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto[];
    surveyOperator?: string | undefined;
    titleConditions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
            this.titleConditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto.fromJS(item));
            }
            this.surveyOperator = _data["surveyOperator"];
            if (Array.isArray(_data["titleConditions"])) {
                this.titleConditions = [] as any;
                for (let item of _data["titleConditions"])
                    this.titleConditions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        data["surveyOperator"] = this.surveyOperator;
        if (Array.isArray(this.titleConditions)) {
            data["titleConditions"] = [];
            for (let item of this.titleConditions)
                data["titleConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseDto {
    surveyName: string;
    isPublic: boolean;
    acquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseAcquisitionDto[];
    surveyOperator?: string | undefined;
    titleConditions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto {
    nopimsTitleType!: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyAcquisitionsResponseTitleDto {
    nopimsTitleType: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto {
    surveyName!: string;
    isPublic!: boolean;
    surveyDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            this.surveyDataAuditChanges = _data["surveyDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["surveyDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        data["surveyDataAuditChanges"] = this.surveyDataAuditChanges ? this.surveyDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataAuditChangesResponseDto {
    surveyName: string;
    isPublic: boolean;
    surveyDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;
    acquisitionType!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
            this.acquisitionType = _data["acquisitionType"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        data["acquisitionType"] = this.acquisitionType;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
    acquisitionType: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto {
    surveyId!: number;
    surveyName?: string | undefined;
    isPublic!: boolean;
    acquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto[];
    items!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto[];
    canViewSurveyAcquisitions!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto.fromJS(item));
            }
            this.canViewSurveyAcquisitions = _data["canViewSurveyAcquisitions"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewSurveyAcquisitions"] = this.canViewSurveyAcquisitions;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDto {
    surveyId: number;
    surveyName?: string | undefined;
    isPublic: boolean;
    acquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto[];
    items: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto[];
    canViewSurveyAcquisitions: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto;
    acquisition!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto();
            this.acquisition = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto();
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto.fromJS(_data["acquisition"]) : new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemDto;
    acquisition: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAcquisitionDto;
    dataMonitoringItemType: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status?: string | undefined;
    dataSubmission?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDataMonitoringItemsResponseResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto {
    id!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    alias!: string;
    isConfidential!: boolean;
    type?: string | undefined;
    status?: string | undefined;
    operatorCompanyName?: string | undefined;
    nopimsLegislation?: string | undefined;
    basinNames!: string;
    countryNames!: string;
    regionNames!: string;
    titles!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto[];
    comments!: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    showBasicRelevantDate!: boolean;
    basicRelevantDate?: Date | undefined;
    showInterpretativeRelevantDate!: boolean;
    interpretativeRelevantDate?: Date | undefined;
    showSubset2dRelevantDate!: boolean;
    subset2dRelevantDate?: Date | undefined;
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.alias = _data["alias"];
            this.isConfidential = _data["isConfidential"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.operatorCompanyName = _data["operatorCompanyName"];
            this.nopimsLegislation = _data["nopimsLegislation"];
            this.basinNames = _data["basinNames"];
            this.countryNames = _data["countryNames"];
            this.regionNames = _data["regionNames"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.showBasicRelevantDate = _data["showBasicRelevantDate"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.showInterpretativeRelevantDate = _data["showInterpretativeRelevantDate"];
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.showSubset2dRelevantDate = _data["showSubset2dRelevantDate"];
            this.subset2dRelevantDate = _data["subset2dRelevantDate"] ? new Date(_data["subset2dRelevantDate"].toString()) : <any>undefined;
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["alias"] = this.alias;
        data["isConfidential"] = this.isConfidential;
        data["type"] = this.type;
        data["status"] = this.status;
        data["operatorCompanyName"] = this.operatorCompanyName;
        data["nopimsLegislation"] = this.nopimsLegislation;
        data["basinNames"] = this.basinNames;
        data["countryNames"] = this.countryNames;
        data["regionNames"] = this.regionNames;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["showBasicRelevantDate"] = this.showBasicRelevantDate;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["showInterpretativeRelevantDate"] = this.showInterpretativeRelevantDate;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["showSubset2dRelevantDate"] = this.showSubset2dRelevantDate;
        data["subset2dRelevantDate"] = this.subset2dRelevantDate ? this.subset2dRelevantDate.toISOString() : <any>undefined;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseDto {
    id: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    alias: string;
    isConfidential: boolean;
    type?: string | undefined;
    status?: string | undefined;
    operatorCompanyName?: string | undefined;
    nopimsLegislation?: string | undefined;
    basinNames: string;
    countryNames: string;
    regionNames: string;
    titles: GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto[];
    comments: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    showBasicRelevantDate: boolean;
    basicRelevantDate?: Date | undefined;
    showInterpretativeRelevantDate: boolean;
    interpretativeRelevantDate?: Date | undefined;
    showSubset2dRelevantDate: boolean;
    subset2dRelevantDate?: Date | undefined;
    audit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto {
    nopimsTitleType!: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyDetailsResponseTitleDto {
    nopimsTitleType: NopimsTitleTypeEnum;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto {
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListRequestDto {
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto {
    surveys!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseDto {
    surveys: GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto {
    id!: number;
    identifier!: string;
    name!: string;
    isPublic!: boolean;
    status!: string;
    type!: string;
    operator!: string;
    legislation!: string;
    basins!: string;
    countries!: string;
    regions!: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.isPublic = _data["isPublic"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.operator = _data["operator"];
            this.legislation = _data["legislation"];
            this.basins = _data["basins"];
            this.countries = _data["countries"];
            this.regions = _data["regions"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["isPublic"] = this.isPublic;
        data["status"] = this.status;
        data["type"] = this.type;
        data["operator"] = this.operator;
        data["legislation"] = this.legislation;
        data["basins"] = this.basins;
        data["countries"] = this.countries;
        data["regions"] = this.regions;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyListResponseItemDto {
    id: number;
    identifier: string;
    name: string;
    isPublic: boolean;
    status: string;
    type: string;
    operator: string;
    legislation: string;
    basins: string;
    countries: string;
    regions: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto implements ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId!: number;
    surveyAcquisitionId!: number;
    surveyVersionNumber!: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceTypeId?: number | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.shotPointInterval = _data["shotPointInterval"];
            this.receiverGroupInterval = _data["receiverGroupInterval"];
            this.groupChannelCount = _data["groupChannelCount"];
            this.surveyEnergySourceTypeId = _data["surveyEnergySourceTypeId"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["shotPointInterval"] = this.shotPointInterval;
        data["receiverGroupInterval"] = this.receiverGroupInterval;
        data["groupChannelCount"] = this.groupChannelCount;
        data["surveyEnergySourceTypeId"] = this.surveyEnergySourceTypeId;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId: number;
    surveyAcquisitionId: number;
    surveyVersionNumber: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceTypeId?: number | undefined;
}

export class CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto implements ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages: StatusMessagesDto;
}

export class DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto implements IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId!: number;
    surveyAcquisitionId!: number;
    surveyVersionNumber!: number;
    surveyAcquisitionParameterId!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyAcquisitionParameterId = _data["surveyAcquisitionParameterId"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyAcquisitionParameterId"] = this.surveyAcquisitionParameterId;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId: number;
    surveyAcquisitionId: number;
    surveyVersionNumber: number;
    surveyAcquisitionParameterId: number;
}

export class DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto implements IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto {
    surveyId!: number;
    surveyVersionNumber!: number;
    surveyName?: string | undefined;
    isPublic!: boolean;
    acquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto[];
    surveyEnergySourceTypes!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto[];
    parameters!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto[];
    canViewAcquisition!: boolean;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitions = [];
            this.surveyEnergySourceTypes = [];
            this.parameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyEnergySourceTypes"])) {
                this.surveyEnergySourceTypes = [] as any;
                for (let item of _data["surveyEnergySourceTypes"])
                    this.surveyEnergySourceTypes!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto.fromJS(item));
            }
            this.canViewAcquisition = _data["canViewAcquisition"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyEnergySourceTypes)) {
            data["surveyEnergySourceTypes"] = [];
            for (let item of this.surveyEnergySourceTypes)
                data["surveyEnergySourceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["canViewAcquisition"] = this.canViewAcquisition;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseDto {
    surveyId: number;
    surveyVersionNumber: number;
    surveyName?: string | undefined;
    isPublic: boolean;
    acquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto[];
    surveyEnergySourceTypes: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto[];
    parameters: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto[];
    canViewAcquisition: boolean;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto {
    id!: number;
    acquisition?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto | undefined;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceType?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acquisition = _data["acquisition"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto.fromJS(_data["acquisition"]) : <any>undefined;
            this.shotPointInterval = _data["shotPointInterval"];
            this.receiverGroupInterval = _data["receiverGroupInterval"];
            this.groupChannelCount = _data["groupChannelCount"];
            this.surveyEnergySourceType = _data["surveyEnergySourceType"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto.fromJS(_data["surveyEnergySourceType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acquisition"] = this.acquisition ? this.acquisition.toJSON() : <any>undefined;
        data["shotPointInterval"] = this.shotPointInterval;
        data["receiverGroupInterval"] = this.receiverGroupInterval;
        data["groupChannelCount"] = this.groupChannelCount;
        data["surveyEnergySourceType"] = this.surveyEnergySourceType ? this.surveyEnergySourceType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseParameterDto {
    id: number;
    acquisition?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseAcquisitionDto | undefined;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceType?: GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyParametersResponseSurveyEnergySourceTypeDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId!: number;
    surveyAcquisitionId!: number;
    surveyVersionNumber!: number;
    surveyParameterId!: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceTypeId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyParameterId = _data["surveyParameterId"];
            this.shotPointInterval = _data["shotPointInterval"];
            this.receiverGroupInterval = _data["receiverGroupInterval"];
            this.groupChannelCount = _data["groupChannelCount"];
            this.surveyEnergySourceTypeId = _data["surveyEnergySourceTypeId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyParameterId"] = this.surveyParameterId;
        data["shotPointInterval"] = this.shotPointInterval;
        data["receiverGroupInterval"] = this.receiverGroupInterval;
        data["groupChannelCount"] = this.groupChannelCount;
        data["surveyEnergySourceTypeId"] = this.surveyEnergySourceTypeId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterRequestDto {
    surveyId: number;
    surveyAcquisitionId: number;
    surveyVersionNumber: number;
    surveyParameterId: number;
    shotPointInterval?: number | undefined;
    receiverGroupInterval?: number | undefined;
    groupChannelCount?: number | undefined;
    surveyEnergySourceTypeId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyParameterResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetGeoscienceAustraliaAcquisitionIdentifierDto implements IGetGeoscienceAustraliaAcquisitionIdentifierDto {
    acquisitionId!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaAcquisitionIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaAcquisitionIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaAcquisitionIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaAcquisitionIdentifierDto {
    acquisitionId: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto {
    surveyId!: number;
    surveyName?: string | undefined;
    isPublic!: boolean;
    acquisitionIdentifiers!: GetGeoscienceAustraliaAcquisitionIdentifierDto[];
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.acquisitionIdentifiers = [];
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["acquisitionIdentifiers"])) {
                this.acquisitionIdentifiers = [] as any;
                for (let item of _data["acquisitionIdentifiers"])
                    this.acquisitionIdentifiers!.push(GetGeoscienceAustraliaAcquisitionIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.acquisitionIdentifiers)) {
            data["acquisitionIdentifiers"] = [];
            for (let item of this.acquisitionIdentifiers)
                data["acquisitionIdentifiers"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportAttachmentsResponseDto {
    surveyId: number;
    surveyName?: string | undefined;
    isPublic: boolean;
    acquisitionIdentifiers: GetGeoscienceAustraliaAcquisitionIdentifierDto[];
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    surveyAcquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto.fromJS(item));
            }
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    surveyAcquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
    surveyName!: string;
    isPublic!: boolean;
    surveyAcquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto[];
    items!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto[];
    loanStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
    surveyName: string;
    isPublic: boolean;
    surveyAcquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto[];
    items: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsItemDto[];
    loanStatuses: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsConditionStatusDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyReportsSurveyAcquisitionItemDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveyReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto implements ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId!: number;
    surveyVersionNumber!: number;
    surveyAcquisitionId!: number;
    lineName?: string | undefined;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.lineName = _data["lineName"];
            this.firstShotPoint = _data["firstShotPoint"];
            this.lastShotPoint = _data["lastShotPoint"];
            this.lineLength = _data["lineLength"];
            this.nominalShotInterval = _data["nominalShotInterval"];
            this.shotIncrement = _data["shotIncrement"];
            this.publicComments = _data["publicComments"];
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["lineName"] = this.lineName;
        data["firstShotPoint"] = this.firstShotPoint;
        data["lastShotPoint"] = this.lastShotPoint;
        data["lineLength"] = this.lineLength;
        data["nominalShotInterval"] = this.nominalShotInterval;
        data["shotIncrement"] = this.shotIncrement;
        data["publicComments"] = this.publicComments;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId: number;
    surveyVersionNumber: number;
    surveyAcquisitionId: number;
    lineName?: string | undefined;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;
}

export class CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto implements ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto implements IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId!: number;
    surveyVersionNumber!: number;
    surveyAcquisitionId!: number;
    lineId!: number;

    constructor(data?: IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.lineId = _data["lineId"];
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["lineId"] = this.lineId;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId: number;
    surveyVersionNumber: number;
    surveyAcquisitionId: number;
    lineId: number;
}

export class DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto implements IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto implements IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
    surveyId!: number;

    constructor(data?: IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
    surveyId: number;
}

export class ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto implements IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;

    constructor(data?: IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        return data;
    }
}

export interface IExportGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto {
    id!: number;
    lineName!: string;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;
    surveyAcquisition?: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineName = _data["lineName"];
            this.firstShotPoint = _data["firstShotPoint"];
            this.lastShotPoint = _data["lastShotPoint"];
            this.lineLength = _data["lineLength"];
            this.nominalShotInterval = _data["nominalShotInterval"];
            this.shotIncrement = _data["shotIncrement"];
            this.publicComments = _data["publicComments"];
            this.surveyAcquisition = _data["surveyAcquisition"] ? GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto.fromJS(_data["surveyAcquisition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineName"] = this.lineName;
        data["firstShotPoint"] = this.firstShotPoint;
        data["lastShotPoint"] = this.lastShotPoint;
        data["lineLength"] = this.lineLength;
        data["nominalShotInterval"] = this.nominalShotInterval;
        data["shotIncrement"] = this.shotIncrement;
        data["publicComments"] = this.publicComments;
        data["surveyAcquisition"] = this.surveyAcquisition ? this.surveyAcquisition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto {
    id: number;
    lineName: string;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;
    surveyAcquisition?: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
    surveyVersionNumber!: number;
    surveyName!: string;
    isPublic!: boolean;
    surveyAcquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto[];
    items!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesResponseDto {
    surveyVersionNumber: number;
    surveyName: string;
    isPublic: boolean;
    surveyAcquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto[];
    items: GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineItemDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLinesSurveyAcquisitionItemDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId!: number;
    surveyVersionNumber!: number;
    surveyAcquisitionId!: number;
    lineId!: number;
    lineName?: string | undefined;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyVersionNumber = _data["surveyVersionNumber"];
            this.surveyAcquisitionId = _data["surveyAcquisitionId"];
            this.lineId = _data["lineId"];
            this.lineName = _data["lineName"];
            this.firstShotPoint = _data["firstShotPoint"];
            this.lastShotPoint = _data["lastShotPoint"];
            this.lineLength = _data["lineLength"];
            this.nominalShotInterval = _data["nominalShotInterval"];
            this.shotIncrement = _data["shotIncrement"];
            this.publicComments = _data["publicComments"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyVersionNumber"] = this.surveyVersionNumber;
        data["surveyAcquisitionId"] = this.surveyAcquisitionId;
        data["lineId"] = this.lineId;
        data["lineName"] = this.lineName;
        data["firstShotPoint"] = this.firstShotPoint;
        data["lastShotPoint"] = this.lastShotPoint;
        data["lineLength"] = this.lineLength;
        data["nominalShotInterval"] = this.nominalShotInterval;
        data["shotIncrement"] = this.shotIncrement;
        data["publicComments"] = this.publicComments;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineRequestDto {
    surveyId: number;
    surveyVersionNumber: number;
    surveyAcquisitionId: number;
    lineId: number;
    lineName?: string | undefined;
    firstShotPoint?: string | undefined;
    lastShotPoint?: string | undefined;
    lineLength?: number | undefined;
    nominalShotInterval?: number | undefined;
    shotIncrement?: number | undefined;
    publicComments?: string | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySeismicLineResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    title?: string | undefined;
    isPublic!: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    surveyAcquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto[];
    surveyAcquisitionDescriptions?: string | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.title = _data["title"];
            this.isPublic = _data["isPublic"];
            this.dataType = _data["dataType"];
            this.tapeId = _data["tapeId"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto.fromJS(item));
            }
            this.surveyAcquisitionDescriptions = _data["surveyAcquisitionDescriptions"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.consignment = _data["consignment"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["title"] = this.title;
        data["isPublic"] = this.isPublic;
        data["dataType"] = this.dataType;
        data["tapeId"] = this.tapeId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        data["surveyAcquisitionDescriptions"] = this.surveyAcquisitionDescriptions;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["consignment"] = this.consignment;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    title?: string | undefined;
    isPublic: boolean;
    dataType?: string | undefined;
    tapeId?: string | undefined;
    receivedDate?: Date | undefined;
    surveyAcquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto[];
    surveyAcquisitionDescriptions?: string | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
    surveyId!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
    surveyId: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
    surveyName!: string;
    isPublic!: boolean;
    surveyAcquisitions!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto[];
    items!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto[];
    loanStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyAcquisitions = [];
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["surveyAcquisitions"])) {
                this.surveyAcquisitions = [] as any;
                for (let item of _data["surveyAcquisitions"])
                    this.surveyAcquisitions!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.surveyAcquisitions)) {
            data["surveyAcquisitions"] = [];
            for (let item of this.surveyAcquisitions)
                data["surveyAcquisitions"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
    surveyName: string;
    isPublic: boolean;
    surveyAcquisitions: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto[];
    items: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataItemDto[];
    loanStatuses: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataConditionStatusDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyAcquisitionItemDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
    surveyId!: number;
    surveyData?: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            if (Array.isArray(_data["surveyData"])) {
                this.surveyData = [] as any;
                for (let item of _data["surveyData"])
                    this.surveyData!.push(UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        if (Array.isArray(this.surveyData)) {
            data["surveyData"] = [];
            for (let item of this.surveyData)
                data["surveyData"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataRequestDto {
    surveyId: number;
    surveyData?: UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: SepiGaNopimsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedSurveyDataIds"])) {
                this.failedSurveyDataIds = [] as any;
                for (let item of _data["failedSurveyDataIds"])
                    this.failedSurveyDataIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedSurveyDataIds)) {
            data["failedSurveyDataIds"] = [];
            for (let item of this.failedSurveyDataIds)
                data["failedSurveyDataIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedSurveyDataIds?: number[] | undefined;
}

export class UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto implements IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaSurveysAcquisitionsSurveySurveyDataSurveyDataDto {
    versionNumber: number;
    id: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto {
    id!: number;
    surveyName!: string;
    isPublic!: boolean;
    surveyTitles!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto[];
    surveyWorkProgramActivities!: GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto[];

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyTitles = [];
            this.surveyWorkProgramActivities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyName = _data["surveyName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["surveyTitles"])) {
                this.surveyTitles = [] as any;
                for (let item of _data["surveyTitles"])
                    this.surveyTitles!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyWorkProgramActivities"])) {
                this.surveyWorkProgramActivities = [] as any;
                for (let item of _data["surveyWorkProgramActivities"])
                    this.surveyWorkProgramActivities!.push(GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyName"] = this.surveyName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.surveyTitles)) {
            data["surveyTitles"] = [];
            for (let item of this.surveyTitles)
                data["surveyTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyWorkProgramActivities)) {
            data["surveyWorkProgramActivities"] = [];
            for (let item of this.surveyWorkProgramActivities)
                data["surveyWorkProgramActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseDto {
    id: number;
    surveyName: string;
    isPublic: boolean;
    surveyTitles: GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto[];
    surveyWorkProgramActivities: GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto[];
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto {
    titleRelationshipTypeName?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleTypeDescription!: string;
    acquisitionId?: number | undefined;
    acquisitionName!: string;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleRelationshipTypeName = _data["titleRelationshipTypeName"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleTypeDescription = _data["titleTypeDescription"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionName = _data["acquisitionName"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleRelationshipTypeName"] = this.titleRelationshipTypeName;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleTypeDescription"] = this.titleTypeDescription;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionName"] = this.acquisitionName;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseTitleDto {
    titleRelationshipTypeName?: string | undefined;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleTypeDescription: string;
    acquisitionId?: number | undefined;
    acquisitionName: string;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto implements IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto {
    id!: number;
    acquisitionId!: number;
    acquisitionName!: string;
    titleId!: string;
    titleNumber!: string;
    workProgram2YearActivityType!: string;
    workProgramStartDate?: Date | undefined;
    workProgramEndDate?: Date | undefined;
    workProgramQuantity?: number | undefined;
    workProgramUnits?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionName = _data["acquisitionName"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.workProgram2YearActivityType = _data["workProgram2YearActivityType"];
            this.workProgramStartDate = _data["workProgramStartDate"] ? new Date(_data["workProgramStartDate"].toString()) : <any>undefined;
            this.workProgramEndDate = _data["workProgramEndDate"] ? new Date(_data["workProgramEndDate"].toString()) : <any>undefined;
            this.workProgramQuantity = _data["workProgramQuantity"];
            this.workProgramUnits = _data["workProgramUnits"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionName"] = this.acquisitionName;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["workProgram2YearActivityType"] = this.workProgram2YearActivityType;
        data["workProgramStartDate"] = this.workProgramStartDate ? this.workProgramStartDate.toISOString() : <any>undefined;
        data["workProgramEndDate"] = this.workProgramEndDate ? this.workProgramEndDate.toISOString() : <any>undefined;
        data["workProgramQuantity"] = this.workProgramQuantity;
        data["workProgramUnits"] = this.workProgramUnits;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaSurveysAcquisitionsSurveyTitleDetailsResponseWorkProgramActivityDto {
    id: number;
    acquisitionId: number;
    acquisitionName: string;
    titleId: string;
    titleNumber: string;
    workProgram2YearActivityType: string;
    workProgramStartDate?: Date | undefined;
    workProgramEndDate?: Date | undefined;
    workProgramQuantity?: number | undefined;
    workProgramUnits?: string | undefined;
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto implements IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto {

    constructor(data?: IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRequestDto {
}

export class GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto implements IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto {
    secureUsers!: GeoscienceAustraliaSecureUserDetailsDto[];

    constructor(data?: IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureUsers"])) {
                this.secureUsers = [] as any;
                for (let item of _data["secureUsers"])
                    this.secureUsers!.push(GeoscienceAustraliaSecureUserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureUsers)) {
            data["secureUsers"] = [];
            for (let item of this.secureUsers)
                data["secureUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsResponseDto {
    secureUsers: GeoscienceAustraliaSecureUserDetailsDto[];
}

export class SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto implements ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    roles?: SecureRoleEnum[] | undefined;

    constructor(data?: ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    roles?: SecureRoleEnum[] | undefined;
}

export class SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto implements ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto {
    roles?: SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto[] | undefined;

    constructor(data?: ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesRequestDto {
    roles?: SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRoleDto[] | undefined;
}

export class SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto implements ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveGeoscienceAustraliaUserManagementGeoscienceAustraliaDetailsRolesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto implements IApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto implements IApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto implements IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto implements IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto implements IGeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    isSecureUserBlocked!: boolean;
    isSecureUserRevokedButVisible!: boolean;

    constructor(data?: IGeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserRevokedButVisible = _data["isSecureUserRevokedButVisible"];
        }
    }

    static fromJS(data: any): GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserRevokedButVisible"] = this.isSecureUserRevokedButVisible;
        return data;
    }
}

export interface IGeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    isSecureUserBlocked: boolean;
    isSecureUserRevokedButVisible: boolean;
}

export class GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto implements IGeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;

    constructor(data?: IGeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface IGeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
}

export class GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto implements IGeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting!: SecureRoleEnum[];
    rolesRequested!: SecureRoleEnum[];
    rolesApproved!: SecureRoleEnum[];
    hasAllGeneralRoles!: boolean;

    constructor(data?: IGeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesExisting = [];
            this.rolesRequested = [];
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesExisting"])) {
                this.rolesExisting = [] as any;
                for (let item of _data["rolesExisting"])
                    this.rolesExisting!.push(item);
            }
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesExisting)) {
            data["rolesExisting"] = [];
            for (let item of this.rolesExisting)
                data["rolesExisting"].push(item);
        }
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface IGeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting: SecureRoleEnum[];
    rolesRequested: SecureRoleEnum[];
    rolesApproved: SecureRoleEnum[];
    hasAllGeneralRoles: boolean;
}

export class GeoscienceAustraliaUserManagementRequestDetailsSummaryDto implements IGeoscienceAustraliaUserManagementRequestDetailsSummaryDto {
    id!: number;
    versionNumber!: number;
    type!: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime!: Date;
    comments?: string | undefined;
    isComplete!: boolean;
    isNewUserRequest!: boolean;
    isGeoscienceAustraliaStandardRoleRequest!: boolean;

    constructor(data?: IGeoscienceAustraliaUserManagementRequestDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.type = _data["type"];
            this.requestGroupCode = _data["requestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.isComplete = _data["isComplete"];
            this.isNewUserRequest = _data["isNewUserRequest"];
            this.isGeoscienceAustraliaStandardRoleRequest = _data["isGeoscienceAustraliaStandardRoleRequest"];
        }
    }

    static fromJS(data: any): GeoscienceAustraliaUserManagementRequestDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaUserManagementRequestDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["type"] = this.type;
        data["requestGroupCode"] = this.requestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["isComplete"] = this.isComplete;
        data["isNewUserRequest"] = this.isNewUserRequest;
        data["isGeoscienceAustraliaStandardRoleRequest"] = this.isGeoscienceAustraliaStandardRoleRequest;
        return data;
    }
}

export interface IGeoscienceAustraliaUserManagementRequestDetailsSummaryDto {
    id: number;
    versionNumber: number;
    type: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime: Date;
    comments?: string | undefined;
    isComplete: boolean;
    isNewUserRequest: boolean;
    isGeoscienceAustraliaStandardRoleRequest: boolean;
}

export class GetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto implements IGetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId: number;
}

export class GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto implements IGetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    summary!: GeoscienceAustraliaUserManagementRequestDetailsSummaryDto;
    existingUserDetails!: GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto;
    geoscienceAustraliaStandardRoleDetails!: GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new GeoscienceAustraliaUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = new GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto();
            this.geoscienceAustraliaStandardRoleDetails = new GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? GeoscienceAustraliaUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new GeoscienceAustraliaUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = _data["existingUserDetails"] ? GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto.fromJS(_data["existingUserDetails"]) : new GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto();
            this.geoscienceAustraliaStandardRoleDetails = _data["geoscienceAustraliaStandardRoleDetails"] ? GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["geoscienceAustraliaStandardRoleDetails"]) : new GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["existingUserDetails"] = this.existingUserDetails ? this.existingUserDetails.toJSON() : <any>undefined;
        data["geoscienceAustraliaStandardRoleDetails"] = this.geoscienceAustraliaStandardRoleDetails ? this.geoscienceAustraliaStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    summary: GeoscienceAustraliaUserManagementRequestDetailsSummaryDto;
    existingUserDetails: GeoscienceAustraliaUserManagementRequestDetailsExistingUserDetailsDto;
    geoscienceAustraliaStandardRoleDetails: GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class GetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto implements IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId: number;
}

export class GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto implements IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    summary!: GeoscienceAustraliaUserManagementRequestDetailsSummaryDto;
    newUserDetails!: GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto;
    geoscienceAustraliaStandardRoleDetails!: GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new GeoscienceAustraliaUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = new GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto();
            this.geoscienceAustraliaStandardRoleDetails = new GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? GeoscienceAustraliaUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new GeoscienceAustraliaUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = _data["newUserDetails"] ? GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto.fromJS(_data["newUserDetails"]) : new GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto();
            this.geoscienceAustraliaStandardRoleDetails = _data["geoscienceAustraliaStandardRoleDetails"] ? GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["geoscienceAustraliaStandardRoleDetails"]) : new GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["newUserDetails"] = this.newUserDetails ? this.newUserDetails.toJSON() : <any>undefined;
        data["geoscienceAustraliaStandardRoleDetails"] = this.geoscienceAustraliaStandardRoleDetails ? this.geoscienceAustraliaStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    summary: GeoscienceAustraliaUserManagementRequestDetailsSummaryDto;
    newUserDetails: GeoscienceAustraliaUserManagementRequestDetailsNewUserDetailsDto;
    geoscienceAustraliaStandardRoleDetails: GeoscienceAustraliaUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class RejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto implements IRejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectGeoscienceAustraliaUserManagementRequestDetailsGarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto implements IRejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectGeoscienceAustraliaUserManagementRequestDetailsGarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto implements IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto implements IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectGeoscienceAustraliaUserManagementRequestDetailsNuGarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class BatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto implements IBatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;

    constructor(data?: IBatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchApproveGeoscienceAustraliaUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
}

export class BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto implements IBatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchApproveGeoscienceAustraliaUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class BatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto implements IBatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IBatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): BatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IBatchRejectGeoscienceAustraliaUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto implements IBatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchRejectGeoscienceAustraliaUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto implements IGeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto {
    requestDatetime!: Date;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    isSecureUserRevokedButVisible!: boolean;
    secureRequestGroupLink!: SecureRequestGroupLinkDto;
    requestVersionNumber!: number;
    rolesRequested!: SecureRoleEnum[];

    constructor(data?: IGeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureRequestGroupLink = new SecureRequestGroupLinkDto();
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserRevokedButVisible = _data["isSecureUserRevokedButVisible"];
            this.secureRequestGroupLink = _data["secureRequestGroupLink"] ? SecureRequestGroupLinkDto.fromJS(_data["secureRequestGroupLink"]) : new SecureRequestGroupLinkDto();
            this.requestVersionNumber = _data["requestVersionNumber"];
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
        }
    }

    static fromJS(data: any): GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserRevokedButVisible"] = this.isSecureUserRevokedButVisible;
        data["secureRequestGroupLink"] = this.secureRequestGroupLink ? this.secureRequestGroupLink.toJSON() : <any>undefined;
        data["requestVersionNumber"] = this.requestVersionNumber;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        return data;
    }
}

export interface IGeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto {
    requestDatetime: Date;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    isSecureUserRevokedButVisible: boolean;
    secureRequestGroupLink: SecureRequestGroupLinkDto;
    requestVersionNumber: number;
    rolesRequested: SecureRoleEnum[];
}

export class GetGeoscienceAustraliaUserManagementRequestListRequestDto implements IGetGeoscienceAustraliaUserManagementRequestListRequestDto {

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestListRequestDto {
}

export class GetGeoscienceAustraliaUserManagementRequestListResponseDto implements IGetGeoscienceAustraliaUserManagementRequestListResponseDto {
    geoscienceAustraliaAdministratorRequests!: GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto[];
    isGeoscienceAustraliaAdministratorRequestLimitExceeded!: boolean;
    noptaRequests!: NoptaGeoscienceAustraliaRequestListItemDto[];
    isNoptaRequestLimitExceeded!: boolean;

    constructor(data?: IGetGeoscienceAustraliaUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.geoscienceAustraliaAdministratorRequests = [];
            this.noptaRequests = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["geoscienceAustraliaAdministratorRequests"])) {
                this.geoscienceAustraliaAdministratorRequests = [] as any;
                for (let item of _data["geoscienceAustraliaAdministratorRequests"])
                    this.geoscienceAustraliaAdministratorRequests!.push(GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto.fromJS(item));
            }
            this.isGeoscienceAustraliaAdministratorRequestLimitExceeded = _data["isGeoscienceAustraliaAdministratorRequestLimitExceeded"];
            if (Array.isArray(_data["noptaRequests"])) {
                this.noptaRequests = [] as any;
                for (let item of _data["noptaRequests"])
                    this.noptaRequests!.push(NoptaGeoscienceAustraliaRequestListItemDto.fromJS(item));
            }
            this.isNoptaRequestLimitExceeded = _data["isNoptaRequestLimitExceeded"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.geoscienceAustraliaAdministratorRequests)) {
            data["geoscienceAustraliaAdministratorRequests"] = [];
            for (let item of this.geoscienceAustraliaAdministratorRequests)
                data["geoscienceAustraliaAdministratorRequests"].push(item.toJSON());
        }
        data["isGeoscienceAustraliaAdministratorRequestLimitExceeded"] = this.isGeoscienceAustraliaAdministratorRequestLimitExceeded;
        if (Array.isArray(this.noptaRequests)) {
            data["noptaRequests"] = [];
            for (let item of this.noptaRequests)
                data["noptaRequests"].push(item.toJSON());
        }
        data["isNoptaRequestLimitExceeded"] = this.isNoptaRequestLimitExceeded;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementRequestListResponseDto {
    geoscienceAustraliaAdministratorRequests: GeoscienceAustraliaUserManagementGeoscienceAustraliaRequestListAdministratorGeoscienceAustraliaRequestListItemDto[];
    isGeoscienceAustraliaAdministratorRequestLimitExceeded: boolean;
    noptaRequests: NoptaGeoscienceAustraliaRequestListItemDto[];
    isNoptaRequestLimitExceeded: boolean;
}

export class NoptaGeoscienceAustraliaRequestListItemDto implements INoptaGeoscienceAustraliaRequestListItemDto {
    requestDatetime!: Date;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    isSecureUserRevokedButVisible!: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;

    constructor(data?: INoptaGeoscienceAustraliaRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserRevokedButVisible = _data["isSecureUserRevokedButVisible"];
            this.requestCode = _data["requestCode"];
            this.roleRequested = _data["roleRequested"];
        }
    }

    static fromJS(data: any): NoptaGeoscienceAustraliaRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoptaGeoscienceAustraliaRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserRevokedButVisible"] = this.isSecureUserRevokedButVisible;
        data["requestCode"] = this.requestCode;
        data["roleRequested"] = this.roleRequested;
        return data;
    }
}

export interface INoptaGeoscienceAustraliaRequestListItemDto {
    requestDatetime: Date;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    isSecureUserRevokedButVisible: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;
}

export class GetGeoscienceAustraliaUserManagementUserDetailsRequestDto implements IGetGeoscienceAustraliaUserManagementUserDetailsRequestDto {
    secureUserId!: number;

    constructor(data?: IGetGeoscienceAustraliaUserManagementUserDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementUserDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementUserDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementUserDetailsRequestDto {
    secureUserId: number;
}

export class GetGeoscienceAustraliaUserManagementUserDetailsResponseDto implements IGetGeoscienceAustraliaUserManagementUserDetailsResponseDto {
    userDetails!: GeoscienceAustraliaSecureUserDetailsDto;

    constructor(data?: IGetGeoscienceAustraliaUserManagementUserDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userDetails = new GeoscienceAustraliaSecureUserDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetails = _data["userDetails"] ? GeoscienceAustraliaSecureUserDetailsDto.fromJS(_data["userDetails"]) : new GeoscienceAustraliaSecureUserDetailsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementUserDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementUserDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementUserDetailsResponseDto {
    userDetails: GeoscienceAustraliaSecureUserDetailsDto;
}

export class GetGeoscienceAustraliaUserManagementUserListRequestDto implements IGetGeoscienceAustraliaUserManagementUserListRequestDto {

    constructor(data?: IGetGeoscienceAustraliaUserManagementUserListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementUserListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementUserListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementUserListRequestDto {
}

export class GetGeoscienceAustraliaUserManagementUserListResponseDto implements IGetGeoscienceAustraliaUserManagementUserListResponseDto {
    secureUsers!: GeoscienceAustraliaSecureUserDetailsDto[];

    constructor(data?: IGetGeoscienceAustraliaUserManagementUserListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureUsers"])) {
                this.secureUsers = [] as any;
                for (let item of _data["secureUsers"])
                    this.secureUsers!.push(GeoscienceAustraliaSecureUserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaUserManagementUserListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaUserManagementUserListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureUsers)) {
            data["secureUsers"] = [];
            for (let item of this.secureUsers)
                data["secureUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaUserManagementUserListResponseDto {
    secureUsers: GeoscienceAustraliaSecureUserDetailsDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status!: string;
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemDto;
    dataMonitoringItemType: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status: string;
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto {
    wellId!: number;
    boreholeId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.boreholeId = _data["boreholeId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["boreholeId"] = this.boreholeId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsRequestDto {
    wellId: number;
    boreholeId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto {
    wellId!: number;
    wellBoreholeId!: number;
    wellName!: string;
    boreholeName!: string;
    isPrimaryBorehole!: boolean;
    isPublic!: boolean;
    items!: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto[];
    canViewWells!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.wellBoreholeId = _data["wellBoreholeId"];
            this.wellName = _data["wellName"];
            this.boreholeName = _data["boreholeName"];
            this.isPrimaryBorehole = _data["isPrimaryBorehole"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto.fromJS(item));
            }
            this.canViewWells = _data["canViewWells"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["wellBoreholeId"] = this.wellBoreholeId;
        data["wellName"] = this.wellName;
        data["boreholeName"] = this.boreholeName;
        data["isPrimaryBorehole"] = this.isPrimaryBorehole;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewWells"] = this.canViewWells;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResponseDto {
    wellId: number;
    wellBoreholeId: number;
    wellName: string;
    boreholeName: string;
    isPrimaryBorehole: boolean;
    isPublic: boolean;
    items: GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsItemDto[];
    canViewWells: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDataMonitoringItemsResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto {
    isConfidential!: boolean;
    isSystemConfidential!: boolean;
    isUserOverridden!: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    confidentialityAudit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.confidentialityAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConfidential = _data["isConfidential"];
            this.isSystemConfidential = _data["isSystemConfidential"];
            this.isUserOverridden = _data["isUserOverridden"];
            this.isUserConfidential = _data["isUserConfidential"];
            this.comments = _data["comments"];
            this.confidentialityAudit = _data["confidentialityAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["confidentialityAudit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConfidential"] = this.isConfidential;
        data["isSystemConfidential"] = this.isSystemConfidential;
        data["isUserOverridden"] = this.isUserOverridden;
        data["isUserConfidential"] = this.isUserConfidential;
        data["comments"] = this.comments;
        data["confidentialityAudit"] = this.confidentialityAudit ? this.confidentialityAudit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto {
    isConfidential: boolean;
    isSystemConfidential: boolean;
    isUserOverridden: boolean;
    isUserConfidential?: boolean | undefined;
    comments?: string | undefined;
    confidentialityAudit: SecurePortalSimpleAuditEventsDto;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto {
    wellId!: number;
    boreholeId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.boreholeId = _data["boreholeId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["boreholeId"] = this.boreholeId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsRequestDto {
    wellId: number;
    boreholeId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto {
    wellId!: number;
    wellState?: string | undefined;
    boreholeId!: number;
    ubhi!: string;
    boreholeName!: string;
    isPrimary!: boolean;
    boreholeAlias?: string | undefined;
    uwi!: string;
    wellName!: string;
    boreholeStatus?: string | undefined;
    boreholeType?: string | undefined;
    boreholePurpose?: string | undefined;
    nopimsTitleType!: NopimsTitleTypeEnum;
    nopimsTitleTypeName?: string | undefined;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
    operator?: string | undefined;
    drillingCompany?: string | undefined;
    rig?: string | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    bottomHoleLatitude?: number | undefined;
    bottomHoleLongitude?: number | undefined;
    spatialDatum?: string | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    wellBoreholeDepthReferenceType?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    kickOffDate?: Date | undefined;
    totalDepthDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    isAutoCalculateDate!: boolean;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    confidentiality!: GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto;
    boreholeAudit!: SecurePortalSimpleAuditEventsDto;
    isPublic!: boolean;
    isNeverPublicUserOverride!: boolean;
    neverPublicUserOverrideComments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.confidentiality = new GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto();
            this.boreholeAudit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.wellState = _data["wellState"];
            this.boreholeId = _data["boreholeId"];
            this.ubhi = _data["ubhi"];
            this.boreholeName = _data["boreholeName"];
            this.isPrimary = _data["isPrimary"];
            this.boreholeAlias = _data["boreholeAlias"];
            this.uwi = _data["uwi"];
            this.wellName = _data["wellName"];
            this.boreholeStatus = _data["boreholeStatus"];
            this.boreholeType = _data["boreholeType"];
            this.boreholePurpose = _data["boreholePurpose"];
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.nopimsTitleTypeName = _data["nopimsTitleTypeName"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
            this.operator = _data["operator"];
            this.drillingCompany = _data["drillingCompany"];
            this.rig = _data["rig"];
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.bottomHoleLatitude = _data["bottomHoleLatitude"];
            this.bottomHoleLongitude = _data["bottomHoleLongitude"];
            this.spatialDatum = _data["spatialDatum"];
            this.kickOffDepth = _data["kickOffDepth"];
            this.drillersTotalDepth = _data["drillersTotalDepth"];
            this.loggerTotalDepthMeasuredDepth = _data["loggerTotalDepthMeasuredDepth"];
            this.wellBoreholeDepthReferenceType = _data["wellBoreholeDepthReferenceType"];
            this.depthReferenceAboveDatum = _data["depthReferenceAboveDatum"];
            this.trueVerticalDepthSubSea = _data["trueVerticalDepthSubSea"];
            this.kickOffDate = _data["kickOffDate"] ? new Date(_data["kickOffDate"].toString()) : <any>undefined;
            this.totalDepthDate = _data["totalDepthDate"] ? new Date(_data["totalDepthDate"].toString()) : <any>undefined;
            this.rigReleaseDate = _data["rigReleaseDate"] ? new Date(_data["rigReleaseDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.isAutoCalculateDate = _data["isAutoCalculateDate"];
            this.actualHoleCost = _data["actualHoleCost"];
            this.initialApprovedFinancialExpenditure = _data["initialApprovedFinancialExpenditure"];
            this.finalApprovedFinancialExpenditure = _data["finalApprovedFinancialExpenditure"];
            this.costComments = _data["costComments"];
            this.confidentiality = _data["confidentiality"] ? GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto.fromJS(_data["confidentiality"]) : new GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto();
            this.boreholeAudit = _data["boreholeAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["boreholeAudit"]) : new SecurePortalSimpleAuditEventsDto();
            this.isPublic = _data["isPublic"];
            this.isNeverPublicUserOverride = _data["isNeverPublicUserOverride"];
            this.neverPublicUserOverrideComments = _data["neverPublicUserOverrideComments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["wellState"] = this.wellState;
        data["boreholeId"] = this.boreholeId;
        data["ubhi"] = this.ubhi;
        data["boreholeName"] = this.boreholeName;
        data["isPrimary"] = this.isPrimary;
        data["boreholeAlias"] = this.boreholeAlias;
        data["uwi"] = this.uwi;
        data["wellName"] = this.wellName;
        data["boreholeStatus"] = this.boreholeStatus;
        data["boreholeType"] = this.boreholeType;
        data["boreholePurpose"] = this.boreholePurpose;
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["nopimsTitleTypeName"] = this.nopimsTitleTypeName;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        data["operator"] = this.operator;
        data["drillingCompany"] = this.drillingCompany;
        data["rig"] = this.rig;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["bottomHoleLatitude"] = this.bottomHoleLatitude;
        data["bottomHoleLongitude"] = this.bottomHoleLongitude;
        data["spatialDatum"] = this.spatialDatum;
        data["kickOffDepth"] = this.kickOffDepth;
        data["drillersTotalDepth"] = this.drillersTotalDepth;
        data["loggerTotalDepthMeasuredDepth"] = this.loggerTotalDepthMeasuredDepth;
        data["wellBoreholeDepthReferenceType"] = this.wellBoreholeDepthReferenceType;
        data["depthReferenceAboveDatum"] = this.depthReferenceAboveDatum;
        data["trueVerticalDepthSubSea"] = this.trueVerticalDepthSubSea;
        data["kickOffDate"] = this.kickOffDate ? this.kickOffDate.toISOString() : <any>undefined;
        data["totalDepthDate"] = this.totalDepthDate ? this.totalDepthDate.toISOString() : <any>undefined;
        data["rigReleaseDate"] = this.rigReleaseDate ? this.rigReleaseDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["isAutoCalculateDate"] = this.isAutoCalculateDate;
        data["actualHoleCost"] = this.actualHoleCost;
        data["initialApprovedFinancialExpenditure"] = this.initialApprovedFinancialExpenditure;
        data["finalApprovedFinancialExpenditure"] = this.finalApprovedFinancialExpenditure;
        data["costComments"] = this.costComments;
        data["confidentiality"] = this.confidentiality ? this.confidentiality.toJSON() : <any>undefined;
        data["boreholeAudit"] = this.boreholeAudit ? this.boreholeAudit.toJSON() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["isNeverPublicUserOverride"] = this.isNeverPublicUserOverride;
        data["neverPublicUserOverrideComments"] = this.neverPublicUserOverrideComments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeDetailsResponseDto {
    wellId: number;
    wellState?: string | undefined;
    boreholeId: number;
    ubhi: string;
    boreholeName: string;
    isPrimary: boolean;
    boreholeAlias?: string | undefined;
    uwi: string;
    wellName: string;
    boreholeStatus?: string | undefined;
    boreholeType?: string | undefined;
    boreholePurpose?: string | undefined;
    nopimsTitleType: NopimsTitleTypeEnum;
    nopimsTitleTypeName?: string | undefined;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
    operator?: string | undefined;
    drillingCompany?: string | undefined;
    rig?: string | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    bottomHoleLatitude?: number | undefined;
    bottomHoleLongitude?: number | undefined;
    spatialDatum?: string | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    wellBoreholeDepthReferenceType?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    kickOffDate?: Date | undefined;
    totalDepthDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    isAutoCalculateDate: boolean;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    confidentiality: GetGeoscienceAustraliaWellsBoreholesBoreholeDetailsConfidentialityDto;
    boreholeAudit: SecurePortalSimpleAuditEventsDto;
    isPublic: boolean;
    isNeverPublicUserOverride: boolean;
    neverPublicUserOverrideComments?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto {
    wellId!: number;
    boreholeId!: number;
    wellName!: string;
    isPublic!: boolean;
    ubhi!: string;
    boreholeName!: string;
    boreholeStatus!: string;
    boreholeOperator?: string | undefined;
    drilledBy?: string | undefined;
    rigId?: number | undefined;
    rigName?: string | undefined;
    kickOffDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.boreholeId = _data["boreholeId"];
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            this.ubhi = _data["ubhi"];
            this.boreholeName = _data["boreholeName"];
            this.boreholeStatus = _data["boreholeStatus"];
            this.boreholeOperator = _data["boreholeOperator"];
            this.drilledBy = _data["drilledBy"];
            this.rigId = _data["rigId"];
            this.rigName = _data["rigName"];
            this.kickOffDate = _data["kickOffDate"] ? new Date(_data["kickOffDate"].toString()) : <any>undefined;
            this.rigReleaseDate = _data["rigReleaseDate"] ? new Date(_data["rigReleaseDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["boreholeId"] = this.boreholeId;
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        data["ubhi"] = this.ubhi;
        data["boreholeName"] = this.boreholeName;
        data["boreholeStatus"] = this.boreholeStatus;
        data["boreholeOperator"] = this.boreholeOperator;
        data["drilledBy"] = this.drilledBy;
        data["rigId"] = this.rigId;
        data["rigName"] = this.rigName;
        data["kickOffDate"] = this.kickOffDate ? this.kickOffDate.toISOString() : <any>undefined;
        data["rigReleaseDate"] = this.rigReleaseDate ? this.rigReleaseDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto {
    wellId: number;
    boreholeId: number;
    wellName: string;
    isPublic: boolean;
    ubhi: string;
    boreholeName: string;
    boreholeStatus: string;
    boreholeOperator?: string | undefined;
    drilledBy?: string | undefined;
    rigId?: number | undefined;
    rigName?: string | undefined;
    kickOffDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto {
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeListRequestDto {
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto {
    boreholes!: GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeListResponseDto {
    boreholes: GetGeoscienceAustraliaWellsBoreholesBoreholeListItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto implements IGetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto {
    boreholeId!: number;

    constructor(data?: IGetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeId = _data["boreholeId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeId"] = this.boreholeId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaBoreholeReportAttachmentsRequestDto {
    boreholeId: number;
}

export class GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto implements IGetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto {
    boreholeId!: number;
    wellId!: number;
    boreholeName?: string | undefined;
    wellName?: string | undefined;
    canViewWell!: boolean;
    isPrimaryBorehole!: boolean;
    isPublic!: boolean;
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeId = _data["boreholeId"];
            this.wellId = _data["wellId"];
            this.boreholeName = _data["boreholeName"];
            this.wellName = _data["wellName"];
            this.canViewWell = _data["canViewWell"];
            this.isPrimaryBorehole = _data["isPrimaryBorehole"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeId"] = this.boreholeId;
        data["wellId"] = this.wellId;
        data["boreholeName"] = this.boreholeName;
        data["wellName"] = this.wellName;
        data["canViewWell"] = this.canViewWell;
        data["isPrimaryBorehole"] = this.isPrimaryBorehole;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaBoreholeReportAttachmentsResponseDto {
    boreholeId: number;
    wellId: number;
    boreholeName?: string | undefined;
    wellName?: string | undefined;
    canViewWell: boolean;
    isPrimaryBorehole: boolean;
    isPublic: boolean;
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.conditionStatus = _data["conditionStatus"];
            this.loanStatus = _data["loanStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["conditionStatus"] = this.conditionStatus;
        data["loanStatus"] = this.loanStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    conditionStatus?: string | undefined;
    loanStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
    wellId!: number;
    boreholeId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.boreholeId = _data["boreholeId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["boreholeId"] = this.boreholeId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
    wellId: number;
    boreholeId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
    boreholeName!: string;
    wellName!: string;
    isPrimaryBorehole!: boolean;
    isPublic!: boolean;
    canViewWells!: boolean;
    items!: GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto[];
    loanStatuses!: GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeName = _data["boreholeName"];
            this.wellName = _data["wellName"];
            this.isPrimaryBorehole = _data["isPrimaryBorehole"];
            this.isPublic = _data["isPublic"];
            this.canViewWells = _data["canViewWells"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeName"] = this.boreholeName;
        data["wellName"] = this.wellName;
        data["isPrimaryBorehole"] = this.isPrimaryBorehole;
        data["isPublic"] = this.isPublic;
        data["canViewWells"] = this.canViewWells;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
    boreholeName: string;
    wellName: string;
    isPrimaryBorehole: boolean;
    isPublic: boolean;
    canViewWells: boolean;
    items: GetGeoscienceAustraliaWellsBoreholesBoreholeReportsItemDto[];
    loanStatuses: GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto implements IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto implements IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellBoreholeReportsLoanStatusDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto implements IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto implements IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto implements IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesBoreholeReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto {
    id!: number;
    identifier?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto {
    id: number;
    identifier?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto {
    id!: number;
    identifier?: string | undefined;
    isInvalid!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.isInvalid = _data["isInvalid"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto {
    id: number;
    identifier?: string | undefined;
    isInvalid: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsRequestDto {
    dataMonitoringItemId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId!: number;
    name?: string | undefined;
    identifier?: string | undefined;
    type!: NopimsActivityTypeEnum;
    wellDetails!: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto;
    duplicateDataMonitoringItems!: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto | undefined;
    authorisations!: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto[];
    status!: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewWells!: boolean;
    canViewBoreholes!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellDetails = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto();
            this.duplicateDataMonitoringItems = [];
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItemId = _data["dataMonitoringItemId"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.type = _data["type"];
            this.wellDetails = _data["wellDetails"] ? GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto.fromJS(_data["wellDetails"]) : new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto();
            if (Array.isArray(_data["duplicateDataMonitoringItems"])) {
                this.duplicateDataMonitoringItems = [] as any;
                for (let item of _data["duplicateDataMonitoringItems"])
                    this.duplicateDataMonitoringItems!.push(GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto.fromJS(item));
            }
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto.fromJS(item));
            }
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.extensionDueDate = _data["extensionDueDate"] ? new Date(_data["extensionDueDate"].toString()) : <any>undefined;
            this.resubmissionDueDate = _data["resubmissionDueDate"] ? new Date(_data["resubmissionDueDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.canViewWells = _data["canViewWells"];
            this.canViewBoreholes = _data["canViewBoreholes"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItemId"] = this.dataMonitoringItemId;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["type"] = this.type;
        data["wellDetails"] = this.wellDetails ? this.wellDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.duplicateDataMonitoringItems)) {
            data["duplicateDataMonitoringItems"] = [];
            for (let item of this.duplicateDataMonitoringItems)
                data["duplicateDataMonitoringItems"].push(item.toJSON());
        }
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["extensionDueDate"] = this.extensionDueDate ? this.extensionDueDate.toISOString() : <any>undefined;
        data["resubmissionDueDate"] = this.resubmissionDueDate ? this.resubmissionDueDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["canViewWells"] = this.canViewWells;
        data["canViewBoreholes"] = this.canViewBoreholes;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResponseDto {
    dataMonitoringItemId: number;
    name?: string | undefined;
    identifier?: string | undefined;
    type: NopimsActivityTypeEnum;
    wellDetails: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto;
    duplicateDataMonitoringItems: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDuplicateDataMonitoringItemDto[];
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsDataSubmissionDto | undefined;
    authorisations: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto[];
    status: string;
    dueDate?: Date | undefined;
    extensionDueDate?: Date | undefined;
    resubmissionDueDate?: Date | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    comments?: string | undefined;
    canViewWells: boolean;
    canViewBoreholes: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
    audit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsResubmissionDto {
    id: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto implements IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto {
    well?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto | undefined;
    borehole?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto | undefined;
    rigReleaseDueDate?: Date | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.well = _data["well"] ? GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto.fromJS(_data["well"]) : <any>undefined;
            this.borehole = _data["borehole"] ? GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto.fromJS(_data["borehole"]) : <any>undefined;
            this.rigReleaseDueDate = _data["rigReleaseDueDate"] ? new Date(_data["rigReleaseDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["well"] = this.well ? this.well.toJSON() : <any>undefined;
        data["borehole"] = this.borehole ? this.borehole.toJSON() : <any>undefined;
        data["rigReleaseDueDate"] = this.rigReleaseDueDate ? this.rigReleaseDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsWellDto {
    well?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto | undefined;
    borehole?: GetGeoscienceAustraliaWellsBoreholesDataMonitoringItemDetailsReferenceDto | undefined;
    rigReleaseDueDate?: Date | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto {
    name?: string | undefined;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate!: Date;
    companyOwner?: string | undefined;
    status?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.companyOwner = _data["companyOwner"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["make"] = this.make;
        data["model"] = this.model;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["companyOwner"] = this.companyOwner;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigDetailsResponseDto {
    name?: string | undefined;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate: Date;
    companyOwner?: string | undefined;
    status?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto implements IGetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto {
    name!: string;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate!: Date;
    companyOwner?: string | undefined;
    status!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.companyOwner = _data["companyOwner"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["make"] = this.make;
        data["model"] = this.model;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["companyOwner"] = this.companyOwner;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto {
    name: string;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate: Date;
    companyOwner?: string | undefined;
    status: string;
}

export class GetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto implements IGetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigHistoryListRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto implements IGetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto {
    currentName!: string;
    rigHistory!: GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto[];

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rigHistory = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentName = _data["currentName"];
            if (Array.isArray(_data["rigHistory"])) {
                this.rigHistory = [] as any;
                for (let item of _data["rigHistory"])
                    this.rigHistory!.push(GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentName"] = this.currentName;
        if (Array.isArray(this.rigHistory)) {
            data["rigHistory"] = [];
            for (let item of this.rigHistory)
                data["rigHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigHistoryListResponseDto {
    currentName: string;
    rigHistory: GetGeoscienceAustraliaWellsBoreholesRigHistoryItemDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesRigListItemDto implements IGetGeoscienceAustraliaWellsBoreholesRigListItemDto {
    id!: number;
    name!: string;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate!: Date;
    companyOwner?: string | undefined;
    status!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.companyOwner = _data["companyOwner"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["make"] = this.make;
        data["model"] = this.model;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["companyOwner"] = this.companyOwner;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigListItemDto {
    id: number;
    name: string;
    type?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    effectiveFromDate: Date;
    companyOwner?: string | undefined;
    status: string;
}

export class GetGeoscienceAustraliaWellsBoreholesRigListRequestDto implements IGetGeoscienceAustraliaWellsBoreholesRigListRequestDto {
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigListRequestDto {
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesRigListResponseDto implements IGetGeoscienceAustraliaWellsBoreholesRigListResponseDto {
    rigs!: GetGeoscienceAustraliaWellsBoreholesRigListItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesRigListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rigs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rigs"])) {
                this.rigs = [] as any;
                for (let item of _data["rigs"])
                    this.rigs!.push(GetGeoscienceAustraliaWellsBoreholesRigListItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesRigListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesRigListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rigs)) {
            data["rigs"] = [];
            for (let item of this.rigs)
                data["rigs"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesRigListResponseDto {
    rigs: GetGeoscienceAustraliaWellsBoreholesRigListItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto {
    id!: number;
    ubhi!: string;
    name!: string;
    isPrimary!: boolean;
    isPublic!: boolean;
    purpose?: string | undefined;
    rig?: string | undefined;
    boreholeType?: string | undefined;
    boreholeStatus!: string;
    boreholeOperator?: string | undefined;
    drillingCompany?: string | undefined;
    kickOffDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ubhi = _data["ubhi"];
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.isPublic = _data["isPublic"];
            this.purpose = _data["purpose"];
            this.rig = _data["rig"];
            this.boreholeType = _data["boreholeType"];
            this.boreholeStatus = _data["boreholeStatus"];
            this.boreholeOperator = _data["boreholeOperator"];
            this.drillingCompany = _data["drillingCompany"];
            this.kickOffDate = _data["kickOffDate"] ? new Date(_data["kickOffDate"].toString()) : <any>undefined;
            this.rigReleaseDate = _data["rigReleaseDate"] ? new Date(_data["rigReleaseDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ubhi"] = this.ubhi;
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["isPublic"] = this.isPublic;
        data["purpose"] = this.purpose;
        data["rig"] = this.rig;
        data["boreholeType"] = this.boreholeType;
        data["boreholeStatus"] = this.boreholeStatus;
        data["boreholeOperator"] = this.boreholeOperator;
        data["drillingCompany"] = this.drillingCompany;
        data["kickOffDate"] = this.kickOffDate ? this.kickOffDate.toISOString() : <any>undefined;
        data["rigReleaseDate"] = this.rigReleaseDate ? this.rigReleaseDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto {
    id: number;
    ubhi: string;
    name: string;
    isPrimary: boolean;
    isPublic: boolean;
    purpose?: string | undefined;
    rig?: string | undefined;
    boreholeType?: string | undefined;
    boreholeStatus: string;
    boreholeOperator?: string | undefined;
    drillingCompany?: string | undefined;
    kickOffDate?: Date | undefined;
    rigReleaseDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellBoreholesRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto {
    wellName!: string;
    isPublic!: boolean;
    boreholes!: GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto[];

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellBoreholesResponseDto {
    wellName: string;
    isPublic: boolean;
    boreholes: GetGeoscienceAustraliaWellsBoreholesWellBoreholesBoreholeItemDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesRequestDto {
    wellId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto {
    wellName!: string;
    isPublic!: boolean;
    wellDataAuditChanges!: SecurePortalSimpleDataAuditChangesDto;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellDataAuditChanges = new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            this.wellDataAuditChanges = _data["wellDataAuditChanges"] ? SecurePortalSimpleDataAuditChangesDto.fromJS(_data["wellDataAuditChanges"]) : new SecurePortalSimpleDataAuditChangesDto();
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        data["wellDataAuditChanges"] = this.wellDataAuditChanges ? this.wellDataAuditChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataAuditChangesResponseDto {
    wellName: string;
    isPublic: boolean;
    wellDataAuditChanges: SecurePortalSimpleDataAuditChangesDto;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto {
    id!: number;
    name!: string;
    isFinalised!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFinalised = _data["isFinalised"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFinalised"] = this.isFinalised;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto {
    id: number;
    name: string;
    isFinalised: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto {
    id!: number;
    identifier!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto {
    id: number;
    identifier: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto {
    id!: number;
    name!: string;
    classificationType!: string;
    sortOrder!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classificationType = _data["classificationType"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classificationType"] = this.classificationType;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto {
    id: number;
    name: string;
    classificationType: string;
    sortOrder: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto {
    dataMonitoringItem!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto;
    borehole!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto;
    dataMonitoringItemType!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status!: string;
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate!: boolean;
    authorisations!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto[];
    resubmissions!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto[];
    comments?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataMonitoringItem = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto();
            this.borehole = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto();
            this.dataMonitoringItemType = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto();
            this.authorisations = [];
            this.resubmissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMonitoringItem = _data["dataMonitoringItem"] ? GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto.fromJS(_data["dataMonitoringItem"]) : new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto();
            this.borehole = _data["borehole"] ? GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto.fromJS(_data["borehole"]) : new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto();
            this.dataMonitoringItemType = _data["dataMonitoringItemType"] ? GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto.fromJS(_data["dataMonitoringItemType"]) : new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isDueDateExtended = _data["isDueDateExtended"];
            this.status = _data["status"];
            this.dataSubmission = _data["dataSubmission"] ? GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto.fromJS(_data["dataSubmission"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.contentsCheckCompletedDate = _data["contentsCheckCompletedDate"] ? new Date(_data["contentsCheckCompletedDate"].toString()) : <any>undefined;
            this.dataCheckCompletedDate = _data["dataCheckCompletedDate"] ? new Date(_data["dataCheckCompletedDate"].toString()) : <any>undefined;
            this.sentToGaDate = _data["sentToGaDate"] ? new Date(_data["sentToGaDate"].toString()) : <any>undefined;
            this.isInvalidDuplicate = _data["isInvalidDuplicate"];
            if (Array.isArray(_data["authorisations"])) {
                this.authorisations = [] as any;
                for (let item of _data["authorisations"])
                    this.authorisations!.push(GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["resubmissions"])) {
                this.resubmissions = [] as any;
                for (let item of _data["resubmissions"])
                    this.resubmissions!.push(GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMonitoringItem"] = this.dataMonitoringItem ? this.dataMonitoringItem.toJSON() : <any>undefined;
        data["borehole"] = this.borehole ? this.borehole.toJSON() : <any>undefined;
        data["dataMonitoringItemType"] = this.dataMonitoringItemType ? this.dataMonitoringItemType.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDueDateExtended"] = this.isDueDateExtended;
        data["status"] = this.status;
        data["dataSubmission"] = this.dataSubmission ? this.dataSubmission.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["contentsCheckCompletedDate"] = this.contentsCheckCompletedDate ? this.contentsCheckCompletedDate.toISOString() : <any>undefined;
        data["dataCheckCompletedDate"] = this.dataCheckCompletedDate ? this.dataCheckCompletedDate.toISOString() : <any>undefined;
        data["sentToGaDate"] = this.sentToGaDate ? this.sentToGaDate.toISOString() : <any>undefined;
        data["isInvalidDuplicate"] = this.isInvalidDuplicate;
        if (Array.isArray(this.authorisations)) {
            data["authorisations"] = [];
            for (let item of this.authorisations)
                data["authorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.resubmissions)) {
            data["resubmissions"] = [];
            for (let item of this.resubmissions)
                data["resubmissions"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto {
    dataMonitoringItem: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemDto;
    borehole: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto;
    dataMonitoringItemType: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataMonitoringItemTypeDto;
    dueDate?: Date | undefined;
    isDueDateExtended?: boolean | undefined;
    status: string;
    dataSubmission?: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsDataSubmissionDto | undefined;
    receivedDate?: Date | undefined;
    contentsCheckCompletedDate?: Date | undefined;
    dataCheckCompletedDate?: Date | undefined;
    sentToGaDate?: Date | undefined;
    isInvalidDuplicate: boolean;
    authorisations: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsAuthorisationDto[];
    resubmissions: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto[];
    comments?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsRequestDto {
    wellId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto {
    wellId!: number;
    wellName!: string;
    isPublic!: boolean;
    boreholes!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto[];
    items!: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto[];
    canViewWellBoreholes!: boolean;
    canViewDataSubmissions!: boolean;
    canViewAuthorisations!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholes = [];
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto.fromJS(item));
            }
            this.canViewWellBoreholes = _data["canViewWellBoreholes"];
            this.canViewDataSubmissions = _data["canViewDataSubmissions"];
            this.canViewAuthorisations = _data["canViewAuthorisations"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canViewWellBoreholes"] = this.canViewWellBoreholes;
        data["canViewDataSubmissions"] = this.canViewDataSubmissions;
        data["canViewAuthorisations"] = this.canViewAuthorisations;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResponseDto {
    wellId: number;
    wellName: string;
    isPublic: boolean;
    boreholes: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsBoreholeDto[];
    items: GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsItemDto[];
    canViewWellBoreholes: boolean;
    canViewDataSubmissions: boolean;
    canViewAuthorisations: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto implements IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto {
    id!: number;
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDataMonitoringItemsResubmissionDto {
    id: number;
    name: string;
    isCompleted: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto {
    id!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDetailsRequestDto {
    id: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto {
    uwi!: string;
    name!: string;
    wellStatus?: string | undefined;
    isConfidential!: boolean;
    nopimsJurisdiction?: string | undefined;
    legislation?: string | undefined;
    spudDate?: Date | undefined;
    nopimsTitleType!: NopimsTitleTypeEnum;
    nopimsTitleTypeName?: string | undefined;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
    titleholderCompany?: string | undefined;
    comments?: string | undefined;
    isOffshore!: boolean;
    waterDepthMeters?: number | undefined;
    groundElevationMeters?: number | undefined;
    permanentDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    spatialDatum?: string | undefined;
    stateTerritory?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;
    field?: string | undefined;
    isPublic!: boolean;
    wellAudit?: SecurePortalSimpleAuditEventsDto | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uwi = _data["uwi"];
            this.name = _data["name"];
            this.wellStatus = _data["wellStatus"];
            this.isConfidential = _data["isConfidential"];
            this.nopimsJurisdiction = _data["nopimsJurisdiction"];
            this.legislation = _data["legislation"];
            this.spudDate = _data["spudDate"] ? new Date(_data["spudDate"].toString()) : <any>undefined;
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.nopimsTitleTypeName = _data["nopimsTitleTypeName"];
            this.titleNumber = _data["titleNumber"];
            this.otherTitleNumber = _data["otherTitleNumber"];
            this.titleholderCompany = _data["titleholderCompany"];
            this.comments = _data["comments"];
            this.isOffshore = _data["isOffshore"];
            this.waterDepthMeters = _data["waterDepthMeters"];
            this.groundElevationMeters = _data["groundElevationMeters"];
            this.permanentDatum = _data["permanentDatum"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.spatialDatum = _data["spatialDatum"];
            this.stateTerritory = _data["stateTerritory"];
            this.basin = _data["basin"];
            this.subBasin = _data["subBasin"];
            this.field = _data["field"];
            this.isPublic = _data["isPublic"];
            this.wellAudit = _data["wellAudit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["wellAudit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uwi"] = this.uwi;
        data["name"] = this.name;
        data["wellStatus"] = this.wellStatus;
        data["isConfidential"] = this.isConfidential;
        data["nopimsJurisdiction"] = this.nopimsJurisdiction;
        data["legislation"] = this.legislation;
        data["spudDate"] = this.spudDate ? this.spudDate.toISOString() : <any>undefined;
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["nopimsTitleTypeName"] = this.nopimsTitleTypeName;
        data["titleNumber"] = this.titleNumber;
        data["otherTitleNumber"] = this.otherTitleNumber;
        data["titleholderCompany"] = this.titleholderCompany;
        data["comments"] = this.comments;
        data["isOffshore"] = this.isOffshore;
        data["waterDepthMeters"] = this.waterDepthMeters;
        data["groundElevationMeters"] = this.groundElevationMeters;
        data["permanentDatum"] = this.permanentDatum;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["spatialDatum"] = this.spatialDatum;
        data["stateTerritory"] = this.stateTerritory;
        data["basin"] = this.basin;
        data["subBasin"] = this.subBasin;
        data["field"] = this.field;
        data["isPublic"] = this.isPublic;
        data["wellAudit"] = this.wellAudit ? this.wellAudit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellDetailsResponseDto {
    uwi: string;
    name: string;
    wellStatus?: string | undefined;
    isConfidential: boolean;
    nopimsJurisdiction?: string | undefined;
    legislation?: string | undefined;
    spudDate?: Date | undefined;
    nopimsTitleType: NopimsTitleTypeEnum;
    nopimsTitleTypeName?: string | undefined;
    titleNumber?: string | undefined;
    otherTitleNumber?: string | undefined;
    titleholderCompany?: string | undefined;
    comments?: string | undefined;
    isOffshore: boolean;
    waterDepthMeters?: number | undefined;
    groundElevationMeters?: number | undefined;
    permanentDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    spatialDatum?: string | undefined;
    stateTerritory?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;
    field?: string | undefined;
    isPublic: boolean;
    wellAudit?: SecurePortalSimpleAuditEventsDto | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesWellListItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellListItemDto {
    id!: number;
    uwi!: string;
    name!: string;
    status!: string;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleholder?: string | undefined;
    region?: string | undefined;
    isOffshore!: string;
    spudDate?: Date | undefined;
    isPublic!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uwi = _data["uwi"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
            this.titleholder = _data["titleholder"];
            this.region = _data["region"];
            this.isOffshore = _data["isOffshore"];
            this.spudDate = _data["spudDate"] ? new Date(_data["spudDate"].toString()) : <any>undefined;
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uwi"] = this.uwi;
        data["name"] = this.name;
        data["status"] = this.status;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        data["titleholder"] = this.titleholder;
        data["region"] = this.region;
        data["isOffshore"] = this.isOffshore;
        data["spudDate"] = this.spudDate ? this.spudDate.toISOString() : <any>undefined;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellListItemDto {
    id: number;
    uwi: string;
    name: string;
    status: string;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
    titleholder?: string | undefined;
    region?: string | undefined;
    isOffshore: string;
    spudDate?: Date | undefined;
    isPublic: boolean;
}

export class GetGeoscienceAustraliaWellsBoreholesWellListRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellListRequestDto {
    searchText?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellListRequestDto {
    searchText?: string | undefined;
}

export class GetGeoscienceAustraliaWellsBoreholesWellListResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellListResponseDto {
    wells!: GetGeoscienceAustraliaWellsBoreholesWellListItemDto[];
    isResultSetLimited!: boolean;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wells = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wells"])) {
                this.wells = [] as any;
                for (let item of _data["wells"])
                    this.wells!.push(GetGeoscienceAustraliaWellsBoreholesWellListItemDto.fromJS(item));
            }
            this.isResultSetLimited = _data["isResultSetLimited"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wells)) {
            data["wells"] = [];
            for (let item of this.wells)
                data["wells"].push(item.toJSON());
        }
        data["isResultSetLimited"] = this.isResultSetLimited;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellListResponseDto {
    wells: GetGeoscienceAustraliaWellsBoreholesWellListItemDto[];
    isResultSetLimited: boolean;
}

export class GetGeoscienceAustraliaBoreholeIdentifierDto implements IGetGeoscienceAustraliaBoreholeIdentifierDto {
    boreholeId!: number;
    name?: string | undefined;

    constructor(data?: IGetGeoscienceAustraliaBoreholeIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boreholeId = _data["boreholeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaBoreholeIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaBoreholeIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boreholeId"] = this.boreholeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaBoreholeIdentifierDto {
    boreholeId: number;
    name?: string | undefined;
}

export class GetGeoscienceAustraliaWellReportAttachmentsRequestDto implements IGetGeoscienceAustraliaWellReportAttachmentsRequestDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellReportAttachmentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellReportAttachmentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellReportAttachmentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellReportAttachmentsRequestDto {
    wellId: number;
}

export class GetGeoscienceAustraliaWellReportAttachmentsResponseDto implements IGetGeoscienceAustraliaWellReportAttachmentsResponseDto {
    wellId!: number;
    wellName?: string | undefined;
    isPublic!: boolean;
    boreholeIdentifiers!: GetGeoscienceAustraliaBoreholeIdentifierDto[];
    attachments!: GetGeoscienceAustraliaReportAttachmentsItemDto[];

    constructor(data?: IGetGeoscienceAustraliaWellReportAttachmentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boreholeIdentifiers = [];
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["boreholeIdentifiers"])) {
                this.boreholeIdentifiers = [] as any;
                for (let item of _data["boreholeIdentifiers"])
                    this.boreholeIdentifiers!.push(GetGeoscienceAustraliaBoreholeIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetGeoscienceAustraliaReportAttachmentsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellReportAttachmentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellReportAttachmentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.boreholeIdentifiers)) {
            data["boreholeIdentifiers"] = [];
            for (let item of this.boreholeIdentifiers)
                data["boreholeIdentifiers"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellReportAttachmentsResponseDto {
    wellId: number;
    wellName?: string | undefined;
    isPublic: boolean;
    boreholeIdentifiers: GetGeoscienceAustraliaBoreholeIdentifierDto[];
    attachments: GetGeoscienceAustraliaReportAttachmentsItemDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsItemDto {
    id!: number;
    versionNumber!: number;
    itemId!: string;
    publicTitle!: string;
    isPublic!: boolean;
    reportType!: string;
    receivedDate?: Date | undefined;
    wellBoreholes!: GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks!: string;
    reportTitle!: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated!: Date;
    dateLastModified!: Date;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wellBoreholes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.itemId = _data["itemId"];
            this.publicTitle = _data["publicTitle"];
            this.isPublic = _data["isPublic"];
            this.reportType = _data["reportType"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto.fromJS(item));
            }
            this.isConfidential = _data["isConfidential"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.reportTitle = _data["reportTitle"];
            this.consignment = _data["consignment"];
            this.loanStatus = _data["loanStatus"];
            this.conditionStatus = _data["conditionStatus"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["itemId"] = this.itemId;
        data["publicTitle"] = this.publicTitle;
        data["isPublic"] = this.isPublic;
        data["reportType"] = this.reportType;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        data["isConfidential"] = this.isConfidential;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["reportTitle"] = this.reportTitle;
        data["consignment"] = this.consignment;
        data["loanStatus"] = this.loanStatus;
        data["conditionStatus"] = this.conditionStatus;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsItemDto {
    id: number;
    versionNumber: number;
    itemId: string;
    publicTitle: string;
    isPublic: boolean;
    reportType: string;
    receivedDate?: Date | undefined;
    wellBoreholes: GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto[];
    isConfidential?: string | undefined;
    confidentialityRemarks: string;
    reportTitle: string;
    consignment?: string | undefined;
    loanStatus?: string | undefined;
    conditionStatus?: string | undefined;
    dateCreated: Date;
    dateLastModified: Date;
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto {
    id: number;
    name: string;
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
    wellId!: number;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
    wellId: number;
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
    wellName!: string;
    isPublic!: boolean;
    items!: GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto[];
    wellBoreholes!: GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto[];
    loanStatuses!: GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto[];
    conditionStatuses!: GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto[];

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.wellBoreholes = [];
            this.loanStatuses = [];
            this.conditionStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellName = _data["wellName"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto.fromJS(item));
            }
            if (Array.isArray(_data["wellBoreholes"])) {
                this.wellBoreholes = [] as any;
                for (let item of _data["wellBoreholes"])
                    this.wellBoreholes!.push(GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["loanStatuses"])) {
                this.loanStatuses = [] as any;
                for (let item of _data["loanStatuses"])
                    this.loanStatuses!.push(GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionStatuses"])) {
                this.conditionStatuses = [] as any;
                for (let item of _data["conditionStatuses"])
                    this.conditionStatuses!.push(GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellName"] = this.wellName;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.wellBoreholes)) {
            data["wellBoreholes"] = [];
            for (let item of this.wellBoreholes)
                data["wellBoreholes"].push(item.toJSON());
        }
        if (Array.isArray(this.loanStatuses)) {
            data["loanStatuses"] = [];
            for (let item of this.loanStatuses)
                data["loanStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionStatuses)) {
            data["conditionStatuses"] = [];
            for (let item of this.conditionStatuses)
                data["conditionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
    wellName: string;
    isPublic: boolean;
    items: GetGeoscienceAustraliaWellsBoreholesWellReportsItemDto[];
    wellBoreholes: GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto[];
    loanStatuses: GetGeoscienceAustraliaWellsBoreholesWellReportsLoanStatusDto[];
    conditionStatuses: GetGeoscienceAustraliaWellsBoreholesWellReportsConditionStatusDto[];
}

export class GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto implements IGetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto {
    id!: number;
    name!: string;

    constructor(data?: IGetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeoscienceAustraliaWellsBoreholesWellReportsWellBoreholeItemDto {
    id: number;
    name: string;
}

export class UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto implements IUpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto {
    versionNumber!: number;
    id!: number;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto {
    versionNumber: number;
    id: number;
}

export class UpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto implements IUpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto[] | undefined;
    updateConfidentiality!: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks!: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate!: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment!: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus!: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus!: boolean;
    loanStatusId?: number | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto.fromJS(item));
            }
            this.updateConfidentiality = _data["updateConfidentiality"];
            this.confidentiality = _data["confidentiality"];
            this.updateConfidentialityRemarks = _data["updateConfidentialityRemarks"];
            this.confidentialityRemarksUpdateType = _data["confidentialityRemarksUpdateType"];
            this.confidentialityRemarks = _data["confidentialityRemarks"];
            this.updateReceivedDate = _data["updateReceivedDate"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.receivedDateOffset = _data["receivedDateOffset"];
            this.updateConsignment = _data["updateConsignment"];
            this.consignmentUpdateType = _data["consignmentUpdateType"];
            this.consignment = _data["consignment"];
            this.updateConditionStatus = _data["updateConditionStatus"];
            this.conditionStatusId = _data["conditionStatusId"];
            this.updateLoanStatus = _data["updateLoanStatus"];
            this.loanStatusId = _data["loanStatusId"];
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["updateConfidentiality"] = this.updateConfidentiality;
        data["confidentiality"] = this.confidentiality;
        data["updateConfidentialityRemarks"] = this.updateConfidentialityRemarks;
        data["confidentialityRemarksUpdateType"] = this.confidentialityRemarksUpdateType;
        data["confidentialityRemarks"] = this.confidentialityRemarks;
        data["updateReceivedDate"] = this.updateReceivedDate;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["receivedDateOffset"] = this.receivedDateOffset;
        data["updateConsignment"] = this.updateConsignment;
        data["consignmentUpdateType"] = this.consignmentUpdateType;
        data["consignment"] = this.consignment;
        data["updateConditionStatus"] = this.updateConditionStatus;
        data["conditionStatusId"] = this.conditionStatusId;
        data["updateLoanStatus"] = this.updateLoanStatus;
        data["loanStatusId"] = this.loanStatusId;
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesWellReportsRequestDto {
    reports?: UpdateGeoscienceAustraliaWellsBoreholesWellReportsReportDto[] | undefined;
    updateConfidentiality: boolean;
    confidentiality?: boolean | undefined;
    updateConfidentialityRemarks: boolean;
    confidentialityRemarksUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    confidentialityRemarks?: string | undefined;
    updateReceivedDate: boolean;
    receivedDate?: Date | undefined;
    receivedDateOffset?: number | undefined;
    updateConsignment: boolean;
    consignmentUpdateType?: ReportsStringUpdateTypeEnum | undefined;
    consignment?: string | undefined;
    updateConditionStatus: boolean;
    conditionStatusId?: number | undefined;
    updateLoanStatus: boolean;
    loanStatusId?: number | undefined;
}

export class UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto implements IUpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;

    constructor(data?: IUpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
            if (Array.isArray(_data["failedReportIds"])) {
                this.failedReportIds = [] as any;
                for (let item of _data["failedReportIds"])
                    this.failedReportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        if (Array.isArray(this.failedReportIds)) {
            data["failedReportIds"] = [];
            for (let item of this.failedReportIds)
                data["failedReportIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGeoscienceAustraliaWellsBoreholesWellReportsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
    failedReportIds?: number[] | undefined;
}

export class GetJointAuthorityAccountMyDetailsRequestDto implements IGetJointAuthorityAccountMyDetailsRequestDto {

    constructor(data?: IGetJointAuthorityAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityAccountMyDetailsRequestDto {
}

export class GetJointAuthorityAccountMyDetailsResponseDto implements IGetJointAuthorityAccountMyDetailsResponseDto {
    versionNumber!: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    jointAuthorityId?: number | undefined;
    jointAuthorityName?: string | undefined;
    jointAuthorityAdministrators!: UserContactDto[];
    existingRoles!: SecureUserJointAuthorityRoleDto;
    pendingRequests!: JointAuthorityAccountMyDetailsPendingRequestsDto[];
    notificationTypes!: SecureUserNotificationTypesDto[];
    audit!: SecurePortalSimpleAuditEventsDto;

    constructor(data?: IGetJointAuthorityAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jointAuthorityAdministrators = [];
            this.existingRoles = new SecureUserJointAuthorityRoleDto();
            this.pendingRequests = [];
            this.notificationTypes = [];
            this.audit = new SecurePortalSimpleAuditEventsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            if (Array.isArray(_data["jointAuthorityAdministrators"])) {
                this.jointAuthorityAdministrators = [] as any;
                for (let item of _data["jointAuthorityAdministrators"])
                    this.jointAuthorityAdministrators!.push(UserContactDto.fromJS(item));
            }
            this.existingRoles = _data["existingRoles"] ? SecureUserJointAuthorityRoleDto.fromJS(_data["existingRoles"]) : new SecureUserJointAuthorityRoleDto();
            if (Array.isArray(_data["pendingRequests"])) {
                this.pendingRequests = [] as any;
                for (let item of _data["pendingRequests"])
                    this.pendingRequests!.push(JointAuthorityAccountMyDetailsPendingRequestsDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(SecureUserNotificationTypesDto.fromJS(item));
            }
            this.audit = _data["audit"] ? SecurePortalSimpleAuditEventsDto.fromJS(_data["audit"]) : new SecurePortalSimpleAuditEventsDto();
        }
    }

    static fromJS(data: any): GetJointAuthorityAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        if (Array.isArray(this.jointAuthorityAdministrators)) {
            data["jointAuthorityAdministrators"] = [];
            for (let item of this.jointAuthorityAdministrators)
                data["jointAuthorityAdministrators"].push(item.toJSON());
        }
        data["existingRoles"] = this.existingRoles ? this.existingRoles.toJSON() : <any>undefined;
        if (Array.isArray(this.pendingRequests)) {
            data["pendingRequests"] = [];
            for (let item of this.pendingRequests)
                data["pendingRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item.toJSON());
        }
        data["audit"] = this.audit ? this.audit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJointAuthorityAccountMyDetailsResponseDto {
    versionNumber: number;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    jointAuthorityId?: number | undefined;
    jointAuthorityName?: string | undefined;
    jointAuthorityAdministrators: UserContactDto[];
    existingRoles: SecureUserJointAuthorityRoleDto;
    pendingRequests: JointAuthorityAccountMyDetailsPendingRequestsDto[];
    notificationTypes: SecureUserNotificationTypesDto[];
    audit: SecurePortalSimpleAuditEventsDto;
}

export class JointAuthorityAccountMyDetailsPendingRequestsDto implements IJointAuthorityAccountMyDetailsPendingRequestsDto {
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    secureRequestGroupId!: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime!: Date;
    rolesRequested!: SecureRoleEnum[];

    constructor(data?: IJointAuthorityAccountMyDetailsPendingRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.secureRequestGroupCode = _data["secureRequestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
        }
    }

    static fromJS(data: any): JointAuthorityAccountMyDetailsPendingRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityAccountMyDetailsPendingRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["secureRequestGroupCode"] = this.secureRequestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        return data;
    }
}

export interface IJointAuthorityAccountMyDetailsPendingRequestsDto {
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    secureRequestGroupId: number;
    secureRequestGroupCode?: string | undefined;
    requestDatetime: Date;
    rolesRequested: SecureRoleEnum[];
}

export class SaveJointAuthorityAccountMyDetailsRequestDto implements ISaveJointAuthorityAccountMyDetailsRequestDto {
    versionNumber!: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    notificationTypes?: SecureEntityTypeNotificationTypeEnum[] | undefined;

    constructor(data?: ISaveJointAuthorityAccountMyDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveJointAuthorityAccountMyDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJointAuthorityAccountMyDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item);
        }
        return data;
    }
}

export interface ISaveJointAuthorityAccountMyDetailsRequestDto {
    versionNumber: number;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    notificationTypes?: SecureEntityTypeNotificationTypeEnum[] | undefined;
}

export class SaveJointAuthorityAccountMyDetailsResponseDto implements ISaveJointAuthorityAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;

    constructor(data?: ISaveJointAuthorityAccountMyDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveJointAuthorityAccountMyDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJointAuthorityAccountMyDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveJointAuthorityAccountMyDetailsResponseDto {
    statusMessages?: StatusMessagesDto | undefined;
}

export class SecureUserJointAuthorityRoleDto implements ISecureUserJointAuthorityRoleDto {
    hasJaMembership!: boolean;
    activeRoles!: SecureRoleEnum[];
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;

    constructor(data?: ISecureUserJointAuthorityRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasJaMembership = _data["hasJaMembership"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedDatetime = _data["lastUpdatedDatetime"] ? new Date(_data["lastUpdatedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SecureUserJointAuthorityRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserJointAuthorityRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasJaMembership"] = this.hasJaMembership;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedDatetime"] = this.lastUpdatedDatetime ? this.lastUpdatedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISecureUserJointAuthorityRoleDto {
    hasJaMembership: boolean;
    activeRoles: SecureRoleEnum[];
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
}

export class CreateJointAuthorityAccountRequestAccessJaaRequestDto implements ICreateJointAuthorityAccountRequestAccessJaaRequestDto {
    jointAuthorityId!: number;
    submittedComments?: string | undefined;
    jaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateJointAuthorityAccountRequestAccessJaaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.submittedComments = _data["submittedComments"];
            this.jaaAuthoritySupportingDocument = _data["jaaAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["jaaAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateJointAuthorityAccountRequestAccessJaaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJointAuthorityAccountRequestAccessJaaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["submittedComments"] = this.submittedComments;
        data["jaaAuthoritySupportingDocument"] = this.jaaAuthoritySupportingDocument ? this.jaaAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateJointAuthorityAccountRequestAccessJaaRequestDto {
    jointAuthorityId: number;
    submittedComments?: string | undefined;
    jaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateJointAuthorityAccountRequestAccessJaaResponseDto implements ICreateJointAuthorityAccountRequestAccessJaaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateJointAuthorityAccountRequestAccessJaaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateJointAuthorityAccountRequestAccessJaaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJointAuthorityAccountRequestAccessJaaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateJointAuthorityAccountRequestAccessJaaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateJointAuthorityAccountRequestAccessJarRequestDto implements ICreateJointAuthorityAccountRequestAccessJarRequestDto {
    jointAuthorityId!: number;
    submittedComments?: string | undefined;
    jointAuthorityStandardRolesRequest?: JointAuthorityStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateJointAuthorityAccountRequestAccessJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.submittedComments = _data["submittedComments"];
            this.jointAuthorityStandardRolesRequest = _data["jointAuthorityStandardRolesRequest"] ? JointAuthorityStandardRoleRequestDetailsDto.fromJS(_data["jointAuthorityStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateJointAuthorityAccountRequestAccessJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJointAuthorityAccountRequestAccessJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["submittedComments"] = this.submittedComments;
        data["jointAuthorityStandardRolesRequest"] = this.jointAuthorityStandardRolesRequest ? this.jointAuthorityStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateJointAuthorityAccountRequestAccessJarRequestDto {
    jointAuthorityId: number;
    submittedComments?: string | undefined;
    jointAuthorityStandardRolesRequest?: JointAuthorityStandardRoleRequestDetailsDto | undefined;
}

export class CreateJointAuthorityAccountRequestAccessJarResponseDto implements ICreateJointAuthorityAccountRequestAccessJarResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateJointAuthorityAccountRequestAccessJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateJointAuthorityAccountRequestAccessJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJointAuthorityAccountRequestAccessJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateJointAuthorityAccountRequestAccessJarResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetJointAuthorityAccountRequestAccessReferenceDataRequestDto implements IGetJointAuthorityAccountRequestAccessReferenceDataRequestDto {

    constructor(data?: IGetJointAuthorityAccountRequestAccessReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityAccountRequestAccessReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityAccountRequestAccessReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityAccountRequestAccessReferenceDataRequestDto {
}

export class GetJointAuthorityAccountRequestAccessReferenceDataResponseDto implements IGetJointAuthorityAccountRequestAccessReferenceDataResponseDto {
    jointAuthorities!: SecureUserJointAuthorityDto[];

    constructor(data?: IGetJointAuthorityAccountRequestAccessReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jointAuthorities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jointAuthorities"])) {
                this.jointAuthorities = [] as any;
                for (let item of _data["jointAuthorities"])
                    this.jointAuthorities!.push(SecureUserJointAuthorityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityAccountRequestAccessReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityAccountRequestAccessReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jointAuthorities)) {
            data["jointAuthorities"] = [];
            for (let item of this.jointAuthorities)
                data["jointAuthorities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityAccountRequestAccessReferenceDataResponseDto {
    jointAuthorities: SecureUserJointAuthorityDto[];
}

export class SecureUserJointAuthorityDto implements ISecureUserJointAuthorityDto {
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    hasPendingRequest!: boolean;
    hasJointAuthorityAdministrator!: boolean;
    activeRoles!: SecureRoleEnum[];
    isJointAuthorityAdministrator!: boolean;
    isJointAuthoritySigner!: boolean;
    hasAllSpecialRoles!: boolean;
    hasAllGeneralRoles!: boolean;

    constructor(data?: ISecureUserJointAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.hasJointAuthorityAdministrator = _data["hasJointAuthorityAdministrator"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
            this.isJointAuthorityAdministrator = _data["isJointAuthorityAdministrator"];
            this.isJointAuthoritySigner = _data["isJointAuthoritySigner"];
            this.hasAllSpecialRoles = _data["hasAllSpecialRoles"];
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): SecureUserJointAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserJointAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["hasJointAuthorityAdministrator"] = this.hasJointAuthorityAdministrator;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        data["isJointAuthorityAdministrator"] = this.isJointAuthorityAdministrator;
        data["isJointAuthoritySigner"] = this.isJointAuthoritySigner;
        data["hasAllSpecialRoles"] = this.hasAllSpecialRoles;
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface ISecureUserJointAuthorityDto {
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    hasPendingRequest: boolean;
    hasJointAuthorityAdministrator: boolean;
    activeRoles: SecureRoleEnum[];
    isJointAuthorityAdministrator: boolean;
    isJointAuthoritySigner: boolean;
    hasAllSpecialRoles: boolean;
    hasAllGeneralRoles: boolean;
}

export class JointAuthorityApplicationListItemDto implements IJointAuthorityApplicationListItemDto {
    applicationLink!: ApplicationLinkDto;
    trackingNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    isWithJa!: boolean;
    applicationStatusDisplay?: string | undefined;
    statusDate?: Date | undefined;
    daysAtStatus!: number;
    timeframe!: number;
    submittedDate?: Date | undefined;
    titleLinks!: TitleLinkDto[];
    titleNumbers?: string | undefined;
    titleTypeDisplay?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;

    constructor(data?: IJointAuthorityApplicationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicationLink = new ApplicationLinkDto();
            this.titleLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationLink = _data["applicationLink"] ? ApplicationLinkDto.fromJS(_data["applicationLink"]) : new ApplicationLinkDto();
            this.trackingNumber = _data["trackingNumber"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.applicationName = _data["applicationName"];
            this.isWithJa = _data["isWithJa"];
            this.applicationStatusDisplay = _data["applicationStatusDisplay"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.daysAtStatus = _data["daysAtStatus"];
            this.timeframe = _data["timeframe"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["titleLinks"])) {
                this.titleLinks = [] as any;
                for (let item of _data["titleLinks"])
                    this.titleLinks!.push(TitleLinkDto.fromJS(item));
            }
            this.titleNumbers = _data["titleNumbers"];
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): JointAuthorityApplicationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityApplicationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationLink"] = this.applicationLink ? this.applicationLink.toJSON() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["applicationTypeName"] = this.applicationTypeName;
        data["applicationName"] = this.applicationName;
        data["isWithJa"] = this.isWithJa;
        data["applicationStatusDisplay"] = this.applicationStatusDisplay;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["daysAtStatus"] = this.daysAtStatus;
        data["timeframe"] = this.timeframe;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.titleLinks)) {
            data["titleLinks"] = [];
            for (let item of this.titleLinks)
                data["titleLinks"].push(item.toJSON());
        }
        data["titleNumbers"] = this.titleNumbers;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IJointAuthorityApplicationListItemDto {
    applicationLink: ApplicationLinkDto;
    trackingNumber?: string | undefined;
    applicationTypeName?: string | undefined;
    applicationName?: string | undefined;
    isWithJa: boolean;
    applicationStatusDisplay?: string | undefined;
    statusDate?: Date | undefined;
    daysAtStatus: number;
    timeframe: number;
    submittedDate?: Date | undefined;
    titleLinks: TitleLinkDto[];
    titleNumbers?: string | undefined;
    titleTypeDisplay?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
}

export class JointAuthoritySecureUserDetailsDto implements IJointAuthoritySecureUserDetailsDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    registrationDatetime!: Date;
    lastLoginDatetime?: Date | undefined;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    isSecureUserBlocked!: boolean;
    isSecureUserSignedIn!: boolean;
    hasPendingRequest!: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
    hasInactivityWarning!: boolean;
    badgeSortOrder!: number;
    activeRoles!: SecureRoleEnum[];

    constructor(data?: IJointAuthoritySecureUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.accountStatus = _data["accountStatus"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.correspondenceEmailAddress = _data["correspondenceEmailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.isSecureUserSignedIn = _data["isSecureUserSignedIn"];
            this.hasPendingRequest = _data["hasPendingRequest"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedDatetime = _data["lastUpdatedDatetime"] ? new Date(_data["lastUpdatedDatetime"].toString()) : <any>undefined;
            this.hasInactivityWarning = _data["hasInactivityWarning"];
            this.badgeSortOrder = _data["badgeSortOrder"];
            if (Array.isArray(_data["activeRoles"])) {
                this.activeRoles = [] as any;
                for (let item of _data["activeRoles"])
                    this.activeRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): JointAuthoritySecureUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthoritySecureUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["accountStatus"] = this.accountStatus;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["correspondenceEmailAddress"] = this.correspondenceEmailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["isSecureUserSignedIn"] = this.isSecureUserSignedIn;
        data["hasPendingRequest"] = this.hasPendingRequest;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedDatetime"] = this.lastUpdatedDatetime ? this.lastUpdatedDatetime.toISOString() : <any>undefined;
        data["hasInactivityWarning"] = this.hasInactivityWarning;
        data["badgeSortOrder"] = this.badgeSortOrder;
        if (Array.isArray(this.activeRoles)) {
            data["activeRoles"] = [];
            for (let item of this.activeRoles)
                data["activeRoles"].push(item);
        }
        return data;
    }
}

export interface IJointAuthoritySecureUserDetailsDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    registrationDatetime: Date;
    lastLoginDatetime?: Date | undefined;
    accountStatus?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    correspondenceEmailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    isSecureUserBlocked: boolean;
    isSecureUserSignedIn: boolean;
    hasPendingRequest: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedDatetime?: Date | undefined;
    hasInactivityWarning: boolean;
    badgeSortOrder: number;
    activeRoles: SecureRoleEnum[];
}

export class JointAuthorityTitleListItemDto implements IJointAuthorityTitleListItemDto {
    titleLink!: TitleLinkDto;
    titleTypeDisplay?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    titleHoldersDisplay?: string | undefined;

    constructor(data?: IJointAuthorityTitleListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLink = new TitleLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : new TitleLinkDto();
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.titleStatus = _data["titleStatus"];
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.anniversaryDate = _data["anniversaryDate"] ? new Date(_data["anniversaryDate"].toString()) : <any>undefined;
            this.titleHoldersDisplay = _data["titleHoldersDisplay"];
        }
    }

    static fromJS(data: any): JointAuthorityTitleListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityTitleListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["titleStatus"] = this.titleStatus;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["titleHoldersDisplay"] = this.titleHoldersDisplay;
        return data;
    }
}

export interface IJointAuthorityTitleListItemDto {
    titleLink: TitleLinkDto;
    titleTypeDisplay?: string | undefined;
    titleStatus?: string | undefined;
    currentExpiryDate?: Date | undefined;
    anniversaryDate?: Date | undefined;
    titleHoldersDisplay?: string | undefined;
}

export class GetJointAuthorityHomeDashboardRequestDto implements IGetJointAuthorityHomeDashboardRequestDto {

    constructor(data?: IGetJointAuthorityHomeDashboardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityHomeDashboardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityHomeDashboardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityHomeDashboardRequestDto {
}

export class GetJointAuthorityHomeDashboardResponseDto implements IGetJointAuthorityHomeDashboardResponseDto {
    hasAssociatedJointAuthorities!: boolean;
    isApplicationsTileVisible!: boolean;
    isTitlesTileVisible!: boolean;
    applications!: JointAuthorityApplicationListItemDto[];
    titles!: JointAuthorityTitleListItemDto[];

    constructor(data?: IGetJointAuthorityHomeDashboardResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAssociatedJointAuthorities = _data["hasAssociatedJointAuthorities"];
            this.isApplicationsTileVisible = _data["isApplicationsTileVisible"];
            this.isTitlesTileVisible = _data["isTitlesTileVisible"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(JointAuthorityApplicationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(JointAuthorityTitleListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityHomeDashboardResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityHomeDashboardResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssociatedJointAuthorities"] = this.hasAssociatedJointAuthorities;
        data["isApplicationsTileVisible"] = this.isApplicationsTileVisible;
        data["isTitlesTileVisible"] = this.isTitlesTileVisible;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityHomeDashboardResponseDto {
    hasAssociatedJointAuthorities: boolean;
    isApplicationsTileVisible: boolean;
    isTitlesTileVisible: boolean;
    applications: JointAuthorityApplicationListItemDto[];
    titles: JointAuthorityTitleListItemDto[];
}

export class GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto implements IGetJointAuthorityOeiLicenceDetailsMemorialApplicationDto {
    applicationId!: string;
    applicationTypeName!: string;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision!: string;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;

    constructor(data?: IGetJointAuthorityOeiLicenceDetailsMemorialApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.decision = _data["decision"];
            this.implementedDate = _data["implementedDate"] ? new Date(_data["implementedDate"].toString()) : <any>undefined;
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationTypeName"] = this.applicationTypeName;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["decision"] = this.decision;
        data["implementedDate"] = this.implementedDate ? this.implementedDate.toISOString() : <any>undefined;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceDetailsMemorialApplicationDto {
    applicationId: string;
    applicationTypeName: string;
    executedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    decision: string;
    implementedDate?: Date | undefined;
    registeredDate?: Date | undefined;
    fileId?: number | undefined;
}

export class GetJointAuthorityOeiLicenceDetailsRequestDto implements IGetJointAuthorityOeiLicenceDetailsRequestDto {
    licenceId!: number;

    constructor(data?: IGetJointAuthorityOeiLicenceDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceDetailsRequestDto {
    licenceId: number;
}

export class GetJointAuthorityOeiLicenceDetailsResponseDto implements IGetJointAuthorityOeiLicenceDetailsResponseDto {
    licenceId!: number;
    summary!: GetJointAuthorityOeiLicenceDetailsSummaryDto;
    memorial!: GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto[];

    constructor(data?: IGetJointAuthorityOeiLicenceDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new GetJointAuthorityOeiLicenceDetailsSummaryDto();
            this.memorial = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.summary = _data["summary"] ? GetJointAuthorityOeiLicenceDetailsSummaryDto.fromJS(_data["summary"]) : new GetJointAuthorityOeiLicenceDetailsSummaryDto();
            if (Array.isArray(_data["memorial"])) {
                this.memorial = [] as any;
                for (let item of _data["memorial"])
                    this.memorial!.push(GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.memorial)) {
            data["memorial"] = [];
            for (let item of this.memorial)
                data["memorial"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceDetailsResponseDto {
    licenceId: number;
    summary: GetJointAuthorityOeiLicenceDetailsSummaryDto;
    memorial: GetJointAuthorityOeiLicenceDetailsMemorialApplicationDto[];
}

export class GetJointAuthorityOeiLicenceDetailsSummaryDto implements IGetJointAuthorityOeiLicenceDetailsSummaryDto {
    licenceNumber!: string;
    projectName!: string;
    licenceTypeDescription!: string;
    licenceStatusDescription!: string;
    legislationDescription!: string;
    declaredAreaName!: string;
    grantDate!: Date;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    ceaseDate?: Date | undefined;
    licenceHolderId!: number;
    licenceHolderName!: string;
    finalisedArea!: number;
    finalisedGenerationCapacity!: number;
    renewableEnergyResourceDescription!: string;
    technologyToBeInvestigatedDescription!: string;
    relatedLicences!: LicenceLinkDto[];

    constructor(data?: IGetJointAuthorityOeiLicenceDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedLicences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"];
            this.projectName = _data["projectName"];
            this.licenceTypeDescription = _data["licenceTypeDescription"];
            this.licenceStatusDescription = _data["licenceStatusDescription"];
            this.legislationDescription = _data["legislationDescription"];
            this.declaredAreaName = _data["declaredAreaName"];
            this.grantDate = _data["grantDate"] ? new Date(_data["grantDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.ceaseDate = _data["ceaseDate"] ? new Date(_data["ceaseDate"].toString()) : <any>undefined;
            this.licenceHolderId = _data["licenceHolderId"];
            this.licenceHolderName = _data["licenceHolderName"];
            this.finalisedArea = _data["finalisedArea"];
            this.finalisedGenerationCapacity = _data["finalisedGenerationCapacity"];
            this.renewableEnergyResourceDescription = _data["renewableEnergyResourceDescription"];
            this.technologyToBeInvestigatedDescription = _data["technologyToBeInvestigatedDescription"];
            if (Array.isArray(_data["relatedLicences"])) {
                this.relatedLicences = [] as any;
                for (let item of _data["relatedLicences"])
                    this.relatedLicences!.push(LicenceLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber;
        data["projectName"] = this.projectName;
        data["licenceTypeDescription"] = this.licenceTypeDescription;
        data["licenceStatusDescription"] = this.licenceStatusDescription;
        data["legislationDescription"] = this.legislationDescription;
        data["declaredAreaName"] = this.declaredAreaName;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["ceaseDate"] = this.ceaseDate ? this.ceaseDate.toISOString() : <any>undefined;
        data["licenceHolderId"] = this.licenceHolderId;
        data["licenceHolderName"] = this.licenceHolderName;
        data["finalisedArea"] = this.finalisedArea;
        data["finalisedGenerationCapacity"] = this.finalisedGenerationCapacity;
        data["renewableEnergyResourceDescription"] = this.renewableEnergyResourceDescription;
        data["technologyToBeInvestigatedDescription"] = this.technologyToBeInvestigatedDescription;
        if (Array.isArray(this.relatedLicences)) {
            data["relatedLicences"] = [];
            for (let item of this.relatedLicences)
                data["relatedLicences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceDetailsSummaryDto {
    licenceNumber: string;
    projectName: string;
    licenceTypeDescription: string;
    licenceStatusDescription: string;
    legislationDescription: string;
    declaredAreaName: string;
    grantDate: Date;
    endDate?: Date | undefined;
    comesIntoForceDate?: Date | undefined;
    ceaseDate?: Date | undefined;
    licenceHolderId: number;
    licenceHolderName: string;
    finalisedArea: number;
    finalisedGenerationCapacity: number;
    renewableEnergyResourceDescription: string;
    technologyToBeInvestigatedDescription: string;
    relatedLicences: LicenceLinkDto[];
}

export class GetJointAuthorityOeiLicenceListLicenceDto implements IGetJointAuthorityOeiLicenceListLicenceDto {
    licenceLink!: LicenceLinkDto;
    licenceTypeDisplay!: string;
    licenceStatusDisplay?: string | undefined;
    licenceHolderDisplay?: string | undefined;
    comesIntoForceDate!: Date;
    endDate!: Date;

    constructor(data?: IGetJointAuthorityOeiLicenceListLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licenceLink = new LicenceLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceLink = _data["licenceLink"] ? LicenceLinkDto.fromJS(_data["licenceLink"]) : new LicenceLinkDto();
            this.licenceTypeDisplay = _data["licenceTypeDisplay"];
            this.licenceStatusDisplay = _data["licenceStatusDisplay"];
            this.licenceHolderDisplay = _data["licenceHolderDisplay"];
            this.comesIntoForceDate = _data["comesIntoForceDate"] ? new Date(_data["comesIntoForceDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceListLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceListLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        data["licenceTypeDisplay"] = this.licenceTypeDisplay;
        data["licenceStatusDisplay"] = this.licenceStatusDisplay;
        data["licenceHolderDisplay"] = this.licenceHolderDisplay;
        data["comesIntoForceDate"] = this.comesIntoForceDate ? this.comesIntoForceDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceListLicenceDto {
    licenceLink: LicenceLinkDto;
    licenceTypeDisplay: string;
    licenceStatusDisplay?: string | undefined;
    licenceHolderDisplay?: string | undefined;
    comesIntoForceDate: Date;
    endDate: Date;
}

export class GetJointAuthorityOeiLicenceListRequestDto implements IGetJointAuthorityOeiLicenceListRequestDto {

    constructor(data?: IGetJointAuthorityOeiLicenceListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceListRequestDto {
}

export class GetJointAuthorityOeiLicenceListResponseDto implements IGetJointAuthorityOeiLicenceListResponseDto {
    licences!: GetJointAuthorityOeiLicenceListLicenceDto[];

    constructor(data?: IGetJointAuthorityOeiLicenceListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(GetJointAuthorityOeiLicenceListLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOeiLicenceListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOeiLicenceListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOeiLicenceListResponseDto {
    licences: GetJointAuthorityOeiLicenceListLicenceDto[];
}

export class GetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto implements IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto implements IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto {
    items!: GetApplicationDetailsItemDto[];

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetApplicationDetailsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsApplicationDetailsResponseDto {
    items: GetApplicationDetailsItemDto[];
}

export class GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto implements IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto {
    status!: string;
    startedDatetime!: Date;
    daysAtStatus!: number;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.startedDatetime = _data["startedDatetime"] ? new Date(_data["startedDatetime"].toString()) : <any>undefined;
            this.daysAtStatus = _data["daysAtStatus"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["startedDatetime"] = this.startedDatetime ? this.startedDatetime.toISOString() : <any>undefined;
        data["daysAtStatus"] = this.daysAtStatus;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto {
    status: string;
    startedDatetime: Date;
    daysAtStatus: number;
}

export class GetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto implements IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto implements IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto {
    items!: GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto[];

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsApprovalTrackingResponseDto {
    items: GetJointAuthorityOpggsApplicationDetailsApprovalTrackingItemDto[];
}

export class GetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto implements IGetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsBlockDetailsRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto implements IGetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto {
    blocks!: GetBlockDetailsItemDto[];
    showLocationDetails!: boolean;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.blocks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(GetBlockDetailsItemDto.fromJS(item));
            }
            this.showLocationDetails = _data["showLocationDetails"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["showLocationDetails"] = this.showLocationDetails;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsBlockDetailsResponseDto {
    blocks: GetBlockDetailsItemDto[];
    showLocationDetails: boolean;
}

export class GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto implements IGetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
    authorisationId?: string | undefined;
    documentName!: string;
    documentSize!: number;
    canDownload!: boolean;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
            this.documentName = _data["documentName"];
            this.documentSize = _data["documentSize"];
            this.canDownload = _data["canDownload"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        data["documentName"] = this.documentName;
        data["documentSize"] = this.documentSize;
        data["canDownload"] = this.canDownload;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto {
    authorisationId?: string | undefined;
    documentName: string;
    documentSize: number;
    canDownload: boolean;
}

export class GetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto implements IGetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsDocumentationRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto implements IGetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto {
    applicationFormDocuments!: GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto[];
    supportingDocumentationDocuments!: GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto[];
    hasUnavailableApplicationFormDocuments!: boolean;
    hasUnavailableSupportingDocumentationDocuments!: boolean;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicationFormDocuments = [];
            this.supportingDocumentationDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationFormDocuments"])) {
                this.applicationFormDocuments = [] as any;
                for (let item of _data["applicationFormDocuments"])
                    this.applicationFormDocuments!.push(GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["supportingDocumentationDocuments"])) {
                this.supportingDocumentationDocuments = [] as any;
                for (let item of _data["supportingDocumentationDocuments"])
                    this.supportingDocumentationDocuments!.push(GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto.fromJS(item));
            }
            this.hasUnavailableApplicationFormDocuments = _data["hasUnavailableApplicationFormDocuments"];
            this.hasUnavailableSupportingDocumentationDocuments = _data["hasUnavailableSupportingDocumentationDocuments"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationFormDocuments)) {
            data["applicationFormDocuments"] = [];
            for (let item of this.applicationFormDocuments)
                data["applicationFormDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.supportingDocumentationDocuments)) {
            data["supportingDocumentationDocuments"] = [];
            for (let item of this.supportingDocumentationDocuments)
                data["supportingDocumentationDocuments"].push(item.toJSON());
        }
        data["hasUnavailableApplicationFormDocuments"] = this.hasUnavailableApplicationFormDocuments;
        data["hasUnavailableSupportingDocumentationDocuments"] = this.hasUnavailableSupportingDocumentationDocuments;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsDocumentationResponseDto {
    applicationFormDocuments: GetJointAuthorityOpggsApplicationDetailsDocumentationApplicationFormDocumentDto[];
    supportingDocumentationDocuments: GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto[];
    hasUnavailableApplicationFormDocuments: boolean;
    hasUnavailableSupportingDocumentationDocuments: boolean;
}

export class GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto implements IGetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
    authorisationId?: string | undefined;
    documentName!: string;
    documentSize!: number;
    sensitiveToCompanyName?: string | undefined;
    canDownload!: boolean;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
            this.documentName = _data["documentName"];
            this.documentSize = _data["documentSize"];
            this.sensitiveToCompanyName = _data["sensitiveToCompanyName"];
            this.canDownload = _data["canDownload"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        data["documentName"] = this.documentName;
        data["documentSize"] = this.documentSize;
        data["sensitiveToCompanyName"] = this.sensitiveToCompanyName;
        data["canDownload"] = this.canDownload;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsDocumentationSupportingDocumentationDocumentDto {
    authorisationId?: string | undefined;
    documentName: string;
    documentSize: number;
    sensitiveToCompanyName?: string | undefined;
    canDownload: boolean;
}

export class GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto implements IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto implements IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto {
    applicationId!: string;
    hasTitleholders!: boolean;
    hasBlockDetails!: boolean;
    hasWorkProgram!: boolean;
    applicationTypeName?: string | undefined;
    trackingNumber?: string | undefined;
    applicationStatus?: string | undefined;
    applicationStatusDatetime?: Date | undefined;
    applicationName?: string | undefined;
    submittedDate!: Date;
    titlesLabel?: string | undefined;
    titleLinks?: TitleLinkDto[] | undefined;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.hasTitleholders = _data["hasTitleholders"];
            this.hasBlockDetails = _data["hasBlockDetails"];
            this.hasWorkProgram = _data["hasWorkProgram"];
            this.applicationTypeName = _data["applicationTypeName"];
            this.trackingNumber = _data["trackingNumber"];
            this.applicationStatus = _data["applicationStatus"];
            this.applicationStatusDatetime = _data["applicationStatusDatetime"] ? new Date(_data["applicationStatusDatetime"].toString()) : <any>undefined;
            this.applicationName = _data["applicationName"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.titlesLabel = _data["titlesLabel"];
            if (Array.isArray(_data["titleLinks"])) {
                this.titleLinks = [] as any;
                for (let item of _data["titleLinks"])
                    this.titleLinks!.push(TitleLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["hasTitleholders"] = this.hasTitleholders;
        data["hasBlockDetails"] = this.hasBlockDetails;
        data["hasWorkProgram"] = this.hasWorkProgram;
        data["applicationTypeName"] = this.applicationTypeName;
        data["trackingNumber"] = this.trackingNumber;
        data["applicationStatus"] = this.applicationStatus;
        data["applicationStatusDatetime"] = this.applicationStatusDatetime ? this.applicationStatusDatetime.toISOString() : <any>undefined;
        data["applicationName"] = this.applicationName;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["titlesLabel"] = this.titlesLabel;
        if (Array.isArray(this.titleLinks)) {
            data["titleLinks"] = [];
            for (let item of this.titleLinks)
                data["titleLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsLayoutAndHeaderResponseDto {
    applicationId: string;
    hasTitleholders: boolean;
    hasBlockDetails: boolean;
    hasWorkProgram: boolean;
    applicationTypeName?: string | undefined;
    trackingNumber?: string | undefined;
    applicationStatus?: string | undefined;
    applicationStatusDatetime?: Date | undefined;
    applicationName?: string | undefined;
    submittedDate: Date;
    titlesLabel?: string | undefined;
    titleLinks?: TitleLinkDto[] | undefined;
}

export class GetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto implements IGetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsTitleholdersRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto implements IGetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto {
    titleholders!: GetTitleholdersItemDto[];

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleholders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titleholders"])) {
                this.titleholders = [] as any;
                for (let item of _data["titleholders"])
                    this.titleholders!.push(GetTitleholdersItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titleholders)) {
            data["titleholders"] = [];
            for (let item of this.titleholders)
                data["titleholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsTitleholdersResponseDto {
    titleholders: GetTitleholdersItemDto[];
}

export class GetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto implements IGetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto {
    applicationId!: string;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsWorkProgramRequestDto {
    applicationId: string;
}

export class GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto implements IGetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto {
    showPrimaryAndSecondaryTerms!: boolean;
    years?: ApplicationWorkProgramYearDto[] | undefined;
    grandTotal!: number;
    primaryTermTotal!: number;
    secondaryTermTotal!: number;

    constructor(data?: IGetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showPrimaryAndSecondaryTerms = _data["showPrimaryAndSecondaryTerms"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(ApplicationWorkProgramYearDto.fromJS(item));
            }
            this.grandTotal = _data["grandTotal"];
            this.primaryTermTotal = _data["primaryTermTotal"];
            this.secondaryTermTotal = _data["secondaryTermTotal"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPrimaryAndSecondaryTerms"] = this.showPrimaryAndSecondaryTerms;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal;
        data["primaryTermTotal"] = this.primaryTermTotal;
        data["secondaryTermTotal"] = this.secondaryTermTotal;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationDetailsWorkProgramResponseDto {
    showPrimaryAndSecondaryTerms: boolean;
    years?: ApplicationWorkProgramYearDto[] | undefined;
    grandTotal: number;
    primaryTermTotal: number;
    secondaryTermTotal: number;
}

export class GetJointAuthorityOpggsApplicationListRequestDto implements IGetJointAuthorityOpggsApplicationListRequestDto {
    inProgressOnly!: boolean;

    constructor(data?: IGetJointAuthorityOpggsApplicationListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressOnly = _data["inProgressOnly"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressOnly"] = this.inProgressOnly;
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationListRequestDto {
    inProgressOnly: boolean;
}

export class GetJointAuthorityOpggsApplicationListResponseDto implements IGetJointAuthorityOpggsApplicationListResponseDto {
    applications?: JointAuthorityApplicationListItemDto[] | undefined;

    constructor(data?: IGetJointAuthorityOpggsApplicationListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(JointAuthorityApplicationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsApplicationListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsApplicationListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsApplicationListResponseDto {
    applications?: JointAuthorityApplicationListItemDto[] | undefined;
}

export class GetJointAuthorityOpggsTitleListRequestDto implements IGetJointAuthorityOpggsTitleListRequestDto {

    constructor(data?: IGetJointAuthorityOpggsTitleListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityOpggsTitleListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsTitleListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityOpggsTitleListRequestDto {
}

export class GetJointAuthorityOpggsTitleListResponseDto implements IGetJointAuthorityOpggsTitleListResponseDto {
    titles?: GetJointAuthorityOpggsTitleListTitleDto[] | undefined;

    constructor(data?: IGetJointAuthorityOpggsTitleListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetJointAuthorityOpggsTitleListTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsTitleListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsTitleListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityOpggsTitleListResponseDto {
    titles?: GetJointAuthorityOpggsTitleListTitleDto[] | undefined;
}

export class GetJointAuthorityOpggsTitleListTitleDto implements IGetJointAuthorityOpggsTitleListTitleDto {
    titleLink!: TitleLinkDto;
    titleTypeDisplay!: string;
    titleStatusDisplay?: string | undefined;
    titleHoldersDisplay?: string | undefined;
    currentExpiryDate?: Date | undefined;
    renewalDate?: Date | undefined;
    grantedDate?: Date | undefined;
    offshoreArea?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;

    constructor(data?: IGetJointAuthorityOpggsTitleListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titleLink = new TitleLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleLink = _data["titleLink"] ? TitleLinkDto.fromJS(_data["titleLink"]) : new TitleLinkDto();
            this.titleTypeDisplay = _data["titleTypeDisplay"];
            this.titleStatusDisplay = _data["titleStatusDisplay"];
            this.titleHoldersDisplay = _data["titleHoldersDisplay"];
            this.currentExpiryDate = _data["currentExpiryDate"] ? new Date(_data["currentExpiryDate"].toString()) : <any>undefined;
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : <any>undefined;
            this.grantedDate = _data["grantedDate"] ? new Date(_data["grantedDate"].toString()) : <any>undefined;
            this.offshoreArea = _data["offshoreArea"];
            this.basin = _data["basin"];
            this.subBasin = _data["subBasin"];
        }
    }

    static fromJS(data: any): GetJointAuthorityOpggsTitleListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityOpggsTitleListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["titleTypeDisplay"] = this.titleTypeDisplay;
        data["titleStatusDisplay"] = this.titleStatusDisplay;
        data["titleHoldersDisplay"] = this.titleHoldersDisplay;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>undefined;
        data["grantedDate"] = this.grantedDate ? this.grantedDate.toISOString() : <any>undefined;
        data["offshoreArea"] = this.offshoreArea;
        data["basin"] = this.basin;
        data["subBasin"] = this.subBasin;
        return data;
    }
}

export interface IGetJointAuthorityOpggsTitleListTitleDto {
    titleLink: TitleLinkDto;
    titleTypeDisplay: string;
    titleStatusDisplay?: string | undefined;
    titleHoldersDisplay?: string | undefined;
    currentExpiryDate?: Date | undefined;
    renewalDate?: Date | undefined;
    grantedDate?: Date | undefined;
    offshoreArea?: string | undefined;
    basin?: string | undefined;
    subBasin?: string | undefined;
}

export class GetJointAuthorityUserManagementJointAuthorityDetailsRequestDto implements IGetJointAuthorityUserManagementJointAuthorityDetailsRequestDto {

    constructor(data?: IGetJointAuthorityUserManagementJointAuthorityDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityUserManagementJointAuthorityDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementJointAuthorityDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityUserManagementJointAuthorityDetailsRequestDto {
}

export class GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto implements IGetJointAuthorityUserManagementJointAuthorityDetailsResponseDto {
    jointAuthorityName?: string | undefined;
    secureUsers!: JointAuthoritySecureUserDetailsDto[];

    constructor(data?: IGetJointAuthorityUserManagementJointAuthorityDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityName = _data["jointAuthorityName"];
            if (Array.isArray(_data["secureUsers"])) {
                this.secureUsers = [] as any;
                for (let item of _data["secureUsers"])
                    this.secureUsers!.push(JointAuthoritySecureUserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementJointAuthorityDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityName"] = this.jointAuthorityName;
        if (Array.isArray(this.secureUsers)) {
            data["secureUsers"] = [];
            for (let item of this.secureUsers)
                data["secureUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityUserManagementJointAuthorityDetailsResponseDto {
    jointAuthorityName?: string | undefined;
    secureUsers: JointAuthoritySecureUserDetailsDto[];
}

export class SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto implements ISaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto {
    secureUserId!: number;
    secureUserVersionNumber!: number;
    roles?: SecureRoleEnum[] | undefined;

    constructor(data?: ISaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.secureUserVersionNumber = _data["secureUserVersionNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["secureUserVersionNumber"] = this.secureUserVersionNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ISaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto {
    secureUserId: number;
    secureUserVersionNumber: number;
    roles?: SecureRoleEnum[] | undefined;
}

export class SaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto implements ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto {
    roles?: SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto[] | undefined;

    constructor(data?: ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesRequestDto {
    roles?: SaveJointAuthorityUserManagementJointAuthorityDetailsRoleDto[] | undefined;
}

export class SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto implements ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveJointAuthorityUserManagementJointAuthorityDetailsRolesResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveJointAuthorityUserManagementRequestDetailsJarRequestDto implements IApproveJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveJointAuthorityUserManagementRequestDetailsJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveJointAuthorityUserManagementRequestDetailsJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveJointAuthorityUserManagementRequestDetailsJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto implements IApproveJointAuthorityUserManagementRequestDetailsJarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveJointAuthorityUserManagementRequestDetailsJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveJointAuthorityUserManagementRequestDetailsJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveJointAuthorityUserManagementRequestDetailsJarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class ApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto implements IApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    rolesApproved!: SecureRoleEnum[];

    constructor(data?: IApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        return data;
    }
}

export interface IApproveJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    rolesApproved: SecureRoleEnum[];
}

export class ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto implements IApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetJointAuthorityUserManagementRequestDetailsJarRequestDto implements IGetJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetJointAuthorityUserManagementRequestDetailsJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestDetailsJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestDetailsJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId: number;
}

export class GetJointAuthorityUserManagementRequestDetailsJarResponseDto implements IGetJointAuthorityUserManagementRequestDetailsJarResponseDto {
    summary!: JointAuthorityUserManagementRequestDetailsSummaryDto;
    existingUserDetails!: JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto;
    jointAuthorityStandardRoleDetails!: JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetJointAuthorityUserManagementRequestDetailsJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new JointAuthorityUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = new JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto();
            this.jointAuthorityStandardRoleDetails = new JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? JointAuthorityUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new JointAuthorityUserManagementRequestDetailsSummaryDto();
            this.existingUserDetails = _data["existingUserDetails"] ? JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto.fromJS(_data["existingUserDetails"]) : new JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto();
            this.jointAuthorityStandardRoleDetails = _data["jointAuthorityStandardRoleDetails"] ? JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["jointAuthorityStandardRoleDetails"]) : new JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestDetailsJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestDetailsJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["existingUserDetails"] = this.existingUserDetails ? this.existingUserDetails.toJSON() : <any>undefined;
        data["jointAuthorityStandardRoleDetails"] = this.jointAuthorityStandardRoleDetails ? this.jointAuthorityStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestDetailsJarResponseDto {
    summary: JointAuthorityUserManagementRequestDetailsSummaryDto;
    existingUserDetails: JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto;
    jointAuthorityStandardRoleDetails: JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class GetJointAuthorityUserManagementRequestDetailsNuJarRequestDto implements IGetJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId!: number;

    constructor(data?: IGetJointAuthorityUserManagementRequestDetailsNuJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestDetailsNuJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId: number;
}

export class GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto implements IGetJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    summary!: JointAuthorityUserManagementRequestDetailsSummaryDto;
    newUserDetails!: JointAuthorityUserManagementRequestDetailsNewUserDetailsDto;
    jointAuthorityStandardRoleDetails!: JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto;

    constructor(data?: IGetJointAuthorityUserManagementRequestDetailsNuJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new JointAuthorityUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = new JointAuthorityUserManagementRequestDetailsNewUserDetailsDto();
            this.jointAuthorityStandardRoleDetails = new JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? JointAuthorityUserManagementRequestDetailsSummaryDto.fromJS(_data["summary"]) : new JointAuthorityUserManagementRequestDetailsSummaryDto();
            this.newUserDetails = _data["newUserDetails"] ? JointAuthorityUserManagementRequestDetailsNewUserDetailsDto.fromJS(_data["newUserDetails"]) : new JointAuthorityUserManagementRequestDetailsNewUserDetailsDto();
            this.jointAuthorityStandardRoleDetails = _data["jointAuthorityStandardRoleDetails"] ? JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto.fromJS(_data["jointAuthorityStandardRoleDetails"]) : new JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto();
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestDetailsNuJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["newUserDetails"] = this.newUserDetails ? this.newUserDetails.toJSON() : <any>undefined;
        data["jointAuthorityStandardRoleDetails"] = this.jointAuthorityStandardRoleDetails ? this.jointAuthorityStandardRoleDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    summary: JointAuthorityUserManagementRequestDetailsSummaryDto;
    newUserDetails: JointAuthorityUserManagementRequestDetailsNewUserDetailsDto;
    jointAuthorityStandardRoleDetails: JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto;
}

export class JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto implements IJointAuthorityUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime!: Date;
    isSecureUserBlocked!: boolean;

    constructor(data?: IJointAuthorityUserManagementRequestDetailsExistingUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.lastLoginDatetime = _data["lastLoginDatetime"] ? new Date(_data["lastLoginDatetime"].toString()) : <any>undefined;
            this.registrationDatetime = _data["registrationDatetime"] ? new Date(_data["registrationDatetime"].toString()) : <any>undefined;
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
        }
    }

    static fromJS(data: any): JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityUserManagementRequestDetailsExistingUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["lastLoginDatetime"] = this.lastLoginDatetime ? this.lastLoginDatetime.toISOString() : <any>undefined;
        data["registrationDatetime"] = this.registrationDatetime ? this.registrationDatetime.toISOString() : <any>undefined;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        return data;
    }
}

export interface IJointAuthorityUserManagementRequestDetailsExistingUserDetailsDto {
    secureUserId?: number | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    lastLoginDatetime?: Date | undefined;
    registrationDatetime: Date;
    isSecureUserBlocked: boolean;
}

export class JointAuthorityUserManagementRequestDetailsNewUserDetailsDto implements IJointAuthorityUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;

    constructor(data?: IJointAuthorityUserManagementRequestDetailsNewUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): JointAuthorityUserManagementRequestDetailsNewUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityUserManagementRequestDetailsNewUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface IJointAuthorityUserManagementRequestDetailsNewUserDetailsDto {
    emailAddress?: string | undefined;
    fullName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
}

export class JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto implements IJointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting!: SecureRoleEnum[];
    rolesRequested!: SecureRoleEnum[];
    rolesApproved!: SecureRoleEnum[];
    hasAllGeneralRoles!: boolean;

    constructor(data?: IJointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rolesExisting = [];
            this.rolesRequested = [];
            this.rolesApproved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesExisting"])) {
                this.rolesExisting = [] as any;
                for (let item of _data["rolesExisting"])
                    this.rolesExisting!.push(item);
            }
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            this.hasAllGeneralRoles = _data["hasAllGeneralRoles"];
        }
    }

    static fromJS(data: any): JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesExisting)) {
            data["rolesExisting"] = [];
            for (let item of this.rolesExisting)
                data["rolesExisting"].push(item);
        }
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        data["hasAllGeneralRoles"] = this.hasAllGeneralRoles;
        return data;
    }
}

export interface IJointAuthorityUserManagementRequestDetailsStandardRoleDetailsDto {
    rolesExisting: SecureRoleEnum[];
    rolesRequested: SecureRoleEnum[];
    rolesApproved: SecureRoleEnum[];
    hasAllGeneralRoles: boolean;
}

export class JointAuthorityUserManagementRequestDetailsSummaryDto implements IJointAuthorityUserManagementRequestDetailsSummaryDto {
    id!: number;
    versionNumber!: number;
    type!: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime!: Date;
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    comments?: string | undefined;
    isComplete!: boolean;
    isNewUserRequest!: boolean;
    isJointAuthorityStandardRoleRequest!: boolean;
    isJointAuthoritySignerRequest!: boolean;

    constructor(data?: IJointAuthorityUserManagementRequestDetailsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.type = _data["type"];
            this.requestGroupCode = _data["requestGroupCode"];
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.comments = _data["comments"];
            this.isComplete = _data["isComplete"];
            this.isNewUserRequest = _data["isNewUserRequest"];
            this.isJointAuthorityStandardRoleRequest = _data["isJointAuthorityStandardRoleRequest"];
            this.isJointAuthoritySignerRequest = _data["isJointAuthoritySignerRequest"];
        }
    }

    static fromJS(data: any): JointAuthorityUserManagementRequestDetailsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityUserManagementRequestDetailsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["type"] = this.type;
        data["requestGroupCode"] = this.requestGroupCode;
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["comments"] = this.comments;
        data["isComplete"] = this.isComplete;
        data["isNewUserRequest"] = this.isNewUserRequest;
        data["isJointAuthorityStandardRoleRequest"] = this.isJointAuthorityStandardRoleRequest;
        data["isJointAuthoritySignerRequest"] = this.isJointAuthoritySignerRequest;
        return data;
    }
}

export interface IJointAuthorityUserManagementRequestDetailsSummaryDto {
    id: number;
    versionNumber: number;
    type: SecureRequestGroupTypeEnum;
    requestGroupCode?: string | undefined;
    requestDatetime: Date;
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    comments?: string | undefined;
    isComplete: boolean;
    isNewUserRequest: boolean;
    isJointAuthorityStandardRoleRequest: boolean;
    isJointAuthoritySignerRequest: boolean;
}

export class RejectJointAuthorityUserManagementRequestDetailsJarRequestDto implements IRejectJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectJointAuthorityUserManagementRequestDetailsJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectJointAuthorityUserManagementRequestDetailsJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectJointAuthorityUserManagementRequestDetailsJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectJointAuthorityUserManagementRequestDetailsJarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectJointAuthorityUserManagementRequestDetailsJarResponseDto implements IRejectJointAuthorityUserManagementRequestDetailsJarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectJointAuthorityUserManagementRequestDetailsJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectJointAuthorityUserManagementRequestDetailsJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectJointAuthorityUserManagementRequestDetailsJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectJointAuthorityUserManagementRequestDetailsJarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class RejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto implements IRejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId!: number;
    versionNumber!: number;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IRejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureRequestGroupId = _data["secureRequestGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): RejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureRequestGroupId"] = this.secureRequestGroupId;
        data["versionNumber"] = this.versionNumber;
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IRejectJointAuthorityUserManagementRequestDetailsNuJarRequestDto {
    secureRequestGroupId: number;
    versionNumber: number;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto implements IRejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectJointAuthorityUserManagementRequestDetailsNuJarResponseDto {
    statusMessages: StatusMessagesDto;
}

export class BatchApproveJointAuthorityUserManagementRequestListRequestDto implements IBatchApproveJointAuthorityUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;

    constructor(data?: IBatchApproveJointAuthorityUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchApproveJointAuthorityUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveJointAuthorityUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchApproveJointAuthorityUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
}

export class BatchApproveJointAuthorityUserManagementRequestListResponseDto implements IBatchApproveJointAuthorityUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchApproveJointAuthorityUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchApproveJointAuthorityUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchApproveJointAuthorityUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchApproveJointAuthorityUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class BatchRejectJointAuthorityUserManagementRequestListRequestDto implements IBatchRejectJointAuthorityUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious!: boolean;

    constructor(data?: IBatchRejectJointAuthorityUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureRequestGroups"])) {
                this.secureRequestGroups = [] as any;
                for (let item of _data["secureRequestGroups"])
                    this.secureRequestGroups!.push(SecureRequestGroupKeyDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.isSuspicious = _data["isSuspicious"];
        }
    }

    static fromJS(data: any): BatchRejectJointAuthorityUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectJointAuthorityUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureRequestGroups)) {
            data["secureRequestGroups"] = [];
            for (let item of this.secureRequestGroups)
                data["secureRequestGroups"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["isSuspicious"] = this.isSuspicious;
        return data;
    }
}

export interface IBatchRejectJointAuthorityUserManagementRequestListRequestDto {
    secureRequestGroups?: SecureRequestGroupKeyDto[] | undefined;
    comments?: string | undefined;
    isSuspicious: boolean;
}

export class BatchRejectJointAuthorityUserManagementRequestListResponseDto implements IBatchRejectJointAuthorityUserManagementRequestListResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IBatchRejectJointAuthorityUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): BatchRejectJointAuthorityUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRejectJointAuthorityUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchRejectJointAuthorityUserManagementRequestListResponseDto {
    statusMessages: StatusMessagesDto;
}

export class GetJointAuthorityUserManagementRequestListRequestDto implements IGetJointAuthorityUserManagementRequestListRequestDto {

    constructor(data?: IGetJointAuthorityUserManagementRequestListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestListRequestDto {
}

export class GetJointAuthorityUserManagementRequestListResponseDto implements IGetJointAuthorityUserManagementRequestListResponseDto {
    jointAuthorityAdministratorRequests!: JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto[];
    isJointAuthorityAdministratorRequestLimitExceeded!: boolean;
    noptaRequests!: NoptaJointAuthorityRequestListItemDto[];
    isNoptaRequestLimitExceeded!: boolean;

    constructor(data?: IGetJointAuthorityUserManagementRequestListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jointAuthorityAdministratorRequests = [];
            this.noptaRequests = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jointAuthorityAdministratorRequests"])) {
                this.jointAuthorityAdministratorRequests = [] as any;
                for (let item of _data["jointAuthorityAdministratorRequests"])
                    this.jointAuthorityAdministratorRequests!.push(JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto.fromJS(item));
            }
            this.isJointAuthorityAdministratorRequestLimitExceeded = _data["isJointAuthorityAdministratorRequestLimitExceeded"];
            if (Array.isArray(_data["noptaRequests"])) {
                this.noptaRequests = [] as any;
                for (let item of _data["noptaRequests"])
                    this.noptaRequests!.push(NoptaJointAuthorityRequestListItemDto.fromJS(item));
            }
            this.isNoptaRequestLimitExceeded = _data["isNoptaRequestLimitExceeded"];
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementRequestListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementRequestListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jointAuthorityAdministratorRequests)) {
            data["jointAuthorityAdministratorRequests"] = [];
            for (let item of this.jointAuthorityAdministratorRequests)
                data["jointAuthorityAdministratorRequests"].push(item.toJSON());
        }
        data["isJointAuthorityAdministratorRequestLimitExceeded"] = this.isJointAuthorityAdministratorRequestLimitExceeded;
        if (Array.isArray(this.noptaRequests)) {
            data["noptaRequests"] = [];
            for (let item of this.noptaRequests)
                data["noptaRequests"].push(item.toJSON());
        }
        data["isNoptaRequestLimitExceeded"] = this.isNoptaRequestLimitExceeded;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementRequestListResponseDto {
    jointAuthorityAdministratorRequests: JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto[];
    isJointAuthorityAdministratorRequestLimitExceeded: boolean;
    noptaRequests: NoptaJointAuthorityRequestListItemDto[];
    isNoptaRequestLimitExceeded: boolean;
}

export class JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto implements IJointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto {
    requestDatetime!: Date;
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    secureRequestGroupLink!: SecureRequestGroupLinkDto;
    requestVersionNumber!: number;
    rolesRequested!: SecureRoleEnum[];
    isSignerRequest!: boolean;

    constructor(data?: IJointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureRequestGroupLink = new SecureRequestGroupLinkDto();
            this.rolesRequested = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.secureRequestGroupLink = _data["secureRequestGroupLink"] ? SecureRequestGroupLinkDto.fromJS(_data["secureRequestGroupLink"]) : new SecureRequestGroupLinkDto();
            this.requestVersionNumber = _data["requestVersionNumber"];
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            this.isSignerRequest = _data["isSignerRequest"];
        }
    }

    static fromJS(data: any): JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["secureRequestGroupLink"] = this.secureRequestGroupLink ? this.secureRequestGroupLink.toJSON() : <any>undefined;
        data["requestVersionNumber"] = this.requestVersionNumber;
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        data["isSignerRequest"] = this.isSignerRequest;
        return data;
    }
}

export interface IJointAuthorityUserManagementJointAuthorityRequestListAdministratorJointAuthorityRequestListItemDto {
    requestDatetime: Date;
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    secureRequestGroupLink: SecureRequestGroupLinkDto;
    requestVersionNumber: number;
    rolesRequested: SecureRoleEnum[];
    isSignerRequest: boolean;
}

export class NoptaJointAuthorityRequestListItemDto implements INoptaJointAuthorityRequestListItemDto {
    requestDatetime!: Date;
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked!: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;

    constructor(data?: INoptaJointAuthorityRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDatetime = _data["requestDatetime"] ? new Date(_data["requestDatetime"].toString()) : <any>undefined;
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.secureUserId = _data["secureUserId"];
            this.secureUserDisplayName = _data["secureUserDisplayName"];
            this.isSecureUserBlocked = _data["isSecureUserBlocked"];
            this.requestCode = _data["requestCode"];
            this.roleRequested = _data["roleRequested"];
        }
    }

    static fromJS(data: any): NoptaJointAuthorityRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoptaJointAuthorityRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDatetime"] = this.requestDatetime ? this.requestDatetime.toISOString() : <any>undefined;
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["secureUserId"] = this.secureUserId;
        data["secureUserDisplayName"] = this.secureUserDisplayName;
        data["isSecureUserBlocked"] = this.isSecureUserBlocked;
        data["requestCode"] = this.requestCode;
        data["roleRequested"] = this.roleRequested;
        return data;
    }
}

export interface INoptaJointAuthorityRequestListItemDto {
    requestDatetime: Date;
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    secureUserId?: number | undefined;
    secureUserDisplayName?: string | undefined;
    isSecureUserBlocked: boolean;
    requestCode?: string | undefined;
    roleRequested?: string | undefined;
}

export class GetJointAuthorityUserManagementUserDetailsRequestDto implements IGetJointAuthorityUserManagementUserDetailsRequestDto {
    secureUserId!: number;

    constructor(data?: IGetJointAuthorityUserManagementUserDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureUserId = _data["secureUserId"];
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementUserDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementUserDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureUserId"] = this.secureUserId;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementUserDetailsRequestDto {
    secureUserId: number;
}

export class GetJointAuthorityUserManagementUserDetailsResponseDto implements IGetJointAuthorityUserManagementUserDetailsResponseDto {
    userDetails!: JointAuthoritySecureUserDetailsDto;

    constructor(data?: IGetJointAuthorityUserManagementUserDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userDetails = new JointAuthoritySecureUserDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetails = _data["userDetails"] ? JointAuthoritySecureUserDetailsDto.fromJS(_data["userDetails"]) : new JointAuthoritySecureUserDetailsDto();
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementUserDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementUserDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJointAuthorityUserManagementUserDetailsResponseDto {
    userDetails: JointAuthoritySecureUserDetailsDto;
}

export class GetJointAuthorityUserManagementUserListRequestDto implements IGetJointAuthorityUserManagementUserListRequestDto {

    constructor(data?: IGetJointAuthorityUserManagementUserListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJointAuthorityUserManagementUserListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementUserListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJointAuthorityUserManagementUserListRequestDto {
}

export class GetJointAuthorityUserManagementUserListResponseDto implements IGetJointAuthorityUserManagementUserListResponseDto {
    secureUsers!: JointAuthoritySecureUserDetailsDto[];

    constructor(data?: IGetJointAuthorityUserManagementUserListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.secureUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secureUsers"])) {
                this.secureUsers = [] as any;
                for (let item of _data["secureUsers"])
                    this.secureUsers!.push(JointAuthoritySecureUserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointAuthorityUserManagementUserListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointAuthorityUserManagementUserListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secureUsers)) {
            data["secureUsers"] = [];
            for (let item of this.secureUsers)
                data["secureUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJointAuthorityUserManagementUserListResponseDto {
    secureUsers: JointAuthoritySecureUserDetailsDto[];
}

export class RequestRegistrationEmailVerificationRequestDto implements IRequestRegistrationEmailVerificationRequestDto {
    email!: string;
    token!: string;

    constructor(data?: IRequestRegistrationEmailVerificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RequestRegistrationEmailVerificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRegistrationEmailVerificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    }
}

export interface IRequestRegistrationEmailVerificationRequestDto {
    email: string;
    token: string;
}

export class RequestRegistrationEmailVerificationResponseDto implements IRequestRegistrationEmailVerificationResponseDto {
    statusMessages!: StatusMessagesDto;

    constructor(data?: IRequestRegistrationEmailVerificationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): RequestRegistrationEmailVerificationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRegistrationEmailVerificationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestRegistrationEmailVerificationResponseDto {
    statusMessages: StatusMessagesDto;
}

export class VerifyRegistrationEmailVerificationCodeRequestDto implements IVerifyRegistrationEmailVerificationCodeRequestDto {
    token!: string;
    verificationCode?: string | undefined;

    constructor(data?: IVerifyRegistrationEmailVerificationCodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): VerifyRegistrationEmailVerificationCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyRegistrationEmailVerificationCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface IVerifyRegistrationEmailVerificationCodeRequestDto {
    token: string;
    verificationCode?: string | undefined;
}

export class VerifyRegistrationEmailVerificationCodeResponseDto implements IVerifyRegistrationEmailVerificationCodeResponseDto {
    status!: EmailVerificationStatusEnum;
    statusMessages!: StatusMessagesDto;

    constructor(data?: IVerifyRegistrationEmailVerificationCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
        }
    }

    static fromJS(data: any): VerifyRegistrationEmailVerificationCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyRegistrationEmailVerificationCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVerifyRegistrationEmailVerificationCodeResponseDto {
    status: EmailVerificationStatusEnum;
    statusMessages: StatusMessagesDto;
}

export class CreateRegistrationCompanyNuCaRequestDto implements ICreateRegistrationCompanyNuCaRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.caAuthoritySupportingDocument = _data["caAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["caAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["caAuthoritySupportingDocument"] = this.caAuthoritySupportingDocument ? this.caAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCaRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateRegistrationCompanyNuCaResponseDto implements ICreateRegistrationCompanyNuCaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateRegistrationCompanyNuCrCsRequestDto implements ICreateRegistrationCompanyNuCrCsRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest!: boolean;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCrCsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.isCompanySignerPoaRequest = _data["isCompanySignerPoaRequest"];
            this.newUserRequest = _data["newUserRequest"] ? NewUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.companyStandardRolesRequest = _data["companyStandardRolesRequest"] ? CompanyStandardRoleRequestDetailsDto.fromJS(_data["companyStandardRolesRequest"]) : <any>undefined;
            this.csAuthoritySupportingDocument = _data["csAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csAuthoritySupportingDocument"]) : <any>undefined;
            this.csPoaSupportingDocument = _data["csPoaSupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["csPoaSupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCrCsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCrCsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["isCompanySignerPoaRequest"] = this.isCompanySignerPoaRequest;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["companyStandardRolesRequest"] = this.companyStandardRolesRequest ? this.companyStandardRolesRequest.toJSON() : <any>undefined;
        data["csAuthoritySupportingDocument"] = this.csAuthoritySupportingDocument ? this.csAuthoritySupportingDocument.toJSON() : <any>undefined;
        data["csPoaSupportingDocument"] = this.csPoaSupportingDocument ? this.csPoaSupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCrCsRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    isCompanySignerPoaRequest: boolean;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
    csAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
    csPoaSupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateRegistrationCompanyNuCrCsResponseDto implements ICreateRegistrationCompanyNuCrCsResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCrCsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCrCsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCrCsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCrCsResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateRegistrationCompanyNuCrRequestDto implements ICreateRegistrationCompanyNuCrRequestDto {
    companyId!: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCrRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.companyStandardRolesRequest = _data["companyStandardRolesRequest"] ? CompanyStandardRoleRequestDetailsDto.fromJS(_data["companyStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCrRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCrRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["companyStandardRolesRequest"] = this.companyStandardRolesRequest ? this.companyStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCrRequestDto {
    companyId: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    companyStandardRolesRequest?: CompanyStandardRoleRequestDetailsDto | undefined;
}

export class CreateRegistrationCompanyNuCrResponseDto implements ICreateRegistrationCompanyNuCrResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuCrResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuCrResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuCrResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuCrResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateRegistrationCompanyNuNcCaRequestDto implements ICreateRegistrationCompanyNuNcCaRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    newCompanyRequest?: NewCompanyRequestDetailsDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuNcCaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.newCompanyRequest = _data["newCompanyRequest"] ? NewCompanyRequestDetailsDto.fromJS(_data["newCompanyRequest"]) : <any>undefined;
            this.caAuthoritySupportingDocument = _data["caAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["caAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuNcCaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuNcCaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["newCompanyRequest"] = this.newCompanyRequest ? this.newCompanyRequest.toJSON() : <any>undefined;
        data["caAuthoritySupportingDocument"] = this.caAuthoritySupportingDocument ? this.caAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuNcCaRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewUserRequestDetailsWithPasswordDto | undefined;
    newCompanyRequest?: NewCompanyRequestDetailsDto | undefined;
    caAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateRegistrationCompanyNuNcCaResponseDto implements ICreateRegistrationCompanyNuNcCaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationCompanyNuNcCaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationCompanyNuNcCaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCompanyNuNcCaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationCompanyNuNcCaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetRegistrationCompanyCompanyDto implements IGetRegistrationCompanyCompanyDto {
    companyId!: number;
    companyName?: string | undefined;
    hasCompanyAdministrator!: boolean;

    constructor(data?: IGetRegistrationCompanyCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.hasCompanyAdministrator = _data["hasCompanyAdministrator"];
        }
    }

    static fromJS(data: any): GetRegistrationCompanyCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationCompanyCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["hasCompanyAdministrator"] = this.hasCompanyAdministrator;
        return data;
    }
}

export interface IGetRegistrationCompanyCompanyDto {
    companyId: number;
    companyName?: string | undefined;
    hasCompanyAdministrator: boolean;
}

export class GetRegistrationCompanyReferenceDataRequestDto implements IGetRegistrationCompanyReferenceDataRequestDto {

    constructor(data?: IGetRegistrationCompanyReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRegistrationCompanyReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationCompanyReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRegistrationCompanyReferenceDataRequestDto {
}

export class GetRegistrationCompanyReferenceDataResponseDto implements IGetRegistrationCompanyReferenceDataResponseDto {
    companies!: GetRegistrationCompanyCompanyDto[];
    countries!: SecurePortalCountryDto[];

    constructor(data?: IGetRegistrationCompanyReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companies = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(GetRegistrationCompanyCompanyDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SecurePortalCountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegistrationCompanyReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationCompanyReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegistrationCompanyReferenceDataResponseDto {
    companies: GetRegistrationCompanyCompanyDto[];
    countries: SecurePortalCountryDto[];
}

export class NewUserRequestDetailsWithPasswordDto implements INewUserRequestDetailsWithPasswordDto {
    token!: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;

    constructor(data?: INewUserRequestDetailsWithPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.createdSecureUserId = _data["createdSecureUserId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): NewUserRequestDetailsWithPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserRequestDetailsWithPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["createdSecureUserId"] = this.createdSecureUserId;
        data["password"] = this.password;
        return data;
    }
}

export interface INewUserRequestDetailsWithPasswordDto {
    token: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;
}

export class CreateRegistrationGeoscienceAustraliaNuGaaRequestDto implements ICreateRegistrationGeoscienceAustraliaNuGaaRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto | undefined;
    gaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateRegistrationGeoscienceAustraliaNuGaaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.gaaAuthoritySupportingDocument = _data["gaaAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["gaaAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationGeoscienceAustraliaNuGaaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationGeoscienceAustraliaNuGaaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["gaaAuthoritySupportingDocument"] = this.gaaAuthoritySupportingDocument ? this.gaaAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationGeoscienceAustraliaNuGaaRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto | undefined;
    gaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateRegistrationGeoscienceAustraliaNuGaaResponseDto implements ICreateRegistrationGeoscienceAustraliaNuGaaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationGeoscienceAustraliaNuGaaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationGeoscienceAustraliaNuGaaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationGeoscienceAustraliaNuGaaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationGeoscienceAustraliaNuGaaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateRegistrationGeoscienceAustraliaNuGarRequestDto implements ICreateRegistrationGeoscienceAustraliaNuGarRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto | undefined;
    geoscienceAustraliaStandardRolesRequest?: GeoscienceAustraliaStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateRegistrationGeoscienceAustraliaNuGarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.geoscienceAustraliaStandardRolesRequest = _data["geoscienceAustraliaStandardRolesRequest"] ? GeoscienceAustraliaStandardRoleRequestDetailsDto.fromJS(_data["geoscienceAustraliaStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationGeoscienceAustraliaNuGarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationGeoscienceAustraliaNuGarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["geoscienceAustraliaStandardRolesRequest"] = this.geoscienceAustraliaStandardRolesRequest ? this.geoscienceAustraliaStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationGeoscienceAustraliaNuGarRequestDto {
    submittedComments?: string | undefined;
    newUserRequest?: NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto | undefined;
    geoscienceAustraliaStandardRolesRequest?: GeoscienceAustraliaStandardRoleRequestDetailsDto | undefined;
}

export class CreateRegistrationGeoscienceAustraliaNuGarResponseDto implements ICreateRegistrationGeoscienceAustraliaNuGarResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationGeoscienceAustraliaNuGarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationGeoscienceAustraliaNuGarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationGeoscienceAustraliaNuGarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationGeoscienceAustraliaNuGarResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetRegistrationGeoscienceAustraliaReferenceDataRequestDto implements IGetRegistrationGeoscienceAustraliaReferenceDataRequestDto {

    constructor(data?: IGetRegistrationGeoscienceAustraliaReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRegistrationGeoscienceAustraliaReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationGeoscienceAustraliaReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRegistrationGeoscienceAustraliaReferenceDataRequestDto {
}

export class GetRegistrationGeoscienceAustraliaReferenceDataResponseDto implements IGetRegistrationGeoscienceAustraliaReferenceDataResponseDto {
    hasGeoscienceAustraliaAdministrator!: boolean;

    constructor(data?: IGetRegistrationGeoscienceAustraliaReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasGeoscienceAustraliaAdministrator = _data["hasGeoscienceAustraliaAdministrator"];
        }
    }

    static fromJS(data: any): GetRegistrationGeoscienceAustraliaReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationGeoscienceAustraliaReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasGeoscienceAustraliaAdministrator"] = this.hasGeoscienceAustraliaAdministrator;
        return data;
    }
}

export interface IGetRegistrationGeoscienceAustraliaReferenceDataResponseDto {
    hasGeoscienceAustraliaAdministrator: boolean;
}

export class NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto implements INewGeoscienceAustraliaUserRequestDetailsWithPasswordDto {
    token!: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;

    constructor(data?: INewGeoscienceAustraliaUserRequestDetailsWithPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.createdSecureUserId = _data["createdSecureUserId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewGeoscienceAustraliaUserRequestDetailsWithPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["createdSecureUserId"] = this.createdSecureUserId;
        data["password"] = this.password;
        return data;
    }
}

export interface INewGeoscienceAustraliaUserRequestDetailsWithPasswordDto {
    token: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;
}

export class CreateRegistrationJointAuthorityNuJaaRequestDto implements ICreateRegistrationJointAuthorityNuJaaRequestDto {
    jointAuthorityId!: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewJointAuthorityUserRequestDetailsWithPasswordDto | undefined;
    jaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;

    constructor(data?: ICreateRegistrationJointAuthorityNuJaaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewJointAuthorityUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.jaaAuthoritySupportingDocument = _data["jaaAuthoritySupportingDocument"] ? SecureRequestGroupSupportingDocumentDto.fromJS(_data["jaaAuthoritySupportingDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationJointAuthorityNuJaaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationJointAuthorityNuJaaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["jaaAuthoritySupportingDocument"] = this.jaaAuthoritySupportingDocument ? this.jaaAuthoritySupportingDocument.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationJointAuthorityNuJaaRequestDto {
    jointAuthorityId: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewJointAuthorityUserRequestDetailsWithPasswordDto | undefined;
    jaaAuthoritySupportingDocument?: SecureRequestGroupSupportingDocumentDto | undefined;
}

export class CreateRegistrationJointAuthorityNuJaaResponseDto implements ICreateRegistrationJointAuthorityNuJaaResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationJointAuthorityNuJaaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationJointAuthorityNuJaaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationJointAuthorityNuJaaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationJointAuthorityNuJaaResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class CreateRegistrationJointAuthorityNuJarRequestDto implements ICreateRegistrationJointAuthorityNuJarRequestDto {
    jointAuthorityId!: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewJointAuthorityUserRequestDetailsWithPasswordDto | undefined;
    jointAuthorityStandardRolesRequest?: JointAuthorityStandardRoleRequestDetailsDto | undefined;

    constructor(data?: ICreateRegistrationJointAuthorityNuJarRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.submittedComments = _data["submittedComments"];
            this.newUserRequest = _data["newUserRequest"] ? NewJointAuthorityUserRequestDetailsWithPasswordDto.fromJS(_data["newUserRequest"]) : <any>undefined;
            this.jointAuthorityStandardRolesRequest = _data["jointAuthorityStandardRolesRequest"] ? JointAuthorityStandardRoleRequestDetailsDto.fromJS(_data["jointAuthorityStandardRolesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationJointAuthorityNuJarRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationJointAuthorityNuJarRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["submittedComments"] = this.submittedComments;
        data["newUserRequest"] = this.newUserRequest ? this.newUserRequest.toJSON() : <any>undefined;
        data["jointAuthorityStandardRolesRequest"] = this.jointAuthorityStandardRolesRequest ? this.jointAuthorityStandardRolesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationJointAuthorityNuJarRequestDto {
    jointAuthorityId: number;
    submittedComments?: string | undefined;
    newUserRequest?: NewJointAuthorityUserRequestDetailsWithPasswordDto | undefined;
    jointAuthorityStandardRolesRequest?: JointAuthorityStandardRoleRequestDetailsDto | undefined;
}

export class CreateRegistrationJointAuthorityNuJarResponseDto implements ICreateRegistrationJointAuthorityNuJarResponseDto {
    statusMessages!: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;

    constructor(data?: ICreateRegistrationJointAuthorityNuJarResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusMessages = new StatusMessagesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusMessages = _data["statusMessages"] ? StatusMessagesDto.fromJS(_data["statusMessages"]) : new StatusMessagesDto();
            this.secureRequestGroupId = _data["secureRequestGroupId"] ? SecureRequestGroupIdDto.fromJS(_data["secureRequestGroupId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRegistrationJointAuthorityNuJarResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationJointAuthorityNuJarResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusMessages"] = this.statusMessages ? this.statusMessages.toJSON() : <any>undefined;
        data["secureRequestGroupId"] = this.secureRequestGroupId ? this.secureRequestGroupId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateRegistrationJointAuthorityNuJarResponseDto {
    statusMessages: StatusMessagesDto;
    secureRequestGroupId?: SecureRequestGroupIdDto | undefined;
}

export class GetRegistrationJointAuthorityJointAuthorityDto implements IGetRegistrationJointAuthorityJointAuthorityDto {
    jointAuthorityId!: number;
    jointAuthorityName?: string | undefined;
    hasJointAuthorityAdministrator!: boolean;

    constructor(data?: IGetRegistrationJointAuthorityJointAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jointAuthorityId = _data["jointAuthorityId"];
            this.jointAuthorityName = _data["jointAuthorityName"];
            this.hasJointAuthorityAdministrator = _data["hasJointAuthorityAdministrator"];
        }
    }

    static fromJS(data: any): GetRegistrationJointAuthorityJointAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationJointAuthorityJointAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jointAuthorityId"] = this.jointAuthorityId;
        data["jointAuthorityName"] = this.jointAuthorityName;
        data["hasJointAuthorityAdministrator"] = this.hasJointAuthorityAdministrator;
        return data;
    }
}

export interface IGetRegistrationJointAuthorityJointAuthorityDto {
    jointAuthorityId: number;
    jointAuthorityName?: string | undefined;
    hasJointAuthorityAdministrator: boolean;
}

export class GetRegistrationJointAuthorityReferenceDataRequestDto implements IGetRegistrationJointAuthorityReferenceDataRequestDto {

    constructor(data?: IGetRegistrationJointAuthorityReferenceDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRegistrationJointAuthorityReferenceDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationJointAuthorityReferenceDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRegistrationJointAuthorityReferenceDataRequestDto {
}

export class GetRegistrationJointAuthorityReferenceDataResponseDto implements IGetRegistrationJointAuthorityReferenceDataResponseDto {
    jointAuthorities!: GetRegistrationJointAuthorityJointAuthorityDto[];

    constructor(data?: IGetRegistrationJointAuthorityReferenceDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jointAuthorities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jointAuthorities"])) {
                this.jointAuthorities = [] as any;
                for (let item of _data["jointAuthorities"])
                    this.jointAuthorities!.push(GetRegistrationJointAuthorityJointAuthorityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegistrationJointAuthorityReferenceDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationJointAuthorityReferenceDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jointAuthorities)) {
            data["jointAuthorities"] = [];
            for (let item of this.jointAuthorities)
                data["jointAuthorities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegistrationJointAuthorityReferenceDataResponseDto {
    jointAuthorities: GetRegistrationJointAuthorityJointAuthorityDto[];
}

export class NewJointAuthorityUserRequestDetailsWithPasswordDto implements INewJointAuthorityUserRequestDetailsWithPasswordDto {
    token!: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;

    constructor(data?: INewJointAuthorityUserRequestDetailsWithPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.contactNumber = _data["contactNumber"];
            this.createdSecureUserId = _data["createdSecureUserId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): NewJointAuthorityUserRequestDetailsWithPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewJointAuthorityUserRequestDetailsWithPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["contactNumber"] = this.contactNumber;
        data["createdSecureUserId"] = this.createdSecureUserId;
        data["password"] = this.password;
        return data;
    }
}

export interface INewJointAuthorityUserRequestDetailsWithPasswordDto {
    token: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    contactNumber?: string | undefined;
    createdSecureUserId?: number | undefined;
    password?: string | undefined;
}

export class GetShellFeatureSwitchesRequestDto implements IGetShellFeatureSwitchesRequestDto {

    constructor(data?: IGetShellFeatureSwitchesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellFeatureSwitchesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellFeatureSwitchesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellFeatureSwitchesRequestDto {
}

export class GetShellFeatureSwitchesResponseDto implements IGetShellFeatureSwitchesResponseDto {
    featureSwitches!: NeatsFeatureSwitchEnum[];

    constructor(data?: IGetShellFeatureSwitchesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureSwitches = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureSwitches"])) {
                this.featureSwitches = [] as any;
                for (let item of _data["featureSwitches"])
                    this.featureSwitches!.push(item);
            }
        }
    }

    static fromJS(data: any): GetShellFeatureSwitchesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellFeatureSwitchesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureSwitches)) {
            data["featureSwitches"] = [];
            for (let item of this.featureSwitches)
                data["featureSwitches"].push(item);
        }
        return data;
    }
}

export interface IGetShellFeatureSwitchesResponseDto {
    featureSwitches: NeatsFeatureSwitchEnum[];
}

export class GetShellPortalLinksLinkDto implements IGetShellPortalLinksLinkDto {
    name!: ExternalLinkEnum;
    url!: string;

    constructor(data?: IGetShellPortalLinksLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetShellPortalLinksLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellPortalLinksLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetShellPortalLinksLinkDto {
    name: ExternalLinkEnum;
    url: string;
}

export class GetShellPortalLinksRequestDto implements IGetShellPortalLinksRequestDto {

    constructor(data?: IGetShellPortalLinksRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellPortalLinksRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellPortalLinksRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellPortalLinksRequestDto {
}

export class GetShellPortalLinksResponseDto implements IGetShellPortalLinksResponseDto {
    links!: GetShellPortalLinksLinkDto[];

    constructor(data?: IGetShellPortalLinksResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(GetShellPortalLinksLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShellPortalLinksResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellPortalLinksResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetShellPortalLinksResponseDto {
    links: GetShellPortalLinksLinkDto[];
}

export class GetShellSecureUserRoleConfigurationRequestDto implements IGetShellSecureUserRoleConfigurationRequestDto {

    constructor(data?: IGetShellSecureUserRoleConfigurationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellSecureUserRoleConfigurationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellSecureUserRoleConfigurationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellSecureUserRoleConfigurationRequestDto {
}

export class GetShellSecureUserRoleConfigurationResponseDto implements IGetShellSecureUserRoleConfigurationResponseDto {
    companyRoleGroups!: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    jointAuthorityRoleGroups!: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    geoscienceAustraliaRoleGroups!: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    roleRelationships!: GetShellSecureUserRoleConfigurationRoleRelationshipDto[];

    constructor(data?: IGetShellSecureUserRoleConfigurationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companyRoleGroups = [];
            this.jointAuthorityRoleGroups = [];
            this.geoscienceAustraliaRoleGroups = [];
            this.roleRelationships = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companyRoleGroups"])) {
                this.companyRoleGroups = [] as any;
                for (let item of _data["companyRoleGroups"])
                    this.companyRoleGroups!.push(GetShellSecureUserRoleConfigurationRoleGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["jointAuthorityRoleGroups"])) {
                this.jointAuthorityRoleGroups = [] as any;
                for (let item of _data["jointAuthorityRoleGroups"])
                    this.jointAuthorityRoleGroups!.push(GetShellSecureUserRoleConfigurationRoleGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["geoscienceAustraliaRoleGroups"])) {
                this.geoscienceAustraliaRoleGroups = [] as any;
                for (let item of _data["geoscienceAustraliaRoleGroups"])
                    this.geoscienceAustraliaRoleGroups!.push(GetShellSecureUserRoleConfigurationRoleGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["roleRelationships"])) {
                this.roleRelationships = [] as any;
                for (let item of _data["roleRelationships"])
                    this.roleRelationships!.push(GetShellSecureUserRoleConfigurationRoleRelationshipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShellSecureUserRoleConfigurationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellSecureUserRoleConfigurationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companyRoleGroups)) {
            data["companyRoleGroups"] = [];
            for (let item of this.companyRoleGroups)
                data["companyRoleGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.jointAuthorityRoleGroups)) {
            data["jointAuthorityRoleGroups"] = [];
            for (let item of this.jointAuthorityRoleGroups)
                data["jointAuthorityRoleGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.geoscienceAustraliaRoleGroups)) {
            data["geoscienceAustraliaRoleGroups"] = [];
            for (let item of this.geoscienceAustraliaRoleGroups)
                data["geoscienceAustraliaRoleGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.roleRelationships)) {
            data["roleRelationships"] = [];
            for (let item of this.roleRelationships)
                data["roleRelationships"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetShellSecureUserRoleConfigurationResponseDto {
    companyRoleGroups: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    jointAuthorityRoleGroups: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    geoscienceAustraliaRoleGroups: GetShellSecureUserRoleConfigurationRoleGroupDto[];
    roleRelationships: GetShellSecureUserRoleConfigurationRoleRelationshipDto[];
}

export class GetShellSecureUserRoleConfigurationRoleDto implements IGetShellSecureUserRoleConfigurationRoleDto {
    role!: SecureRoleEnum;
    title?: string | undefined;

    constructor(data?: IGetShellSecureUserRoleConfigurationRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GetShellSecureUserRoleConfigurationRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellSecureUserRoleConfigurationRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["title"] = this.title;
        return data;
    }
}

export interface IGetShellSecureUserRoleConfigurationRoleDto {
    role: SecureRoleEnum;
    title?: string | undefined;
}

export class GetShellSecureUserRoleConfigurationRoleGroupDto implements IGetShellSecureUserRoleConfigurationRoleGroupDto {
    group!: SecureRoleGroupEnum;
    title?: string | undefined;
    isSpecial!: boolean;
    roles!: GetShellSecureUserRoleConfigurationRoleDto[];

    constructor(data?: IGetShellSecureUserRoleConfigurationRoleGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.title = _data["title"];
            this.isSpecial = _data["isSpecial"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(GetShellSecureUserRoleConfigurationRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShellSecureUserRoleConfigurationRoleGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellSecureUserRoleConfigurationRoleGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["title"] = this.title;
        data["isSpecial"] = this.isSpecial;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetShellSecureUserRoleConfigurationRoleGroupDto {
    group: SecureRoleGroupEnum;
    title?: string | undefined;
    isSpecial: boolean;
    roles: GetShellSecureUserRoleConfigurationRoleDto[];
}

export class GetShellSecureUserRoleConfigurationRoleRelationshipDto implements IGetShellSecureUserRoleConfigurationRoleRelationshipDto {
    role!: SecureRoleEnum;
    effectiveRoles!: SecureRoleEnum[];

    constructor(data?: IGetShellSecureUserRoleConfigurationRoleRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.effectiveRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            if (Array.isArray(_data["effectiveRoles"])) {
                this.effectiveRoles = [] as any;
                for (let item of _data["effectiveRoles"])
                    this.effectiveRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): GetShellSecureUserRoleConfigurationRoleRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellSecureUserRoleConfigurationRoleRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        if (Array.isArray(this.effectiveRoles)) {
            data["effectiveRoles"] = [];
            for (let item of this.effectiveRoles)
                data["effectiveRoles"].push(item);
        }
        return data;
    }
}

export interface IGetShellSecureUserRoleConfigurationRoleRelationshipDto {
    role: SecureRoleEnum;
    effectiveRoles: SecureRoleEnum[];
}

export class GetShellBamboraConfigurationRequestDto implements IGetShellBamboraConfigurationRequestDto {

    constructor(data?: IGetShellBamboraConfigurationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellBamboraConfigurationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellBamboraConfigurationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellBamboraConfigurationRequestDto {
}

export class GetShellBamboraConfigurationResponseDto implements IGetShellBamboraConfigurationResponseDto {
    merchantId!: string;

    constructor(data?: IGetShellBamboraConfigurationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): GetShellBamboraConfigurationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellBamboraConfigurationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        return data;
    }
}

export interface IGetShellBamboraConfigurationResponseDto {
    merchantId: string;
}

export class GetShellLhsNavigationRequestDto implements IGetShellLhsNavigationRequestDto {

    constructor(data?: IGetShellLhsNavigationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellLhsNavigationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellLhsNavigationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellLhsNavigationRequestDto {
}

export class GetShellLhsNavigationResponseDto implements IGetShellLhsNavigationResponseDto {
    secureEntityType!: SecureEntityTypeEnum;
    company!: LhsNavigationCompanyDto;
    jointAuthority!: LhsNavigationJointAuthorityDto;
    geoscienceAustralia!: LhsNavigationGeoscienceAustraliaDto;

    constructor(data?: IGetShellLhsNavigationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new LhsNavigationCompanyDto();
            this.jointAuthority = new LhsNavigationJointAuthorityDto();
            this.geoscienceAustralia = new LhsNavigationGeoscienceAustraliaDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureEntityType = _data["secureEntityType"];
            this.company = _data["company"] ? LhsNavigationCompanyDto.fromJS(_data["company"]) : new LhsNavigationCompanyDto();
            this.jointAuthority = _data["jointAuthority"] ? LhsNavigationJointAuthorityDto.fromJS(_data["jointAuthority"]) : new LhsNavigationJointAuthorityDto();
            this.geoscienceAustralia = _data["geoscienceAustralia"] ? LhsNavigationGeoscienceAustraliaDto.fromJS(_data["geoscienceAustralia"]) : new LhsNavigationGeoscienceAustraliaDto();
        }
    }

    static fromJS(data: any): GetShellLhsNavigationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellLhsNavigationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureEntityType"] = this.secureEntityType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["jointAuthority"] = this.jointAuthority ? this.jointAuthority.toJSON() : <any>undefined;
        data["geoscienceAustralia"] = this.geoscienceAustralia ? this.geoscienceAustralia.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShellLhsNavigationResponseDto {
    secureEntityType: SecureEntityTypeEnum;
    company: LhsNavigationCompanyDto;
    jointAuthority: LhsNavigationJointAuthorityDto;
    geoscienceAustralia: LhsNavigationGeoscienceAustraliaDto;
}

export class GetShellOpenApplicationLinkDto implements IGetShellOpenApplicationLinkDto {
    isAuthorised!: boolean;
    id!: string;

    constructor(data?: IGetShellOpenApplicationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetShellOpenApplicationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenApplicationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShellOpenApplicationLinkDto {
    isAuthorised: boolean;
    id: string;
}

export class GetShellOpenDraftApplicationLinkDto implements IGetShellOpenDraftApplicationLinkDto {
    isAuthorised!: boolean;
    id!: number;
    type!: DraftApplicationTypeEnum;

    constructor(data?: IGetShellOpenDraftApplicationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetShellOpenDraftApplicationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenDraftApplicationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetShellOpenDraftApplicationLinkDto {
    isAuthorised: boolean;
    id: number;
    type: DraftApplicationTypeEnum;
}

export class GetShellOpenFeedbackLinkDto implements IGetShellOpenFeedbackLinkDto {
    isAuthorised!: boolean;
    id!: number;

    constructor(data?: IGetShellOpenFeedbackLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetShellOpenFeedbackLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenFeedbackLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShellOpenFeedbackLinkDto {
    isAuthorised: boolean;
    id: number;
}

export class GetShellOpenFinancialNotificationLinkDto implements IGetShellOpenFinancialNotificationLinkDto {
    isAuthorised!: boolean;
    id!: number;
    isComplete!: boolean;

    constructor(data?: IGetShellOpenFinancialNotificationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): GetShellOpenFinancialNotificationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenFinancialNotificationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface IGetShellOpenFinancialNotificationLinkDto {
    isAuthorised: boolean;
    id: number;
    isComplete: boolean;
}

export class GetShellOpenLicenceLinkDto implements IGetShellOpenLicenceLinkDto {
    isAuthorised!: boolean;
    id!: number;

    constructor(data?: IGetShellOpenLicenceLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetShellOpenLicenceLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenLicenceLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShellOpenLicenceLinkDto {
    isAuthorised: boolean;
    id: number;
}

export class GetShellOpenLinkQueryParameterDto implements IGetShellOpenLinkQueryParameterDto {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IGetShellOpenLinkQueryParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetShellOpenLinkQueryParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenLinkQueryParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetShellOpenLinkQueryParameterDto {
    key?: string | undefined;
    value?: string | undefined;
}

export class GetShellOpenLinkRequestDto implements IGetShellOpenLinkRequestDto {
    queryParameters?: GetShellOpenLinkQueryParameterDto[] | undefined;

    constructor(data?: IGetShellOpenLinkRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queryParameters"])) {
                this.queryParameters = [] as any;
                for (let item of _data["queryParameters"])
                    this.queryParameters!.push(GetShellOpenLinkQueryParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShellOpenLinkRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenLinkRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queryParameters)) {
            data["queryParameters"] = [];
            for (let item of this.queryParameters)
                data["queryParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetShellOpenLinkRequestDto {
    queryParameters?: GetShellOpenLinkQueryParameterDto[] | undefined;
}

export class GetShellOpenLinkResponseDto implements IGetShellOpenLinkResponseDto {
    linkType!: SepiLinkTypeEnum;
    applicationLink?: GetShellOpenApplicationLinkDto | undefined;
    draftApplicationLink?: GetShellOpenDraftApplicationLinkDto | undefined;
    financialNotificationLink?: GetShellOpenFinancialNotificationLinkDto | undefined;
    secureRequestGroupLink?: GetShellOpenSecureRequestGroupLinkDto | undefined;
    feedbackLink?: GetShellOpenFeedbackLinkDto | undefined;
    titleLink?: GetShellOpenTitleLinkDto | undefined;
    licenceLink?: GetShellOpenLicenceLinkDto | undefined;

    constructor(data?: IGetShellOpenLinkResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkType = _data["linkType"];
            this.applicationLink = _data["applicationLink"] ? GetShellOpenApplicationLinkDto.fromJS(_data["applicationLink"]) : <any>undefined;
            this.draftApplicationLink = _data["draftApplicationLink"] ? GetShellOpenDraftApplicationLinkDto.fromJS(_data["draftApplicationLink"]) : <any>undefined;
            this.financialNotificationLink = _data["financialNotificationLink"] ? GetShellOpenFinancialNotificationLinkDto.fromJS(_data["financialNotificationLink"]) : <any>undefined;
            this.secureRequestGroupLink = _data["secureRequestGroupLink"] ? GetShellOpenSecureRequestGroupLinkDto.fromJS(_data["secureRequestGroupLink"]) : <any>undefined;
            this.feedbackLink = _data["feedbackLink"] ? GetShellOpenFeedbackLinkDto.fromJS(_data["feedbackLink"]) : <any>undefined;
            this.titleLink = _data["titleLink"] ? GetShellOpenTitleLinkDto.fromJS(_data["titleLink"]) : <any>undefined;
            this.licenceLink = _data["licenceLink"] ? GetShellOpenLicenceLinkDto.fromJS(_data["licenceLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShellOpenLinkResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenLinkResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkType"] = this.linkType;
        data["applicationLink"] = this.applicationLink ? this.applicationLink.toJSON() : <any>undefined;
        data["draftApplicationLink"] = this.draftApplicationLink ? this.draftApplicationLink.toJSON() : <any>undefined;
        data["financialNotificationLink"] = this.financialNotificationLink ? this.financialNotificationLink.toJSON() : <any>undefined;
        data["secureRequestGroupLink"] = this.secureRequestGroupLink ? this.secureRequestGroupLink.toJSON() : <any>undefined;
        data["feedbackLink"] = this.feedbackLink ? this.feedbackLink.toJSON() : <any>undefined;
        data["titleLink"] = this.titleLink ? this.titleLink.toJSON() : <any>undefined;
        data["licenceLink"] = this.licenceLink ? this.licenceLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShellOpenLinkResponseDto {
    linkType: SepiLinkTypeEnum;
    applicationLink?: GetShellOpenApplicationLinkDto | undefined;
    draftApplicationLink?: GetShellOpenDraftApplicationLinkDto | undefined;
    financialNotificationLink?: GetShellOpenFinancialNotificationLinkDto | undefined;
    secureRequestGroupLink?: GetShellOpenSecureRequestGroupLinkDto | undefined;
    feedbackLink?: GetShellOpenFeedbackLinkDto | undefined;
    titleLink?: GetShellOpenTitleLinkDto | undefined;
    licenceLink?: GetShellOpenLicenceLinkDto | undefined;
}

export class GetShellOpenSecureRequestGroupLinkDto implements IGetShellOpenSecureRequestGroupLinkDto {
    isAuthorised!: boolean;
    id!: number;
    type!: SecureRequestGroupTypeEnum;

    constructor(data?: IGetShellOpenSecureRequestGroupLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetShellOpenSecureRequestGroupLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenSecureRequestGroupLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetShellOpenSecureRequestGroupLinkDto {
    isAuthorised: boolean;
    id: number;
    type: SecureRequestGroupTypeEnum;
}

export class GetShellOpenTitleLinkDto implements IGetShellOpenTitleLinkDto {
    isAuthorised!: boolean;
    id!: string;

    constructor(data?: IGetShellOpenTitleLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetShellOpenTitleLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellOpenTitleLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShellOpenTitleLinkDto {
    isAuthorised: boolean;
    id: string;
}

export class GetShellTitleBadgesRequestDto implements IGetShellTitleBadgesRequestDto {

    constructor(data?: IGetShellTitleBadgesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetShellTitleBadgesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellTitleBadgesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetShellTitleBadgesRequestDto {
}

export class GetShellTitleBadgesResponseDto implements IGetShellTitleBadgesResponseDto {
    titles!: GetShellTitleBadgesTitleDto[];

    constructor(data?: IGetShellTitleBadgesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetShellTitleBadgesTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShellTitleBadgesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellTitleBadgesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetShellTitleBadgesResponseDto {
    titles: GetShellTitleBadgesTitleDto[];
}

export class GetShellTitleBadgesTitleDto implements IGetShellTitleBadgesTitleDto {
    titleId!: string;
    hasPriorUseRights!: boolean;
    hasRoyaltyAct!: boolean;
    hasPerthTreaty!: boolean;

    constructor(data?: IGetShellTitleBadgesTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.hasPriorUseRights = _data["hasPriorUseRights"];
            this.hasRoyaltyAct = _data["hasRoyaltyAct"];
            this.hasPerthTreaty = _data["hasPerthTreaty"];
        }
    }

    static fromJS(data: any): GetShellTitleBadgesTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShellTitleBadgesTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["hasPriorUseRights"] = this.hasPriorUseRights;
        data["hasRoyaltyAct"] = this.hasRoyaltyAct;
        data["hasPerthTreaty"] = this.hasPerthTreaty;
        return data;
    }
}

export interface IGetShellTitleBadgesTitleDto {
    titleId: string;
    hasPriorUseRights: boolean;
    hasRoyaltyAct: boolean;
    hasPerthTreaty: boolean;
}

export class LhsNavigationCompanyDto implements ILhsNavigationCompanyDto {
    showApplicationsList!: boolean;
    showApplicationAdhocUpload!: boolean;
    showTitlesList!: boolean;
    showLegislativeForms2To7List!: boolean;
    showLicenceList!: boolean;
    showLicenceAdhocUpload!: boolean;
    showInvitationToApplyList!: boolean;
    showFinancialNotificationList!: boolean;
    showPaymentHistoryList!: boolean;
    showViewUserRequests!: boolean;
    showViewUsersList!: boolean;
    showViewMyCompanies!: boolean;

    constructor(data?: ILhsNavigationCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showApplicationsList = _data["showApplicationsList"];
            this.showApplicationAdhocUpload = _data["showApplicationAdhocUpload"];
            this.showTitlesList = _data["showTitlesList"];
            this.showLegislativeForms2To7List = _data["showLegislativeForms2To7List"];
            this.showLicenceList = _data["showLicenceList"];
            this.showLicenceAdhocUpload = _data["showLicenceAdhocUpload"];
            this.showInvitationToApplyList = _data["showInvitationToApplyList"];
            this.showFinancialNotificationList = _data["showFinancialNotificationList"];
            this.showPaymentHistoryList = _data["showPaymentHistoryList"];
            this.showViewUserRequests = _data["showViewUserRequests"];
            this.showViewUsersList = _data["showViewUsersList"];
            this.showViewMyCompanies = _data["showViewMyCompanies"];
        }
    }

    static fromJS(data: any): LhsNavigationCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new LhsNavigationCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showApplicationsList"] = this.showApplicationsList;
        data["showApplicationAdhocUpload"] = this.showApplicationAdhocUpload;
        data["showTitlesList"] = this.showTitlesList;
        data["showLegislativeForms2To7List"] = this.showLegislativeForms2To7List;
        data["showLicenceList"] = this.showLicenceList;
        data["showLicenceAdhocUpload"] = this.showLicenceAdhocUpload;
        data["showInvitationToApplyList"] = this.showInvitationToApplyList;
        data["showFinancialNotificationList"] = this.showFinancialNotificationList;
        data["showPaymentHistoryList"] = this.showPaymentHistoryList;
        data["showViewUserRequests"] = this.showViewUserRequests;
        data["showViewUsersList"] = this.showViewUsersList;
        data["showViewMyCompanies"] = this.showViewMyCompanies;
        return data;
    }
}

export interface ILhsNavigationCompanyDto {
    showApplicationsList: boolean;
    showApplicationAdhocUpload: boolean;
    showTitlesList: boolean;
    showLegislativeForms2To7List: boolean;
    showLicenceList: boolean;
    showLicenceAdhocUpload: boolean;
    showInvitationToApplyList: boolean;
    showFinancialNotificationList: boolean;
    showPaymentHistoryList: boolean;
    showViewUserRequests: boolean;
    showViewUsersList: boolean;
    showViewMyCompanies: boolean;
}

export class LhsNavigationGeoscienceAustraliaDto implements ILhsNavigationGeoscienceAustraliaDto {
    showViewWellsBoreholesWells!: boolean;
    showViewWellsBoreholesBoreholes!: boolean;
    showViewWellsBoreholesRigs!: boolean;
    showViewWellsBoreholesReports!: boolean;
    showViewSurveysAcquisitionsSurveys!: boolean;
    showViewSurveysAcquisitionsAcquisitions!: boolean;
    showViewReprocessingsProjectsReprocessings!: boolean;
    showViewReprocessingsProjectsReprocessingProjects!: boolean;
    showViewDataSubmissionsAuthorisations!: boolean;
    showViewFeedbackList!: boolean;
    showViewUserRequests!: boolean;
    showViewGeoscienceAustralia!: boolean;
    showViewMyUserList!: boolean;
    showViewReportsAndAttachmentsReports!: boolean;
    showViewReportsAndAttachmentsAttachments!: boolean;
    showViewReportsAndDataSurveyData!: boolean;

    constructor(data?: ILhsNavigationGeoscienceAustraliaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showViewWellsBoreholesWells = _data["showViewWellsBoreholesWells"];
            this.showViewWellsBoreholesBoreholes = _data["showViewWellsBoreholesBoreholes"];
            this.showViewWellsBoreholesRigs = _data["showViewWellsBoreholesRigs"];
            this.showViewWellsBoreholesReports = _data["showViewWellsBoreholesReports"];
            this.showViewSurveysAcquisitionsSurveys = _data["showViewSurveysAcquisitionsSurveys"];
            this.showViewSurveysAcquisitionsAcquisitions = _data["showViewSurveysAcquisitionsAcquisitions"];
            this.showViewReprocessingsProjectsReprocessings = _data["showViewReprocessingsProjectsReprocessings"];
            this.showViewReprocessingsProjectsReprocessingProjects = _data["showViewReprocessingsProjectsReprocessingProjects"];
            this.showViewDataSubmissionsAuthorisations = _data["showViewDataSubmissionsAuthorisations"];
            this.showViewFeedbackList = _data["showViewFeedbackList"];
            this.showViewUserRequests = _data["showViewUserRequests"];
            this.showViewGeoscienceAustralia = _data["showViewGeoscienceAustralia"];
            this.showViewMyUserList = _data["showViewMyUserList"];
            this.showViewReportsAndAttachmentsReports = _data["showViewReportsAndAttachmentsReports"];
            this.showViewReportsAndAttachmentsAttachments = _data["showViewReportsAndAttachmentsAttachments"];
            this.showViewReportsAndDataSurveyData = _data["showViewReportsAndDataSurveyData"];
        }
    }

    static fromJS(data: any): LhsNavigationGeoscienceAustraliaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LhsNavigationGeoscienceAustraliaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showViewWellsBoreholesWells"] = this.showViewWellsBoreholesWells;
        data["showViewWellsBoreholesBoreholes"] = this.showViewWellsBoreholesBoreholes;
        data["showViewWellsBoreholesRigs"] = this.showViewWellsBoreholesRigs;
        data["showViewWellsBoreholesReports"] = this.showViewWellsBoreholesReports;
        data["showViewSurveysAcquisitionsSurveys"] = this.showViewSurveysAcquisitionsSurveys;
        data["showViewSurveysAcquisitionsAcquisitions"] = this.showViewSurveysAcquisitionsAcquisitions;
        data["showViewReprocessingsProjectsReprocessings"] = this.showViewReprocessingsProjectsReprocessings;
        data["showViewReprocessingsProjectsReprocessingProjects"] = this.showViewReprocessingsProjectsReprocessingProjects;
        data["showViewDataSubmissionsAuthorisations"] = this.showViewDataSubmissionsAuthorisations;
        data["showViewFeedbackList"] = this.showViewFeedbackList;
        data["showViewUserRequests"] = this.showViewUserRequests;
        data["showViewGeoscienceAustralia"] = this.showViewGeoscienceAustralia;
        data["showViewMyUserList"] = this.showViewMyUserList;
        data["showViewReportsAndAttachmentsReports"] = this.showViewReportsAndAttachmentsReports;
        data["showViewReportsAndAttachmentsAttachments"] = this.showViewReportsAndAttachmentsAttachments;
        data["showViewReportsAndDataSurveyData"] = this.showViewReportsAndDataSurveyData;
        return data;
    }
}

export interface ILhsNavigationGeoscienceAustraliaDto {
    showViewWellsBoreholesWells: boolean;
    showViewWellsBoreholesBoreholes: boolean;
    showViewWellsBoreholesRigs: boolean;
    showViewWellsBoreholesReports: boolean;
    showViewSurveysAcquisitionsSurveys: boolean;
    showViewSurveysAcquisitionsAcquisitions: boolean;
    showViewReprocessingsProjectsReprocessings: boolean;
    showViewReprocessingsProjectsReprocessingProjects: boolean;
    showViewDataSubmissionsAuthorisations: boolean;
    showViewFeedbackList: boolean;
    showViewUserRequests: boolean;
    showViewGeoscienceAustralia: boolean;
    showViewMyUserList: boolean;
    showViewReportsAndAttachmentsReports: boolean;
    showViewReportsAndAttachmentsAttachments: boolean;
    showViewReportsAndDataSurveyData: boolean;
}

export class LhsNavigationJointAuthorityDto implements ILhsNavigationJointAuthorityDto {
    showApplicationsList!: boolean;
    showTitlesList!: boolean;
    showLicencesList!: boolean;
    showViewUserRequests!: boolean;
    showViewMyJointAuthority!: boolean;
    showViewMyUserList!: boolean;

    constructor(data?: ILhsNavigationJointAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showApplicationsList = _data["showApplicationsList"];
            this.showTitlesList = _data["showTitlesList"];
            this.showLicencesList = _data["showLicencesList"];
            this.showViewUserRequests = _data["showViewUserRequests"];
            this.showViewMyJointAuthority = _data["showViewMyJointAuthority"];
            this.showViewMyUserList = _data["showViewMyUserList"];
        }
    }

    static fromJS(data: any): LhsNavigationJointAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new LhsNavigationJointAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showApplicationsList"] = this.showApplicationsList;
        data["showTitlesList"] = this.showTitlesList;
        data["showLicencesList"] = this.showLicencesList;
        data["showViewUserRequests"] = this.showViewUserRequests;
        data["showViewMyJointAuthority"] = this.showViewMyJointAuthority;
        data["showViewMyUserList"] = this.showViewMyUserList;
        return data;
    }
}

export interface ILhsNavigationJointAuthorityDto {
    showApplicationsList: boolean;
    showTitlesList: boolean;
    showLicencesList: boolean;
    showViewUserRequests: boolean;
    showViewMyJointAuthority: boolean;
    showViewMyUserList: boolean;
}

export class SignInRequestDto implements ISignInRequestDto {

    constructor(data?: ISignInRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SignInRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISignInRequestDto {
}

export class SignInResponseDto implements ISignInResponseDto {
    secureEntityType!: SecureEntityTypeEnum;

    constructor(data?: ISignInResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureEntityType = _data["secureEntityType"];
        }
    }

    static fromJS(data: any): SignInResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureEntityType"] = this.secureEntityType;
        return data;
    }
}

export interface ISignInResponseDto {
    secureEntityType: SecureEntityTypeEnum;
}

export class GetAllReportsRequestDto implements IGetAllReportsRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetAllReportsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageToken = _data["pageToken"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetAllReportsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageToken"] = this.pageToken;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetAllReportsRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;
}

export class GetAllReportsResponseDto implements IGetAllReportsResponseDto {
    nextPageToken?: string | undefined;
    reports?: GetAllReportsResponseReportDto[] | undefined;

    constructor(data?: IGetAllReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextPageToken = _data["nextPageToken"];
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(GetAllReportsResponseReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextPageToken"] = this.nextPageToken;
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllReportsResponseDto {
    nextPageToken?: string | undefined;
    reports?: GetAllReportsResponseReportDto[] | undefined;
}

export class GetAllReportsResponseReportDto implements IGetAllReportsResponseReportDto {
    reportTitle?: string | undefined;
    publicTitle?: string | undefined;
    reportType?: string | undefined;
    itemId?: string | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    writtenDate?: Date | undefined;
    receivedDate?: Date | undefined;
    releasedDate?: Date | undefined;
    author?: string | undefined;
    basicInterpretativeType?: string | undefined;
    contractorName?: string | undefined;
    companyName?: string | undefined;
    dataFormat?: string | undefined;
    dataStatus?: string | undefined;
    conditionStatus?: string | undefined;
    mediaType?: string | undefined;
    rddsStatus?: string | undefined;
    rddsComments?: string | undefined;
    qcComments?: string | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential!: boolean;
    confidentialityComments?: string | undefined;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAllReportsResponseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTitle = _data["reportTitle"];
            this.publicTitle = _data["publicTitle"];
            this.reportType = _data["reportType"];
            this.itemId = _data["itemId"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.writtenDate = _data["writtenDate"] ? new Date(_data["writtenDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.basicInterpretativeType = _data["basicInterpretativeType"];
            this.contractorName = _data["contractorName"];
            this.companyName = _data["companyName"];
            this.dataFormat = _data["dataFormat"];
            this.dataStatus = _data["dataStatus"];
            this.conditionStatus = _data["conditionStatus"];
            this.mediaType = _data["mediaType"];
            this.rddsStatus = _data["rddsStatus"];
            this.rddsComments = _data["rddsComments"];
            this.qcComments = _data["qcComments"];
            this.isCopiedToNopims = _data["isCopiedToNopims"];
            this.isConfidential = _data["isConfidential"];
            this.confidentialityComments = _data["confidentialityComments"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllReportsResponseReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportsResponseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTitle"] = this.reportTitle;
        data["publicTitle"] = this.publicTitle;
        data["reportType"] = this.reportType;
        data["itemId"] = this.itemId;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["writtenDate"] = this.writtenDate ? this.writtenDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["basicInterpretativeType"] = this.basicInterpretativeType;
        data["contractorName"] = this.contractorName;
        data["companyName"] = this.companyName;
        data["dataFormat"] = this.dataFormat;
        data["dataStatus"] = this.dataStatus;
        data["conditionStatus"] = this.conditionStatus;
        data["mediaType"] = this.mediaType;
        data["rddsStatus"] = this.rddsStatus;
        data["rddsComments"] = this.rddsComments;
        data["qcComments"] = this.qcComments;
        data["isCopiedToNopims"] = this.isCopiedToNopims;
        data["isConfidential"] = this.isConfidential;
        data["confidentialityComments"] = this.confidentialityComments;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllReportsResponseReportDto {
    reportTitle?: string | undefined;
    publicTitle?: string | undefined;
    reportType?: string | undefined;
    itemId?: string | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    writtenDate?: Date | undefined;
    receivedDate?: Date | undefined;
    releasedDate?: Date | undefined;
    author?: string | undefined;
    basicInterpretativeType?: string | undefined;
    contractorName?: string | undefined;
    companyName?: string | undefined;
    dataFormat?: string | undefined;
    dataStatus?: string | undefined;
    conditionStatus?: string | undefined;
    mediaType?: string | undefined;
    rddsStatus?: string | undefined;
    rddsComments?: string | undefined;
    qcComments?: string | undefined;
    isCopiedToNopims?: boolean | undefined;
    isConfidential: boolean;
    confidentialityComments?: string | undefined;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAllReprocessingRequestDto implements IGetAllReprocessingRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetAllReprocessingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageToken = _data["pageToken"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetAllReprocessingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReprocessingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageToken"] = this.pageToken;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetAllReprocessingRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;
}

export class GetAllReprocessingResponseDto implements IGetAllReprocessingResponseDto {
    nextPageToken?: string | undefined;
    reprocessing?: GetAllReprocessingResponseReprocessingDto[] | undefined;

    constructor(data?: IGetAllReprocessingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextPageToken = _data["nextPageToken"];
            if (Array.isArray(_data["reprocessing"])) {
                this.reprocessing = [] as any;
                for (let item of _data["reprocessing"])
                    this.reprocessing!.push(GetAllReprocessingResponseReprocessingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllReprocessingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReprocessingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextPageToken"] = this.nextPageToken;
        if (Array.isArray(this.reprocessing)) {
            data["reprocessing"] = [];
            for (let item of this.reprocessing)
                data["reprocessing"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllReprocessingResponseDto {
    nextPageToken?: string | undefined;
    reprocessing?: GetAllReprocessingResponseReprocessingDto[] | undefined;
}

export class GetAllReprocessingResponseRelatedSurveyDto implements IGetAllReprocessingResponseRelatedSurveyDto {
    identifier?: string | undefined;
    name?: string | undefined;

    constructor(data?: IGetAllReprocessingResponseRelatedSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetAllReprocessingResponseRelatedSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReprocessingResponseRelatedSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetAllReprocessingResponseRelatedSurveyDto {
    identifier?: string | undefined;
    name?: string | undefined;
}

export class GetAllReprocessingResponseReprocessingDto implements IGetAllReprocessingResponseReprocessingDto {
    identifier?: string | undefined;
    name?: string | undefined;
    legislation?: string | undefined;
    operator?: string | undefined;
    basins?: string[] | undefined;
    comments?: string | undefined;
    relatedSurveys?: GetAllReprocessingResponseRelatedSurveyDto[] | undefined;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAllReprocessingResponseReprocessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.legislation = _data["legislation"];
            this.operator = _data["operator"];
            if (Array.isArray(_data["basins"])) {
                this.basins = [] as any;
                for (let item of _data["basins"])
                    this.basins!.push(item);
            }
            this.comments = _data["comments"];
            if (Array.isArray(_data["relatedSurveys"])) {
                this.relatedSurveys = [] as any;
                for (let item of _data["relatedSurveys"])
                    this.relatedSurveys!.push(GetAllReprocessingResponseRelatedSurveyDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllReprocessingResponseReprocessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReprocessingResponseReprocessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["legislation"] = this.legislation;
        data["operator"] = this.operator;
        if (Array.isArray(this.basins)) {
            data["basins"] = [];
            for (let item of this.basins)
                data["basins"].push(item);
        }
        data["comments"] = this.comments;
        if (Array.isArray(this.relatedSurveys)) {
            data["relatedSurveys"] = [];
            for (let item of this.relatedSurveys)
                data["relatedSurveys"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllReprocessingResponseReprocessingDto {
    identifier?: string | undefined;
    name?: string | undefined;
    legislation?: string | undefined;
    operator?: string | undefined;
    basins?: string[] | undefined;
    comments?: string | undefined;
    relatedSurveys?: GetAllReprocessingResponseRelatedSurveyDto[] | undefined;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAcquisitionRequestDto implements IGetAcquisitionRequestDto {
    identifier?: string | undefined;

    constructor(data?: IGetAcquisitionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): GetAcquisitionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcquisitionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IGetAcquisitionRequestDto {
    identifier?: string | undefined;
}

export class GetAcquisitionResponseDto implements IGetAcquisitionResponseDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyIdentifier?: string | undefined;
    surveyName?: string | undefined;
    linePrefix?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalLineLength?: number | undefined;
    areaSqKm?: number | undefined;
    exclusivity?: string | undefined;
    vessel?: string | undefined;
    acquisitionType?: string | undefined;
    terrainType?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    subset2DReleaseDate?: Date | undefined;
    isAutoCalculateDates!: boolean;
    publicComments?: string | undefined;
    comments?: string | undefined;
    isConfidential!: boolean;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAcquisitionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.surveyIdentifier = _data["surveyIdentifier"];
            this.surveyName = _data["surveyName"];
            this.linePrefix = _data["linePrefix"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalLineLength = _data["totalLineLength"];
            this.areaSqKm = _data["areaSqKm"];
            this.exclusivity = _data["exclusivity"];
            this.vessel = _data["vessel"];
            this.acquisitionType = _data["acquisitionType"];
            this.terrainType = _data["terrainType"];
            this.contractor = _data["contractor"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.subset2DRelevantDate = _data["subset2DRelevantDate"] ? new Date(_data["subset2DRelevantDate"].toString()) : <any>undefined;
            this.subset2DReleaseDate = _data["subset2DReleaseDate"] ? new Date(_data["subset2DReleaseDate"].toString()) : <any>undefined;
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.publicComments = _data["publicComments"];
            this.comments = _data["comments"];
            this.isConfidential = _data["isConfidential"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAcquisitionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcquisitionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["surveyIdentifier"] = this.surveyIdentifier;
        data["surveyName"] = this.surveyName;
        data["linePrefix"] = this.linePrefix;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalLineLength"] = this.totalLineLength;
        data["areaSqKm"] = this.areaSqKm;
        data["exclusivity"] = this.exclusivity;
        data["vessel"] = this.vessel;
        data["acquisitionType"] = this.acquisitionType;
        data["terrainType"] = this.terrainType;
        data["contractor"] = this.contractor;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["subset2DRelevantDate"] = this.subset2DRelevantDate ? this.subset2DRelevantDate.toISOString() : <any>undefined;
        data["subset2DReleaseDate"] = this.subset2DReleaseDate ? this.subset2DReleaseDate.toISOString() : <any>undefined;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["publicComments"] = this.publicComments;
        data["comments"] = this.comments;
        data["isConfidential"] = this.isConfidential;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAcquisitionResponseDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyIdentifier?: string | undefined;
    surveyName?: string | undefined;
    linePrefix?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalLineLength?: number | undefined;
    areaSqKm?: number | undefined;
    exclusivity?: string | undefined;
    vessel?: string | undefined;
    acquisitionType?: string | undefined;
    terrainType?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    subset2DReleaseDate?: Date | undefined;
    isAutoCalculateDates: boolean;
    publicComments?: string | undefined;
    comments?: string | undefined;
    isConfidential: boolean;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAllAcquisitionsRequestDto implements IGetAllAcquisitionsRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetAllAcquisitionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageToken = _data["pageToken"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetAllAcquisitionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAcquisitionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageToken"] = this.pageToken;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetAllAcquisitionsRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;
}

export class GetAllAcquisitionsResponseAcquisitionDto implements IGetAllAcquisitionsResponseAcquisitionDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyIdentifier?: string | undefined;
    surveyName?: string | undefined;
    linePrefix?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalLineLength?: number | undefined;
    areaSqKm?: number | undefined;
    exclusivity?: string | undefined;
    vessel?: string | undefined;
    acquisitionType?: string | undefined;
    terrainType?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    subset2DReleaseDate?: Date | undefined;
    isAutoCalculateDates!: boolean;
    publicComments?: string | undefined;
    comments?: string | undefined;
    isConfidential!: boolean;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAllAcquisitionsResponseAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.surveyIdentifier = _data["surveyIdentifier"];
            this.surveyName = _data["surveyName"];
            this.linePrefix = _data["linePrefix"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalLineLength = _data["totalLineLength"];
            this.areaSqKm = _data["areaSqKm"];
            this.exclusivity = _data["exclusivity"];
            this.vessel = _data["vessel"];
            this.acquisitionType = _data["acquisitionType"];
            this.terrainType = _data["terrainType"];
            this.contractor = _data["contractor"];
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.subset2DRelevantDate = _data["subset2DRelevantDate"] ? new Date(_data["subset2DRelevantDate"].toString()) : <any>undefined;
            this.subset2DReleaseDate = _data["subset2DReleaseDate"] ? new Date(_data["subset2DReleaseDate"].toString()) : <any>undefined;
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.publicComments = _data["publicComments"];
            this.comments = _data["comments"];
            this.isConfidential = _data["isConfidential"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllAcquisitionsResponseAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAcquisitionsResponseAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["surveyIdentifier"] = this.surveyIdentifier;
        data["surveyName"] = this.surveyName;
        data["linePrefix"] = this.linePrefix;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalLineLength"] = this.totalLineLength;
        data["areaSqKm"] = this.areaSqKm;
        data["exclusivity"] = this.exclusivity;
        data["vessel"] = this.vessel;
        data["acquisitionType"] = this.acquisitionType;
        data["terrainType"] = this.terrainType;
        data["contractor"] = this.contractor;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["subset2DRelevantDate"] = this.subset2DRelevantDate ? this.subset2DRelevantDate.toISOString() : <any>undefined;
        data["subset2DReleaseDate"] = this.subset2DReleaseDate ? this.subset2DReleaseDate.toISOString() : <any>undefined;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["publicComments"] = this.publicComments;
        data["comments"] = this.comments;
        data["isConfidential"] = this.isConfidential;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllAcquisitionsResponseAcquisitionDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyIdentifier?: string | undefined;
    surveyName?: string | undefined;
    linePrefix?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalLineLength?: number | undefined;
    areaSqKm?: number | undefined;
    exclusivity?: string | undefined;
    vessel?: string | undefined;
    acquisitionType?: string | undefined;
    terrainType?: string | undefined;
    contractor?: string | undefined;
    basicRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    subset2DReleaseDate?: Date | undefined;
    isAutoCalculateDates: boolean;
    publicComments?: string | undefined;
    comments?: string | undefined;
    isConfidential: boolean;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAllAcquisitionsResponseDto implements IGetAllAcquisitionsResponseDto {
    nextPageToken?: string | undefined;
    acquisitions?: GetAllAcquisitionsResponseAcquisitionDto[] | undefined;

    constructor(data?: IGetAllAcquisitionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextPageToken = _data["nextPageToken"];
            if (Array.isArray(_data["acquisitions"])) {
                this.acquisitions = [] as any;
                for (let item of _data["acquisitions"])
                    this.acquisitions!.push(GetAllAcquisitionsResponseAcquisitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAcquisitionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAcquisitionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextPageToken"] = this.nextPageToken;
        if (Array.isArray(this.acquisitions)) {
            data["acquisitions"] = [];
            for (let item of this.acquisitions)
                data["acquisitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllAcquisitionsResponseDto {
    nextPageToken?: string | undefined;
    acquisitions?: GetAllAcquisitionsResponseAcquisitionDto[] | undefined;
}

export class GetAllSurveysRequestDto implements IGetAllSurveysRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetAllSurveysRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageToken = _data["pageToken"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetAllSurveysRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveysRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageToken"] = this.pageToken;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetAllSurveysRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;
}

export class GetAllSurveysResponseDto implements IGetAllSurveysResponseDto {
    nextPageToken?: string | undefined;
    surveys?: GetAllSurveysResponseSurveyDto[] | undefined;

    constructor(data?: IGetAllSurveysResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextPageToken = _data["nextPageToken"];
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(GetAllSurveysResponseSurveyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllSurveysResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveysResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextPageToken"] = this.nextPageToken;
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllSurveysResponseDto {
    nextPageToken?: string | undefined;
    surveys?: GetAllSurveysResponseSurveyDto[] | undefined;
}

export class GetAllSurveysResponseSurveyDto implements IGetAllSurveysResponseSurveyDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyType?: string | undefined;
    operator?: string | undefined;
    legislation?: string | undefined;
    basins?: string[] | undefined;
    offshoreAreas?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    comments?: string | undefined;
    isConfidential!: boolean;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAllSurveysResponseSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.surveyType = _data["surveyType"];
            this.operator = _data["operator"];
            this.legislation = _data["legislation"];
            if (Array.isArray(_data["basins"])) {
                this.basins = [] as any;
                for (let item of _data["basins"])
                    this.basins!.push(item);
            }
            if (Array.isArray(_data["offshoreAreas"])) {
                this.offshoreAreas = [] as any;
                for (let item of _data["offshoreAreas"])
                    this.offshoreAreas!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.subset2DRelevantDate = _data["subset2DRelevantDate"] ? new Date(_data["subset2DRelevantDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.isConfidential = _data["isConfidential"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSurveysResponseSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveysResponseSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["surveyType"] = this.surveyType;
        data["operator"] = this.operator;
        data["legislation"] = this.legislation;
        if (Array.isArray(this.basins)) {
            data["basins"] = [];
            for (let item of this.basins)
                data["basins"].push(item);
        }
        if (Array.isArray(this.offshoreAreas)) {
            data["offshoreAreas"] = [];
            for (let item of this.offshoreAreas)
                data["offshoreAreas"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["subset2DRelevantDate"] = this.subset2DRelevantDate ? this.subset2DRelevantDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["isConfidential"] = this.isConfidential;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllSurveysResponseSurveyDto {
    identifier?: string | undefined;
    name?: string | undefined;
    surveyType?: string | undefined;
    operator?: string | undefined;
    legislation?: string | undefined;
    basins?: string[] | undefined;
    offshoreAreas?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    basicReleaseDate?: Date | undefined;
    subset2DRelevantDate?: Date | undefined;
    comments?: string | undefined;
    isConfidential: boolean;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAllBoreholesRequestDto implements IGetAllBoreholesRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetAllBoreholesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageToken = _data["pageToken"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetAllBoreholesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBoreholesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageToken"] = this.pageToken;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetAllBoreholesRequestDto {
    pageToken?: string | undefined;
    pageSize?: number | undefined;
}

export class GetAllBoreholesResponseBoreholeDto implements IGetAllBoreholesResponseBoreholeDto {
    ubhi?: string | undefined;
    name?: string | undefined;
    uwi?: string | undefined;
    well?: string | undefined;
    boreholeStatus?: string | undefined;
    rigContractorCompany?: string | undefined;
    operator?: string | undefined;
    boreholeType?: string | undefined;
    purpose?: string | undefined;
    kickOffDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    totalDepthDate?: Date | undefined;
    rig?: string | undefined;
    rigReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    spatialDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    depthReference?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    isConfidential!: boolean;
    basicReleaseDate?: Date | undefined;
    isAutoCalculateDates!: boolean;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetAllBoreholesResponseBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubhi = _data["ubhi"];
            this.name = _data["name"];
            this.uwi = _data["uwi"];
            this.well = _data["well"];
            this.boreholeStatus = _data["boreholeStatus"];
            this.rigContractorCompany = _data["rigContractorCompany"];
            this.operator = _data["operator"];
            this.boreholeType = _data["boreholeType"];
            this.purpose = _data["purpose"];
            this.kickOffDate = _data["kickOffDate"] ? new Date(_data["kickOffDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.kickOffDepth = _data["kickOffDepth"];
            this.drillersTotalDepth = _data["drillersTotalDepth"];
            this.totalDepthDate = _data["totalDepthDate"] ? new Date(_data["totalDepthDate"].toString()) : <any>undefined;
            this.rig = _data["rig"];
            this.rigReleaseDate = _data["rigReleaseDate"] ? new Date(_data["rigReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.spatialDatum = _data["spatialDatum"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.depthReference = _data["depthReference"];
            this.depthReferenceAboveDatum = _data["depthReferenceAboveDatum"];
            this.loggerTotalDepthMeasuredDepth = _data["loggerTotalDepthMeasuredDepth"];
            this.actualHoleCost = _data["actualHoleCost"];
            this.initialApprovedFinancialExpenditure = _data["initialApprovedFinancialExpenditure"];
            this.finalApprovedFinancialExpenditure = _data["finalApprovedFinancialExpenditure"];
            this.costComments = _data["costComments"];
            this.trueVerticalDepthSubSea = _data["trueVerticalDepthSubSea"];
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.isConfidential = _data["isConfidential"];
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllBoreholesResponseBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBoreholesResponseBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubhi"] = this.ubhi;
        data["name"] = this.name;
        data["uwi"] = this.uwi;
        data["well"] = this.well;
        data["boreholeStatus"] = this.boreholeStatus;
        data["rigContractorCompany"] = this.rigContractorCompany;
        data["operator"] = this.operator;
        data["boreholeType"] = this.boreholeType;
        data["purpose"] = this.purpose;
        data["kickOffDate"] = this.kickOffDate ? this.kickOffDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["kickOffDepth"] = this.kickOffDepth;
        data["drillersTotalDepth"] = this.drillersTotalDepth;
        data["totalDepthDate"] = this.totalDepthDate ? this.totalDepthDate.toISOString() : <any>undefined;
        data["rig"] = this.rig;
        data["rigReleaseDate"] = this.rigReleaseDate ? this.rigReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["spatialDatum"] = this.spatialDatum;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["depthReference"] = this.depthReference;
        data["depthReferenceAboveDatum"] = this.depthReferenceAboveDatum;
        data["loggerTotalDepthMeasuredDepth"] = this.loggerTotalDepthMeasuredDepth;
        data["actualHoleCost"] = this.actualHoleCost;
        data["initialApprovedFinancialExpenditure"] = this.initialApprovedFinancialExpenditure;
        data["finalApprovedFinancialExpenditure"] = this.finalApprovedFinancialExpenditure;
        data["costComments"] = this.costComments;
        data["trueVerticalDepthSubSea"] = this.trueVerticalDepthSubSea;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["isConfidential"] = this.isConfidential;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllBoreholesResponseBoreholeDto {
    ubhi?: string | undefined;
    name?: string | undefined;
    uwi?: string | undefined;
    well?: string | undefined;
    boreholeStatus?: string | undefined;
    rigContractorCompany?: string | undefined;
    operator?: string | undefined;
    boreholeType?: string | undefined;
    purpose?: string | undefined;
    kickOffDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    totalDepthDate?: Date | undefined;
    rig?: string | undefined;
    rigReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    spatialDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    depthReference?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    isConfidential: boolean;
    basicReleaseDate?: Date | undefined;
    isAutoCalculateDates: boolean;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class GetAllBoreholesResponseDto implements IGetAllBoreholesResponseDto {
    nextPageToken?: string | undefined;
    boreholes?: GetAllBoreholesResponseBoreholeDto[] | undefined;

    constructor(data?: IGetAllBoreholesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextPageToken = _data["nextPageToken"];
            if (Array.isArray(_data["boreholes"])) {
                this.boreholes = [] as any;
                for (let item of _data["boreholes"])
                    this.boreholes!.push(GetAllBoreholesResponseBoreholeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllBoreholesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBoreholesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextPageToken"] = this.nextPageToken;
        if (Array.isArray(this.boreholes)) {
            data["boreholes"] = [];
            for (let item of this.boreholes)
                data["boreholes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllBoreholesResponseDto {
    nextPageToken?: string | undefined;
    boreholes?: GetAllBoreholesResponseBoreholeDto[] | undefined;
}

export class GetBoreholeRequestDto implements IGetBoreholeRequestDto {
    ubhi?: string | undefined;

    constructor(data?: IGetBoreholeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubhi = _data["ubhi"];
        }
    }

    static fromJS(data: any): GetBoreholeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoreholeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubhi"] = this.ubhi;
        return data;
    }
}

export interface IGetBoreholeRequestDto {
    ubhi?: string | undefined;
}

export class GetBoreholeResponseDto implements IGetBoreholeResponseDto {
    ubhi?: string | undefined;
    name?: string | undefined;
    uwi?: string | undefined;
    well?: string | undefined;
    boreholeStatus?: string | undefined;
    rigContractorCompany?: string | undefined;
    operator?: string | undefined;
    boreholeType?: string | undefined;
    purpose?: string | undefined;
    kickOffDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    totalDepthDate?: Date | undefined;
    rig?: string | undefined;
    rigReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    spatialDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    depthReference?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    isConfidential!: boolean;
    basicReleaseDate?: Date | undefined;
    isAutoCalculateDates!: boolean;
    createdBy?: string | undefined;
    createdDatetime!: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime!: Date;

    constructor(data?: IGetBoreholeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubhi = _data["ubhi"];
            this.name = _data["name"];
            this.uwi = _data["uwi"];
            this.well = _data["well"];
            this.boreholeStatus = _data["boreholeStatus"];
            this.rigContractorCompany = _data["rigContractorCompany"];
            this.operator = _data["operator"];
            this.boreholeType = _data["boreholeType"];
            this.purpose = _data["purpose"];
            this.kickOffDate = _data["kickOffDate"] ? new Date(_data["kickOffDate"].toString()) : <any>undefined;
            this.basicRelevantDate = _data["basicRelevantDate"] ? new Date(_data["basicRelevantDate"].toString()) : <any>undefined;
            this.kickOffDepth = _data["kickOffDepth"];
            this.drillersTotalDepth = _data["drillersTotalDepth"];
            this.totalDepthDate = _data["totalDepthDate"] ? new Date(_data["totalDepthDate"].toString()) : <any>undefined;
            this.rig = _data["rig"];
            this.rigReleaseDate = _data["rigReleaseDate"] ? new Date(_data["rigReleaseDate"].toString()) : <any>undefined;
            this.interpretativeRelevantDate = _data["interpretativeRelevantDate"] ? new Date(_data["interpretativeRelevantDate"].toString()) : <any>undefined;
            this.interpretativeReleaseDate = _data["interpretativeReleaseDate"] ? new Date(_data["interpretativeReleaseDate"].toString()) : <any>undefined;
            this.spatialDatum = _data["spatialDatum"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.depthReference = _data["depthReference"];
            this.depthReferenceAboveDatum = _data["depthReferenceAboveDatum"];
            this.loggerTotalDepthMeasuredDepth = _data["loggerTotalDepthMeasuredDepth"];
            this.actualHoleCost = _data["actualHoleCost"];
            this.initialApprovedFinancialExpenditure = _data["initialApprovedFinancialExpenditure"];
            this.finalApprovedFinancialExpenditure = _data["finalApprovedFinancialExpenditure"];
            this.costComments = _data["costComments"];
            this.trueVerticalDepthSubSea = _data["trueVerticalDepthSubSea"];
            this.comments = _data["comments"];
            this.publicComments = _data["publicComments"];
            this.isConfidential = _data["isConfidential"];
            this.basicReleaseDate = _data["basicReleaseDate"] ? new Date(_data["basicReleaseDate"].toString()) : <any>undefined;
            this.isAutoCalculateDates = _data["isAutoCalculateDates"];
            this.createdBy = _data["createdBy"];
            this.createdDatetime = _data["createdDatetime"] ? new Date(_data["createdDatetime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDatetime = _data["lastModifiedDatetime"] ? new Date(_data["lastModifiedDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBoreholeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoreholeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubhi"] = this.ubhi;
        data["name"] = this.name;
        data["uwi"] = this.uwi;
        data["well"] = this.well;
        data["boreholeStatus"] = this.boreholeStatus;
        data["rigContractorCompany"] = this.rigContractorCompany;
        data["operator"] = this.operator;
        data["boreholeType"] = this.boreholeType;
        data["purpose"] = this.purpose;
        data["kickOffDate"] = this.kickOffDate ? this.kickOffDate.toISOString() : <any>undefined;
        data["basicRelevantDate"] = this.basicRelevantDate ? this.basicRelevantDate.toISOString() : <any>undefined;
        data["kickOffDepth"] = this.kickOffDepth;
        data["drillersTotalDepth"] = this.drillersTotalDepth;
        data["totalDepthDate"] = this.totalDepthDate ? this.totalDepthDate.toISOString() : <any>undefined;
        data["rig"] = this.rig;
        data["rigReleaseDate"] = this.rigReleaseDate ? this.rigReleaseDate.toISOString() : <any>undefined;
        data["interpretativeRelevantDate"] = this.interpretativeRelevantDate ? this.interpretativeRelevantDate.toISOString() : <any>undefined;
        data["interpretativeReleaseDate"] = this.interpretativeReleaseDate ? this.interpretativeReleaseDate.toISOString() : <any>undefined;
        data["spatialDatum"] = this.spatialDatum;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["depthReference"] = this.depthReference;
        data["depthReferenceAboveDatum"] = this.depthReferenceAboveDatum;
        data["loggerTotalDepthMeasuredDepth"] = this.loggerTotalDepthMeasuredDepth;
        data["actualHoleCost"] = this.actualHoleCost;
        data["initialApprovedFinancialExpenditure"] = this.initialApprovedFinancialExpenditure;
        data["finalApprovedFinancialExpenditure"] = this.finalApprovedFinancialExpenditure;
        data["costComments"] = this.costComments;
        data["trueVerticalDepthSubSea"] = this.trueVerticalDepthSubSea;
        data["comments"] = this.comments;
        data["publicComments"] = this.publicComments;
        data["isConfidential"] = this.isConfidential;
        data["basicReleaseDate"] = this.basicReleaseDate ? this.basicReleaseDate.toISOString() : <any>undefined;
        data["isAutoCalculateDates"] = this.isAutoCalculateDates;
        data["createdBy"] = this.createdBy;
        data["createdDatetime"] = this.createdDatetime ? this.createdDatetime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDatetime"] = this.lastModifiedDatetime ? this.lastModifiedDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetBoreholeResponseDto {
    ubhi?: string | undefined;
    name?: string | undefined;
    uwi?: string | undefined;
    well?: string | undefined;
    boreholeStatus?: string | undefined;
    rigContractorCompany?: string | undefined;
    operator?: string | undefined;
    boreholeType?: string | undefined;
    purpose?: string | undefined;
    kickOffDate?: Date | undefined;
    basicRelevantDate?: Date | undefined;
    kickOffDepth?: number | undefined;
    drillersTotalDepth?: number | undefined;
    totalDepthDate?: Date | undefined;
    rig?: string | undefined;
    rigReleaseDate?: Date | undefined;
    interpretativeRelevantDate?: Date | undefined;
    interpretativeReleaseDate?: Date | undefined;
    spatialDatum?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    depthReference?: string | undefined;
    depthReferenceAboveDatum?: number | undefined;
    loggerTotalDepthMeasuredDepth?: number | undefined;
    actualHoleCost?: number | undefined;
    initialApprovedFinancialExpenditure?: number | undefined;
    finalApprovedFinancialExpenditure?: number | undefined;
    costComments?: string | undefined;
    trueVerticalDepthSubSea?: number | undefined;
    comments?: string | undefined;
    publicComments?: string | undefined;
    isConfidential: boolean;
    basicReleaseDate?: Date | undefined;
    isAutoCalculateDates: boolean;
    createdBy?: string | undefined;
    createdDatetime: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDatetime: Date;
}

export class AllocatedFinancialNotificationDetailsDto implements IAllocatedFinancialNotificationDetailsDto {
    financialNotificationId!: number;
    versionNumber!: number;

    constructor(data?: IAllocatedFinancialNotificationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialNotificationId = _data["financialNotificationId"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): AllocatedFinancialNotificationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatedFinancialNotificationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialNotificationId"] = this.financialNotificationId;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IAllocatedFinancialNotificationDetailsDto {
    financialNotificationId: number;
    versionNumber: number;
}

export class ApplicationWorkProgramYearActivityDto implements IApplicationWorkProgramYearActivityDto {
    activity!: string;
    description!: string;
    quantity!: string;
    value?: number | undefined;
    activityOrder!: number;

    constructor(data?: IApplicationWorkProgramYearActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.value = _data["value"];
            this.activityOrder = _data["activityOrder"];
        }
    }

    static fromJS(data: any): ApplicationWorkProgramYearActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationWorkProgramYearActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["value"] = this.value;
        data["activityOrder"] = this.activityOrder;
        return data;
    }
}

export interface IApplicationWorkProgramYearActivityDto {
    activity: string;
    description: string;
    quantity: string;
    value?: number | undefined;
    activityOrder: number;
}

export class ApplicationWorkProgramYearDto implements IApplicationWorkProgramYearDto {
    yearType!: string;
    activities!: ApplicationWorkProgramYearActivityDto[];
    value?: number | undefined;
    yearOrder!: number;

    constructor(data?: IApplicationWorkProgramYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearType = _data["yearType"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ApplicationWorkProgramYearActivityDto.fromJS(item));
            }
            this.value = _data["value"];
            this.yearOrder = _data["yearOrder"];
        }
    }

    static fromJS(data: any): ApplicationWorkProgramYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationWorkProgramYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearType"] = this.yearType;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["value"] = this.value;
        data["yearOrder"] = this.yearOrder;
        return data;
    }
}

export interface IApplicationWorkProgramYearDto {
    yearType: string;
    activities: ApplicationWorkProgramYearActivityDto[];
    value?: number | undefined;
    yearOrder: number;
}

export class GetApplicationDetailsItemDto implements IGetApplicationDetailsItemDto {
    name!: string;
    value!: string;

    constructor(data?: IGetApplicationDetailsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetApplicationDetailsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationDetailsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetApplicationDetailsItemDto {
    name: string;
    value: string;
}

export class GetBlockDetailsItemDto implements IGetBlockDetailsItemDto {
    blockId!: number;
    blockNumber!: number;
    isPartBlock!: string;
    mapSheetCode!: string;
    mapSheetName!: string;
    locationName!: string;

    constructor(data?: IGetBlockDetailsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blockId = _data["blockId"];
            this.blockNumber = _data["blockNumber"];
            this.isPartBlock = _data["isPartBlock"];
            this.mapSheetCode = _data["mapSheetCode"];
            this.mapSheetName = _data["mapSheetName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetBlockDetailsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockDetailsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockId"] = this.blockId;
        data["blockNumber"] = this.blockNumber;
        data["isPartBlock"] = this.isPartBlock;
        data["mapSheetCode"] = this.mapSheetCode;
        data["mapSheetName"] = this.mapSheetName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetBlockDetailsItemDto {
    blockId: number;
    blockNumber: number;
    isPartBlock: string;
    mapSheetCode: string;
    mapSheetName: string;
    locationName: string;
}

export class GetTitleholdersItemDto implements IGetTitleholdersItemDto {
    companyId!: number;
    companyName!: string;
    acnOrArbn!: string;

    constructor(data?: IGetTitleholdersItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.acnOrArbn = _data["acnOrArbn"];
        }
    }

    static fromJS(data: any): GetTitleholdersItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTitleholdersItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["acnOrArbn"] = this.acnOrArbn;
        return data;
    }
}

export interface IGetTitleholdersItemDto {
    companyId: number;
    companyName: string;
    acnOrArbn: string;
}

export enum ActEnum {
    Opggs = "Opggs",
    Oei = "Oei",
}

export enum AlfDocumentTypeEnum {
    FnNotice = "FnNotice",
    PaymentStatement = "PaymentStatement",
    FinancialNotificationRefund = "FinancialNotificationRefund",
    LegacyPaymentConfirmation = "LegacyPaymentConfirmation",
    PaymentRefund = "PaymentRefund",
    UnallocatedCreditCardPaymentReceipt = "UnallocatedCreditCardPaymentReceipt",
    AllocatedCreditCardPaymentReceipt = "AllocatedCreditCardPaymentReceipt",
    AllocatedSecurePortalCreditCardPaymentReceipt = "AllocatedSecurePortalCreditCardPaymentReceipt",
}

export enum DraftApplicationTypeEnum {
    ChangeOfCompanyName = "ChangeOfCompanyName",
    ExplorationPermitRenewal = "ExplorationPermitRenewal",
    RetentionLeaseRenewal = "RetentionLeaseRenewal",
    ExtensionOfTimeToLodgeRenewal = "ExtensionOfTimeToLodgeRenewal",
    InitialApplicationRetentionLease = "InitialApplicationRetentionLease",
    InitialApplicationProductionLicence = "InitialApplicationProductionLicence",
    InitialApplicationFeasibilityLicence = "InitialApplicationFeasibilityLicence",
}

export enum FinancialNotificationTypeEnum {
    ApplicationFee = "ApplicationFee",
    AnnualLevyGrant = "AnnualLevyGrant",
    AnnualLevyAnniversary = "AnnualLevyAnniversary",
    LatePaymentPenalty = "LatePaymentPenalty",
    AnnualLevyRenewalAdjustment = "AnnualLevyRenewalAdjustment",
}

export enum LegislativeFormRequestFormDocumentationDigitalSignatureTypeEnum {
    Director = "Director",
    SoleDirectorOnly = "SoleDirectorOnly",
    Secretary = "Secretary",
    SoleDirectorSeparateSecretarySignatureRequired = "SoleDirectorSeparateSecretarySignatureRequired",
    SoleDirectorAndSecretaryOneSignature = "SoleDirectorAndSecretaryOneSignature",
    SoleDirectorOnlyTheCompanyDoesNotHaveACompanySecretaryOneSignature = "SoleDirectorOnlyTheCompanyDoesNotHaveACompanySecretaryOneSignature",
    PowerOfAttorney = "PowerOfAttorney",
}

export enum LegislativeFormRequestFormDocumentationSignatureTypeEnum {
    Wet = "Wet",
    Digital = "Digital",
}

export enum LegislativeFormRequestStateEnum {
    Draft = "Draft",
    ForSigning = "ForSigning",
    ScreeningNopta = "ScreeningNopta",
    Rejected = "Rejected",
    Approved = "Approved",
}

export enum LegislativeFormTypeEnum {
    Form2 = "Form2",
    Form3 = "Form3",
    Form4 = "Form4",
    Form5 = "Form5",
    Form6 = "Form6",
    Form7 = "Form7",
}

export enum NeatsFeatureSwitchEnum {
    Dam2ViewDocuments = "Dam2ViewDocuments",
    MaintainApplication2 = "MaintainApplication2",
}

export enum Payment2MethodEnum {
    DirectDeposit = "DirectDeposit",
    Cheque = "Cheque",
    CreditCard = "CreditCard",
    CreditNote = "CreditNote",
}

export enum PublicStatusEnum {
    FurtherInformationRequired = "FurtherInformationRequired",
    Offer = "Offer",
    Approved = "Approved",
    NotApproved = "NotApproved",
    Lodged = "Lodged",
    UnderAssessment = "UnderAssessment",
    JointAuthorityForDecision = "JointAuthorityForDecision",
    Screening = "Screening",
    FurtherInformationReceived = "FurtherInformationReceived",
    NoptaForDecisionImplementation = "NoptaForDecisionImplementation",
    Registered = "Registered",
    MinisterForDecision = "MinisterForDecision",
    RegistrarForDecisionImplementation = "RegistrarForDecisionImplementation",
}

export enum SecureEntityTypeEnum {
    Company = "Company",
    JointAuthority = "JointAuthority",
    GeoscienceAustralia = "GeoscienceAustralia",
}

export enum SecureRequestGroupTypeEnum {
    NU_CA = "NU_CA",
    NU_CR = "NU_CR",
    NU_CR_CS = "NU_CR_CS",
    NU_NC_CA = "NU_NC_CA",
    CA = "CA",
    CR = "CR",
    CR_CS = "CR_CS",
    CS = "CS",
    NC_CA = "NC_CA",
    NU_JAA = "NU_JAA",
    NU_JAR = "NU_JAR",
    JAA = "JAA",
    JAR = "JAR",
    NU_GAA = "NU_GAA",
    NU_GAR = "NU_GAR",
    GAA = "GAA",
    GAR = "GAR",
}

export enum SecureRoleEnum {
    CompanyAdministrator = "CompanyAdministrator",
    CompanySigner = "CompanySigner",
    CompanyFinancePayer = "CompanyFinancePayer",
    CompanyApplicationReader = "CompanyApplicationReader",
    CompanyLegislativeFormsManager = "CompanyLegislativeFormsManager",
    CompanyApplicationCreator = "CompanyApplicationCreator",
    CompanyApplicationSubmitter = "CompanyApplicationSubmitter",
    JointAuthorityAdministrator = "JointAuthorityAdministrator",
    JointAuthorityReader = "JointAuthorityReader",
    JointAuthorityOfficer = "JointAuthorityOfficer",
    GeoscienceAustraliaAdministrator = "GeoscienceAustraliaAdministrator",
    GeoscienceAustraliaReader = "GeoscienceAustraliaReader",
    GeoscienceAustraliaManager = "GeoscienceAustraliaManager",
    GeoscienceAustraliaFeedbackManager = "GeoscienceAustraliaFeedbackManager",
}

export enum SecureRoleGroupEnum {
    CompanySpecial = "CompanySpecial",
    CompanyFinance = "CompanyFinance",
    CompanyApplications = "CompanyApplications",
    CompanyLegislativeForms = "CompanyLegislativeForms",
    JointAuthoritySpecial = "JointAuthoritySpecial",
    JointAuthorityApplications = "JointAuthorityApplications",
    GeoscienceAustraliaSpecial = "GeoscienceAustraliaSpecial",
    GeoscienceAustraliaData = "GeoscienceAustraliaData",
    GeoscienceAustraliaFeedback = "GeoscienceAustraliaFeedback",
}

export enum Title2SubTypeEnum {
    WorkBid = "WorkBid",
    CashBid = "CashBid",
    Consolidated = "Consolidated",
}

export enum TitleTypeEnum {
    ExplorationPermit = "ExplorationPermit",
    RetentionLease = "RetentionLease",
    ProductionLicence = "ProductionLicence",
    PipelineLicence = "PipelineLicence",
    InfrastructureLicence = "InfrastructureLicence",
    SpecialProspectingAuthority = "SpecialProspectingAuthority",
    AccessAuthority = "AccessAuthority",
    GreenhouseGasAssessmentPermit = "GreenhouseGasAssessmentPermit",
    GreenhouseGasInjectionPermit = "GreenhouseGasInjectionPermit",
    GreenhouseGasHoldingPermit = "GreenhouseGasHoldingPermit",
    SearchAuthority = "SearchAuthority",
    SpecialAuthority = "SpecialAuthority",
}

export class DraftApplicationIdDto implements IDraftApplicationIdDto {
    draftApplicationId!: number;
    draftApplicationType!: DraftApplicationTypeEnum;

    constructor(data?: IDraftApplicationIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftApplicationId = _data["draftApplicationId"];
            this.draftApplicationType = _data["draftApplicationType"];
        }
    }

    static fromJS(data: any): DraftApplicationIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftApplicationId"] = this.draftApplicationId;
        data["draftApplicationType"] = this.draftApplicationType;
        return data;
    }
}

export interface IDraftApplicationIdDto {
    draftApplicationId: number;
    draftApplicationType: DraftApplicationTypeEnum;
}

export class TitleInfoDto implements ITitleInfoDto {
    id!: string;
    titleNumber!: string;

    constructor(data?: ITitleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): TitleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface ITitleInfoDto {
    id: string;
    titleNumber: string;
}

export enum DraftApplicationEvaTypeEnum {
    Yes = "Yes",
    No = "No",
    NA = "NA",
}

export enum DraftApplicationForeignInvestmentApprovalTypeEnum {
    YesAttached = "YesAttached",
    YesToBeProvidedSeparately = "YesToBeProvidedSeparately",
    No = "No",
}

export enum DraftApplicationFormDocumentationDigitalSignatureTypeEnum {
    Director = "Director",
    SoleDirectorOnly = "SoleDirectorOnly",
    Secretary = "Secretary",
    SoleDirectorSeparateSecretarySignatureRequired = "SoleDirectorSeparateSecretarySignatureRequired",
    SoleDirectorAndSecretaryOneSignature = "SoleDirectorAndSecretaryOneSignature",
    SoleDirectorOnlyTheCompanyDoesNotHaveACompanySecretaryOneSignature = "SoleDirectorOnlyTheCompanyDoesNotHaveACompanySecretaryOneSignature",
    PowerOfAttorney = "PowerOfAttorney",
}

export enum DraftApplicationFormDocumentationSignatureTypeEnum {
    Wet = "Wet",
    Digital = "Digital",
}

export enum DraftApplicationOeiContactOverlappingContactTypeEnum {
    UseAbove = "UseAbove",
    UseAttached = "UseAttached",
}

export enum DraftApplicationStateEnum {
    Preparing = "Preparing",
    ForSigning = "ForSigning",
    Paying = "Paying",
    ForSubmission = "ForSubmission",
    Submitted = "Submitted",
    Deleted = "Deleted",
}

export enum DraftApplicationSupportingDocumentationChecklistItemTypeEnum {
    CoCN_Certificate = "CoCN_Certificate",
    EpRenewal_Blocks = "EpRenewal_Blocks",
    EpRenewal_Technical = "EpRenewal_Technical",
    EpRenewal_Financial = "EpRenewal_Financial",
    RlRenewal_Technical = "RlRenewal_Technical",
    RlRenewal_Financial = "RlRenewal_Financial",
    Iarl_Technical = "Iarl_Technical",
    Iarl_Financial = "Iarl_Financial",
    Iarl_Blocks = "Iarl_Blocks",
    Iapp_Technical = "Iapp_Technical",
    Iapp_Financial = "Iapp_Financial",
    Iapp_Blocks = "Iapp_Blocks",
    Iafl_ProposedLicenceAreaDetails = "Iafl_ProposedLicenceAreaDetails",
    Iafl_RelevantDocumentation = "Iafl_RelevantDocumentation",
}

export enum DraftApplicationValidationStateEnum {
    Valid = "Valid",
    Invalid = "Invalid",
    RecoverableError = "RecoverableError",
    UnrecoverableError = "UnrecoverableError",
}

export class DraftApplicationLicenceDto implements IDraftApplicationLicenceDto {
    licenceId!: number;
    licenceNumber!: string;

    constructor(data?: IDraftApplicationLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.licenceNumber = _data["licenceNumber"];
        }
    }

    static fromJS(data: any): DraftApplicationLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["licenceNumber"] = this.licenceNumber;
        return data;
    }
}

export interface IDraftApplicationLicenceDto {
    licenceId: number;
    licenceNumber: string;
}

export class DraftApplicationTitleDto implements IDraftApplicationTitleDto {
    titleId!: string;
    titleNumber!: string;

    constructor(data?: IDraftApplicationTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): DraftApplicationTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IDraftApplicationTitleDto {
    titleId: string;
    titleNumber: string;
}

export class ProgressChecklistItemDto implements IProgressChecklistItemDto {
    description!: string;
    isChecked!: boolean;

    constructor(data?: IProgressChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): ProgressChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isChecked"] = this.isChecked;
        return data;
    }
}

export interface IProgressChecklistItemDto {
    description: string;
    isChecked: boolean;
}

export class DocumentationConfigurationDto implements IDocumentationConfigurationDto {
    container!: string;
    allowedExtensions!: string[];
    maximumFileSizeMb!: number;

    constructor(data?: IDocumentationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowedExtensions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            if (Array.isArray(_data["allowedExtensions"])) {
                this.allowedExtensions = [] as any;
                for (let item of _data["allowedExtensions"])
                    this.allowedExtensions!.push(item);
            }
            this.maximumFileSizeMb = _data["maximumFileSizeMb"];
        }
    }

    static fromJS(data: any): DocumentationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        if (Array.isArray(this.allowedExtensions)) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        data["maximumFileSizeMb"] = this.maximumFileSizeMb;
        return data;
    }
}

export interface IDocumentationConfigurationDto {
    container: string;
    allowedExtensions: string[];
    maximumFileSizeMb: number;
}

export class SupportingDocumentationSuppliedOfflineDetailsDto implements ISupportingDocumentationSuppliedOfflineDetailsDto {
    isSuppliedOffline!: boolean;
    suppliedOfflineComments?: string | undefined;
    suppliedOfflineCompanyIds?: number[] | undefined;

    constructor(data?: ISupportingDocumentationSuppliedOfflineDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuppliedOffline = _data["isSuppliedOffline"];
            this.suppliedOfflineComments = _data["suppliedOfflineComments"];
            if (Array.isArray(_data["suppliedOfflineCompanyIds"])) {
                this.suppliedOfflineCompanyIds = [] as any;
                for (let item of _data["suppliedOfflineCompanyIds"])
                    this.suppliedOfflineCompanyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SupportingDocumentationSuppliedOfflineDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentationSuppliedOfflineDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuppliedOffline"] = this.isSuppliedOffline;
        data["suppliedOfflineComments"] = this.suppliedOfflineComments;
        if (Array.isArray(this.suppliedOfflineCompanyIds)) {
            data["suppliedOfflineCompanyIds"] = [];
            for (let item of this.suppliedOfflineCompanyIds)
                data["suppliedOfflineCompanyIds"].push(item);
        }
        return data;
    }
}

export interface ISupportingDocumentationSuppliedOfflineDetailsDto {
    isSuppliedOffline: boolean;
    suppliedOfflineComments?: string | undefined;
    suppliedOfflineCompanyIds?: number[] | undefined;
}

export class GetInvitationToApplyReferenceDataDraftApplicationApplicantDto implements IGetInvitationToApplyReferenceDataDraftApplicationApplicantDto {
    companyId!: number;
    companyName!: string;

    constructor(data?: IGetInvitationToApplyReferenceDataDraftApplicationApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetInvitationToApplyReferenceDataDraftApplicationApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitationToApplyReferenceDataDraftApplicationApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetInvitationToApplyReferenceDataDraftApplicationApplicantDto {
    companyId: number;
    companyName: string;
}

export class GetInvitationToApplyReferenceDataDraftApplicationTypeDto implements IGetInvitationToApplyReferenceDataDraftApplicationTypeDto {
    type!: DraftApplicationTypeEnum;
    name!: string;

    constructor(data?: IGetInvitationToApplyReferenceDataDraftApplicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetInvitationToApplyReferenceDataDraftApplicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitationToApplyReferenceDataDraftApplicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetInvitationToApplyReferenceDataDraftApplicationTypeDto {
    type: DraftApplicationTypeEnum;
    name: string;
}

export class GetTitleReferenceDataDraftApplicationApplicantDto implements IGetTitleReferenceDataDraftApplicationApplicantDto {
    companyId!: number;
    companyName!: string;

    constructor(data?: IGetTitleReferenceDataDraftApplicationApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetTitleReferenceDataDraftApplicationApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTitleReferenceDataDraftApplicationApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetTitleReferenceDataDraftApplicationApplicantDto {
    companyId: number;
    companyName: string;
}

export class GetTitleReferenceDataDraftApplicationTypeDto implements IGetTitleReferenceDataDraftApplicationTypeDto {
    type!: DraftApplicationTypeEnum;
    name!: string;

    constructor(data?: IGetTitleReferenceDataDraftApplicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetTitleReferenceDataDraftApplicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTitleReferenceDataDraftApplicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetTitleReferenceDataDraftApplicationTypeDto {
    type: DraftApplicationTypeEnum;
    name: string;
}

export class DraftApplicationWorkProgramActivityDto implements IDraftApplicationWorkProgramActivityDto {
    key!: number;
    yearTypeId!: number;
    quantity?: number | undefined;
    unitId?: number | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    indicativeExpenditure?: number | undefined;

    constructor(data?: IDraftApplicationWorkProgramActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.yearTypeId = _data["yearTypeId"];
            this.quantity = _data["quantity"];
            this.unitId = _data["unitId"];
            this.activity = _data["activity"];
            this.description = _data["description"];
            this.indicativeExpenditure = _data["indicativeExpenditure"];
        }
    }

    static fromJS(data: any): DraftApplicationWorkProgramActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationWorkProgramActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["yearTypeId"] = this.yearTypeId;
        data["quantity"] = this.quantity;
        data["unitId"] = this.unitId;
        data["activity"] = this.activity;
        data["description"] = this.description;
        data["indicativeExpenditure"] = this.indicativeExpenditure;
        return data;
    }
}

export interface IDraftApplicationWorkProgramActivityDto {
    key: number;
    yearTypeId: number;
    quantity?: number | undefined;
    unitId?: number | undefined;
    activity?: string | undefined;
    description?: string | undefined;
    indicativeExpenditure?: number | undefined;
}

export class DraftApplicationWorkProgramUnitDto implements IDraftApplicationWorkProgramUnitDto {
    id!: number;
    name!: string;

    constructor(data?: IDraftApplicationWorkProgramUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DraftApplicationWorkProgramUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationWorkProgramUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDraftApplicationWorkProgramUnitDto {
    id: number;
    name: string;
}

export class DraftApplicationWorkProgramYearDto implements IDraftApplicationWorkProgramYearDto {
    yearTypeId!: number;
    yearDisplay!: string;

    constructor(data?: IDraftApplicationWorkProgramYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearTypeId = _data["yearTypeId"];
            this.yearDisplay = _data["yearDisplay"];
        }
    }

    static fromJS(data: any): DraftApplicationWorkProgramYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftApplicationWorkProgramYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearTypeId"] = this.yearTypeId;
        data["yearDisplay"] = this.yearDisplay;
        return data;
    }
}

export interface IDraftApplicationWorkProgramYearDto {
    yearTypeId: number;
    yearDisplay: string;
}

export enum LegislativeFormCompanyAddressTypeEnum {
    Postal = "Postal",
    Business = "Business",
}

export class FormDocumentationConfigurationDto implements IFormDocumentationConfigurationDto {
    container!: string;
    allowedExtensions!: string[];
    maximumFileSizeMb!: number;

    constructor(data?: IFormDocumentationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowedExtensions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"];
            if (Array.isArray(_data["allowedExtensions"])) {
                this.allowedExtensions = [] as any;
                for (let item of _data["allowedExtensions"])
                    this.allowedExtensions!.push(item);
            }
            this.maximumFileSizeMb = _data["maximumFileSizeMb"];
        }
    }

    static fromJS(data: any): FormDocumentationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocumentationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container;
        if (Array.isArray(this.allowedExtensions)) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        data["maximumFileSizeMb"] = this.maximumFileSizeMb;
        return data;
    }
}

export interface IFormDocumentationConfigurationDto {
    container: string;
    allowedExtensions: string[];
    maximumFileSizeMb: number;
}

export class FormRequestAddressDetailsDto implements IFormRequestAddressDetailsDto {
    addressType!: LegislativeFormCompanyAddressTypeEnum;
    streetAddress?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    countryId!: number;
    countrySubdivisionId?: number | undefined;

    constructor(data?: IFormRequestAddressDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"];
            this.streetAddress = _data["streetAddress"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.countryId = _data["countryId"];
            this.countrySubdivisionId = _data["countrySubdivisionId"];
        }
    }

    static fromJS(data: any): FormRequestAddressDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequestAddressDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType;
        data["streetAddress"] = this.streetAddress;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["countryId"] = this.countryId;
        data["countrySubdivisionId"] = this.countrySubdivisionId;
        return data;
    }
}

export interface IFormRequestAddressDetailsDto {
    addressType: LegislativeFormCompanyAddressTypeEnum;
    streetAddress?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    countryId: number;
    countrySubdivisionId?: number | undefined;
}

export class FormRequestIdDto implements IFormRequestIdDto {
    formRequestId!: number;
    formTypeId!: number;

    constructor(data?: IFormRequestIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formRequestId = _data["formRequestId"];
            this.formTypeId = _data["formTypeId"];
        }
    }

    static fromJS(data: any): FormRequestIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequestIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formRequestId"] = this.formRequestId;
        data["formTypeId"] = this.formTypeId;
        return data;
    }
}

export interface IFormRequestIdDto {
    formRequestId: number;
    formTypeId: number;
}

export class FormRequestRegisteredTitleholderDetailsDto implements IFormRequestRegisteredTitleholderDetailsDto {
    acnOrArbn?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;

    constructor(data?: IFormRequestRegisteredTitleholderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acnOrArbn = _data["acnOrArbn"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): FormRequestRegisteredTitleholderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequestRegisteredTitleholderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acnOrArbn"] = this.acnOrArbn;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        return data;
    }
}

export interface IFormRequestRegisteredTitleholderDetailsDto {
    acnOrArbn?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
}

export class FormRequestTitleholderInfoDto implements IFormRequestTitleholderInfoDto {
    companyId!: number;
    companyName!: string;

    constructor(data?: IFormRequestTitleholderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): FormRequestTitleholderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequestTitleholderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IFormRequestTitleholderInfoDto {
    companyId: number;
    companyName: string;
}

export class AdvancedSearchOperationDto implements IAdvancedSearchOperationDto {
    value!: SearchAdvancedOperationEnum;
    name?: string | undefined;

    constructor(data?: IAdvancedSearchOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchOperationDto {
    value: SearchAdvancedOperationEnum;
    name?: string | undefined;
}

export class AdvancedSearchReferenceDataAcquisitionDto implements IAdvancedSearchReferenceDataAcquisitionDto {
    acquisitionId!: number;
    acquisitionDisplay?: string | undefined;

    constructor(data?: IAdvancedSearchReferenceDataAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquisitionId = _data["acquisitionId"];
            this.acquisitionDisplay = _data["acquisitionDisplay"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId;
        data["acquisitionDisplay"] = this.acquisitionDisplay;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataAcquisitionDto {
    acquisitionId: number;
    acquisitionDisplay?: string | undefined;
}

export class AdvancedSearchReferenceDataEnoDto implements IAdvancedSearchReferenceDataEnoDto {
    eno!: string;
    name!: string;

    constructor(data?: IAdvancedSearchReferenceDataEnoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eno = _data["eno"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataEnoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataEnoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eno"] = this.eno;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataEnoDto {
    eno: string;
    name: string;
}

export class AdvancedSearchReferenceDataReprocessingDto implements IAdvancedSearchReferenceDataReprocessingDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IAdvancedSearchReferenceDataReprocessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataReprocessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataReprocessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataReprocessingDto {
    id: number;
    name?: string | undefined;
}

export class AdvancedSearchReferenceDataReprocessingProjectDto implements IAdvancedSearchReferenceDataReprocessingProjectDto {
    id!: number;
    displayName?: string | undefined;

    constructor(data?: IAdvancedSearchReferenceDataReprocessingProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataReprocessingProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataReprocessingProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataReprocessingProjectDto {
    id: number;
    displayName?: string | undefined;
}

export class AdvancedSearchReferenceDataSurveyDto implements IAdvancedSearchReferenceDataSurveyDto {
    id!: number;
    name!: string;

    constructor(data?: IAdvancedSearchReferenceDataSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataSurveyDto {
    id: number;
    name: string;
}

export class AdvancedSearchReferenceDataTitleDto implements IAdvancedSearchReferenceDataTitleDto {
    nopimsTitleType!: NopimsTitleTypeEnum;
    titleId?: string | undefined;
    titleNumber?: string | undefined;

    constructor(data?: IAdvancedSearchReferenceDataTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nopimsTitleType = _data["nopimsTitleType"];
            this.titleId = _data["titleId"];
            this.titleNumber = _data["titleNumber"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nopimsTitleType"] = this.nopimsTitleType;
        data["titleId"] = this.titleId;
        data["titleNumber"] = this.titleNumber;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataTitleDto {
    nopimsTitleType: NopimsTitleTypeEnum;
    titleId?: string | undefined;
    titleNumber?: string | undefined;
}

export class AdvancedSearchReferenceDataWellBoreholeDto implements IAdvancedSearchReferenceDataWellBoreholeDto {
    id!: number;
    name!: string;

    constructor(data?: IAdvancedSearchReferenceDataWellBoreholeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataWellBoreholeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataWellBoreholeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataWellBoreholeDto {
    id: number;
    name: string;
}

export class AdvancedSearchReferenceDataWellDto implements IAdvancedSearchReferenceDataWellDto {
    id!: number;
    name!: string;

    constructor(data?: IAdvancedSearchReferenceDataWellDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchReferenceDataWellDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchReferenceDataWellDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchReferenceDataWellDto {
    id: number;
    name: string;
}

export class AdvancedSearchTypeDto implements IAdvancedSearchTypeDto {
    value!: SearchAdvancedTypeEnum;
    name?: string | undefined;

    constructor(data?: IAdvancedSearchTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvancedSearchTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvancedSearchTypeDto {
    value: SearchAdvancedTypeEnum;
    name?: string | undefined;
}

export class SearchAdvancedFilterDto implements ISearchAdvancedFilterDto {
    searchType!: SearchAdvancedTypeEnum;
    operation?: SearchAdvancedOperationEnum | undefined;
    ids?: number[] | undefined;
    guids?: string[] | undefined;
    items?: string[] | undefined;
    text?: string | undefined;

    constructor(data?: ISearchAdvancedFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data["searchType"];
            this.operation = _data["operation"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["guids"])) {
                this.guids = [] as any;
                for (let item of _data["guids"])
                    this.guids!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SearchAdvancedFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAdvancedFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchType"] = this.searchType;
        data["operation"] = this.operation;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.guids)) {
            data["guids"] = [];
            for (let item of this.guids)
                data["guids"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["text"] = this.text;
        return data;
    }
}

export interface ISearchAdvancedFilterDto {
    searchType: SearchAdvancedTypeEnum;
    operation?: SearchAdvancedOperationEnum | undefined;
    ids?: number[] | undefined;
    guids?: string[] | undefined;
    items?: string[] | undefined;
    text?: string | undefined;
}

export enum AssignmentGroupEnum {
    Ga = "Ga",
    Nopta = "Nopta",
}

export enum AttachmentTypeEnum {
    Report = "Report",
    SurveyData = "SurveyData",
}

export enum AuthorisationActivityTypeEnum {
    Borehole = "Borehole",
    AcquisitionProject = "AcquisitionProject",
}

export enum AuthorisationCategoryTypeEnum {
    Exemption = "Exemption",
    Extension = "Extension",
    Variation = "Variation",
    CombineDataSubmission = "CombineDataSubmission",
    DigitalTransfer = "DigitalTransfer",
    Export = "Export",
    ViewOnly = "ViewOnly",
    Sampling = "Sampling",
    SamplingAndExport = "SamplingAndExport",
}

export enum BasicInterpTypeEnum {
    B = "B",
    Bi = "Bi",
    I = "I",
    Nr = "Nr",
}

export enum DataSubmissionResubmissionStatusEnum {
    Preparing = "Preparing",
    Requested = "Requested",
    Received = "Received",
    Completed = "Completed",
}

export enum FeedbackTypeEnum {
    DataSpecificFeedback = "DataSpecificFeedback",
    GeneralFeedback = "GeneralFeedback",
}

export enum NopimsActivityTypeEnum {
    Borehole = "Borehole",
    Acquisition = "Acquisition",
    Project = "Project",
}

export enum NopimsTitleTypeEnum {
    Nopta = "Nopta",
    Other = "Other",
}

export enum RelatedActivityEnum {
    Borehole = "Borehole",
    Acquisition = "Acquisition",
    Project = "Project",
}

export enum SearchAdvancedOperationEnum {
    And = "And",
    Or = "Or",
}

export enum SearchAdvancedTypeEnum {
    Titles = "Titles",
    Surveys = "Surveys",
    Acquisitions = "Acquisitions",
    Wells = "Wells",
    Borehole = "Borehole",
    Eno = "Eno",
    Reprocessings = "Reprocessings",
    Projects = "Projects",
    EnoList = "EnoList",
    ItemIdList = "ItemIdList",
    Comments = "Comments",
    ConfidentialityRemarks = "ConfidentialityRemarks",
}

export enum SearchAuthorisationsTypeEnum {
    InProgress = "InProgress",
    Last12Months = "Last12Months",
    All = "All",
}

export enum SepiGaNopimsStringUpdateTypeEnum {
    Prepend = "Prepend",
    Append = "Append",
    Overwrite = "Overwrite",
}

export enum CreateReportRelatedActivityTypeEnum {
    WellBorehole = "WellBorehole",
    SurveyAcquisition = "SurveyAcquisition",
    ReprocessingProject = "ReprocessingProject",
}

export enum ReportRelatedActivityTypeEnum {
    Borehole = "Borehole",
    Acquisition = "Acquisition",
    Project = "Project",
}

export enum ReportsStringUpdateTypeEnum {
    Prepend = "Prepend",
    Append = "Append",
    Overwrite = "Overwrite",
}

export enum CreateSurveyDataRelatedActivityTypeEnum {
    SurveyAcquisition = "SurveyAcquisition",
    ReprocessingProject = "ReprocessingProject",
}

export enum SurveyDataStringUpdateTypeEnum {
    Prepend = "Prepend",
    Append = "Append",
    Overwrite = "Overwrite",
}

export enum SurveyDataRelatedActivityTypeEnum {
    Borehole = "Borehole",
    Acquisition = "Acquisition",
    Project = "Project",
}

export enum EmailVerificationStatusEnum {
    Verified = "Verified",
    Unverified = "Unverified",
    FailedWithTooManyAttempts = "FailedWithTooManyAttempts",
    InvalidToken = "InvalidToken",
}

export class CompanyStandardRoleRequestDetailsDto implements ICompanyStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleCompanyMembershipIds?: SecureUserRoleCompanyMembershipIdDto[] | undefined;

    constructor(data?: ICompanyStandardRoleRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            if (Array.isArray(_data["createdSecureUserRoleCompanyMembershipIds"])) {
                this.createdSecureUserRoleCompanyMembershipIds = [] as any;
                for (let item of _data["createdSecureUserRoleCompanyMembershipIds"])
                    this.createdSecureUserRoleCompanyMembershipIds!.push(SecureUserRoleCompanyMembershipIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyStandardRoleRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyStandardRoleRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        if (Array.isArray(this.createdSecureUserRoleCompanyMembershipIds)) {
            data["createdSecureUserRoleCompanyMembershipIds"] = [];
            for (let item of this.createdSecureUserRoleCompanyMembershipIds)
                data["createdSecureUserRoleCompanyMembershipIds"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleCompanyMembershipIds?: SecureUserRoleCompanyMembershipIdDto[] | undefined;
}

export class NewCompanyRequestDetailsDto implements INewCompanyRequestDetailsDto {
    createdCompanyId?: number | undefined;
    companyName?: string | undefined;
    companyAbn?: string | undefined;
    companyAcnOrArbn?: string | undefined;
    effectiveDate?: Date | undefined;
    businessAddress?: string | undefined;
    businessSuburb?: string | undefined;
    businessPostcode?: string | undefined;
    businessCountrySubdivisionId?: number | undefined;
    businessState?: string | undefined;
    businessCountryId?: number | undefined;
    businessCountry?: string | undefined;
    postalAddress?: string | undefined;
    postalSuburb?: string | undefined;
    postalPostcode?: string | undefined;
    postalCountrySubdivisionId?: number | undefined;
    postalState?: string | undefined;
    postalCountryId?: number | undefined;
    postalCountry?: string | undefined;

    constructor(data?: INewCompanyRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdCompanyId = _data["createdCompanyId"];
            this.companyName = _data["companyName"];
            this.companyAbn = _data["companyAbn"];
            this.companyAcnOrArbn = _data["companyAcnOrArbn"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.businessAddress = _data["businessAddress"];
            this.businessSuburb = _data["businessSuburb"];
            this.businessPostcode = _data["businessPostcode"];
            this.businessCountrySubdivisionId = _data["businessCountrySubdivisionId"];
            this.businessState = _data["businessState"];
            this.businessCountryId = _data["businessCountryId"];
            this.businessCountry = _data["businessCountry"];
            this.postalAddress = _data["postalAddress"];
            this.postalSuburb = _data["postalSuburb"];
            this.postalPostcode = _data["postalPostcode"];
            this.postalCountrySubdivisionId = _data["postalCountrySubdivisionId"];
            this.postalState = _data["postalState"];
            this.postalCountryId = _data["postalCountryId"];
            this.postalCountry = _data["postalCountry"];
        }
    }

    static fromJS(data: any): NewCompanyRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewCompanyRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdCompanyId"] = this.createdCompanyId;
        data["companyName"] = this.companyName;
        data["companyAbn"] = this.companyAbn;
        data["companyAcnOrArbn"] = this.companyAcnOrArbn;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["businessAddress"] = this.businessAddress;
        data["businessSuburb"] = this.businessSuburb;
        data["businessPostcode"] = this.businessPostcode;
        data["businessCountrySubdivisionId"] = this.businessCountrySubdivisionId;
        data["businessState"] = this.businessState;
        data["businessCountryId"] = this.businessCountryId;
        data["businessCountry"] = this.businessCountry;
        data["postalAddress"] = this.postalAddress;
        data["postalSuburb"] = this.postalSuburb;
        data["postalPostcode"] = this.postalPostcode;
        data["postalCountrySubdivisionId"] = this.postalCountrySubdivisionId;
        data["postalState"] = this.postalState;
        data["postalCountryId"] = this.postalCountryId;
        data["postalCountry"] = this.postalCountry;
        return data;
    }
}

export interface INewCompanyRequestDetailsDto {
    createdCompanyId?: number | undefined;
    companyName?: string | undefined;
    companyAbn?: string | undefined;
    companyAcnOrArbn?: string | undefined;
    effectiveDate?: Date | undefined;
    businessAddress?: string | undefined;
    businessSuburb?: string | undefined;
    businessPostcode?: string | undefined;
    businessCountrySubdivisionId?: number | undefined;
    businessState?: string | undefined;
    businessCountryId?: number | undefined;
    businessCountry?: string | undefined;
    postalAddress?: string | undefined;
    postalSuburb?: string | undefined;
    postalPostcode?: string | undefined;
    postalCountrySubdivisionId?: number | undefined;
    postalState?: string | undefined;
    postalCountryId?: number | undefined;
    postalCountry?: string | undefined;
}

export class SecureUserRoleCompanyMembershipIdDto implements ISecureUserRoleCompanyMembershipIdDto {
    role!: SecureRoleEnum;
    secureUserRoleCompanyMembershipId!: number;

    constructor(data?: ISecureUserRoleCompanyMembershipIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.secureUserRoleCompanyMembershipId = _data["secureUserRoleCompanyMembershipId"];
        }
    }

    static fromJS(data: any): SecureUserRoleCompanyMembershipIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserRoleCompanyMembershipIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["secureUserRoleCompanyMembershipId"] = this.secureUserRoleCompanyMembershipId;
        return data;
    }
}

export interface ISecureUserRoleCompanyMembershipIdDto {
    role: SecureRoleEnum;
    secureUserRoleCompanyMembershipId: number;
}

export class GeoscienceAustraliaStandardRoleRequestDetailsDto implements IGeoscienceAustraliaStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleGeoscienceAustraliaMembershipIds?: SecureUserRoleGeoscienceAustraliaMembershipIdDto[] | undefined;

    constructor(data?: IGeoscienceAustraliaStandardRoleRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            if (Array.isArray(_data["createdSecureUserRoleGeoscienceAustraliaMembershipIds"])) {
                this.createdSecureUserRoleGeoscienceAustraliaMembershipIds = [] as any;
                for (let item of _data["createdSecureUserRoleGeoscienceAustraliaMembershipIds"])
                    this.createdSecureUserRoleGeoscienceAustraliaMembershipIds!.push(SecureUserRoleGeoscienceAustraliaMembershipIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeoscienceAustraliaStandardRoleRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoscienceAustraliaStandardRoleRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        if (Array.isArray(this.createdSecureUserRoleGeoscienceAustraliaMembershipIds)) {
            data["createdSecureUserRoleGeoscienceAustraliaMembershipIds"] = [];
            for (let item of this.createdSecureUserRoleGeoscienceAustraliaMembershipIds)
                data["createdSecureUserRoleGeoscienceAustraliaMembershipIds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeoscienceAustraliaStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleGeoscienceAustraliaMembershipIds?: SecureUserRoleGeoscienceAustraliaMembershipIdDto[] | undefined;
}

export class SecureUserRoleGeoscienceAustraliaMembershipIdDto implements ISecureUserRoleGeoscienceAustraliaMembershipIdDto {
    role!: SecureRoleEnum;
    secureUserRoleGeoscienceAustraliaMembershipId!: number;

    constructor(data?: ISecureUserRoleGeoscienceAustraliaMembershipIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.secureUserRoleGeoscienceAustraliaMembershipId = _data["secureUserRoleGeoscienceAustraliaMembershipId"];
        }
    }

    static fromJS(data: any): SecureUserRoleGeoscienceAustraliaMembershipIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserRoleGeoscienceAustraliaMembershipIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["secureUserRoleGeoscienceAustraliaMembershipId"] = this.secureUserRoleGeoscienceAustraliaMembershipId;
        return data;
    }
}

export interface ISecureUserRoleGeoscienceAustraliaMembershipIdDto {
    role: SecureRoleEnum;
    secureUserRoleGeoscienceAustraliaMembershipId: number;
}

export class JointAuthorityStandardRoleRequestDetailsDto implements IJointAuthorityStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleJointAuthorityMembershipIds?: SecureUserRoleJointAuthorityMembershipIdDto[] | undefined;

    constructor(data?: IJointAuthorityStandardRoleRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rolesRequested"])) {
                this.rolesRequested = [] as any;
                for (let item of _data["rolesRequested"])
                    this.rolesRequested!.push(item);
            }
            if (Array.isArray(_data["rolesApproved"])) {
                this.rolesApproved = [] as any;
                for (let item of _data["rolesApproved"])
                    this.rolesApproved!.push(item);
            }
            if (Array.isArray(_data["createdSecureUserRoleJointAuthorityMembershipIds"])) {
                this.createdSecureUserRoleJointAuthorityMembershipIds = [] as any;
                for (let item of _data["createdSecureUserRoleJointAuthorityMembershipIds"])
                    this.createdSecureUserRoleJointAuthorityMembershipIds!.push(SecureUserRoleJointAuthorityMembershipIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JointAuthorityStandardRoleRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JointAuthorityStandardRoleRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesRequested)) {
            data["rolesRequested"] = [];
            for (let item of this.rolesRequested)
                data["rolesRequested"].push(item);
        }
        if (Array.isArray(this.rolesApproved)) {
            data["rolesApproved"] = [];
            for (let item of this.rolesApproved)
                data["rolesApproved"].push(item);
        }
        if (Array.isArray(this.createdSecureUserRoleJointAuthorityMembershipIds)) {
            data["createdSecureUserRoleJointAuthorityMembershipIds"] = [];
            for (let item of this.createdSecureUserRoleJointAuthorityMembershipIds)
                data["createdSecureUserRoleJointAuthorityMembershipIds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJointAuthorityStandardRoleRequestDetailsDto {
    rolesRequested?: SecureRoleEnum[] | undefined;
    rolesApproved?: SecureRoleEnum[] | undefined;
    createdSecureUserRoleJointAuthorityMembershipIds?: SecureUserRoleJointAuthorityMembershipIdDto[] | undefined;
}

export class SecureUserRoleJointAuthorityMembershipIdDto implements ISecureUserRoleJointAuthorityMembershipIdDto {
    role!: SecureRoleEnum;
    secureUserRoleJointAuthorityMembershipId!: number;

    constructor(data?: ISecureUserRoleJointAuthorityMembershipIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.secureUserRoleJointAuthorityMembershipId = _data["secureUserRoleJointAuthorityMembershipId"];
        }
    }

    static fromJS(data: any): SecureUserRoleJointAuthorityMembershipIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserRoleJointAuthorityMembershipIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["secureUserRoleJointAuthorityMembershipId"] = this.secureUserRoleJointAuthorityMembershipId;
        return data;
    }
}

export interface ISecureUserRoleJointAuthorityMembershipIdDto {
    role: SecureRoleEnum;
    secureUserRoleJointAuthorityMembershipId: number;
}

export class SecureRequestGroupIdDto implements ISecureRequestGroupIdDto {
    id!: number;
    code!: string;
    type!: SecureRequestGroupTypeEnum;

    constructor(data?: ISecureRequestGroupIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecureRequestGroupIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureRequestGroupIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecureRequestGroupIdDto {
    id: number;
    code: string;
    type: SecureRequestGroupTypeEnum;
}

export class SecureRequestGroupSupportingDocumentDto implements ISecureRequestGroupSupportingDocumentDto {
    fileName?: string | undefined;
    content?: string | undefined;

    constructor(data?: ISecureRequestGroupSupportingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SecureRequestGroupSupportingDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureRequestGroupSupportingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        return data;
    }
}

export interface ISecureRequestGroupSupportingDocumentDto {
    fileName?: string | undefined;
    content?: string | undefined;
}

export class SecureRequestGroupKeyDto implements ISecureRequestGroupKeyDto {
    id!: number;
    versionNumber!: number;

    constructor(data?: ISecureRequestGroupKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): SecureRequestGroupKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecureRequestGroupKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ISecureRequestGroupKeyDto {
    id: number;
    versionNumber: number;
}

export enum SecureEntityTypeNotificationTypeEnum {
    JointAuthority_Exploration = "JointAuthority_Exploration",
    JointAuthority_Development = "JointAuthority_Development",
    JointAuthority_GreenhouseGas = "JointAuthority_GreenhouseGas",
}

export enum ExternalLinkEnum {
    CompanyUserAgreement = "CompanyUserAgreement",
    MfaUrl = "MfaUrl",
    CompanyAdministratorRequestForm = "CompanyAdministratorRequestForm",
    NoptaFormsGuidancePetroleum = "NoptaFormsGuidancePetroleum",
    SignatureGuidance = "SignatureGuidance",
    NoptaFormsGuidanceGreenhouseGas = "NoptaFormsGuidanceGreenhouseGas",
    HalvingRules = "HalvingRules",
    CompanySignerRequestForm = "CompanySignerRequestForm",
    JointAuthorityAdministratorRequestForm = "JointAuthorityAdministratorRequestForm",
    NeatsSecurePortalGuidance = "NeatsSecurePortalGuidance",
    GeoscienceAustraliaAdministratorRequestForm = "GeoscienceAustraliaAdministratorRequestForm",
    JointAuthorityUserAgreement = "JointAuthorityUserAgreement",
    NoptaFormsGuidanceOei = "NoptaFormsGuidanceOei",
    NeatsNopimsPublicPortalGuidance = "NeatsNopimsPublicPortalGuidance",
}

export enum SepiLinkTypeEnum {
    OpggsApplicationList = "OpggsApplicationList",
    DraftApplicationList = "DraftApplicationList",
    OeiApplicationList = "OeiApplicationList",
    FinancialNotificationList = "FinancialNotificationList",
    SecureRequestGroupList = "SecureRequestGroupList",
    TitleList = "TitleList",
    Application = "Application",
    DraftApplication = "DraftApplication",
    FinancialNotification = "FinancialNotification",
    SecureRequestGroup = "SecureRequestGroup",
    Title = "Title",
    Licence = "Licence",
    NopimsFeedback = "NopimsFeedback",
}

export class DeltaModelAttributeDto implements IDeltaModelAttributeDto {
    name!: string;
    value?: string | undefined;

    constructor(data?: IDeltaModelAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DeltaModelAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeltaModelAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IDeltaModelAttributeDto {
    name: string;
    value?: string | undefined;
}

export enum DeltaModelChangeTypeEnum {
    Created = "Created",
    Deleted = "Deleted",
    Updated = "Updated",
}

export class SimpleAuditEventDto implements ISimpleAuditEventDto {
    action!: string;
    identity!: string;
    timestamp!: Date;
    secureUserId?: number | undefined;

    constructor(data?: ISimpleAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.identity = _data["identity"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.secureUserId = _data["secureUserId"];
        }
    }

    static fromJS(data: any): SimpleAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["identity"] = this.identity;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["secureUserId"] = this.secureUserId;
        return data;
    }
}

export interface ISimpleAuditEventDto {
    action: string;
    identity: string;
    timestamp: Date;
    secureUserId?: number | undefined;
}

export class SimpleAuditEventsDto implements ISimpleAuditEventsDto {
    events!: SimpleAuditEventDto[];

    constructor(data?: ISimpleAuditEventsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(SimpleAuditEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleAuditEventsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleAuditEventsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimpleAuditEventsDto {
    events: SimpleAuditEventDto[];
}

export enum SimpleDataAuditChangeTypeEnum {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Other = "Other",
}

export class SimpleDataAuditDeltaModelNodeDto implements ISimpleDataAuditDeltaModelNodeDto {
    name!: string;
    key?: any | undefined;
    changeType!: DeltaModelChangeTypeEnum;
    originalAttributes!: DeltaModelAttributeDto[];
    newAttributes!: DeltaModelAttributeDto[];
    nodes!: SimpleDataAuditDeltaModelNodeDto[];

    constructor(data?: ISimpleDataAuditDeltaModelNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.originalAttributes = [];
            this.newAttributes = [];
            this.nodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.key = _data["key"];
            this.changeType = _data["changeType"];
            if (Array.isArray(_data["originalAttributes"])) {
                this.originalAttributes = [] as any;
                for (let item of _data["originalAttributes"])
                    this.originalAttributes!.push(DeltaModelAttributeDto.fromJS(item));
            }
            if (Array.isArray(_data["newAttributes"])) {
                this.newAttributes = [] as any;
                for (let item of _data["newAttributes"])
                    this.newAttributes!.push(DeltaModelAttributeDto.fromJS(item));
            }
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(SimpleDataAuditDeltaModelNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleDataAuditDeltaModelNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleDataAuditDeltaModelNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        data["changeType"] = this.changeType;
        if (Array.isArray(this.originalAttributes)) {
            data["originalAttributes"] = [];
            for (let item of this.originalAttributes)
                data["originalAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.newAttributes)) {
            data["newAttributes"] = [];
            for (let item of this.newAttributes)
                data["newAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimpleDataAuditDeltaModelNodeDto {
    name: string;
    key?: any | undefined;
    changeType: DeltaModelChangeTypeEnum;
    originalAttributes: DeltaModelAttributeDto[];
    newAttributes: DeltaModelAttributeDto[];
    nodes: SimpleDataAuditDeltaModelNodeDto[];
}

export class SimpleDataAuditSnapshotModelNodeDto implements ISimpleDataAuditSnapshotModelNodeDto {
    name!: string;
    key?: any | undefined;
    attributes!: SnapshotModelAttributeDto[];
    nodes!: SimpleDataAuditSnapshotModelNodeDto[];

    constructor(data?: ISimpleDataAuditSnapshotModelNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = [];
            this.nodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.key = _data["key"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(SnapshotModelAttributeDto.fromJS(item));
            }
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(SimpleDataAuditSnapshotModelNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleDataAuditSnapshotModelNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleDataAuditSnapshotModelNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimpleDataAuditSnapshotModelNodeDto {
    name: string;
    key?: any | undefined;
    attributes: SnapshotModelAttributeDto[];
    nodes: SimpleDataAuditSnapshotModelNodeDto[];
}

export class SnapshotModelAttributeDto implements ISnapshotModelAttributeDto {
    name!: string;
    value?: string | undefined;

    constructor(data?: ISnapshotModelAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SnapshotModelAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotModelAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISnapshotModelAttributeDto {
    name: string;
    value?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// taken from https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export interface IConfig {
    getSessionCorrelation: () => string;
}